<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 612 369.3"
    style="enable-background: new 0 0 612 369.3"
    xml:space="preserve"
  >
    <g id="C2" :fill="fill">
      <path
        class="st2"
        d="M306,137.5c-0.5-0.1-1-0.2-1.5-0.3c-0.7-0.2-1.5-0.3-2.2-0.5c-0.7-0.1-1.3-0.2-2-0.4c0,0.1,0,0.1,0,0.2
		c0.6,0.2,1.1,0.4,1.7,0.6c0,0.1-0.1,0.3-0.1,0.4c-1.1-0.3-2.3-0.5-3.4-0.8v0.1c0.4,0.2,0.8,0.4,1.2,0.6c0,0.1,0,0.2,0,0.4
		c-1.8,0-3.6,0-5.2,0c0.3,0.1,0.9,0.4,1.6,0.7c-0.4,0.2-0.6,0.4-0.9,0.6c2.2,0.5,4.2,1,6.1,1.5c1.6,0.4,3.2,0.8,4.8,1.2
		c0.3,0.1,0.7,0.2,1,0.3c0-0.1,0-0.1,0.1-0.2c-0.4-0.2-0.7-0.4-1.1-0.7c-0.2-0.1-0.3-0.2-0.5-0.3c0,0,0,0-0.1,0l0,0
		c0.2-0.1,0.4-0.2,0.5-0.3c0.3-0.2,0.5-0.3,0.7-0.4c-0.3-0.1-0.5-0.3-0.7-0.5V137.5z"
      />
      <path
        class="st2"
        d="M292.6,129.3c-0.5,0-1,0.2-1.4,0.4C291.7,129.6,292.2,129.5,292.6,129.3c0.3,0.1,0.4,0,0.6,0
		C293,129.3,292.8,129.3,292.6,129.3z"
      />
      <path
        class="st2"
        d="M31.9,190.9c-0.1-2.6-0.2-5.2-0.4-7.8c-0.7-0.3-1.7-0.1-3.1,0.6c-0.1,0-0.1,0-0.2,0.1
		c-0.1-0.2-0.2-0.3-0.3-0.5l-0.1-0.1c0,0.2,0,0.3,0,0.5c0.1,2.4,0.1,4.9,0.2,7.3c0,1.3,0.1,2.5,0.1,3.8c0,0.3,0,0.6,0,0.9
		c0,0.6,0,1.2,0,1.8c0.1,4.7,0.2,9.5,0.3,14.2c0,0.4,0.3,1,0.6,1.2c1.1,0.8,2.4,1.5,3.8,2.4c0.1-0.5,0.1-0.7,0.1-1
		c-0.3-5.8-0.5-11.7-0.8-17.5C32.1,194.8,32,192.9,31.9,190.9z"
      />
      <path
        class="st2"
        d="M28.8,299c0.3-0.3,0.6-0.7,0.9-1c-0.1-2.7-0.1-5.4-0.2-8s-0.1-5.2-0.2-7.9c0-0.2,0-0.3,0-0.5
		c0-1.1-0.4-1.7-1.4-2.3c-3.6-2.1-7.1-4.2-10.6-6.3c-0.4-0.2-0.7-0.4-1.2-0.6c0,0.7-0.1,1.2-0.1,1.6c-0.1,2.4-0.1,4.8-0.2,7.3
		c0,0.6,0,1.1,0,1.7c0,1-0.1,2.1-0.1,3.1c0,0.6,0,1.2-0.1,1.8c0,1.2-0.1,2.3-0.1,3.5c0.1,0.1,0.2,0.2,0.3,0.3
		c0.1,0.1,0.2,0.3,0.2,0.4c0.2,1,0.5,2.1,0.7,3.2c0,0.2,0.1,0.4,0.1,0.6c-0.1,0.1-0.2,0.2-0.4,0.4c-0.1,0.1-0.2,0.3-0.3,0.5
		c-0.5,0.9,0.1,1.8,1.2,1.7c0.1,0,0.1,0,0.2,0c0.6-0.1,1.2-0.2,1.8-0.4c0.3-0.1,0.5-0.1,0.8-0.2c0.2,0,0.4-0.1,0.6-0.1
		c0,0.1,0,0.1,0,0.2c0.2,0.7,0,1.6,1.2,1.8c0.1,0,0.1,0.3,0.1,0.4v0.1c0,0.6,0.3,1.1,1.1,1.2c0.2,0,0.3,0,0.5,0c0.6,0,1-0.3,1.4-0.8
		c0.1-0.1,0.2-0.2,0.3-0.3c0.3,0.1,0.6,0.1,0.9,0.1C27.3,300.5,28.1,299.8,28.8,299z"
      />
      <path
        class="st2"
        d="M177.2,173.6c-0.4,0.5-0.6,1.1-0.7,1.9c0.9-0.2,1.6-0.4,2.3-0.6c0-0.5,0-1,0-1.4c0-0.3,0-0.7,0-1.1
		C178.2,172.8,177.6,173.2,177.2,173.6z"
      />
      <path
        class="st2"
        d="M299.5,125.5c2-0.4,3.9-0.7,5.9-1.1c-0.3-0.1-0.6-0.2-0.9-0.4c-0.1-0.1-0.3-0.2-0.5-0.1c-0.5,0-1.1,0-1.4,0.2
		C301.7,124.8,300.2,124.5,299.5,125.5z"
      />
      <path
        class="st2"
        d="M209.9,116.9c-0.2,0.2-0.4,0.3-0.6,0.5c0,0.4-0.1,0.9-0.1,1.4c0.6-0.1,1.2-0.3,1.9-0.4c1.6-0.3,3.1-0.7,4.7-1
		c-0.3-0.7-0.8-1.3-1.9-1.6C212.3,115.3,211,115.9,209.9,116.9z"
      />
      <path
        class="st2"
        d="M138.1,113.1c0.2-0.4,0.5-0.8,0.5-1.1c0-0.4-0.2-0.8-1-0.9c-0.2,0-0.4-0.3-0.7-0.6c-0.1-0.1-0.2-0.3-0.3-0.4
		c-0.2,0.2-0.6,0.4-0.7,0.7c-0.1,0.2,0.1,0.6,0.2,0.6c0.5,0.1,0.6,0.3,0.6,0.6c0,0.3-0.1,0.7,0.1,0.9c0.1,0.1-0.1,0.3-0.3,0.6
		C137.1,113.4,137.6,113.3,138.1,113.1z"
      />
      <path
        class="st2"
        d="M147.1,136.7l-0.1-0.1c0,0.1-0.1,0.1-0.1,0.2C146.9,136.7,147,136.7,147.1,136.7z"
      />
      <path
        class="st2"
        d="M144.2,137.7c0.4-0.1,0.8-0.3,1.2-0.4c-0.1,0-0.1-0.1-0.2-0.1c-0.3-0.2-0.7-0.3-1.3-0.6
		C144,137.1,144.1,137.4,144.2,137.7z"
      />
      <path
        class="st2"
        d="M36,302.9c0.3-0.1,0.5-0.1,0.7-0.1c0.1,0,0.1,0,0.2,0c0-0.8-0.1-1.7-0.1-2.5c-0.1-2.8-0.3-5.7-0.4-8.5
		c0-0.8-0.1-1.6-0.1-2.5c0-0.1,0-0.2,0-0.3c-0.1-1.3-0.1-2.6-0.2-3.9c0-0.4-0.2-1.1-0.5-1.3c-1.8-1.1-3.6-2.2-5.5-3.3
		c-0.1,0.4-0.1,0.6-0.1,0.7c0,0.2,0,0.4,0,0.6c0.1,2.7,0.1,5.4,0.2,8.1c0,1,0,1.9,0.1,2.9c0,0.1,0,0.2,0,0.4c0,0.1,0,0.2,0,0.3
		c0,0.1,0,0.3,0,0.4c0,1.3,0.1,2.7,0.1,4v0.1c0,0,0,0.1,0,0.2c0.6,0.4,1.2,0.7,0.9,1.6c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.2,0.2,0.2
		c0.1,0,0.2,0,0.2,0c0.3,0,0.4,0,0.5,0.1s0.1,0.3-0.1,0.6c-0.1,0.2,0.8,0.1,0.9,0.7c0.1,0.6,0.5,1.2,0.7,1.9
		c0.1,0.2,0.2,0.4,0.6,0.6c0-0.2,0-0.3,0.1-0.5c0-0.1,0-0.2,0-0.3c0-0.3,0.1-0.5,0.1-0.8c0-0.1,0-0.2,0-0.2c0.1,0.1,0.3,0.1,0.5,0.2
		C35.4,302.8,35.8,303,36,302.9z"
      />
      <path
        class="st2"
        d="M208,119c0.1,0,0.1,0,0.2,0c0.3-0.1,0.7-0.1,1-0.2c-0.3-0.1-0.4-0.1-0.7-0.2c-0.1,0.1-0.2,0.2-0.3,0.3
		C208.1,118.9,208.1,119,208,119z"
      />
      <path
        class="st2"
        d="M274.1,126.6c-0.3,0.1-0.7,0.4-0.6,1c0.2,0.6,0.6,1.3,0.9,1.9c0.1,0,0.2-0.1,0.4-0.1c0-0.3,0-0.7-0.1-1.3
		c0.5,0.6,0.7,0.9,1.1,1.4c0.5,0,1.3-0.6,1.7,0.3c0.3-0.1,0.6-0.1,0.9-0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.1-0.7-0.2-1.3-1.4-1.5
		C275.8,127.8,275.1,127.1,274.1,126.6z"
      />
      <path
        class="st2"
        d="M165.4,121.3c-0.2,0-0.6-0.2-0.8-0.4c-0.1,0-0.2,0.1-0.4,0.1c-0.5,0.1-1,0.3-1.5,0.4c-0.4,0.1-0.8,0.3-1.3,0.4
		c-1.3,0.4-2.6,0.8-3.9,1.2c-1.2,0.4-2.4,0.8-3.7,1.1c-1.9,0.6-3.7,1.2-5.6,1.8c0.3,0.7,0.9,0.9,2.7,1.1c-1.2,0.5-1.6,1.2-1.7,2
		c0,0.3,0,0.6,0,1c0.1,0.5-0.2,1-0.3,1.4c-0.5,0.1-0.9,0.2-1.5,0.3c0.2,0.4,0.4,0.7,0.6,1.1c0.1,0.1,0.1,0.2,0.2,0.3
		c0.3-0.5,0.6-0.8,0.8-1.2c0,0,0-0.1,0.1-0.1l0,0c0.9-0.1,1.9,0.5,2.8-0.3c0.1-0.4,0.2-0.9,0.3-1.4c0.1,0,0.2,0,0.3,0
		c0.8,0,1.6,0.1,2.6,0.1c-0.3,0.5-0.5,0.9-0.7,1.2c0.2-0.1,0.3-0.1,0.5-0.2l0,0c0.1-0.1,0.3-0.1,0.4-0.2c-0.1,0.2-0.2,0.4-0.3,0.4
		c-0.1,0.1-0.2,0.1-0.4,0c-0.1,0-0.2,0-0.2-0.1c-0.2,0.1-0.4,0.3-0.6,0.4c-0.3,0.3-0.5,0.6-0.6,1c-0.2,0.5-0.6,1.1-1.1,1.8
		c0.8-0.3,1.6-0.5,2.4-0.8c0.1,0,0.3-0.1,0.4-0.1c0.3-0.1,0.6-0.2,0.9-0.3c0.7-0.3,1.5-0.5,2.2-0.8c0.2-0.1,0.3-0.1,0.5-0.2
		c0.1,0,0.1,0,0.2-0.1c2.2-0.7,4.4-1.4,6.6-2.1c0.8-0.3,1.7-0.5,2.5-0.8c0.1,0,0.3-0.1,0.4-0.1h0.1c0.3-0.1,0.7-0.2,1-0.3
		c0.1,0,0.3-0.1,0.4-0.1c0.7-0.2,1.4-0.4,2.1-0.6c-0.2-0.1-0.4-0.1-0.8-0.2c0.7-0.2,1-0.3,1.3-0.5c0.1-0.1,0.3-0.1,0.4-0.2
		c0.7-0.3,1.3-0.7,1.4-1.5c0.1-0.4,0.4-0.7,0.8-1.2c0-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.1,0.1-0.2,0.1c-1,0.4-1.7,0.7-2.4,1
		c-0.3,0.1-0.5,0.2-0.8,0.2c-0.2,0.1-0.4,0.1-0.6,0.2c-0.4,0.1-0.8,0.2-1.2,0.3c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.3,0-0.6
		c0.1-0.3,0.2-0.7,0.2-1.1c0.1-0.5,0.2-0.9,0.7-1.3c-0.2-1.1,1-2.3,0-3.3c-0.1,0-0.2,0-0.4,0c-0.1-0.1-0.1-0.2-0.2-0.5
		c-0.9,0.6-2,1-1.9,2.2C166.9,121.9,166.4,121.1,165.4,121.3z M151.5,129.3L151.5,129.3h0.1H151.5z M151.7,126.8
		c0.1,0,0.1,0.1,0.2,0.1c-0.1,0.1-0.1,0.2-0.2,0.2C151.7,127.1,151.7,126.9,151.7,126.8z M169.6,120.3c0.1-0.1,0.2-0.1,0.3-0.1
		c0,0.1,0.1,0.2,0.1,0.2c-0.1,0.1-0.2,0.2-0.3,0.3l-0.3-0.1C169.5,120.5,169.5,120.4,169.6,120.3z"
      />
      <path
        class="st2"
        d="M136.9,115.9c0,0.3,0,0.6,0.1,0.9c0.2,1.5,1.2,1.9,3.5,1.7l0.1,0.1c0.3,0.3,0.5,0.5,0.7,0.8
		c1.2,0,1-1.5,2.3-1.4c0.1,0,0.1,0,0.2,0c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.2-0.2,0.3-0.2,0.5c-0.5,1.1-0.5,2.1,1.3,2.6
		c-0.5,0.8-1,1.5-1.5,2.2c0.4,0.5,1.1,0.6,1.7,0.4c0.2,0,0.3-0.1,0.5-0.2c0.6-0.2,1.2-0.4,1.8-0.7c0.5-0.2,1-0.4,1.6-0.6
		c0,0.1,0,0.1,0,0.2c0.7-0.2,1.4-0.5,2.2-0.7c-0.2-0.4-0.3-0.9-0.5-1.3c-1-2.9-2-5.7-3-8.7c-1.4,0.3-2.7,0.7-4.1,1
		c-0.1,0.2-0.2,0.3-0.4,0.5c0.1,0,0.1,0.1,0.2,0.1c0.3-0.2,0.7-0.5,1.1-0.8c0.9,0.3,1.8,0.6,2.7,0.9c0.2,0.1,0.3,0.4,0.3,0.5
		c-0.1,0.2-0.4,0.4-0.6,0.5c-0.2,0-0.4-0.1-0.7-0.2c-0.6,1.2,0.9,1.8,0.9,2.9c-0.8,0.2-1.2,1.4-2.5,1c0.5-0.6,1-1.1,1.5-1.7
		c-0.8-0.5-1.4-1.1-2.4-1c-0.1,0.5-0.2,1-0.4,1.6c0,0.1,0,0.1,0,0.2c-0.2-0.3-0.3-0.6-0.4-0.9c-0.1-0.4-0.1-0.9,0.1-1.3
		c0.1-0.2-0.1-0.6-0.2-1.1c-0.6,0.3-1.1,0.6-1.7,0.9c-0.3-0.3-0.6-0.7-0.9-1c-0.1,0-0.2,0.1-0.3,0.1c-1.5,0.4-3,0.8-4.5,1.2
		C135.8,115.5,136.4,115.7,136.9,115.9z"
      />
      <path
        class="st2"
        d="M276.5,139.2c0.2-0.2,0.5-0.3,0.9-0.5c0.1,0.4,0.1,0.8,0.2,1.1c0.4-0.1,0.8-0.2,1.1-0.3
		c0.3-0.1,0.5-0.1,0.8-0.2c0-0.1-0.1-0.2-0.1-0.2c-0.3-0.7-0.6-1.6-0.6-2.4c0-0.1,0-0.2,0-0.3v-0.1c-0.5,0.1-1,0.2-1.4,0.3
		c0,0.1-0.1,0.3-0.1,0.4c0,0.2-0.1,0.5-0.1,0.7c0,0.1-0.3,0.2-0.5,0.3C275.8,138.6,275.8,138.6,276.5,139.2z"
      />
      <path
        class="st2"
        d="M268,135.9L268,135.9L268,135.9C267.9,135.9,268,135.9,268,135.9c-0.2,0.1-0.3,0.3-0.5,0.4
		c-0.7-0.6-0.9,0.2-1.4,0.4c-0.2-0.4-0.3-0.7-0.2-1c-0.3,0.1-0.6,0.1-0.9,0.2c-0.6,0.1-1.2,0.2-1.8,0.4c0.2,0,0.3,0.1,0.5,0.1
		c-0.7,0.6,0.1,0.4,0.5,0.6c-0.6,0.4-1.1,0.7-1.8,1.1c0.1-0.5,0.1-0.7,0.1-1c0-0.2-0.1-0.3-0.3-0.6c-0.5,0.1-0.9,0.2-1.4,0.3
		c0.2,0.2,0.4,0.4,0.5,0.6c-0.3,0.2-0.7,0.4-1.2,0.8c0.8-0.1,1.2-0.1,1.7-0.1c-0.3,0.4-0.6,0.6-0.7,0.8c2.6-0.5,5.2-1.1,7.7-1.6
		c0.4-0.1,0.8-0.2,1.1-0.2c0.1-0.3,0.3-0.5,0.4-0.8c0.3,0.1,0.6,0.2,1,0.3c0-0.5,0.1-1,0.1-1.4c-0.5-0.1-1-0.1-1.5-0.1
		c-0.3,0.1-0.5,0.1-0.8,0.2c0.1,0.1,0.2,0.2,0.3,0.3C269.3,135.9,268.7,136,268,135.9z M261.5,137.4L261.5,137.4
		C261.5,137.4,261.6,137.4,261.5,137.4C261.6,137.4,261.5,137.4,261.5,137.4z"
      />
      <path
        class="st2"
        d="M240.6,118.4c-0.1,0.2,0.1,0.7,0.3,0.8c0.2,0.1,0.7-0.1,1-0.2c0.3-0.2,0.5-0.4,0.8-0.7
		c0.3,0.1,0.4,0.3,0.7,0.4c-0.4,0.8-1.5,1.4-1.3,2.5c0.9-0.2,1-0.9,1.5-1.3c0.7,0.3,1.8-0.6,2.1,0.5c0.4-0.3,0.6-0.5,0.9-0.7
		c0,0.2,0,0.4,0,0.6c0,0.7,0.1,1.3,1.1,1.5c1-0.5,0.1-1,0.1-1.5c0.9,0,0.8,0.9,1.5,1.2c-0.5,0.4-0.9,0.7-1.3,1
		c0.1,0,0.2,0.1,0.4,0.1s0.3,0.1,0.5,0.1c-0.3,0.5-0.6,1-1,1.6c0.5,0.4,0.4,1.3,0.6,2c0.1,0.3-0.3,0.8-0.5,1.1
		c-0.2,0.2-0.5,0.4-0.9,0.7c-0.4-0.1-1-0.3-1.6-0.4c-0.3,0.3-0.5,0.6-0.8,0.9l0,0c-0.2,0.3-0.5,0.5-0.7,0.8c0.4,0.1,0.8,0.2,1.2,0.3
		c0.2,0.1,0.4,0.1,0.6,0.2c0.4,0.1,0.9,0.1,1.4-0.1c1.2,0.7,2-0.6,3.2-0.6c-0.2,0.3-0.4,0.6-0.6,0.9c-0.1,0.1-0.2,0.3-0.3,0.4
		c-0.1,0-0.2-0.1-0.3-0.1c-0.2-0.1-0.3-0.1-0.5-0.2c-0.3,0.2,0,0.8-0.9,0.6c-0.5-0.1-1,0.7-0.9,1.3c0,0.1,0,0.2,0.1,0.3
		c0.2,0.3,0.5,0.5,0.7,0.7c-0.1,0.4-0.4,0.9-0.4,1.3c0,0.1,0,0.2,0.1,0.3c0.1,0.2,0.3,0.4,0.6,0.5h0.1c1.1-0.2,2.1-0.4,3.2-0.6
		c0.2-0.1,0.4-0.3,0.7-0.4c0,0.1-0.1,0.2-0.1,0.3c0.6-0.1,1.3-0.2,1.9-0.4c5-0.9,10-1.9,15-2.8h0.1l-0.1-0.1
		c-0.1-0.1-0.2-0.2-0.4-0.3c0-0.1,0.1-0.2,0.1-0.3c0.2-0.5,0.4-0.9,0.6-1.4c0.1-0.2,0.1-0.3,0.2-0.5c-0.2-0.1-0.5-0.1-0.9-0.2
		c0.6-0.8,1.4-1.3,2.2-1.2c0.9,0.2,1.4-0.4,2-0.7c0,0,0.1,0,0.1-0.1c0.9-0.3,0.9-1.1,0.2-1.6c-0.5-0.4-1.1-0.7-1.6-1.1
		c-0.9-0.8-2-1-3.2-0.9c-0.2,0-0.5,0-0.7,0.1c0,0.4,0.5,0.9-0.1,1.2c-0.1,0-0.3,0.1-0.5,0.1c-0.1-0.2-0.3-0.5-0.4-0.8
		c-0.1-0.2-0.2-0.4-0.4-0.5c-0.3-0.2-0.6-0.4-1.1-0.3c-0.8,0.1-1.1-0.3-1.5-0.6l-0.1-0.1c-0.6-0.5-1-0.5-1.6,0.2
		c-0.4,0.5-0.9,0.3-1.3,0.6c-0.1-0.6-0.1-0.8,0.2-1l0,0c0.1-0.1,0.3-0.2,0.5-0.3c-0.6-0.4-0.5-1.4-1.7-0.9c-0.1,0-0.3-0.2-0.3-0.3
		c-0.2-0.9-1.3-1.3-1.7-2.1c-0.1-0.1-0.3-0.2-0.5-0.3c-0.3,0.4-0.7,0.7-1,1.1c-0.5-0.4-1-0.8-1.5-1.3c-0.5,0.3-1,0.5-1.4,0.8
		l0.1-0.1c0,0,0,0-0.1,0c0,0,0,0,0,0.1c-0.3,0.3-0.6,0.7-1,1c0.5,0.5,1,1,1.5,1.5c-0.4,0.8-0.8,1.6-1.2,2.5
		c-0.4-0.3-0.5-0.7-0.8-0.8c-0.4-0.1-0.8,0.1-1.5,0.3c0.3-1,0.5-1.9,0.8-3.1c-0.1-0.3-0.3-0.9-1.4-0.7c-0.3,0.1-0.7-0.4-1.1-0.7
		c0.5-0.3,0.9-0.6,1.3-0.8c0.2-0.1,0.4-0.2,0.5-0.3c-0.1-0.3-0.2-0.5-0.3-0.6c-0.3-0.4-0.6-0.3-1.6-0.1c0,0.2,0,0.3,0,0.5
		c0,0.1,0,0.3,0,0.4s0,0.1,0,0.2c-0.1,0-0.1,0-0.2,0c-0.3-0.1-0.7-0.2-1.2-0.3l0,0l0,0c0.1,0.2,0.1,0.4,0.2,0.5
		c0.1,0.2,0.2,0.5,0.2,0.7c-0.5,0.1-0.9,0.2-1.4,0.3c-0.4,0.1-0.8,0.4-1.5,0.7c0.3-0.6,0.5-1,0.6-1.3c-0.3-0.6-0.6-1-1.7-0.8
		c-0.2,0-0.4,0-0.6-0.1c-0.3-0.1-0.6-0.2-1-0.4c-0.1,0-0.2-0.1-0.3-0.1C241.1,117.4,240.8,117.9,240.6,118.4z M266.7,124.7
		c0.1,0,0.2,0,0.3,0.1c0.1,0,0.1,0.1,0.2,0.1c-0.2,0.2-0.3,0.3-0.4,0.4c-0.1-0.1-0.2-0.2-0.3-0.3c0,0,0,0-0.1-0.1
		C266.5,124.9,266.6,124.8,266.7,124.7z M250.3,131.1c-0.1,0-0.3-0.1-0.4-0.1c0.1-0.1,0.1-0.2,0.2-0.2c0.1,0,0.3,0,0.4,0
		C250.4,130.9,250.3,131.1,250.3,131.1z M259.8,121.8L259.8,121.8l-0.1,0.1L259.8,121.8z"
      />
      <path
        class="st2"
        d="M179.7,126.2l-0.1-0.1c0,0.1,0,0.1-0.1,0.2C179.6,126.2,179.7,126.2,179.7,126.2z"
      />
      <path
        class="st2"
        d="M291.1,127.1c1.7-0.3,3.5-0.7,5.2-1c-0.1-0.1-0.1-0.2-0.2-0.3c-0.8-1-1.2-2.2-1.2-3.4c0-1.1-0.3-1.9-1.4-2.6
		c0.7-0.2,1.2-0.3,1.6-0.5c1.6-0.6,2.4-2.3,1.6-3.6c-0.6-1.2-2.4-1.6-3.9-1c-1.7,0.7-2.5,2.2-1.7,3.5c0.5,0.9,1.2,1.7,1.9,2.5
		c0.9,1,0.7,2.2-0.6,3c-1.5,0.9-2,1.6-1.7,2.7C290.8,126.7,290.9,126.9,291.1,127.1z"
      />
      <path
        class="st2"
        d="M230.3,139.9c-0.3,0.1-0.6,0.3-0.9,0.5c0.2,0.3,0.4,0.6,0.6,0.9c0.1,0.1,0.2,0.2,0.3,0.4
		c0.5-0.1,1-0.2,1.5-0.3c2.6-0.5,5.2-1,7.8-1.5c1.6-0.3,3.2-0.6,4.8-0.9c0.9-0.2,1.8-0.3,2.6-0.5c-0.2-0.5-0.3-1.1-0.4-1.7
		c-1.4,0.3-2.9,0.5-4.3,0.8c-0.1,0-0.1,0-0.2,0c-1.7,0.3-3.4,0.7-5.1,1c-1.2,0.2-2.3,0.5-3.5,0.7c-0.6,0.1-1.3,0.3-1.9,0.4
		C231.3,139.7,230.8,139.8,230.3,139.9z"
      />
      <path
        class="st2"
        d="M301.4,117.1c-0.1,0.9,0.4,1.6,1.3,2.1c1.1,0.6,2.2,1.1,3.2,1.8l0,0v-0.4v-0.3v-1.9V118v-3.9
		c-0.9,0.3-1.9,0.5-2.8,0.9C302.1,115.4,301.5,116.1,301.4,117.1z"
      />
      <path
        class="st2"
        d="M153.2,109.6l-0.1-0.1c-0.2,0.1-0.4,0.1-0.6,0.2c-0.2,0.1-0.5,0.1-0.7,0.2c0.2-0.1,0.5-0.1,0.7-0.2
		C152.7,109.7,153,109.6,153.2,109.6z"
      />
      <path
        class="st2"
        d="M154.8,110.5c0,0.1,0,0.1,0,0.2c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6,0.2-1.3,0.3-1.9,0.4c-1.3,0.3-2.6,0.5-3.9,1
		c0.6,1.9,1.3,3.7,1.9,5.6c0.5,1.4,1,2.8,1.4,4.2c0.9-0.3,1.7-0.5,2.6-0.8c1.7-0.5,3.4-1,5.1-1.5c1.1-0.3,2.3-0.7,3.4-1
		c0.1-0.1,0.1-0.2,0.2-0.4c-0.6,0.1-1,0.1-1.6,0.1c0.5-0.4,0.9-0.6,1.3-1c0.1-0.1,0.2-0.1,0.2-0.2c-0.1,0-0.2-0.1-0.2-0.1
		c-0.4-0.1-0.7-0.3-0.9-0.4s-0.6-0.1-0.6-0.2c-0.1-0.8-0.8-0.9-1.5-1.1c-0.1,0-0.3-0.1-0.4-0.1c-0.2,0.1-0.3,0.2-0.4,0.4
		c-0.5,0.5-1.1,1.1-2.2,0.4c0.5-0.6,1-1.3,1.6-2c-0.1-0.2-0.2-0.6-0.3-0.9c-0.1-0.7-0.3-1.2-1.5-1.1c-0.4,0.1-0.9-0.3-1.4-0.6
		c0.2-0.6,0.4-1,0.6-1.4C155.8,110.2,155.3,110.4,154.8,110.5z"
      />
      <path
        class="st2"
        d="M53.5,309.6c0-0.4-0.1-0.8-0.1-1.2c0-0.4-0.1-0.7-0.1-1.1c-0.1-0.7-0.2-1.3-0.2-2c0-0.4-0.1-0.7-0.1-1.1
		c0,0,0,0,0-0.1c-0.3-0.1-0.6-0.1-1,0c-0.3,0-0.7,0.1-1.1,0.3c0,0-0.1,0-0.1,0.1c-0.4,0.2-0.6,0.4-0.9,0.6c-0.4,0.4-0.7,0.8-0.9,1.3
		c-0.1,0.2-0.1,0.4-0.1,0.5c-0.1,0.4-0.1,0.8-0.2,1.2c0.2,0.1,0.3,0.2,0.5,0.3c0.3,0.2,0.6,0.3,0.9,0.5c0.8,0.3,1.6,0.5,2.7,0.3
		c0.2,0,0.3,0,0.5-0.1c0,0.2,0,0.3,0,0.5l0,0c0,0.6,0.1,1.1,0.1,1.7c-0.4,0.3-0.8,0.5-1.1,0.8c-1.1,1-1.5,2.3-0.9,3.4
		c0.5,1,1.7,1.6,3,1.6c-0.3-2.5-0.6-5-0.8-7.5C53.5,309.6,53.5,309.6,53.5,309.6z"
      />
      <path
        class="st2"
        d="M159.8,120.6c-0.2,0.1-0.5,0.1-0.7,0.2c-0.9,0.3-1.8,0.6-2.7,0.9c-0.3,0.1-0.7,0.2-1,0.3
		c0,0.1,0.1,0.3,0.1,0.4c1.5-0.5,2.9-0.9,4.4-1.4C159.9,120.9,159.9,120.7,159.8,120.6z"
      />
      <path
        class="st2"
        d="M277.1,135.4L277.1,135.4c0.5,0,0.9-0.1,1.3-0.2c-0.1-0.2-0.3-0.4-0.5-0.6c-0.2-0.2-0.4-0.4-0.6-0.6
		c-0.1-0.1-0.2-0.3-0.2-0.4c-0.4,0.1-0.7,0.1-1.1,0.2c0.1,0.3,0.3,0.6,0.6,0.9C276.7,134.9,276.9,135.1,277.1,135.4z"
      />
      <path
        class="st2"
        d="M302.7,132.7c-0.4,0.2-0.8,0.3-1.3,0.5c-0.1-0.4-0.2-0.8-0.2-1.1c-0.3-0.1-0.6-0.1-0.9-0.2
		c-0.3,0.1-0.6,0.1-0.9,0.2c-2.2,0.5-4.4,0.9-6.6,1.4c-0.9,0.2-1.7,0.4-2.6,0.5c-0.1,0-0.2,0-0.2,0.1c0,0.2,0.1,0.4,0.1,0.5
		c0.2,0.7,0.1,1.5-0.1,2.4c3.5-0.8,7-1.6,10.5-2.4c1.8-0.4,3.6-0.8,5.4-1.2v-2.7c-1,0.2-2.1,0.4-3.1,0.6
		C302.8,131.8,302.7,132.3,302.7,132.7z"
      />
      <path
        class="st2"
        d="M104.2,153.8c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0.1,0,0.1-0.1,0.2-0.1c0.9-0.4,1.9-0.9,2.8-1.3
		c-0.4-0.4-1-0.4-1.7-0.3C104.7,152.8,104.2,153.3,104.2,153.8z"
      />
      <path
        class="st2"
        d="M294.3,129.1c1.4-0.3,2.8-0.6,4.3-0.8c-0.1,0-0.2-0.1-0.3-0.1c-0.4,0-0.8-0.4-1-0.7c-0.1-0.1-0.1-0.2-0.2-0.3
		c-0.9,0.2-1.9,0.4-2.8,0.5C294.3,128.3,294.3,128.7,294.3,129.1z"
      />
      <path
        class="st2"
        d="M276.1,131.2c-0.3,0.5-0.5,1-0.4,1.6c0.4-0.1,0.8-0.2,1.3-0.2v-0.1c0.6-0.5,1.2-0.9,2.1-0.9
		c0.8,0,0.8,0,1.5-1.1c0,0,0,0-0.1,0C279,130.7,277.5,131,276.1,131.2z"
      />
      <path
        class="st2"
        d="M231,270.6c1.3-0.4,2,0,2.3,1.1c0.2,0.6,0.6,0.8,1.5,1l0,0c-1.4-1.3-2.8-2.7-4.2-4
		C230.4,269.4,230.4,269.5,231,270.6z"
      />
      <path
        class="st2"
        d="M252,246.5c-0.4,0.2-0.9,0.3-1.3,0.4c-0.5,0.2-1,0.5-1.2,1c0,0,0,0.1-0.1,0.1c0.1,0,0.4,0,0.7,0
		c-0.1,0.2-0.3,0.5-0.4,0.7c0.4,0,0.8,0,1.2,0.1c-0.4,0.3-0.7,0.6-1.1,0.9c0.2,0.3,0.4,0.6,0.7,0.7c0.2,0.1,0.6,0,0.8-0.1
		c0.1,0,0.1-0.1,0.1-0.1c0.2-0.8,1-1.3,1.4-2l0.1-0.1c0.1-0.2,0.1-0.4,0.1-0.7v-0.1c-0.3-0.2-0.5-0.4-0.8-0.6
		C252.2,246.6,252.1,246.5,252,246.5z"
      />
      <path
        class="st2"
        d="M171.9,293.6c-0.1-0.3-0.2-0.5-0.4-0.7c-0.6-0.9-1.8-1.5-3.5-1.7c0.7,1,1.4,2.1,2,3.1l0,0
		c0.3,0.4,0.5,0.8,0.8,1.2c0.1,0.2,0.2,0.3,0.3,0.5s0.3,0.4,0.4,0.6c0.1-0.3,0.3-0.5,0.4-0.8c0.1-0.3,0.2-0.6,0.2-0.9
		c0-0.1,0-0.2,0-0.4C172,294.2,172,293.9,171.9,293.6z"
      />
      <path
        class="st2"
        d="M240.1,271.7c-0.6-0.1-1-0.5-0.9-1.1c0-0.3-0.3-0.6-0.5-1c-0.4,0.2-0.7,0.3-1,0.4c-0.5-0.2-0.4-1.1-1.4-0.7
		c-0.1,0.2-0.2,0.4-0.4,0.8c-0.2-0.4-0.4-0.6-0.4-0.8c0-0.4,0.2-0.9,0.3-1.4c0.1-1.3-0.2-1.6-1.7-1.8c-0.3,0-0.6-0.1-1.1-0.1
		c0.5-0.6,0.9-1.2,1.4-1.9c0.4,0.3,0.7,0.5,0.8,0.7c0.4,0.5,0.8,0.9,1.6,1.1c0.8,0.3,1.4,0.9,2.2,1c0.7,0.1,1.4-0.3,1.3-0.8
		c-0.1-0.5-0.3-1.1-1-1.2c-1-0.1-1.6-0.4-2-1.2c-0.3-0.6-1-0.6-1.8-0.2c-0.4,0.2-0.8,0.4-1.6,0.7c0.9-1-0.2-0.8-0.3-1.2
		c0.2-0.1,0.4-0.2,0.8-0.3c-0.3-0.4-0.5-0.8-0.8-1.3c0.2-0.1,0.5-0.2,0.7-0.3c0.1-0.3,0.1-0.7,0.3-0.9c1.1-0.8,1.1-0.7,3.4,0
		c0.3-0.4,0.6-0.9,0.9-1.4c-0.3-0.4-0.5-0.9-0.8-1.4c-0.9,0-1.8,0.3-2.6-0.1c-0.3-0.2-1.2,0.3-1.9,0.6c-0.7,0.3-1.3,0.5-1.8,0l0,0
		l0,0c0.5-0.4,0.7-0.6,0.7-0.8c0-0.1,0-0.2,0-0.3c0-0.2-0.1-0.4-0.1-0.7c0-0.1,0-0.1,0-0.2c0.1,0,0.2,0,0.3,0c1.1,0,1.1,1,1.9,1.4
		c0.2-0.3,0.3-0.7,0.6-1.4c0.2,0.4,0.4,0.6,0.5,0.8c0.6-0.2,1.1-0.8,1.2-1.3v-0.1c0-0.1,0-0.3,0-0.4c-0.2-0.5-0.6-0.9-1-1.4
		l-0.1-0.1c0.2,0,0.4,0,0.7,0c-0.1-0.7,0-1.3,0.3-1.9c0.2-0.5,0.6-0.9,1.1-1.3c0.1-0.1,0.2-0.2,0.3-0.3c0.2-0.3,0.3-0.6,0.4-0.9
		c0.1-0.3-0.7-0.7-0.8-0.5c-0.3,0.9-1.5,0.6-2,1.2c-0.1,0.1-0.2,0.3-0.4,0.4c-0.6-0.1-1-0.6-1.5-0.8c-0.4-0.1-0.8-0.2-1.3,0
		c0,0.3,0,0.6,0,0.8c-0.1,1-0.8,1.8-2.1,2.4c0.3-0.8,0.7-1.6,1-2.4c-0.8-0.7,1.2-1.7-0.2-2.4c-0.7,0.2-0.3,0.8-0.5,1.2
		c-0.5,0.2-1.1,0.4-1.6,0.6c0-0.1-0.1-0.1-0.1-0.2c0.4-0.2,0.8-0.4,1.2-0.6c-0.1-0.1-0.2-0.2-0.4-0.3c-0.6-0.1-1.3-0.2-2.2-0.2
		c-0.2,0.2-0.7,0.5-1.1,0.8c-0.7-0.5-1.3-1-1.9-1.4c0,0,0,0-0.1-0.1c0,0-0.1,0-0.1-0.1c0,0,0,0-0.1,0c-0.3,0.1-0.5,0.7-0.9,0.6
		c-0.1,0-0.2-0.1-0.3-0.2l0,0c-0.3,0-0.7-0.1-1-0.1c-0.2,0-0.4-0.1-0.6-0.1c-0.3,0.2-0.6,0.5-0.9,0.7c-0.5-0.2-1.1-0.4-1.7-0.7
		c-0.2,0.5-0.3,0.9-0.5,1.4c-0.6-0.2-1.1-0.3-1.5-0.4c0.2-0.1,0.4-0.2,0.7-0.4c-0.5-0.1-0.8-0.2-1.1-0.3v-0.1c0.5-0.3,1.1-0.7,1.6-1
		c0.1-0.1,0.4,0.2,0.7,0.4c0.2-0.1,0.4-0.1,0.5-0.2c0.6-1.2,0.3-1.2,1.9-1.3c0.4,0,0.7-0.1,1.1-0.2c0.2,0.3,0.3,0.6,0.5,0.9
		c0.2,0.4,0.4,0.8,0.6,1.1l0,0c0.6-0.4,0.7-0.9,0.8-1.4c0-0.4-0.1-0.8-0.1-1.3c1,0.1,1.1,0.6,1.1,1.4c0.3-0.2,0.5-0.4,0.7-0.5
		s0.4-0.2,0.7-0.4c-0.6-0.5-0.4-1.3-0.1-1.9c0.3-0.6,1.3-1,2.1-1.6c0.2,0,0.7,0.1,1.4,0.2c0-1,0-2,0-2.9c0.5,0,1.1,0,1.6,0
		c-0.5-0.4,0.8-0.9,0.1-1.3c0.4-0.4,0.7-0.8,1.1-1.3c0.8,0.3,1.1-0.1,1.4-0.6c1.2,0.7,0.9,1.7,0.4,2.8c-0.7,0.2-1.6,0.5-2.5,0.8
		c0-0.3,0-0.6-0.5-0.5c-0.1,0.3-0.3,0.8,0.4,0.5c0,0.2-0.1,0.5-0.1,0.7c0.1,0.8,0.3,1.3,0.6,1.7c0.6,0.7,1.7,0.9,3.5,0.9
		c0.4,0.4,0.7,0.8,1.1,1.1c0.2,0.1,0.3,0.2,0.5,0.3c1,0.4,2.3,0,2.7-1.1c0.4-0.9,0.3-1.7-0.5-2.2c-0.6-0.4-0.6-0.9-0.1-1.5
		c-0.6-0.1-1.1-0.3-1.7-0.4c-0.2,0.6-0.5,1.2-0.7,1.7c-0.2-0.3-0.5-0.6-0.7-0.9c0.2-0.4,0.3-0.7,0.5-1.1c-0.7,0.1-1.2,0.1-1.8,0.2
		c0.5-0.6,0.9-1.3,1.5-1.8c0.4-0.3,0.9-0.6,1.4-0.8c-6.1-4.7-12.3-9.4-18.4-14.1c-1-0.7-2-1.5-2.9-2.2c-2.3-1.8-4.6-3.5-6.9-5.3
		c-0.3-0.2-0.6-0.5-1-0.7c-14.9-11.4-29.8-22.7-44.7-34.1c0.2,4.3,0.3,8.2,0.5,12c0,0.4,0.4,0.8,0.7,1.1c1.7,1.5,3.3,3,5.1,4.5
		c-0.9,0.8-1.5,0.6-2.2,0c-1.1-1-2.2-1.9-3.2-2.9c-0.1,0.1-0.3,0.2-0.4,0.2c0.2,1.4,0.5,2.8,0.7,4.3c-0.1,0.4-0.3,1-0.3,1.6
		c0,1,0.2,2,0.1,2.9c-0.1,1.1,0.4,1.9,1.2,2.7c9.8,9.3,19.5,18.5,29.3,27.8c0.2,0.2,0.4,0.4,0.6,0.6c0.5,0.5,1,1,1.6,1.5
		c0.3,0.3,0.6,0.6,0.9,0.9c0.5,0.5,1.1,1,1.6,1.5c0.9,0.1,2,0.2,3.1,0.3l0,0l0,0h-0.1c1.5,0.4,1.1,1.7,1.4,2.6
		c0.5,0.1,1,0.4,1.3,0.3c1.2-0.4,1.7,0.1,2,0.9c0.1,0.2,0.7,0.4,0.3,0.7c-0.5,0.4,0.4,1.3-1.1,1.4c0.5,0.6,0.9,1.1,1.2,1.6
		c0.1,0.1,0.1,0.2,0.2,0.3c0.7,0.6,1.4,1.3,2,1.9c0.5-0.2,1-0.4,1.7-0.6c-0.5,0.5-0.7,0.7-1,0.9c0,0,0,0.1,0.1,0.1
		c0.7-0.4,1.5-0.7,2.2-1.1c0,0.1,0.1,0.3,0.1,0.4c0.1,0.3,0.2,0.9,0.1,0.9c-0.7,0.2-0.6,1-1.2,1.2c0.3,0.3,0.6,0.6,1,0.9
		c0.1,0.1,0.3,0.2,0.4,0.4c0.4,0.4,0.8,0.8,1.2,1.1c3.3,3.1,6.6,6.2,9.8,9.3c0.8,0.8,1.6,1.5,2.4,2.3c0.4,0.4,0.8,0.8,1.2,1.1
		c0.5,0.4,0.9,0.9,1.4,1.3c0.2-0.2,0.4-0.5,0.5-0.8c0.5,0.1,1.1,0.2,0.7,0.7c-0.2,0.3-0.2,0.5-0.1,0.8c0,0.1,0,0.2,0,0.3
		c0.3,0.3,0.7,0.6,1,0.9l0,0c0.9,0.8,1.8,1.7,2.6,2.5c0.2-0.1,0.4-0.2,0.5-0.2c0.9,0.3,1.5-0.1,2-0.8c0.3,0.4,0.5,0.6,0.7,0.8
		c-0.3,0.2-0.6,0.4-0.9,0.6c-0.2,0.5,0.6,1.5,1.1,1.4c1-0.3,1.6,0.1,2.2,0.6c0.2,0.2,0.7,0.1,1.2,0.1
		C241.6,272.7,241.3,271.9,240.1,271.7z M222.9,228c-1,1-1.7,1.1-2.7,0.2c-2-1.7-4.1-3.4-6.1-5.3c-0.3-0.3-0.6-0.5-0.9-0.8
		c0.6-0.1,1.4-0.4,1.7-0.1c0.1,0.1,0.2,0.1,0.3,0.2C217.8,224.1,220.3,226,222.9,228z M173.2,195.8c-1.5-1.4-3.2-2.7-4.8-4.1
		c0.1-0.2,0.2-0.4,0.2-0.6c0.7,0.2,1.5,0.2,2.1,0.6c1.7,1.2,3.4,2.6,5.1,4C174.8,196.5,174.1,196.6,173.2,195.8z M172,190.5
		c1.1-0.8,1.9-0.8,2.8,0c1.6,1.4,3.3,2.7,5,4.1c-1,0.8-1.8,0.9-2.7,0.1C175.4,193.2,173.7,191.9,172,190.5z M203.7,235.3
		c-1.9-1.9-3.9-3.6-5.9-5.3c-0.3-0.3-0.8-0.4-1.2-0.6c1.2-1.2,1.9-1.2,2.8-0.4c0.6,0.6,1.3,1.1,1.9,1.7c0.1,0.1,0.2,0.2,0.3,0.3
		c1.6,1.4,3.2,2.8,4.8,4.3C205.4,236.1,204.7,236.2,203.7,235.3z M209.9,232.8c-0.1,0-0.1-0.1-0.2-0.1c0,0,0,0-0.1-0.1
		c-1.9-1.8-3.9-3.6-5.9-5.3c-0.3-0.3-0.5-0.6-0.7-1.2c0.6,0,1.4-0.1,1.7,0.2c2.4,2,4.8,4.1,7.1,6.1c0.1,0.1,0.1,0.2,0.2,0.4
		C211.4,233.5,210.7,233.5,209.9,232.8z M214,247.5L214,247.5c0-0.1,0.1-0.1,0.1-0.1C214.1,247.5,214,247.5,214,247.5z M215.4,230.5
		c-0.5-0.4-1-0.9-1.5-1.3c-0.3-0.3-0.7-0.6-1-0.9c-0.2-0.2-0.4-0.3-0.6-0.5c-0.8-0.7-1.6-1.4-2.4-2.2c-0.5-0.5-1.1-1-1.6-1.6
		c0.2,0,0.3-0.1,0.5-0.1c0.5-0.1,1-0.2,1.2-0.1c0.9,0.7,1.9,1.5,2.8,2.2c0.6,0.5,1.3,1,1.9,1.5c0.2,0.2,0.4,0.3,0.6,0.5
		c0.9,0.7,1.8,1.5,2.7,2.2C217,231.2,216.2,231.3,215.4,230.5z"
      />
      <path
        class="st2"
        d="M223.4,261.8c-2.8-2.6-5.5-5.3-8.3-7.9c-0.4-0.3-0.7-0.7-1.1-1c-0.2-0.2-0.4-0.4-0.6-0.6
		c-0.5-0.4-0.9-0.9-1.4-1.3c-0.3,0.3-0.5,0.7-0.7,1c-0.1,0.1-0.1,0.2-0.2,0.2c0.3,0.3,0.5,0.5,0.8,0.8c3.3,3.2,6.6,6.4,9.9,9.6
		c2,2,4.1,3.9,6.1,5.9c-0.1-0.2-0.2-0.5-0.3-0.7c0-0.1,0.3-0.2,0.5-0.4c0.1,0.1,0.2,0.2,0.2,0.3c0.4-0.1,0.7-0.2,1-0.3
		C227.3,265.5,225.3,263.6,223.4,261.8z"
      />
      <path
        class="st2"
        d="M138,100.5c-0.1,0-0.2,0-0.3,0c0,0.2-0.2,0.6-0.1,0.7c0.9,0.5,0.8,1.3,0.8,2.1c0.8-0.2,1.6-0.4,2.4-0.7
		c-0.8-0.4-1.5-0.7-2.4-1.2C138.3,101.3,138.1,100.9,138,100.5z"
      />
      <path
        class="st2"
        d="M306,111.1c-0.6,0.1-1.2,0.1-1.9,0.2C304.7,111.4,305.3,111.4,306,111.1L306,111.1z"
      />
      <path
        class="st2"
        d="M134.5,114.1c0.4-0.1,0.7-0.2,1.1-0.3C135.2,113.7,134.9,113.8,134.5,114.1z"
      />
      <path
        class="st2"
        d="M118.3,137.4c-0.1-0.1-0.4,0-0.6,0.1c-1.6,0.7-3.2,1.4-4.8,2.1c0.3,0.7,1,1.1,2,1.2c0.2,1,0.4,1.8,0.6,2.7
		c0,0.3-0.1,0.7-0.3,1c-0.3,0.6-0.5,0.8-0.3,1c0.1,0.2,0.3,0.3,0.6,0.6c0.3,0.3,0.4,0.7,0.4,1.2c0,0.1,0,0.1,0,0.2
		c0,0.5,0,1.1-0.1,1.6c0.7-0.3,1.5-0.7,2.2-1c-0.1-0.3-0.1-0.7-0.2-1c0-0.1,0-0.2-0.1-0.3c-0.1-0.2-0.1-0.5-0.1-0.7
		c0.1-0.4,0.1-0.7,0.1-1.1c0-0.9-0.3-1.8-0.6-2.7c-0.5-1.3-0.6-2.5,0.4-3.8c0.2,0,0.4,0.1,0.6,0c0.3-0.1,0.6-0.3,0.8-0.5
		C118.8,137.8,118.6,137.5,118.3,137.4z"
      />
      <path
        class="st2"
        d="M136.8,103.7c-0.9,0-1.9-0.2-2.8,0.1c0.4,0.1,0.8,0.3,1.2,0.4C135.7,104,136.2,103.9,136.8,103.7z"
      />
      <path
        class="st2"
        d="M142.8,102.1c-0.5-0.3-1.1-0.6-1.6-0.9c-0.1,0.5-0.2,1-0.3,1.5C141.5,102.5,142.1,102.3,142.8,102.1z"
      />
      <path
        class="st2"
        d="M151,110c0-0.8,0-1.5-0.1-2.1c-0.2-0.9-1.1-0.9-2-0.9c0.6-0.8,0.7-1.6,0.5-2.4c-0.7-0.6-1.3-0.1-2,0
		c-0.2-0.2-0.4-0.5-0.6-0.7c-0.2,0-0.4,0.1-0.6,0.1c0.8,2.2,1.5,4.4,2.3,6.5C149.2,110.4,150.1,110.2,151,110z"
      />
      <path
        class="st2"
        d="M306,110.6v-0.7v-0.1v-2.6v-0.5c-0.4,0-0.8,0.1-1.2,0.1c-0.8,0.1-1.6,0.1-2.5,0.2s-1.8,0.2-2.7,0.3
		c0.7,0.1,1.5,0.1,2.4-0.2c-0.6,1.4-0.3,2.5,0.3,3.5c0.2,0.1,0.5,0.2,0.7,0.3C304,110.8,305,110.7,306,110.6z"
      />
      <path
        class="st2"
        d="M136.5,106.9c-0.4,0.2-0.8,0.2-1.1-0.3c-0.2-0.5-0.6-0.8-1.2-0.9c-0.2,0.1-0.5,0.1-0.7,0.2
		c-0.4,0.7,0.1,1.2,0.6,1.9c-0.3,0.3-0.6,0.6-1,1c0.3,0.3,0.5,0.6,0.9,1c1.2-1.1,1.4-1.2,2.6-0.7c1.7,0.6,1.7,0.6,3.5,0.2
		c0.3,0.7,0.6,1.3,0.9,2.1c0.5,0,1.2,0.1,2.1,0.2c-0.2,0.2-0.4,0.3-0.5,0.4c1.5-0.4,3-0.8,4.6-1.1c-0.8-2.4-1.6-4.7-2.5-7.1
		c-0.3-0.1-0.6-0.3-0.8-0.6c-2.5,0.7-5,1.3-7.5,2C136.4,105.8,136.5,106.3,136.5,106.9z"
      />
      <path
        class="st2"
        d="M114.4,124.3c0,0.3,0.1,0.6,0.1,0.8c0,0.4,0.1,0.8,0.1,1.2c-1.8,0.2-2.2,0.2-2.6,1.2c-0.1,0.3-0.3,0.6-0.4,1.1
		c0,0.1,0.1,0.2,0.1,0.2c0.7,1.1,2,1.3,3.4,1.2c0,0.2,0,0.4,0,0.6c0,1.7-0.1,3.3-0.1,5c0.4-0.2,0.8-0.4,1.2-0.5
		c-0.1-1.4-0.3-2.8-0.4-4.2c0-0.2,0-0.4-0.1-0.6c0.9,0.1,1.7,0.1,2.4-0.3c0.2-0.1,0.4-0.3,0.5-0.4c0.3-0.4,0.6-1,0.7-1.4
		c0-0.5-0.1-0.9-0.5-1.2c-0.6-0.5-1.6-0.6-3.2-0.5c-0.2-0.3-0.2-0.7-0.3-1.1C115.2,125,115,124.6,114.4,124.3z"
      />
      <path
        class="st2"
        d="M200.4,120.8c0.8-0.2,1.6-0.4,2.4-0.6l-0.1-0.1C202.5,120,200.5,120.6,200.4,120.8
		C200.5,120.7,200.5,120.7,200.4,120.8z"
      />
      <path
        class="st2"
        d="M200.6,122c0.2,0.2,0.4,0.4,0.7,0.6l0,0c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.2,0.3-0.4,0.4-0.6c0,0,0,0,0-0.1l0,0
		c-0.3,0.1-0.5,0.1-0.8,0.2C200.9,122,200.7,122,200.6,122z"
      />
      <path
        class="st2"
        d="M301.2,95.5c0.8,0,1.6-0.1,2.3-0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0c0.5,0,1,0,1.5-0.1c0.1,0,0.2,0,0.3,0
		V95v-0.2v-0.6v-3.6v-1.4v-1.4v-0.4l0,0h-0.1c-1.4,0.3-2.6,1.4-3.6,3c-0.3-0.3-0.6-0.6-0.9-0.9c-0.3,0.3-0.5,0.5-0.7,0.6
		c-0.3,0.4-0.1,0.6,0.7,1.2c0.2-0.1,0.4-0.2,0.7-0.4l0,0c0.1,0.3,0.1,0.6,0.2,1.1c-0.4,0.1-0.7,0.1-1,0.1c-2,0-3.9,1.7-4,3.5
		c0.6,0,1.1-0.1,1.7-0.1C299.7,95.6,300.5,95.6,301.2,95.5z"
      />
      <path
        class="st2"
        d="M140.6,139c-0.1,0-0.2-0.1-0.3-0.1c-0.4,0-0.9,0-1.2,0.1s-0.6,0.4-0.9,0.9C138.9,139.7,139.8,139.4,140.6,139z
		"
      />
      <path
        class="st2"
        d="M226.1,114.9c0.2,0,0.4-0.2,0.9-0.5c0.1,0.2,0.1,0.5,0.2,0.7c1.6-0.3,3.1-0.5,4.7-0.8c1.1-0.2,2.2-0.4,3.3-0.6
		c0.5-0.1,1.1-0.2,1.6-0.3c-0.1-0.8-0.6-1.5-1.2-2l0,0c-0.3-0.3-0.7-0.5-1.1-0.6c-0.2-0.1-0.3-0.1-0.5-0.2c-1.9-0.6-4.2,0.1-5.5,1.5
		c-0.3,0.3-0.5,0.6-0.7,0.9c-0.5,0.7-1.2,1.2-2.1,1.4c0,0.1,0.1,0.1,0.1,0.2C225.9,114.8,226,114.9,226.1,114.9z"
      />
      <path
        class="st2"
        d="M213.6,119c-1.2,0.2-2.4,0.5-3.5,0.8c-0.9,0.2-1.7,0.4-2.6,0.6c-0.5,0.1-1.1,0.3-1.6,0.4s-1,0.2-1.4,0.4
		c-0.6,0.1-1.1,0.3-1.7,0.4c0,0,0,0,0.1,0c-0.3,0.9-0.5,1.7-0.8,2.7c-0.2,0.1-0.4,0.1-0.6,0.2c-0.8,0.3-1.5,0.6-1.8,1.5
		c-1-0.1-2-0.1-3-0.6s-2-0.1-2.5,0.9c-0.2,0.4-0.3,0.9-0.5,1.3c-0.3,0.5-0.7,1-1.1,1.6c-0.4-1.5-0.4-1.8,1-5.4
		c-0.2,0.1-0.5,0.1-0.7,0.2c-0.2,0.5-0.2,0.9-0.4,1.4s-0.6,1-0.9,1.7c-0.3-0.5-0.5-0.8-0.8-1.2c-0.6,1.5-0.7,2.8,0,4
		c-0.2,0.2-0.4,0.5-0.7,0.6c-0.4,0.3-0.8,0.5-1.2,0.6c-0.8,0.2-1.3-0.1-1.8-1.1c-0.2-0.4-0.4-0.7-0.6-1.1c-0.1-0.2-0.2-0.5-0.4-0.7
		c0,0,0.2-0.1,0.4-0.3l0,0c0.4-0.4,0.5-0.7,0-1s-1-0.1-1.3,0.5c-0.7,1.2-1.7,1.6-3.4,1.1c0.5-0.3,1.4,0.1,1.5-0.7c0-0.3,0-0.5,0-0.8
		c0-0.2-0.1-0.3-0.1-0.5c-0.1,0-0.2,0-0.3,0.1c-1.2,0.3-2.3,0.7-3.5,1c0,0.1,0.1,0.3,0.1,0.4c0.4,0.7,0.7,1.4-0.6,1.9
		c-0.1,0.9-0.7,1.4-1.4,1.9c-0.6,0.4-1.2,0.7-1.6,1.2c-0.2-0.1-0.5-0.2-0.8-0.3c0.3-0.3,0.5-0.6,0.8-0.8c-0.1,0-0.2-0.1-0.3-0.1
		s-0.2-0.1-0.3-0.1c0.1-0.8,0.2-1.6,0.3-2.4c-0.5,0-0.9,0-1.2,0c0-0.1,0-0.1,0-0.2c-0.7,0.2-1.4,0.4-2.2,0.7
		c-0.7,0.2-1.4,0.4-2.1,0.6c-1.2,0.4-2.4,0.8-3.6,1.1c-2.8,0.9-5.5,1.7-8.3,2.6c-1.8,0.6-3.6,1.2-5.4,1.8c0.3,0.4,0.6,0.8,0.7,1.3
		c0.1,0.7,0.7,1.1,1.5,1c1.3-0.2,1.7,0.5,2.3,1.3c0.3-0.1,0.6-0.2,0.9-0.3c0.1,0.1,0.2,0.2,0.1,0.2c-0.5,0.6-0.9,1.2-0.8,2
		c0,0.2-0.2,0.4-0.3,0.5c-0.6-0.2-1.1-0.4-1.8-0.7c-0.3-0.4,0.4-1.3-0.4-1.8c-0.4,0.4-0.6,0.5-0.6,1c0,0.1,0,0.3,0,0.4
		c0.1,0.4,0.2,0.9,0.5,1.8c2,0,3.9-0.7,5.9-0.3c0.5,1.1,0.5,1.1-1.3,2.3c0.5,0.2,0.9,0.4,1.3,0.6c-0.3,1.4-1.6,0-2.2,0.9
		c0.3,0.2,0.7,0.4,1,0.6c-0.5,0.5-1,1.1-1.6,1.7c-0.5,0.1-1.1,0.1-2.2,0.2c0.5-0.5,0.7-0.7,1-0.9c0.3-0.1,0.7-0.1,0.9-0.3
		c0.3-0.3,0.6-0.7,0.6-1s-0.4-0.7-0.7-0.7c-0.4,0-1,0.2-1.3,0.5s-0.4,0.7-0.6,1.2c-1.3-1.3-1.3-1.3-2.9-0.6c0-0.1,0-0.2,0-0.3
		s0-0.2,0-0.4s0-0.4-0.1-0.7c-0.2,0-0.4,0-0.4,0.1c-0.3,0.6-0.9,0.8-1.7,1c-0.1-0.4-0.2-0.7-0.3-1.1c-0.1-0.5-0.3-1-0.4-1.5
		c0.7-0.5,1.1-1,0.8-1.8c-0.1-0.2-0.1-0.5-0.1-0.8s0-0.6,0.1-0.9c0.1-0.5-1-0.9-0.2-1.5c0.1-0.1-0.3-0.7-0.6-1.2h-0.1
		c-0.4-0.1-1,0.8-1.5,0.2c-0.1-0.1-0.2-0.2-0.3-0.3c-1.1,0.4-2.2,0.8-3.3,1.2c-2.5,0.9-4.9,1.8-7.3,2.7h-0.1
		c-0.1,0.2-0.1,0.4-0.1,0.5c0,0.2,0,0.5,0,0.6c0.7,1.4,1.1,2.8,2.4,3.9c0.5,0.4,0.7,1,1,1.5c0.1,0.1,0.1,0.2,0.2,0.3
		c0.2,0.3,0.3,0.6-0.2,0.9c-0.1,0.1-0.1,0.3,0,0.4c0.4,0.6,0.1,1.3-0.1,2c-0.1,0.4,0,0.9-0.1,1.3c-0.1,0.3-0.3,0.6-0.4,0.8
		c-0.5-0.1-1-0.3-1.5-0.5h-0.1c-0.9-0.4-1.7-0.8-2.6-1.3c0,0.3,0,0.6,0,0.9c0,2.6,0,5.2,0.1,7.9c0,0.7,0,1.3,0,2c0,0.6,0,1.2,0,2
		c1.2-0.2,2.3-0.5,3.5-0.7c2.4-0.5,4.9-1,7.3-1.5c0.9-0.2,1.8-0.4,2.7-0.6c1-0.2,1.9-0.4,2.9-0.6c2.2-0.5,4.4-0.9,6.5-1.4
		c6.3-1.3,12.6-2.6,18.9-3.9c0.8-0.2,1.6-0.3,2.5-0.5c1.2-0.3,2.5-0.5,3.7-0.8c3.6-0.7,7.1-1.5,10.7-2.2c0.4-0.1,0.9-0.2,1.3-0.3
		c3.2-0.7,6.5-1.3,9.7-2c0.1,0,0.2,0,0.3-0.1c1.7-0.4,3.4-0.7,5.1-1.1c2.2-0.5,4.4-0.9,6.7-1.4c1.5-0.3,3-0.6,4.5-0.9
		c1.3-0.3,2.5-0.5,3.8-0.8c0-0.1,0-0.2,0-0.3c-2.1-0.7-4.1-1.4-6.2-2.1c-1-0.3-2-0.6-2.9-1c-0.4-0.2-0.8-0.6-1.1-0.9
		c0.4-0.2,0.8-0.6,1.3-0.7c0.7-0.1,1.4-0.2,2-0.4c0.8-0.1,1.5-0.3,2.3-0.4c0.2,0,0.4-0.1,0.6-0.1c0.2,0,0.3-0.1,0.5-0.1
		c0.5-0.1,1-0.2,1.5-0.3c0-0.3,0-0.5-0.1-0.7c-0.1-0.4-0.4-0.7-0.8-1c-0.3-0.2-0.7-0.3-1.1-0.4c-0.6-0.1-1.3-0.1-2,0.1
		c-0.2-0.6-0.6-1.1,0-1.6c-0.5-0.1-1-0.1-1.6-0.2c0.1-0.4,0.2-0.8,0.3-1.2c0.3-1,0.5-2,1.2-2.9c0,0,0.1,0,0.1,0.1
		c1.3,0.6,2.5,1.1,4,0.4c0.7-0.3,1.4-0.8,1.8-1.3l0.1-0.1c0.4-0.6,0.6-1.2,0.4-1.8c-0.2-0.7-0.8-1.4-1.8-2.1
		c-0.1-0.1-0.2-0.1-0.3-0.2c0.1-0.1,0.2-0.2,0.4-0.2c0.4-0.2,0.8-0.5,1.2-0.8c0.6,1.4,1.7,2.4,3.4,2.5c0.2,0,0.4,0,0.6,0
		c2-0.1,3.3-1.1,4.3-2.6c0.2,0.1,0.4,0.2,0.6,0.3l0,0c1,0.1,1.9,0.1,2.9,0.1c0.7,0,1.2,0,1.7,0.2c0.1-0.5,0.2-0.9,0.4-1.4
		c0.2-0.6-0.2-0.9-0.8-1.2c-1.2-0.6-2.3,0.1-3.5,0.3c-0.2,0.3-0.4,0.7-0.5,1c-0.7-0.9-1.3-1.9-2.1-2.6c-0.4-0.3-0.9-0.5-1.4-0.7
		c-0.4-0.1-0.8-0.2-1.1-0.4c0.2-0.4,0.4-0.9,0.6-1.4c0-0.1,0.1-0.1,0.1-0.2c0.2-0.4,0.4-0.8,0.5-1.2c0.4-0.1,0.9-0.2,1.5-0.3l0,0
		c0.1,0,0.2-0.1,0.3-0.1c1-0.3,1.9-0.9,2.5-1.6c0.4-0.5,0.7-1,0.8-1.7l0,0c0-0.1,0-0.1,0-0.2c-0.1,0-0.1,0-0.2,0h-0.1
		c-0.5,0.1-1.1,0.2-1.6,0.3c-0.4,0.1-0.8,0.1-1.3,0.2c-0.4,0.1-0.8,0.1-1.1,0.2c-1.4,0.2-2.7,0.5-4.1,0.7c-0.2,0-0.4,0.1-0.6,0.1
		c-0.2,0-0.4,0.1-0.7,0.1c-1.4,0.3-2.7,0.5-4.1,0.7c-0.5,0.1-1,0.2-1.5,0.3c-0.1,0.2-0.2,0.3-0.3,0.5l-0.1,0.1
		c-0.3,0.7-0.5,1.5-0.3,2.4c0,0.2,0.2,0.4,0.2,0.6c0,0.4-0.6,0.7-0.9,0.5c-0.5-0.3-1-0.7-1.4-1c-0.1-0.1-0.2-0.1-0.3-0.2
		s-0.3-0.2-0.4-0.3l-0.1-0.1c0,0,0-0.1,0.1-0.1c0.4-0.5,0.8-1,1-1.4c0-0.1-0.1-0.2-0.2-0.4c-0.2,0-0.4,0.1-0.6,0.1
		c-0.4,0.3-0.7,0.5-1.2,0.7c-0.3,0.1-0.7,0.1-1.1,0v-0.1c0-0.1,0-0.1,0-0.2c-0.1,0-0.1,0-0.2,0c-0.6,0.1-1.3,0.3-1.9,0.4
		C213.8,118.9,213.7,118.9,213.6,119z M235.1,124.9c0,0.1,0,0.1,0,0.2c-0.1,0-0.1-0.1-0.2-0.1C234.9,125,235,124.9,235.1,124.9z
M162.3,142.9c0,0,0.1,0,0.1,0.1c-0.1,0-0.2,0.1-0.3,0.1L162,143C162.2,143,162.3,142.9,162.3,142.9z"
      />
      <path
        class="st2"
        d="M241.3,158.6c1-0.5,1.8-1.3,2.7-1.4c1.5-0.2,1.1,1.5,1.7,2.2c0.8,1.1,1.9,1.3,3.1,1c1.1-0.3,2.1-0.8,2.2-2.2
		c-0.7,0.1-1.2,0.5-1.7,0.8c-1.2,0.6-2.4,0.5-3.2-0.5c-0.9-1,0.1-1.7,0.7-2.4c0.1-0.1,0.1-0.2,0.3-0.8H247c-2.5,0.8-4.6,1.4-7,2.2
		C240.6,158,241,158.4,241.3,158.6z"
      />
      <path
        class="st2"
        d="M258.8,165.9c2,0.8,3.9,1.7,5.9,2.5c0.1-0.1,0.1-0.3,0.2-0.4c-2-0.8-3.9-1.6-5.9-2.4
		C258.9,165.7,258.9,165.8,258.8,165.9z"
      />
      <path
        class="st2"
        d="M158,171.5c0.8,0.6,1.6,1.2,2.4,1.7c0.1-0.5,0.2-1,0.2-1.4c0-2.4-2.1-4.1-4.6-3.7c-0.5,0.1-1.1,0.3-1.7,0.6
		C155.5,169.7,156.7,170.6,158,171.5C157.9,171.5,158,171.5,158,171.5z"
      />
      <path
        class="st2"
        d="M177.4,165c-0.1-0.1-0.3-0.2-0.4-0.2c-1.7-1-3.3-0.5-5.1,0.1c1.1,0.8,2,1.5,2.9,2.2c0,0.1-0.1,0.3-0.1,0.4
		c-0.4-0.1-0.9-0.1-1.3-0.3c-0.6-0.4-1.2-0.8-1.8-1.3c-0.3-0.2-0.5-0.3-0.7-0.5c-0.8-0.4-1.3-0.3-2.6,0.4c0.5,0.3,0.9,0.7,1.3,1
		c0.5,0.4,1,0.7,1.5,1.1c-0.1,0.2-0.1,0.3-0.2,0.5c-0.5-0.1-1-0.2-1.4-0.4c-0.3-0.2-0.7-0.4-1-0.7c-0.3-0.2-0.5-0.4-0.8-0.6
		c-1.3-0.9-2.4-0.9-4,0.3c0.9,0.6,1.7,1.2,2.5,1.8c0,0.1-0.1,0.2-0.1,0.4c-0.6-0.2-1.3-0.3-1.9-0.5c0,2,0,3.9,0,5.9
		c0,1.1,0.4,1.8,1.3,2.4c2.8,2.1,5.6,4.2,8.4,6.3c0,0,0.1,0,0.1,0.1c12.3,9.1,24.6,18.3,36.9,27.4c1.3,0.9,2.5,1.9,3.8,2.8
		c1.7,1.2,3.3,2.5,5,3.7c6.5,4.8,13,9.7,19.5,14.5c0.2-0.3,0.5-0.5,0.7-0.7c0.6-1.1,1.9-1.3,3-1.9c0.2,0.7,0.3,1.4,0.5,2.3
		c-0.6-0.5-0.9-0.8-1.2-1c-0.5-0.3-1-0.1-1.1,0.4c-0.2,0.5-0.2,1.1-0.3,1.7c-0.1,0-0.3,0.1-0.4,0.1c0.6,0.4,1.2,0.9,1.8,1.3
		c0.1,0,0.2,0,0.3-0.1c0.1,0,0.4,0.2,0.8,0.5c0.4-0.2,0.9-0.5,1.4-0.7c-0.1-0.5-0.1-0.9-0.2-1.3c0.3,0.1,0.7,0.1,0.9,0.3
		c0.4,0.3,0.7,0.7,1,1c-1,0.3-2,0.7-2.7,1.4c0.3,0.2,0.5,0.4,0.8,0.6c0.2-0.1,0.3-0.2,0.4-0.3c1.2-0.9,1.9-1.2,3.3-1.4
		c1.3-0.1,1.9-0.5,2.9-2.1c0.9,0.3,1.3,1.3,2.5,1.1c0.2,0,0.4,0.4,0.5,0.7s0,0.6,0,0.9l0,0c0,0.1-0.1,0.2-0.1,0.4
		c0.1-0.1,0.2-0.2,0.3-0.3c0.1,0.1,0.3,0.2,0.3,0.3c-0.1,0.3-0.3,0.5-0.5,0.8c0.3,0,0.5,0,0.7,0c-0.1,0.1-0.1,0.1-0.2,0.2
		c-0.1,0.2-0.2,0.3-0.4,0.5c-0.1,0.3-0.2,0.7-0.2,1.1c0,0.1,0,0.1,0,0.2c0.1,0,0.2,0,0.2-0.1c0.1,0,0.3-0.1,0.5-0.1
		c0.1,0.3,0.3,0.6,0.4,0.8c0.2,0,0.3,0,0.4,0c0.3-0.3,0.6-0.5,1-0.8c0.3-0.2,0.6-0.5,0.9-0.7l0,0c0.6-0.5,1-0.9,0.6-1.5l-0.1-0.1
		c0,0,0.3-0.3,0.5-0.5c0.1,0.2,0.1,0.5,0.3,0.6c1,0.4,2.7-0.5,3.2-1.4v-0.1c0-0.1,0.1-0.2,0.1-0.3c0-0.2-0.4-0.3-0.6-0.5
		c0.1-0.3,0.2-0.7,0.3-1.1c1.3,0.2,2.5-0.1,3.3-1c0.1-0.1,0.3-0.3,0.4-0.5h0.1c1.6,0.5,3,1.1,4.9-0.3c-0.2,0.8-0.3,1.3-0.4,1.8
		c-2.3-0.7-3.8-0.5-4.7,0.5l0,0c-0.1,0.1-0.2,0.2-0.3,0.4c-0.8,1.2-0.2,2.4,1.6,3.5c-0.4,0.3-0.8,0.6-1.1,0.8
		c-0.1,0-0.3-0.1-0.3-0.1c-0.3-0.4-0.5-0.7-0.9-0.9c-0.1-0.1-0.3-0.2-0.5-0.3c-0.7-0.4-1.5-0.5-2.3-0.3c-1.1,0.2-1.8,0.7-2.4,1.4
		c-0.2,0.2-0.3,0.4-0.4,0.6c-0.1,0.2-0.2,0.4-0.3,0.6c0,0.1-0.1,0.2-0.1,0.2c-0.1,0.2,0,0.6,0.2,0.8l0,0c0.1,0.1,0.1,0.1,0.2,0.2
		c0.1,0.1,0.2,0.2,0.3,0.3c0.8,0.8,1.6,1.5,3.2,1.4c-0.3,0.9-0.6,1.7-0.8,2.4c-1.1,0.4-2.1,0.9-3.2,1.4c-0.2-0.2-0.6-0.5-0.9-0.9
		c0.1-0.1,0.1-0.3,0.3-0.4c0.4-0.3,0.6-0.7,0.6-1.1c0-0.2,0-0.3-0.1-0.5c-0.3-0.5-1-0.8-1.6-0.7c-0.8,0.1-1.2,0.6-1.3,1.2
		c-0.1,0.4-0.2,0.7-0.2,0.9c0.3,0.2,0.6,0.4,0.9,0.7c1.3,1,2.6,1.9,3.9,2.9c0.1,0.1,0.2,0.1,0.2,0.2c0,0,0,0,0.1,0
		c1.1,0.8,2.2,1.7,3.3,2.5c0.5-0.3,1-0.6,1.3-1.1c0.4-0.6,0.8-1.2,1.2-1.8c-0.2,0-0.3-0.1-0.4-0.2c-0.2-0.2,0-0.6-0.1-1
		c0.5-0.1,0.9-0.2,1.3-0.2c1.1-0.1,1.9-0.3,2.6-0.8c0.2-0.1,0.3-0.2,0.4-0.4c0.3-0.3,0.5-0.6,0.6-0.9c0.2-0.6,0.3-1.3,0.1-2
		c-0.1-0.4-0.2-0.7,0.4-1c0.3,0.2,0.7,0.4,1,0.6c0.4,0.2,0.8,0.4,1.3,0.7c-0.3,0.3-0.6,0.5-0.8,0.7c-0.1,0.2-0.1,0.5-0.1,1.1
		c0.6-0.4,0.9-0.7,1.2-0.8c0.3-0.1,0.7-0.2,1.1-0.3c0.1,0.3,0.2,0.6,0.3,0.9c0.2,0.5,0.5,0.8,0.9,1.1s0.9,0.4,1.6,0.4
		c0.3,0,0.6,0,0.9-0.1c0.4-0.1,0.7-0.3,1-0.5c0.2-0.1,0.4-0.2,0.5-0.4c0.2-0.2,0.4-0.4,0.5-0.6c0-0.1,0-0.2,0-0.3
		c-0.1-0.5,0.1-0.8,0.8-1c0.2-0.1,0.4-0.4,0.6-0.6c-0.3-0.6-0.7-1.1-1.3-1.6c-1.6-1.4-1.3-1.4,0.3-2.7c2.4-2,4.6-1.8,6.9-0.9
		c0.2-0.2,0.4-0.3,0.6-0.5c0.5,0.1,1.2,0.2,2,0.3c1.2,0.3,1.8,0.1,2.3-1c0.1-0.3,0.2-0.7,0.3-1c-5.8-3.5-11.6-7-17.5-10.5l0,0l0,0
		c-0.4-0.2-0.7-0.4-1.1-0.6c-3.5-2.1-7-4.2-10.6-6.3c-1.3-0.8-2.5-1.5-3.8-2.3c-13-7.8-26.1-15.6-39.1-23.5
		c-0.1-0.1-0.2-0.1-0.3-0.2c-10.2-6.2-20.5-12.3-30.7-18.4c-1,0.6-1.8,1-2.6,1.6c-1.3,1-1.7-0.4-2.4-0.9c-0.3-0.2-0.7-0.3-1-0.4
		c-0.3-0.1-0.6-0.1-0.9-0.2c-0.3-0.1-0.6-0.1-0.9-0.2c0-0.1,0-0.2,0-0.2c0-0.1,0-0.1,0-0.2c1.8-0.3,3.6-0.5,5.4-0.8
		c-0.3-0.2-0.5-0.4-0.9-0.6C182.8,168.3,180,166.9,177.4,165z M262,242.2c-0.1-0.1-0.2-0.2-0.2-0.4c0.7-0.6,1.4-1.1,2.1-1.7
		c0.6-0.4,1.1-0.9,1.7-1.3c0.3-0.2,0.6-0.4,0.9-0.6c0.3-0.2,0.5-0.4,0.8-0.5c0.9-0.4,1.5,0,2.3,1.3C267,240.1,264.5,241.1,262,242.2
		z M276.3,230.6c0.3-0.2,0.9-0.4,1.2-0.2c1.6,1.1,3.2,2.3,5,3.7c-1.8,1.2-3.5,2.4-5.3,3.5c-0.2,0.1-0.6,0-0.9-0.1
		c-0.2-0.1-0.4-0.3-0.6-0.4c-1.9-1.6-3.9-2.7-6.6-1.6c0.1-0.1,0.2-0.3,0.3-0.4C271.7,233.6,274,232.1,276.3,230.6z M254.6,235.6
		v-0.1V235.6L254.6,235.6z M255.7,233.1C255.7,233,255.7,233,255.7,233.1C255.7,233,255.7,233,255.7,233.1
		C255.7,233,255.7,233,255.7,233.1z M258.1,234.5c0-0.6,0-1.1,0.1-1.8c0.7-0.5,1.2-0.3,1.5,0.3C259.1,233.6,258.6,234.1,258.1,234.5
		z M256.8,230.2c0.7-0.2,1.3-0.8,1.9-1.3c0.6-0.6,1.1-1.3,1.7-2c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.1,0.1-0.1,0.2-0.2
		c0.4-0.3,0.9-0.2,1.4-0.2c0.1,0.4,0.1,0.9-0.5,1.1c-1.6,0.5-2.2,1.5-2.1,2.9c0,0.1-0.1,0.3-0.2,0.5c-1.6,0.2-2.7,1-3.4,2.2
		c0,0.1-0.2,0.1-0.3,0.1c0-0.6-0.5-0.3-1-0.2C255.1,231.6,255.3,230.6,256.8,230.2z M254.7,233.2
		C254.7,233.3,254.8,233.3,254.7,233.2c0,0.1,0,0.1-0.1,0.1c0,0,0,0-0.1-0.1C254.6,233.3,254.7,233.2,254.7,233.2z M168.9,179
		c2.5-2.2,2.9-2.2,4.6,0.2C172,179.1,170.6,179,168.9,179z M176.5,174c0.5-1.1,1.7-2,3.4-2.4c-0.2,0.6-0.5,1.1-0.6,1.6
		c0,0.1,0,0.2,0,0.4c0,0.4,0.2,0.9,0.3,1.6c-1.1,0.3-2.2,0.5-3.3,0.8C176.1,175.3,176.2,174.7,176.5,174z M189.1,190.7
		c-1.5-1.3-3.1-2.4-4.7-3.6c0-0.1,0.1-0.3,0.1-0.4c0.5-0.1,1.2-0.4,1.6-0.2c2,1.3,3.9,2.8,6,4.3C190.8,191.5,190,191.4,189.1,190.7z
M236.4,222.7c-0.6,0-1.5,0.3-1.9,0c-2.6-1.7-5-3.6-7.5-5.4c-0.1-0.1-0.2-0.2-0.2-0.4c0.8-0.8,1.5-0.8,2.4-0.1
		c2.4,1.8,4.8,3.6,7.3,5.4C236.5,222.3,236.4,222.5,236.4,222.7z M232.1,214.9c0-0.2,0-0.3,0.1-0.5c0.5-0.1,1.2-0.4,1.6-0.1
		c1.7,1.1,3.4,2.2,5.1,3.3c1.1,0.7,2.1,1.4,3.2,2.1c-0.9,0.9-1.6,1-2.5,0.3c-0.4-0.3-0.8-0.6-1.2-0.9
		C236.2,217.8,234.2,216.4,232.1,214.9z M243.5,232l0.1-0.1c0,0.1,0.1,0.1,0.1,0.2C243.7,232,243.6,232,243.5,232z M242.7,210
		c0.6-0.1,1.4-0.5,1.8-0.2c1.1,0.6,2.2,1.3,3.3,1.9c1.2,0.7,2.4,1.5,3.7,2.2c0.5,0.3,1,0.6,1.4,0.9c-0.7,0.7-1.4,1-2.1,0.7
		c-0.2-0.1-0.4-0.2-0.7-0.3c-1.3-0.8-2.6-1.7-3.9-2.5c-1.2-0.7-2.4-1.5-3.5-2.2C242.7,210.4,242.7,210.2,242.7,210z M239.4,212.1
		c0.2,0.1,0.3,0.2,0.5,0.3c0.3,0.2,0.6,0.4,1,0.6c2.3,1.4,4.5,2.8,6.7,4.2c0,0.2-0.1,0.4-0.1,0.6c-0.7,0-1.6,0.3-2.1,0
		c-2.5-1.5-4.8-3.2-7.2-4.8c-0.1-0.1-0.2-0.3-0.7-0.7C238.4,212.1,239,211.9,239.4,212.1z M200.9,182.8c1.9,1.2,3.9,2.2,5.9,3.4
		c-1.1,0.8-1.9,1-3,0.3c-1.9-1.2-3.8-2.3-5.9-3.5C199,182.4,199.9,182.2,200.9,182.8z M196.8,184c1.8,1.2,3.6,2.3,5.5,3.6
		c-1,0.7-1.7,0.8-2.6,0.2c-1.8-1.2-3.6-2.3-5.6-3.6C195.1,183.4,195.9,183.4,196.8,184z M192.2,185.7c1.4,1.2,3,2.2,4.5,3.3
		c0.1,0,0.1,0.2,0.2,0.6c-0.8,0-1.6,0.3-2.1,0c-1.9-1.2-3.7-2.5-5.6-3.9C190.4,184.8,191.2,184.9,192.2,185.7z M188.7,173.4
		c0.9-0.2,1,0.5,0.8,1.1c-0.4,1.4-1.3,2.5-2.4,3.2c-0.6-1.2-1.1-2.2-1.6-3.3C186.4,174.1,187.5,173.7,188.7,173.4z M183.7,178
		c-0.9,0.9-2.7,1.1-4.3,0.5c-1-0.4-2-1-2.8-1.9c1.3-0.2,2.4-0.5,3.5-0.7c0.1,0,0.2,0,0.4,0c0.1,0,0.2,0,0.3,0.1
		C181.7,176.7,182.7,177.4,183.7,178z"
      />
      <path
        class="st2"
        d="M214.8,228.4L214.8,228.4c-0.5-0.4-0.9-0.8-1.4-1.1c-1.3-1.1-2.7-2.2-4-3.3c-0.1,0.1-0.2,0.3-0.3,0.4
		c0.7,0.9,1.9,2,3.2,3c0.1,0.1,0.2,0.1,0.2,0.2c0.4,0.3,0.9,0.7,1.3,1c1.5,1.1,2.8,1.8,3.3,1.7C216.3,229.7,215.6,229.1,214.8,228.4
		z"
      />
      <path
        class="st2"
        d="M286,149.5c-0.9,0.9-2.4,1.1-3.5,0.4c-0.4-0.3-0.9-0.5-1.4-0.5c-2-0.2-2.2-0.6-1-2.5c-0.6,0.2-1,0.3-1.2,0.5
		c-0.5,0.4-0.9,0.9-1.3,1.4c0.5,0.3,1,0.7,1.5,0.9c0.8,0.4,1.6,0.6,2.3,1.1c0.1,0.1,0.3,0.2,0.5,0.2l0,0c2.1,0.9,4.9-0.1,5.5-2.5
		c0,0,0,0-0.1,0C286.7,149,286.3,149.2,286,149.5z"
      />
      <path
        class="st2"
        d="M235.9,163.7c0.5-0.5,0.9-1.1,0.9-1.8c0-0.2-0.9-0.4-1.3-0.7c-0.1,0.1-0.1,0.3-0.2,0.4
		C235.5,162.4,235.7,163,235.9,163.7z"
      />
      <path
        class="st2"
        d="M251.5,135.8c0,0.1,0,0.1,0.1,0.2c0.3,0.5-0.2,1,0,1.5c1.3-0.3,2.6-0.5,4-0.8c0.1-0.1,0.1-0.1,0.2-0.2
		c0.1,0,0.1,0.1,0.2,0.1c3-0.6,6-1.2,8.9-1.7c0.7-0.1,1.3-0.3,2-0.4l0.1-0.1c0.4-0.4,0.8-0.9,1.1-1.3l0,0c0.1-0.1,0.2-0.2,0.3-0.4
		c-2.6,0.5-5.3,1-7.9,1.5C257.4,134.7,254.4,135.3,251.5,135.8z"
      />
      <path
        class="st2"
        d="M262.1,165c2,0.8,3.9,1.5,5.9,2.3c0-0.2,0.1-0.4,0.1-0.5c-2-0.7-3.9-1.4-5.9-2.1
		C262.2,164.8,262.2,164.9,262.1,165z"
      />
      <path
        class="st2"
        d="M235.7,222.2c-2.7-2-5.2-3.9-7.9-5.5C228.7,218.4,234.6,222.4,235.7,222.2z"
      />
      <path
        class="st2"
        d="M197.9,229.2c2.2,2,4.4,4,6.6,6c0.2,0.2,0.6,0.1,1,0.2c-2.8-3.4-6.6-6.5-7.6-6.5
		C197.9,229,197.9,229.2,197.9,229.2z"
      />
      <path
        class="st2"
        d="M191,190.6c-1.9-1.3-3.7-2.6-5.4-3.9C186.7,188.7,189.9,190.8,191,190.6z"
      />
      <path
        class="st2"
        d="M145,209.4c-0.3-0.4-0.5-0.7-0.8-0.9c-1-1.1-2-2.1-2.9-3.2c-0.1-0.1-0.1-0.1-0.2-0.2c-2.5-2.7-5-5.5-7.5-8.2
		c-0.8-0.9-1.2-1.8-1.2-3c0-2.7,0-5.4-0.1-8.1c0-1.5,0-3,0.1-4.5c0-0.2,0-0.5,0-0.7c0-1.4-0.3-2.6-1-3.6c-0.2-0.3-0.3-0.5-0.5-0.7
		c-0.3-0.4-0.7-0.7-1.1-1.1c-0.7-0.6-1.2-0.8-2.1-0.6c-0.3,0.1-0.6,0.1-0.9,0.2c-1.5,0.4-3.1,0.7-4.6,1.1c-0.9,0.2-1.9,0.4-2.8,0.6
		c-2.2,0.5-4.4,1-6.6,1.5c-0.1,0-0.2,0-0.3,0.1c-0.5,0.1-1,0.2-1.5,0.3c-4.4,1-8.7,2-13.1,3c-0.5,0.1-1,0.3-1.6,0.4
		c0.7,1,1.4,2.1,2,3.1c0.4,0.7,0.9,1.3,1.3,2c9.5,14.5,18.9,28.9,28.3,43.3c0.4,0.6,0.8,1.2,1.2,1.8c0.9,1.3,1.7,2.7,2.6,4
		c0.7,1,1.3,2,2,3c2.1,3.2,4.2,6.3,6.2,9.5c0.2-0.1,0.3-0.1,0.5-0.2c0-4.9,0-9.8,0-14.6c0-5.1-0.1-10.2-0.1-15.3
		C140.6,214.9,140.9,211.2,145,209.4z"
      />
      <path
        class="st2"
        d="M195.6,189.5c0.1-0.1,0.2-0.3,0.3-0.4c-2.2-2.2-4.7-3.7-5.7-3.2C192,187.1,193.8,188.3,195.6,189.5z"
      />
      <path
        class="st2"
        d="M199.3,183c1.9,1.4,3.8,2.9,6.2,3.4C203.6,185,201.7,183.6,199.3,183z"
      />
      <path
        class="st2"
        d="M201.1,187.6c-1.9-1.8-5-3.5-6-3.2c2,1.2,3.9,2.4,5.8,3.6C201,187.8,201.1,187.7,201.1,187.6z"
      />
      <path
        class="st2"
        d="M250.2,139.8L250.2,139.8C250.1,139.7,250.1,139.8,250.2,139.8C250.1,139.8,250.2,139.8,250.2,139.8z"
      />
      <path
        class="st2"
        d="M172.8,190.5c1.9,1.6,3.7,3.1,5.7,4.2C177.6,193,174,190.3,172.8,190.5z"
      />
      <path
        class="st2"
        d="M189.2,174.1c-0.1-0.1-0.2-0.2-0.3-0.3c-0.9,0.3-1.8,0.5-2.7,0.8c0.5,0.8,0.8,1.5,1.4,2.4
		C188.1,175.9,188.7,175,189.2,174.1z"
      />
      <path
        class="st2"
        d="M249.6,139c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.2,0.2,0.3c0.4-0.3,0.8-0.6,1.3-0.8
		c0.3-0.1,0.6-0.3,0.9-0.5C251.4,138.6,250.5,138.8,249.6,139L249.6,139z"
      />
      <path
        class="st2"
        d="M293,223.5c-0.4,0.4-0.7,1-0.9,1.6c-0.1,0.4-0.2,0.9-0.3,1.3c0,0.3,0,0.6,0,1c0.1,0.6,0.3,1.2,0.7,1.7
		c1.8-1,3.5-2,5.2-2.8c-0.6-0.5-1.3-1-1.9-1.5l-0.1-0.1c-0.7-0.5-1.4-1.1-2.2-1.7C293.3,223.1,293.1,223.3,293,223.5z"
      />
      <path
        class="st2"
        d="M169.6,191.4c-0.1,0.1-0.2,0.2-0.3,0.3c1.5,1.9,4.5,4.1,5.6,3.9C173.1,194.1,171.4,192.8,169.6,191.4z"
      />
      <path
        class="st2"
        d="M301.6,143.8c-0.8-0.4-1.6-0.8-2.4-1.2C299.7,144.4,300.7,144.9,301.6,143.8z"
      />
      <path
        class="st2"
        d="M208.7,247.8c-0.1,0-0.1,0.1-0.2,0.1c-0.6,0.2-0.8-0.2-0.9-0.6c-0.3,0.3-0.5,0.6-0.6,0.9
		c0.3,0.3,0.7,0.6,1,0.9c0.7-0.1,1.3,0.4,2,0.4c-0.2-0.2-0.4-0.4-0.8-0.7c0.1,0,0.3-0.1,0.4-0.1C209.3,248.4,209,248.1,208.7,247.8z
		"
      />
      <path
        class="st2"
        d="M199,167.2c-0.9,0.2-1.8,0.5-2.7,0.7c-0.2,0-0.3,0.1-0.5,0.1c-0.7,0.2-1.4,0.4-2.2,0.6
		c0.7,0.6,1.2,1.2,1.8,1.5c1.4,0.7,2.2-0.6,3.2-1.1c0.4-0.2,0.6-1,0.8-1.6C199.3,167.4,199.1,167.3,199,167.2z"
      />
      <path
        class="st2"
        d="M212,179.6c2.1,0.9,3.8,2.6,6.1,3.1c0.1-0.2,0.2-0.3,0.2-0.5c-2-1.1-4-2.2-6-3.3
		C212.2,179.2,212.1,179.4,212,179.6z"
      />
      <path
        class="st2"
        d="M221,176.9c2,1.1,4,2.2,5.9,3.3c0.1-0.2,0.2-0.4,0.3-0.6c-2-1.1-4-2.1-6-3.2C221.1,176.6,221,176.8,221,176.9z
		"
      />
      <path
        class="st2"
        d="M258,204.8c-0.3-0.1-0.5-0.1-0.7,0c0.2,0.1,0.4,0.3,0.5,0.4c2.7,2,6.8,4.1,7.9,3.9
		C263.4,207.2,259.6,205.2,258,204.8z"
      />
      <path
        class="st2"
        d="M269.9,207.1c-2.6-1.5-5.1-3.1-7.7-4.6c-0.1,0.2-0.2,0.3-0.3,0.5c2.6,1.5,5.1,3.1,7.7,4.6
		C269.8,207.4,269.9,207.3,269.9,207.1z"
      />
      <path
        class="st2"
        d="M231,178.5c-2.3-1.1-4.3-2.1-6.3-3C225.9,177.1,229.7,178.9,231,178.5z"
      />
      <path
        class="st2"
        d="M200.3,170.3c-1,0.3-1.9,0.8-2.9,1.3c2.1,2.1,4.8,2.3,6.3,0.6c-0.7-0.5-1.3-1.1-2-1.5
		C201.2,170.4,200.6,170.1,200.3,170.3z"
      />
      <path
        class="st2"
        d="M270.3,143c0.7,0.3,1.5,0.5,2.2,0.8c-1.8,0.6-3.4-1.1-5.5-0.2c1,0.4,1.6,0.7,2.3,1c0,0.2-0.1,0.3-0.1,0.5
		c-1.3-0.4-2.6-0.8-3.9-1.1c0,0.1,0,0.2-0.1,0.3c0.7,0.3,1.5,0.6,2.2,0.9c0,0.1-0.1,0.3-0.1,0.4c-1.5-0.4-3-0.9-4.5-1.3
		c0,0.2-0.1,0.3-0.1,0.5c1.8,0.9,3.6,1.9,5.5,2.6c1.6,0.6,3.2,1.1,4.8,1.5c0.2,0,0.3,0.1,0.5,0.2c0.6,0.2,1.3,0.4,1.9,0.6
		c0.9,0.3,1.8,0.5,3.1,0.9c-2-1.5-1.9-2.5,0-3.4c1-0.4,2-0.8,3.1-0.8c1,0,1.9,0.5,2.9,0.8c-0.1,0.3-0.1,0.5-0.2,0.8
		c-0.6,0-1.2,0-1.7-0.2c-1.5-0.6-2.2-0.4-3,1.1c0.7,0.1,1.2,0.1,1.7,0.2c0.4,0.1,0.9,0.2,1.3,0.4c0.9,0.7,2.2,0.6,3-0.3
		c0.3-0.4,0.9-0.6,1.3-0.7c0.1,0,0.2,0,0.4,0.1c0,0,0.1,0,0.1-0.1v0.1c0.2,0.1,0.4,0.3,0.4,0.4c-0.1,0.5-0.3,1.2-0.7,1.5
		c-0.9,0.6-1.9,1-3,1.6c3.7,1.1,7.2,2.2,10.7,3.3c-0.2-1.2,0.6-1,1.2-0.8c1.3,0.4,2.7,0.8,4,1.2c0-0.1,0.1-0.2,0.1-0.3
		c-1-0.4-2-0.8-3-1.2c0.1-0.2,0.1-0.4,0.2-0.6c2.8,0.2,5.2,1.7,8.3,2.5c-1.3,0.4-2.2,0.7-3.1,1c0,0.2,0,0.3,0.1,0.5
		c1.1,0.3,2.3,0.7,3.4,1c5,1.5,10,3.1,15,4.6c0.6,0.2,1.3,0.4,1.9,0.6c6.7,2.1,13.3,4.1,20,6.2c0.4-1.2,1.2-1,2.2-0.7
		c1.7,0.6,3.5,1.1,5.2,1.6c0.9,0.3,1.8,0.6,2.8,0.9c-0.4,0.4-0.7,0.6-1,0.9c0.4,0.1,0.8,0.2,1.2,0.4c1.3,0.4,2.7,0.8,4,1.2
		c7.3,2.3,14.5,4.5,21.6,6.7c0-0.4,0-0.7,0.1-1c0-0.4,0-0.8,0.1-1.1c0-0.4,0.1-0.8,0.1-1.3c1.4,1.2,2.6,2.1,3.7,3
		c-0.3,0.4-0.6,0.8-1,1.5c1-0.6,1.8-1.4,2.4-1.2c0.3,0.1,0.6,0.2,0.9,0.2c0.9,0.3,1.9,0.6,2.9,1c0.5,0.2,1,0.4,1.6,0.6
		c0.1,0,0.2,0.1,0.3,0.1c-0.1,0-0.3,0.1-0.4,0.1c-0.8,0.2-1.5,0.4-2.4,0.6c0.8,0.3,1.2,0.4,1.7,0.6c0.2,0.1,0.5,0.1,0.7,0.2
		c1.9,0.6,3.8,1.2,5.8,1.8c1.1,0.3,2.1,0.6,3.2,1c0.7,0.2,1.4,0.4,2.2,0.7c5.2,1.6,10.5,3.2,15.6,5c1.9,0.6,3.5,0.9,5,0.6
		c0.8-0.1,1.5-0.4,2.2-0.8c0.6-0.4,1.2-0.8,1.9-1.4c1-1,2.2-1.8,3.4-2.7c0.7-0.5,1.5-1,2.2-1.6c0.1-0.1,0.3-0.2,0.4-0.3
		c-0.1,0-0.2-0.1-0.3-0.1c-0.6-0.2-1-0.3-1.4-0.5c-0.9-0.2-1.7-0.5-2.6-0.7c-3.9-1.1-7.8-2.2-11.7-3.3c-0.5-0.1-1-0.3-1.5-0.4
		c-3.3-0.9-6.6-1.9-9.9-2.8H404c-1.1-0.3-2.1-0.6-3.2-0.9c-1-0.3-2-0.6-3-0.8c-0.7-0.2-1.5-0.4-2.2-0.6c-2.3-0.6-4.5-1.3-6.8-1.9
		c-10.5-2.9-20.9-5.9-31.4-8.8c-1.6-0.4-3.2-0.9-4.8-1.3c-0.2,0-0.3-0.1-0.5-0.1c-7-2-14-3.9-21.1-5.9c-0.5-0.1-1-0.3-1.5-0.4
		c-7.7-2.2-15.5-4.3-23.2-6.5c-9.6-2.7-19.1-5.4-28.7-8c-0.5,0-1,0-1.4,0.1c0-0.2-0.1-0.3-0.2-0.5c-0.2-0.1-0.4-0.1-0.6-0.2
		c-0.1,0.1-0.2,0.2-0.4,0.4c-0.1-0.2-0.1-0.4-0.2-0.5c-0.2-0.1-0.4-0.1-0.6-0.2c-1.1-0.3-2.3,0-3.4,0
		C270.4,142.8,270.4,142.9,270.3,143z M417.2,184.5c3,0.9,6.1,1.8,9.1,2.8c0.6,0.2,1.3,0.4,1.9,0.6c0,0.2,0.1,0.3,0.1,0.5
		c-0.3,0.1-0.5,0.2-0.8,0.4c-0.2,0.1-0.4,0.1-0.6,0.1c-3.1-0.9-6.1-1.9-9.2-2.9c-0.6-0.2-1.1-0.4-1.7-0.5c-0.1,0-0.1-0.2-0.3-0.5
		C416.2,184.7,416.7,184.4,417.2,184.5C417.1,184.5,417.1,184.4,417.2,184.5z M414.7,186.3L414.7,186.3c1.1,0.3,2.2,0.6,3.2,0.9
		c2.5,0.7,5.1,1.5,7.6,2.2c0.1,0,0.2,0.2,0.6,0.5c-0.7,0.2-1.3,0.6-1.8,0.5c-3.7-1.1-7.3-2.2-10.9-3.3c-0.1,0-0.1-0.1-0.5-0.6
		C413.7,186.4,414.2,186.1,414.7,186.3z M412.3,187.6c2.8,0.8,5.5,1.7,8.3,2.5c1,0.3,1.9,0.6,2.9,0.9c0,0,0.1,0,0.1,0.1
		c0.1,0.1,0.1,0.2,0.3,0.4c-0.1,0-0.1,0-0.2,0.1c-0.6,0.2-1.1,0.5-1.5,0.4c-0.9-0.3-1.9-0.6-2.8-0.9c-1.6-0.5-3.2-1-4.8-1.6
		c-0.8-0.3-1.6-0.5-2.4-0.8c-0.3-0.1-0.6-0.2-1-0.3c-0.1,0-0.1-0.1-0.5-0.5C411.5,187.7,411.9,187.5,412.3,187.6z M409.6,189.2
		c0.8,0.3,1.7,0.5,2.5,0.8c0.5,0.2,1,0.3,1.5,0.5c1.9,0.6,3.7,1.2,5.6,1.7c0.7,0.2,1.3,0.4,2,0.6c0,0.2,0.1,0.3,0.1,0.5
		c-0.2,0.1-0.5,0.2-0.7,0.3s-0.4,0.1-0.5,0.1c-3.9-1.2-7.8-2.4-11.7-3.7c0-0.1,0-0.3,0-0.4C408.8,189.5,409.3,189.1,409.6,189.2z
M390.7,178.2c0.5,0.4,1.1,1.1,1.3,1.6c0.1,0.4,0.1,0.7,0.1,1c-0.2,0.8-0.8,1.5-1.6,2.3c-0.1-0.5-0.1-0.9-0.2-1.3
		c-0.1-0.2-0.1-0.4-0.2-0.6c-0.4-1-1.2-1.2-3.4-1.6c1.1-0.6,2.2-1.5,3.4-1.7C390.2,177.9,390.4,178,390.7,178.2z M384.9,176.6
		c1.1,0.2,2.2,0.6,3.3,1.4c-1.1,0.7-2,1.2-3,1.9c-0.6-0.6-1.1-1.2-1.8-1.6c-0.8-0.5-1.7-0.7-2.8-0.5
		C381.7,176.7,383.3,176.3,384.9,176.6z M351.5,166.4c0.3-0.1,0.6-0.1,0.8-0.1c0.1,0,0.2,0.1,0.3,0.1c2.8,0.7,5.5,1.4,8.3,2.2
		c0,0.2,0.1,0.3,0.1,0.5c-0.6,0.1-1.2,0.5-1.7,0.3c-2.5-0.6-4.9-1.4-7.4-2.1c-0.2-0.1-0.4-0.1-0.5-0.2c-0.2,0-0.3-0.1-0.5-0.1
		c-0.1,0-0.1-0.2-0.2-0.5C351,166.5,351.3,166.5,351.5,166.4z M349.3,167.4c2.9,0.8,5.7,1.7,8.5,2.6c0,0.1,0,0.3,0,0.4
		c-0.2,0-0.3,0.1-0.5,0.2c-0.2,0.1-0.5,0.2-0.7,0.1c-0.4-0.1-0.8-0.2-1.1-0.3c-2.5-0.7-5.1-1.5-7.6-2.3c0-0.1,0-0.3,0-0.4
		C348.4,167.6,348.9,167.3,349.3,167.4z M345.6,168.6c0.5-0.1,1-0.4,1.4-0.3c2.5,0.7,4.9,1.5,7.4,2.4c0.4,0.2,0.8,0.3,1.2,0.5
		c-0.4,0.1-0.9,0.5-1.2,0.4c-0.3-0.1-0.5-0.2-0.8-0.2c-2.7-0.8-5.4-1.6-8.1-2.5C345.6,168.8,345.6,168.7,345.6,168.6z M304.3,152.4
		c0.6,0.2,1.1,0.3,1.7,0.5c1.6,0.5,3.2,1.1,4.9,1.7c-0.8,0.5-2.8,0.2-4.9-0.4c-1.3-0.4-2.7-0.9-3.9-1.6
		C303.1,152.5,303.7,152.3,304.3,152.4z M306,154.9c0.6,0.2,1.3,0.4,2,0.6c-0.5,0.4-1.2,0.5-2,0.5c-1.6,0-3.8-0.9-6.3-2.4
		C301.9,153.1,303.9,154.1,306,154.9z"
      />
      <path
        class="st2"
        d="M215.9,178.4c2,1,4.1,2,6.1,3c0.1-0.2,0.2-0.3,0.2-0.5c-2-1-4-2.1-6-3.1C216.1,178,216,178.2,215.9,178.4z"
      />
      <path
        class="st2"
        d="M192,158.9c0.5-0.1,1-0.2,1.5-0.3c4.4-1,8.8-2,13.2-2.9c3.5-0.8,7.1-1.6,10.6-2.4c18.1-4,36.2-8.1,54.2-12.1
		c-0.1-0.1-0.3-0.2-0.4-0.3c-0.2-0.1-0.2-0.3-0.3-0.4c-0.1-0.3,0.2-0.7,0.1-1c0-0.1,0-0.1-0.1-0.2c0.7-0.6,0.4-0.9,0-1.3
		c-5,1-10,2.1-15,3.1c-0.2,0.2-0.4,0.3-0.8,0.3l-0.1-0.1c-0.3,0.1-0.6,0.1-0.9,0.2c0,0.1,0,0.2,0.1,0.3c0,0.1,0.3,0.1,0.6,0.1
		c-0.8,0.4-1.6,0.8-2.5,1.3c0.2,0.2,0.3,0.4,0.6,0.7c-0.3,0.1-0.5,0.2-0.6,0.1c-0.6-0.3-0.6-0.8-0.2-1.3c-0.2-0.3-0.5-0.5-0.8-0.6
		c-5.3,1.1-10.6,2.2-16,3.3c0,0,0,0,0,0.1c-0.1,0.3-0.5,0.6-0.6,1s-0.3,0.6-0.7,0.6c-0.6,0-0.6-0.4-0.6-0.8c0-0.1,0.1-0.3,0.1-0.5
		c-4.1,0.9-8.2,1.7-12.4,2.6c-1.1,0.2-2.2,0.5-3.3,0.7c-1.6,0.3-3.2,0.7-4.8,1c-2.6,0.5-5.2,1.1-7.8,1.6c-0.2,0-0.3,0.1-0.5,0.1
		c-0.4,0.1-0.8,0.2-1.2,0.3c-0.1,0-0.1,0-0.2,0c-0.3,0.1-0.7,0.1-1,0.2c-1.1,0.2-2.2,0.5-3.3,0.7c-0.9,0.2-1.8,0.4-2.7,0.6
		c-0.5,0.1-1,0.2-1.5,0.3c-3.6,0.7-7.2,1.5-10.8,2.2l0,0c-0.1,0-0.2,0-0.3,0.1c-0.8,0.2-1.6,0.3-2.4,0.5c-1.3,0.3-2.5,0.5-3.8,0.8
		c-3.6,0.8-7.3,1.5-10.9,2.3c0,0,0,0-0.1,0c-1.2,0.3-2.5,0.5-3.7,0.8c-3.3,0.7-6.6,1.4-9.9,2.1c-2,0.4-4,0.8-5.9,1.2
		c-2.3,0.5-4.6,1-6.9,1.4c-0.9,0.2-1.8,0.4-2.7,0.6c-0.2,0-0.4,0.1-0.6,0.3c-0.3,0.2-0.6,0.5-0.6,0.7c0,0.1,0,0.2,0,0.3
		c0,0.3,0,0.6,0,1c0,0.8,0,1.5,0,2.3l0,0c0,0.3,0,0.6,0,0.9c0.5-0.1,0.9-0.1,1.2-0.2h0.1c1.5-0.3,3-0.7,4.4-1
		c0.6-0.1,1.2-0.3,1.8-0.4c0.5-0.1,0.9-0.2,1.4-0.3c2.1-0.5,4.2-0.9,6.4-1.4c1-0.2,2.1-0.5,3.1-0.7c1.6-0.3,3.2-0.7,4.8-1
		c0.9-0.2,1-0.7,1.2-1.5c0.2-0.7,0.9-1.6,1.4-1.7c0.4,0,0.9,0.5,1.4,1c0.1,0.1,0.2,0.2,0.3,0.3c0.2,0.1,0.2,0.4,0.3,0.7
		c0.1,0,0.2-0.1,0.4-0.1c2.2-0.5,4.3-1,6.5-1.4c1-0.2,2-0.5,3-0.7c1.1-0.2,2.1-0.5,3.2-0.7c3.1-0.7,6.3-1.4,9.4-2.1
		C188.3,159.7,190.1,159.3,192,158.9z"
      />
      <path
        class="st2"
        d="M299.5,227.5c-0.5,0.3-1,0.6-1.5,0.9c-0.7,0.4-1.5,0.9-2.2,1.4c-0.3,0.2-0.5,0.3-0.8,0.5
		c0.3,0.1,0.6,0.2,0.9,0.2c0.6,0.1,1.3,0.3,1.9,0.3c2.5,0.3,4.7,0.1,6.2-0.5l0,0c0.1-0.1,0.2-0.2,0.2-0.3c0.2-0.2,0.5-0.5,0.7-0.7
		l0.1-0.1c-1.5-0.6-3-1.3-4.5-1.9C300.2,227.4,299.7,227.4,299.5,227.5z"
      />
      <path
        class="st2"
        d="M271.9,199.7c0.8,0.4,1.5,0.8,2.3,1.3c1.1,0.6,2.1,1.2,3.2,1.8c0.6,0.3,1.2,0.7,1.8,1c0.1-0.2,0.2-0.3,0.3-0.5
		c-2.4-1.3-4.9-2.6-7.3-3.9C272,199.4,272,199.5,271.9,199.7z"
      />
      <path
        class="st2"
        d="M292.8,234.4v0.1c0,0.5-0.1,0.9-0.1,1.4v-0.1c-0.2,0.4-0.4,0.8-0.6,1.2c0,0,0,0.1-0.1,0.1h0.1
		c0.4-0.1,0.6-0.1,0.8-0.1c-0.1-0.4-0.2-0.8-0.2-1.2c0.2-0.3,0.4-0.7,0.7-1.1C293.2,234.6,293,234.5,292.8,234.4z"
      />
      <path
        class="st2"
        d="M228.3,164.1c1.2,0.4,2.3,0.8,3.4,1.1c0-0.2,0.1-0.3,0.1-0.5C230.8,164.5,230.2,162.2,228.3,164.1z"
      />
      <path
        class="st2"
        d="M283.4,138.1c-0.2,0.1-0.7,0.2-1.1,0.4c-0.1,0-0.1,0.1-0.2,0.3c2.1-0.5,4.3-1,6.4-1.4c-1.1-0.8-2-1.8-3.6-2
		C284.5,136.2,284,137.1,283.4,138.1z"
      />
      <path
        class="st2"
        d="M237.2,172.1c1.9,1,3.8,2.2,5.8,2.9c0.1-0.2,0.2-0.3,0.2-0.5c-1.9-1-3.8-2-5.8-3
		C237.3,171.8,237.3,171.9,237.2,172.1z"
      />
      <path
        class="st2"
        d="M209.3,253.4c0.5,0.5,0.8,0.8,1.2,1.2c-0.4,0.7-0.8,1.4-1.2,2.1c-0.1,0.2-0.2,0.4-0.4,0.6
		c0.3-0.1,0.6-0.1,0.9-0.2c0.1,0.2,0.2,0.4,0.3,0.7c-0.3,0.1-0.5,0.2-0.7,0.3c2.6,2.6,5.3,5.3,7.9,7.9c0.1,0,0.1-0.1,0.2-0.1
		c0.5-0.4,0.9-0.6,1.7-0.8c0.1,0.2,0.1,0.5,0.3,0.7c0.1,0.2,0.4,0.2,0.9,0.5c-1,0.1-1.6,0.2-2.3,0.3c0,0.1,0.1,0.2,0.1,0.3
		c0.4,0.4,0.9,0.9,1.3,1.3l0,0c0.8,0,1.3-0.2,0.8,0.7c-0.2,0.4,1.1,0.1,0.6,0.7c0,0,0,0,0.1,0.1c0.5,0.1,0.7,0.5,0.9,0.9
		c0.1,0.1,0.1,0.1,0.2,0.2c0.2,0.2,0.4,0.4,0.7,0.7c1.1,0,0.7-1.1,1.5-1.2c0.4,0.5,0.9,0.9,1.3,1.4c0.1,0.2,0.3,0.3,0.4,0.5
		c0.6-0.3,1.1-0.5,1.6-0.7c0,0,0,0,0-0.1c0.1-0.2,0.1-0.4,0.3-0.5c0.1-0.1,0.2-0.1,0.3-0.2c-1.6-1.5-3.2-3.1-4.7-4.6
		c-3.8-3.7-7.6-7.4-11.4-11.1c-0.6-0.6-1.2-1.2-1.8-1.8C209.9,253.2,209.7,253.3,209.3,253.4z M221.4,267.3c0.1,0.1,0.2,0.1,0.2,0.2
		c-0.2,0.1-0.4,0.3-0.6,0.4c-0.1-0.1-0.1-0.1-0.2-0.2C221,267.7,221.2,267.5,221.4,267.3z"
      />
      <path
        class="st2"
        d="M241.2,171.1c1.8,1,3.5,2,5.3,3c0.1-0.2,0.2-0.4,0.3-0.6c-1.8-1-3.6-1.9-5.4-2.9
		C241.4,170.8,241.3,170.9,241.2,171.1z"
      />
      <path
        class="st2"
        d="M282.8,227.1c3.2,1.9,6.4,3.8,9.6,5.7c0,0,0,0,0-0.1c0.1,0,0.2,0,0.3,0c0-0.1,0.1-0.1,0.1-0.2
		c-3.3-2-6.6-3.9-9.8-5.9C283,226.8,282.9,226.9,282.8,227.1z"
      />
      <path
        class="st2"
        d="M138.1,175.5c-0.6-0.6-1.2-1.4-2-1.5c-0.3,1.6-0.1,2.8,1.2,4c0.1,0.1,0.2,0.2,0.3,0.3
		c7.6,7.1,15.1,14.3,22.7,21.5c0.3,0.3,0.7,0.6,1.1,1c0.5-2.8,0.1-5-2.6-6.3c0.1-0.1,0.2-0.2,0.3-0.4c0.7-0.1,1.5-0.2,2.3-0.4
		c-0.2-5.4-0.4-10.7-0.7-16.1c0-0.5-0.5-1.1-1-1.5c-0.1-0.1-0.2-0.1-0.3-0.2c-0.4-0.3-0.8-0.6-1.2-0.9c-1.3-1-2.7-2-4-3
		c-0.7-0.5-1.3-1-2-1.6c-0.4-0.4-0.8-0.6-1.2-0.7c-1-0.3-1.9-0.1-3.1,0.4c0.4,0.4,0.9,0.7,1.3,1c0.7,0.5,1.3,1.1,2,1.6l0,0
		c0,0.1-0.1,0.3-0.1,0.4c-0.4-0.1-0.9-0.1-1.2-0.3c0,0,0,0-0.1,0c-0.6-0.4-1.2-1-1.9-1.4c-0.2-0.1-0.4-0.3-0.6-0.4
		c-0.6-0.3-1.3-0.4-2-0.6l0,0c-0.1,0.2-0.1,0.3-0.2,0.5c1,0.9,2.1,1.8,3.1,2.7c-0.9,0.9-1.5,0.9-2.3,0.2c-0.7-0.7-1.5-1.2-2.2-1.9
		c-0.1-0.1-0.1-0.1-0.2-0.2c-0.7-0.6-1.4-0.6-2.3,0c1,1,2,1.9,3,2.8c0,0.2-0.1,0.3-0.1,0.5c-0.5-0.1-1.1,0-1.5-0.3
		c-0.8-0.5-1.5-1.1-2.1-1.8c-0.6-0.6-1.1-0.9-1.8-0.9c-0.4,0-0.9,0.1-1.4,0.4c-0.1,0-0.1,0.1-0.2,0.1l0.1,0.1
		c0.2,0.2,0.5,0.4,0.7,0.6c0.8,0.7,1.6,1.4,2.5,2.2C139.4,176.3,138.7,176,138.1,175.5z"
      />
      <path
        class="st2"
        d="M231.7,143.5c0.6-0.2,0.8-0.7,1-1.1c-0.6,0.1-1.1,0.2-1.6,0.3C231.4,143,231.5,143.2,231.7,143.5z"
      />
      <path
        class="st2"
        d="M258,137.3c-0.3,0.1-0.6,0.1-0.8,0.2c0.2,0.1,0.3,0.2,0.5,0.3C257.7,137.5,257.8,137.4,258,137.3z"
      />
      <path
        class="st2"
        d="M260.6,136.8c-0.5,0.1-1.1,0.2-1.6,0.3c-0.2,0-0.4,0.1-0.7,0.1c0.1,0,0.2,0,0.4,0c0.1,0,0.3,0,0.4,0
		C259.7,137.3,260.2,137.3,260.6,136.8z"
      />
      <path
        class="st2"
        d="M261.2,138.8c-0.7-0.1-1.3-0.2-1.9-0.3c-0.5-0.1-1-0.4-1.5-0.6c0,0.5,0,0.9,0,1.6
		C258.9,139.2,260,139,261.2,138.8z"
      />
      <path
        class="st2"
        d="M256,139.9c0.5-0.1,0.9-0.2,1.4-0.3c-0.3-0.3-0.5-0.5-0.7-0.7C256.4,139.2,255.9,139.4,256,139.9z"
      />
      <path
        class="st2"
        d="M227,162.5c0.1,0.1,0.2,0.1,0.4,0.2c0.5-0.3,1.1-0.5,1.6-0.8c-0.3-0.7-0.6-1.2-0.8-1.8c-0.1,0-0.3,0-0.4,0
		C227.5,160.9,227.3,161.7,227,162.5z"
      />
      <path
        class="st2"
        d="M280.1,140.6C280.1,140.5,280.1,140.5,280.1,140.6c-0.1-0.1-0.1-0.1-0.1-0.1
		C280.1,140.5,280.1,140.5,280.1,140.6z"
      />
      <path
        class="st2"
        d="M231.1,159.6c2.1,1.6,2.1,1.6,3.3,0.4c-1.2-0.3-2.2-0.5-3.2-0.8C231.1,159.4,231.1,159.5,231.1,159.6z"
      />
      <path
        class="st2"
        d="M291,196.6c-1.4-0.6-2.9-1.3-4.3-1.9c-0.5-0.2-1-0.4-1.5-0.6c-0.3-0.1-0.6-0.2-0.8-0.4
		c-0.1,0.1-0.1,0.3-0.2,0.4c0.2,0.1,0.3,0.2,0.5,0.2c0.5,0.2,1.1,0.5,1.6,0.7c1.3,0.6,2.7,1.3,4,1.9c0.7,0.3,1.3,0.6,2,0.8h0.1
		c0.1-0.2,0.2-0.4,0.2-0.6c0,0,0,0-0.1,0C292,197.1,291.5,196.9,291,196.6z"
      />
      <path
        class="st2"
        d="M254.5,171.3c-2.3-1-4.3-1.8-6.3-2.7C249.5,170.1,253.3,171.7,254.5,171.3z"
      />
      <path
        class="st2"
        d="M295.8,189.4c2.7,1.1,5.3,2.3,8,3.4c0-0.1,0.1-0.2,0.1-0.3c-2.6-1.2-5.3-2.3-7.9-3.5
		C295.9,189.1,295.9,189.3,295.8,189.4z"
      />
      <path
        class="st2"
        d="M288.1,192.4c2.6,1.3,5.2,2.6,7.9,3.9c0.1-0.1,0.1-0.3,0.2-0.4c-2.6-1.3-5.2-2.6-7.8-3.8
		C288.3,192.1,288.2,192.3,288.1,192.4z"
      />
      <path
        class="st2"
        d="M292.2,191c2.6,1.2,5.2,2.4,7.8,3.6c0.1-0.1,0.1-0.3,0.2-0.4c-2.6-1.2-5.2-2.4-7.8-3.7
		C292.4,190.7,292.3,190.8,292.2,191z"
      />
      <path
        class="st2"
        d="M270.9,154.7c0.1-0.1,0.1-0.2,0.2-0.3c-0.4-0.4-0.8-0.9-1.3-1.3c-0.4,0.2-0.7,0.4-1.3,0.9
		C269.5,154.2,270.2,154.5,270.9,154.7z"
      />
      <path
        class="st2"
        d="M228.8,144.3c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.2-0.2c-0.4-0.1-0.7-0.2-1.1-0.3
		c-0.9,0.2-1.6,0.4-2.1,0.5c1.3,0.7,2.5,1,3.8,1.1C229.1,144.8,229,144.5,228.8,144.3z"
      />
      <path
        class="st2"
        d="M238.5,233c-0.2,0.1-0.5,0.1-0.8,0.2c0.2-0.2,0.3-0.3,0.4-0.4c-4.5-3.3-8.9-6.6-13.4-9.9
		c-0.3-0.2-0.6-0.5-1-0.7c-1.7-1.3-3.4-2.6-5.1-3.8l0,0c-11.9-8.8-23.7-17.7-35.6-26.5c-0.1,0.1-0.2,0.2-0.3,0.3
		c0.5,0.4,1,0.8,1.5,1.2c11.2,8.6,22.4,17.1,33.6,25.7c0.9,0.7,1.8,1.3,2.6,2c6.2,4.7,12.4,9.5,18.7,14.2c0-0.2,0-0.4,0.1-0.5
		c0.1-0.2,0.6-0.1,0.9-0.2C239.7,233.8,239.1,233.4,238.5,233z"
      />
      <path
        class="st2"
        d="M242.2,236.5c0.2-0.1,0.4-0.2,0.6-0.3c-0.1-0.1-0.2-0.1-0.3-0.2C242.4,236.2,242.3,236.3,242.2,236.5z"
      />
      <path
        class="st2"
        d="M200.2,239.8c-11.3-10.8-22.6-21.5-33.9-32.3c-0.1-0.1-0.3-0.3-0.4-0.4l-0.1-0.1c-0.2,0.5-0.3,0.8-0.1,1
		c11.6,11.3,23.2,22.5,34.8,33.8C200.3,241.1,200.2,240.5,200.2,239.8z"
      />
      <path
        class="st2"
        d="M249.3,136.2c0.3,0.3,0.6,0.4,1.5,0.5c0-0.2-0.1-0.5-0.1-0.7C250.2,136,249.7,136.1,249.3,136.2z"
      />
      <path
        class="st2"
        d="M169.7,197c-1.5-1.3-3-2.6-4.5-3.9c-0.1,0.1-0.2,0.2-0.3,0.3c1.5,1.3,3,2.7,4.5,4
		C169.5,197.2,169.6,197.1,169.7,197z"
      />
      <path
        class="st2"
        d="M177.6,177.1c0.7,0.6,1.4,0.9,2.3,1.1c0.9,0.2,1.9,0.2,3,0c-1-0.7-1.9-1.4-2.8-1.6
		C179.3,176.4,178.5,176.5,177.6,177.1z"
      />
      <path
        class="st2"
        d="M219.5,141.9c0.5,0.3,1,0.6,1.6,0.8c1.1-0.3,2.1-0.7,2.5-1.5c-0.3,0.1-0.6,0.1-0.9,0.2
		c-0.4,0.1-0.9,0.2-1.3,0.2C220.8,141.7,220.1,141.8,219.5,141.9z"
      />
      <path
        class="st2"
        d="M185.2,173.2c0.7,0.1,1.6-0.5,2.7-1c-1.7-1.3-3.2-1.1-4.9-0.8C183.8,172.1,184.4,173,185.2,173.2z"
      />
      <path
        class="st2"
        d="M256.5,246.4c-1-0.8-2.1-1.5-3.1-2.3c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.2
		c-0.1-0.1-0.3-0.2-0.4-0.3l-0.1-0.1c-0.2,0.1-0.3,0.3-0.3,0.5c0,0.1,0,0.1,0,0.2c0,0.2,0.4,0.3,0.8,0.6c-0.1,0.1-0.2,0.3-0.4,0.5
		c0.1,0.1,0.3,0.2,0.4,0.3c0.7,0.6,1.5,1.1,2.2,1.7C255.6,247,256.1,246.7,256.5,246.4z"
      />
      <path
        class="st2"
        d="M96.4,173.2c6-1.3,12.1-2.6,18.1-3.8c1.5-0.3,2.9-0.6,4.4-0.9c0.7-0.1,1.4-0.3,2-0.4c2-0.4,4.1-0.9,6.1-1.3
		c1.2-0.2,2.4-0.5,3.6-0.7c0.1,0,0.2,0,0.3-0.1c0.5-0.1,0.8-0.2,1.1-0.4c0.2-0.2,0.4-0.5,0.4-0.9c0,0,0,0,0-0.1s0-0.3,0-0.4
		c-0.1-3.9-0.1-7.9-0.1-11.8c-0.2,0.2-0.3,0.3-0.5,0.5c-1.3-0.3-2.6-0.5-2.7-2c-0.5,0.3-0.7,0.5-1,0.6c-0.4,0.2-0.9,0.4-1.3,0.5
		s-1.8,0.6-2.2,0.7c-1.3,0.6-2.7,0.8-4.2,0.6c-0.7-0.1-1.3-0.2-2.1-0.4c0.4-0.2,0.7-0.2,0.9-0.4c0.6-0.3,0.7-0.8,0.3-1.2
		c-0.5-0.5-1-0.9-1.3-1.1c-0.1-0.3-0.1-0.7-0.2-1c-0.3,0.1-0.7,0.3-1,0.4c-0.5,0.2-1.1,0.5-1.6,0.7v0.1c-0.1,0.4,0.1,0.7,0.3,1.1
		c0.4,0.7,0.3,1.3-0.1,1.8c-0.3,0.3-0.7,0.5-1.2,0.6c-0.3,0.1-0.7,0.2-0.9,0.1c-1.7-0.5-3.6-0.1-5.4-0.2l-0.1-0.1
		c-1.2,0.5-2.3,1.1-3.5,1.6c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0.1-0.3,0.1-0.4,0.2c-0.1,0.2-0.1,0.3-0.2,0.5c-0.1,0.1,0.1,0.4,0.2,0.7
		c-0.6,0-1.2-0.2-1.8-0.3c-0.6,0.3-1.1,0.5-1.7,0.8l0,0l0,0c-1.1,0.5-2.3,1.1-3.4,1.6c0.1,0.3,0.3,0.6,0.6,1
		c-0.3,0.9-0.7,1.7-0.6,2.5c0,0.1,0.1,0.2,0.1,0.3s0.1,0.2,0.1,0.3s0.1,0.2,0.2,0.3c0.3,0.4,0.6,0.8,0.9,1.2c0.2,0.3,0.5,0.6,0.9,1
		c-1.2,0.6-2.1,1.5-3.5,0.8c-0.4-0.2-0.8-0.1-1,0.4c-0.2,0.6-0.5,0.7-0.9,0.1c-0.2-0.3-1.1,0.2-1-0.6c0.1-0.1,0.3-0.2,0.4-0.3
		c-0.2,0-0.3,0-0.5,0v-0.1c0-0.1,0-0.1,0-0.2c0-0.4,0.1-0.8-0.6-0.8c-0.3,0-0.7,0.1-0.8,0.3c-0.2,0.2-0.1,0.5-0.1,0.8
		c-0.2-0.1-0.4-0.1-0.5-0.2c-0.2,0.1-0.3,0.2-0.4,0.3c-0.2,0.2-0.2,0.3-0.2,0.4c0,0.1,0.1,0.2,0.1,0.3l0,0c0,0.1,0,0.2,0,0.3
		c0,0.2-0.1,0.4-0.5,0.4c-0.5,0.1-0.9,0.1-1.5,0.1l0,0l0,0c0.6,0.7,1.4,0.7,2.2,1c-0.3,0.6-0.4,1.4-1.6,1.1c0.2,0.3,0.2,0.5,0.3,0.8
		c-0.3,0.4-0.6,0.8-1,1.2c0.2,0.1,0.4,0.3,0.7,0.5c-0.2,0.2-0.5,0.4-0.7,0.7c0.3,0.4,0.6,0.7,0.9,1c0.1,0.3,0,0.6-0.2,0.8
		C91.2,174.4,93.8,173.8,96.4,173.2z M92.1,166.3c0.1,0,0.3-0.1,0.4-0.1c0,0.1,0,0.2,0.1,0.2C92.4,166.3,92.2,166.3,92.1,166.3z"
      />
      <path
        class="st2"
        d="M3.5,199.2c0.7,0.1,1.4,0.2,2,0.4c-1.1-0.7-2.1-1.3-3.2-2c-0.6-0.4-0.9-1.1-1.4-1.6c0.7,0.2,1.5,0.2,2,0.5
		c1.8,1.1,3.6,2.3,5.5,3.4c0.5,0,0.9,0.2,1.3,0.7l0.1,0.1c0.8,0.5,1.6,1,2.3,1.5c4.8,3,9.5,6,14.3,8.9c0.4,0.2,0.8,0.5,1.3,0.8
		c0-2.8,0-5.4,0-8c0-1.9-0.1-3.8-0.1-5.6c0-0.8,0-1.7-0.1-2.5c0-0.7,0-1.4,0-2.1c0-0.9,0-1.8-0.1-2.7c0-1.9-0.1-3.8-0.1-5.7
		c0-1.1,0-2.2-0.1-3.3c0-0.7,0-1.5,0-2.2c-0.2,0.3-0.4,0.6-0.5,0.8c-0.2,0.6-0.5,0.9-1.3,0.9c-0.5,0-0.9-0.1-1.3-0.4
		c-0.2-0.2-0.4-0.4-0.5-0.6c-0.1-0.3-0.2-0.7-0.3-1c-0.3,0.9-0.8,1.7-0.2,2.6c-0.3,0.2-0.6,0.4-0.9,0.6c-0.2,0.1-0.4,0.2-0.6,0.3
		c-0.1-0.3-0.2-0.5-0.3-0.9c-0.3-0.1-0.8-0.1-1.3-0.2c-0.4,0.8-1,1.3-1.7,1.8c-0.8,0.5-1.6,1.2-2,1.9s-0.5,1.6-0.6,2.3
		c0,0.3,0.1,0.7,0.2,1c0,0.1,0.1,0.2,0.1,0.3c0.2,0.8,0.6,1.4,1.3,1.9c0.4,0.3,0.8,0.5,1.3,0.7c-0.1,0.3-0.2,0.6-0.4,1
		c-0.2-0.3-0.4-0.5-0.6-0.7c-0.5,0.4-0.4,0.7-0.3,1.1c0.1,0.3,0.2,0.6,0.1,0.8c-0.3,0.1-0.5,0.3-0.7,0.4c-0.1,0.1-0.2,0.1-0.3,0.2
		l0,0h-0.1c-0.1,0.1-0.2,0.1-0.3,0.2c0-0.1-0.1-0.3-0.1-0.4c0-0.1,0-0.2-0.1-0.3c0-0.2-0.1-0.4-0.1-0.5c-0.1-0.5-0.1-0.9-0.7-1.1
		c-0.2-0.1-0.3-0.4-0.4-0.6c-0.4-0.6-0.6-1.2-1.1-1.7c-0.2-0.2-0.4-0.4-0.5-0.5s-0.2-0.2-0.4-0.3c-0.2-0.2-0.5-0.3-0.7-0.3
		c-0.7-0.2-1.4-0.1-2.5,0.3c-0.3,0.1-0.5,0.2-1.1,0.4c0.3-1,0.1-1.6-0.8-2.2c-0.1,0.3-0.1,0.5-0.2,0.7c-0.3,0.9-0.4,1-1.4,0.9
		c-0.3,0-0.7-0.1-1-0.1c-0.5-0.1-1-0.4-1.2-1.1c-0.2,0.5-0.3,0.7-0.4,1c-1,0.3-1.9,0.6-2.7,0.9c-0.3,0.3-0.3,0.7-0.6,1v0.3v6.7
		c1.1,0.6,2.2,1.1,3.2,1.7C3.2,199.8,3.3,199.5,3.5,199.2z M7.5,189.7l-0.1,0.1l-0.1-0.1H7.5z"
      />
      <path
        class="st2"
        d="M143.4,271.3c-0.2,0.3-0.4,0.6-0.5,1c0.1,0,0.2,0,0.4,0C143.3,271.9,143.3,271.6,143.4,271.3z"
      />
      <path
        class="st2"
        d="M30.3,279.1c1.8,1.2,3.6,2.2,5.7,3.5c0-0.8,0-1.3,0-1.8c-0.4-8.8-0.8-17.5-1.2-26.3c-0.5-10.8-1-21.7-1.4-32.5
		c-0.1-1.4-0.1-2.7-0.2-4.1c0-0.4-0.1-1.1-0.4-1.3c-0.2-0.1-0.3-0.2-0.5-0.3c-1.1-0.8-2.3-1.5-3.6-2.3c0,1,0,1.7,0,2.5
		c0,0.5,0,1,0,1.5c0,1.3,0.1,2.6,0.1,4c0.2,7.1,0.3,14.2,0.5,21.4c0.3,11.4,0.5,22.7,0.8,34.1C29.9,278,29.9,278.8,30.3,279.1z"
      />
      <path
        class="st2"
        d="M277.2,237.1c1.4-0.9,2.6-2,4.2-3.2c-1.4-1-2.7-1.8-4-2.7c-0.2-0.1-0.5-0.1-0.7-0.1c-1.8,1-3.5,2.1-5.1,3.1
		c1.5,0.9,2.9,1.8,4.3,2.6C276.3,237,277,237.2,277.2,237.1z"
      />
      <path
        class="st2"
        d="M145,264.6c0.2-0.1,0.4-0.4,0.6-0.7c0.3,0.1,0.7,0.2,1,0.4c0.8,0.4,1.5,0.5,2.3,0.3c-1.1-1.6-2.1-3.2-3.2-4.8
		c-0.1-0.1-0.2-0.3-0.3-0.4c-0.1,0.3-0.3,0.6-0.4,0.9c-0.1,0.4-0.3,0.7-0.4,1.1c0,1.1,0,2.3,0,3.4
		C144.8,264.7,144.9,264.7,145,264.6z"
      />
      <path
        class="st2"
        d="M5.6,199.6c0.4,1,0.2,2.1,1.1,3c0.2-1-1-1.6-0.3-2.5C6.1,200,5.8,199.8,5.6,199.6z"
      />
      <path
        class="st2"
        d="M143.4,264.9c-0.4-0.2-0.8-0.4-1.4-0.5h-0.1c0,1.7,0,3.5,0,5.2v0.1c0.5-0.1,1.1-0.4,1.5-0.8
		C143.4,267.6,143.4,266.2,143.4,264.9z"
      />
      <path
        class="st2"
        d="M52.6,302.3c0-0.3-0.1-0.5-0.1-0.8C52.5,301.8,52.6,302,52.6,302.3z"
      />
      <path
        class="st2"
        d="M146.4,211.7c0.5-0.2,0.9-0.6,1.4-1c-2-0.6-4.4,0.7-5.2,2.8c0,0,0,0,0,0.1s-0.1,0.1-0.1,0.2
		c-0.4,1.2-0.6,2.6-0.6,3.9c-0.1,7.1-0.2,14.1-0.2,21.2c0,0.5,0,1,0,1.5c0,0.3,0,0.6,0,0.9c0,2.5,0,5,0.1,7.5c0,1,0,2,0.1,3.1l0,0
		c0.6,0.3,1,0.7,1.3,1.4c-0.5,0.2-0.9,0.3-1.2,0.5c0,0.4,0,0.9,0,1.3c0,1.2,0,2.5,0,3.7c0.4,0.2,1,0.3,1.5,0.2c0-2.1,0-4.3,0-6.4
		c0-0.4,0-0.9,0-1.3c0-0.7,0-1.4,0-2.1c0-2.5,0-5-0.1-7.5c0-1.4,0-2.7,0-4.1c0-0.9,0-1.8,0-2.7c0-1.7,0-3.3,0-5
		c0-4.4-0.1-8.7,0-13.1C143.2,214.3,144.2,212.6,146.4,211.7z"
      />
      <path
        class="st2"
        d="M89.3,181.9c0.3,0.5,0.6,1,0.9,1.5c0.2,0.3,0.3,0.5,0.5,0.8c0.9,1.4,1.7,2.9,2.6,4.3c0,0,0,0.1,0.1,0.1
		c0.2,0.4,0.5,0.8,0.7,1.3c8,13.5,15.9,27,23.9,40.4c0,0,0,0,0,0.1c0.9,1.6,1.9,3.1,2.8,4.7c0.5,0.9,1,1.7,1.5,2.6
		c0.7,1.1,1.3,2.2,2,3.4s1.4,2.4,2.2,3.7c0.2,0.4,0.5,0.8,0.7,1.2c1,1.7,2,3.4,3,5c2.2,3.7,4.3,7.3,6.5,11c0.7,1.1,1.3,2.2,2,3.3
		c0.5,0.9,1.1,1.8,1.6,2.7c0.1,0,0.2-0.1,0.3-0.1c0-0.3,0-0.6,0-0.9c0-1.1,0-2.2,0-3.3v-0.1c-0.3-0.3-0.8-0.4-1.3-0.5
		c-0.2,0-0.5-0.1-0.7-0.1h-0.1c0-0.1,0-0.1,0-0.2c0.1-1,1.5-1.3,2.1-2.2c-0.5,0.1-0.9,0.2-1.3,0.3c-0.8-0.6-1.1-1.3-0.6-2.1
		c-0.3-0.3-0.6-0.5-1-0.6c-0.3-0.1-0.6-0.2-0.9-0.4c-0.6-0.3-1.2-0.6-1.5-1.3l0.1-0.1c0.4-0.3,0.7-0.6,1.1-0.9l0,0
		c0.2-0.2,0.5-0.4,0.7-0.6c-0.2-0.2-0.5-0.3-0.8-0.5c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1,0-0.1-0.1-0.2c-0.2-0.4-0.1-0.9-0.2-1.5
		c0.9,0.2,1.5,0.5,2.2,0.5s1.5-0.2,2.1-0.5c0.1,0,0.2-0.1,0.3-0.1c0,0,0,0,0.1,0c0-0.1-0.1-0.2-0.1-0.4c-0.1,0-0.1-0.1-0.2-0.1
		c0-0.1,0-0.3,0-0.5c-0.3-0.7-0.6-1.3-1-2c-2-3-4-6-6-9c-0.9-1.3-1.7-2.6-2.6-3.9c-0.5-0.8-1.1-1.6-1.6-2.4
		c-0.8-1.3-1.6-2.5-2.5-3.8c-0.1-0.1-0.1-0.2-0.2-0.3c-0.6-0.9-1.2-1.9-1.8-2.8c-0.6-0.9-1.2-1.9-1.8-2.8
		c-8.4-12.8-16.8-25.7-25.2-38.5c-0.1-0.1-0.2-0.3-0.3-0.4c-0.6-0.9-1.2-1.8-1.8-2.7c-0.9-1.3-0.8-1.6,0.8-2
		c5.1-1.2,10.1-2.3,15.2-3.5l0,0c1.4-0.3,2.8-0.6,4.2-1c0.1,0,0.1,0,0.2,0c0.7-0.1,1.3-0.3,2-0.5c0.4-0.1,0.9-0.2,1.3-0.3l0,0
		c0.6-0.1,1.2-0.3,1.8-0.4c1.7-0.4,3.4-0.8,5.1-1.2c1.2-0.3,2.4-0.6,3.6-0.8c0.6-0.1,1.1-0.3,1.7-0.4c0.5-0.1,1.2-0.6,1.2-0.9
		c0.1-1.1,0.1-2.3,0.1-3.5v-0.1c0-0.3,0-0.7,0-1.1c-3.2,0.7-6.5,1.4-9.7,2.1l0,0c-0.5,0.1-0.9,0.2-1.4,0.3c-1,0.2-2.1,0.4-3.1,0.7
		c-0.9,0.2-1.8,0.4-2.7,0.6c-8.8,1.9-17.6,3.7-26.5,5.6c-0.4,0.1-0.9,0.2-1.3,0.3c-0.2,0-0.3,0.1-0.5,0.1c0.4,0.6,0.3,1.4,0.4,2.2
		c-0.1,0-0.1,0-0.2,0c0,0.1,0.1,0.1,0.1,0.2c0-0.1,0-0.1,0.1-0.2c0.6,0.3,1.3,0.6,1.3,1.4c-0.2,0-0.4,0.1-0.6,0.1
		C88.7,180.8,89,181.3,89.3,181.9z"
      />
      <path
        class="st2"
        d="M285.9,238.3c-0.8,0-0.3,1.3-1.4,0.9c0.2-0.7,0.3-1.4,0.4-2c0.4-0.3,0.7-0.5,1.1-0.8c-0.6-0.3-1.2-0.6-1.8-0.9
		c-0.2-0.1-0.6-0.2-0.8-0.1c-1.4,0.8-2.9,1.8-4.2,2.6c0.5,1,1.5,1.6,2.1,2.5c0.1-0.1,0.2-0.1,0.2-0.1c1,0.3,1.5-0.6,2.4-0.8
		c0.6,1.2,1.6,0.3,2.6,0.3C286.8,239.3,286.7,238.7,285.9,238.3z"
      />
      <path
        class="st2"
        d="M142.7,260.1c-0.1,0.2-0.2,0.4-0.2,0.6c0,0.8,0.5,1.4,0.8,2.1c0-0.8,0-1.5,0-2.3
		C143.2,260.4,143,260.2,142.7,260.1z"
      />
      <path
        class="st2"
        d="M152.9,270.6c-0.8-1.2-1.6-2.4-2.3-3.5c-0.2,0.4-0.3,0.9-0.2,1.4C150.4,269.5,151.5,270.4,152.9,270.6z"
      />
      <path
        class="st2"
        d="M239.1,136.4c-0.1,0.1-0.2,0.2-0.3,0.3s-0.2,0.2-0.3,0.3c0.2,0,0.3-0.1,0.5-0.1h0.1c1.2-0.2,2.5-0.5,3.7-0.7
		c-0.1-0.1-0.2-0.2-0.3-0.3C240.5,136.4,240.4,136.5,239.1,136.4z"
      />
      <path
        class="st2"
        d="M244.1,135.9c0-0.1,0-0.2,0-0.3c-0.2,0.1-0.3,0.3-0.4,0.4C243.8,136,243.9,136,244.1,135.9z"
      />
      <path
        class="st2"
        d="M147,207.8c-3.6-4-7.3-7.9-11-11.9c-0.9-0.9-1.2-1.9-1.2-3.1c0-1.8,0-3.6,0-5.3c0-2.4,0-4.7,0-7.1
		c0-1.5,0-2.9,0-4.4c0-0.7,0-1.4,0-2c0-1.2,0-2.3,0-3.5c0-0.1,0-0.2,0-0.3c0-1.3,0-2.5,0-3.8c0-1.1,0-2.2,0-3.3c0-0.7,0-1.4,0-2.1
		c0-3.2,0-6.5-0.1-9.7c-0.2-0.2-0.5-0.3-0.7-0.5c-0.1,0.1-0.1,0.1-0.2,0.2c0,3.4,0,6.7,0,10.1c0,2,0,3.9,0,5.9c0,0.9,0,1.7,0,2.6
		c0,0.5,0,1,0,1.5c0,0.8,0,1.6,0,2.4c0,0.8,0,1.7,0,2.5c0,1.5,0,3.1,0,4.6c0,2,0,4.1,0,6.1c0,2.4,0,4.8,0,7.1c0,0.7,0.3,1.5,0.8,2.1
		c3.7,4.1,7.4,8.2,11.2,12.3c0.5,0.5,1.2,0.7,1.9,1.1c0.1-0.1,0.2-0.3,0.3-0.4C147.6,208.5,147.3,208.1,147,207.8z"
      />
      <path
        class="st2"
        d="M147.2,283.8c0.3,0,0.5,0,0.8-0.1c-0.9-1.5-1.8-3-2.7-4.5c-0.5-0.9-1.1-1.9-1.6-2.8c-0.3,1-0.6,2.1-0.3,3.2
		c0.1,0.4,0.2,0.7,0.4,1.1c-1.4,0.7-2.5,1.7-2.1,3.2c0.3,0.9,1,1.5,2.1,1.6C145.5,285.7,146.6,284.9,147.2,283.8z"
      />
      <path
        class="st2"
        d="M139.2,269.4c0.1,0,0.2,0.1,0.4,0.1c-0.2-0.4-0.4-0.7-0.7-1.1c-1.1-1.9-2.2-3.8-3.3-5.6
		c-1.1-1.9-2.3-3.9-3.4-5.8c-1.2-2-2.3-4-3.4-5.9c-0.4-0.7-0.8-1.4-1.2-2.1c-0.7-1.2-1.4-2.3-2-3.5c-0.2-0.4-0.5-0.9-0.7-1.3
		c-0.5-0.9-1.1-1.8-1.6-2.8c-0.5-0.8-0.9-1.6-1.4-2.4c-0.8-1.4-1.7-2.8-2.5-4.2c-0.5-0.9-1.1-1.8-1.6-2.8c-0.6-1.1-1.3-2.1-1.9-3.2
		c-5.2-8.7-10.4-17.5-15.6-26.2c0,0,0-0.1-0.1-0.1c-2.3-4-4.7-7.9-7-11.9c-0.1-0.1-0.1-0.3-0.2-0.4c-0.1-0.2-0.3-0.5-0.4-0.7
		c-1.1-1.9-2.3-3.9-3.4-5.8c-0.6-1-1.2-2.1-1.9-3.1c-0.1,0-0.2,0-0.4,0.1c-0.1-0.2-0.1-0.4,0.1-0.6c-0.4-0.6-0.8-1.3-1.1-1.9
		c0,0,0,0,0-0.1c-0.3,0-0.6,0-0.8,0.1c-0.3,0.2-0.6,0.5-0.9,1.1c-0.1,0-0.2-0.1-0.4-0.1c0.4,0.8,0.9,1.6,1.3,2.3
		c0.3,0.6,0.7,1.2,1,1.8c0.6,1,1.2,2.1,1.8,3.1c0.1,0.3,0.3,0.5,0.4,0.8c1.1,1.9,2.2,3.8,3.2,5.7c4.7,8.3,9.5,16.6,14.2,24.9
		c-0.2,0.1-0.4,0.2-0.6,0.3c-4.7-8.2-9.4-16.4-14.1-24.6c-1.5-2.6-2.9-5.2-4.4-7.7c0-0.1-0.1-0.1-0.1-0.2c-0.4-0.6-0.7-1.2-1.1-1.9
		c-0.3-0.5-0.6-1-0.9-1.5c-0.5-0.9-1.1-1.9-1.6-2.8l-0.1-0.1c-0.2,0.1-0.5,0.1-0.6,0.2c-0.3,0.2-0.5,0.4-0.5,0.7
		c-0.1,0.5-0.3,0.6-0.8,0.9c-0.7,0.4-0.8,1.1-0.5,1.9c0.1,0,0.2-0.1,0.2-0.1c1.2-0.5,2.2-0.5,3,0.2l0,0c0,0,0,0,0.1,0.1h-0.1
		c0,0,0,0-0.1,0c-0.8,0.2-1.8-0.2-2.6,0.4l0,0c-0.2,0.1-0.9-0.1-1.2-0.6c-0.4-0.7-1.3-1.1-1.8-1.8c-0.2-0.2-0.7,0-0.9-0.1
		c-0.1,0-0.2-0.1-0.1-0.4l0,0c0-0.2,0.1-0.4,0.1-0.5v-0.1c-0.2,0-0.5,0-0.6,0.2c0,0.1,0,0.1,0,0.2c-0.4,0.1-0.8,0.3-1.2,0.4
		c-0.1-0.1-0.2-0.2-0.2-0.3c-0.2-0.5-0.6-0.8-1-1c-0.7-0.3-1.6-0.1-2.4,0.6c-0.5,0.5-0.8,1.1-1.8,0.8c0.1,0.5,0.2,0.8,0.3,1.3
		c0.5-0.1,1-0.1,1.8-0.2c-0.2,0.2-0.3,0.3-0.4,0.4c-0.2,0.2-0.4,0.4-0.6,0.6c-0.3,0.3-0.5,0.6-0.8,1.1c-0.3-0.2-0.5-0.4-0.7-0.6
		c-0.4-0.5-0.7-1-1.1-1.6c-0.3-0.4-0.6-0.8-1.1-1.1c-0.8,0.1-1.5,0-2.1-0.3c-0.5-0.2-0.9-0.5-1.3-0.9c-0.5,0.4-0.9,0.8-1.3,1.2
		c0-0.9,0.3-1.5,1.1-2c0,0,0.1,0,0.1-0.1l0,0c0.1,0.1,0.1,0.3,0.2,0.4c0.2-0.2,0.4-0.4,0.4-0.6c0-0.1-0.1-0.2-0.3-0.3l0,0
		c-0.1-0.1-0.3-0.2-0.3-0.3l0,0c-0.2-0.8-0.7-1.4-1.4-1.7c-0.4-0.1-0.8-0.2-1.3-0.2c0-0.1,0-0.1,0-0.2c0.1-0.3,0.1-0.5,0.2-0.7
		c0.1-0.3,0.2-0.7,0.3-1c0.1-0.1,0.2-0.3,0.4-0.4c0.1-0.1,0.3-0.2,0.5-0.3s0.5-0.2,0.8-0.3c0.1,0,0.3-0.1,0.4-0.1l0,0
		c0.2-0.2,0.5-0.7,0.6-0.7c1.1,0.2,1.4-0.7,2.2-1.1c-0.7-0.4-1.3-0.8-2.1-0.9c-0.5-0.1-1,0-1.6,0.2c0.1,0.1,0.1,0.2,0.2,0.3
		c0.1,0.2,0.2,0.4,0.3,0.5c-0.3,0.5-0.7,0.9-1.4,0.9h-0.1c-0.4,0-1,0.4-1.4,0.7c-0.5,0.4-1.1,0.6-1.4,0.2c-0.8-0.9-2.1-1.2-3.3-1.4
		l0,0c-0.4-0.1-0.9-0.1-1.3-0.2c-0.7-0.2-0.8-0.4-0.9-0.8c0.1-0.1,0.1-0.2,0.2-0.2c0.3-0.3,0.7-0.5,0.9-0.8c0.7-0.8,1.7-1.4,2.1-2.4
		c0.2-0.3,0.2-0.7,0.2-1.1c0-1.5-0.7-2.2-2.6-2.2c-0.6,0-1.2,0.1-1.9,0.1c-0.1-0.2-0.2-0.5-0.2-0.8c0.1-1.4-0.8-2.4-2-3.2
		c-1.2-0.9-2.7-0.5-4,0c-1.3,0.4-2.2,1.2-2.7,2.1c-0.2,0.4-0.3,0.8-0.4,1.2c-0.2,1-0.8,1.8-1.7,2.3c-0.3,0.2-0.5,0.3-0.7,0.5
		c-0.7,0.5-1.1,1.1-1.4,1.7c-0.3,0.7-0.3,1.5-0.1,2.3c0,0.1,0,0.2,0.1,0.3l-0.1,0.1c-0.9,0.2-0.9,0.2-1.3-1.3
		c-0.5,0.1-1.1,0.2-1.8,0.3c0.2,0.7,0.8,1,1.4,1.2c-0.7,0.9-1.5,1.7-2,2.6c-0.1,0.3-0.2,0.5-0.2,0.8c2.6,1.9,5.2,3.8,7.8,5.7
		c0.4,0.3,0.8,0.5,1.3,0.9c0-0.6,0.1-1,0.1-1.4c0.2,0,0.4,0,0.4,0c0.3,2.7,2.4,3.4,4.3,4.8c0.3,0.2,0.7,0.5,1,0.8c0-0.5,0-0.9,0-1.3
		c0-0.3,0-0.6,0-0.9c0.2,0,0.3,0,0.3,0.1c0,0.2,0.1,0.5,0.1,0.7c0.1,0.5,0.3,0.9,0.5,1.3c0.4,0.8,1,1.5,1.8,2
		c0.3,0.2,0.5,0.4,0.8,0.6l0.1,0.1c0.3,0.3,0.5,0.8,0.6,1.2c0.2,0.9,0.4,1.9,0.6,2.8c0.3,1.3,0.6,2.6,0.9,3.9c0,0.1,0.1,0.3,0.1,0.4
		c0.3,1.2,0.5,2.4,0.8,3.6c0.1,0.5,0.2,1,0.3,1.5c1.9,8.4,3.7,16.8,5.5,25.1c0.9,3.9,1.7,7.8,2.5,11.7c0.2,1,0.4,2,0.6,2.9
		c0.7,3.4,1.5,6.8,2.2,10.2c0.5,2.1,0.9,4.2,1.4,6.2c0.1,0.6,0.3,1.1,0.4,1.7c2.3,10.3,4.5,20.7,6.8,31c0.2,0.8,0.3,1.5,0.5,2.3
		s0.3,1.6,0.5,2.4c0.3,1.2,0.5,2.4,0.8,3.5c0,0.1,0,0.1,0,0.2v0.1c0.6,2.5,1.1,5.1,1.7,7.6c2,0.2,4-0.3,6-1.5l0,0
		c0.9,0.6,1.7,0.9,2.4,0.9c0.6,0,1.2-0.1,1.7-0.4c0.9-0.5,1.4-1.7,1.2-2.5c-0.3-1.1-1.4-1.6-3.5-1.5c-0.2-0.1-0.3-0.2-0.4-0.3
		c-0.3-0.3-0.4-0.6-0.5-0.9c0-0.2,0-0.4,0-0.6s0-0.5,0-0.7s-0.1-0.5-0.2-0.7c-0.1-0.1-0.1-0.2-0.2-0.3c-0.8,0.1-1.4,0-2-0.5l0,0
		c-0.2-0.1-0.4-0.3-0.6-0.4s-0.5-0.3-0.7-0.4c-0.3-0.2-0.5-0.4-0.6-0.8c-0.1-0.2-0.2-0.3-0.4-0.4c-0.4-0.2-1.1-0.2-1.7,0.1l0,0
		c-0.3,0.1-0.5,0.4-0.8,0.6l-0.1,0.1c0-0.1,0-0.1,0-0.2c-0.1-0.4-0.1-0.8-0.2-1.4c0.3,0.1,0.6,0.2,0.8,0.2c0.1,0,0.1,0,0.2,0.1
		c0-0.2,0-0.5,0-0.8c0-0.1,0-0.1,0-0.2c1-0.3,2-0.6,2.3-1.6c0-0.1,0.4-0.1,0.6-0.2c0.3-0.2,0.7-0.4,0.8-0.6c0.1-0.2,0.1-0.4,0.2-0.5
		c0-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1,0.1-0.1c0.3-0.5,0.8-0.9,1.3-1.3c0.3-0.2,0.4-0.5,0.6-0.8c0.3-0.5,0.7-0.8,1.4-0.9
		c0.4,0,0.9-0.5,1.4-0.8c0.1,0.4,0.3,0.9,0.4,1.5c-0.8,0.3-1.4,0.5-2.3,0.9c0,0,0.1,0,0.1,0.1c0.5,0.4,0.8,0.8,1.2,1.2
		c0.1,0.1,0.1,0.1,0.2,0.2c0.3,0.3,0.5,0.5,0.9,0.7s0.9,0.4,1.6,0.4c0.4-0.4,1.1-0.9,1.5-1.5c0.1-0.1,0.2-0.2,0.2-0.3
		c0.6-0.6,1.5-0.6,2.3-0.8c0.5,0.7,0.7,1.3,0.1,1.9c-0.1,0.1-0.3,0.3-0.5,0.4c-0.4,0.3-0.7,0.8-0.7,1.2c-0.1,0.7,0,1.4,0,2.2
		c0,0.2,0,0.4,0,0.6c0.9-0.2,1.6-0.4,2.4-0.7c0,0.2,0,0.4,0,0.6c0,0.4,0,0.7,0,1.1c0.6-0.1,1.1-0.2,1.6-0.3
		c-0.2,0.7-0.3,1.5-0.6,2.5c-0.6,0.3-1.4,0.6-2.3,1c0,0.2,0,0.4,0.1,0.7c0,0.3,0.1,0.6,0.1,0.9v0.1c0.1,1.1,0.7,2,2,2.3
		c1.1,0.3,2.6-0.1,3.4-0.9c0.9-1,1.1-2,0.4-3c-0.1-0.2-0.2-0.3-0.4-0.5c0.9-0.9,2.3-0.7,3.4-1.2c0.5-0.6,1.1-1.2,1.3-1.8
		c0.3-0.8,0-1.6-0.7-2.2c-0.3-0.2-0.5-0.4-1-0.8c1,0.1,1.6,0.3,2.2,0.3s0.8-1,1.8-0.7c-0.1,0.4-0.2,0.8-0.3,1.2
		c0.3,0.3,0.5,0.6,0.9,0.9c0.2,0.1,0.5,0.2,0.8,0.1c1.3-0.2,1.3-0.2,1.6,0.7c0,0.1,0.1,0.2,0.2,0.3c0,0,0.1,0.1,0.2,0.2
		c0,0,0.1,0.1,0.2,0.1l0.1-0.1c0.1-0.3,0.3-0.5,0.4-0.8c0.1,0,0.1,0,0.2,0c0.4,0,0.8,0.1,1.3,0.1c0.3-0.3,0.7-0.5,1.1-0.8
		c0.2,0.1,0.3,0.2,0.4,0.3c0.7,1.3,0.7,1.3,2.2,1.2c0.3,0.6,0.6,1.2,0.9,1.9c1-1.1,2.2-0.5,3.2-1c0.3-0.1,0.9-0.1,1.2,0.1
		c0.8,0.7,1.8,0.3,2.8,0.6c-0.1-0.4-0.2-0.7-0.3-1c0.8-0.1,1.5-0.1,2.2-0.2c-0.2-0.4-0.5-0.7-0.8-1.2c0.8-0.3,1.5-0.7,2.2-0.9
		c-0.5-0.2-1-0.3-1.4-0.6c-0.4-0.3-0.5-0.7-0.9-1.3c0.4,0,0.6,0,0.9,0.1s0.7,0.3,1,0.3c0.2,0,0.5-0.2,0.6-0.3
		c0.1-0.1,0.1-0.4-0.1-0.5c-0.3-0.3-0.6-0.5-0.9-0.7c0.1-0.3,0.2-0.6,0.3-1c-0.3-0.1-0.6-0.2-1.1-0.4c-0.1,0.9-0.7,1.4-1.6,1.2
		c-1-0.2-1.6,0.3-2.4,0.9c-0.5-0.4-1-0.7-1.6-1.1c-0.2,0.1-0.5,0.1-0.8,0.2c-0.2,0-0.3,0.1-0.5,0.1c0-0.3,0-0.4,0-0.6
		c-0.5,0-1.4,0.5-1-0.6c-1,0.8-1,0.8-3.6,0.8c0.3-0.4,0.6-0.8,0.9-1.1c-0.2-0.1-0.4-0.2-0.6-0.3c-0.3-0.2-0.6-0.4-0.9-0.7
		c0.4-1.2,0.4-1.2,1.8-1.8c-0.1-0.7,0-1.5-1.3-1.6c-0.6-0.1-0.7-0.5-0.6-0.9c0.1-0.3,0.2-0.6,0.4-0.9c-2.1-0.4-2.4,1.3-3.7,1.9
		c-0.1-0.3-0.2-0.6-0.3-0.9c-0.6-1.5-0.8-1.6-3-1.3c0.9-0.7,0.5-1.6,0.1-1.9c-0.8-0.8-0.5-1.4,0.2-2.2c-0.3-0.2-0.5-0.3-0.8-0.5
		c-0.2,0.4-0.3,0.8-0.6,1c-0.9,0.4-1.9,0.7-2.8,1.1c-0.1-0.3-0.2-0.5-0.2-0.6l0,0c0.1-0.6,0.1-1.2-0.2-1.7c-0.2-0.3-0.6-0.6-1.2-0.7
		c-0.5-0.1-0.8-0.9-1.1-1.3c-0.6,1.4-2,0.7-3.2,0.7c-0.2,0-0.3,0-0.5,0c0-0.3-0.1-0.8-0.1-1.2c0-0.2,0-0.4,0-0.6
		c0.2,0,0.5,0.1,0.7,0s0.3-0.3,0.5-0.4c-0.2-0.1-0.5-0.4-0.6-0.3c-0.5,0.1-0.9,0.4-1.3,0.6c-0.1,0.1-0.3,0.1-0.4,0.2
		c-0.4,0.2-0.9,0.4-1.3,0.6c-1.3-0.5-0.7-1.2-0.1-1.9c-0.5,0-0.9,0-1.7,0c0.3-0.2,0.5-0.4,0.7-0.5c0.1,0,0.1-0.1,0.2-0.1l0,0
		c0.2-0.1,0.5-0.3,0.9-0.5c-0.5-0.1-0.8-0.2-1.1-0.3c0.4-0.5,0.1-1.2,1-1.7c0.2,0.4,0.3,0.7,0.6,1c0.7,0.8,2,0.9,2.7,0.1
		s1.5-1.1,2.5-1.6c0.5,0.5,0.9,1,1.4,1.5c-0.6,0.8-1.9,1.3-1.7,2.4c0.3,0.3,0.6,0.5,1,0.8c0,0,0.1,0,0.1,0.1
		c0.6,0.4,1.3,0.6,2.3,0.3c0.2-0.1,0.5,0.3,0.8,0.4c0.3-0.2,0.6-0.4,0.9-0.6c0.2,0.1,0.3,0.1,0.5,0.2s0.4,0.2,0.7,0.3
		c0.1,0,0.2,0.1,0.3,0.1c0.1-0.3,0.1-0.6,0.2-1c0.6,0.1,1.2,0.1,2,0.2c-0.2-0.4-0.3-0.6-0.5-0.9c0-0.1,0.1-0.2,0.1-0.2
		c0.4-0.4,0.9-0.8,1.2-1.2c0.4-0.4,0.9-0.5,1.3-0.2c0.3,0.3,0.2,0.6-0.3,0.9c-0.3,0.2-0.6,0.4-0.8,0.6c-0.4,0.5-0.5,1-0.2,1.4
		c0.3,0.3,0.9,0.7,1.3,0.6c1.2-0.3,2.4,0.1,3.5,0c0,0.8-0.9,1.8,0.5,2.3c0.1,0,0.1,0.4,0.1,0.5c-0.2,0.8-0.1,1.5,0.8,1.8
		c1,0.4,1.9-0.1,2.6-0.8c2.6,1.3,4-0.8,5.7-1.8c1,0.8,1.7,1.6,0.8,2.9c0.2,0.1,0.4,0.1,0.6,0.2c0.2,0,0.3,0.1,0.5,0.2
		c0.7,1.4,0.5,3,0.7,4.8c1.1-0.9,1.1-1.8,0.8-2.7c-0.4-1.1-0.9-2.2-1-3.4c-0.1-0.7-0.1-1.2-0.1-1.6c0.1-1.4,0.7-1.5,2.9-2
		c1.1-0.3,2.2-0.5,3.4-1.1c-0.4,0-0.8,0-1.3-0.1c0-0.1-0.1-0.2,0-0.2c0.4-0.3,0.8-0.6,1.2-0.9c1.3,1,1.9,1.1,2.6,0.5
		c0.7-0.7,0.4-1.1-1-2c0.7-1,0.7-1,0.4-2.5c0.6,0,1.2,0,1.8,0l0,0c0.1-0.1,0.3-0.2,0.4-0.3C138.1,269.3,138.2,269.1,139.2,269.4z
M59.8,182.6C59.7,182.6,59.7,182.6,59.8,182.6c0.2-0.2,0.4-0.3,0.6-0.4c0.4-0.2,0.7-0.4,1.2-0.7c-0.3,0.6-0.6,1-0.8,1.4
		c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1-0.1-0.2-0.2-0.3-0.2C60.1,182.8,59.9,182.7,59.8,182.6z M61.2,173.3L61.2,173.3L61.2,173.3
		L61.2,173.3z M102.8,293c0.1-0.1,0.2-0.2,0.2-0.3c0.1,0,0.1,0.1,0.2,0.1C103.1,292.8,103,292.9,102.8,293c-0.1,0.2-0.1,0.6-0.2,0.6
		c-0.4,0.1-0.8,0-1.1,0c0,0,0,0-0.1,0c-1,0.6-1.5,1.5-2.3,2.2c-0.3,0.3-0.7,0.5-1.2,0.7c0.1-0.3,0.2-0.6,0.3-0.9
		c0.2-0.5,0.3-1,0.5-1.5c0.4-0.9,0.3-1.7-0.2-2.5c0.9,0,1.6-0.1,2.1,0C101.6,291.7,102.1,292,102.8,293z M130.7,275.9
		c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0v0.1C130.8,275.9,130.8,275.9,130.7,275.9z"
      />
      <path
        class="st2"
        d="M217.1,266.1c-2.6-2.7-5.2-5.3-7.8-8c-0.4,0.3-0.8,0.6-1.5,0.6c-0.3,0-0.7,0-1,0c-0.2,0-0.4-0.1-0.5-0.1
		c-0.9,0.5-1.7,1-2.5,1.4c0.2,0.8,0.4,1.3,1.2,1.6c0.7,0.3,1.3,0.9,1.6,1.5c0.5,0.9,1.9,0.4,2.5,1.2c0.1,0.2,1.1-0.2,1.7-0.3
		c-0.1-0.4-0.1-0.9-0.2-1.4c0.5-0.1,0.8-0.1,1.2-0.2c0,0.2,0.1,0.4,0.1,0.5c0.3,1.3,0.5,1.4,2.2,1.6c0.4,0,0.7,0.3,1,0.5
		c0.2,0.1,0.3,0.3,0.4,0.5C216.1,266.4,216.5,266.5,217.1,266.1z M211.4,262.1c0.3-0.3,0.5-0.6,0.7-0.9
		C212.5,262,212.5,262,211.4,262.1z"
      />
      <path
        class="st2"
        d="M170.7,297.7c-0.5-0.8-1-1.5-1.5-2.3c-0.5-0.7-1-1.5-1.5-2.2c-0.8-1.2-1.6-2.4-2.4-3.6
		c-0.8-1.1-1.5-2.3-2.3-3.4c-0.1-0.2-0.2-0.3-0.3-0.5c-0.7-1.1-1.4-2.2-2.1-3.3c-0.4-0.6-0.8-1.3-1.2-1.9c-0.7-0.2-1.3-0.4-1.9-0.5
		c0.1-0.5,0.3-1,0.4-1.6c0-0.1,0-0.1,0-0.2c-1.4-2.1-2.7-4.1-4.1-6.2h-0.1c-1.7,0.6-2.9,0.4-3.8-0.7c-0.1-0.2-0.2-0.4-0.4-0.5
		c-1.1-1.3-3.2-1.5-4.8-0.6c0,1.2-0.4,2.4-0.7,4.2c0.9,1.5,1.8,3,2.7,4.5c1,1.6,1.9,3.2,2.9,4.8c0.9-0.1,1.8-0.2,2.7-0.2
		c0.1,0.7,0.1,1.5,0.2,2.3c0.1,0.1,0.2,0.1,0.3,0.2c0,0-0.1,0.1-0.1,0.2c-0.1-0.1-0.1-0.2-0.2-0.3c-0.5-0.1-0.9-0.2-1.4-0.3
		c-0.2,0-0.3,0-0.5-0.1c3.7,6.3,7.5,12.6,11.2,19c1.4-0.4,2.5-1.2,3.3-2.4c0.2-0.3,0.4-0.6,0.6-0.9c0.1-0.6,0.1-1.2,0.2-1.9
		C167.6,299.1,169.3,298.9,170.7,297.7z M156.9,289.9c-1.1,0-2.2,0.1-3.2,0.1c0-1,0-2,0-2.9c1.1,0.3,2.3,0.6,3.7,0.9
		C157.2,288.5,157,289.2,156.9,289.9z"
      />
      <path
        class="st2"
        d="M145.8,288.1c-0.6,2,0.8,3.7,3.1,4c0.4,0,0.8,0,1.5,0.1c-0.8,1.6-1.1,3.1-0.1,4.5s2.5,2,4.5,2.1
		c-0.3,1.2-0.4,2.4,0.3,3.5c1.1,1.6,2.8,2.4,5,2.3c0.1,0,0.2,0,0.2,0c-3.8-6.4-7.5-12.8-11.3-19.1
		C147.5,285.8,146.2,286.8,145.8,288.1z"
      />
      <path
        class="st2"
        d="M72.5,299.4c0.2-0.3,0.4-0.6,0.6-0.9s0.4-0.6,0.6-0.9c0.2,0.3,0.5,0.6,0.8,0.8c0.3,0.4,0.7,0.8,1.1,1.2l0,0
		c-0.9,1.7-0.6,3.1,0.4,4.4c0.3,0.5,0.7,0.9,1.2,1.4c0.3,0.3,0.5,0.5,0.8,0.8h0.1c-0.2-0.9-0.4-1.8-0.6-2.7c0-0.1,0-0.1,0-0.2
		c-0.4-1.6-0.7-3.3-1.1-4.9c-0.1-0.4-0.2-0.9-0.3-1.3c-0.1-0.4-0.2-0.8-0.3-1.1c-0.1-0.3-0.1-0.6-0.2-0.9c-0.2-1.1-0.5-2.3-0.7-3.4
		c-0.1-0.4-0.2-0.8-0.3-1.2c-2.1-9.5-4.1-19-6.2-28.5c-0.2-0.8-0.3-1.5-0.5-2.3c-1.1-5.2-2.3-10.5-3.4-15.7
		c-0.3-1.3-0.6-2.6-0.9-3.9c-0.1-0.4-0.2-0.8-0.3-1.3c-1.3-5.6-2.6-11.3-3.8-16.9c-1.5-6.8-3-13.6-4.5-20.4c-0.1-0.3-0.1-0.6-0.2-1
		c-0.6-2.6-1.1-5.2-1.7-7.7c-0.2-1-0.4-2-0.6-2.9c-0.1-0.4-0.3-0.7-0.5-1s-0.4-0.5-0.5-0.8c-0.2,0.1-0.3,0.2-0.5,0.2
		c0.2,1.2,0.5,2.4,0.7,3.6c0.1,0.3,0.1,0.7,0.2,1c0.1,0.6,0.2,1.2,0.3,1.7c0.1,0.3,0.1,0.6,0.2,1c0.3,1.7,0.7,3.4,1,5
		c0,0.2,0.1,0.4,0.1,0.6c2,10.2,4.1,20.4,6.1,30.6c0.1,0.5,0.2,1,0.3,1.5c1.2,5.9,2.4,11.9,3.5,17.8c0.1,0.6,0.3,1.3,0.4,1.9
		c0.5,2.3,0.9,4.6,1.4,6.9c0.2,1.2,0.5,2.4,0.7,3.6c1.5,7.4,2.9,14.8,4.4,22.2c0.1,0.3,0.1,0.6,0.2,0.9c0.4,2.1,0.8,4.2,1.2,6.3
		c0.1,0.7,0.3,1.4,0.4,2.1c-0.2,0-0.3,0.1-0.5,0.1c-0.1-0.5-0.3-1-0.4-1.6c-0.1-0.5-0.2-1.1-0.3-1.6c-0.2-0.8-0.3-1.5-0.5-2.3
		c-0.1-0.3-0.1-0.6-0.2-0.9c0,0,0,0,0-0.1l0,0c-0.1-0.7-0.3-1.4-0.4-2.1c-0.1-0.3-0.1-0.6-0.2-0.9c-1.4-7.1-2.8-14.3-4.2-21.4
		c-0.1-0.7-0.3-1.4-0.4-2.2c-0.6-3-1.2-6.1-1.8-9.1c-0.1-0.6-0.2-1.1-0.3-1.7c0-0.2-0.1-0.3-0.1-0.5c-1.2-5.9-2.4-11.8-3.5-17.7
		c-0.1-0.5-0.2-1-0.3-1.5c-0.7-3.6-1.5-7.2-2.2-10.9c-1.3-6.4-2.6-12.7-3.8-19.1c0-0.1,0-0.2-0.1-0.3c0-0.1,0-0.2,0-0.2
		c0-0.2-0.1-0.5-0.1-0.7c-0.5-2.6-1-5.2-1.5-7.8c0-0.2-0.1-0.4-0.1-0.6c-0.1-0.8-0.3-1.6-0.4-2.4c-0.1-0.4-0.2-0.7-0.3-1.1
		c0-0.1-0.1-0.2-0.1-0.2c0-0.1-0.1-0.2-0.1-0.3c-0.3-0.6-0.7-1.1-1.1-1.5c-0.2-0.2-0.4-0.4-0.6-0.6c-0.1-0.1-0.1-0.1-0.2-0.2
		c-0.2-0.1-0.3-0.2-0.5-0.4c-0.8-0.6-1.6-1.1-2.3-1.7c-0.1,0.1-0.2,0.1-0.3,0.2c0.2,1.4,0.4,2.7,0.6,4.1c0.2,1.2,0.3,2.3,0.5,3.5
		c0,0.3,0.1,0.6,0.1,0.8c1.3,8.4,2.5,16.8,3.8,25.2c0.1,0.6,0.2,1.1,0.3,1.7c0.8,5.5,1.6,10.9,2.4,16.4c-0.2,0-0.4,0.1-0.6,0.1
		c-0.2-1.6-0.5-3.2-0.7-4.7c-0.6-3.9-1.2-7.8-1.7-11.7c-0.1-0.6-0.2-1.2-0.3-1.7c-0.2-1.3-0.4-2.7-0.6-4c0-0.3-0.1-0.7-0.1-1
		c-1-6.6-2-13.3-3-19.9c-0.1-0.4-0.1-0.7-0.2-1.1c-0.2-1.2-0.4-2.5-0.6-3.7c-0.2-1.2-0.4-2.5-0.6-3.7c0-0.3-0.2-0.6-0.4-1
		c-0.2-0.3-0.4-0.6-0.6-0.8c-0.1-0.1-0.2-0.2-0.3-0.3c-0.5-0.4-1-0.7-1.5-1.1c-0.2-0.1-0.4-0.3-0.5-0.4c-1.8-1.4-3.7-2.7-5.5-4
		c-1.2,0-2.2,0.2-2.9,0.7c0.1,1.5,0.1,3,0.2,4.5c0,0.3,0,0.5,0,0.8c0,0,0,0,0.1,0c0.4,0.1,0.7,0.4,1,0.7c0.2,0.2,0.5,0.5,0.7,0.7
		c-0.4,0.4,0,0.6,0.1,0.9c0.1,0.2,0.1,0.3,0.1,0.5c0,0.4-0.1,0.7-0.9,0.9c-0.3-0.6-0.8-1.1-1-1.7l0,0c0.1,1.8,0.2,3.6,0.2,5.4
		c0.1,2.2,0.2,4.4,0.3,6.6c0.3,6.7,0.6,13.4,0.9,20.2c0.1,1.2,0.1,2.4,0.2,3.6c0.2,4,0.4,8.1,0.5,12.1c0.7,15.5,1.4,31,2.1,46.5
		c0,0.6,0.1,1.3,0.1,1.9c0.1,2.3,0.2,4.6,0.3,6.9c0,0.4,0,0.8,0.1,1.2c0,0.4,0,0.8,0.1,1.2c0,0.9,0.1,1.8,0.1,2.7v0.1
		c0,0.7,0.1,1.5,0.1,2.2c0,0.3,0,0.5,0,0.8c0,0.1,0,0.2,0,0.3c0,0.7,0.1,1.3,0.1,2c0,0.5,0,0.9,0.1,1.4c0,0.2,0,0.4,0,0.5
		c0,0.7,0.1,1.4,0.1,2.1c0.3-0.1,0.7-0.1,1-0.2c0.2-0.2,0.4-0.3,0.6-0.5c0.3-0.2,0.6-0.4,1.1-0.5c0.2,0,0.3-0.6,0.5-0.8
		c0.3-0.2,0.6-0.3,1-0.5c-0.1-0.2-0.1-0.5,0-0.8s0.3-0.6,0.8-0.9c0,0,0,0,0.1,0.1c0.2,0.2,0.4,0.4,0.6,0.7c0.2-0.4,0.6-0.7,0.6-0.9
		c-0.1-0.3-0.1-0.6-0.1-0.9c0-0.5,0.1-0.9,0.1-1.3c0-0.3-0.3-0.5-0.4-0.7c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.3,0.2-0.4,0.3
		c-0.1,0.1-0.2,0.1-0.3,0.3c0,0-0.1,0-0.1-0.1c-0.1,0-0.2-0.1-0.2-0.1c-0.7-0.5-1.4-1.1-2.5-1.5c-0.3-0.1-0.6-0.2-1-0.2
		c0.5-0.2,0.8-0.5,1-0.8c0.5-0.5,0.8-1,1.6-1.1c0,0.4-0.1,0.8-0.2,1.2c0.2,0,0.4-0.1,0.6-0.2c0.4-0.2,0.7-0.4,1-0.7
		c0.3-0.3,0.6-0.6,0.9-0.8c1.8,1.8,1.8,1.8,4.5,1.3c0.1,0,0.3-0.1,0.4-0.1c0.3-0.1,0.6-0.3,0.9-0.5c0.1,0,0.1-0.1,0.2-0.1h0.1
		c0.4-0.2,0.9-0.5,1.6-0.1c-0.6,0.4-1.1,0.8-1.7,1.3c-0.1,0.1-0.1,0.1-0.2,0.2c0.6,0.6,1,1.5,1.8,1.8c0.1,0.1,0.3,0.1,0.5,0.1
		c-0.1-1-0.2-2-0.3-3c-0.4-3.7-0.8-7.5-1.3-11.2c-1-9.1-2-18.3-3-27.4c-0.1-1.2-0.3-2.4-0.4-3.6c-1.2-10.8-2.4-21.7-3.6-32.5
		c-0.3-3-0.7-6-1-9.1c0-0.4,0.3-0.8,0.5-1.2c0.2,0.3,0.5,0.6,0.7,1c0.1,0.2,0.1,0.4,0.1,0.6c0.8,7.6,1.7,15.1,2.5,22.7
		c0.1,0.7,0.1,1.3,0.2,2c0.2,1.9,0.4,3.7,0.6,5.6c0.1,0.5,0.1,1,0.2,1.6c0.1,1.2,0.3,2.4,0.4,3.5c0.2,1.9,0.4,3.8,0.6,5.7
		c0.1,1.2,0.3,2.4,0.4,3.5c0.6,5.3,1.2,10.7,1.8,16c0.1,0.5,0.1,1,0.2,1.4c0.8,7,1.6,14,2.3,21c0.1,0.8,0.2,1.5,0.3,2.3
		c0,0.3,0.1,0.7,0.1,1c0.4,0,0.8-0.1,1.2-0.1c0.4,0.2,1,0.5,1.8,0.8c0.2,0.8,0.7,1.7,0.4,2.7c-1.3,0.1-2.2,0.3-2.8,0.6
		c0.1,1.2,0.3,2.5,0.4,3.7c0.2,0.1,0.5,0.2,0.8,0.3c0.1,0,0.3,0.1,0.4,0.1c-0.2,0.4-0.4,0.7-0.7,1.1c-0.1-0.1-0.2-0.2-0.4-0.3
		c0,0.2,0,0.4,0.1,0.6c0.2,1.4,0.3,2.8,0.5,4.2l0,0c0,0.4,0.1,0.8,0.1,1.3c0,0.4,0.1,0.8,0.1,1.2c0.1,1.3,0.3,2.7,0.4,4
		c0,0.3,0.1,0.5,0.1,0.8c0,0.1,0,0.2,0,0.2c0.8-0.2,1.4-0.7,1.9-1.2c0.3-0.4,0.6-0.7,0.7-1.2c0.1-0.2,0.1-0.5,0.2-0.7
		c0.1-0.4,0.1-0.8,0.2-1.2c-0.2,0-0.5,0.1-0.5,0.1c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.2-0.2-0.4-0.3-0.6h0.1c0.5-0.2,0.9-0.3,1.3-0.5
		c1.7-0.7,2.4-2.2,1.7-3.6c-0.1-0.1-0.1-0.2-0.2-0.3c-0.5-0.7-0.5-0.7-0.2-1.4c0.4,0.4,0.9,0.8,1.3,1.2l0,0c0.1,0.1,0.2,0.2,0.3,0.3
		c-0.6-4.2-1.2-8.4-1.7-12.5c-0.1-1.1-0.3-2.1-0.4-3.2c0-0.3-0.1-0.6-0.1-0.9c0-0.1,0-0.2,0-0.2s0,0,0-0.1c0.2,0,0.3-0.1,0.5-0.1
		c0.1,0.3,0.2,0.6,0.2,0.9c0,0.1,0,0.2,0.1,0.2c0.1,0.7,0.2,1.4,0.3,2.1c0.7,4.8,1.3,9.6,2,14.3c0.5-0.5,1-0.9,1.5-1.4
		c0.2,0.3,0.4,0.5,0.6,0.7c0.8,0.7,1.8,1,2.7,0.7c0.8-0.2,1.6-0.8,2-1.7c0-0.1,0.1-0.2,0.1-0.3c-0.1-0.2-0.2-0.4-0.1-0.6
		c0-0.8,0.9-1.5,0.9-2.4c0.6,0.1,1,0.2,1.5,0.3c0.1,0,0.1,0,0.2,0c0.2-0.7,0.4-1.4,0.4-2c0-0.3,0-0.6,0-0.9
		C72.6,300.1,72.6,299.7,72.5,299.4z M34.7,184.4C34.7,184.4,34.7,184.3,34.7,184.4L34.7,184.4C34.8,184.4,34.8,184.4,34.7,184.4z
M41.6,291.2c-0.1,0-0.1,0-0.2,0c0.1-0.1,0.1-0.1,0.2-0.2c0.3-0.3,0.7-0.7,1-1.1C43.1,290.8,43,291,41.6,291.2z M42.2,202.5
		c-0.2-0.3-0.7-0.6-0.7-0.9c-0.3-1.8-0.4-3.6-0.7-5.6c0,0-0.1-0.3,0-0.6c0.1-0.2,0.3-0.5,0.4-0.7c0.2,0.2,0.7,0.4,0.7,0.6
		c0.3,2.2,0.5,4.3,0.7,6.5C42.7,202,42.4,202.2,42.2,202.5z"
      />
      <path
        class="st2"
        d="M259.1,249.7c0.7,0.2,1.4,0.3,2.1,0.2c-0.1-0.1-0.2-0.2-0.3-0.3c-0.8-0.6-1.7-1.3-2.5-1.9l-0.1-0.1
		c-0.5-0.3-0.9-0.7-1.4-1c0.2,0.6,0.3,1.2,0.5,1.8c0,0.2,0.1,0.3,0.1,0.5c0.1,0.1,0.2,0.1,0.2,0.2l0,0c0.4,0.1,0.7,0.3,1,0.4
		C258.9,249.6,259,249.6,259.1,249.7z"
      />
      <path
        class="st2"
        d="M162.4,275.9c-0.1,0-0.2,0.1-0.3,0.1c-1.5,0.7-2.2,1.7-2.3,2.9c0.2,0.3,0.4,0.6,0.6,0.9
		c0.2,0.4,0.5,0.7,0.7,1.1c0.5,0.8,1,1.6,1.6,2.4c0,0,0,0.1,0.1,0.1c0.5,0.7,0.9,1.4,1.4,2.1c0.5,0.8,1,1.6,1.6,2.4
		c0.1,0.2,0.2,0.4,0.4,0.5c0.1,0.1,0.2,0.3,0.3,0.4c0.3,0.4,0.5,0.8,0.8,1.1c0.1-0.3,0.1-0.7,0.2-1c0-0.1,0-0.1,0-0.2h0.1
		c0.9,0,1.7,0,2.6-0.2c0,0,0,0,0.1,0c2.4-0.5,4.1-2.3,4-4.4c-0.1-1.9-1.9-3.4-4.4-3.5c-0.6,0-1.2,0.1-1.8,0.1c0.2-1,0.6-2.1,0.5-3
		c-0.1-0.6-1-1.2-1.7-1.6C165.4,275.4,164,275.2,162.4,275.9z"
      />
      <path
        class="st2"
        d="M241.1,219.7c-0.8-0.6-1.7-1.1-2.5-1.7c-1.8-1.2-3.6-2.3-5.3-3.5c-0.1,0.2-0.2,0.3-0.3,0.5
		c1.8,1.2,3.6,2.5,5.4,3.7c0.8,0.5,1.6,1,2.4,1.5C240.9,220,241,219.8,241.1,219.7z"
      />
      <path
        class="st2"
        d="M250.8,215.1c0.1,0,0.1,0.1,0.2,0.1c0.2,0,0.6-0.1,1-0.1c-0.2-0.2-0.5-0.4-0.7-0.5c-1.3-1-2.7-1.9-4.1-2.6
		c-1.8-1-3.4-1.6-4-1.4c1.1,0.7,2.1,1.3,3.2,2C247.9,213.3,249.4,214.2,250.8,215.1z"
      />
      <path
        class="st2"
        d="M271,202.6c-1.3-0.7-2.5-1.3-3.8-2c-0.1,0.1-0.1,0.2-0.2,0.3c1.1,0.6,2.1,1.2,3.2,1.8c1,0.5,1.9,1.1,2.9,1.6
		c0.6,0.3,1.2,0.7,1.9,1c0.1-0.2,0.2-0.3,0.3-0.5c-0.8-0.4-1.5-0.8-2.3-1.2C272.3,203.3,271.6,202.9,271,202.6z"
      />
      <path
        class="st2"
        d="M149.4,212.4c0.7,0.8,1.4,1.5,2.1,2.3c0.2,0.2,0.4,0.5,0.6,0.7l0.1,0.1c3.4,3.7,6.8,7.4,10.2,11.1
		c0.3,0.3,0.6,0.7,0.9,1c0.1,0.1,0.2,0.2,0.2,0.3c0.1,0.1,0.2,0.2,0.3,0.3c0.2,0.3,0.5,0.5,1.2,1c0-0.6,0-1.2-0.1-1.9
		c-0.7-17.9-1.4-35.5-2.1-53c0-0.6,0-1.1-0.1-1.7c-0.1-2.1-0.2-4.2-0.2-6.3c-0.2,0-0.5,0-0.7,0c0,0.6-0.2,1.3-0.1,1.9
		c0,1.3,0.1,2.6,0.1,3.9c0,0.8,0.1,1.7,0.1,2.5c0.3,8.7,0.6,17.3,1,25.9c0.3,7.2,0.6,14.4,0.8,21.6c0,0.6-0.5,1.3-0.7,1.9
		c-0.6-0.3-1.3-0.5-1.8-1c-2.6-2.7-5.1-5.5-7.6-8.2c-0.4-0.4-0.7-0.8-1.1-1.2c-0.6-0.6-1.1-1.2-1.7-1.9c-0.5-0.6-1-1.1-1.6-1.7
		c-0.1,0.1-0.3,0.1-0.4,0.2c0.1,0.5,0.2,1.1,0.3,1.6C149.2,212.1,149.3,212.3,149.4,212.4z"
      />
      <path
        class="st2"
        d="M152.9,212.2c2.8,3.1,5.7,6.2,8.5,9.2c0.3,0.3,0.6,0.5,1.1,1c-0.2-5.5-0.4-10.7-0.7-15.9c0-0.5-0.5-1-0.9-1.4
		c-0.5-0.5-1.1-1-1.6-1.6c-0.2-0.2-0.5-0.5-0.7-0.7c-3.6-3.5-7.3-7-10.9-10.5c-0.1-0.1-0.1-0.1-0.2-0.2c-1-0.9-2-1.9-2.9-2.8
		c-2.7-2.6-5.4-5.2-8.3-8c-0.1,0.4-0.2,0.5-0.2,0.6s0,0.1,0,0.2c0,1.3,0,2.6,0,3.9c0,2.4,0,4.8,0.1,7.2c0,0.5,0.4,1.1,0.7,1.5
		c5.1,5.6,10.3,11.2,15.4,16.8C152.5,211.8,152.7,212,152.9,212.2z"
      />
      <path
        class="st2"
        d="M303.5,233.1c-0.4-0.6-0.4-1.1-0.3-1.5c0.1-0.2,0.2-0.4,0.3-0.7c-1.4,0.4-3,0.6-4.5,0.6c-0.4,0-0.8,0-1.1,0
		c-0.2,0-0.4,0-0.6-0.1c-0.1,0-0.3,0-0.4,0c0.1,0.1,0.1,0.2,0.2,0.3c0.3,0.4,0.5,0.8,0.8,1.2c-0.1,0.2-0.4,0.5-0.4,0.8
		c0,0,0,0.1,0.1,0.1c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0.1,0.3,0.2,0.5,0.2c0.6-1.2,1.3-2.2,3.1-1.9c-0.4,0.3-0.9,0.5-1.1,0.8
		c-0.2,0.5,0.3,1.1,1.1,1.5c0.3-0.3,0.7-0.6,1-0.9c0.2,0.1,0.5,0.2,0.8,0.3c0.1-0.2,0.3-0.2,0.3-0.3s0-0.1,0-0.2
		C303.6,233.5,303.6,233.3,303.5,233.1z"
      />
      <path
        class="st2"
        d="M214.4,222.1c-0.1,0.1-0.2,0.2-0.3,0.4c0.1,0.1,0.2,0.2,0.3,0.3c2.1,2.3,6.7,5.6,7.7,5.2
		c-2.5-1.9-4.9-3.7-7.3-5.6C214.7,222.3,214.6,222.2,214.4,222.1z"
      />
      <path
        class="st2"
        d="M15.1,285.6c0.1-4.3,0.2-8.6,0.3-12.8c0-0.5-0.4-1.2-0.9-1.4c-3.5-2.2-7.1-4.3-10.7-6.4
		c-0.3-0.2-0.7-0.4-1-0.6c-0.2-0.2-0.3-0.6-0.4-1c0.3,0,0.8-0.2,1-0.1c1.2,0.6,2.3,1.3,3.4,2c2.8,1.7,5.5,3.3,8.8,5.2
		c0-3.1,0-6,0-8.8c0.2,0,0.4,0,0.6,0c0,0.4,0.1,0.9,0.1,1.3c-0.1,2.2-0.1,4.3-0.2,6.5c-0.1,0.9,0.2,1.4,1,1.9
		c4,2.3,7.9,4.7,12.1,7.2c0-0.8,0-1.3,0-1.9c0-0.5,0-1.1,0-1.6c0-0.3,0-0.7,0-1c-0.4-17.7-0.8-35.4-1.1-53c0-0.6,0-1.2,0-1.9
		c0-1.4-0.1-2.8-0.1-4.2c0-1-0.4-1.6-1.2-2.1c-6.1-3.8-12.1-7.6-18.1-11.4c-0.3,0.1-0.5,0.3-0.8,0.5c0,1-0.1,2.1-0.1,3.2
		c0,0.1,0,0.1,0,0.2c-0.5,0-1.1,0-1.6,0c-0.6,0-1.3,0-1.9,0c0-0.4,0.1-0.8,0-1.2c-0.1-0.5-0.7-0.7-1.2-0.6c-0.3,0.1-0.6,0.2-0.9,0.3
		l0,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0.1c-0.1,0.1-0.2,0.2-0.3,0.3s-0.1,0.1-0.1,0.2c0,0.1,0,0.1-0.1,0.2c0,0.3,0.2,0.6,0.5,0.8
		c0.6,0.4,1.2,0.6,1.9,0.4c0.1,0.8,0.5,1.2,1.2,1.4c0.3,0.1,0.7,0.1,1.1,0c-0.1,0.4-0.2,0.7-0.3,1c-0.3,0.6-1,0.7-2.3,0.4
		c-0.2,0.2-0.3,0.3-0.4,0.4c-0.2-0.4-0.6-0.7-1-1c-0.8-0.2-1.5-0.5-2-0.9v2.5v2.1v0.7v3v82.1c0.5,0.3,1.1,0.6,2,0.2
		c1-0.4,1.2-1.2,1.2-2c0.7-0.3,1.3-0.6,2-1c0.4-0.2,0.8-0.4,1.3-0.4c0.1,0,0.3,0,0.4,0.1c0.1,0,0.1,0,0.2,0c0.3,0,0.8-0.2,0.8-0.4
		c0.2-0.9,1.1-1,1.8-1.2c0.8-0.3,1.6-0.6,2.5-0.7c0.5-0.1,0.8-0.3,1.2-0.6c0.5-0.4,1-0.6,1.5-0.4c0-1.2,0.1-2.4,0.1-3.6
		C15,286.8,15.1,286.2,15.1,285.6z"
      />
      <path
        class="st2"
        d="M240.3,213.6c2.3,2,5.7,3.9,6.5,3.6c-2.1-1.3-4.1-2.6-6.2-3.9c-0.3-0.2-0.7-0.4-1.1-0.7
		c-0.2-0.1-0.5-0.3-0.7-0.4c0.2,0.2,0.4,0.5,0.7,0.7C239.8,213.2,240.1,213.4,240.3,213.6z"
      />
      <path
        class="st2"
        d="M248.4,139.7c-0.3-0.1-0.4-0.2-0.6-0.3c-0.1,0-0.1,0-0.2,0c-3.6,0.7-7,1.4-9.9,2c-1.4,0.3-2.7,0.5-3.9,0.8
		c0.3,0.4,0.4,0.9,0.5,1.3v0.1c0.1,0.3,0.2,0.5,0.4,0.8c0.2,0,0.4-0.1,0.6-0.1c4.2-0.9,8.5-1.8,12.7-2.7c0.2-0.6,1.1-0.1,1.4-0.7
		c-0.5-0.1-1-0.2-1.6-0.3c0.1-0.1,0.2-0.2,0.2-0.4C248.2,140,248.3,139.8,248.4,139.7z"
      />
      <path
        class="st2"
        d="M208.4,229.8c-0.7-0.6-1.4-1.2-2.1-1.8c-0.3-0.2-0.5-0.4-0.8-0.7c-0.4-0.3-0.8-0.7-1.2-1
		c-0.1,0.2-0.2,0.3-0.4,0.5c1.2,1,2.3,2.1,3.5,3.1l0,0c0.2,0.2,0.4,0.4,0.7,0.6c0,0,0,0,0.1,0.1c0.8,0.7,1.6,1.5,2.4,2.2
		c0.2,0.2,0.6,0.1,0.9,0.1c0-0.1,0.1-0.2,0.1-0.3c-0.9-0.8-1.8-1.5-2.7-2.3C208.6,230,208.5,229.9,208.4,229.8z"
      />
      <path
        class="st2"
        d="M136.3,179.6C136.3,179.6,136.3,179.7,136.3,179.6c4.3,4.1,8.5,8.2,12.8,12.3c0.3,0.3,0.6,0.6,0.9,0.8
		c3.3,3.1,6.6,6.3,9.9,9.5c0.6,0.6,1.2,1.2,1.9,1.8c0-0.2-0.4-0.7-1.1-1.4c-0.2-0.3-0.5-0.6-0.8-0.9c-0.3-0.3-0.5-0.6-0.8-0.9
		c-2.2-2.3-5.4-5.6-8.8-8.9c-0.3-0.3-0.6-0.6-0.9-0.9c-5.3-5.2-10.8-10.3-12.6-11.7c-0.1-0.1-0.1-0.1-0.2-0.2
		c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0.1-0.2,0.2-0.3,0.3C136,179.4,136.2,179.5,136.3,179.6z"
      />
      <path
        class="st2"
        d="M236.3,137.4L236.3,137.4c-0.1,0-0.1,0-0.2,0C236.2,137.5,236.2,137.4,236.3,137.4z"
      />
      <path
        class="st2"
        d="M233.7,138c0.6-0.1,1.3-0.3,1.9-0.4l0,0c-0.9-0.1-0.9-0.2-1.9,0.2C233.7,137.8,233.7,137.9,233.7,138z"
      />
      <path
        class="st2"
        d="M236.9,137.1c-0.2,0-0.4,0.2-0.6,0.3c0.3-0.1,0.6-0.1,1-0.2C237.2,137.2,237.1,137.2,236.9,137.1z"
      />
      <path
        class="st2"
        d="M27.8,180.3c0.1-0.2,0.1-0.4,0.1-0.7c0-0.1,0-0.3,0.1-0.4c-0.1,0-0.1,0-0.2-0.1c0,0.1,0,0.2,0,0.3
		C27.7,179.7,27.8,180,27.8,180.3z"
      />
      <path
        class="st2"
        d="M103.7,301.5c-0.7,0.4-1.2,0.6-1.7,0.9c-0.9,0.7-1.7,1.4-2.6,2.1c-0.6,0.5-0.4,1.2,0.3,1.3
		c0.9,0.1,1.4,0.6,2,1c0.5,0.4,1,0.6,1.5,0.7c0.7,0.1,1.4,0,2.2-0.2c0.3-0.1,0.6-0.2,1-0.4c0,0.6,0,1.1,0.1,1.6
		c0.3,1.4,1.8,2.3,3.4,2.2c0.3,0,0.7,0,1-0.1c1.8-0.4,3-1.8,3-3.4c0-0.1,0-0.2,0-0.4c-0.3-1.8-2.1-2.8-4.2-2.4c-0.1,0-0.1,0-0.2,0.1
		c-0.4,0.1-0.7,0.2-1.1,0.3c-0.2,0.1-0.4,0.2-0.7,0.2c0.1-0.2,0.1-0.3,0.1-0.5c0.2-1.1-0.4-2-1.2-2.7c-0.1-0.1-0.3-0.1-0.4-0.2
		c-0.5-0.1-0.9-0.2-1.5-0.2c0.2-0.4,0.3-0.7,0.6-1.2c0.4,0.5,0.7,0.9,1.1,1.2c0.1,0.1,0.3,0.1,0.4,0.2c0.4,0,0.7,0.1,1.1,0.1
		c1.2,0.1,2.2-0.3,2.9-1c0.1-0.1,0.3-0.3,0.4-0.4c0.7-1,0.7-2-0.1-2.9c-0.1-0.1-0.2-0.2-0.4-0.3c-0.8-0.6-1.9-0.8-3.1-0.5
		c-0.5,0.1-0.9,0.3-1.3,0.4c-0.4,0.6-0.7,1.2-1,1.6c-0.5-0.1-0.9-0.3-1.3-0.4c-0.2,0.5-0.6,1-0.7,1.6
		C103.3,300.5,103.6,301,103.7,301.5z"
      />
      <path
        class="st2"
        d="M81.1,319.8c-0.1-0.4-0.2-0.7-0.2-1.1c-0.2,0-0.3,0.1-0.5,0.2c-0.4,0.2-0.6,0.5-0.8,0.7
		c-0.7,0.8-0.4,1.7,0.7,2.4c0.1,0,0.1,0.1,0.2,0.2c-1.3,1.2-1.3,1.2-0.5,2.5c0.3,0.5,0.6,1,0.8,1.4c0.8,0.1,1.4,0.1,1.8,0.1
		C82,324.1,81.6,322,81.1,319.8z"
      />
      <path
        class="st2"
        d="M86.9,321.3c0-0.3-0.1-0.6-0.1-0.9c-0.6-0.1-1-0.2-1.4-0.2c-0.7,0-1.5,0-2.2,0c-0.2-0.3-0.4-0.6-0.6-0.9
		l-0.1-0.1c0,0-0.1-0.1-0.2-0.1c0,0.1,0.1,0.2,0.1,0.4c0.5,2.2,1,4.4,1.5,6.6c0.2-0.2,0.5-0.4,0.8-0.8c0.6,0,1.3,0.1,2,0.1
		c0-0.1,0-0.2,0-0.3c0-0.2,0-0.4,0-0.5c0-0.2-0.1-0.6,0-0.6c0.7-0.3,0.5-0.8,0.4-1.2C87,322.3,86.9,321.8,86.9,321.3z"
      />
      <path
        class="st2"
        d="M167.3,275.1c0.3,1.8,2.5,2.8,4.6,2.3c2.2-0.5,3.6-2.3,3.2-4.1c0-0.2-0.1-0.3-0.2-0.5
		c-0.1-0.2-0.2-0.4-0.3-0.5c-0.1-0.2-0.3-0.4-0.5-0.5c-0.6-0.5-1.3-0.8-2.1-0.9c-0.5-0.1-1.1,0-1.6,0.1
		C168,271.7,166.9,273.1,167.3,275.1z"
      />
      <path
        class="st2"
        d="M179.7,278.4c-0.6-1.2-2.2-1.9-3.9-1.6c-2,0.4-3.4,2.1-3.1,3.8c0.3,1.5,2.4,2.6,4.3,2.2
		c1.5-0.3,2.6-1.3,2.9-2.5c0.1-0.4,0.1-0.8,0.1-1.2C179.9,278.9,179.9,278.6,179.7,278.4z"
      />
      <path
        class="st2"
        d="M102.1,308.4c-0.1-0.1-0.1-0.1-0.2-0.1c-0.2-0.1-0.4-0.3-0.6-0.4c-0.7-0.3-1.3-0.3-2-0.1c-0.1,0-0.1,0-0.2,0.1
		c-0.7,0.3-1.3,0.9-1.8,1.8c-0.4,0.1-0.9,0.1-1.2,0.3c-0.4,0.2-0.8,0.5-1.1,0.7c-0.4-0.3-0.7-0.6-1.1-0.7c-0.4-0.2-0.9-0.2-1.3,0
		c-0.4,0.1-0.8,0.4-1.1,0.8c-0.1,0.1-0.1,0.2-0.1,0.2c-0.3,0.6,0,1.3,0.7,1.6c0.3,0.1,0.6,0.2,0.9,0.2c0.2,0,0.3,0,0.5-0.1
		c0.1,0,0.3-0.1,0.4-0.2c0.1,0,0.1-0.1,0.2-0.1c0.1-0.1,0.3-0.1,0.4-0.1c0.3,0.4,0.6,0.7,0.9,1c0.8-0.8,1.5-1.5,2.2-2.2
		c0.4,0.2,0.8,0.4,1.2,0.5c1.2,0.4,2.1,0.3,2.8-0.3c0.2-0.2,0.4-0.4,0.6-0.6c0.1-0.1,0.1-0.2,0.2-0.3c0,0,0-0.1,0.1-0.1
		c0.1-0.2,0.1-0.4,0.1-0.6c0-0.1,0-0.2,0-0.3c0-0.1,0-0.3-0.1-0.4C102.5,308.9,102.3,308.6,102.1,308.4z"
      />
      <path
        class="st2"
        d="M172.2,266.4c0.5,0.1,1,0.1,1.5,0c1.3-0.3,2.3-1.2,2.6-2.3c0.1-0.3,0.1-0.7,0-1.1c-0.2-0.9-1.1-1.6-2.2-1.8
		c-0.5-0.1-1.1-0.1-1.7,0c-1.4,0.3-2.3,1.3-2.5,2.3c-0.1,0.3-0.1,0.6,0,0.9C170.1,265.5,171.1,266.2,172.2,266.4z"
      />
      <path
        class="st2"
        d="M148,337.3c-1.4,0.2-2.4,1.1-2.6,2.1h5.9c0-0.1,0-0.2,0-0.3C151.1,337.9,149.6,337,148,337.3z"
      />
      <path
        class="st2"
        d="M246.2,238.7c-1-0.7-2-1.5-2.9-2.2c-0.5,0.2-0.9,0.4-1.3,0.6c1,0.8,2,1.5,3,2.3
		C245.4,239.3,245.8,239,246.2,238.7z"
      />
      <path
        class="st2"
        d="M245.8,236.6c-0.2-0.2-0.5-0.4-0.8-0.4c0.5,0.4,1.1,0.8,1.6,1.2C246.5,237,246,236.9,245.8,236.6z"
      />
      <path
        class="st2"
        d="M249.8,239.1c0.1,0.3,0.1,0.5,0.1,0.7c1.1-0.2,1.8-0.4,2.2-0.7s0.5-0.8,0.4-1.6c-0.6-0.1-1.2-0.1-1.8-0.2
		c-0.1,0-0.1,0-0.2,0c-0.3-0.1-0.7-0.1-1-0.1c-0.2,0-0.5,0-0.7,0c-0.6,0.1-1.2,0.3-1.8,0.7c0.5,0.4,1,0.7,1.4,1.1
		c0.1,0.1,0.3,0.2,0.4,0.3c0.1,0.1,0.2,0.1,0.3,0.2C249.4,239.3,249.6,239.2,249.8,239.1z"
      />
      <path
        class="st2"
        d="M232.8,294.9c0.6-1.2-0.1-2.4-1.5-2.8c-0.2,0-0.3-0.1-0.5-0.1c-0.6-0.1-1.1-0.1-1.5-0.6
		c-0.1-0.2-0.4-0.4-0.7-0.4s-0.7,0-1,0.2c-0.2,0.1-0.2,0.5-0.2,0.7l0,0c0.1,0.3,0.4,0.6,0.6,0.9c-0.2,0.4-0.4,0.8-0.5,1.2
		c-0.3,1.3,0.5,2.3,2,2.6C230.9,296.8,232.3,296.1,232.8,294.9z"
      />
      <path
        class="st2"
        d="M186.2,256.4c1.1,0.4,2.6,0,3.4-0.8c0.8-0.8,1-2,0.4-2.9c-0.3-0.4-0.7-0.7-0.9-1c-1.7-0.3-2.9,0.2-4,0.9
		c-0.1,0.4-0.3,0.8-0.4,1.2C184.3,255,184.9,256,186.2,256.4z"
      />
      <path
        class="st2"
        d="M194.3,257.8c-0.1-0.4-0.7-0.8-1.2-1c-0.9-0.3-1.8-0.4-2.7-0.6c-0.8-0.1-1.5,0.1-2,0.7
		c-0.6,0.6-0.5,1.3-0.2,1.9c0.3,0.5,1,0.7,1.9,0.5c0.4-0.1,0.8-0.2,1.3-0.3c0.3,0.4,0.5,0.8,0.8,1.2c0.4,0,0.8-0.1,1.1-0.1
		s0.7,0.2,1.1,0.4c0.4-0.5,0.8-1,1.2-1.6C195,258.7,194.5,258.4,194.3,257.8z"
      />
      <path
        class="st2"
        d="M225.9,294.5c-0.2-0.1-0.5-0.3-0.7-0.3c-0.5-0.1-1-0.2-1.5-0.3c0.2-0.7,0.3-1.2,0-1.7
		c-0.2-0.4-0.5-0.8-1.1-1.1c-0.4,0.4-0.6,0.8-0.6,1.1c-0.1,0.7,0.5,1.3,0.9,1.9c-0.4,0.4-0.8,0.7-1.1,1.1c0.3,0.9,0.9,1.5,1.5,2
		c0.5,0.4,1.1,0.8,1.6,1.2c0,0,0.1,0,0.1,0.1c0.8,0.1,1.3-0.3,1.6-0.9c0.1-0.1,0.1-0.2,0.2-0.4C227.3,296.2,226.9,295.1,225.9,294.5
		z"
      />
      <path
        class="st2"
        d="M91.4,307.2c0,0.3,0.2,0.6,0.3,0.9c0.3,0.5,0.9,0.8,1.6,0.9h0.1c0.3,0,0.7,0,1.1-0.1c1-0.2,1.8-0.8,2.1-1.6
		c0.2-0.4,0.2-0.7,0.2-1.1c-0.2-1.2-1.6-2-3.1-1.7C92.2,304.8,91.2,306,91.4,307.2z"
      />
      <path
        class="st2"
        d="M188.1,263.8c-0.4-1.1-1.5-1.6-2.8-1.5c-1,0.1-2,0.9-2.3,1.7c-0.4,1,0.1,2,1.1,2.5c1.1,0.5,2.2,0.3,3.2-0.5
		c0.5-0.4,1-0.8,1.7-1.3C188,264.8,188.2,264.2,188.1,263.8z"
      />
      <path
        class="st2"
        d="M90.1,299.9c0.3,0.3,0.6,0.5,1,0.6c0.5,0.2,1.2,0.2,1.8,0c0.5-0.1,1-0.4,1.3-0.7c0,0,0.1,0,0.1-0.1
		c0.7-0.8,0.8-2,0.2-2.7l0,0c-0.6-0.8-1.9-1-3.1-0.6c-0.5,0.2-1,0.4-1.4,0.7c-0.1,0.4-0.3,0.8-0.4,1.1
		C89.5,298.8,89.7,299.4,90.1,299.9z"
      />
      <path
        class="st2"
        d="M1.2,311c0.1-0.2,0.2-0.3,0.3-0.5c0,0,0,0,0-0.1c0.1-0.4,0.2-0.7,0.1-1.1c0-0.1-0.1-0.3-0.1-0.4
		c-0.3-0.6-0.8-1-1.4-1.1v1.1v1.5v0.8v0.7c0.1-0.1,0.3-0.1,0.4-0.2C0.7,311.5,1,311.3,1.2,311z"
      />
      <path
        class="st2"
        d="M90.7,314.2c-0.2-0.2-0.4-0.4-0.7-0.4c-0.6,0-1.2,0.2-1.9,0.3c-0.6-1.5-1.3-1.9-2.8-1.6
		c-0.3,0.1-0.6,0.2-1,0.4c0.4,0.3,0.6,0.5,0.9,0.7c-0.5,0.5-1,1-1.5,1.5c-0.1,0.1-0.1,0.1-0.2,0.2c0.5,0.4,0.8,0.7,1.2,0.9
		c0.8,0.3,1.6,0.1,2.9-0.8c1.3,1,1.8,1.1,2.6,0.6C90.9,315.5,91.1,314.8,90.7,314.2z"
      />
      <path
        class="st2"
        d="M273.6,247.1c0-0.1,0.1-0.3,0.1-0.4c0-0.2,0-0.3,0-0.5c-0.2-1.2-1.6-2-3-1.7c-0.1,0-0.1,0-0.1,0
		c-1.2,0.3-2.1,1.3-2,2.4c0,0.1,0,0.1,0,0.2c0.1,0.9,1,1.6,2,1.7c0.3,0,0.7,0,1,0c0.2,0,0.5-0.1,0.7-0.2
		C272.9,248.2,273.4,247.7,273.6,247.1z"
      />
      <path
        class="st2"
        d="M4.5,310.9c-0.4,0.1-0.8,0.3-1.1,0.5c-0.1,0.1-0.2,0.2-0.3,0.3c-0.3,0.3-0.6,0.7-0.7,1.2
		c-0.1,0.2-0.1,0.5,0,0.7c0,0.1,0,0.1,0.1,0.2c0.2,0.8,1,1.3,2,1.4c0.3,0,0.6,0,0.9,0c0.5-0.1,0.9-0.3,1.2-0.5
		c0.1-0.1,0.3-0.2,0.4-0.3c0.4-0.4,0.7-1,0.6-1.5c0-0.1,0-0.2,0-0.3C7.2,311.3,5.9,310.6,4.5,310.9z"
      />
      <path
        class="st2"
        d="M90,297C89.9,297,89.9,297.1,90,297C90,297.1,90,297.1,90,297L90,297L90,297z"
      />
      <path
        class="st2"
        d="M88.7,295.9c-0.1-0.4-0.1-0.9-0.3-1.3c-0.4-1.1-2.4-1.5-3.5-0.7c-0.4,0.3-0.8,0.9-0.8,1.5c0,0.1,0,0.2,0,0.2
		c0,0.1,0,0.3,0.1,0.4c0.1,0.3,0.2,0.5,0.4,0.6c0.1,0.1,0.3,0.2,0.4,0.3c0.3,0.1,0.6,0.3,0.9,0.3c0.2,0,0.4,0,0.6,0l0,0
		c0.3,0,0.6,0,0.8,0.1c1,0.4,1.8,0.2,2.7-0.3c0.1-0.2,0.2-0.4,0.3-0.7C89.6,296.2,89.1,296,88.7,295.9z"
      />
      <path
        class="st2"
        d="M249.4,264.9c0.2-0.3,0.4-0.6,0.6-0.9c0.4-0.1,0.7-0.1,0.9-0.1c0-0.1,0-0.1,0-0.2c-0.4-0.1-0.9-0.2-1.3-0.2
		l0.1-0.1c0.3,0,0.5,0,0.8-0.1c0-0.1,0-0.2,0-0.3c-1.3,0-2.6-0.1-3.9-0.1c-0.2,0-0.4,0.1-0.5,0.1c-1.2,0.3-1.7,0.6-1.9,1.2
		c-0.1,0.4,0,0.8,0.1,1.5c0.5,0,0.9,0,1.4,0c0.1,0,0.1,0,0.2,0c0,0.2,0.1,0.4,0.1,0.7c0.8-0.2,1.4-0.5,2.1-0.5
		C248.8,265.6,249.1,265.4,249.4,264.9z"
      />
      <path
        class="st2"
        d="M263.4,252c0.2,0.4,0.6,0.7,0.8,1.1c0.4,0,0.7-0.1,1-0.1h0.1c-0.7-0.5-1.4-1.1-2.1-1.6
		C263.2,251.6,263.3,251.8,263.4,252z"
      />
      <path
        class="st2"
        d="M207.3,269c-0.5-0.7-0.1-1.2,0.2-1.8c0.5-0.9,0.4-1.1-0.8-1.7c-0.5,0.3-0.9,0.8-1.4,0.9
		c-0.9,0.1-1.4,0.6-2,1.2c0.2,0.5,0.3,0.9,0.5,1.3s0.4,0.8,0.7,1.2c0.2,0.3,0.6,0.5,0.9,0.5C206.1,270.6,207.6,269.4,207.3,269z"
      />
      <path
        class="st2"
        d="M108,311.7c-0.5-0.6-1.4-0.9-2.3-0.7c-0.1,0-0.3,0.1-0.4,0.1c-1,0.4-1.6,1.4-1.4,2.3c0.3,1.1,1.5,1.6,2.8,1.3
		c1.2-0.3,1.9-1.3,1.7-2.3C108.2,312.2,108.1,311.9,108,311.7z"
      />
      <path
        class="st2"
        d="M251.2,281.8c0.1-0.1,0.2-0.1,0.3-0.2c0.6-0.5,0.8-1.2,0.6-1.8c-0.1-0.4-0.4-0.7-0.9-0.9
		c-1.6-0.5-3.7,0.8-3.6,2.3c0,0.5,0.3,1-0.1,1.7l0,0c0.9-0.2,1.6-0.3,2.2-0.5C250.2,282.3,250.8,282.1,251.2,281.8z"
      />
      <path
        class="st2"
        d="M10.3,306c-0.4-0.2-1-0.3-1.5-0.2c-1.3,0.2-2.1,1.3-1.9,2.4c0.2,1,1.3,1.6,2.5,1.3c0.6-0.1,1.2-0.4,1.5-0.8
		s0.5-0.9,0.4-1.4C11.3,306.8,10.9,306.3,10.3,306z"
      />
      <path
        class="st2"
        d="M278.3,268.5c0.2,0,0.5,0,0.7,0c-0.1-1-0.4-1.7-1-2.1c-0.2-0.2-0.4-0.3-0.7-0.4c-0.1,0-0.3-0.1-0.4-0.1
		c-0.3-0.1-0.6-0.1-1-0.1c-1.4,0.1-2.4,0.8-2.7,1.8c-0.1,0.3-0.2,0.6-0.2,0.9c1.4,0,2.7-0.1,4.2-0.1
		C277.5,268.5,277.9,268.5,278.3,268.5z"
      />
      <path
        class="st2"
        d="M3.4,306.5c0.1,0,0.1,0,0.2,0c1.2-0.3,2-1.3,1.7-2.3l0,0c-0.3-1-1.4-1.6-2.6-1.3c-0.8,0.2-1.4,0.7-1.7,1.4
		c-0.1,0.3-0.2,0.7-0.1,1v0.1C1.2,306.2,2.3,306.7,3.4,306.5z"
      />
      <path
        class="st2"
        d="M200.3,264.3c0,0.1-0.1,0.2,0,0.3c0.1,0.4,0.2,0.8,0.4,1.1c0.2,0.4,0.6,0.8,1.3,0.5c0.6-0.2,0.6-0.6,0.5-1.1
		c0-0.4-0.2-0.9,0-1.2c1.3-1.5,0.5-2.6-0.5-3.7C200.6,261.5,199.4,262.6,200.3,264.3z"
      />
      <path
        class="st2"
        d="M13.2,300.9c-0.6,0.1-1.2,0.3-1.4,0.7c-0.1,0.1-0.1,0.3-0.2,0.4c-0.1,0.7-0.6,1-1,1.4
		c-0.1,0.1-0.1,0.1-0.2,0.2c0.3,0.5,0.4,0.7,0.6,0.9c0.2,0.2,0.5,0.2,1,0.3c0.2-0.1,0.3-0.3,0.5-0.4c0.1-0.1,0.2-0.2,0.4-0.3
		c0.1,0.3,0.1,0.4,0.2,0.5c0.1-0.1,0.3-0.2,0.4-0.3c0.1-0.1,0.2-0.1,0.2-0.2c0.3-0.2,0.6-0.4,0.9-0.6l0,0c0-0.5,0-0.9,0-1.4
		c0-0.1,0-0.2,0-0.2s0,0,0-0.1c0-0.2,0-0.4,0-0.6C14.3,301,13.8,300.8,13.2,300.9z"
      />
      <path
        class="st2"
        d="M164.9,303.8c-1.2,0.3-1.9,1.4-1.6,2.4c0.3,0.9,1.4,1.4,2.5,1.1c1.2-0.3,2-1.4,1.7-2.3
		C167.2,304.1,166,303.5,164.9,303.8z"
      />
      <path
        class="st2"
        d="M295.5,254.4h0.1c0.5-0.1,1-0.4,1.3-0.7c0.4-0.4,0.6-0.9,0.5-1.5c-0.2-0.9-1.2-1.5-2.4-1.3
		c-0.2,0-0.3,0.1-0.5,0.1c-0.8,0.3-1.4,1.1-1.3,2c0,0.2,0.1,0.3,0.1,0.4C293.7,254.1,294.6,254.6,295.5,254.4z"
      />
      <path
        class="st2"
        d="M257.1,250.3c-0.4-0.3-0.7-0.6-1.1-0.8c-0.3-0.2-0.6-0.5-0.9-0.7c-0.2,0.2-0.5,0.4-0.7,0.6
		c-0.2,0.2-0.5,0.4-0.7,0.6c-0.5,0.5-0.6,1.1-0.4,1.7l0,0c0.1,0.3,0.3,0.5,0.6,0.7c0.2,0.1,0.4,0.2,0.6,0.3c0.3,0.1,0.5,0.1,0.8,0.1
		c0.2,0,0.5-0.1,0.7-0.2c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.3-0.2,0.4-0.3l0.1-0.1c0.2-0.3,0.4-0.6,0.6-0.9c0-0.1,0.1-0.2,0.1-0.3
		c-0.1-0.1-0.2-0.1-0.3-0.2C257.2,250.4,257.2,250.4,257.1,250.3z"
      />
      <path
        class="st2"
        d="M195,250.8c0.2,0,0.4,0.1,0.5,0.2l0,0c0.3,0.2,0.5,0.3,0.7,0.3s0.4-0.2,0.7-0.8c-0.1-0.1-0.2-0.1-0.3-0.2l0,0
		c-0.1-0.1-0.3-0.2-0.4-0.3c0.4-1.3,0.3-1.8-0.5-2.2c-0.9-0.5-1.8-0.2-2.7,0.4c-0.1,0.1-0.2,0.1-0.3,0.2
		C192.4,250.3,192.7,250.7,195,250.8z"
      />
      <path
        class="st2"
        d="M283.4,249.2c-0.2-0.2-0.3-0.4-0.5-0.5c-0.2-0.2-0.5-0.4-0.9-0.5s-0.8-0.2-1.3-0.1c-0.3,1.2-0.6,2.4-0.8,3.5
		c-0.1,0.4,0.4,0.9,0.9,0.6c0.9-0.4,1.8-0.9,2.6-1.5C283.8,250.3,283.7,249.6,283.4,249.2z"
      />
      <path
        class="st2"
        d="M246.8,240.8c0.2,0.2,0.5,0.4,0.7,0.6c0.3,0.2,0.6,0.5,0.9,0.7c-0.1-0.2-0.2-0.4-0.2-0.6
		c0-0.1-0.1-0.2-0.1-0.2c-0.2-0.4-0.6-0.8-1.2-0.7c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0.1-0.1,0.1C246.7,240.7,246.7,240.8,246.8,240.8z
		"
      />
      <path
        class="st2"
        d="M247.6,244.6c0.2-0.2,0.5-0.3,0.7-0.5c0.1-0.1,0.2-0.1,0.3-0.2c-0.6-0.5-1.2-0.9-1.8-1.4
		c-0.3-0.2-0.6-0.5-1-0.7c-0.3,0.6-0.4,1.1-0.6,1.7c-0.2,0.6,0.3,1,0.9,1.4C246.6,245.1,247.1,244.9,247.6,244.6z"
      />
      <path
        class="st2"
        d="M260.3,256.9h0.1c0.5-0.1,0.9-0.5,1.2-0.9c0.3-0.4,0.4-0.8,0.3-1.1l0,0c-0.2-0.9-1.3-1.5-2.4-1.2
		c-0.1,0-0.2,0.1-0.3,0.1c-0.6,0.2-1,0.5-1.2,0.9c-0.1,0.3-0.2,0.6-0.1,1c0,0.2,0.1,0.3,0.2,0.4
		C258.5,256.8,259.4,257.2,260.3,256.9z"
      />
      <path
        class="st2"
        d="M199.7,257.4c2.4,0.9,2.4,0.9,3.4,2c0.3-0.2,0.9-0.5,0.9-0.7c0.1-1.1-0.2-2.1-1.3-2.8c0,0.3,0.1,0.6,0.1,0.9
		c0,0.1-0.3,0.3-0.5,0.5c-0.3-0.5-0.6-1.1-0.9-1.7c-0.3,0.1-0.6,0.2-0.8,0.3c-0.1,0-0.3,0.1-0.4,0.2c-0.3-0.2-0.6-0.5-1-0.9
		c0.7-0.2,1.3-0.7,2-1.4c0.1-0.1,0.2-0.2,0.3-0.4c0.3-0.3,0.3-0.8,0.4-1.1l0,0c0.2-1.4-0.3-2.7-1.3-3.8c-0.5-0.5-0.4-1.1-0.2-1.7
		c0.2-0.6,0.4-1.1,0.6-1.7c0.1,0,0.4-0.1,0.6-0.1c-0.2-0.2-0.4-0.4-0.7-0.6l-0.1,0.1c-0.1,0-0.2-0.1-0.2-0.1c0-0.1,0-0.2,0-0.3
		c-11.7-11.3-23.4-22.6-35.1-34c0,0.7,0,1.1,0,1.4c0.2,5.5,0.4,11,0.5,16.4c0,0.2,0,0.5-0.1,0.7c-0.2,0.7-0.5,1.4-0.8,2.1
		c-0.8-0.5-1.7-0.9-2.3-1.5c-0.8-0.9-1.6-1.8-2.5-2.7c-1.6-1.7-3.2-3.4-4.7-5.1c-0.2-0.2-0.4-0.4-0.6-0.6c-0.5-0.5-0.9-1-1.4-1.5
		c0,0,0,0-0.1-0.1c-1.2-1.3-2.4-2.6-3.6-4c-0.5-0.6-1-1.1-1.6-1.7c-0.3-0.3-0.5-0.4-0.7-0.5c-0.4-0.1-0.8-0.1-1.3,0.1
		c-1.9,1-2.2,2.7-2.2,4.5c-0.1,4.8-0.1,9.6,0,14.4c0,1.3,0,2.5,0.1,3.8c0.1,1.8,0.1,3.6,0.2,5.4c0.1,2.4,0.1,4.7-0.1,7
		c-0.2,3.2,0.1,6.1,1.2,8.8c0.1-0.2,0.1-0.5,0-0.7v-0.1c0-0.1,0-0.1,0.1-0.2c0.5,0.1,0.9,0.3,0.7,0.8c0,0.1,0,0.1-0.1,0.2
		c-0.1,0.3-0.2,0.7-0.3,1c0.6,1.3,1.5,2.6,2.6,3.8c0.1,0.1,0.2,0.2,0.2,0.4c0.4,0.6,0.8,1.3,1.2,1.9c1-0.7,1.4-1.6,1.1-2.5
		c-0.3-1.1-1.2-1.7-2.6-1.7c-0.2,0-0.4,0-0.5,0c0.7-2.1,2.1-3,4-2.5c0.3,0.1,0.7,0.3,0.8,0.5c0.3,1.1,1.2,1.7,2.6,1.9
		c-1,1.7-2.2,3.3-1.3,5.2c-0.5,0.1-0.9,0.2-1.4,0.3c-0.6,0.2-1,0.4-1.4,0.7c1,1.5,2,3,3,4.5c1.1-0.3,2-1,2.4-2.1
		c0.1-0.3,0.2-0.7,0.3-1.1c0.6-0.1,0.9,0.1,0.9,0.6c0,0.8,0.1,1.5,0.1,2.4c-1,0.4-2,0.9-2.6,1.9c1,1.5,1.9,3,2.9,4.4
		c1.3-0.1,2.5-0.5,3.3-1.4c0.3-0.4,0.6-0.7,0.7-1.1c0.2-0.6,0.2-1.2,0.1-1.8c1.6-0.4,3.1-0.7,4.6-1.1c1.3-0.4,2-1.3,2.3-2.4
		s-0.2-1.9-1.1-2.5c-1.1-0.8-2.3-1.5-3.5-2.3c-0.1,0-0.1-0.1-0.2-0.1c-0.5-0.3-0.8-0.7-0.9-1.3c-0.1-1.3-1.2-2.1-2.8-2
		c-1.7,0.2-2.4-0.9-3.7-1.2c0.6-0.7,0.9-1.2,1.9-1.5c0.1,0,0.1-0.1,0.2-0.1c0.5-0.1,0.9-0.4,1.3-0.7c0.4-0.3,0.8-0.6,1.3-0.8
		c1.2,0.4,1.3,1.2,1.1,2.1c-0.6,0.3-1.4-0.1-1.8,0.7c0.4,0.2,0.8,0.3,1.1,0.6c0.3,0.3,0.6,0.7,1.1,1.4c0.2-0.7,0.3-1.1,0.3-1.4
		c1-0.1,1.9-0.1,2.7,0.5c0.9,0.7,2.1,0.4,3.1-0.2c0.4-0.2,0.6-0.4,1.2-0.3c1.2,0.1,2.4-1,2.4-1.9c0,0,0,0,0-0.1c0-1-0.8-1.5-2-1.5
		c-0.2,0-0.4,0-0.6,0.1c-0.5,0.1-0.8,0.1-1.2-0.1c-1.4-0.6-2.6-0.3-3.6,0.8c-0.3,0.3-0.6,0.4-0.8,0c0.7-0.8,1.9-1.1,2.5-2.1
		c0.5-0.8,1.2-1.6,1.5-2.5c0.4-0.8,0.4-1.7,0.7-2.7c0.2-0.1,0.3-0.1,0.5-0.2c0.4-0.1,0.8-0.3,1.2-0.4c0,0.5-0.1,1-0.1,1.6
		c0.9,0.2,2.1-0.4,2.3,1.1c0,0-0.3,0.4-0.7,0.7l0,0h-0.1c-0.4-0.2-0.8-0.4-1.2-0.6c-0.2,0.2-0.3,0.3-0.3,0.5
		c-0.1,0.4,0.1,0.6,0.5,0.8l0,0c0.3,0.1,0.7,0.3,0.7,0.5c0.1,0.5,0.3,0.9,0.7,1.2l0.1,0.1c0.5,0.3,1.1,0.5,1.8,0.6
		c0.1,0.1,0.1,0.2,0.2,0.3c0.3,0.6,0.6,1.2,0.9,1.7c0.2,0.3,0.4,0.7,0.6,1c0.8,1.3,1.2,2.7,1.1,4.1c0,0.5,0,1,0.1,1.5
		c0.2,0.7,0.5,1.3,1.3,1.8c-0.7,0.2-1.3,0.3-1.8,0.4l0,0c-0.4,0.1-0.7,0.2-1,0.4c-1.3,0.7-2.1,2.1-1.8,3.4c0.3,1.4,1.8,2.3,3.5,2.2
		c0.3,0,0.6,0,1-0.1c0.3-0.1,0.5-0.2,0.8-0.3c0.7-0.3,1.3-0.8,1.7-1.4c0.1-0.1,0.1-0.2,0.2-0.3c0.3-0.5,0.3-1.1,0.2-1.8
		c-0.1-0.2-0.1-0.4-0.2-0.5c-0.3-0.8-0.7-1.6-1.3-2.3c-0.1-0.1-0.2-0.3-0.3-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.7-1-1-2,0-3.4
		c0.2-0.1,0.6-0.3,1-0.5c2.2-0.9,2.7-1.9,2-3.8c0-0.1,0-0.2-0.1-0.4c1.4-0.9,0.6-1.9,0.4-2.9c0.6-0.6,1.1-1.1,1.6-1.6
		c0.4-1,0.6-2,0.2-2.9c-0.6-1.5-0.2-3,0.2-4.6c0-0.1,0-0.1,0.1-0.2c0.1-0.3,0.2-0.6,0.3-1c1.3,1,2.6,1.9,4,2.9
		c0.5,0.4,1,0.7,1.5,1.1c0.3-0.7,0.8-1.3,1.3-1.9c0.4-0.5,0.7-1.1,0.6-1.8c0.5,0.1,0.8,0.2,1.2,0.3c1-0.8,1.1-1.1,0.7-1.5
		c-0.4-0.4-0.7-0.4-2,0.2c-0.6-0.4-0.8-0.8,0-1.2c1-0.6,1.9-1.3,3.2-0.7c0.3,0.1,0.7,0,1.2,0c1.1,1.8,1.7,3.8,1.6,5.9
		c0,0.8,0,1.4,0.7,1.9s1,1.2,1.1,2c0.1,0.9,0,1.1-0.9,1.5c-0.5,0.2-1,0.3-1.4,0.3c-1.5,0.1-1.5,0-2.1,1.2l0.1,0.1
		c1.1,0.9,2.1,1.2,2.9,1C198.6,256.5,198.8,257.1,199.7,257.4C199.6,257.4,199.7,257.4,199.7,257.4z M163.8,257
		c0.4-0.5,0.7-0.3,1-0.1C164.5,257,164.1,257,163.8,257z"
      />
      <path
        class="st2"
        d="M244.6,254.5c0.3,0.3,0.6,0.5,1,0.7c0.1,0,0.1,0.1,0.2,0.1c0.2,0.1,0.4,0.2,0.6,0.2h0.1
		c0.6-0.2,1.1-0.3,1.7-0.4c0.6-0.2,1.1-0.4,1.7-0.8c-0.4,0-0.6,0.1-0.9,0.1c-0.2,0-0.4,0-0.6,0.1c-0.5-1-0.6-1.1-1.5-1.3
		c0,0,0,0-0.1,0s-0.2,0-0.4-0.1c-0.3,0-0.5-0.2-0.7-0.3c-0.7-0.6-1.3-0.3-2,0.1c0.1,0.5,0.3,1,0.6,1.4
		C244.5,254.3,244.5,254.4,244.6,254.5z"
      />
      <path
        class="st2"
        d="M41.2,332.3c-1.1,0.3-1.8,1.2-1.5,2c0.2,0.8,1.2,1.3,2.2,1.1c1.1-0.2,1.9-1.1,1.7-2
		C43.3,332.5,42.3,332.1,41.2,332.3z"
      />
      <path
        class="st2"
        d="M36.6,338.3c-0.8,0.1-1.4,0.6-1.6,1.1h3.5c0-0.2,0-0.3,0-0.5C38.1,338.4,37.4,338.2,36.6,338.3z"
      />
      <path
        class="st2"
        d="M140,276c-0.3-0.1-0.7-0.1-1,0c-0.8,0.2-1.4,0.8-1.6,1.4c0,0.1,0,0.3,0,0.4c0,0.3,0.2,0.5,0.4,0.7
		c0.5,0.4,1.2,0.6,1.9,0.4c0.9-0.2,1.5-0.9,1.5-1.7c0-0.1,0-0.2,0-0.3C141,276.6,140.6,276.2,140,276z"
      />
      <path
        class="st2"
        d="M21.1,304.9c-0.3-0.7-1.2-1.1-2.1-0.9c-1,0.2-1.7,1.1-1.5,1.9c0.1,0.7,0.7,1.1,1.5,1.1c0.2,0,0.4,0,0.6-0.1
		c1.1-0.2,1.7-1,1.5-1.9C21.1,305,21.1,305,21.1,304.9z"
      />
      <path
        class="st2"
        d="M8.4,298.1c-0.3-0.1-0.5-0.2-0.9-0.3c-0.2,0-0.4,0-0.6,0c-0.9,0.2-1.6,1-1.5,1.8c0.1,0.9,1,1.4,2.1,1.2
		c0.4-0.1,0.7-0.2,0.9-0.4c0.2-0.1,0.3-0.3,0.5-0.5c0.2-0.3,0.2-0.6,0.2-0.9C9.1,298.6,8.8,298.3,8.4,298.1z"
      />
      <path
        class="st2"
        d="M176.2,289.8c-0.2-0.8-1.2-1.3-2.2-1c-0.9,0.2-1.5,1-1.4,1.7c0,0.1,0,0.1,0,0.2c0.2,0.8,1.2,1.3,2.2,1.1
		c0.5-0.1,0.9-0.4,1.2-0.8c0.1-0.1,0.2-0.3,0.2-0.4C176.3,290.3,176.3,290.1,176.2,289.8L176.2,289.8z"
      />
      <path
        class="st2"
        d="M280.1,254.8c-0.1-0.7-1.4-1.2-2.3-1s-1.5,1-1.4,1.8c0.1,0.8,1,1.3,1.9,1.2
		C279.4,256.6,280.2,255.7,280.1,254.8z"
      />
      <path
        class="st2"
        d="M225.1,277.8c-0.1-0.4-0.5-0.8-0.4-1.1c0.4-0.8-0.1-1.1-0.5-1.5c-1.1,0.3-0.6,0.8-0.6,1.3
		c-0.4-0.2-0.8-0.4-1.2-0.6c0,0-0.1,0-0.1,0.1c-0.2,0.4-0.4,0.9-0.6,1.3c0.8,1.3,0.8,1.3,2.4,1.5
		C224.9,278.8,225.3,278.4,225.1,277.8z"
      />
      <path
        class="st2"
        d="M220.6,301.1c-0.7,0.2-1.3,0.6-2,0.9c-0.1,0.4,0,0.7,0.1,1c0.2,0.4,0.5,0.8,1,1.1c0.9-0.4,1.6-0.8,2.3-1.1
		c0.2-0.1,0.4-0.2,0.6-0.4c0.2-0.2,0.4-0.4,0.4-0.8c-0.4-0.2-0.8-0.5-1.3-0.7C221.3,301,220.9,301,220.6,301.1z"
      />
      <path
        class="st2"
        d="M0.4,316.9c-0.1,0-0.3,0.1-0.4,0.2v2.6c0.4,0.1,0.8,0.2,1.2,0.1c0.9-0.2,1.6-1.1,1.3-1.8
		C2.3,317.1,1.3,316.6,0.4,316.9z"
      />
      <path
        class="st2"
        d="M272.9,264.7c0.4,0.1,0.8,0.2,1.2,0.1c0.1,0,0.3-0.1,0.4-0.1c0.3-0.1,0.5-0.3,0.7-0.6c0,0,0,0-0.1-0.1
		c-0.5-0.4-1-0.7-1.4-1.1c-0.3-0.2-0.6-0.4-0.8-0.6c-0.1,0.1-0.2,0.1-0.3,0.2c-0.2,0.2-0.3,0.4-0.4,0.7c-0.1,0.3-0.1,0.5,0,0.8
		C272.2,264.3,272.5,264.6,272.9,264.7z"
      />
      <path
        class="st2"
        d="M283.4,287.7c-0.2,0.3-0.4,0.6-0.3,1c0.1,0.8,0.9,1.3,1.8,1.1c0.3,0,0.6-0.2,0.9-0.4c-0.1-0.1-0.2-0.1-0.3-0.2
		C284.7,288.8,284.1,288.3,283.4,287.7z"
      />
      <path
        class="st2"
        d="M286.4,288.1c0-0.1-0.1-0.3-0.2-0.4s-0.2-0.1-0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.3c-0.3-0.1-0.6-0.2-1-0.2
		c0.2,0.1,0.4,0.3,0.5,0.4c0.4,0.3,0.8,0.6,1.1,0.9C286.3,288.3,286.3,288.2,286.4,288.1C286.4,288.3,286.4,288.2,286.4,288.1z"
      />
      <path
        class="st2"
        d="M213,315.3c-0.5-0.1-1.1-0.1-1.6-0.1c-0.8,0-1.5,0-2.3,0.1c-0.7,0.1-1.5,0.1-2.3,0.2c-0.1,0-0.2,0-0.3,0
		c0.2,0.2,0.4,0.3,0.6,0.5c0.9,0.6,1.8,0.9,2.8,0.8c0.3,0,0.6-0.1,0.9-0.2C211.6,316.3,212.3,315.9,213,315.3z"
      />
      <path
        class="st2"
        d="M278.8,289.4c0.5,0.4,0.9,0.8,1.4,1.2c0-0.1,0-0.1,0-0.2C280,289.8,279.5,289.4,278.8,289.4z"
      />
      <path
        class="st2"
        d="M111.7,314.7c-0.9,0.2-1.4,1-1.2,1.8c0.1,0.4,0.4,0.6,0.7,0.8c0.3,0.1,0.7,0.2,1.1,0.1c0.5-0.1,1-0.5,1.2-0.9
		c0.1-0.3,0.2-0.5,0.1-0.8C113.5,314.9,112.5,314.4,111.7,314.7z"
      />
      <path
        class="st2"
        d="M211.7,317.1c-0.8,0.2-1.3,0.9-1.2,1.6s1,1.2,1.9,1s1.4-1,1.3-1.7C213.4,317.2,212.6,316.8,211.7,317.1z"
      />
      <path
        class="st2"
        d="M296.1,256.9c-0.8,0-1.6,0.3-2,1.2c0.3,0.3,0.5,0.7,0.8,0.9c0.6,0.4,1.2,0.3,1.9-0.1c0.5-0.3,0.8-0.6,0.7-1.2
		C297.3,257.2,296.8,256.9,296.1,256.9z"
      />
      <path
        class="st2"
        d="M238.2,253.7c-0.5,0.4-0.6,0.8-0.2,1.3c0,0,0,0.1,0.1,0.1c0.1,0.2,0.3,0.3,0.4,0.5c0.2,0.2,0.3,0.3,0.5,0.3
		c0.3,0.1,0.6,0.1,0.9-0.1c0.7-0.3,0.8-0.8,0.7-1.4c-0.1-0.2-0.3-0.5-0.5-0.7C239.5,253.3,238.8,253.3,238.2,253.7z"
      />
      <path
        class="st2"
        d="M11.8,295.3c0.8-0.2,1.3-0.8,1.2-1.4c-0.1-0.7-1-1.1-1.8-0.9c-0.7,0.2-1.3,0.8-1.2,1.4
		C10.1,295.1,10.9,295.5,11.8,295.3z"
      />
      <path
        class="st2"
        d="M0,336.6v2.4c0.1,0,0.3,0,0.4,0c0.8-0.2,1.4-0.9,1.2-1.5C1.5,337,0.7,336.5,0,336.6z"
      />
      <path
        class="st2"
        d="M1.5,325.5c-0.1-0.3-0.3-0.5-0.6-0.7c-0.3-0.1-0.6-0.2-0.9-0.2v0.7v1.6c0.1,0,0.2,0,0.3,0
		C1,326.8,1.6,326.1,1.5,325.5z"
      />
      <path
        class="st2"
        d="M259.6,257.5c-0.1,0-0.3,0.1-0.4,0.1c-0.4,0.2-0.7,0.6-0.8,1c0,0.1,0,0.2,0,0.4c0.1,0.6,0.7,1.1,1.3,0.9
		c0.6-0.1,1.1-0.6,1.4-1.1c0.1-0.2,0.2-0.5,0.2-0.7s-0.2-0.4-0.5-0.5C260.4,257.5,260,257.4,259.6,257.5z"
      />
      <path
        class="st2"
        d="M17.8,336.9L17.8,336.9c-0.2,0.1-0.3,0.1-0.5,0.2c-1,0.4-1.4,1-1.3,1.8c0,0.2,0.1,0.4,0.1,0.6h0.5h0.3
		c0.6-0.2,1-0.4,1.2-0.7C18.4,338.3,18.4,337.7,17.8,336.9C17.9,336.9,17.8,336.9,17.8,336.9z"
      />
      <path
        class="st2"
        d="M276.5,287.4L276.5,287.4c1.1-0.2,1.7-0.7,1.9-1.7c-1.2,0.1-2.3,0.2-3.4,0.3
		C275.4,286.5,276,286.9,276.5,287.4z"
      />
      <path
        class="st2"
        d="M288.1,292.9c-0.7,0.5-1.3,1-2,1.5c0.3,0.2,0.7,0.3,1.2,0.2c0.7-0.2,1.1-0.8,1-1.3
		C288.2,293,288.2,293,288.1,292.9z"
      />
      <path
        class="st2"
        d="M212.3,305.3c-0.7,0.1-1.2,0.7-1.2,1.3c0,0.4,0.4,0.7,0.8,0.9c0.2,0.1,0.5,0.1,0.8,0s0.5-0.2,0.7-0.4
		c0.3-0.2,0.4-0.6,0.3-0.9C213.6,305.5,213,305.2,212.3,305.3z"
      />
      <path
        class="st2"
        d="M14.4,311.7c0-0.6,0-1.2,0-1.7c-0.2,0.1-0.4,0.3-0.6,0.5C13.8,311.1,13.9,311.5,14.4,311.7z"
      />
      <path
        class="st2"
        d="M16.4,311c0.2-0.5,0-0.9-0.5-1.1c-0.3-0.1-0.5-0.1-0.8-0.1c0,0.7,0,1.4-0.1,2.1l0,0
		C15.6,311.9,16.1,311.6,16.4,311z"
      />
      <path
        class="st2"
        d="M216.3,312.3c-0.7,0.3-0.9,0.7-0.8,1.7c0.5,0,0.9,0,1.3-0.1c0.7-0.2,1.3-0.5,1.9-1.1c-0.4-0.4-0.8-0.6-1.2-0.7
		C217.1,312,216.7,312.1,216.3,312.3z"
      />
      <path
        class="st2"
        d="M183.3,274c-0.5,0.1-0.9,0.6-1,1c0,0.1,0,0.2,0,0.3c0.2,0.5,0.9,0.9,1.6,0.7c0.1,0,0.2-0.1,0.3-0.2
		c0.5-0.3,0.7-0.7,0.6-1.2C184.6,274.1,184,273.8,183.3,274z"
      />
      <path
        class="st2"
        d="M261.1,268.8C261.1,268.8,261,268.8,261.1,268.8c-0.2,0.1-0.2,0.1-0.3,0.2c-0.2,0.3-0.2,0.8,0.1,1.3
		c0.3,0.4,0.8,0.6,1.4,0.3c0.4-0.2,0.7-0.4,1.2-0.7c-0.2-0.3-0.3-0.4-0.4-0.6C262.7,268.7,261.8,268.5,261.1,268.8z"
      />
      <path
        class="st2"
        d="M283,266.1c-0.4-0.3-0.8-0.6-1.2-0.9c-0.3,0.1-0.6,0.3-0.7,0.6c-0.1,0.2-0.2,0.5-0.1,0.8
		c0.2,0.5,0.8,0.8,1.4,0.7c0.5-0.1,0.8-0.5,1-0.9C283.2,266.3,283.1,266.2,283,266.1z"
      />
      <path
        class="st2"
        d="M158,309.3c-0.5,0.1-0.9,0.5-1,0.9l0,0c0.2,0.4,0.4,0.7,0.6,1.1c0.2,0.1,0.5,0.1,0.8,0c0.1,0,0.2-0.1,0.3-0.1
		c0.5-0.2,0.9-0.8,0.8-1.2C159.4,309.5,158.6,309.2,158,309.3z"
      />
      <path
        class="st2"
        d="M197,265.8c-0.4,0.5-0.7,1.1-1.1,1.6c-0.4,0.1-0.8,0.2-1.3,0.3c0.3,0.5,0.6,0.9,0.9,1.5c0.8-0.9,1.5-1.5,2-2.2
		C197.9,266.4,197.9,266,197,265.8z"
      />
      <path
        class="st2"
        d="M219,271.3c-0.4-0.8-0.9-1.5-0.9-2.3c0-0.2-0.4-0.4-0.7-0.7c0.2,1.3,0.2,1.3-0.6,2.6c0.1,0.1,0.1,0.1,0.1,0.2
		c0.8,0.9,0.9,0.9,2.2,0.5C219.2,271.5,219.1,271.4,219,271.3z"
      />
      <path
        class="st2"
        d="M86,319.5c0.6-0.1,1.1-0.6,1-1.1c-0.1-0.6-0.7-1-1.4-0.9c-0.6,0.1-1.1,0.7-1,1.2
		C84.6,319.3,85.2,319.7,86,319.5z"
      />
      <path
        class="st2"
        d="M305.4,285.7c-0.7,0.1-1.2,0.7-1.1,1.3c0.1,0.5,0.8,0.8,1.4,0.7c0.1,0,0.2,0,0.3-0.1v-1.9
		C305.8,285.7,305.6,285.7,305.4,285.7z"
      />
      <path
        class="st2"
        d="M212.8,269.8c0-0.1-0.6-0.1-0.9-0.1c-0.2,0.7-0.3,1.5,0.6,1.9c0.3-0.2,0.7-0.5,0.8-0.4c0.8,0.5,1-0.1,1.1-0.5
		c0.1-0.3-0.1-0.6-0.1-0.8C213.7,269.8,213.1,270.6,212.8,269.8z"
      />
      <path
        class="st2"
        d="M189.7,248.8c-0.6,0.3-0.7,0.8-0.6,1.2c0.1,0.5,0.3,1,1.2,0.8c0.3-0.7,0.6-1.4,0.9-2
		C190.8,248,190.2,248.5,189.7,248.8z"
      />
      <path
        class="st2"
        d="M233.7,285.4c-0.2,0.1-0.4,0.5-0.4,0.8c0,0.5,0.4,0.8,1,0.9c0.6,0,1.2-0.1,1.4-0.9c-0.3-0.3-0.6-0.6-1.1-0.9
		C234.5,285.2,233.9,285.2,233.7,285.4z"
      />
      <path
        class="st2"
        d="M232.8,272c-0.3,0.1-0.7,0.2-1,0.3c0.5,0.4,0.9,0.9,1.4,1.3C233.8,273,233.3,272.5,232.8,272z"
      />
      <path
        class="st2"
        d="M88,309.4c0.4,0.7,1,0.8,1.7,0.5c0.3-0.1,0.5-0.2,0.6-0.4c0.4-0.3,0.6-0.8,0.5-1.5c-0.5,0.2-0.9,0.3-1.3,0.5
		c-0.3,0.1-0.5,0.2-0.8,0.4C88.5,309,88.2,309.2,88,309.4L88,309.4z"
      />
      <path
        class="st2"
        d="M167.9,301.1c-0.3-0.5-0.6-0.8-1-1.3c-0.5,0.5-0.8,0.9-1.2,1.2c0.3,0.5,0.5,0.9,0.9,1.6
		C167.1,302,167.5,301.6,167.9,301.1z"
      />
      <path
        class="st2"
        d="M249.6,323.4c0.1-0.9,0.2-1.8,0.2-2.7c-0.3,0.2-0.6,0.5-1,0.7C249.1,322.1,249.3,322.8,249.6,323.4z"
      />
      <path
        class="st2"
        d="M229.3,273.8c0.1-0.3,0-0.6,0-0.9s0.1-0.6,0.2-1l-0.1-0.1c-0.4,0-0.8,0-1.1-0.1c0.1-0.2,0.2-0.4,0.4-0.7
		c0,0,0,0-0.1-0.1c-0.4,0.2-0.7,0.3-1,0.4l0,0l0,0C227.8,272.3,228.4,273.1,229.3,273.8z"
      />
      <path
        class="st2"
        d="M201.4,259.6c-0.5-0.1-0.8-0.3-1.1-0.3c-0.6-0.1-0.9,0.3-1.1,0.7c-0.2,0.4-0.1,0.8,0.3,0.9
		c0.4,0.1,0.9,0,1.3-0.2C201.2,260.4,201.2,260,201.4,259.6z"
      />
      <path
        class="st2"
        d="M201.8,242.1c0.3,0.9,0.3,0.9,1.7,1.2c0.1-0.1,0.1-0.2,0.2-0.2c-0.4-0.4-0.8-0.7-1.2-1.1
		C202.3,242,202,242.1,201.8,242.1z"
      />
      <path
        class="st2"
        d="M74.7,326.9c1-0.6,1.8-1.1,2.7-1.6C75.7,324.7,75.2,325,74.7,326.9z"
      />
      <path
        class="st2"
        d="M27.9,336.7c1.5-0.5,1.7-0.8,1.2-1.9C27.9,335.5,27.9,335.5,27.9,336.7z"
      />
      <path
        class="st2"
        d="M210.3,268.2c-0.1,0.1-0.3,0.4-0.2,0.5c0.1,0.8,0.7,1.1,1.8,0.9c-0.2-0.5-0.5-1-0.8-1.5
		C211,268.1,210.5,268.1,210.3,268.2z"
      />
      <path
        class="st2"
        d="M216.9,295.6c0.6-0.1,0.9-0.4,0.9-0.8c0-0.6-0.5-0.9-1.1-0.8s-0.9,0.4-0.9,0.9
		C215.8,295.4,216.3,295.7,216.9,295.6z"
      />
      <path
        class="st2"
        d="M217.8,278.3c-0.2-0.2-0.4-0.3-0.8-0.5c-0.4,0.9-0.4,1.4,0.2,1.7c0.2,0.1,0.6,0.3,1,0.4
		C218.3,279.3,218.2,278.7,217.8,278.3z"
      />
      <path
        class="st2"
        d="M251.6,283.2c-0.3,0.2-0.5,0.5-0.5,0.8c-0.1,0.4,0.7,0.7,1.2,0.5c0.1-0.1,0.2-0.2,0.3-0.3
		c0.2-0.2,0.3-0.4,0.6-0.6c-0.6-0.2-1-0.6-1.3-0.5C251.8,283.1,251.7,283.1,251.6,283.2z"
      />
      <path
        class="st2"
        d="M232.2,298.2c-0.3,0.5-0.5,0.8-0.6,1.1c0,0.1,0,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.3c0.2,0.2,0.7,0.3,1,0.2
		c0.6-0.1,0.9-0.5,0.7-0.9C233.2,298.8,232.7,298.6,232.2,298.2z"
      />
      <path
        class="st2"
        d="M227.4,273c-0.2-0.1-0.4-0.2-0.6-0.2c-0.5-0.2-0.9-0.3-1.4-0.5c-0.1,0-0.5,0.3-0.5,0.4
		c0.1,0.2,0.3,0.4,0.5,0.5l0,0c0.5,0.2,1.1,0.4,1.8,0.6C227.6,273.6,227.8,273.2,227.4,273z"
      />
      <path
        class="st2"
        d="M194.1,254.9L194.1,254.9c-0.2-0.2-0.5-0.3-0.7-0.3h-0.1c-0.3,0.1-0.6,0.5-0.6,0.7c0,0.4,0.2,0.8,0.6,1
		c0.4,0.3,0.9,0,1.3-0.5C194.5,255.5,194.3,255.2,194.1,254.9z"
      />
      <path
        class="st2"
        d="M137.6,283.5c0.1,0.9,0.1,0.9,0.8,1.3c0.6-0.2,1.2-0.6,0.9-1.2C139,283.2,138.3,283.2,137.6,283.5z"
      />
      <path
        class="st2"
        d="M233.5,279.8c1,0.3,1.1,1.7,2.7,1.1c-0.3-0.5-0.6-1-0.9-1.5C234.7,279.5,234.2,279.6,233.5,279.8z"
      />
      <path
        class="st2"
        d="M116,310c-0.3,0.2-0.6,0.5-0.7,0.8c-0.1,0.4,0.5,0.7,1,0.6s0.9-0.5,0.8-0.9C117,310.1,116.4,309.8,116,310z"
      />
      <path
        class="st2"
        d="M29.3,302.7c-0.5,0-1,0.5-0.7,0.9c0.1,0.2,0.3,0.3,0.4,0.4s0.3,0.2,0.4,0.2c0.2-0.1,0.3-0.1,0.4-0.2
		c0-0.4,0-0.8,0-1.2c0,0,0,0-0.1,0C29.6,302.7,29.5,302.7,29.3,302.7z"
      />
      <path
        class="st2"
        d="M152.8,304.1c-0.3,0.2-0.7,0.6-0.7,0.8c0.1,0.2,0.3,0.4,0.7,0.6c0.1,0.1,0.2,0.2,0.4,0.3c0,0,0-0.1,0.1-0.1
		c0.3-0.5,0.5-0.8,0.6-1C153.9,304.2,153.3,303.9,152.8,304.1z"
      />
      <path
        class="st2"
        d="M287.2,275.8c0.6,0.6,0.6,1.5,2.1,1.2C288.6,275.6,288.6,275.6,287.2,275.8z"
      />
      <path
        class="st2"
        d="M74.5,317c0.2-0.2,0.3-0.5,0.5-0.7c-0.2-0.1-0.3-0.2-0.5-0.3h-0.1c-0.1-0.1-0.3-0.1-0.4-0.1
		c-0.2,0-0.4,0.3-0.7,0.6c-0.1,0.1-0.1,0.2-0.2,0.2c0.6,0.2,1,0.5,1.2,0.4C74.4,317.1,74.4,317.1,74.5,317z"
      />
      <path
        class="st2"
        d="M220.2,272.1c0.6,0.4-0.4,1.3,0.6,1.6h-0.1c0,0,0,0,0,0.1l0,0c0.1,0.1,0.3,0.1,0.4,0.2
		C221.7,272.8,221.5,272.4,220.2,272.1z"
      />
      <path
        class="st2"
        d="M235.4,282.1c-0.3,0.3-0.5,0.6-0.5,0.8c0,0,0,0,0,0.1c0,0.3,0.4,0.6,1.2,0.9
		C236.5,283.1,236.1,282.6,235.4,282.1z"
      />
      <path
        class="st2"
        d="M233.3,279.4L233.3,279.4c0.2,0,0.3-0.4,0.2-0.5c-0.3-0.4-0.7-0.7-1.3-1.2c-0.1,0.2-0.1,0.3-0.2,0.4
		c-0.1,0.6,0.2,0.9,0.5,1.2C232.6,279.5,233,279.4,233.3,279.4z"
      />
      <path
        class="st2"
        d="M240.4,263.3c-0.1-0.1-0.3-0.2-0.4-0.2c-0.2,0-0.4,0.1-0.9,0.2c0.5,0.6,0.4,1.4,1.5,1.4l0,0c0,0,0,0,0.1,0l0,0
		C241.1,264.2,240,263.8,240.4,263.3z"
      />
      <path
        class="st2"
        d="M205.4,253.5c-0.2-0.6-0.5-1.2-0.9-2.2c0,0.1-0.1,0.2-0.1,0.3c-0.2,0.5-0.6,0.8-0.3,1.3
		c0.2,0.3,0.3,0.7,0.8,0.7C205,253.5,205.2,253.5,205.4,253.5z"
      />
      <path
        class="st2"
        d="M250.9,274.7c0,0.1,0.6,0.4,0.7,0.4c0.3-0.2,0.6-0.5,0.7-0.8c0-0.1-0.4-0.3-0.9-0.5
		C251.2,274.1,250.9,274.4,250.9,274.7z"
      />
      <path
        class="st2"
        d="M249.1,234.8c-0.3,0.4-0.6,0.8-0.8,1.1c0.1,0.1,0.1,0.1,0.2,0.2c0.6-0.3,1.3-0.5,2-0.9
		C250,235.1,249.7,235,249.1,234.8z"
      />
      <path
        class="st2"
        d="M78.6,331.5c-0.2,0.2-0.5,0.5-0.4,0.7c0,0.2,0.4,0.3,0.8,0.6c0.2-0.4,0.5-0.7,0.4-0.9
		C79.3,331.7,78.9,331.6,78.6,331.5z"
      />
      <path
        class="st2"
        d="M305.5,230.2c-0.3,0.2-0.6,0.3-0.9,0.4c-0.1,0.1-0.2,0.3-0.2,0.4c0,0.1,0.5,0.3,0.9,0.4
		c0.3-0.3,0.6-0.6,0.6-0.8C305.9,230.5,305.7,230.3,305.5,230.2z"
      />
      <path
        class="st2"
        d="M207.8,250.8L207.8,250.8c-0.6-0.1-1.1-0.7-1.8,0.1C207,251.6,207,251.6,207.8,250.8z"
      />
      <path
        class="st2"
        d="M79.2,325.7c0-0.3-0.4-0.5-0.7-0.9c-0.3,0.4-0.8,0.7-0.7,0.9c0.1,0.3,0.5,0.4,0.8,0.6
		C78.7,326.1,79.2,325.9,79.2,325.7z"
      />
      <path
        class="st2"
        d="M207.1,244.5c0.1-0.3,0-0.7-0.1-1c-0.3,0.1-0.5,0.2-0.7,0.3C206.6,244.1,206.8,244.3,207.1,244.5z"
      />
      <path
        class="st2"
        d="M250.8,243.9c0.3-0.3,0.6-0.6,0.9-1c-0.2-0.1-0.3-0.2-0.5-0.4C250.9,242.9,250.8,243.4,250.8,243.9
		L250.8,243.9z"
      />
      <path
        class="st2"
        d="M227.1,279.9c-0.3,0.3-0.5,0.5-0.7,0.8c0.3,0.1,0.6,0.4,0.8,0.3c0.3-0.1,0.5-0.4,0.6-0.7
		C227.8,280.2,227.4,280,227.1,279.9z"
      />
      <path
        class="st2"
        d="M233.3,245.2c-0.4,0.4-0.8,0.8-1.1,1.2c0.7,0.5,1.1-0.3,1.7-0.3c0.1-0.2,0.1-0.4,0.2-0.6
		C233.8,245.4,233.6,245.3,233.3,245.2z"
      />
      <path
        class="st2"
        d="M241.7,258c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.1,0.1-0.2,0.2c0.1,0,0.1,0,0.1,0c0.5,0,0.9,0,1.2-0.2
		s0.5-0.4,0.6-0.8C242.5,257.3,242.1,257.6,241.7,258z"
      />
      <path
        class="st2"
        d="M46.1,327.4c-0.2,0-0.3,0.4-0.4,0.6c0.3,0.1,0.5,0.3,0.8,0.3c0.1,0,0.3-0.3,0.6-0.7
		C46.7,327.5,46.4,327.4,46.1,327.4z"
      />
      <path
        class="st2"
        d="M12,327.3c0.7-0.7,0.8-1.2,0.2-1.9C11.4,326,11.5,326.5,12,327.3z"
      />
      <path
        class="st2"
        d="M226.6,290.9c0-0.1,0.1-0.2,0.1-0.3c0.1-0.3,0.1-0.5,0-0.7s-0.4-0.4-0.9-0.5l0,0l0,0c0,0,0,0,0,0.1
		c0,0.4,0,0.7,0.2,0.9C226.1,290.6,226.3,290.7,226.6,290.9z"
      />
      <path
        class="st2"
        d="M114.3,301.6c-0.2,0.4-0.6,0.7-0.5,0.9c0.1,0.2,0.5,0.3,0.8,0.4c0.1,0,0.5-0.4,0.4-0.6
		C115,302.1,114.6,301.9,114.3,301.6z"
      />
      <path
        class="st2"
        d="M188.9,268.5c1.3-0.8,0.1-1.1,0.1-1.7C187.7,267.6,188.9,267.9,188.9,268.5z"
      />
      <path
        class="st2"
        d="M277.4,272.8c0.5,0.4,0.4,1,1.1,1.2c0.1-0.1,0.1-0.1,0.2-0.2C278.5,272.8,278.5,272.8,277.4,272.8z"
      />
      <path
        class="st2"
        d="M258.2,277.8c0.9,0,1.6,0.1,2.2,0.1c-0.5-0.3-0.9-0.5-1.3-0.8C258.8,277.4,258.6,277.5,258.2,277.8z"
      />
      <path
        class="st2"
        d="M228.7,241.9c-0.5,0.4-0.8,0.6-1.2,0.9c0.2,0.1,0.3,0.2,0.4,0.3c0.1,0.1,0.3,0.3,0.4,0.4
		C229.2,243.1,228.9,242.6,228.7,241.9z"
      />
      <path
        class="st2"
        d="M90.4,317.2c0.1,0.1,0.2,0.2,0.3,0.3l0,0c0.5-0.4,1.1-0.7,1.4-1.1c0.1-0.1,0.1-0.1,0.2-0.2
		c-0.1-0.1-0.2-0.2-0.3-0.2C91.6,316.4,91,316.8,90.4,317.2z"
      />
      <path
        class="st2"
        d="M248.7,245.3c-0.4,0.3-0.6,0.5-1,0.7c0.5,0.5,0.9,0.7,1.4,0.2C249.2,246.1,248.8,245.7,248.7,245.3z"
      />
      <path
        class="st2"
        d="M256.1,286c0.1,0.8,0.1,0.8,0.9,1.3C256.9,286.8,256.9,286.3,256.1,286z"
      />
      <path
        class="st2"
        d="M205.7,321.1c0,0.7,0.2,1.1,1,1.7C206.8,321.8,206.6,321.4,205.7,321.1z"
      />
      <path
        class="st2"
        d="M230.9,244.3c-0.2,0.1-0.3,0.3-0.5,0.7c0.7-0.1,1.3-0.2,1.8-0.8C231.5,244.1,231.2,244.2,230.9,244.3
		L230.9,244.3z"
      />
      <path
        class="st2"
        d="M212.2,287c-0.3,0.4-0.5,0.6-0.6,0.9c0,0.1,0.4,0.3,0.6,0.4c0.2-0.2,0.5-0.5,0.6-0.7
		C212.8,287.4,212.5,287.3,212.2,287z"
      />
      <path
        class="st2"
        d="M83,328.6c0-0.1-0.1-0.2-0.1-0.4c-0.2-0.1-0.4-0.3-0.5-0.2c-0.3,0.1-0.4,0.4-0.6,0.7c0.2,0.1,0.5,0.4,0.7,0.3
		S82.8,328.8,83,328.6z"
      />
      <path
        class="st2"
        d="M289.1,270.6c-0.2-0.2-0.4-0.3-0.7-0.5l0,0c-0.2,0.2-0.5,0.4-0.4,0.5c0.2,0.2,0.4,0.4,0.8,0.6
		C288.9,270.9,289.1,270.7,289.1,270.6z"
      />
      <path
        class="st2"
        d="M251.1,259.9c-0.1,0.7,0.3,1,1.2,1.2C252.1,260.4,252,259.9,251.1,259.9z"
      />
      <path
        class="st2"
        d="M233.6,274c0.2,0.2,0.3,0.3,0.5,0.5c0.2,0.1,0.4,0.2,0.6,0.3c0.1-0.1,0.2-0.2,0.3-0.4
		C234.7,274.1,234.3,273.8,233.6,274z"
      />
      <path
        class="st2"
        d="M47.2,337.8c0.2-0.5,0.4-1,0.7-1.6C46.8,337,46.8,337,47.2,337.8z"
      />
      <path
        class="st2"
        d="M273.2,251.3c-0.4-0.2-0.7-0.3-1-0.4c-0.1,0.2-0.4,0.5-0.3,0.6c0.2,0.2,0.5,0.3,0.8,0.3
		C272.8,251.8,273,251.5,273.2,251.3z"
      />
      <path
        class="st2"
        d="M216.1,273.4c0.1,0,0.3,0.1,0.5,0.1c-0.2-0.2-0.3-0.4-0.5-0.6c-0.2-0.3-0.5-0.5-0.8-0.9
		C215.5,273,215.5,273.2,216.1,273.4z"
      />
      <path
        class="st2"
        d="M241.3,246.6c0.1,0.1,0.2,0.2,0.3,0.2s0.1-0.1,0.2-0.1c0.3-0.2,0.6-0.4,0.8-0.6c0.1-0.1-0.2-0.3-0.3-0.5
		c-0.3,0.3-0.5,0.6-0.8,0.8C241.4,246.5,241.3,246.5,241.3,246.6z"
      />
      <path
        class="st2"
        d="M241.3,236.2c0-0.2-0.4-0.3-0.7-0.5c-0.1,0.1-0.1,0.2-0.2,0.3c0.2,0.2,0.5,0.4,0.7,0.5
		C241.2,236.4,241.3,236.3,241.3,236.2z"
      />
      <path
        class="st2"
        d="M31.9,302.5c-0.4-0.2-0.7-0.3-1-0.4c0,0.1-0.1,0.2-0.2,0.2l0,0c-0.1,0.1-0.2,0.3-0.1,0.4
		c0.1,0.2,0.4,0.3,0.7,0.3C31.4,303.1,31.6,302.8,31.9,302.5z"
      />
      <path
        class="st2"
        d="M74.6,328.9c-0.2,0-0.4,0.4-0.4,0.5c0,0.2,0.4,0.3,0.7,0.5c0.2-0.3,0.4-0.6,0.4-0.7
		C75.2,329,74.9,328.8,74.6,328.9z"
      />
      <path
        class="st2"
        d="M16.8,301c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1-0.2-0.4-0.4-0.7c-0.4,0.4-0.6,0.7-0.9,1c0.2,0.1,0.3,0.1,0.4,0.2
		C16.5,301.3,16.6,301.2,16.8,301z"
      />
      <path
        class="st2"
        d="M29.3,322.4c0.8-0.2,0.9-0.5,0.6-1.2C29.4,321.5,29,321.8,29.3,322.4z"
      />
      <path
        class="st2"
        d="M208.6,255.1c0-0.3,0.1-0.6,0.1-0.8c0.1-0.3,0.2-0.5,0.3-0.8c-0.2,0-0.4,0.1-0.6,0.1
		C208.2,254.3,208.2,254.3,208.6,255.1z"
      />
      <path
        class="st2"
        d="M210,276c0.1-0.4,0.2-0.8,0.4-1.1c-0.2,0-0.4,0-0.6-0.1c-0.1,0.4-0.1,0.8-0.2,1.2C209.8,276,209.9,276,210,276
		z"
      />
      <path
        class="st2"
        d="M233,295.9c0,0.1,0,0.3,0.1,0.4c0.1,0.4,0.4,0.7,1,1.1c0-0.2,0-0.3-0.1-0.4C233.9,296.4,233.6,296,233,295.9z"
      />
      <path
        class="st2"
        d="M89.7,320.7c-0.2,0.3-0.5,0.5-0.4,0.6c0.1,0.2,0.4,0.3,0.6,0.4c0.1-0.2,0.4-0.3,0.4-0.5
		C90.2,321.1,89.9,321,89.7,320.7z"
      />
      <path
        class="st2"
        d="M182.3,281.1c0.6-0.2,1.1-0.5,0.7-1.3C182.7,280.4,182.5,280.8,182.3,281.1z"
      />
      <path
        class="st2"
        d="M203.2,239.7c0.3-0.1,0.5-0.2,0.9-0.4c-0.2-0.3-0.3-0.6-0.5-0.8C202.9,238.8,203,239.2,203.2,239.7z"
      />
      <path
        class="st2"
        d="M201.5,241.3c-0.2,0.1-0.3,0.3-0.5,0.6c0.5,0,0.9,0,1.1-0.3c-0.1-0.1-0.2-0.2-0.3-0.3
		C201.6,241.2,201.6,241.2,201.5,241.3z"
      />
      <path
        class="st2"
        d="M193.1,252c0.7,0.2,1.1,0.3,1.8,0.5C194.4,251.8,194,251.6,193.1,252z"
      />
      <path
        class="st2"
        d="M184.2,259c0.4,0.2,0.8,0.4,1.5,0.8C185.3,259,184.9,258.9,184.2,259z"
      />
      <path
        class="st2"
        d="M213.5,289.7c0.1,0,0.2,0,0.4,0c0.1-0.4,0.1-0.8,0.2-1.2c-0.1,0-0.3,0-0.4,0
		C213.6,289,213.6,289.4,213.5,289.7z"
      />
      <path
        class="st2"
        d="M254.6,254.2c-0.8-0.2-1.2-0.5-1.9,0.2C253.4,254.3,253.8,254.3,254.6,254.2z"
      />
      <path
        class="st2"
        d="M13.7,312.4c0.2,0.2,0.4,0.4,0.5,0.6c0,0,0,0,0.1,0c0-0.1,0-0.3,0-0.4c-0.1-0.1-0.2-0.2-0.3-0.3
		C13.9,312.2,13.8,312.3,13.7,312.4z"
      />
      <path
        class="st2"
        d="M180.2,288.2c0.3-0.5,0.4-0.8,0.6-1.1C180.3,287.3,179.8,287.6,180.2,288.2z"
      />
      <path
        class="st2"
        d="M195.5,252.6c0.4-0.2,0.4-0.2,0.4-0.5c0-0.1,0-0.2-0.1-0.3c-0.2,0.4-0.4,0.6-0.6,0.9
		C195.4,252.7,195.4,252.6,195.5,252.6z"
      />
      <path
        class="st2"
        d="M292.2,237.8L292.2,237.8c0,0.1-0.1,0.1-0.1,0.2c0,0.1,0.1,0.3,0.2,0.3c0.6,0.1,0.6-0.3,0.7-0.6
		C292.8,237.7,292.4,237.5,292.2,237.8z"
      />
      <path
        class="st2"
        d="M217.2,275.8c-0.4,0-0.7-0.1-0.9,0s-0.3,0.3-0.3,0.5c0,0.1,0.3,0.3,0.5,0.3
		C216.5,276.5,216.7,276.2,217.2,275.8z"
      />
      <path
        class="st2"
        d="M44.9,320.3c-0.2,0.1-0.3,0.2-0.5,0.4c0.1,0.1,0.3,0.2,0.6,0.4c0.1-0.3,0.3-0.4,0.3-0.6
		C45.3,320.4,45,320.3,44.9,320.3z"
      />
      <path
        class="st2"
        d="M31.3,337.5c0,0.1,0,0.2,0,0.4c0.3-0.3,0.6-0.5,0.9-0.8c-0.1-0.1-0.1-0.1-0.2-0.2
		C31.7,337.1,31.5,337.3,31.3,337.5z"
      />
      <path
        class="st2"
        d="M254.1,255.9c-0.2,0.5,0,0.7,0.4,0.9c0.1,0,0.2,0.1,0.3,0.1c0.1-0.2,0-0.3,0-0.5
		C254.8,256.1,254.5,256,254.1,255.9z"
      />
      <path
        class="st2"
        d="M289.8,256.1c-0.1-0.4-0.3-0.8,0.3-0.9c-0.2,0-0.5,0-1-0.1C289.4,255.6,289.6,255.8,289.8,256.1z"
      />
      <path
        class="st2"
        d="M289.9,256.2C289.8,256.3,289.8,256.3,289.9,256.2c0.1,0.1,0.3,0.2,0.4,0.2h0.1c0,0,0-0.1-0.1-0.1
		C290.2,256.4,290,256.3,289.9,256.2c0-0.1,0-0.1-0.1-0.1C289.8,256.2,289.8,256.2,289.9,256.2C289.8,256.3,289.8,256.3,289.9,256.2
		z"
      />
      <path
        class="st2"
        d="M78.6,319.8c0.2-0.1,0.4-0.3,0.3-0.5c0-0.1-0.4-0.3-0.5-0.3c-0.2,0.1-0.3,0.3-0.5,0.5
		C78.3,319.7,78.5,319.9,78.6,319.8z"
      />
      <path
        class="st2"
        d="M250.8,245.8c0,0-0.1-0.1-0.1-0.3c-0.4,0.1-0.7,0.3-1.1,0.5C250,246.5,250.4,246.1,250.8,245.8z"
      />
      <path
        class="st2"
        d="M67.5,323.4c-0.3-0.3-0.5-0.5-0.7-0.7C66.5,323.5,66.5,323.5,67.5,323.4z"
      />
      <path
        class="st2"
        d="M272.3,265.1c-0.1,0.1-0.2,0.1-0.3,0.2l0.1,0.1c0.2,0.2,0.3,0.4,0.5,0.6l0,0c0.1,0,0.1-0.1,0.2-0.1l0.1-0.1
		C272.7,265.6,272.6,265.4,272.3,265.1C272.4,265.2,272.4,265.1,272.3,265.1z"
      />
      <path
        class="st2"
        d="M92.5,292.2c0-0.1-0.2-0.2-0.4-0.3c-0.1,0.2-0.3,0.3-0.3,0.5c0,0,0.3,0.1,0.4,0.2
		C92.4,292.5,92.6,292.4,92.5,292.2z"
      />
      <path
        class="st2"
        d="M221.5,311.5c0.1,0.1,0.3,0.2,0.4,0.2c0.1,0,0.2-0.2,0.3-0.3c-0.1-0.1-0.1-0.2-0.2-0.2
		C221.8,311.2,221.7,311.4,221.5,311.5z"
      />
      <path
        class="st2"
        d="M36,306.2c0.2,0.1,0.3,0.2,0.5,0.2c0.1,0,0.2-0.2,0.4-0.4c-0.3-0.1-0.5-0.2-0.7-0.2
		C36.2,305.9,36.1,306.1,36,306.2z"
      />
      <path
        class="st2"
        d="M82.6,334.5c0,0-0.3,0.2-0.3,0.3c0,0.2,0.2,0.3,0.4,0.5c0.2-0.3,0.4-0.5,0.4-0.6
		C83.1,334.6,82.8,334.6,82.6,334.5z"
      />
      <path
        class="st2"
        d="M204.1,249.7c-0.2,0-0.5,0-0.7-0.1c0,0.2-0.1,0.4-0.2,0.8c0.3-0.2,0.5-0.3,0.6-0.4v0.1l0,0
		c0.1,0.2,0.1,0.4,0.2,0.6c1.1-0.9,1.1-0.9,0.5-1.4C204.4,249.4,204.3,249.6,204.1,249.7L204.1,249.7L204.1,249.7z"
      />
      <path
        class="st2"
        d="M205.5,242.9l0.2,0.1c0.1-0.1,0.3-0.3,0.4-0.4c-0.2-0.1-0.3-0.1-0.4-0.2C205.6,242.6,205.5,242.7,205.5,242.9z
		"
      />
      <path
        class="st2"
        d="M252.5,256.9c0.1,0.1,0.1,0.1,0.2,0.2c0.3-0.2,0.5-0.3,0.8-0.5c-0.1-0.1-0.2-0.1-0.2-0.2
		C253,256.5,252.8,256.7,252.5,256.9z"
      />
      <path
        class="st2"
        d="M93.1,317.8c0.1,0.1,0.3,0.3,0.5,0.3c0.1,0,0.3-0.3,0.5-0.5c-0.3-0.1-0.5-0.2-0.7-0.1
		C93.2,317.5,93,317.7,93.1,317.8z"
      />
      <path
        class="st2"
        d="M303.1,281.9c0.1,0.1,0.3,0.2,0.4,0.2c0.2,0,0.3-0.3,0.5-0.5c-0.2,0-0.3-0.1-0.4-0.1
		C303.5,281.6,303.3,281.8,303.1,281.9z"
      />
      <path
        class="st2"
        d="M246.1,240.3c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0,0.2,0,0.3-0.1c0-0.2,0.1-0.3,0.2-0.7
		C246.6,240,246.3,240.2,246.1,240.3z"
      />
      <path
        class="st2"
        d="M10.4,296.3c0,0,0.3-0.1,0.3-0.2c-0.1-0.2-0.2-0.3-0.3-0.4c-0.2,0.1-0.3,0.2-0.4,0.2
		C10.1,296.1,10.2,296.2,10.4,296.3z"
      />
      <path
        class="st2"
        d="M200.4,278.3c0.1,0,0.2,0,0.2,0c0.1-0.2,0.2-0.4,0.4-0.7c-0.1,0-0.3-0.1-0.4-0.1
		C200.5,277.8,200.5,278,200.4,278.3z"
      />
      <path
        class="st2"
        d="M299.5,272.4c-0.1,0.2-0.2,0.3-0.3,0.5c0,0.1,0.2,0.1,0.4,0.3c0.1-0.3,0.2-0.4,0.2-0.6
		C299.9,272.5,299.6,272.5,299.5,272.4z"
      />
      <path
        class="st2"
        d="M209.6,270.2c0,0.1,0.1,0.3,0.2,0.4c0.1-0.2,0.2-0.4,0.2-0.6c-0.1,0-0.2,0-0.3,0
		C209.7,270.1,209.6,270.2,209.6,270.2z"
      />
      <path
        class="st2"
        d="M238,245.5c-0.2,0.1-0.3,0.2-0.5,0.3c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1,0.1-0.2,0.1-0.3,0.2c0.3,0,0.5,0.1,0.6,0
		c0.2,0,0.4-0.2,0.5-0.5C238,245.7,238,245.6,238,245.5z"
      />
      <path
        class="st2"
        d="M234.6,247.2c0.3-0.1,0.6-0.2,0.9-0.3c0-0.1-0.1-0.2-0.1-0.4c-0.3,0.2-0.6,0.3-0.9,0.5
		C234.6,247,234.6,247.1,234.6,247.2z"
      />
      <path
        class="st2"
        d="M214.4,280.6c0.1,0,0.2,0,0.3,0c0-0.2,0-0.5,0-0.7c-0.1,0-0.2,0-0.3,0C214.5,280.1,214.4,280.3,214.4,280.6z"
      />
      <path
        class="st2"
        d="M305,237c0,0.3,0,0.6,0,0.9C305.4,237.6,305.5,237.3,305,237z"
      />
      <path
        class="st2"
        d="M305,237.9L305,237.9c-0.1,0.1-0.1,0.1-0.1,0.1C305,238,305,238,305,237.9L305,237.9z"
      />
      <path
        class="st2"
        d="M25.4,329.8c0.1,0.3,0.2,0.6,0.4,0.9c0.1-0.1,0.2-0.1,0.4-0.2c-0.2-0.3-0.3-0.5-0.5-0.8
		C25.5,329.7,25.5,329.7,25.4,329.8z"
      />
      <path
        class="st2"
        d="M245,249.5c0.1,0.1,0.1,0.2,0.2,0.3c0.1-0.1,0.3-0.2,0.4-0.2c-0.1-0.1-0.1-0.2-0.2-0.2
		C245.3,249.4,245.1,249.5,245,249.5z"
      />
      <path
        class="st2"
        d="M199.4,251.4c0,0.2-0.1,0.4-0.1,0.6c0.1,0,0.2,0,0.2,0c0.1-0.2,0.1-0.4,0.2-0.6
		C199.7,251.5,199.5,251.4,199.4,251.4z"
      />
      <path
        class="st2"
        d="M83.6,317c-0.1,0-0.2,0-0.3,0.1c0.1,0.2,0.1,0.4,0.2,0.6c0.1,0,0.2,0,0.3-0.1C83.7,317.4,83.6,317.2,83.6,317z
		"
      />
      <path
        class="st2"
        d="M205.9,257.5c0.1,0.1,0.3,0.2,0.4,0.1c0.1,0,0.2-0.2,0.3-0.4c-0.2-0.1-0.4-0.1-0.5-0.1
		C206,257.2,205.8,257.4,205.9,257.5z"
      />
      <path
        class="st2"
        d="M265.8,245.8c-0.1,0.2-0.3,0.4-0.4,0.6c0.2-0.1,0.4-0.3,0.6-0.4C265.9,245.9,265.8,245.9,265.8,245.8z"
      />
      <path
        class="st2"
        d="M265.3,246.4c-0.1,0-0.1,0.1-0.2,0.1l0,0c0,0,0,0,0.1,0S265.3,246.4,265.3,246.4z"
      />
      <path
        class="st2"
        d="M230,270.6c0.1,0.1,0.1,0.1,0.2,0.2c0,0,0,0,0-0.1C230.3,270.6,230.1,270.5,230,270.6z"
      />
      <path
        class="st2"
        d="M201,330.8c0.2,0.2,0.4,0.4,0.6,0.6C201.6,331.1,201.9,330.8,201,330.8z"
      />
      <path
        class="st2"
        d="M201.6,331.4C201.6,331.4,201.6,331.5,201.6,331.4c0,0.1,0.1,0.1,0.1,0.1C201.7,331.5,201.6,331.5,201.6,331.4
		L201.6,331.4z"
      />
      <path
        class="st2"
        d="M93.1,301.5c-0.1-0.1-0.2-0.2-0.3-0.4c-0.1,0.2-0.3,0.3-0.2,0.4c0,0.1,0.2,0.1,0.4,0.1
		C93,301.7,93.2,301.5,93.1,301.5z"
      />
      <path
        class="st2"
        d="M229.1,314.4c0.2,0.1,0.4,0.1,0.6,0.2c0-0.1,0.1-0.2,0.1-0.3c-0.2,0-0.4-0.1-0.6-0.1
		C229.2,314.2,229.1,314.3,229.1,314.4z"
      />
      <path
        class="st2"
        d="M263.4,232.6c-0.1,0-0.2,0.2-0.2,0.2c0,0.1,0.2,0.2,0.2,0.3c0.1-0.1,0.2-0.2,0.4-0.3
		C263.6,232.7,263.5,232.6,263.4,232.6z"
      />
      <path
        class="st2"
        d="M303.1,234.9c-0.1,0.1-0.1,0.2-0.1,0.3s0.1,0.1,0.2,0.1h0.1l0.2-0.2c0-0.1-0.2-0.2-0.3-0.4
		C303.2,234.8,303.2,234.9,303.1,234.9z"
      />
      <path
        class="st2"
        d="M213.7,278.7c-0.2,0-0.4,0-0.6-0.1c0.1,0.1,0.2,0.3,0.4,0.4C213.5,278.9,213.6,278.8,213.7,278.7z"
      />
      <path
        class="st2"
        d="M213.1,278.6C213.1,278.6,213,278.6,213.1,278.6c-0.1-0.1-0.1,0-0.1,0S213,278.6,213.1,278.6z"
      />
      <path
        class="st2"
        d="M306,231.8c-0.1,0.1-0.2,0.2-0.3,0.3c0.1,0.1,0.2,0.2,0.3,0.2V231.8z"
      />
      <path
        class="st2"
        d="M204.2,256.7c0.1,0,0.1,0,0.2,0c0.1-0.2,0.2-0.4,0.3-0.5c-0.1,0-0.2-0.1-0.3-0.1
		C204.3,256.3,204.2,256.5,204.2,256.7z"
      />
      <path
        class="st2"
        d="M202.1,269.1c0.2,0,0.3,0.1,0.5,0c0.1,0,0.2-0.2,0.5-0.4c-0.4,0-0.5,0-0.6,0.1
		C202.3,268.9,202.2,269,202.1,269.1z"
      />
      <path
        class="st2"
        d="M304.7,233.2c0.1-0.1,0.3-0.2,0.3-0.3s-0.1-0.2-0.4-0.5c-0.1,0.3-0.2,0.5-0.1,0.6
		C304.4,233.1,304.6,233.2,304.7,233.2z"
      />
      <path
        class="st2"
        d="M204.9,280.7c0.1,0,0.2,0,0.3,0c0.1-0.2,0.2-0.4,0.3-0.7c-0.1,0-0.2,0-0.4,0
		C205,280.2,204.9,280.5,204.9,280.7z"
      />
      <path
        class="st2"
        d="M127,296.9C127,296.9,127,296.8,127,296.9c-0.1-0.1-0.1-0.1-0.1-0.1l0,0C127,296.9,127,296.9,127,296.9z"
      />
      <path
        class="st2"
        d="M127,296.9c0.2,0.2,0.4,0.5,0.6,0.8C127.9,296.9,127.4,297,127,296.9z"
      />
      <path
        class="st2"
        d="M183.9,283.3c-0.2,0.1-0.3,0.2-0.5,0.4c0.1,0.1,0.2,0.2,0.3,0.2c0.1-0.1,0.3-0.3,0.4-0.4
		C184.1,283.5,184,283.4,183.9,283.3z"
      />
      <path
        class="st2"
        d="M212.8,278c0.1,0.2,0.1,0.3,0.2,0.5c0-0.2,0.1-0.3,0.1-0.5C213,278,212.9,278,212.8,278z"
      />
      <path
        class="st2"
        d="M244.2,260.5l0.1,0.1c0.1,0.1,0.2,0.2,0.2,0.2c0.1-0.1,0.2-0.1,0.3-0.2l0.1-0.1h-0.1c-0.1,0-0.2,0-0.4,0
		C244.3,260.5,244.3,260.5,244.2,260.5z"
      />
      <path
        class="st2"
        d="M198.1,274.4l0.1,0.1c0.1-0.1,0.2-0.2,0.3-0.3c0,0-0.1-0.1-0.2-0.2C198.2,274.1,198.1,274.2,198.1,274.4z"
      />
      <path
        class="st2"
        d="M248.5,251.5c-0.1,0.1-0.2,0.2-0.2,0.4c0,0,0.2,0.1,0.4,0.2c0.1-0.2,0.2-0.3,0.2-0.4
		C248.8,251.6,248.5,251.5,248.5,251.5z"
      />
      <path
        class="st2"
        d="M90.4,312.2c0.1,0.1,0.2,0.1,0.4,0.2c0-0.1,0.1-0.2,0.1-0.3c-0.1,0-0.2-0.1-0.4-0.1
		C90.5,312,90.4,312.2,90.4,312.2z"
      />
      <path
        class="st2"
        d="M203.6,241.3c0.1,0.1,0.2,0.1,0.2,0.2l0.1-0.1C203.9,241.3,203.8,241.3,203.6,241.3
		C203.6,241.2,203.6,241.3,203.6,241.3z"
      />
      <path
        class="st2"
        d="M238.7,290.6l0.1,0.1c0.1,0,0.2-0.1,0.3-0.1c-0.1-0.1-0.1-0.1-0.2-0.2C238.8,290.4,238.7,290.5,238.7,290.6z"
      />
      <path
        class="st2"
        d="M290.9,255.5c0,0.1,0,0.1,0.1,0.2c0,0.1,0.1,0.2,0.1,0.3c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.2-0.2-0.2-0.3
		C291,255.6,291,255.6,290.9,255.5z"
      />
      <path
        class="st2"
        d="M58.7,312.1c0,0.1,0,0.3-0.1,0.4c0.1-0.1,0.2-0.2,0.3-0.3C58.9,312.1,58.8,312.1,58.7,312.1z"
      />
      <path
        class="st2"
        d="M58.7,312.5C58.6,312.5,58.6,312.5,58.7,312.5c-0.1,0.1-0.1,0.1-0.1,0.2h0.1C58.7,312.6,58.7,312.5,58.7,312.5
		z"
      />
      <path
        class="st2"
        d="M238.2,246.6C238.3,246.6,238.2,246.5,238.2,246.6c-0.2-0.1-0.4-0.1-0.6-0.1c0,0.1,0,0.2,0,0.3
		C237.9,246.8,238.1,246.7,238.2,246.6z"
      />
      <path
        class="st2"
        d="M129.9,335c-0.1,0-0.2,0.1-0.2,0.1c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.3-0.1
		C130,335.1,130,335,129.9,335z"
      />
      <path
        class="st2"
        d="M108.7,277.3c0.1,0.1,0.2,0.1,0.3,0.2c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.1-0.3-0.1
		C108.9,277.1,108.8,277.2,108.7,277.3z"
      />
      <path
        class="st2"
        d="M67.2,310.8c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1-0.1-0.1-0.1-0.2-0.1C67.2,310.6,67.2,310.7,67.2,310.8z"
      />
      <path
        class="st2"
        d="M205.7,256.9c0.1,0,0.2-0.1,0.4-0.2c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0.1-0.2,0.2-0.3,0.3
		C205.5,256.8,205.6,256.9,205.7,256.9z"
      />
      <path
        class="st2"
        d="M248.2,250.9c-0.6,0.2-0.8,0.3-1,0.3c0.1,0.1,0.1,0.2,0.2,0.3C247.6,251.4,247.8,251.3,248.2,250.9z"
      />
      <path
        class="st2"
        d="M292.5,256.1c-0.1,0.1-0.2,0.1-0.2,0.2s0.1,0.2,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2
		C292.6,256.2,292.5,256.2,292.5,256.1z"
      />
      <path
        class="st2"
        d="M304.9,238c-0.1,0.1-0.1,0.1-0.2,0.2l0.1,0.1C304.9,238.2,304.9,238.1,304.9,238z"
      />
      <path
        class="st2"
        d="M162.2,310.7C162.2,310.7,162.3,310.7,162.2,310.7c0.1,0.1,0.2,0.2,0.2,0.2s0,0,0.1,0s0.1-0.1,0.2-0.1
		c-0.1-0.1-0.2-0.2-0.3-0.2C162.3,310.6,162.3,310.6,162.2,310.7z"
      />
      <path
        class="st2"
        d="M251.6,254.2L251.6,254.2c0.1,0.2,0.1,0.2,0.2,0.3c0.1-0.1,0.2-0.1,0.2-0.2l0,0c-0.1-0.1-0.1-0.2-0.2-0.2
		C251.7,254,251.5,254.1,251.6,254.2z"
      />
      <path
        class="st2"
        d="M62.5,321c0.1,0,0.2,0.2,0.3,0.1c0.1,0,0.2-0.2,0.3-0.2c-0.1-0.1-0.2-0.2-0.3-0.2
		C62.7,320.7,62.6,320.9,62.5,321z"
      />
      <path
        class="st2"
        d="M209.4,266.8c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.3-0.1c-0.1-0.1-0.1-0.2-0.2-0.2
		C209.6,266.7,209.5,266.7,209.4,266.8z"
      />
      <path
        class="st2"
        d="M195.7,272.9c0,0.1,0.2,0.1,0.3,0.1c0-0.1,0.1-0.3,0.1-0.4c0,0-0.2,0-0.4-0.1
		C195.7,272.7,195.6,272.8,195.7,272.9z"
      />
      <path
        class="st2"
        d="M118.9,284.1l0.1,0.1c0.1,0.1,0.1,0.1,0.2,0.2c0.1-0.1,0.2-0.1,0.3-0.2c-0.1,0-0.2-0.1-0.3-0.1
		c-0.1,0-0.1,0-0.2-0.1L118.9,284.1z"
      />
      <path
        class="st2"
        d="M297.9,255.5c-0.1,0-0.1,0.2-0.1,0.3l0,0c0.1,0,0.2,0,0.2,0s0-0.1,0.1-0.1c0-0.1,0.1-0.1,0.1-0.2
		C298.1,255.5,298,255.5,297.9,255.5z"
      />
      <path
        class="st2"
        d="M291.9,256.9c-0.1,0-0.2,0.1-0.3,0.1c0.1,0.1,0.2,0.2,0.2,0.3c0.1-0.1,0.2-0.1,0.2-0.2
		C292.1,257.1,292,257,291.9,256.9z"
      />
      <path
        class="st2"
        d="M293.8,282.7c0.1,0,0.2,0,0.3,0c0.1-0.1,0.1-0.2,0.2-0.3c-0.1,0-0.2-0.1-0.3-0.1
		C293.8,282.4,293.8,282.6,293.8,282.7z"
      />
      <path
        class="st2"
        d="M249.2,266L249.2,266C249.3,266,249.3,266,249.2,266C249.3,265.9,249.2,266,249.2,266L249.2,266z"
      />
      <path
        class="st2"
        d="M249,266.3c0.1-0.1,0.1-0.2,0.2-0.3c-0.1,0-0.2,0.1-0.4,0.1C248.9,266.2,248.9,266.2,249,266.3z"
      />
      <path
        class="st2"
        d="M40,311.2c-0.1,0-0.2-0.1-0.2-0.1c0,0.1,0,0.2,0,0.3c0.1,0,0.2,0,0.2,0S40,311.3,40,311.2z"
      />
      <path
        class="st2"
        d="M201.8,331.9c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.1-0.3-0.2C201.7,331.7,201.8,331.8,201.8,331.9z"
      />
      <path
        class="st2"
        d="M231.3,243.3C231.3,243.3,231.3,243.4,231.3,243.3c0,0.1,0.1,0.1,0.1,0.1v-0.1
		C231.4,243.3,231.3,243.3,231.3,243.3z"
      />
      <path
        class="st2"
        d="M228.3,243.6h0.1C228.4,243.5,228.4,243.5,228.3,243.6C228.3,243.5,228.3,243.5,228.3,243.6
		C228.3,243.5,228.3,243.6,228.3,243.6z"
      />
      <path
        class="st2"
        d="M227.9,243.9c0.1-0.1,0.2-0.2,0.4-0.3c-0.2,0-0.3,0.1-0.5,0.1C227.8,243.8,227.9,243.9,227.9,243.9z"
      />
      <path
        class="st2"
        d="M242.3,240.3c-0.1,0-0.2-0.1-0.3-0.1l-0.1,0.1c0.1,0,0.2,0,0.3,0C242.2,240.5,242.3,240.4,242.3,240.3z"
      />
      <path
        class="st2"
        d="M259,241.3l-0.1,0.1c0,0.1,0.1,0.1,0.2,0.1c0.1-0.1,0.1-0.1,0.2-0.2C259.2,241.3,259.1,241.3,259,241.3z"
      />
      <path
        class="st2"
        d="M253.5,236.3l0.1,0.1c0.1,0,0.1,0,0.2,0c-0.1,0-0.1-0.1-0.2-0.1H253.5z"
      />
      <path
        class="st2"
        d="M198,247.4c-0.1,0-0.1,0-0.2,0c0,0.1,0,0.1,0,0.2C197.9,247.5,198,247.5,198,247.4
		C198,247.5,198,247.4,198,247.4z"
      />
      <path
        class="st2"
        d="M192.7,248.3c0,0,0.1,0.1,0.1,0.2l0,0l0,0C192.7,248.4,192.7,248.3,192.7,248.3z"
      />
      <path
        class="st2"
        d="M114.6,296.9l-0.1-0.1c-0.1,0-0.2,0.1-0.3,0.2c0.1,0,0.1,0.1,0.2,0.1C114.4,297,114.5,296.9,114.6,296.9z"
      />
      <path
        class="st2"
        d="M10.7,316.2l0.1,0.1c0.1,0,0.2-0.1,0.3-0.2L11,316C10.9,316.1,10.8,316.1,10.7,316.2z"
      />
      <path
        class="st2"
        d="M207,243.1v0.1c0,0.1,0,0.1,0,0.2c0-0.1,0.1-0.1,0.1-0.2C207.1,243.2,207,243.1,207,243.1z"
      />
      <path
        class="st2"
        d="M200.8,240.9c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2-0.1,0.2-0.2C201.1,240.8,201,240.8,200.8,240.9
		C200.8,240.8,200.8,240.9,200.8,240.9z"
      />
      <path
        class="st2"
        d="M144.2,292.6l0.1,0.1c0.1-0.1,0.2-0.1,0.3-0.2l-0.1-0.1C144.4,292.5,144.3,292.6,144.2,292.6z"
      />
      <path
        class="st2"
        d="M121.9,297.8c0,0.1,0.1,0.2,0.2,0.2c0-0.1,0.1-0.1,0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.2
		C121.9,297.8,121.8,297.8,121.9,297.8z"
      />
      <path
        class="st2"
        d="M204.3,310.1c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.1-0.1-0.2-0.2
		C204.4,310,204.3,310.1,204.3,310.1z"
      />
      <path
        class="st2"
        d="M181.3,285.9c0.1,0,0.2,0.1,0.2,0.1c0.1,0,0.1-0.1,0.2-0.2c-0.1,0-0.2,0-0.3,0
		C181.3,285.8,181.3,285.8,181.3,285.9z"
      />
      <path
        class="st2"
        d="M188.9,260.6c0-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2s0.1,0.1,0.1,0.2
		C188.8,260.7,188.9,260.7,188.9,260.6z"
      />
      <path
        class="st2"
        d="M225.8,277.1c0,0.2,0,0.3,0.1,0.5c0.1,0,0.1,0,0.2,0c0-0.1-0.1-0.3-0.1-0.4
		C225.9,277.1,225.9,277.1,225.8,277.1z"
      />
      <path
        class="st2"
        d="M88.2,307.3c0,0.1-0.1,0.2-0.1,0.3c0,0,0.1,0,0.2,0.1c0-0.1,0.1-0.2,0.1-0.2C88.4,307.4,88.2,307.3,88.2,307.3
		z"
      />
      <path
        class="st2"
        d="M236.1,275.7c0,0.1,0.2,0.1,0.2,0.1c0-0.1,0.1-0.2,0.1-0.3l-0.2-0.1C236.1,275.5,236.1,275.6,236.1,275.7z"
      />
      <path
        class="st2"
        d="M254.3,259.6c0,0.1,0.1,0.1,0.1,0.2l0.1-0.1c0,0,0-0.1-0.1-0.1C254.5,259.5,254.4,259.6,254.3,259.6z"
      />
      <path
        class="st2"
        d="M240.2,262.1c0.1,0,0.2,0,0.3,0l0,0c0,0,0-0.1,0.1-0.1c-0.1,0-0.2,0-0.3,0C240.3,262,240.3,262,240.2,262.1
		C240.3,262,240.3,262.1,240.2,262.1z"
      />
      <path
        class="st2"
        d="M201.8,270.6c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2c-0.1,0-0.1-0.1-0.2-0.1
		C201.9,270.6,201.8,270.6,201.8,270.6z"
      />
      <path
        class="st2"
        d="M195.3,272.2c0,0,0.2,0,0.2,0.1c0-0.1,0.1-0.2,0.1-0.2s-0.1-0.1-0.2-0.1C195.3,272,195.3,272.1,195.3,272.2z"
      />
      <path
        class="st2"
        d="M25.2,308.7c0,0.1,0,0.1,0,0.2v0.1l0.1,0.1l0.1-0.1c0,0,0-0.1-0.1-0.1C25.2,308.8,25.2,308.8,25.2,308.7z"
      />
      <path
        class="st2"
        d="M161.9,310.1c0,0,0.1,0.1,0.2,0.1c0-0.1,0-0.2,0.1-0.2c-0.1,0-0.1-0.1-0.2-0.1
		C161.9,309.9,161.9,310,161.9,310.1z"
      />
      <path
        class="st2"
        d="M267.6,246.9l0.1-0.1c-0.1,0-0.2-0.1-0.3-0.1l-0.1,0.1C267.4,246.8,267.5,246.9,267.6,246.9z"
      />
      <path
        class="st2"
        d="M216.1,283.8c0.1,0,0.2,0,0.2,0v-0.1c0,0-0.1-0.1-0.2-0.1C216.1,283.7,216.1,283.8,216.1,283.8z"
      />
      <path
        class="st2"
        d="M243.1,252.7c0,0,0-0.1,0.1-0.1c0,0,0-0.1-0.1-0.1c0,0-0.1,0.1,0,0.1C243,252.6,243.1,252.7,243.1,252.7z"
      />
      <path
        class="st2"
        d="M238.2,289.9c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1,0-0.2,0-0.3,0C238.3,289.7,238.2,289.8,238.2,289.9z"
      />
      <path
        class="st2"
        d="M277.8,245.7c-0.1,0-0.2,0.1-0.3,0.1c0.1,0,0.1,0.1,0.1,0.1c0.1,0,0.2-0.1,0.3-0.1
		C277.9,245.8,277.9,245.7,277.8,245.7z"
      />
      <path
        class="st2"
        d="M222.6,282.8v-0.1h-0.1C222.5,282.7,222.5,282.7,222.6,282.8C222.5,282.8,222.5,282.8,222.6,282.8z"
      />
      <path
        class="st2"
        d="M223.1,283.4c-0.1,0-0.2,0-0.3,0c0.1,0,0.1,0,0.2,0C223,283.5,223,283.4,223.1,283.4z"
      />
      <path
        class="st2"
        d="M50.9,321.9L51,322c0.1,0,0.2-0.1,0.3-0.2c-0.1,0-0.2,0-0.3,0L50.9,321.9z"
      />
      <path
        class="st2"
        d="M198.5,264.1c0,0,0.1,0,0.1,0.1c0-0.1,0-0.2,0.1-0.3c0,0-0.1,0-0.1-0.1C198.6,264,198.5,264,198.5,264.1z"
      />
      <path
        class="st2"
        d="M252.2,252.3L252.2,252.3c-0.5,0-0.6,0-0.8,0c0,0.1,0,0.1,0,0.2C251.6,252.6,251.8,252.5,252.2,252.3
		L252.2,252.3z"
      />
      <path
        class="st2"
        d="M274.1,248.3c0.1,0.1,0.2,0.2,0.4,0.2c-0.1-0.1-0.1-0.3-0.2-0.4C274.2,248.2,274.1,248.2,274.1,248.3z"
      />
      <path
        class="st2"
        d="M274.5,248.6C274.5,248.5,274.4,248.5,274.5,248.6C274.4,248.5,274.4,248.6,274.5,248.6L274.5,248.6
		L274.5,248.6L274.5,248.6L274.5,248.6z"
      />
      <path
        class="st2"
        d="M243.2,255.2L243.2,255.2c0.2,0.1,0.4,0.1,0.6,0.1c0-0.1,0-0.1,0-0.2C243.5,255,243.4,255.1,243.2,255.2z"
      />
      <path
        class="st2"
        d="M279.6,273L279.6,273c0.1,0,0.2-0.1,0.2-0.1h-0.1L279.6,273z"
      />
      <path
        class="st2"
        d="M268.4,250c0,0,0,0.1,0.1,0.1l0.1,0.1c0,0,0-0.1-0.1-0.1L268.4,250z"
      />
      <path
        class="st2"
        d="M268.3,249.9c-0.4-0.2-0.9-0.5-1.3-0.7c-0.7-0.3-1.5-0.3-2.2-0.1c-0.3,0.1-0.5,0.2-0.7,0.4s-0.4,0.3-0.5,0.5
		c1.1,0.8,2.2,1.7,3.4,2.5c0.5-0.3,0.8-0.7,1-1.3c0-0.2,0.1-0.3,0.1-0.5C268,250.5,268.2,250.2,268.3,249.9
		C268.3,250,268.3,250,268.3,249.9C268.3,250,268.3,249.9,268.3,249.9L268.3,249.9z"
      />
      <path
        class="st2"
        d="M274.5,248.9c0.1,0.1,0.2,0.1,0.3,0.2c0-0.1,0-0.3,0-0.4c0-0.1-0.2-0.1-0.3-0.1
		C274.5,248.7,274.5,248.8,274.5,248.9z"
      />
      <path
        class="st2"
        d="M261,278.1L261,278.1c-0.1-0.1-0.3-0.2-0.4-0.2h-0.1c0,0,0.1,0,0.1,0.1C260.7,278,260.9,278.1,261,278.1
		C261,278.2,261.1,278.2,261,278.1C261.1,278.2,261.1,278.2,261,278.1C261.1,278.1,261,278.1,261,278.1z"
      />
      <path
        class="st2"
        d="M261.2,278.5c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.2-0.1-0.3-0.1C261.1,278.3,261.2,278.4,261.2,278.5z"
      />
      <polygon class="st2" points="60.1,322.3 60.2,322.3 60.2,322.2 	" />
      <path
        class="st2"
        d="M204.5,265.7c-0.1,0-0.1,0-0.2,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.2-0.1
		C204.6,265.8,204.6,265.7,204.5,265.7z"
      />
      <path
        class="st2"
        d="M97.2,314c-0.1,0-0.2,0.1-0.3,0.2l0.1,0.1c0.1,0,0.1-0.1,0.2-0.1h0.1C97.3,314.1,97.2,314.1,97.2,314
		C97.2,314.1,97.2,314,97.2,314z"
      />
      <path
        class="st2"
        d="M269.2,252l0.1,0.1c0-0.1,0.1-0.2,0.1-0.2s-0.1-0.1-0.2-0.1C269.2,251.9,269.2,252,269.2,252z"
      />
      <path
        class="st2"
        d="M2,311.1L2,311.1C2.1,311.2,2.1,311.2,2,311.1L2,311.1c0.1,0,0.1,0,0.1-0.1c0,0,0,0,0-0.1
		C2.1,311,2,311,2,311.1z"
      />
      <path
        class="st2"
        d="M89.6,292.3c-0.1,0.1-0.2,0.1-0.2,0.2s0.1,0.1,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2
		C89.7,292.4,89.6,292.4,89.6,292.3z"
      />
      <path
        class="st2"
        d="M25.3,303.4l-0.1-0.1c0,0.1,0,0.1,0,0.2C25.2,303.4,25.3,303.4,25.3,303.4z"
      />
      <path
        class="st2"
        d="M12.9,304.8L12.9,304.8L12.9,304.8c0-0.1,0.1-0.1,0.1-0.2l0,0l0,0C13,304.7,13,304.7,12.9,304.8z"
      />
      <path
        class="st2"
        d="M196.7,264.8v0.1V264.8c0.1,0,0.1-0.1,0.1-0.1C196.7,264.7,196.7,264.8,196.7,264.8z"
      />
      <path
        class="st2"
        d="M45.1,295.9c0,0-0.1,0-0.1-0.1c0,0.1-0.1,0.1-0.1,0.2H45C45,296,45.1,296,45.1,295.9z"
      />
      <polygon class="st2" points="246.1,260.6 245.9,260.5 245.9,260.6 	" />
      <polygon class="st2" points="193.5,261.6 193.6,261.6 193.5,261.5 	" />
      <path
        class="st2"
        d="M272.2,244c0-0.1,0-0.1,0-0.2c-0.1,0-0.1,0.1-0.2,0.1C272.1,243.9,272.2,243.9,272.2,244z"
      />
      <path
        class="st2"
        d="M272.6,243.4L272.6,243.4L272.6,243.4c-0.1,0.1-0.2,0.3-0.3,0.4l0,0C272.4,243.6,272.5,243.5,272.6,243.4
		L272.6,243.4C272.6,243.4,272.6,243.3,272.6,243.4C272.6,243.3,272.6,243.3,272.6,243.4z"
      />
      <path
        class="st2"
        d="M272.7,243.1c0,0.1,0,0.1-0.1,0.2c0.1,0,0.2-0.1,0.2-0.1C272.8,243.2,272.7,243.2,272.7,243.1z"
      />
      <path
        class="st2"
        d="M246.2,248.5C246.3,248.4,246.3,248.4,246.2,248.5C246.3,248.4,246.2,248.4,246.2,248.5L246.2,248.5z"
      />
      <path
        class="st2"
        d="M246.3,248.3c0,0,0,0.1-0.1,0.1C246.3,248.4,246.3,248.4,246.3,248.3L246.3,248.3z"
      />
      <path
        class="st2"
        d="M207.6,256.3l0.1,0.1l0.1-0.1C207.8,256.3,207.7,256.3,207.6,256.3L207.6,256.3z"
      />
      <polygon class="st2" points="290.8,252.7 290.8,252.8 290.9,252.7 	" />
      <polygon class="st2" points="304.5,234.5 304.5,234.4 304.3,234.4 	" />
      <path
        class="st2"
        d="M240.9,264.7c-0.1,0-0.2,0-0.3,0c0,0.1,0.1,0.1,0.1,0.2C240.8,264.9,240.8,264.8,240.9,264.7z"
      />
      <polygon class="st2" points="9,297.5 9.1,297.5 9,297.4 	" />
      <path
        class="st2"
        d="M199.9,274l0.1,0.1l0.1-0.1l-0.1-0.1C200,273.9,199.9,273.9,199.9,274z"
      />
      <path
        class="st2"
        d="M45.9,307.9c0,0.1,0,0.1,0,0.2L46,308C46,307.9,46,307.9,45.9,307.9z"
      />
      <polygon class="st2" points="200.4,274.5 200.5,274.6 200.5,274.5 	" />
      <path
        class="st2"
        d="M194.3,256.7c0,0,0.1,0,0.1,0.1l0.1-0.1l-0.1-0.1C194.3,256.6,194.3,256.7,194.3,256.7z"
      />
      <path
        class="st2"
        d="M290.4,255.1c-0.1,0-0.2,0-0.3,0C290.2,255.2,290.3,255.2,290.4,255.1c0.1,0.1,0.3,0.2,0.4,0.3l0.1,0.1
		c0-0.1,0-0.1-0.1-0.2C290.7,255.3,290.6,255.2,290.4,255.1z"
      />
      <path
        class="st2"
        d="M208.3,253.4C208.3,253.5,208.4,253.5,208.3,253.4C208.4,253.5,208.4,253.5,208.3,253.4c0.1,0.1,0.1,0,0.1,0
		C208.4,253.5,208.3,253.5,208.3,253.4z"
      />
      <polygon class="st2" points="42.2,310 42.3,310.1 42.3,310 	" />
      <path
        class="st2"
        d="M240.6,267.5l0.1-0.1c-0.1,0-0.2,0.1-0.3,0.1C240.5,267.4,240.5,267.5,240.6,267.5z"
      />
      <path
        class="st2"
        d="M290.5,256.5h-0.1l0,0C290.4,256.6,290.5,256.5,290.5,256.5z"
      />
      <path
        class="st2"
        d="M234,246.2c0,0-0.1-0.1-0.2-0.1l0,0l0,0C233.9,246.2,234,246.2,234,246.2z"
      />
      <path
        class="st2"
        d="M249.3,265.9c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.1,0-0.2-0.1C249.3,265.8,249.3,265.9,249.3,265.9z"
      />
      <path
        class="st2"
        d="M252.6,237.3L252.6,237.3c-0.1,0.1-0.1,0.1-0.1,0.1l0,0L252.6,237.3z"
      />
      <path
        class="st2"
        d="M240,240l0.1-0.1l-0.1-0.1l-0.1,0.1C239.9,240,239.9,240,240,240z"
      />
      <path
        class="st2"
        d="M262.8,234.6c0,0.1,0,0.2,0.1,0.2l0.1-0.1C263,234.6,262.9,234.6,262.8,234.6z"
      />
      <path
        class="st2"
        d="M201.2,246.7c0,0,0.1,0,0.1,0.1l0.1-0.1l-0.1-0.1C201.3,246.6,201.3,246.7,201.2,246.7z"
      />
      <path
        class="st2"
        d="M253.4,235.1l0.1-0.1C253.5,235,253.5,235,253.4,235.1C253.4,235,253.5,235.1,253.4,235.1z"
      />
      <path
        class="st2"
        d="M253.5,235C253.6,235,253.6,235,253.5,235c0.1-0.1,0.1-0.1,0.1-0.1S253.6,234.9,253.5,235L253.5,235z"
      />
      <polygon class="st2" points="203.5,244.7 203.6,244.7 203.6,244.6 	" />
      <path
        class="st2"
        d="M220.7,273.8l0.1,0.1C220.8,273.9,220.8,273.8,220.7,273.8L220.7,273.8z"
      />
      <path
        class="st2"
        d="M220.8,274C220.8,274,220.8,273.9,220.8,274L220.8,274c0.1,0,0.3,0,0.4-0.1l0,0l0,0
		C221.1,273.9,221,274,220.8,274z"
      />
      <path
        class="st2"
        d="M114.8,297.6l-0.1,0.1l0.1,0.1l0.1-0.1C114.9,297.7,114.8,297.7,114.8,297.6z"
      />
      <polygon class="st2" points="85.2,306.1 85.3,306 85.2,306 	" />
      <polygon class="st2" points="179.8,286.8 179.9,286.8 179.9,286.7 	" />
      <polygon class="st2" points="181.7,286.7 181.9,286.7 181.9,286.6 	" />
      <path
        class="st2"
        d="M235.9,275c-0.1,0-0.2,0.1-0.3,0.1l0.1,0.1C235.8,275.1,235.8,275,235.9,275z"
      />
      <path
        class="st2"
        d="M292,265.7l0.1,0.1l0.1-0.1l-0.1-0.1C292.1,265.6,292,265.6,292,265.7z"
      />
      <polygon class="st2" points="69.9,314.8 70,314.7 69.9,314.7 	" />
      <path
        class="st2"
        d="M292.6,266.3l-0.1,0.1l0.1,0.1l0.1-0.1C292.7,266.4,292.7,266.3,292.6,266.3z"
      />
      <polygon
        class="st2"
        points="172.1,302.2 172.2,302.3 172.2,302.2 172.3,302.2 172.2,302.2 	"
      />
      <path
        class="st2"
        d="M278,283.4c0.1,0,0.2,0.1,0.2,0.1h0.1c0,0,0,0,0-0.1C278.1,283.5,278.1,283.5,278,283.4z"
      />
      <path
        class="st2"
        d="M44.1,334.7c0.1,0,0.1,0,0.2,0.1v-0.1l-0.1-0.1C44.1,334.6,44.1,334.7,44.1,334.7z"
      />
      <path
        class="st2"
        d="M224.9,298.6L224.9,298.6c0.1-0.1,0.1-0.1,0.1-0.1l0,0L224.9,298.6z"
      />
      <path
        class="st2"
        d="M296.9,289.1c0-0.1,0.1-0.2,0.1-0.2c0-0.1,0-0.1,0-0.2c0,0,0,0.1-0.1,0.1C296.9,288.9,296.9,289,296.9,289.1z"
      />
      <path
        class="st2"
        d="M203.7,316.1l0.1,0.1l0.1-0.1C203.9,316,203.8,316,203.7,316.1C203.8,316,203.7,316,203.7,316.1z"
      />
      <path
        class="st2"
        d="M229.4,313.7l-0.1-0.1l-0.1,0.1l0.1,0.1C229.3,313.8,229.3,313.8,229.4,313.7z"
      />
      <polygon class="st2" points="193.8,333.6 193.9,333.6 193.9,333.5 	" />
      <path
        class="st2"
        d="M228.1,268c0.1-0.1,0.1-0.2,0.2-0.2l0,0l0,0C228.2,267.8,228.2,267.9,228.1,268z"
      />
      <path
        class="st2"
        d="M55.3,141.5c0,0.2,0.1,0.5,0.3,0.7C55.5,142,55.4,141.7,55.3,141.5z"
      />
      <path
        class="st2"
        d="M58.6,144.6c-0.8-1.7-1.6-3.5-2.4-5.2c-0.1,0.1-0.2,0.2-0.3,0.4c0.7,1.5,1.4,3,2,4.5
		C58.2,144.5,58.4,144.6,58.6,144.6z"
      />
      <path
        class="st2"
        d="M60.9,134.6C60.9,134.7,60.9,134.7,60.9,134.6c-0.5,1-0.4,2.1,0,3.6c-0.7,0-1.2-0.1-1.7-0.1
		c-0.7,0.1-1.3,0.2-1.8,0.5c0.9,2,1.8,3.9,2.6,5.9c1.8-0.5,3.2-2,3-3.6c0-0.4-0.2-0.9-0.3-1.4c2.8,0.2,4.6-0.3,5.7-1.6
		c0.1-0.2,0.3-0.4,0.4-0.6c0.2-0.4,0.3-0.7,0.4-1.1c0.2-0.9-0.1-1.8-0.7-2.5c-0.2-0.2-0.4-0.5-0.7-0.7c-0.5-0.4-1.2-0.6-1.9-0.7
		c-1-0.1-2,0-2.9,0.4c-0.1,0.1-0.2,0.1-0.4,0.2c-0.4,0.2-0.7,0.4-0.9,0.6C61.4,133.9,61.1,134.2,60.9,134.6z"
      />
      <path
        class="st2"
        d="M121,133.1c0.2-0.1,0.3-0.1,0.5-0.2c1.4-0.6,2.8-1.1,4.1-1.7c0.3-0.1,0.6-0.2,0.9-0.4c-0.3-0.1-0.7-0.1-1-0.2
		c-0.7-0.1-1.3-0.2-1.9-0.3c-0.2,0-0.4-0.1-0.6-0.1c-0.7-0.1-1.2,0.4-1.3,1.2l0,0c0,0.5-0.4,0.6-0.7,0.8c-0.5,0.3-0.9,0.7-1,1.1
		c0,0.1,0,0.1-0.1,0.2c0.2-0.1,0.5-0.2,0.7-0.3C120.8,133.2,120.9,133.2,121,133.1z"
      />
      <path
        class="st2"
        d="M125.6,139.1c-0.1,0.2-0.2,0.4-0.1,0.6c0,0.1,0,0.2,0,0.2c0.2,0.7,1.1,1.2,2,1.1c0.1,0,0.1,0,0.2,0
		c1.2-0.3,1.7-1.2,1.3-2.9c1,0.1,2,0.2,3.2,0.2c-0.8-0.8-1-1-0.9-1.7c0-0.2,0.1-0.4,0.2-0.7c1.8,0.5,3.7,1.1,5.6,1.7
		c0-0.4,0.1-0.5,0-0.6c-0.5-0.9-1.2-1.6-1.1-2.8c0.1-0.9-1.4-1.4-2.4-0.8c-0.8,0.5-1.5,0.4-2.3,0.3c-0.4-0.1-0.8-0.2-1.2-0.3
		c-0.5-0.1-1-0.3-1.5-0.5c-0.5,0.2-1,0.4-1.5,0.6c0.4,0.2,0.9,0.4,1.3,0.5c0.1,0,0.1,0.4,0.1,0.7c-0.8-0.3-1.4-0.5-2.3-0.9
		c0.5,1.3,0.8,2.5,1.2,3.6c0,0.1,0.1,0.3,0.1,0.4C126.7,138.1,125.9,138.5,125.6,139.1z"
      />
      <path
        class="st2"
        d="M121.3,136.1c0.8-0.3,1.6-0.5,2.4-0.9c0.3-0.1,0.4-0.3,0.5-0.5c-1,0.4-2.1,0.8-3.1,1.2
		C121.2,136,121.3,136.1,121.3,136.1z"
      />
      <path
        class="st2"
        d="M4.6,180.4c0.6,0.7,1.2,1.5,1.7,2.3c0,0.1,0.1,0.1,0.2,0.2c0.5,0.7,1.2,1,2.3,0.9c0.7-0.1,1.4-0.2,1.9-0.5
		c0.9-0.5,1.8-1.3,2.6-1.8c0,0.3,0,0.6,0.1,0.9c0,0.1,0,0.3,0,0.4c0.1,0,0.2,0,0.3,0c0.1-0.1,0.2-0.3,0.2-0.4c0-0.1,0-0.2,0-0.4
		c-0.1-0.6-0.1-1.2-0.2-1.8c0-0.2,0-0.5-0.1-0.7c-0.1-1.3-0.9-2.3-2.2-3c-0.1,0-0.1,0-0.2-0.1c-2.4-1.1-5.4-0.3-6.6,1.9
		C4.1,179,4.1,179.7,4.6,180.4C4.6,180.3,4.6,180.4,4.6,180.4z"
      />
      <path
        class="st2"
        d="M87.7,124.6c2.4-0.5,3.9-2.3,3.6-4.3c0-0.2-0.1-0.5-0.2-0.7c-2.6,1-5.3,2-7.9,3
		C83.8,124.2,85.6,125,87.7,124.6z"
      />
      <path
        class="st2"
        d="M82.8,121.3c2.4-0.9,4.9-1.9,7.3-2.8c-0.9-0.8-2.4-1.2-3.8-0.9C84.2,118.2,82.8,119.8,82.8,121.3z"
      />
      <path
        class="st2"
        d="M194.9,111.3c0.2,0.1,0.3,0.2,0.5,0.3c1.1-0.3,2.3-0.5,3.4-0.8c0.2,0,0.4-0.1,0.6-0.1c0.2-0.2,0.3-0.3,0.5-0.5
		c-0.4,0.1-0.8,0.2-1.2,0.3C197.4,110.7,196.2,111,194.9,111.3z"
      />
      <path
        class="st2"
        d="M195.5,116.7c0.8,0.7,1.9,0.6,2.8-0.2c0.9-0.8,0.9-1.7,0.1-2.3c-0.4-0.3-0.8-0.5-1.3-0.8
		c0.2-0.4,0.3-0.7,0.5-1c-0.2,0.1-0.5,0.1-0.7,0.2c-0.1,0.5-0.4,0.9-1,1.3C194.6,114.7,194.5,115.9,195.5,116.7z"
      />
      <path
        class="st2"
        d="M193.3,109.8c0.1,0.2,0.3,0.3,0.4,0.5c1.1-0.3,2.1-0.5,3.2-0.7c0.2,0,0.4-0.1,0.6-0.1c0.1,0,0.2,0,0.3-0.1
		c0.2,0,0.3-0.1,0.5-0.1c0.3-0.1,0.6-0.1,0.8-0.2c0.5-0.1,1-0.2,1.4-0.3c0-0.5-0.1-0.9-0.5-1.2c-0.6-0.5-1.4-1-2.2-1.3
		c-1-0.4-2.1-0.3-3.2,0.1c-1,0.4-1.6,1.4-1.7,2.3C192.9,109.1,193,109.5,193.3,109.8z"
      />
      <path
        class="st2"
        d="M180.8,110c0.1,0.2,0.2,0.4,0.2,0.6c0.1,0.5,0,1.1-0.1,1.6c-0.1,0.2,0,0.5,0.1,1c0.3-0.7,0.4-1.1,0.6-1.6
		c0.5,0.5,0.4,1.1,0.4,1.6c0.5-0.1,1.1-0.3,1.6-0.4c-0.1-0.1-0.1-0.3-0.2-0.4c-0.1-0.3-0.4-0.6-0.4-0.8c0.3-1.3-0.6-2.1-1.4-2.9
		c-0.1-0.1-0.2-0.2-0.3-0.3c0,0,0,0-0.1-0.1c0,0,0,0.1-0.1,0.1C180.7,109,180.5,109.5,180.8,110z"
      />
      <path
        class="st2"
        d="M181.8,114.6c0.8-0.2,1.6-0.3,2.4-0.5V114C183.4,114.2,182.6,114.4,181.8,114.6L181.8,114.6z"
      />
      <path
        class="st2"
        d="M191,125c0.1-0.2,0.1-0.5,0.2-0.7c-0.6,0.1-1.2,0.3-1.8,0.4C189.8,125,190.2,125.2,191,125z"
      />
      <path
        class="st2"
        d="M184.5,118.1c0,0.2,0.5,0.4,0.8,0.6c0.2-0.3,0.6-0.6,0.6-0.9c0-0.4-0.2-0.7-0.4-1.1c0.1-0.1,0.2-0.2,0.3-0.2
		c0.1,0.1,0.2,0.2,0.3,0.4c0.8,1.3,1.6,2.6,2.5,3.9c0.4,0.6,0.6,1,0.1,1.7c-0.3,0.4-0.2,0.8,0,1.2c0.7-0.2,1.5-0.4,2.2-0.6
		c-0.2-0.3-0.2-0.6-0.4-0.9c0.4,0.3,0.5,0.4,0.7,0.9c0.3-0.1,0.7-0.2,1-0.3v-0.1c-0.4-0.8-0.3-2-1.6-2.3c-0.2-0.8-0.8-1.4-1.7-1.8
		c-0.1,0,0.1-0.3,0.1-0.4c-0.9-0.3-1.1-1.1-1.6-1.7c-0.2-0.2-0.5-0.5-0.8-0.5c-0.7-0.1-1.2-0.3-1.6-0.6c-0.5,0.1-1,0.3-1.5,0.4
		C184.3,116.4,184.8,117,184.5,118.1z"
      />
      <path
        class="st2"
        d="M95.8,125.2c-1.7-1.7-3.5-2.1-5.3-1.1c-1.6,0.8-2.4,2.5-1.9,3.8c0.3,0.7,0.9,1.3,1.6,1.7
		c1.9-0.8,3.8-1.6,5.7-2.4c0.1-0.4,0.2-0.9,0.2-1.4c0.3-0.1,0.6-0.3,0.9-0.4c0-0.1-0.1-0.2-0.1-0.2
		C96.5,125.1,96.1,125.2,95.8,125.2z"
      />
      <path
        class="st2"
        d="M92.5,129.9c0.1,0,0.2,0,0.4,0c0.8-0.2,1.4-0.5,1.9-0.9C94,129.3,93.2,129.6,92.5,129.9z"
      />
      <path
        class="st2"
        d="M68.9,145.1c-0.2-1.3-1.3-2.1-2.6-2.4c-1.6,0.9-3.2,1.8-4.8,2.7c-0.1,0.4-0.1,0.7,0,1.1
		c0.3,1.7,2.2,2.7,4.3,2.3C67.8,148.5,69.2,146.8,68.9,145.1z"
      />
      <path
        class="st2"
        d="M226.2,133c-0.3,0.2-0.6,0.4-0.8,0.7c-0.6,0.7-0.8,1.6-0.5,2.5c0,0.1,0.1,0.1,0.1,0.1c0,0.1,0.1,0.2,0.1,0.2
		c0.2,0.5,0.6,0.8,1.1,1.1c0.3,0.2,0.7,0.3,1.1,0.4c0.1,0,0.2,0,0.3,0c1.2,0.2,2.4,0,3.3-1c0.1-0.1,0.1-0.2,0.2-0.3
		c0.1-0.2,0.2-0.3,0.3-0.5c0.2-0.4,0.3-0.9,0.4-1.3c0-0.3,0.1-0.6,0.1-0.9c0-0.1,0-0.1,0-0.2c-0.1,0-0.1-0.1-0.2-0.1
		c-0.4-0.3-0.9-0.6-1.3-0.9c0,0,0,0-0.1,0c-1.2-0.6-2.6-0.5-3.8,0.2C226.3,133,226.3,133,226.2,133z"
      />
      <path
        class="st2"
        d="M96.7,123.7c0.8,0.9,1.9,1.1,3.1,1c1.5-0.3,3.5-2.3,3.5-3.4c0-0.7-0.4-1.3-1.2-1.5c-0.7-0.2-1.5-0.4-2.3-0.4
		c-1.3-0.1-2.4,0.4-3.2,1.4C95.9,121.6,95.9,122.8,96.7,123.7z"
      />
      <path
        class="st2"
        d="M298.8,115.5c1.5,0.3,3.5-0.8,4-2.2c0-0.1,0.1-0.2,0.1-0.4c0.1-0.5-0.1-1-0.3-1.4c-1.5,0.2-3,0.4-4.5,0.5
		c-0.5,0.1-1.1,0.1-1.6,0.2C295.9,113.8,297,115.2,298.8,115.5z"
      />
      <path
        class="st2"
        d="M297.7,110.6c-0.4,0.3-0.8,0.6-1,1c0.3,0,0.7-0.1,1-0.1c1.5-0.2,3-0.3,4.6-0.5c0-0.1-0.1-0.2-0.1-0.4
		c-0.5-0.2-0.9-0.4-1.4-0.5C299.7,109.8,298.6,110.1,297.7,110.6z"
      />
      <path
        class="st2"
        d="M100.5,131.2c-0.5-1.2-2.1-1.8-3.6-1.5c-1.8,0.4-3,1.9-2.6,3.4c0.3,1.3,2.1,2.2,3.7,1.9c1-0.2,1.9-0.8,2.4-1.6
		c0.3-0.5,0.5-1.1,0.4-1.7C100.6,131.5,100.6,131.4,100.5,131.2z"
      />
      <path
        class="st2"
        d="M101.4,128.2c0.3,1.5,1.9,2.4,3.7,2c1.8-0.4,3-1.8,2.6-3.3c-0.2-1.1-1.2-1.9-2.5-2c-1.1,0.4-2.2,0.8-3.3,1.2
		C101.5,126.7,101.3,127.4,101.4,128.2z"
      />
      <path
        class="st2"
        d="M220.4,116.2c1.7-0.4,2.8-1.9,2.5-3.3s-2-2.2-3.7-1.9l0,0h-0.1c-0.3,0.1-0.5,0.2-0.8,0.3
		c-0.2,0.1-0.3,0.1-0.4,0.2c-1,0.6-1.5,1.6-1.3,2.7C216.8,115.7,218.6,116.6,220.4,116.2z"
      />
      <path
        class="st2"
        d="M87.2,137.9c0.2,0.8,0.8,1.4,1.6,1.7c0.6,0.3,1.4,0.4,2.1,0.2c1-0.2,1.9-0.9,2.3-1.7c0.3-0.5,0.4-1,0.2-1.6
		c-0.3-1.3-1.7-2.1-3.4-1.9c-0.1,0-0.2,0-0.3,0c-0.5,0.1-1,0.3-1.4,0.6C87.5,136,87,136.9,87.2,137.9z"
      />
      <path
        class="st2"
        d="M40.3,162.7c0.5,0.2,1,0.1,1.5-0.1c0.8-0.3,1.3-1,1.4-1.6l0,0c0-0.2,0-0.4,0-0.6c0-0.2-0.1-0.3-0.2-0.5
		c-0.2-0.4-0.7-0.6-1.3-0.7c-0.1,0-0.3,0-0.5-0.1c-0.3,0-0.6,0-1,0c-1.2-1.2-2.2-1.5-3.4-0.9c-0.9,0.4-1.5,1.4-1.2,2.3
		c0.3,1,1.2,1.4,3.2,1.2C39.3,162.2,39.9,162.5,40.3,162.7z"
      />
      <path
        class="st2"
        d="M109.9,130.8c-1.2,0.1-2.1,0.7-2.6,1.6c-0.2,0.3-0.1,0.8-0.8,0.9c0.2,0.2,0.4,0.4,0.8,0.6
		c-0.9,0.4-2.1,0.5-2,1.5c0,0.5,0.3,0.9,0.9,1c1.1,0.2,1.6-0.5,1.9-1.2c0.7,0.1,1.2,0.2,1.8,0.1c0.3,0,0.6-0.1,0.9-0.2
		c1.1-0.4,1.7-1.2,1.7-2.2c0-0.6-0.3-1.2-0.7-1.5C111.3,131,110.6,130.8,109.9,130.8z"
      />
      <path
        class="st2"
        d="M293.2,110.7c1.3,0.6,2.9,0.2,4-0.8l0.1-0.1c0.7-0.8,0.6-1.5,0.4-2.2c-0.6,0.1-1.1,0.1-1.7,0.2
		c-0.4,0-0.8,0.1-1.2,0.1c-0.3,0-0.5,0.1-0.8,0.1c-0.7,0.1-1.5,0.1-2.2,0.2C291.7,109.1,292.1,110.2,293.2,110.7z"
      />
      <path
        class="st2"
        d="M297.2,106.5c2.3-0.2,4.6-0.4,6.9-0.6c0.6-0.1,1.2-0.1,1.8-0.2c0.5,0,1-0.1,1.5-0.1c-0.1-0.4-0.6-0.6-1-0.4
		c-0.2,0-0.3,0.1-0.4,0.2v-1.3v-1.9v-0.9v-1.4v-1v-0.7c-0.2,0-0.4,0-0.6,0c-0.3,0-0.5,0-0.8,0c-0.1,0-0.2,0-0.2,0
		c-0.5,0-1,0-1.5,0.1c-0.5,0-0.9,0-1.4,0.1c-0.3,0-0.7,0-1,0c-0.5,0-0.9,0-1.4,0.1c0.4,0.2,0.9,0.3,1.4,0.4c0.2,0,0.5,0,0.7,0
		c0.1,0,0.3,0,0.4,0s0.1,0,0.2,0V99c0,0.5-0.1,1-0.1,1.5c0,0.1,0,0.2,0,0.3c-0.4,0-0.7,0.1-1.1,0.1c-0.2,0-0.4,0-0.5,0
		c-0.5,0.1-0.9,0.2-1.3,0.4c-2,0.9-2.9,3-2,4.5c0.1,0.2,0.2,0.4,0.3,0.6c-0.4-0.1-0.7-0.2-1.1-0.3c-1.2-0.3-2.5,0.1-3.3,0.8
		C294.1,106.8,295.6,106.6,297.2,106.5C297.1,106.5,297.2,106.5,297.2,106.5z"
      />
      <path
        class="st2"
        d="M225.5,111c0.8,0.3,1.7,0.3,2.5-0.1c0.3-0.1,0.6-0.3,0.9-0.5c0.9-0.8,1.2-1.9,0.7-2.8c-0.2-0.3-0.4-0.6-0.6-1
		c0-0.1-0.1-0.1-0.1-0.2s-0.1-0.1-0.1-0.2c-0.2,0-0.3,0-0.5,0c-1,0.2-1.9,0.4-2.9,0.5c-0.3,0.2-0.6,0.5-0.8,0.8
		c-0.2,0.2-0.3,0.5-0.4,0.8C223.7,109.4,224.3,110.5,225.5,111z"
      />
      <path
        class="st2"
        d="M25.4,135.7c0.2,1.2,1.8,2.1,3.4,1.8c1.4-0.3,2.5-1.7,2.3-2.9s-1.8-2-3.2-1.7
		C26.3,133.2,25.2,134.5,25.4,135.7z"
      />
      <path
        class="st2"
        d="M92.8,142.7c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c0.1,0.6,0.4,1.1,0.6,1.8
		c0.1-0.1,0.2-0.2,0.3-0.1c0.2,0,0.4,0,0.6,0c0.1,0,0.2,0,0.3,0c0.2-0.1,0.4-0.2,0.6-0.3c0.1-0.1,0.2-0.1,0.3-0.2
		c0.1,0,0.1-0.1,0.2-0.1c0.8-0.4,1.5-0.8,2.3-1.1c0.1-0.3,0.1-0.6,0.1-0.9c0-0.4-0.2-0.8-0.5-1.2c-0.1-0.1-0.3-0.3-0.4-0.4
		c-0.8-0.6-2-0.6-3-0.1h-0.1c-0.2,0.1-0.4,0.2-0.6,0.4s-0.4,0.3-0.5,0.5C92.9,142.1,92.8,142.4,92.8,142.7z"
      />
      <path
        class="st2"
        d="M100.5,136.7c-0.1,0.1-0.2,0.2-0.3,0.4c-0.3,0.5-0.4,1.1-0.3,1.6c0.3,1.2,1.8,1.9,3.2,1.5
		c0.3-0.1,0.6-0.2,0.8-0.3c0.5-0.3,0.9-0.7,1.1-1.2c0.2-0.4,0.2-0.8,0.1-1.2c-0.2-0.9-1.1-1.5-2.1-1.6c-0.3,0-0.7,0-1,0.1
		s-0.6,0.2-0.8,0.3C101,136.3,100.8,136.5,100.5,136.7z"
      />
      <path
        class="st2"
        d="M35,143.7c0.5-0.2,1.1-0.4,0.7-1c0-0.1,0.2-0.4,0.3-0.4c1.1-0.2,0.7-0.8,0.7-1.2c-0.3-1.4-1.8-2.1-3.3-1.6
		c-1.5,0.4-2.5,1.8-2.1,3C31.8,143.6,33.5,144.3,35,143.7z"
      />
      <path
        class="st2"
        d="M56.4,132.7c1.6-0.8,3.3-1.5,4.9-2.3c-0.5-0.7-1.6-1.2-2.8-1c-1.5,0.3-2.6,1.5-2.4,2.8
		C56.2,132.4,56.3,132.6,56.4,132.7z"
      />
      <path
        class="st2"
        d="M59.2,133.9c1.3-0.2,2.3-1.2,2.4-2.2c-1.4,0.7-2.9,1.3-4.3,2C57.9,133.9,58.5,134,59.2,133.9z"
      />
      <path
        class="st2"
        d="M246.1,74.9c0.1,0.7,0.8,1,1.6,1c1.2,0.1,2.3-0.3,3.2-1c0.7-0.6,0.9-1.6,0.5-2.3c-0.7-1.1-1.1-1.3-2.9-0.9
		c-0.3,0.2-1.1,0.4-1.7,0.9C245.9,73.3,246,74.2,246.1,74.9z"
      />
      <path
        class="st2"
        d="M296.2,120.7c-0.2,0.3-0.2,0.7-0.2,1c0,0.1,0,0.1,0,0.2c0.2,1.2,1.6,1.9,3.1,1.6c1.4-0.3,2.4-1.5,2.2-2.6
		c-0.2-1.2-1.5-2-3-1.7C297.4,119.4,296.6,120,296.2,120.7z"
      />
      <path
        class="st2"
        d="M210.9,104.4c0.6-0.1,1.2-0.1,1.7-0.2c0.2,0,0.4-0.1,0.6-0.1c0.9-0.3,1.3-1.2,1.1-2c-0.1-0.3-0.2-0.6-0.5-0.9
		c-0.2-0.2-0.4-0.3-0.7-0.4c-0.2-0.1-0.4-0.1-0.7-0.1l0,0c-0.5,0-1,0.2-1.5,0.4c-0.3,0.2-0.5,0.4-0.7,0.6c-0.1,0.1-0.1,0.2-0.2,0.3
		c-0.2,0.5-0.3,1-0.4,1.4c-0.3,0.1-0.7,0.2-0.9,0.4c-0.1,0-0.1,0.1-0.1,0.1c-0.8,0.6-0.7,1.2,0.1,1.8c0.2,0.1,0.3,0.2,0.5,0.3
		c0.1,0,0.3,0,0.4-0.1C210.5,105.7,210.9,105.1,210.9,104.4z"
      />
      <path
        class="st2"
        d="M100.5,145.3c-0.7,0.4-1.5,0.7-2.2,1.1c0,0.1-0.1,0.1-0.1,0.2c0.2,0.3,0.5,0.6,0.7,0.9
		c-0.1,0.1-0.1,0.1-0.2,0.2c-0.3-0.1-0.6-0.3-0.9-0.4c-0.1,0-0.2,0.1-0.3,0.1c0.4,0.7,0.8,1.5,1.3,2.2s1.3,0.8,2.2,0.7
		c0.9-0.2,1.5-0.7,1.8-1.5s0-1.4-0.7-1.9c-0.4-0.2-0.8-0.4-1.3-0.6C101,146,101.2,145.4,100.5,145.3z"
      />
      <path
        class="st2"
        d="M20.4,163.5c0.2-0.2,0.4-0.3,0.6-0.5c-0.2-0.3-0.3-0.7-0.5-1.1c-0.2-0.4-0.4-0.7-0.6-1.1
		c-0.3-0.4-0.7-0.5-0.4-1.1c0.2-0.4-0.2-0.8-0.8-0.8c-0.6,0-1.1,0.4-1,0.8c0.2,0.6-0.2,0.9-0.6,1.3c-0.2,0.2-0.4,0.4-0.5,0.6
		c1.1,0.8,2.2,1.6,3.2,2.3C20,163.8,20.1,163.6,20.4,163.5z"
      />
      <path
        class="st2"
        d="M18.5,164.6c-0.7-0.5-1.5-1-2.2-1.6c0,0.2,0.1,0.5,0.3,0.7C17,164.4,17.7,164.7,18.5,164.6z"
      />
      <path
        class="st2"
        d="M66,179.3c0.2,0.4,0.7,0.8,1.5,1.2c1-0.4,1.5-1,1.6-1.9c0-0.1,0-0.2,0-0.3c-0.1-0.7-0.9-1-1.6-1.3
		c0.2-0.2,0.3-0.3,0.4-0.4l0.1-0.1c0.4-0.5,0.3-0.7-0.1-1.3l0,0c-1.1,0.6-1.4,0.4-1.5-0.9c0-0.1,0-0.2,0-0.3c0-0.2,0-0.4,0-0.7
		c-0.5,0-1.1,0.5-0.9,0.8c0.1,0.2,0.2,0.5,0.2,0.8c0.1,0.6,0.1,1.3,0.6,1.8c0.1,0.1,0.2,0.2,0.4,0.3c0.1,0.1,0.3,0.1,0.5,0.2
		l-0.1,0.1C66,178,65.7,178.7,66,179.3z"
      />
      <path
        class="st2"
        d="M72.2,167.6L72.2,167.6c-0.3,0-0.5-0.1-0.7-0.1c-0.8,0.7-1.6,1.5-2.6,2.4c0.4,0.1,0.8,0.2,1.2,0.2
		c0.4,0.1,0.7,0.2,1,0.3l0,0c0.1,0,0.3,0.1,0.4,0.1c0.4,0.2,0.7,0.3,1.1,0.3c0.2-0.1,0.5-0.3,0.7-0.4c0.5-0.3,1-0.6,1.5-0.9
		c0,0,0,0-0.1,0c-0.3-0.9-0.7-1.4-1.6-1.7c-0.1,0-0.2-0.1-0.2-0.1C72.6,167.7,72.4,167.7,72.2,167.6z"
      />
      <path
        class="st2"
        d="M76.4,171.5c0.1-0.5,0.2-1,0.3-1.6c0,0,0,0-0.1,0l0,0c-0.1,0-0.1,0.1-0.2,0.1c-0.7,0.4-1.4,0.8-2,1.2
		C74.9,171.7,75.2,171.7,76.4,171.5z"
      />
      <path
        class="st2"
        d="M231.5,104.3c1.5-0.3,3-0.6,4.5-0.8c-1.5,0.2-3,0.4-4.5,0.7C231.5,104.2,231.5,104.2,231.5,104.3z"
      />
      <path
        class="st2"
        d="M236.2,104.8c-1.3,0.2-2.6,0.5-3.9,0.7c0.6,0.4,1.4,0.6,2.2,0.4C235.3,105.7,235.8,105.3,236.2,104.8z"
      />
      <path
        class="st2"
        d="M233.6,101.9c-0.5,0.1-1,0.3-1.3,0.6c1-0.2,2-0.3,3-0.5C234.9,101.9,234.3,101.8,233.6,101.9z"
      />
      <path
        class="st2"
        d="M251.3,99.9c0-0.2,0.1-0.3,0.1-0.5c0.3-1.2-1.2-2.2-2.6-1.9c-1,0.2-1.7,0.9-1.9,1.8c-0.1,0.4,0,0.8,0.2,1.1
		C248.6,100.2,250,100,251.3,99.9z"
      />
      <path
        class="st2"
        d="M108,141.7c-0.7,0.3-1.4,0.7-2.1,1c0,0.3-0.1,0.5-0.3,0.8c-0.4,0.9,0.5,1.8,1.6,1.9c0.8,0.1,1.5-0.1,2-0.5
		c0.1-0.1,0.3-0.3,0.4-0.4c0.1-0.1,0.1-0.2,0.2-0.2c0.2-0.4,0.3-0.8,0.2-1.2c-0.1-0.5-0.5-0.9-1.1-1.1c-0.3-0.1-0.6-0.2-0.9-0.2
		C108.1,141.7,108.1,141.7,108,141.7z"
      />
      <path
        class="st2"
        d="M238.3,111.5c0.4,0.1,0.8,0.2,1.2,0.1c0.9-0.2,1.7-0.8,2-1.6c0.1-0.2,0.1-0.4,0.1-0.6c0-0.1,0-0.2,0-0.3
		c-0.2-1.1-1.5-1.8-2.8-1.5c-0.9,0.2-1.5,0.8-1.8,1.5c-0.2,0.4-0.2,0.7-0.1,1.1C237,110.7,237.6,111.3,238.3,111.5z"
      />
      <path
        class="st2"
        d="M266.5,89c-0.6,0.2-1.2,0.6-1.7,1c-0.7,0.6-0.8,1.5-0.3,2.1s1.8,0.9,2.6,0.6c0.8-0.3,1.5-0.7,2.2-1.1
		c-0.2-1.1-0.5-1.6-0.9-2.2C268,88.9,267.3,88.7,266.5,89z"
      />
      <path
        class="st2"
        d="M287,129.2c-0.6,0.1-1.1,0.2-1.7,0.3c-0.1,0.2-0.2,0.5-0.2,0.7s0.1,0.5,0.2,0.7c0.5-0.1,1-0.2,1.4-0.3l0,0
		c0.4-0.1,0.8-0.2,1.2-0.2c0.6-0.1,1.2-0.2,1.8-0.4h0.1c0,0,0,0,0-0.1s0-0.2-0.1-0.3c-0.1-0.4-0.3-0.7-0.5-0.9
		c-0.7,0.1-1.4,0.3-2.1,0.4C287.3,129.1,287.1,129.1,287,129.2z"
      />
      <path
        class="st2"
        d="M289.5,131.2c-0.4,0.1-0.7,0.1-1.1,0.2c-0.7,0.1-1.5,0.3-2.2,0.4c0.1,0.1,0.2,0.2,0.3,0.2
		c0.9,0,1.6-0.1,2.3-0.4C289,131.6,289.2,131.5,289.5,131.2c0.1,0.5,0.2,0.9,0.2,1.3c0,0.1,0,0.2,0,0.3c0.1,0,0.2,0,0.3-0.1
		c3.2-0.7,6.5-1.3,9.7-2c0,0,0,0,0.1-0.1h0.1c0.4-0.1,0.8-0.2,1.2-0.2c0-0.1-0.1-0.2-0.2-0.3c-0.6-0.1-0.9-0.5-1.2-0.9
		c-3.4,0.6-6.8,1.3-10.2,1.9C289.5,131.2,289.5,131.2,289.5,131.2z"
      />
      <path
        class="st2"
        d="M126,110c0.7,0.2,1.5,0.4,2.2,0.4c0.5,0,1-0.2,1.5-0.4c0.3-0.1,0.5-0.4,0.8-0.6c1.1-0.8,1.2-1.5,0.5-2.6
		c-0.4,0.2-1,0.7-1.3,0.6s-0.6-0.1-0.9-0.1c-0.7,0.2-1.5,0.4-2.2,0.6c-0.3,0.2-0.6,0.4-0.8,0.7c-0.2,0.2-0.5,0.3-0.8,0.4
		C125.2,109.5,125.5,109.9,126,110z"
      />
      <path
        class="st2"
        d="M65.1,128.2c1.3-0.3,2.1-1.4,1.8-2.4c-0.3-1-1.6-1.6-2.8-1.3c-1.2,0.3-2.1,1.5-1.8,2.5
		C62.6,127.9,63.8,128.5,65.1,128.2z"
      />
      <path
        class="st2"
        d="M82.2,117.5c1.2-0.3,2.1-1.4,1.9-2.4s-1.5-1.6-2.8-1.3c-1.2,0.3-2.1,1.5-1.8,2.5
		C79.8,117.1,81,117.7,82.2,117.5z"
      />
      <path
        class="st2"
        d="M282.8,128.3c0.5,0,1-0.2,1.4-0.1c0.1,0,0.3,0.1,0.4,0.1c0.7-0.1,1.4-0.3,2.1-0.4c0.2-0.7,0.6-1.3-0.1-1.9
		c-0.8-0.6-1.6-0.1-2.5,0.1c-0.3-1.3-1.7-0.7-2.7-1c-0.3,0.4-0.5,0.8-0.8,1.1C281.3,127,282,127.7,282.8,128.3z"
      />
      <path
        class="st2"
        d="M68.5,131.5c0.1,0.3,0.4,0.5,0.6,0.7c0.5,0.3,1.1,0.5,1.8,0.3c1.3-0.2,2.2-1.3,1.9-2.4c-0.2-1-1.3-1.6-2.6-1.3
		c-1.3,0.2-2.1,1.1-2,2.2C68.4,131.2,68.4,131.3,68.5,131.5z"
      />
      <path
        class="st2"
        d="M91.3,153.2c0,0.2,0,0.3,0,0.5c0.2,1.1,1.3,1.7,2.6,1.5c0.1,0,0.2-0.1,0.4-0.1c0.3-0.1,0.6-0.3,0.9-0.5
		c0.3-0.3,0.6-0.7,0.7-1c0-0.2,0.1-0.4,0-0.6c-0.2-1.1-1.3-1.7-2.6-1.5C92.2,151.6,91.5,152.3,91.3,153.2z"
      />
      <path
        class="st2"
        d="M252.4,98.6c0.5,0.3,1.2,0.5,2.2,0.7v0.1c0.3,0,0.6-0.1,1-0.1c-0.1-0.1-0.2-0.2-0.3-0.3c0.9-0.9,0.9-1,0.6-1.4
		c-0.4-0.4-0.8-0.9-1.3-1.2c-0.5-0.4-1.1-0.7-1.8-0.8C251.5,97,251.4,98,252.4,98.6z"
      />
      <path
        class="st2"
        d="M286.2,121.7c0.1,0.2,0.1,0.5,0.3,0.7c0.7,1,2.6,1.2,3.5,0.3c0.9-0.8,0.9-2,0.1-2.7c-0.9-0.7-2.2-0.6-3.1,0.2
		c-0.4,0.3-0.8,0.7-1.2,1.1C285.9,121.4,286.1,121.5,286.2,121.7z"
      />
      <path
        class="st2"
        d="M28.2,146.6c-0.2-0.9-1.4-1.6-2.5-1.4c-0.3,0.1-0.6,0.2-0.9,0.3l0,0c-0.7,0.5-1.2,1.3-1.1,2
		c0.2,1,1.4,1.5,2.6,1.3C27.6,148.6,28.4,147.6,28.2,146.6z"
      />
      <path
        class="st2"
        d="M81.2,128.1c-0.4-1.5-0.1-3-0.6-4.5c-0.8,0.3-1.7,0.7-2.5,1c-0.4,0.5-0.5,1.1-0.3,1.7
		C78.1,127.7,79.2,128.3,81.2,128.1z"
      />
      <path
        class="st2"
        d="M34.1,152.9c-0.3-1-1.3-1.5-2.6-1.2c-1.2,0.3-2,1.3-1.8,2.3c0.2,0.9,1.5,1.6,2.6,1.3
		C33.5,155,34.3,153.9,34.1,152.9z"
      />
      <path
        class="st2"
        d="M43.8,158.9c0.4-0.7,0.6-1.1,0.9-1.7c0.7,0,1.4-0.2,1.9-0.7c0.2-0.2,0.3-0.3,0.4-0.6c0-0.1,0.1-0.1,0.1-0.2
		c0.3-1.1-0.7-1.6-1.5-2.1c-0.9,0.4-1.6,0.7-2.4,1.1C43.3,156.1,43.1,157.5,43.8,158.9z"
      />
      <path
        class="st2"
        d="M86.9,132.4c-0.7,0.3-1.5,0.7-2.2,1c0.3,0,0.5,0,0.8,0C86.1,133.2,86.6,132.8,86.9,132.4z"
      />
      <path
        class="st2"
        d="M84.8,129.9c-1.2,0.2-2,1.3-1.8,2.3c0,0.2,0.2,0.4,0.3,0.5c1.3-0.6,2.6-1.2,3.9-1.8
		C86.8,130.1,85.8,129.7,84.8,129.9z"
      />
      <path
        class="st2"
        d="M265,111.8c0,0,0-0.1-0.1-0.1c-0.1-0.2-0.1-0.3-0.2-0.5c-0.2,0-0.5,0.1-0.7,0.1c-0.5,0.3-1,0.6-1.4,0.8
		c0.1-0.3,0.3-0.5,0.5-0.7c-0.9,0.1-1.8,0.2-2.8,0.3c-0.1,0.5-0.3,1-0.8,1.4c-0.3,0.3-0.2,0.7-0.4,1.4c0.9-0.5,1.5-0.7,2.2-1.1
		c0.2,0.2,0.4,0.5,0.6,0.7C263,113,263.1,111.7,265,111.8C264.9,111.8,264.9,111.8,265,111.8z"
      />
      <path
        class="st2"
        d="M263.5,109.7c-0.2,0-0.3,0-0.5,0.1C263.2,109.7,263.3,109.7,263.5,109.7z"
      />
      <path
        class="st2"
        d="M2.2,133C2,132.1,1,131.6,0,131.7v3.6c0.2,0,0.3,0,0.5-0.1C1.7,135,2.5,134,2.2,133z"
      />
      <path
        class="st2"
        d="M270.6,121.9c1.1-0.7,2.1-1.3,3.1-2c-0.4-0.5-0.7-1-1-1.5c-0.3-0.4-0.5-0.8-0.8-1.2c-0.4,0.1-0.8,0.3-1.1,0.5
		c-0.2,0.1-0.4,0.3-0.5,0.4c-0.1,0.2-0.2,0.3-0.1,0.5c0.4,0.8-0.2,1.5-0.5,2.2l0,0C270,121.3,270.3,121.6,270.6,121.9z"
      />
      <path
        class="st2"
        d="M88.8,145.8c-0.6,0.4-1.2,0.7-1.5,1.1c0,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.8-0.3,1.1c0.1,0.2,0.2,0.4,0.4,0.6
		c0,0.1,0.1,0.1,0.1,0.2c0.8-0.4,1.6-0.9,2.5-1.3C89.7,146.9,89.5,146.3,88.8,145.8z"
      />
      <path
        class="st2"
        d="M72.3,139.5c-0.3,0.1-0.5,0.3-0.8,0.4c-0.8,0.4-1.6,0.8-2.4,1.3c0.3,0.2,0.6,0.4,0.9,0.6
		c0.2,0.1,0.5,0.2,0.8,0.2c0.1,0,0.1,0,0.2,0c0.2,0,0.3-0.1,0.5-0.2c0.2-0.1,0.4-0.2,0.5-0.4C72.7,140.8,72.8,140,72.3,139.5
		L72.3,139.5z"
      />
      <path
        class="st2"
        d="M68.1,139.5c-0.2,0-0.4,0.1-0.9,0.3c0.3,0.2,0.5,0.4,0.8,0.6c0.6-0.3,1.1-0.6,1.7-0.9
		C69.1,139.6,68.6,139.5,68.1,139.5z"
      />
      <path
        class="st2"
        d="M62.2,170.3c-0.1-0.9-0.7-1.3-1.7-1.5c-0.3,0-0.8,0-0.8,0.2c-0.2,0.4-0.5,0.5-1,0.6c-0.8,0.2-1.1,0.8-1,1.4
		c0.1,0.5,0.4,0.9,0.8,1.3c0.5,0.4,1.2,0.5,2,0.2c0.1-0.9-1.7-1.1-0.5-2.2C60.6,170.5,61.3,171.1,62.2,170.3z"
      />
      <path
        class="st2"
        d="M145.3,127.2c0.1-0.1,0.1-0.2,0.2-0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.7,0.2-1.3,0.5-2,0.7l-0.1,0.1
		c0.1,0.2,0.1,0.4,0.2,0.6c0,0.1,0.1,0.1,0.2,0.2c0.7,0.2,1.5,0.3,2.3,0.5c0.1-0.2,0.2-0.5,0.2-0.6s0.1-0.2,0.1-0.2
		c-0.1,0-0.1-0.1-0.2-0.1c-0.3-0.2-0.6-0.3-0.8-0.4c0-0.1,0-0.2,0.1-0.3C145.2,127.3,145.2,127.3,145.3,127.2z"
      />
      <path
        class="st2"
        d="M237.8,118.5c-0.3,0-0.5,0-0.8,0c-1.1,0.2-1.7,1-1.5,1.9c0.1,0.4,0.3,0.8,0.7,1s0.9,0.3,1.4,0.2
		c1-0.2,1.7-1.1,1.6-1.9C239.1,119,238.5,118.6,237.8,118.5z"
      />
      <path
        class="st2"
        d="M191.7,99.2c1-0.2,1.7-0.8,1.5-1.3c-0.3-1.1-1.2-1.6-2.5-1.3c-1.1,0.3-1.6,0.8-1.5,1.5
		C189.4,99,190.4,99.5,191.7,99.2z"
      />
      <path
        class="st2"
        d="M249.4,104.5c-1,0.2-1.7,1.1-1.5,1.9s1.2,1.2,2.1,1c1.2-0.3,1.8-1,1.6-1.8
		C251.4,104.8,250.4,104.3,249.4,104.5z"
      />
      <path
        class="st2"
        d="M136.6,100.2c0.5-0.3,1-0.7,1.5-1c0.4,0.9,1.2,1.3,2.3,1.4c0.2-0.2,0.5-0.4,0.5-0.6c0.1-0.3,0-0.7-0.2-0.8
		c-0.8-0.5-1.7-0.8-2.5-1.2c-0.3,0.3-0.5,0.5-0.7,0.8c-0.7-0.1-1.4-0.3-2.3-0.5C135.2,99.3,135.6,99.8,136.6,100.2z"
      />
      <path
        class="st2"
        d="M274.3,121.9c0.1,0.3,0.2,0.6,0,0.8c-1,1.3-0.4,2.1,0.8,2.9c0.1-0.1,0.2-0.2,0.2-0.3l0.1-0.1
		c0.6-0.6,1.4-1.2,1-1.9c-0.1-0.2-0.2-0.5-0.2-0.8c-0.1-0.4-0.1-0.8-0.3-1.1c-0.2-0.3-0.5-0.6-1.2-0.7
		C274.2,121.5,274.2,121.5,274.3,121.9z"
      />
      <path
        class="st2"
        d="M120,142.9c-1,0.2-1.6,0.9-1.6,1.7c0,0.1,0,0.2,0.1,0.3c0.2,0.6,0.9,1,1.6,1c0.1,0,0.3,0,0.4,0
		c1-0.2,1.7-1.1,1.5-1.9C121.8,143.2,120.9,142.7,120,142.9z"
      />
      <path
        class="st2"
        d="M58.7,126.6c0.9-0.2,1.6-1,1.6-1.7c-0.1-0.8-1.1-1.4-2.1-1.2c-0.9,0.2-1.6,0.9-1.6,1.7
		C56.7,126.2,57.7,126.8,58.7,126.6z"
      />
      <path
        class="st2"
        d="M302.4,88.3c0.5-0.1,1-0.4,1.2-0.8c-0.3,0-0.7,0-1,0c-0.6,0-1.2,0-1.8,0.1c-0.1,0-0.1,0-0.2,0h-0.1l0,0
		C300.8,88.2,301.6,88.5,302.4,88.3z"
      />
      <path
        class="st2"
        d="M303.7,86.2c-0.1-0.2-0.2-0.3-0.4-0.5c-0.4-0.3-0.9-0.4-1.5-0.4c-0.6,0.1-1.1,0.5-1.4,0.9c1,0,1.9-0.1,2.9-0.1
		C303.5,86.2,303.6,86.2,303.7,86.2z"
      />
      <path
        class="st2"
        d="M26.3,163.5c-0.1-0.4-0.5-0.7-0.7-1.1c-0.6,0.1-1,0.1-1.4,0.3c-1,0.3-1.5,1.1-1.2,1.9c0.3,0.7,1.3,1.1,2.2,0.8
		C26,165.1,26.6,164.3,26.3,163.5z"
      />
      <path
        class="st2"
        d="M280,133.4c0.6,0.4,0.3,0.9,0.3,1.4c1.1-0.2,2.2-0.5,3.3-0.7c0-0.2,0.1-0.3,0.1-0.5c-0.7-0.8-1.9-0.4-2.7-0.7
		c-0.3,0.1-0.6,0.1-0.9,0.2C280,133.2,279.9,133.3,280,133.4z"
      />
      <path
        class="st2"
        d="M111.3,149.5c0.1,0.5,0.4,0.9,0.9,1.1c0.4-0.2,0.8-0.3,1.2-0.5c0.5-0.2,0.9-0.4,1.4-0.6c0.1-0.2,0.1-0.4,0-0.6
		c-0.1-0.3-0.2-0.5-0.4-0.7c-0.4-0.4-1-0.6-1.6-0.5C111.9,147.9,111.2,148.7,111.3,149.5z"
      />
      <path
        class="st2"
        d="M235,101.3c0.9-0.3,1.6-1.3,1.4-2c-0.2-0.7-0.9-1.1-1.7-0.9c-1.1,0.3-2,1.4-1.8,2.2
		C233.1,101,234.4,101.5,235,101.3z"
      />
      <path
        class="st2"
        d="M42.6,135.9c0.8,0.6,1.7,0.8,2.8,0.3c0-2-0.8-2.7-3.2-2.7C41.5,134.4,41.8,135.2,42.6,135.9z"
      />
      <path
        class="st2"
        d="M193.8,113.9c-0.9,0.5-1.6,0.8-2.1,1.2c-0.7,0.4-1.1,1-1.1,1.7c0.1,0.8,0.8,1.1,1.6,0.8
		c0.6-0.3,1.1-0.7,1.6-0.9C193.8,115.8,193.8,115,193.8,113.9z"
      />
      <path
        class="st2"
        d="M24.1,160.3h0.1c0.9-0.3,1.5-1,1.3-1.8c-0.2-0.7-1-1.1-1.9-1c-0.1,0-0.1,0-0.2,0c-0.9,0.2-1.6,1.1-1.4,1.8
		C22.2,160.1,23.2,160.5,24.1,160.3z"
      />
      <path
        class="st2"
        d="M51.2,142.6c0.3-1.9-0.6-2.7-3-2.8C47.5,141.8,48.4,142.8,51.2,142.6z"
      />
      <path
        class="st2"
        d="M75.3,130c1-0.2,1.6-1,1.4-1.8c-0.2-0.7-1-1.1-1.9-0.9c-1,0.2-1.6,1-1.4,1.8C73.6,129.8,74.4,130.2,75.3,130z"
      />
      <path
        class="st2"
        d="M93.1,117.5c0.9-0.3,1.8-0.6,2.7-1c0-0.2,0-0.3,0-0.5c-0.1-0.7-0.9-1.2-1.8-1c-1,0.2-1.6,0.9-1.5,1.7
		C92.6,117,92.8,117.3,93.1,117.5z"
      />
      <path
        class="st2"
        d="M71.5,176.3c0.4,0,0.7,0,0.9-0.1c0.7-0.1,0.8-0.4,1.3-1.5c-0.6-0.3-1.2-0.7-1.7-1c-0.5,0.2-0.8,0.2-1,0.4l0,0
		c-0.3,0.2-0.6,0.5-1,0.8c-0.5,0.3-0.8,0.7-0.6,1.2l0,0l0,0c-0.1,0.2-0.1,0.4-0.1,0.6l0.3,0.1c0.1-0.2,0.2-0.3,0.3-0.5l0,0l0,0
		C70.5,176.3,71,176.3,71.5,176.3z"
      />
      <path
        class="st2"
        d="M105.4,118.6c0,0.1,0.1,0.2,0.1,0.3c0.1,0.1,0.1,0.2,0.3,0.3c0.3,0.3,0.9,0.5,1.4,0.4c0.7-0.1,1.2-0.6,1.4-1.1
		c0.1-0.2,0.1-0.4,0-0.6c0-0.1,0-0.1-0.1-0.2c-0.1-0.2-0.2-0.4-0.4-0.5l0,0c-0.4-0.3-0.9-0.4-1.4-0.3
		C105.9,117.1,105.3,117.8,105.4,118.6z"
      />
      <path
        class="st2"
        d="M104.9,114.7c-0.2,0.1-0.5,0.2-0.7,0.2c-0.1,0-0.2,0.1-0.2,0.1c0.1,0,0.1,0,0.2,0h0.1
		C104.5,114.9,104.7,114.8,104.9,114.7z"
      />
      <path
        class="st2"
        d="M102.4,114.2c0.3-0.1,0.5-0.2,0.8-0.3c0.8-0.3,1.5-0.5,2.3-0.8c0,0,0,0,0-0.1c-0.2-0.6-0.9-0.9-1.7-0.8
		c-0.9,0.1-1.6,1-1.5,1.7C102.3,114.1,102.3,114.2,102.4,114.2z"
      />
      <path
        class="st2"
        d="M245.4,124.6c0.7,0.9,1.2,0.8,2.1-0.3c-0.7-1.1-2-1.5-3.3-1.9c-0.3-0.1-0.9,0-1.2,0.2c-0.4,0.3-0.2,0.6,0,0.9
		c0.1,0.1,0.1,0.3,0.2,0.5C244.2,123.9,244.9,123.9,245.4,124.6z"
      />
      <path
        class="st2"
        d="M28,165c0.8,0.5,1.5,1.1,2.4,1.7c1-0.6,1.4-1.3,1.1-2.1c-0.3-0.6-0.9-0.9-1.7-0.9
		C28.9,163.8,28.3,164.2,28,165z"
      />
      <path
        class="st2"
        d="M134,98.3c-0.2-0.8-1.3-0.8-2.3-0.5c-0.4,1.2-0.3,2.3,0.5,3.3C133.7,100.3,134.2,99.3,134,98.3z"
      />
      <path
        class="st2"
        d="M271.4,93.8c0.6,0.3,1.3,0.2,1.8-0.3c0.4-0.3,0.7-0.7,1-1.2c-1.1-1-1.6-1.1-2.4-0.8c-0.4,0.2-0.7,0.4-0.9,0.7
		c0,0.1-0.1,0.2-0.2,0.3c0,0.1,0,0.2,0,0.2l0,0c0,0.1,0.1,0.2,0.1,0.3C270.9,93.5,271.1,93.7,271.4,93.8z"
      />
      <path
        class="st2"
        d="M40.5,150c-0.7-1.1-1.4-2.2-2.2-3.3c-0.1-0.1-0.1-0.2-0.2-0.3c-0.2,0.3-0.4,0.5-0.6,0.8
		c-0.4,0.7-0.4,1.4,0.1,2.1C38.3,150.1,39,150.3,40.5,150z"
      />
      <path
        class="st2"
        d="M154.3,139.3c-1-0.7-1.2-0.7-1.7,0.2c-0.2,0.4-0.7,0.4-0.9,0.7c-0.3,0.3-0.7,0.7-0.7,1s0.5,0.6,0.8,0.8
		s0.7,0.1,1,0.2c0-0.1,0.1-0.3,0.1-0.4c0.1-0.3,0.2-0.7,0.4-1s0.4-0.6,0.6-1C154,139.7,154.2,139.5,154.3,139.3z"
      />
      <path
        class="st2"
        d="M72.6,149.8c-0.2-0.7-1-1.1-1.8-0.8c-0.4,0.1-0.7,0.4-0.9,0.6c-0.2,0.3-0.3,0.6-0.2,1c0,0.1,0.1,0.2,0.2,0.3
		c0.3,0.4,0.9,0.6,1.5,0.4C72.3,151.1,72.8,150.5,72.6,149.8z"
      />
      <path
        class="st2"
        d="M295.8,101c0.8-0.1,1.4-0.8,1.3-1.5s-0.9-1.1-1.7-1c-0.8,0.2-1.3,0.8-1.3,1.4C294.2,100.7,295,101.2,295.8,101
		z"
      />
      <path
        class="st2"
        d="M255.8,115c0.1-0.7,0.2-1.1,0.3-1.5c0.3,0.2,0.6,0.4,0.8,0.6l0,0c0.5-1.1,0.5-1.7-0.1-2
		c-0.3,0-0.6,0.1-0.9,0.1c-0.5,0.1-0.9,0.1-1.4,0.2c0,0.1,0,0.2,0.1,0.4c0.3,0.5,0.5,0.9,0.4,1.4C254.9,114.3,255.4,114.5,255.8,115
		z"
      />
      <path
        class="st2"
        d="M133.8,145c0.1,0,0.2,0,0.3,0v-0.1c-0.1-0.7-0.8-1.1-1.7-1c-0.8,0.2-1.4,0.8-1.2,1.5c0.1,0.5,0.6,0.9,1.3,0.9
		C132.7,145.8,133.3,145,133.8,145z"
      />
      <path
        class="st2"
        d="M59.2,158.8c-0.3,0.9,0,1.5,0.8,1.9c0.7,0.4,1.5,0.5,2.3-0.1C61.9,158.9,61.4,158.6,59.2,158.8z"
      />
      <path
        class="st2"
        d="M42.6,148c0.1-1.6-0.4-2.1-2.6-2.4C39.8,147.5,40.5,148.1,42.6,148z"
      />
      <path
        class="st2"
        d="M36.7,165c-0.7,0.1-1.1,0.5-1.2,1.1c-0.1,0.9,0.7,1.2,1.6,1.3c0.1-0.1,0.2-0.2,0.3-0.2
		c0.9-0.7,1.1-1.1,0.8-1.6c-0.1-0.1-0.2-0.2-0.3-0.3C37.6,165,37.2,164.9,36.7,165z"
      />
      <path
        class="st2"
        d="M256.2,93.5c0.7-0.4,1.3-0.7,1.9-0.9c0.1-0.8-0.2-1.3-1.2-1.8c-0.1,1.1-2.1,0.7-2.2,2.1
		C255.3,93.1,255.8,93.3,256.2,93.5z"
      />
      <path
        class="st2"
        d="M141.3,133.5c-0.6,0.3-1.2,0.5-1.7,0.8c-0.6,0.2-1.1,0.5-1.7,0.7c0.4,0.4,0.7,1.1,1.2,1.2
		c0.6,0.1,1.4-0.2,2-0.4C141.2,135,141.2,134.3,141.3,133.5z"
      />
      <path
        class="st2"
        d="M123.7,149.9c0.4,0.5,0.7,0.8,1.1,1c0.5,0.3,1,0.3,1.5-0.1c0.6-0.4,0.7-1.3,0.2-1.8s-1.2-0.4-2.1,0.2
		C124.2,149.5,124,149.7,123.7,149.9z"
      />
      <path
        class="st2"
        d="M10.1,187.8c0.1-0.2,0.2-0.5,0.2-0.7c0.2-0.6,0.2-1.4,0.1-1.7c-0.1-0.2-0.1-0.4-0.3-0.5
		c-0.3-0.2-0.8-0.4-1.1-0.3c-0.3,0.1-0.7,0.6-0.6,0.8c0.1,0.4,0.2,0.8,0.4,1.2C9,187.1,9.3,187.6,10.1,187.8z"
      />
      <path
        class="st2"
        d="M19.2,170.6c0.7-0.2,1.2-0.9,1.1-1.5s-0.9-1-1.6-0.8s-1.3,0.8-1.2,1.4c0,0.3,0.3,0.6,0.6,0.7
		c0.2,0.1,0.4,0.2,0.7,0.2C18.9,170.6,19,170.6,19.2,170.6z"
      />
      <path
        class="st2"
        d="M65.5,164.6c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.2-0.2-0.4-0.3-0.6C65.1,164,65.3,164.3,65.5,164.6z"
      />
      <path
        class="st2"
        d="M66.6,163.7c0.2-0.2,0.4-0.3,0.5-0.5c-0.2-0.1-0.5-0.1-0.8-0.1C66.4,163.3,66.5,163.5,66.6,163.7z"
      />
      <path
        class="st2"
        d="M67.2,165.3c0.2,0,0.4,0,0.6-0.1s0.3-0.1,0.5-0.2c0-0.1,0-0.1-0.1-0.2c-0.1-0.2-0.1-0.3-0.2-0.5
		C67.7,164.5,67.4,164.9,67.2,165.3z"
      />
      <path
        class="st2"
        d="M262,81.4c0.6-0.1,1.2-0.1,1.8-0.2c1.1-0.1,2.3-0.2,3.5-0.3c-1.5-1.2-3-1.3-4.3-0.5
		C262.7,80.7,262.3,81,262,81.4z"
      />
      <path
        class="st2"
        d="M109.7,137.6c-0.5,0.1-0.8,0.4-0.9,0.8c0.6-0.3,1.2-0.5,1.8-0.8C110.3,137.5,110,137.5,109.7,137.6z"
      />
      <path
        class="st2"
        d="M85.2,149.8c-0.6,0.1-1.1,0.5-1.2,1c0.6-0.3,1.2-0.7,1.8-1C85.7,149.7,85.5,149.7,85.2,149.8z"
      />
      <path
        class="st2"
        d="M244.1,112.3c0.1,0,0.1,0,0.2,0c0.5-0.3,0.9-0.5,1.4-0.8c0.4,0.5,1,0.4,1.6,0c-0.5-0.9-1.4-1-2.5-1
		c-0.8,0-1.2,0.2-1.5,0.7c0,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0.1,0.3C243.5,112,243.7,112.2,244.1,112.3z"
      />
      <path
        class="st2"
        d="M132.1,121.4c-0.3-0.4-0.6-0.6-0.9-0.7c-0.4-0.2-0.7-0.1-1.1,0c-0.2,0.1-0.3,0.2-0.4,0.3
		c-0.1,0.1-0.2,0.2-0.3,0.4c-0.3,0.5,0.1,1.1,1.1,1.6c0.2-0.1,0.4-0.2,0.6-0.3C131.6,122.4,132,122,132.1,121.4z"
      />
      <path
        class="st2"
        d="M203.1,107.2c0,0.1,0.1,0.3,0.3,0.4c0.1,0.1,0.3,0.2,0.6,0.3c0.3-0.1,0.7-0.1,1-0.2c0.2,0,0.3-0.1,0.5-0.1
		c0.3-0.3,0.5-0.6,0.4-1c-0.1-0.6-0.9-1-1.6-0.8C203.5,106,203,106.7,203.1,107.2z"
      />
      <path
        class="st2"
        d="M207.2,111.1c0.1,0,0.2,0,0.3,0.1c0.2,0,0.4,0.1,0.7,0.1c0.4-0.5,0.6-0.9,0.6-1.1c-0.8,0.2-1.6,0.3-2.5,0.5
		C206.5,110.8,206.8,111,207.2,111.1z"
      />
      <path
        class="st2"
        d="M28.5,179L28.5,179c0,0.4,0.2,0.7,0.5,0.9c0.7,0.5,1.3,0.1,1.8-0.4c0.1,0.4,0.1,0.7,0.3,1.1
		c0.1,0.3,0.2,0.6,0.3,0.8c0-0.9-0.1-1.7-0.1-2.6c0,0.1-0.1,0.1-0.1,0.2c-0.3-0.4-0.5-0.8-0.9-1.1c-0.6-0.5-1.4-0.2-1.7,0.5
		C28.5,178.6,28.5,178.8,28.5,179z"
      />
      <path
        class="st2"
        d="M109.7,111.8c0.2-0.1,0.5-0.2,0.7-0.2c0.5-0.3,0.7-0.8,0.6-1.2c-0.2-0.5-0.9-0.9-1.5-0.7
		c-0.7,0.2-1.1,0.8-1,1.4C108.5,111.5,109.1,111.8,109.7,111.8z"
      />
      <path
        class="st2"
        d="M262.8,79.8c0.7-0.2,1.2-0.8,1-1.3c-0.1-0.5-0.9-0.9-1.5-0.8c-0.7,0.1-1.3,0.9-1.1,1.4
		C261.3,79.7,262.1,79.9,262.8,79.8z"
      />
      <path
        class="st2"
        d="M16.1,175.4c0.6-0.1,1.2-0.8,1-1.3c-0.1-0.5-0.7-0.8-1.4-0.7c-0.7,0.1-1.2,0.7-1.1,1.2
		C14.7,175.1,15.4,175.5,16.1,175.4z"
      />
      <path
        class="st2"
        d="M110.6,122.9c-0.1,0-0.1,0-0.2,0.1v0.1c0.1,0.2,0.3,0.4,0.5,0.6c0.3,0.1,0.7,0.2,1,0.1c0.7-0.2,1.2-0.8,1-1.3
		c0-0.1-0.1-0.2-0.2-0.3c-0.3,0.1-0.6,0.2-0.8,0.3c-0.1,0-0.2,0.1-0.3,0.1C111.3,122.6,111,122.8,110.6,122.9z"
      />
      <path
        class="st2"
        d="M26.5,110.8c0.7-0.1,1.2-0.7,1.1-1.3c-0.1-0.6-0.7-0.9-1.4-0.8c-0.7,0.1-1.2,0.7-1.1,1.3
		C25.2,110.5,25.9,110.9,26.5,110.8z"
      />
      <path
        class="st2"
        d="M140.6,125.7c-0.2-0.5-0.4-1.1-1.1-1.5c-0.7,0.2-1.3,0.5-1.3,1.2c0.3,0.3,0.5,0.5,0.8,0.8
		C139.6,126.1,140.1,125.9,140.6,125.7z"
      />
      <path
        class="st2"
        d="M146.1,135.3C146.1,135.4,146.1,135.4,146.1,135.3C146.1,135.4,146.2,135.4,146.1,135.3
		C146.2,135.4,146.2,135.4,146.1,135.3L146.1,135.3z"
      />
      <path
        class="st2"
        d="M145.7,133.9c-0.1-0.1-0.2-0.1-0.4-0.2c-0.2-0.1-0.5-0.1-0.7-0.1l0,0c-0.5,0.1-1,0.4-1,1
		c0,0.4,0.1,0.8,0.7,0.9c0.6,0,1.2-0.1,1.7-0.1C146.2,134.8,146.3,134.2,145.7,133.9z"
      />
      <path
        class="st2"
        d="M100.1,95.9c-0.5,0.1-0.9,0.7-0.9,1.1c0.8-0.2,1.5-0.4,2.3-0.6C101.2,95.9,100.6,95.7,100.1,95.9z"
      />
      <path
        class="st2"
        d="M245,133.3c0.5-0.1,1-0.7,0.9-1.1c0-0.1,0-0.1-0.1-0.2c-0.2-0.5-1-1-1.4-0.9c-0.5,0.1-0.9,0.6-0.8,1.1
		c0,0.2,0.1,0.4,0.3,0.6C244.1,133.1,244.6,133.4,245,133.3z"
      />
      <path
        class="st2"
        d="M77.8,122c0.7-0.1,1.2-0.7,1.1-1.3c-0.1-0.5-0.7-0.8-1.3-0.7c-0.7,0.1-1.2,0.7-1.1,1.3
		C76.6,121.8,77.2,122.1,77.8,122z"
      />
      <path
        class="st2"
        d="M209.2,106c-0.5,0.2-1.1,0.4-1.6,0.7c-0.1,0.1-0.2,0.3-0.3,0.4c0.8-0.2,1.5-0.3,2.3-0.5
		C209.6,106.5,209.4,106.3,209.2,106z"
      />
      <path
        class="st2"
        d="M146.2,135.4c0.2,0.2,0.4,0.5,0.7,0.6c0.4,0.1,0.7,0.2,0.9,0.5c0.5-0.2,1-0.4,1.5-0.5
		c-0.1-0.1-0.1-0.2-0.3-0.3c-0.5-0.3-1.1-0.6-1.7-0.9C146.9,134.9,146.6,135.2,146.2,135.4z"
      />
      <path
        class="st2"
        d="M85.3,175.7c0-0.1-0.1-0.1-0.1-0.2c0,0,0,0-0.1,0c-0.2-0.1-0.8-0.1-0.9,0l-0.1,0.1c-0.4,0.3-0.9,0.7-0.9,1.2
		c-0.1,0.6,0.5,0.8,1.3,0.8c0.1-0.2,0.3-0.3,0.5-0.5C84.5,176.2,84.6,175.9,85.3,175.7z"
      />
      <path
        class="st2"
        d="M24.1,127.1c-0.2,1.2-0.3,2.4-0.4,3.5C25.6,129.2,25.7,128.2,24.1,127.1z"
      />
      <path
        class="st2"
        d="M239.9,134.3c0.3,0.1,0.7-0.2,1.1-0.3c-0.9-1.8-1-1.8-2.6-1C238.7,133.5,239.1,134.1,239.9,134.3z"
      />
      <path
        class="st2"
        d="M137.3,151.6c0.7,0.2,1.2-0.1,1.9-1.4c-0.2-0.1-0.4-0.1-0.6-0.2c-0.3-0.1-0.5-0.1-0.7-0.1s-0.3,0-0.4,0
		c-0.3,0.1-0.5,0.2-0.7,0.5l0,0C136.5,150.9,136.8,151.4,137.3,151.6z"
      />
      <path
        class="st2"
        d="M2.8,184.7c0,0.1-0.1,0.3-0.1,0.4c0.2,0.6,0.4,1.2,0.1,1.9c-0.2,0.6,0.5,0.7,1,0.7c0.1-0.5,0.2-0.8,0.3-1.2
		c0-0.2,0-0.3,0-0.5c0-0.6-0.3-1-0.8-1.3c-0.2-0.1-0.3-0.2-0.5-0.3C2.8,184.6,2.8,184.7,2.8,184.7z"
      />
      <path
        class="st2"
        d="M48.6,153.8c-0.3-1.3-0.4-1.4-2.2-1.8C46.3,153.7,47,154.2,48.6,153.8z"
      />
      <path
        class="st2"
        d="M246.7,70.8c0.7-0.1,1.3-0.8,1.2-1.2c-0.2-0.5-0.6-0.7-1.2-0.7c-0.6,0-1,0.5-1,0.9
		C245.6,70.5,246.1,70.9,246.7,70.8z"
      />
      <path
        class="st2"
        d="M136.1,103.3c0.7-0.8,0.6-1.4,0-2c-0.9,0.1-1.5,0.5-1.5,1.2S135.4,103.2,136.1,103.3z"
      />
      <path
        class="st2"
        d="M128.9,101.4c0.1,0.5,0.7,0.9,1.2,0.8s0.8-0.6,0.7-1.3c-0.1-0.6-0.7-1-1.2-0.8
		C129.2,100.2,128.8,100.9,128.9,101.4z"
      />
      <path
        class="st2"
        d="M82.4,171.6c-1.6,1.4-1.6,1.4-0.7,2.4C83.6,172.6,83.6,172.6,82.4,171.6z"
      />
      <path
        class="st2"
        d="M180.3,105.2c-0.7-0.4-1.2,0-1.8,0.7c0.5,0.4,1,0.8,1.5,1.3C181,106,181,105.6,180.3,105.2z"
      />
      <path
        class="st2"
        d="M212.5,107.5c-0.7,0.1-1.4,0.3-2.1,0.4c-0.1,0.1-0.2,0.3-0.3,0.5c0.9-0.2,1.9-0.4,2.8-0.6
		C212.8,107.7,212.7,107.6,212.5,107.5z"
      />
      <path
        class="st2"
        d="M90.5,163.8c0,0.2,0.2,0.4,0.4,0.6c0.2,0.2,0.5,0.3,0.9,0.2c0.5-0.1,0.9-0.5,1-0.9c0-0.1,0-0.2,0-0.2
		c0-0.1-0.1-0.2-0.1-0.3c-0.2-0.3-0.5-0.4-0.9-0.3c-0.4,0.1-0.7,0.3-0.9,0.5C90.6,163.5,90.5,163.6,90.5,163.8z"
      />
      <path
        class="st2"
        d="M289.4,113.6c0.3-0.1,0.7-0.3,0.8-0.7c-0.6,0.1-1.3,0.2-1.9,0.3C288.6,113.5,289,113.7,289.4,113.6z"
      />
      <path
        class="st2"
        d="M288.3,112.6c0.7-0.1,1.3-0.2,2-0.2c-0.2-0.3-0.6-0.5-1-0.5C288.7,111.9,288.4,112.2,288.3,112.6z"
      />
      <path
        class="st2"
        d="M259.2,84.1c0.2-0.1,0.4-0.2,0.5-0.3c-0.6,0-1.3,0.1-1.9,0.1C258.1,84.2,258.6,84.3,259.2,84.1z"
      />
      <path
        class="st2"
        d="M94.4,157c0.7-0.6,0.5-0.9-0.9-1.5c-1.1,1.1-1.1,1.3,0,2c0.2-0.1,0.3-0.2,0.4-0.2
		C94.1,157.2,94.3,157.1,94.4,157z"
      />
      <path
        class="st2"
        d="M264.1,88.3c-0.1-0.5-0.8-0.8-1.4-0.6c-0.5,0.2-0.9,0.7-0.7,1.2c0.1,0.4,0.7,0.7,1.3,0.6
		C263.8,89.3,264.2,88.8,264.1,88.3z"
      />
      <path
        class="st2"
        d="M39.4,128.7c-0.1-0.9-0.7-1.4-1.9-1.6C37.1,128.8,37.7,129.3,39.4,128.7z"
      />
      <path
        class="st2"
        d="M187.6,110.2c0.5-0.1,1.1-0.7,0.8-1.1c-0.2-0.3-0.7-0.5-1.1-0.6c-0.5-0.1-1,0.5-0.9,1
		C186.5,110,187.1,110.3,187.6,110.2z"
      />
      <path
        class="st2"
        d="M179.2,113.4c0.2-0.3,0.2-0.7,0.1-1l-0.1-0.1c-0.2,0-0.6,0-0.8,0c-0.5,0.2-0.9,0.5-1.4,0.9
		c0.4,0.3,0.7,0.5,1,0.6C178.4,114,178.8,113.9,179.2,113.4z"
      />
      <path
        class="st2"
        d="M201.3,103.1c0.1,0.5,0.6,0.8,1.1,0.6c0.4-0.2,0.7-0.6,1.3-1c-0.6-0.3-1-0.6-1.5-0.7
		C201.7,102,201.2,102.6,201.3,103.1z"
      />
      <path
        class="st2"
        d="M186.8,122c0.2-0.8,0.2-1.5-1-2.2c0.1,1.1-0.8,2.1,0.3,3.1C186.4,122.5,186.7,122.2,186.8,122z"
      />
      <path
        class="st2"
        d="M86.1,143.7c-0.5,0.1-1,0.7-0.8,1.1c0.2,0.3,0.7,0.5,1.1,0.6c0.5,0.1,1-0.6,0.9-1
		C87.2,143.8,86.6,143.5,86.1,143.7z"
      />
      <path
        class="st2"
        d="M261.6,117.3c-0.1,0-0.1-0.1-0.2-0.1c-0.4-0.3-0.8-0.4-1.3,0.2l0,0c0.4,0.8,0.8,1.7,1.2,2.5
		c0.1-0.1,0.3-0.1,0.4-0.2c-0.4-0.5-0.6-0.9,0-1.5C262.1,117.9,261.9,117.6,261.6,117.3z"
      />
      <path
        class="st2"
        d="M50.5,158.2c-0.3,0.3-0.4,0.6-0.2,0.8c0.2,0.3,0.7,0.5,1.1,0.5c0.3,0,0.5-0.2,0.7-0.4c0.1-0.2,0.2-0.4,0.2-0.6
		c-0.1-0.4-0.8-0.7-1.3-0.6C50.8,157.9,50.6,158.1,50.5,158.2z"
      />
      <path
        class="st2"
        d="M278.8,121c0.2-0.3,0.4-0.7,0.7-1c0.2-0.2,0.5-0.4,0.8-0.6c0.1,0,0.1-0.1,0.2-0.1c-0.2-0.3-0.4-0.6-0.7-1
		c-0.2,0.3-0.4,0.5-0.6,0.8c-0.6,0.6-1.2,1.1-0.8,1.9C278.5,120.9,278.6,121,278.8,121z"
      />
      <path
        class="st2"
        d="M170.1,101.7c-0.2-0.9-0.8-1.3-2.1-1.1C168.5,102.1,168.7,102.2,170.1,101.7z"
      />
      <path
        class="st2"
        d="M176.6,130.9c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0.1,0.3,0,0.6-0.1c0.6-0.2,0.7-0.6,0.6-1c-0.1-0.5-0.6-0.5-1.8,0
		C176.4,130.5,176.5,130.8,176.6,130.9z"
      />
      <path
        class="st2"
        d="M107.2,103.7c-1.3,0.9-1.3,0.9-0.8,2C108,104.6,108,104.6,107.2,103.7z"
      />
      <path
        class="st2"
        d="M148.7,133.6c-0.4,0.2-0.7,0.5-0.3,0.9c0.3,0.3,0.7,0.5,1.2,0.2s0.7-0.7,0.6-1.4
		C149.7,133.4,149.2,133.4,148.7,133.6z"
      />
      <path
        class="st2"
        d="M112.9,110.8c0.5-0.2,1-0.3,1.6-0.5c-0.3-0.2-0.6-0.4-1-0.4c-0.2,0-0.5,0.1-0.6,0.3
		C112.8,110.3,112.8,110.6,112.9,110.8C112.8,110.7,112.9,110.7,112.9,110.8z"
      />
      <path
        class="st2"
        d="M286.5,133.5c-0.1-0.4-0.4-0.6-1.1-0.6c-0.1,0.3-0.2,0.6-0.3,0.9C285.5,133.7,286,133.6,286.5,133.5z"
      />
      <path
        class="st2"
        d="M246.2,82.2c0.3-0.5,0.7-0.8,0.7-1.2c0-0.4-0.3-0.6-0.9-0.5c-0.6,0.1-1.1,0.7-0.9,1
		C245.4,81.8,245.8,81.9,246.2,82.2z"
      />
      <path
        class="st2"
        d="M264.6,118.4c0.6-0.6,0.9,0.3,1.4,0.1c0.7-0.6,0.3-1-0.2-1.5c-0.4,0.1-0.6,0.1-0.9,0.2c-0.1,0-0.1,0-0.2,0
		c-0.4,0.1-0.5,0.3-0.5,0.5c0,0.1,0,0.2,0,0.3C264.2,118.2,264.4,118.3,264.6,118.4z"
      />
      <path
        class="st2"
        d="M247.1,106.8c0.1-0.3,0.1-0.7-0.1-0.9c-0.4-0.5-0.9-0.4-1.9,0.4c0.4,0.3,0.7,0.6,1,0.7
		C246.4,107,247,106.9,247.1,106.8z"
      />
      <path
        class="st2"
        d="M129.4,129.8c0.3-0.1,0.7-0.5,0.8-0.7c0.1-0.4-0.4-0.7-1.1-0.6c-0.1,0.2-0.5,0.4-0.5,0.7
		C128.4,129.5,128.9,130,129.4,129.8z"
      />
      <path
        class="st2"
        d="M1.3,173c0-0.5-0.5-0.6-1.1-0.5c-0.1,0-0.2,0.1-0.2,0.1v1.3c0.2,0.1,0.5,0.3,0.7,0.5
		C1,173.7,1.3,173.3,1.3,173z"
      />
      <path
        class="st2"
        d="M128.7,88.9c0.5-1.1,0.5-1.1-0.8-1.8C127.5,88.5,127.5,88.5,128.7,88.9z"
      />
      <path
        class="st2"
        d="M2.5,122.3c0.6-0.1,0.8-0.5,0.7-0.9c-0.2-0.4-0.6-0.7-1.1-0.5c-0.3,0.2-0.7,0.6-0.7,1
		C1.5,122.3,1.9,122.5,2.5,122.3z"
      />
      <path
        class="st2"
        d="M186.7,115c0.5,0.3,0.9,0,1.3-0.4C187.5,114.8,187.1,114.9,186.7,115C186.6,115,186.6,115,186.7,115z"
      />
      <path
        class="st2"
        d="M251.4,115.7c0.1,0.7,0.2,1.1,0.1,1.4c0,0.1,0,0.1,0,0.2c0,0.5,0.4,0.6,0.9,0.7l0,0c0.2,0,0.5,0.1,0.7,0.1
		c0-0.5-0.3-0.9-0.7-1.3C252.1,116.5,251.8,116.1,251.4,115.7z"
      />
      <path
        class="st2"
        d="M275.8,125.7c-0.1,0.2,0.1,0.6,0.3,0.7c0.9,0.3,1.1-0.3,1.4-0.9C276.4,125.1,276,125.1,275.8,125.7z"
      />
      <path
        class="st2"
        d="M138.4,97.5c0.2-0.3,0.4-0.5,0.7-0.9c-0.4-0.3-0.7-0.6-1-0.6c-0.4-0.1-0.8,0.6-0.6,0.9
		C137.7,97.2,138.1,97.3,138.4,97.5z"
      />
      <path
        class="st2"
        d="M275.1,139.7c-0.2,0.3-0.4,0.5-0.6,0.8c0.6-0.1,1.3-0.3,1.9-0.4C276.1,139.8,275.7,139.7,275.1,139.7z"
      />
      <path
        class="st2"
        d="M56.2,155.3c-0.5-0.6-1-1-1.9-1C54.2,155.8,54.6,155.9,56.2,155.3z"
      />
      <path
        class="st2"
        d="M119.3,106.8c0-0.5,0.2-0.9,0-1.1c-0.4-0.3-1-0.5-1.6,0C117.8,106.4,118.3,106.6,119.3,106.8z"
      />
      <path
        class="st2"
        d="M179.6,109.7c0.2-0.4,0.5-0.7,0.4-1c-0.1-0.1-0.2-0.2-0.4-0.3c-0.5-0.2-1.3,0.1-1.3,0.5c0,0.1,0,0.2,0,0.2
		C178.4,109.6,179,109.5,179.6,109.7z"
      />
      <path
        class="st2"
        d="M177.6,118.2c0.2-0.3,0.4-0.5,0-0.8c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.2,0.1-0.3,0.1c-0.2,0.1-0.4,0.1-0.6,0.2
		c-0.2,0.2-0.3,0.4-0.5,0.6c0.4,0.2,0.6,0.4,1,0.7C177.2,118.6,177.4,118.4,177.6,118.2z"
      />
      <path
        class="st2"
        d="M127.8,117.4c-0.5,0.1-1,0.3-1.5,0.4c0.1,0.1,0.3,0.3,0.4,0.4c0.1,0,0.1,0.1,0.2,0.1c0.2,0.1,0.7,0,1-0.2
		c0.1-0.1,0.3-0.4,0.2-0.5c0,0,0,0-0.1-0.1C128,117.5,127.9,117.4,127.8,117.4z"
      />
      <path
        class="st2"
        d="M260.1,98.8c0.2,0,0.3,0,0.5-0.1s0.5-0.4,0.8-0.7c-0.5-0.2-0.9-0.6-1.2-0.5c-0.3,0.1-0.7,0.5-0.7,0.7
		C259.6,98.5,259.9,98.7,260.1,98.8z"
      />
      <path
        class="st2"
        d="M129.5,104.6c0.2-0.1,0.3-0.3,0.5-0.4c-0.2-0.4-0.3-0.9-0.6-1.3c-0.1-0.1-0.7-0.1-0.9,0s-0.2,0.6-0.1,0.8
		C128.6,104.1,129.1,104.3,129.5,104.6z"
      />
      <path
        class="st2"
        d="M281.6,128.9c0.4-0.1,0.8-0.2,1.2-0.2c0,0,0,0,0-0.1s0-0.2-0.1-0.2C282.3,128.4,281.8,128.5,281.6,128.9z"
      />
      <path
        class="st2"
        d="M255.2,116.8c-0.3-0.8-1.4-0.5-1.9-1l0,0l0,0C252.9,116.8,253.3,117.1,255.2,116.8z"
      />
      <path
        class="st2"
        d="M13.2,165.7c1-1,0.8-1.3-0.7-1.4C12.5,164.9,12.6,165.4,13.2,165.7z"
      />
      <path
        class="st2"
        d="M121.7,100.5c0.3-1.1,0.3-1.1-1.3-1.4C120.4,99.8,120.6,100.3,121.7,100.5z"
      />
      <path
        class="st2"
        d="M266.7,119.5l0.1,0.1c0.1,0.1,0.6,0.2,0.8,0.1c0.5-0.4,0.1-0.7-0.2-1c-0.1-0.1-0.1-0.1-0.2-0.2
		c-0.1,0-0.2-0.1-0.3-0.2C265.9,118.8,266.3,119.2,266.7,119.5z"
      />
      <path
        class="st2"
        d="M231.9,79c0-0.7,0-1.4-0.7-1.8c-0.1,0.8-0.1,1.6-0.2,2.4C231.5,79.4,231.9,79.2,231.9,79z"
      />
      <path
        class="st2"
        d="M0.9,152.8c-0.7,1.2-0.6,1.5,0.7,1.6C1.8,153.7,1.9,153,0.9,152.8z"
      />
      <path
        class="st2"
        d="M24.5,155c0.2-0.4,0.5-0.6,0.5-0.8c0-0.4-0.4-0.6-0.9-0.5s-0.7,0.5-0.5,0.8C23.7,154.7,24.1,154.8,24.5,155z"
      />
      <path
        class="st2"
        d="M74.6,173.7c0.1-1-0.2-1.4-1.2-1.8c0.3,0.3,0.7,0.6,0.6,0.9C73.9,173.3,73.8,173.6,74.6,173.7z"
      />
      <path
        class="st2"
        d="M247.3,95.9c0.3-0.1,0.4-0.4,0.7-0.9c-0.5-0.1-0.9-0.3-1.2-0.2c-0.2,0.1-0.5,0.5-0.4,0.7
		C246.4,96,246.9,96.1,247.3,95.9z"
      />
      <path
        class="st2"
        d="M101.9,151.5c-0.2-0.1-0.5-0.1-0.8,0c-0.1,0-0.2,0.4-0.1,0.5c0.2,0.6,0.7,0.7,1.4,0.2
		C102.2,151.9,102.1,151.6,101.9,151.5z"
      />
      <path
        class="st2"
        d="M124.8,120.5c0-0.1,0-0.3-0.1-0.4c-0.7-0.3-1.1,0-1.5,0.8C123.9,121.1,124.5,121.2,124.8,120.5z"
      />
      <path
        class="st2"
        d="M3.7,201.4c0,0.2,0.4,0.3,0.7,0.5c0.2-0.2,0.4-0.5,0.8-0.8c-0.4-0.2-0.7-0.5-0.9-0.4
		C4,200.7,3.7,201.1,3.7,201.4z"
      />
      <path
        class="st2"
        d="M219.1,108c-0.2,0-0.4,0.1-0.7,0.1c0.1,0.1,0.2,0.1,0.3,0.2C218.9,108.2,219,108.1,219.1,108z"
      />
      <path
        class="st2"
        d="M154.6,98.5c-0.5,0.4-0.7,0.6-0.7,0.8c0.3-0.1,0.7-0.2,1-0.3C154.9,98.9,154.9,98.7,154.6,98.5z"
      />
      <path
        class="st2"
        d="M165.6,117.3c0.2,0.1,0.3,0.1,0.6,0.2l0,0c0-0.5,0.2-0.9-0.1-1.3l0,0c-0.1-0.1-0.1-0.1-0.2-0.2
		c0,0,0,0-0.1,0.1s-0.2,0.2-0.3,0.3c-0.4,0.4-0.5,0.6-0.2,0.8C165.4,117.2,165.5,117.3,165.6,117.3z"
      />
      <path
        class="st2"
        d="M135,139.1c0-0.1,0-0.2,0-0.2c-0.6-0.2-1.1-0.4-1.9-0.6c0.2,0.6,0.4,0.9,0.8,1
		C134.2,139.3,134.6,139.2,135,139.1z"
      />
      <path
        class="st2"
        d="M117.6,108.2c0.1,0,0.3-0.3,0.3-0.4c-0.1-0.7-0.6-0.7-1.5-0.5C116.6,108,116.9,108.4,117.6,108.2z"
      />
      <path
        class="st2"
        d="M258.4,116.9c0.1,0.1,0.1,0.2,0.2,0.4c0.1,0,0.2-0.1,0.3-0.1l0,0c-0.1-1.1-0.1-1.1-1.2-1.5
		C258,116.1,258.2,116.5,258.4,116.9z"
      />
      <path
        class="st2"
        d="M203.4,117.4L203.4,117.4c-0.6-0.5-0.7-1.1-1.7-1c0.2,0.5,0.3,0.8,0.5,0.9
		C202.5,117.5,202.8,117.5,203.4,117.4z"
      />
      <path
        class="st2"
        d="M245.5,108.1c0,0-0.1,0-0.1-0.1c0,0.1-0.1,0.1-0.1,0.2c-0.2,0.4-0.2,0.6,0.1,0.8c0.2,0.1,0.4,0.3,0.8,0.5
		c0-0.3,0-0.5,0-0.7C246.1,108.6,245.9,108.3,245.5,108.1z"
      />
      <path
        class="st2"
        d="M175.7,112.3c-0.4,0.3-0.8,0.5-1.2,0.8c0.2,0.3,0.4,0.6,0.5,0.9c0.3-0.4,0.6-0.8,0.8-1.2
		C176,112.7,175.8,112.6,175.7,112.3z"
      />
      <path
        class="st2"
        d="M202.3,83c-0.4-0.2-0.5-0.3-0.8-0.3c-0.2,0-0.4,0-0.9,0.1c0.3,0.5,0.5,0.8,0.7,1.3
		C201.7,83.6,202,83.4,202.3,83z"
      />
      <path
        class="st2"
        d="M94.3,137.9c0.2-0.2,0.3-0.4,0.4-0.6c0.2-0.2,0.4-0.5,0.5-0.7h-0.1c-0.1,0-0.2-0.1-0.3-0.1
		C93.9,137,93.9,137,94.3,137.9z"
      />
      <path
        class="st2"
        d="M123.3,110.9c0.2,0.3,0.5,0.4,0.8,0.7c0.2-0.2,0.6-0.4,0.5-0.5c-0.1-0.3-0.4-0.5-0.7-0.9
		C123.6,110.5,123.3,110.8,123.3,110.9z"
      />
      <path
        class="st2"
        d="M132.6,96.9c0.2,0,0.5-0.5,0.8-0.7c0,0,0.1,0,0.1-0.1c-0.4-0.1-0.8-0.3-1.3-0.4
		C131.9,96.4,131.9,96.8,132.6,96.9z"
      />
      <path
        class="st2"
        d="M123.6,141.8c0.2,0.2,0.5,0.4,0.8,0.4c0.1,0,0.3-0.3,0.7-0.7c-0.5-0.1-0.8-0.3-1.2-0.3
		C123.8,141.2,123.5,141.7,123.6,141.8z"
      />
      <path
        class="st2"
        d="M247.9,111.2c0,0.2-0.1,0.4-0.1,0.6c0.2,0,0.4-0.1,0.6-0.1C248.2,111.5,248.1,111.4,247.9,111.2z"
      />
      <path
        class="st2"
        d="M32.9,169c0.2-0.4,0.1-0.7-0.2-1.1c-0.2,0.2-0.3,0.4-0.3,0.5c-0.2,0.3,0,0.4,0.4,0.9
		C32.8,169.2,32.9,169.1,32.9,169z"
      />
      <path
        class="st2"
        d="M66.4,158.8c0.1,0,0.3,0,0.5,0c0-0.6-0.3-0.8-0.8-1H66v0.1C66.1,158.2,66.3,158.5,66.4,158.8z"
      />
      <path
        class="st2"
        d="M122.4,94.4c0.4-0.9-0.2-1.1-1-1.3C121.4,93.8,121.4,94.4,122.4,94.4z"
      />
      <path
        class="st2"
        d="M135.6,146.2c0.1,0.3,0.2,0.7,0.2,1.1c0.2,0.1,0.4,0.1,0.6,0.2c0.1-0.1,0.2-0.2,0.3-0.3
		c-0.3-0.4-0.5-0.8-0.9-1.4C135.7,146,135.6,146.1,135.6,146.2z"
      />
      <path
        class="st2"
        d="M183.4,122.4c0.2,0.2,0.5,0.3,0.8,0.3c0.2,0,0.4-0.3,0.6-0.5c-0.3-0.2-0.6-0.3-1-0.6
		C183.6,122,183.3,122.3,183.4,122.4z"
      />
      <path
        class="st2"
        d="M273.6,133.1c0.3-0.9,0.4-1.1-0.1-1.4c-0.2,0-0.4,0.1-0.6,0.1C273.1,132.2,273.4,132.6,273.6,133.1z"
      />
      <path
        class="st2"
        d="M285.9,119.4c-0.2-0.3-0.4-0.6-0.8-1.1C284.6,119.2,285,119.4,285.9,119.4z"
      />
      <path
        class="st2"
        d="M273.4,134.3c-0.1,0.1-0.2,0.2-0.3,0.3c0.1,0.1,0.2,0.2,0.3,0.3c0.5-0.1,1.2-0.1,1.5-0.8c-0.1,0-0.1,0-0.2,0
		C274.3,134.1,273.8,134.2,273.4,134.3z"
      />
      <path
        class="st2"
        d="M184.7,120.3c-0.2-0.1-0.6-0.3-0.7-0.2c-0.2,0.2-0.4,0.4-0.5,0.7c0,0.1,0.3,0.2,0.6,0.4
		C184.3,120.8,184.5,120.5,184.7,120.3z"
      />
      <path
        class="st2"
        d="M24.5,177c0.6,0,0.9,0,1.2,0c0.1,0,0.2,0,0.2-0.1c0.2-0.1,0.3-0.3,0.3-0.5c0-0.1,0-0.2-0.1-0.3
		s-0.2-0.2-0.4-0.3c-0.2,0.2-0.4,0.4-0.7,0.7C24.8,176.6,24.6,176.8,24.5,177z"
      />
      <path
        class="st2"
        d="M135.7,124.6c0,0,0-0.1,0.1-0.3c-1-0.3-1.1-0.3-1.3,0c-0.1,0.1-0.1,0.3-0.1,0.4
		C134.9,125.1,135.3,124.9,135.7,124.6z"
      />
      <path
        class="st2"
        d="M188.2,79.2c-0.1,0.1-0.2,0.2-0.3,0.3c0.3,0,0.5-0.1,0.8-0.1C188.5,79.3,188.4,79.3,188.2,79.2z"
      />
      <path
        class="st2"
        d="M139.4,137.9c-0.3,0-0.7-0.1-1-0.1c0,0.2-0.1,0.4-0.1,0.5c0.3,0,0.7,0,1,0.1
		C139.3,138.3,139.4,138.1,139.4,137.9z"
      />
      <path
        class="st2"
        d="M130.5,110c-0.2,0.5-0.3,0.9,0.4,1c0.1,0,0.4-0.1,0.4-0.2C131.5,110.3,131.2,110.1,130.5,110z"
      />
      <path
        class="st2"
        d="M157.5,98.3c0-0.1-0.3-0.2-0.6-0.4c-0.1,0.3-0.2,0.5-0.2,0.7C156.9,98.6,157.2,98.5,157.5,98.3
		C157.4,98.4,157.5,98.4,157.5,98.3z"
      />
      <path
        class="st2"
        d="M170.3,105.5c-0.4-0.1-0.7-0.2-0.8-0.2c-0.2,0.2-0.4,0.5-0.5,0.7l0.4,0.2C169.7,106,169.9,105.8,170.3,105.5z"
      />
      <path
        class="st2"
        d="M85.7,146.5c0.7,0.3,1.1,0.1,1.4-0.6C86.3,145.7,85.9,145.9,85.7,146.5z"
      />
      <path
        class="st2"
        d="M134.8,127.8c0.3-0.1,0.7-0.2,1-0.4l0,0c-0.3-0.1-0.6-0.3-0.7-0.3c-0.2,0.1-0.4,0.3-0.5,0.5
		C134.6,127.7,134.7,127.8,134.8,127.8z"
      />
      <path
        class="st2"
        d="M133.3,116c0.2,0.1,0.4,0.3,0.6,0.3c0.1,0,0.2,0,0.3,0s0.3,0,0.4-0.1c0.1,0,0.1-0.3,0.1-0.4l0,0
		c-0.2-0.1-0.4-0.2-0.7-0.2C133.7,115.7,133.5,115.9,133.3,116z"
      />
      <path
        class="st2"
        d="M12.9,156.6c-0.1-0.6-0.2-1-0.3-1.4C12,155.8,12.1,156.3,12.9,156.6z"
      />
      <path
        class="st2"
        d="M7.7,169.5c-0.1-0.7-0.2-1.1-0.2-1.5c-0.2,0-0.3,0-0.5,0.1C6.6,168.6,6.7,169,7.7,169.5z"
      />
      <path
        class="st2"
        d="M270.9,133.7L270.9,133.7c0.5-0.1,0.9-0.2,1.3-0.2C271.8,133.2,271.5,133.1,270.9,133.7z"
      />
      <path
        class="st2"
        d="M192.7,122.7L192.7,122.7c0.3-0.1,0.6-0.1,1-0.2c0-0.1,0.1-0.1,0.1-0.2c-0.3-0.1-0.6-0.3-0.7-0.2
		C192.8,122.2,192.7,122.5,192.7,122.7z"
      />
      <path
        class="st2"
        d="M84.4,169.9C84.5,169.9,84.5,169.9,84.4,169.9c0.2-0.1,0.4-0.4,0.6-0.6c-0.4-0.1-0.7-0.2-0.8-0.1
		c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.1-0.1,0.2-0.2,0.3C84.1,169.8,84.3,170,84.4,169.9z"
      />
      <path
        class="st2"
        d="M87,167c0.3-0.3,0.5-0.6,0.7-0.9C86.8,166.4,86.8,166.4,87,167z"
      />
      <path
        class="st2"
        d="M164.1,110.4c0.8-0.6,0.8-0.6,0.5-0.9c-0.2-0.1-0.5-0.1-0.9-0.3C163.9,109.8,164,110.1,164.1,110.4z"
      />
      <path
        class="st2"
        d="M170.2,119.4c-0.1,0.2,0,0.5,0.2,0.7c0.3-0.3,0.5-0.6,0.6-0.9C170.7,119.2,170.4,119.3,170.2,119.4z"
      />
      <path
        class="st2"
        d="M267.6,76c-0.2-0.3-0.4-0.6-0.6-1c-0.2,0.1-0.3,0.2-0.5,0.2c0.2,0.3,0.5,0.6,0.7,0.9
		C267.3,76.1,267.4,76,267.6,76z"
      />
      <path
        class="st2"
        d="M159.1,108.9c0.2-0.2,0.4-0.3,0.7-0.6c-0.4-0.1-0.6-0.2-0.8-0.2c-0.2,0.1-0.4,0.3-0.4,0.5
		C158.7,108.7,159,108.8,159.1,108.9z"
      />
      <path
        class="st2"
        d="M243.9,125.1c-0.2-0.3-0.4-0.7-0.6-1c-0.1,0-0.2,0-0.4,0C242.4,124.9,243.1,125,243.9,125.1z"
      />
      <path
        class="st2"
        d="M252.7,111.1L252.7,111.1c0.3-0.3,0.4-0.5,0.6-0.7c-0.2-0.1-0.4-0.3-0.5-0.3c-0.2,0.1-0.4,0.3-0.6,0.5
		C252.2,110.7,252.5,110.9,252.7,111.1z"
      />
      <path
        class="st2"
        d="M87.3,173.8c0-0.5-0.2-0.8-0.5-0.9c-0.1-0.1-0.3-0.1-0.5-0.1c-0.1,0.1-0.2,0.2-0.3,0.3c0.1,0,0.1,0.1,0.2,0.1
		C86.5,173.4,86.8,173.6,87.3,173.8z"
      />
      <path
        class="st2"
        d="M272.4,139.7c0.6-0.5,0.4-0.8,0-1.3C271.9,138.9,272,139.3,272.4,139.7z"
      />
      <path
        class="st2"
        d="M131.3,125.8c0.2-0.3,0.3-0.5,0.4-0.8c-0.2-0.1-0.5-0.2-0.7-0.2c-0.1,0-0.4,0.4-0.3,0.4
		C130.7,125.5,131,125.6,131.3,125.8z"
      />
      <path
        class="st2"
        d="M264.9,104.4c0.1-0.2,0.2-0.5,0.2-0.7c0-0.1-0.4-0.3-0.5-0.3c-0.2,0.1-0.4,0.3-0.5,0.5c0,0.1,0.2,0.3,0.3,0.4
		C264.6,104.4,264.8,104.4,264.9,104.4z"
      />
      <path
        class="st2"
        d="M174.3,115.3C174.4,115.3,174.4,115.3,174.3,115.3c0.3-0.4,0.5-0.8,0.7-1.2c-0.4,0.1-0.7,0.1-0.8,0.2
		c-0.1,0-0.1,0.1-0.1,0.1l0,0C174,114.6,174.1,114.9,174.3,115.3L174.3,115.3z"
      />
      <path
        class="st2"
        d="M237.2,131c-0.1-1.2-0.7-2.1-2.5-2c-0.2,0.3-0.5,0.6-0.7,0.9c-0.5,1,0.2,1.9,1.5,1.8c0.4,0,0.7-0.2,1.1-0.3
		v0.1c0,0,0,0,0.1,0c0.4,0.7,0.5,0.7,1.4-0.1C237.7,131.2,237.4,131.1,237.2,131L237.2,131L237.2,131z"
      />
      <path
        class="st2"
        d="M33.2,171.4c0-0.2-0.3-0.3-0.7-0.5c-0.2,0.3-0.3,0.6-0.3,0.8c0,0.1,0.4,0.3,0.5,0.3
		C32.9,171.7,33.2,171.5,33.2,171.4z"
      />
      <path
        class="st2"
        d="M95.3,99.6c-0.1,0-0.3-0.1-0.4-0.1c-0.2,0-0.4,0.1-0.5,0.2c0,0.1-0.1,0.1-0.1,0.2c0.2,0.1,0.5,0.1,0.7,0.2
		C95,100,95.1,99.8,95.3,99.6z"
      />
      <path
        class="st2"
        d="M49,149.7c0,0,0.1,0.2,0.3,0.4c0.3-0.4,0.6-0.7,0.8-1c-0.1-0.1-0.2-0.1-0.3-0.2
		C49.5,149.2,49.3,149.4,49,149.7z"
      />
      <path
        class="st2"
        d="M27,173.2c0-0.1,0-0.2,0-0.4v-0.1c-0.2,0.1-0.3,0.2-0.5,0.3c-0.1,0.1-0.2,0.1-0.3,0.2c0.2,0.1,0.3,0.2,0.5,0.3
		C26.8,173.4,26.9,173.3,27,173.2z"
      />
      <path
        class="st2"
        d="M246.8,115.6c0,0.8,0.8,0.6,1.2,0.8C247.9,115.9,247.6,115.5,246.8,115.6z"
      />
      <path
        class="st2"
        d="M104.5,131.6c0.3,0.4,0.4,0.7,0.7,1.2C105.5,132,105.4,131.6,104.5,131.6z"
      />
      <path
        class="st2"
        d="M241.2,130.5c0.3-0.2,0.5-0.4,0.8-0.6c0.3-0.2,0.5-0.4,0.8-0.6c-0.3,0-0.6,0-0.8,0.1
		C241.5,129.5,241.3,129.8,241.2,130.5z"
      />
      <path
        class="st2"
        d="M130,113.8L130,113.8C130,113.8,130.1,113.8,130,113.8C130.1,113.8,130.1,113.8,130,113.8
		C130,113.7,130,113.8,130,113.8z"
      />
      <path
        class="st2"
        d="M128.3,114.1c0.6-0.1,1.1-0.2,1.7-0.4C129.2,113.3,129.1,113.3,128.3,114.1z"
      />
      <path
        class="st2"
        d="M75.6,167.6c0,0.1,0,0.2,0,0.2c0,0.1,0.1,0.2,0.2,0.4c0-0.1,0.1-0.2,0.1-0.3s0.1-0.2,0.1-0.3s0.1-0.2,0.1-0.3
		c0.1-0.1,0.1-0.3,0.1-0.4c-0.2,0.1-0.3,0.1-0.4,0.2C75.7,167.4,75.6,167.5,75.6,167.6z"
      />
      <path
        class="st2"
        d="M131.1,123.9c0-0.1-0.2-0.3-0.4-0.5c-0.3,0.3-0.4,0.5-0.6,0.7c0.2,0.1,0.4,0.3,0.6,0.2
		C130.8,124.3,131.1,124.1,131.1,123.9z"
      />
      <path
        class="st2"
        d="M111.6,147.3c-0.1-0.1-0.1-0.2-0.2-0.3c-0.2,0.1-0.4,0.1-0.6,0.2c-0.1,0.1-0.2,0.3-0.3,0.4
		c0.1,0.1,0.1,0.1,0.2,0.2C111,147.6,111.3,147.5,111.6,147.3z"
      />
      <path
        class="st2"
        d="M28.8,176.2c0.5-0.1,0.7-0.3,0.6-0.8c0-0.1-0.4-0.2-0.4-0.1C28.5,175.6,28.4,175.9,28.8,176.2z"
      />
      <path
        class="st2"
        d="M262.3,115.3c0.2,0.7,0.2,0.9,0.6,1c0.1,0,0.2,0.1,0.4,0.1c-0.1-0.1-0.2-0.2-0.3-0.3
		C262.8,115.9,262.6,115.7,262.3,115.3z"
      />
      <path
        class="st2"
        d="M168.5,114.4c-0.2,0.2-0.3,0.4-0.4,0.6c0,0,0.1,0,0.1,0.1c0.1,0,0.2,0.1,0.3,0.1c0.2-0.1,0.4-0.3,0.7-0.6
		c-0.2,0-0.3-0.1-0.4-0.1C168.7,114.4,168.6,114.4,168.5,114.4z"
      />
      <path
        class="st2"
        d="M175.7,128.7c0.1,0.2,0.3,0.4,0.7,0.3c0.1,0,0.3-0.3,0.3-0.4c0-0.1-0.1-0.2-0.1-0.2
		C176.3,128.6,176,128.6,175.7,128.7z"
      />
      <path
        class="st2"
        d="M178,128c-0.1,0-0.1,0-0.2,0C177.9,128.1,177.9,128.1,178,128C178,128.1,178,128.1,178,128z"
      />
      <path
        class="st2"
        d="M56.2,152.2c0.1,0,0.2,0,0.4,0s0.5-0.1,0.7-0.2c0-0.1,0-0.2,0-0.2c-0.4,0-0.8,0-1.3,0.1c-0.1,0-0.2,0-0.3,0
		c0,0.1,0,0.2,0,0.3C55.9,152.2,56,152.2,56.2,152.2z"
      />
      <path
        class="st2"
        d="M283.3,123.9c-0.1-0.1-0.2-0.2-0.3-0.3c-0.3,0.2-0.7,0.4-1,0.6c0.1,0.1,0.1,0.2,0.2,0.2
		C282.6,124.2,282.9,124.1,283.3,123.9z"
      />
      <path
        class="st2"
        d="M63.7,175.8c0.3,0.3,0.7,0.6,1,1c0.1-0.1,0.2-0.1,0.3-0.2c-0.3-0.3-0.6-0.6-0.9-1
		C63.9,175.6,63.8,175.7,63.7,175.8z"
      />
      <path
        class="st2"
        d="M233.6,127.7c-0.1,0.6,0.3,0.8,1,1.1C234.5,128.1,234.2,127.8,233.6,127.7z"
      />
      <path
        class="st2"
        d="M126.4,88.7c-0.1-0.2-0.2-0.5-0.3-0.7c-0.2,0-0.3,0.1-0.5,0.1c0.1,0.2,0.3,0.4,0.4,0.7
		C126.2,88.8,126.3,88.8,126.4,88.7z"
      />
      <path
        class="st2"
        d="M79.5,179.5c0-0.1-0.1-0.2-0.1-0.2c-0.3,0.1-0.7,0.2-1,0.3C78.9,179.7,79.3,180,79.5,179.5z"
      />
      <path
        class="st2"
        d="M253.2,102.9c0-0.2-0.1-0.4-0.3-0.6c-0.2,0-0.4,0.1-0.6,0.1c0.2,0.3,0.3,0.5,0.5,0.7
		C253,103,253.1,103,253.2,102.9z"
      />
      <path
        class="st2"
        d="M75.3,177.3c0.1,0,0.2,0.1,0.3,0.1c0.3,0.2,0.7,0.4,1,0c0,0,0-0.1,0.1-0.1c-0.2-0.1-0.4-0.2-0.6-0.2
		C75.8,177.2,75.5,177.3,75.3,177.3z"
      />
      <path
        class="st2"
        d="M76.6,177.4C76.7,177.4,76.7,177.4,76.6,177.4c0.1-0.1,0.1-0.1,0.1-0.2C76.7,177.2,76.7,177.3,76.6,177.4
		L76.6,177.4z"
      />
      <path
        class="st2"
        d="M267.6,113.3c-0.1,0-0.2,0-0.4,0c-0.1,0.3-0.1,0.7-0.2,1c0.1,0,0.2,0,0.4,0
		C267.5,113.9,267.6,113.6,267.6,113.3z"
      />
      <path
        class="st2"
        d="M251.1,118.8c0.1,0,0.1-0.1,0.2-0.1c-0.2-0.3-0.3-0.6-0.5-0.9c-0.1,0-0.2,0.1-0.3,0.1
		C250.7,118.2,250.9,118.5,251.1,118.8z"
      />
      <path
        class="st2"
        d="M130.2,114.5c0,0.2-0.1,0.4-0.1,0.7c0.5-0.5,0.7-1,0-1.3C130.1,114,130.2,114.2,130.2,114.5z"
      />
      <path
        class="st2"
        d="M142.6,129.1c-0.3-0.2-0.4-0.4-0.6-0.6c0,0-0.4,0.2-0.4,0.3C141.5,129.3,141.9,129.3,142.6,129.1z"
      />
      <path
        class="st2"
        d="M167.5,111.8c-0.1-0.1-0.3-0.4-0.4-0.3c-0.2,0-0.3,0.2-0.6,0.4c0.2,0.2,0.4,0.3,0.4,0.3
		C167.2,112.1,167.4,111.9,167.5,111.8z"
      />
      <path
        class="st2"
        d="M114.3,106.3c0.4,0.2,0.7,0.4,1.2,0.7C115.4,106.1,115.1,106,114.3,106.3z"
      />
      <path
        class="st2"
        d="M178.2,88.2c0-0.1,0-0.2-0.1-0.3c-0.5-0.2-0.7,0-0.9,0.5C177.6,88.6,178,88.6,178.2,88.2z"
      />
      <path
        class="st2"
        d="M218.3,116.8C218.4,116.8,218.4,116.8,218.3,116.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.2-0.3,0.3
		C218,116.9,218.2,116.9,218.3,116.8z"
      />
      <path
        class="st2"
        d="M177.5,122.9c0.3-0.1,0.5-0.2,0.8-0.3c-0.1-0.3-0.2-0.5-0.3-0.7C177.5,122.1,177.4,122.5,177.5,122.9z"
      />
      <path
        class="st2"
        d="M135.4,132C135.5,132,135.5,132,135.4,132c0.3,0,0.5-0.2,0.6-0.3l0,0c0-0.1-0.2-0.2-0.4-0.4
		c-0.2,0.2-0.4,0.4-0.5,0.5C135.1,131.8,135.3,132,135.4,132z"
      />
      <path
        class="st2"
        d="M227.4,130.6c-0.2,0.1-0.3,0.3-0.5,0.5c0.2,0.1,0.4,0.1,0.6,0.2c0.1-0.2,0.2-0.4,0.3-0.5
		C227.8,130.8,227.5,130.6,227.4,130.6z"
      />
      <path
        class="st2"
        d="M159,143.4c0.1-0.2,0.2-0.3,0.2-0.5c0-0.1-0.2-0.2-0.5-0.5c-0.1,0.4-0.3,0.6-0.2,0.7
		C158.6,143.2,158.9,143.3,159,143.4z"
      />
      <path
        class="st2"
        d="M101.5,155.5c0.1-0.1,0.2-0.1,0.3-0.2c0-0.1,0-0.2-0.1-0.3C101.7,155.3,101.6,155.4,101.5,155.5z"
      />
      <path
        class="st2"
        d="M173.7,114.3c0-0.4,0-0.8,0.1-1.2c-0.1,0-0.2,0-0.3,0c-0.1,0.4-0.1,0.8-0.2,1.2
		C173.4,114.3,173.6,114.3,173.7,114.3z"
      />
      <path
        class="st2"
        d="M246.8,98c-0.2-0.3-0.5-0.5-0.8-1C245.9,97.7,246.1,98,246.8,98z"
      />
      <path
        class="st2"
        d="M247.2,109.4c0.2-0.2,0.5-0.4,0.7-0.6c-0.1-0.1-0.1-0.1-0.2-0.2c-0.2,0.1-0.5,0.3-0.7,0.4
		C247,109.1,247.1,109.3,247.2,109.4z"
      />
      <path
        class="st2"
        d="M136.7,133c0,0,0-0.2,0-0.3c-0.3,0.1-0.6,0.1-0.9,0.2c0,0.1,0.1,0.2,0.1,0.3
		C136.2,133.2,136.5,133.1,136.7,133z"
      />
      <path
        class="st2"
        d="M180,125.4c0.1-0.1,0.2-0.2,0.3-0.3c-0.2-0.2-0.3-0.3-0.4-0.4c-0.1,0.1-0.1,0.1-0.2,0.2
		c-0.1,0.1-0.2,0.2-0.3,0.4l0.3,0.2C179.9,125.5,179.9,125.4,180,125.4z"
      />
      <path
        class="st2"
        d="M279.5,115.9c0.1-0.1,0.2-0.1,0.3-0.2c-0.2-0.2-0.4-0.4-0.6-0.6h-0.1c-0.1,0-0.1,0.1-0.2,0.1
		c0,0,0,0.1,0.1,0.1C279.2,115.5,279.4,115.7,279.5,115.9z"
      />
      <path
        class="st2"
        d="M288.7,125.7c0.4,0.2,0.6,0.3,1,0.4C289.4,125.6,289.4,125.6,288.7,125.7z"
      />
      <path
        class="st2"
        d="M270.6,67.9c-0.1-0.2-0.3-0.4-0.4-0.6h-0.3l0,0c0.2,0.2,0.3,0.5,0.5,0.7C270.4,68,270.5,67.9,270.6,67.9z"
      />
      <path
        class="st2"
        d="M81.1,167.4C81.1,167.4,81.2,167.4,81.1,167.4c0.1-0.1,0.1-0.1,0-0.1C81.1,167.3,81.1,167.3,81.1,167.4
		c-0.1,0-0.2,0-0.3,0.1c0,0,0,0,0,0.1C80.9,167.5,81,167.5,81.1,167.4z"
      />
      <path
        class="st2"
        d="M230.9,137.1C230.9,137.1,230.9,137,230.9,137.1C230.9,137,230.9,137,230.9,137.1
		C230.8,137.1,230.8,137.1,230.9,137.1L230.9,137.1z"
      />
      <path
        class="st2"
        d="M232.4,137.7c-0.7-0.3-1.1-0.4-1.5-0.6C231,137.6,231.3,137.9,232.4,137.7z"
      />
      <path
        class="st2"
        d="M124,98c0-0.1-0.2-0.3-0.3-0.3c-0.1,0-0.4,0.2-0.3,0.2c0.1,0.2,0.2,0.3,0.4,0.5C123.9,98.2,124,98.1,124,98z"
      />
      <path
        class="st2"
        d="M127,94.3c0.2-0.4-0.1-0.6-0.7-0.7c0.2,0.3,0.3,0.6,0.4,0.8C126.8,94.4,127,94.3,127,94.3z"
      />
      <path
        class="st2"
        d="M237,132.2c-0.5,0.3-0.8,0.5-1.3,0.8C236.6,132.9,236.6,132.9,237,132.2z"
      />
      <path
        class="st2"
        d="M33.3,160.3c-0.1,0-0.2,0-0.3,0c-0.1,0.3-0.1,0.5-0.2,0.8c0.2,0,0.3,0,0.5,0C33.3,160.9,33.3,160.6,33.3,160.3
		z"
      />
      <path
        class="st2"
        d="M27.6,162.8c0.1-0.2,0.1-0.4,0.2-0.6c-0.1,0-0.3,0-0.4,0c0,0.2,0,0.4,0,0.6C27.4,162.8,27.5,162.8,27.6,162.8z
		"
      />
      <path
        class="st2"
        d="M127.3,90C127.4,90,127.4,90,127.3,90c0.1-0.3,0.1-0.4,0.1-0.6c0-0.1-0.2-0.1-0.4-0.2
		c-0.1,0.2-0.2,0.3-0.2,0.5C126.8,89.8,127.1,89.9,127.3,90z"
      />
      <path
        class="st2"
        d="M233.5,144.5c0-0.1-0.1-0.2-0.1-0.2c-0.3,0.1-0.6,0.2-0.9,0.4c0,0,0,0,0,0.1
		C232.9,144.7,233.2,144.6,233.5,144.5z"
      />
      <path
        class="st2"
        d="M251.3,140.7c0.6-0.3,1-0.5,1.4-0.6C252.1,139.9,251.6,139.9,251.3,140.7z"
      />
      <path
        class="st2"
        d="M231.5,131.5c0.1,0,0.1,0.1,0.2,0.1c0.2,0.1,0.3,0.3,0.5,0.4c0.1-0.1,0.1-0.1,0.2-0.2l0,0
		c-0.2-0.2-0.4-0.4-0.5-0.6C231.7,131.3,231.6,131.4,231.5,131.5z"
      />
      <path
        class="st2"
        d="M232.3,133.6c0.3-0.1,0.7-0.1,1-0.2v-0.1c-0.3,0.1-0.7,0.1-1,0.2C232.3,133.5,232.3,133.5,232.3,133.6z"
      />
      <path
        class="st2"
        d="M163.8,103.7c-0.2,0-0.4-0.1-0.5-0.1c-0.1,0.1-0.2,0.2-0.2,0.3c0.1,0,0.3,0.1,0.4,0.1
		C163.6,104,163.6,103.8,163.8,103.7z"
      />
      <path
        class="st2"
        d="M155.9,76.1c0.1,0,0.1-0.2,0.1-0.3c-0.1,0-0.2-0.1-0.3,0c-0.1,0-0.1,0.2-0.1,0.3
		C155.7,76,155.8,76.1,155.9,76.1z"
      />
      <path
        class="st2"
        d="M289.6,108.3c-0.1,0-0.2,0-0.3,0c0,0.1,0,0.1-0.1,0.2c0.1,0,0.2,0,0.3,0C289.5,108.5,289.5,108.4,289.6,108.3z
		"
      />
      <path
        class="st2"
        d="M196.1,68.6c0.1-0.2,0.2-0.3,0.3-0.5c0,0-0.1-0.1-0.3-0.2c-0.1,0.2-0.2,0.3-0.3,0.5
		C195.8,68.4,196,68.5,196.1,68.6z"
      />
      <path
        class="st2"
        d="M171.2,111.7c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0.2-0.2,0.4-0.3,0.6c0.1,0,0.1,0,0.2,0.1
		C171,112.1,171.1,111.9,171.2,111.7z"
      />
      <path
        class="st2"
        d="M153.6,104.6c0.1,0,0.3-0.2,0.3-0.3c0-0.1-0.2-0.2-0.2-0.3c-0.1,0.1-0.3,0.2-0.5,0.3l-0.1,0.1
		c0.2,0,0.3,0.1,0.4,0.1C153.5,104.6,153.5,104.6,153.6,104.6z"
      />
      <path
        class="st2"
        d="M127.7,97.4c0,0.1,0.2,0.1,0.3,0.1c0.1-0.1,0.2-0.2,0.4-0.3c-0.2-0.1-0.4-0.1-0.5-0.2
		C127.8,97.2,127.7,97.3,127.7,97.4z"
      />
      <path
        class="st2"
        d="M304.6,83c-0.1-0.2-0.2-0.4-0.4-0.6c-0.1,0-0.1,0.1-0.2,0.1c0.1,0.2,0.3,0.4,0.4,0.6
		C304.5,83,304.5,83,304.6,83z"
      />
      <path
        class="st2"
        d="M243.8,106c0.1-0.1,0.3-0.2,0.4-0.3c-0.1,0-0.2-0.1-0.3-0.1s-0.1-0.1-0.2-0.1v0.1c-0.1,0.1-0.1,0.2-0.1,0.3
		C243.6,105.9,243.8,106,243.8,106z"
      />
      <path
        class="st2"
        d="M271.7,128.3c0.2,0.2,0.3,0.5,0.5,0.7c0.1-0.1,0.2-0.1,0.3-0.2c-0.2-0.2-0.4-0.4-0.6-0.6
		C271.8,128.2,271.8,128.3,271.7,128.3z"
      />
      <path
        class="st2"
        d="M134.1,96.9c-0.1-0.3-0.1-0.7-0.7-0.7C133.5,96.5,133.5,96.9,134.1,96.9z"
      />
      <path
        class="st2"
        d="M263.3,102.4C263.3,102.3,263.3,102.3,263.3,102.4C263.3,102.3,263.3,102.3,263.3,102.4c-0.1,0-0.2,0-0.2,0
		c0,0.2,0,0.3,0,0.5c0,0.1,0,0.2,0,0.2s0,0,0.1,0s0.2,0,0.3,0C263.4,102.8,263.3,102.6,263.3,102.4z"
      />
      <path
        class="st2"
        d="M128.9,115.4c0-0.1,0-0.1-0.1-0.1c0,0-0.1,0-0.1-0.1v0.1C128.8,115.4,128.9,115.4,128.9,115.4z"
      />
      <path
        class="st2"
        d="M129.2,115.6c-0.1-0.1-0.2-0.1-0.3-0.2c0,0.1,0,0.2,0.1,0.2S129.1,115.6,129.2,115.6z"
      />
      <path
        class="st2"
        d="M83.2,142.3l0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1,0.1-0.2,0.2-0.3,0.3C83,142.1,83.1,142.2,83.2,142.3z"
      />
      <path
        class="st2"
        d="M82.7,170.2c-0.2-0.1-0.3-0.3-0.5-0.4c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0.1-0.1,0.1-0.2,0.2l0.1,0.1
		c0.2,0.2,0.3,0.3,0.5,0.5C82.6,170.3,82.7,170.2,82.7,170.2z"
      />
      <path
        class="st2"
        d="M77.5,109.3c-0.3-0.1-0.5-0.2-0.6-0.2s-0.2,0.1-0.3,0.2c0.1,0.1,0.2,0.3,0.4,0.3
		C77.1,109.6,77.2,109.4,77.5,109.3z"
      />
      <path
        class="st2"
        d="M212.2,81.3c0.1-0.2,0.2-0.3,0.2-0.4s-0.2-0.1-0.2-0.1c-0.1,0.1-0.3,0.2-0.3,0.2
		C211.9,81.1,212,81.1,212.2,81.3z"
      />
      <path
        class="st2"
        d="M274.3,118.5c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0.1-0.1,0.1-0.2,0.2s-0.2,0.2-0.2,0.3c0.1,0,0.1,0.1,0.2,0.1
		C274,118.8,274.1,118.7,274.3,118.5L274.3,118.5z"
      />
      <path
        class="st2"
        d="M145.6,130.5c0,0.1,0.2,0.2,0.4,0.4c0.1-0.4,0.3-0.5,0.2-0.6c0-0.1-0.2-0.1-0.4-0.2
		C145.7,130.2,145.6,130.4,145.6,130.5z"
      />
      <path
        class="st2"
        d="M161,94.8c0.1-0.2,0.2-0.3,0.2-0.4c-0.1,0-0.3-0.1-0.4-0.1c0,0-0.2,0.2-0.1,0.2
		C160.7,94.6,160.8,94.7,161,94.8z"
      />
      <path
        class="st2"
        d="M75.7,174.1c0,0.1,0.1,0.1,0.2,0.2c0.1-0.1,0.2-0.2,0.3-0.3c-0.1,0-0.2-0.1-0.2-0.1
		C75.9,173.9,75.7,174,75.7,174.1z"
      />
      <path
        class="st2"
        d="M224.8,114C224.8,114,224.7,114,224.8,114c-0.1-0.1-0.1-0.1-0.2-0.1C224.6,113.9,224.7,113.9,224.8,114
		C224.7,114,224.7,114,224.8,114z"
      />
      <path
        class="st2"
        d="M225.4,114.4L225.4,114.4c-0.1-0.1-0.4-0.2-0.6-0.4c0,0.1,0.1,0.2,0.2,0.3
		C225.1,114.3,225.2,114.4,225.4,114.4z"
      />
      <path
        class="st2"
        d="M255.1,84.8c-0.1-0.1-0.2,0-0.3-0.1c0,0.1,0,0.2-0.1,0.3c0.1,0,0.2,0,0.3,0C255.1,85,255.1,84.9,255.1,84.8z"
      />
      <path
        class="st2"
        d="M171.3,91.8c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2c0,0,0.1,0.1,0.1,0.2
		C171.2,91.9,171.2,91.9,171.3,91.8z"
      />
      <path
        class="st2"
        d="M224,113.5c0,0.1-0.1,0.2-0.1,0.3c0.2,0,0.5,0.1,0.7,0.1C224.4,113.8,224.2,113.6,224,113.5z"
      />
      <path
        class="st2"
        d="M158.6,96.1c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2s0.1,0.1,0.1,0.2
		C158.4,96.3,158.5,96.2,158.6,96.1z"
      />
      <path
        class="st2"
        d="M78.3,174c-0.1,0.1-0.1,0.1-0.2,0.2c0.2,0.1,0.3,0.1,0.4,0.2l0.1-0.1C78.5,174.1,78.4,174.1,78.3,174z"
      />
      <path
        class="st2"
        d="M231,76.7c0.1,0.1,0.1,0.2,0.2,0.3c0-0.1,0-0.2,0-0.3C231.1,76.7,231.1,76.7,231,76.7z"
      />
      <path
        class="st2"
        d="M126.5,103.8c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0-0.2,0.1-0.3,0.1
		C126.2,103.6,126.3,103.7,126.5,103.8z"
      />
      <path
        class="st2"
        d="M235.1,110.1c0.2-0.1,0.4-0.2,0.6-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.2,0.1-0.4,0.2-0.7,0.2
		C235.1,110,235.1,110,235.1,110.1z"
      />
      <path
        class="st2"
        d="M270,130.4c0,0.3,0,0.5,0.1,0.7c0.1,0,0.2,0,0.3-0.1C270.3,130.8,270.2,130.7,270,130.4z"
      />
      <path
        class="st2"
        d="M267.9,118.1c0.1-0.1,0.1-0.2,0.1-0.2c-0.1,0-0.2,0-0.3,0c-0.1,0,0,0.2-0.1,0.2
		C267.8,118.1,267.9,118.1,267.9,118.1z"
      />
      <path
        class="st2"
        d="M25.3,172.8c-0.1,0-0.2,0-0.3,0.1c0.1,0.1,0.1,0.2,0.2,0.2s0.2-0.1,0.3-0.1C25.5,172.9,25.4,172.8,25.3,172.8z
		"
      />
      <path
        class="st2"
        d="M124.5,137c0,0-0.1,0.1-0.2,0.2c0.1,0,0.2,0.1,0.3,0.1l0.1-0.1C124.6,137.1,124.6,137.1,124.5,137z"
      />
      <path
        class="st2"
        d="M0.4,203.1c-0.1,0-0.1-0.1-0.2-0.1s-0.1,0-0.2,0.1v0.1c0.1,0.1,0.2,0.1,0.3,0.2C0.3,203.2,0.4,203.1,0.4,203.1
		z"
      />
      <path
        class="st2"
        d="M0.3,202.2c-0.1-0.2-0.1-0.3-0.2-0.5H0v0.2c0,0.1,0.1,0.2,0.1,0.3C0.2,202.2,0.3,202.2,0.3,202.2z"
      />
      <path
        class="st2"
        d="M83.7,173.5C83.8,173.5,83.8,173.5,83.7,173.5c0.1,0.2,0.2,0.2,0.2,0.3c0.1-0.1,0.1-0.1,0.2-0.2
		c0-0.1-0.1-0.2-0.1-0.2C84,173.3,83.9,173.4,83.7,173.5C83.8,173.4,83.8,173.4,83.7,173.5z"
      />
      <path
        class="st2"
        d="M178.8,120.9c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0.2-0.2,0.4-0.3,0.7c0,0.1-0.1,0.1-0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2
		C178.4,121.3,178.6,121.1,178.8,120.9z"
      />
      <path
        class="st2"
        d="M185.8,124.4c0-0.1,0-0.2-0.1-0.4c0,0-0.1,0-0.1,0.1C185.6,124.2,185.7,124.3,185.8,124.4z"
      />
      <path
        class="st2"
        d="M173.4,108.5c-0.1-0.1-0.1-0.2-0.1-0.2c-0.1,0.1-0.2,0.1-0.3,0.2c0,0.1,0,0.2,0,0.2
		C173.1,108.6,173.2,108.6,173.4,108.5z"
      />
      <path
        class="st2"
        d="M75.1,143c-0.2,0.1-0.4,0.1-0.6,0.2l0.1,0.1C74.8,143.2,74.9,143.1,75.1,143z"
      />
      <path
        class="st2"
        d="M189.7,117.8c-0.2,0-0.4,0-0.5,0.1s-0.1,0.2-0.1,0.4c0.2,0,0.3,0,0.5-0.1C189.6,118.1,189.6,117.9,189.7,117.8
		z"
      />
      <path
        class="st2"
        d="M31.2,158.7c0.1,0,0.1,0.1,0.2,0.1c0.1-0.1,0.2-0.1,0.2-0.2c0-0.1-0.1-0.2-0.1-0.2
		C31.4,158.5,31.3,158.6,31.2,158.7z"
      />
      <path
        class="st2"
        d="M159.9,113.6l0.1,0.1l0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.1
		C160,113.3,159.9,113.4,159.9,113.6C159.8,113.5,159.8,113.6,159.9,113.6z"
      />
      <path
        class="st2"
        d="M199.6,114.3c0,0.1,0.2,0.2,0.3,0.3c0.1-0.2,0.2-0.3,0.2-0.5c-0.1,0-0.3-0.1-0.4-0.1
		C199.7,114.1,199.6,114.3,199.6,114.3z"
      />
      <path
        class="st2"
        d="M249.7,113.5c0.1-0.1,0.2-0.1,0.3-0.2c0-0.1-0.1-0.2-0.1-0.2c-0.1,0.1-0.2,0.3-0.3,0.4
		C249.6,113.4,249.7,113.5,249.7,113.5z"
      />
      <path
        class="st2"
        d="M120.8,131c-0.1,0-0.3-0.1-0.4-0.1s-0.1,0.2-0.2,0.3c0.1,0,0.3,0.1,0.4,0.1C120.7,131.3,120.8,131.2,120.8,131
		z"
      />
      <path
        class="st2"
        d="M233.5,121.1c0.1-0.1,0.2-0.2,0.3-0.3c0,0-0.1-0.1-0.3-0.4c-0.1,0.2-0.1,0.4-0.2,0.5
		C233.3,121,233.4,121,233.5,121.1z"
      />
      <path
        class="st2"
        d="M238.3,135.4c-0.1-0.1-0.2-0.1-0.2-0.1c-0.1,0-0.2,0.1-0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.2
		C238.2,135.5,238.2,135.5,238.3,135.4z"
      />
      <path
        class="st2"
        d="M114.9,112.7c0,0-0.1,0.1-0.2,0.2c0.2,0.1,0.3,0.1,0.4,0.1l0,0l0.1-0.1l-0.1-0.1
		C115,112.8,115,112.7,114.9,112.7z"
      />
      <path
        class="st2"
        d="M220,89.9c-0.1,0-0.2,0.1-0.3,0.1c0.1,0.1,0.2,0.3,0.3,0.4C220,90.3,220,90.1,220,89.9z"
      />
      <path
        class="st2"
        d="M81.2,162.6c0-0.1,0.1-0.2,0.1-0.3l-0.2-0.1c-0.1,0.1-0.2,0.2-0.3,0.3C80.9,162.6,81,162.6,81.2,162.6z"
      />
      <path
        class="st2"
        d="M275.1,111c-0.1,0-0.2,0-0.2,0c0,0.2,0,0.3-0.1,0.5c0.1,0,0.2,0,0.2,0C275,111.3,275.1,111.1,275.1,111z"
      />
      <path
        class="st2"
        d="M234.4,134.5c0,0,0,0.1-0.1,0.2c0.1,0,0.2,0,0.3,0.1c0-0.1,0.1-0.2,0.1-0.2
		C234.7,134.5,234.5,134.5,234.4,134.5z"
      />
      <path
        class="st2"
        d="M185.5,110c0,0.2-0.1,0.3-0.1,0.5c0.1,0,0.2,0,0.3,0C185.7,110.4,185.6,110.2,185.5,110z"
      />
      <path
        class="st2"
        d="M141.6,137.6c0.1,0,0.2-0.2,0.3-0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0.1-0.2,0.1-0.3,0.2
		C141.4,137.5,141.5,137.7,141.6,137.6z"
      />
      <path
        class="st2"
        d="M166.4,103.5h-0.1c0,0.1-0.1,0.2-0.1,0.2c0.1,0,0.2,0,0.2,0C166.4,103.7,166.4,103.6,166.4,103.5z"
      />
      <path
        class="st2"
        d="M241.2,132.2c0,0,0.1-0.1,0.2-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.2,0.1-0.3,0.1
		C241,132.1,241.1,132.2,241.2,132.2z"
      />
      <path
        class="st2"
        d="M23.2,178.5c0,0.1,0.1,0.2,0.1,0.2c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.1,0,0.2,0c0-0.1,0-0.2-0.1-0.2
		c0-0.1,0-0.2-0.1-0.2C23.3,178.5,23.2,178.5,23.2,178.5z"
      />
      <path
        class="st2"
        d="M188.4,100.8c0.1-0.1,0.1-0.2,0.2-0.3c0,0-0.2-0.1-0.3-0.1c-0.1,0.1-0.1,0.3-0.2,0.4
		C188.2,100.7,188.3,100.8,188.4,100.8z"
      />
      <path
        class="st2"
        d="M288.4,105.9c0.1-0.1,0.2-0.1,0.2-0.2s-0.1-0.1-0.1-0.2c-0.1,0.1-0.2,0.1-0.3,0.2
		C288.2,105.8,288.3,105.9,288.4,105.9z"
      />
      <path
        class="st2"
        d="M150.6,136.9l-0.1-0.1c-0.1,0-0.1,0-0.2,0.1c-0.1,0.1-0.2,0.2-0.2,0.3c0.1,0,0.2,0,0.4,0
		C150.6,137.1,150.6,137,150.6,136.9z"
      />
      <path
        class="st2"
        d="M142.1,122.6c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.2,0.1-0.3,0.2c0.1,0.1,0.1,0.1,0.2,0.2
		C141.9,122.7,142,122.7,142.1,122.6z"
      />
      <path
        class="st2"
        d="M241.2,99.3c0-0.1,0.1-0.2,0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c0,0.1-0.1,0.2-0.1,0.2
		C241,99.2,241.1,99.3,241.2,99.3z"
      />
      <path
        class="st2"
        d="M105.9,133.3c0.2,0,0.3,0,0.5,0l0,0l0,0h0.1c0,0,0,0-0.1-0.1C106.3,133.3,106.1,133.3,105.9,133.3z"
      />
      <path
        class="st2"
        d="M183.4,109.5c0.1,0.1,0.1,0.1,0.2,0.1c0.1-0.1,0.1-0.1,0.2-0.2C183.7,109.4,183.6,109.4,183.4,109.5
		C183.4,109.4,183.4,109.5,183.4,109.5z"
      />
      <path
        class="st2"
        d="M76,141l-0.1-0.1l-0.1,0.1c0,0.1,0.1,0.1,0.2,0.2C75.9,141.2,75.9,141.1,76,141z"
      />
      <path
        class="st2"
        d="M75.5,142.5c-0.1,0-0.1,0.1-0.1,0.1c0,0.1,0,0.1,0,0.2c0.1-0.1,0.1-0.1,0.1-0.2V142.5z"
      />
      <path
        class="st2"
        d="M75.3,142.8C75.3,142.8,75.3,142.9,75.3,142.8c-0.1,0.1-0.2,0.1-0.2,0.2C75.2,143,75.3,142.9,75.3,142.8
		C75.3,142.9,75.3,142.8,75.3,142.8z"
      />
      <path
        class="st2"
        d="M75.3,166.1c0-0.1-0.1-0.1-0.2-0.3c0,0.1-0.1,0.2-0.1,0.2c0,0.1,0.1,0.1,0.1,0.2
		C75.2,166.3,75.3,166.2,75.3,166.1z"
      />
      <path
        class="st2"
        d="M196.7,104.8c0-0.1-0.1-0.1-0.1-0.2l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2C196.6,104.8,196.6,104.8,196.7,104.8z"
      />
      <path
        class="st2"
        d="M171.3,123.2h0.1C171.4,123.2,171.4,123.1,171.3,123.2C171.4,123.1,171.3,123.1,171.3,123.2L171.3,123.2z"
      />
      <path
        class="st2"
        d="M112,120.7c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0-0.1,0.1-0.2,0.2C111.7,120.8,111.8,120.8,112,120.7
		C111.9,120.8,112,120.7,112,120.7z"
      />
      <path
        class="st2"
        d="M171.3,125.3c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1,0-0.2,0-0.3,0C171.3,125.2,171.3,125.3,171.3,125.3z"
      />
      <path
        class="st2"
        d="M148.6,130.6c-0.1,0-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1C148.6,130.7,148.6,130.7,148.6,130.6L148.6,130.6z"
      />
      <path
        class="st2"
        d="M261.7,107.2L261.7,107.2c0-0.1-0.1-0.1-0.1-0.1l-0.1,0.1l0,0C261.5,107.3,261.6,107.3,261.7,107.2
		C261.7,107.3,261.7,107.3,261.7,107.2z"
      />
      <path
        class="st2"
        d="M163.2,107.7c0.1,0,0.2,0,0.3,0s0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0C163.3,107.6,163.3,107.7,163.2,107.7z"
      />
      <path
        class="st2"
        d="M128.7,115.2C128.6,115.1,128.7,115.2,128.7,115.2L128.7,115.2z"
      />
      <path
        class="st2"
        d="M291,102c0,0.1-0.1,0.3-0.1,0.4c0.1-0.1,0.2-0.2,0.2-0.3C291.1,102,291.1,102,291,102z"
      />
      <path
        class="st2"
        d="M30.6,159.6l-0.1,0.1c0,0.1,0.1,0.2,0.1,0.2l0.1-0.1C30.7,159.7,30.7,159.6,30.6,159.6z"
      />
      <path
        class="st2"
        d="M119,141c-0.1,0-0.2,0-0.3,0l-0.1,0.1c0.1,0,0.2,0.1,0.3,0.1C118.9,141.2,118.9,141.1,119,141z"
      />
      <path
        class="st2"
        d="M273.2,140.4l0.1,0.1c0.1-0.1,0.1-0.1,0.2-0.2c-0.1,0-0.1-0.1-0.2-0.1S273.2,140.3,273.2,140.4z"
      />
      <path
        class="st2"
        d="M31.7,160.9l0.1-0.1c0-0.1-0.1-0.1-0.1-0.2l-0.1,0.1C31.6,160.8,31.6,160.8,31.7,160.9z"
      />
      <path
        class="st2"
        d="M188,127l-0.1,0.1c0,0.1,0.1,0.2,0.2,0.2l0.1-0.1C188.2,127.2,188.1,127.1,188,127z"
      />
      <path
        class="st2"
        d="M122.4,115.4c0,0.1,0.1,0.1,0.2,0.1c0-0.1,0.1-0.2,0.1-0.3c-0.1,0-0.2,0-0.3-0.1
		C122.5,115.2,122.4,115.3,122.4,115.4z"
      />
      <path
        class="st2"
        d="M253.9,112.9c0,0.1,0.1,0.2,0.1,0.2l0.1-0.1C254,112.9,254,112.8,253.9,112.9
		C254,112.8,253.9,112.9,253.9,112.9z"
      />
      <path
        class="st2"
        d="M245.4,115c0.1,0,0.2,0.1,0.3,0.1c0-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0S245.4,114.9,245.4,115z"
      />
      <path
        class="st2"
        d="M76.9,178c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.2-0.1,0.3-0.2l-0.1-0.1C77.1,178,77,178,76.9,178z"
      />
      <path
        class="st2"
        d="M109.7,145.8L109.7,145.8C109.6,145.8,109.6,145.9,109.7,145.8c0,0.1,0.1,0.2,0.1,0.2s0,0,0.1,0c0,0,0,0,0.1,0
		l0.1-0.1C109.9,145.8,109.8,145.8,109.7,145.8L109.7,145.8z"
      />
      <path
        class="st2"
        d="M10,167.8H9.9v0.1c0.1,0,0.1,0,0.2,0C10,167.9,10,167.9,10,167.8z"
      />
      <path
        class="st2"
        d="M33.6,131.4v0.1C33.7,131.5,33.7,131.5,33.6,131.4C33.7,131.5,33.7,131.4,33.6,131.4z"
      />
      <path
        class="st2"
        d="M220.1,90.6l-0.1-0.1c0,0,0,0,0-0.1v0.1C220,90.6,220.1,90.6,220.1,90.6z"
      />
      <path
        class="st2"
        d="M220.4,90.9c-0.1-0.1-0.2-0.2-0.3-0.3c0.1,0.1,0.1,0.2,0.2,0.4C220.4,91,220.4,90.9,220.4,90.9z"
      />
      <path
        class="st2"
        d="M71.5,155.2c0,0,0.1,0,0.1-0.1c0.1,0,0.2-0.1,0.2-0.1c-0.1,0-0.1-0.1-0.2-0.1c0,0,0,0.1-0.1,0.1
		C71.6,155.2,71.6,155.2,71.5,155.2z"
      />
      <path
        class="st2"
        d="M71.4,155.3L71.4,155.3c0.1,0,0.1,0,0.1-0.1C71.5,155.3,71.5,155.3,71.4,155.3L71.4,155.3z"
      />
      <path
        class="st2"
        d="M71.1,155.7c0.1-0.1,0.2-0.2,0.3-0.3c-0.2,0.1-0.3,0.1-0.5,0.2C71,155.6,71,155.6,71.1,155.7z"
      />
      <path
        class="st2"
        d="M248.6,82.8c-0.1,0-0.2,0-0.3,0.1c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.2-0.1,0.3-0.2
		C248.6,82.9,248.6,82.8,248.6,82.8z"
      />
      <path
        class="st2"
        d="M228.8,143.5c-0.1,0.1-0.1,0.2-0.2,0.3c0.1-0.1,0.3-0.1,0.4-0.2C228.9,143.6,228.8,143.5,228.8,143.5z"
      />
      <path
        class="st2"
        d="M160.1,97.8c0,0-0.1-0.1-0.2-0.1c0,0.1,0,0.1,0,0.2C159.9,97.8,160,97.8,160.1,97.8L160.1,97.8z"
      />
      <path
        class="st2"
        d="M26.8,125.9l-0.1,0.1c0.1,0,0.2,0,0.3,0l0.1-0.1C27,125.9,26.9,125.9,26.8,125.9z"
      />
      <path
        class="st2"
        d="M277.2,114.1l-0.1-0.1l-0.1,0.1l0,0C277.1,114.1,277.2,114.1,277.2,114.1z"
      />
      <path
        class="st2"
        d="M27.7,125.4c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.2-0.1-0.3-0.2C27.6,125.2,27.7,125.3,27.7,125.4z"
      />
      <path
        class="st2"
        d="M27.5,124.9C27.5,125,27.5,125,27.5,124.9c0.1,0.1,0.1,0.1,0.1,0.1C27.6,125.1,27.6,125,27.5,124.9
		C27.5,125,27.5,125,27.5,124.9z"
      />
      <path
        class="st2"
        d="M27.5,124.9C27.4,124.8,27.4,124.9,27.5,124.9L27.5,124.9z"
      />
      <path
        class="st2"
        d="M11.3,188.5c0,0,0.1,0,0.1-0.1v-0.1c-0.1,0-0.1,0.1-0.2,0.1C11.2,188.4,11.3,188.5,11.3,188.5z"
      />
      <path
        class="st2"
        d="M96.6,107.9c-0.1-0.1-0.2-0.1-0.2-0.2c0,0.1,0.1,0.2,0.1,0.3C96.5,107.9,96.5,107.9,96.6,107.9z"
      />
      <path
        class="st2"
        d="M96.3,107.7L96.3,107.7L96.3,107.7C96.2,107.6,96.2,107.6,96.3,107.7C96.3,107.6,96.3,107.7,96.3,107.7z"
      />
      <path
        class="st2"
        d="M172.9,90.1c-0.1-0.1-0.1-0.2-0.2-0.2l-0.1,0.1c0,0.1,0.1,0.2,0.2,0.2C172.8,90.2,172.9,90.1,172.9,90.1z"
      />
      <path
        class="st2"
        d="M69,174.5v0.1c0,0,0,0.1,0.1,0.1v-0.1C69,174.6,69,174.6,69,174.5z"
      />
      <path
        class="st2"
        d="M269.7,130C269.7,130,269.7,130.1,269.7,130c0,0.1,0.1,0.1,0.1,0.1s0,0,0-0.1C269.8,130,269.8,130,269.7,130z"
      />
      <path
        class="st2"
        d="M119.9,101.1c0-0.1,0.1-0.2,0.1-0.3l-0.1-0.1C119.9,100.8,119.8,100.9,119.9,101.1
		C119.7,101,119.8,101.1,119.9,101.1z"
      />
      <path
        class="st2"
        d="M228.5,128.6c-0.1,0-0.2-0.1-0.3-0.1s-0.2,0.1-0.2,0.2c0.1,0,0.2,0.1,0.3,0.1
		C228.4,128.8,228.5,128.7,228.5,128.6z"
      />
      <path
        class="st2"
        d="M244.3,135.3c0-0.1,0.1-0.1,0.1-0.2c0,0-0.1-0.1-0.2-0.1c0,0.1-0.1,0.2-0.1,0.3
		C244.2,135.2,244.3,135.3,244.3,135.3z"
      />
      <path
        class="st2"
        d="M157.6,144.7C157.6,144.6,157.5,144.7,157.6,144.7c-0.1,0.1,0,0.2,0,0.2l0.1-0.1
		C157.6,144.7,157.6,144.7,157.6,144.7z"
      />
      <path
        class="st2"
        d="M243.1,126.2c0,0.1,0,0.1,0.1,0.2l0.1-0.1C243.3,126.2,243.2,126.2,243.1,126.2
		C243.2,126.2,243.2,126.2,243.1,126.2z"
      />
      <path
        class="st2"
        d="M268.2,120.7c0,0.1,0.1,0.1,0.2,0.2v-0.1C268.4,120.7,268.4,120.7,268.2,120.7
		C268.3,120.7,268.2,120.7,268.2,120.7z"
      />
      <path
        class="st2"
        d="M239.8,127.6l-0.1-0.1c0,0.1-0.1,0.2-0.1,0.3c0,0,0.1,0,0.1,0.1C239.8,127.7,239.8,127.6,239.8,127.6z"
      />
      <path
        class="st2"
        d="M286,125c0-0.1,0.1-0.2,0.1-0.3l-0.1-0.1c0,0.1-0.1,0.2-0.1,0.3C285.9,124.9,286,124.9,286,125z"
      />
      <path
        class="st2"
        d="M107.1,97.4L107.1,97.4c-0.1-0.1-0.2-0.1-0.2,0C106.9,97.4,106.9,97.5,107.1,97.4
		C107,97.4,107,97.4,107.1,97.4z"
      />
      <path
        class="st2"
        d="M79.9,169l-0.1-0.1c-0.1,0-0.2,0.1-0.2,0.1l0.1,0.1C79.7,169.1,79.8,169,79.9,169z"
      />
      <path
        class="st2"
        d="M183.5,74.2C183.5,74.2,183.4,74.2,183.5,74.2c-0.1,0.1-0.1,0.2-0.1,0.2C183.5,74.4,183.5,74.4,183.5,74.2
		C183.6,74.3,183.5,74.2,183.5,74.2z"
      />
      <path
        class="st2"
        d="M26.3,174.9C26.4,174.8,26.4,174.8,26.3,174.9c0.1-0.1,0-0.1,0-0.1l-0.1-0.1l-0.1,0.1
		C26.2,174.8,26.2,174.8,26.3,174.9L26.3,174.9z"
      />
      <path
        class="st2"
        d="M154.8,75.1c-0.1,0-0.2-0.1-0.3-0.1c0,0.1,0.1,0.2,0.1,0.4C154.7,75.3,154.8,75.2,154.8,75.1z"
      />
      <path
        class="st2"
        d="M65.2,89.5c0-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.2-0.1,0.2c0.1,0.1,0.2,0.1,0.3,0.2
		C65.2,89.7,65.3,89.6,65.2,89.5z"
      />
      <path
        class="st2"
        d="M14.3,177.6c0,0-0.1,0-0.2,0.1c0,0.1-0.1,0.2-0.1,0.3c0.1-0.1,0.1-0.2,0.2-0.2
		C14.2,177.7,14.3,177.7,14.3,177.6z"
      />
      <path
        class="st2"
        d="M18.3,176.9c0.1,0,0.1,0,0.2-0.1c0,0,0-0.1-0.1-0.1c0,0-0.1,0-0.1,0.1C18.3,176.8,18.3,176.9,18.3,176.9z"
      />
      <path
        class="st2"
        d="M140,150.6c-0.1,0-0.2,0-0.3,0.1c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.2-0.1,0.3-0.2
		C140,150.6,140,150.6,140,150.6z"
      />
      <path
        class="st2"
        d="M2,207.9C2,207.9,2,208,2,207.9c0.1,0,0.1-0.1,0.2-0.2C2.1,207.8,2,207.9,2,207.9z"
      />
      <path
        class="st2"
        d="M0.3,200.6c0,0,0-0.1,0.1-0.1v-0.1c0,0-0.1,0-0.1,0.1C0.3,200.5,0.3,200.5,0.3,200.6z"
      />
      <path
        class="st2"
        d="M0.7,200.2l-0.1-0.1c0,0.1-0.1,0.2-0.1,0.2C0.5,200.3,0.6,200.3,0.7,200.2z"
      />
      <path
        class="st2"
        d="M76.9,179.9c0,0.1,0,0.1,0,0.2c0.1,0,0.1-0.1,0.2-0.1C77.1,180,77,179.9,76.9,179.9z"
      />
      <path
        class="st2"
        d="M76.9,180.1L76.9,180.1C76.8,180.1,76.8,180.1,76.9,180.1C76.8,180.2,76.9,180.2,76.9,180.1L76.9,180.1z"
      />
      <path
        class="st2"
        d="M70.4,179.3C70.4,179.3,70.4,179.2,70.4,179.3c0.1-0.1,0-0.2,0-0.2C70.3,179.2,70.3,179.2,70.4,179.3
		C70.3,179.3,70.3,179.3,70.4,179.3z"
      />
      <path
        class="st2"
        d="M77.7,177c0,0,0.1,0,0.1,0.1l0.1-0.1l-0.1-0.1C77.8,176.9,77.8,176.9,77.7,177z"
      />
      <path
        class="st2"
        d="M79.4,172.1c0,0.1,0.1,0.1,0.1,0.2c0-0.1,0.1-0.1,0.1-0.2C79.5,172.1,79.4,172.1,79.4,172.1z"
      />
      <path
        class="st2"
        d="M79.3,172C79.3,172.1,79.3,172.1,79.3,172C79.3,172.1,79.3,172.1,79.3,172C79.4,172.1,79.3,172.1,79.3,172
		C79.3,172.1,79.3,172.1,79.3,172z"
      />
      <path
        class="st2"
        d="M79.1,172c0.1,0,0.1,0,0.2,0.1V172C79.2,172,79.2,172,79.1,172z"
      />
      <path
        class="st2"
        d="M8.3,187.1h0.1l0.1-0.1l-0.1-0.1C8.3,187,8.3,187,8.3,187.1z"
      />
      <path
        class="st2"
        d="M273.4,129.1V129V129.1L273.4,129.1c-0.1,0-0.1,0.1-0.1,0.1C273.4,129.2,273.4,129.2,273.4,129.1z"
      />
      <polygon class="st2" points="270.5,129.3 270.6,129.3 270.6,129.2 	" />
      <path
        class="st2"
        d="M83.5,166.8L83.5,166.8c0.1,0.1,0.1,0.1,0.1,0.1C83.6,166.8,83.5,166.8,83.5,166.8L83.5,166.8z"
      />
      <path
        class="st2"
        d="M83.2,166.7L83.2,166.7C83.2,166.7,83.3,166.7,83.2,166.7c0.1,0,0.2,0,0.2,0.1
		C83.4,166.7,83.4,166.7,83.2,166.7C83.3,166.6,83.3,166.7,83.2,166.7z"
      />
      <path
        class="st2"
        d="M233,131.3c0,0.1,0,0.2-0.1,0.2C233,131.4,233,131.4,233,131.3c0.1-0.1,0.1-0.1,0.1-0.2
		C233.1,131.1,233,131.2,233,131.3z"
      />
      <polygon class="st2" points="28.8,172.6 28.9,172.5 28.9,172.5 	" />
      <polygon class="st2" points="87.9,159.5 87.9,159.4 87.8,159.4 	" />
      <polygon class="st2" points="153.2,144.6 153.4,144.6 153.3,144.5 	" />
      <path
        class="st2"
        d="M86.5,158.1c-0.1,0-0.2,0-0.2-0.1h-0.1c0,0,0,0,0.1,0.1C86.3,158.1,86.4,158.1,86.5,158.1z"
      />
      <path
        class="st2"
        d="M274.5,117.1c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C274.4,117.2,274.5,117.2,274.5,117.1z"
      />
      <path
        class="st2"
        d="M242.7,124.1c0.1,0,0.1,0,0.2,0C242.8,124.1,242.8,124,242.7,124.1C242.7,124,242.7,124,242.7,124.1z"
      />
      <path
        class="st2"
        d="M85.9,157.8l-0.1,0.1c0.1,0,0.2,0,0.3,0.1C86.1,158,86,157.9,85.9,157.8z"
      />
      <path
        class="st2"
        d="M101.8,154.4c0,0.1,0,0.2-0.1,0.2C101.8,154.5,101.8,154.5,101.8,154.4c0.1-0.1,0.1-0.1,0.1-0.2
		C101.9,154.2,101.8,154.3,101.8,154.4z"
      />
      <path
        class="st2"
        d="M235.3,123.7c0.1,0,0.2,0,0.2,0.1c0-0.1,0-0.1,0-0.2C235.5,123.6,235.4,123.7,235.3,123.7z"
      />
      <polygon class="st2" points="155.8,140.9 156,141 155.9,140.9 	" />
      <polygon class="st2" points="242.6,121.9 242.7,121.8 242.6,121.8 	" />
      <path
        class="st2"
        d="M235.6,123.3c0,0.1-0.1,0.1-0.1,0.2c0,0,0,0,0,0.1l0,0C235.6,123.4,235.6,123.4,235.6,123.3z"
      />
      <polygon class="st2" points="246.2,115.5 246.2,115.4 246.1,115.4 	" />
      <path
        class="st2"
        d="M290.3,103.6c-0.1,0-0.2,0-0.2,0.1c0,0,0.1,0,0.1,0.1C290.2,103.7,290.3,103.7,290.3,103.6z"
      />
      <path
        class="st2"
        d="M290.9,102.4c0,0.1,0,0.2-0.1,0.3C290.8,102.6,290.9,102.5,290.9,102.4L290.9,102.4z"
      />
      <path class="st2" d="M186.9,124.2L186.9,124.2l0.1-0.1L186.9,124.2z" />
      <path
        class="st2"
        d="M178.3,126.1l0.1-0.1c0,0-0.1,0-0.1-0.1l-0.1,0.1C178.2,126.1,178.3,126.1,178.3,126.1z"
      />
      <path
        class="st2"
        d="M182.7,122.9c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C182.6,123,182.6,122.9,182.7,122.9z"
      />
      <path
        class="st2"
        d="M138.3,132.4L138.3,132.4c0-0.1-0.1-0.1-0.1-0.1C138.1,132.3,138.2,132.3,138.3,132.4z"
      />
      <path
        class="st2"
        d="M178.1,121.7c-0.1,0.1-0.1,0.1-0.2,0.2l0,0l0,0C178,121.8,178.1,121.8,178.1,121.7z"
      />
      <path
        class="st2"
        d="M208.4,113.5c0,0.1,0,0.1,0,0.2l0.1-0.1C208.5,113.5,208.4,113.5,208.4,113.5z"
      />
      <path
        class="st2"
        d="M74.3,142.5l0.1-0.1c0,0,0-0.1,0.1-0.1c0,0-0.1,0-0.1,0.1S74.4,142.5,74.3,142.5z"
      />
      <path
        class="st2"
        d="M74.5,142.4L74.5,142.4c0.1,0,0.1-0.1,0.1-0.1C74.6,142.3,74.5,142.3,74.5,142.4z"
      />
      <path
        class="st2"
        d="M207.9,112.9l-0.1,0.1c0,0,0.1,0,0.1,0.1l0.1-0.1C208,113,207.9,113,207.9,112.9z"
      />
      <path
        class="st2"
        d="M84.2,137.7c0,0-0.1,0.1-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.1s0.1-0.1,0.2-0.1S84.2,137.7,84.2,137.7z"
      />
      <path
        class="st2"
        d="M94.3,135.1c0,0-0.1,0.1,0,0.1l0.1,0.1C94.4,135.2,94.4,135.2,94.3,135.1C94.4,135,94.4,135.1,94.3,135.1z"
      />
      <polygon class="st2" points="27.4,149.7 27.3,149.6 27.3,149.7 	" />
      <polygon class="st2" points="127.1,124.3 127.2,124.3 127.2,124.2 	" />
      <path
        class="st2"
        d="M269.5,84.9c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C269.4,85.1,269.4,85,269.5,84.9z"
      />
      <polygon
        class="st2"
        points="227,93.9 227,93.8 227,93.8 226.9,93.8 227,93.8 	"
      />
      <polygon class="st2" points="132.1,114.4 132.3,114.4 132.3,114.3 	" />
      <path
        class="st2"
        d="M195,100.3C195.1,100.3,195.1,100.3,195,100.3C195.1,100.3,195,100.3,195,100.3c-0.1,0.1-0.1,0.1-0.1,0.2
		C195,100.5,195,100.4,195,100.3L195,100.3z"
      />
      <path
        class="st2"
        d="M195.2,100c0,0.1-0.1,0.2-0.1,0.2C195.2,100.1,195.3,100.1,195.2,100C195.3,100.1,195.2,100,195.2,100z"
      />
      <polygon class="st2" points="139.8,112.1 139.8,112.2 139.9,112.2 	" />
      <polygon class="st2" points="242.5,89.5 242.4,89.5 242.5,89.6 	" />
      <polygon class="st2" points="226.5,93 226.4,93.1 226.6,93.1 	" />
      <path
        class="st2"
        d="M128.1,114.2C128.2,114.2,128.2,114.2,128.1,114.2c0.1-0.1,0.1-0.1,0.1-0.1
		C128.2,114.1,128.2,114.1,128.1,114.2C128.2,114.2,128.2,114.2,128.1,114.2z"
      />
      <path
        class="st2"
        d="M115.2,116.9L115.2,116.9v-0.2V116.9C115.1,116.9,115.2,116.9,115.2,116.9z"
      />
      <polygon class="st2" points="2.6,141.3 2.6,141.2 2.5,141.3 	" />
      <path
        class="st2"
        d="M269.6,80.3c0,0-0.1,0-0.2-0.1c0,0.1,0,0.1,0.1,0.2C269.5,80.3,269.6,80.3,269.6,80.3z"
      />
      <path
        class="st2"
        d="M70.4,120.8L70.4,120.8L70.4,120.8v0.2C70.4,121,70.4,120.9,70.4,120.8z"
      />
      <path
        class="st2"
        d="M106.5,110.2C106.5,110.2,106.6,110.2,106.5,110.2h0.2H106.5C106.5,110.1,106.5,110.2,106.5,110.2z"
      />
      <path
        class="st2"
        d="M159.2,97.6l-0.1-0.1l-0.1,0.1l0.1,0.1C159.2,97.7,159.2,97.6,159.2,97.6z"
      />
      <polygon class="st2" points="121.3,105.5 121.2,105.4 121.2,105.6 	" />
      <polygon class="st2" points="139.2,101 139.3,101 139.2,100.9 	" />
      <path
        class="st2"
        d="M157.1,96.5l-0.1-0.1l-0.1,0.1c0,0,0.1,0,0.1,0.1C157,96.5,157,96.5,157.1,96.5z"
      />
      <path
        class="st2"
        d="M96,107.5L96,107.5c0.1,0.1,0.1,0.1,0.2,0.1C96.1,107.5,96.1,107.5,96,107.5z"
      />
      <path class="st2" d="M155.9,92.6l0.1-0.1v-0.1L155.9,92.6L155.9,92.6z" />
      <polygon class="st2" points="134.6,97.2 134.6,97.3 134.7,97.3 	" />
      <path
        class="st2"
        d="M218.2,247.1c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.2-0.1,0.3-0.1c0.1-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0.1
		C218.4,247,218.3,247,218.2,247.1z"
      />
      <path
        class="st2"
        d="M239.9,231.1c0,0-0.1,0-0.1-0.1l0,0l0,0C239.8,231.1,239.9,231.1,239.9,231.1z"
      />
      <path
        class="st2"
        d="M418.6,121.9c-0.1,0-0.2,0-0.4-0.1c-2.3-0.5-4.6-1.2-7-1.7c-1.4-0.3-2.8-0.4-4.2-0.5c-0.1,0-0.2,0-0.3,0
		c-0.7-0.1-1.3-0.2-2-0.3c-0.5-0.1-1-0.1-1.5-0.1c-0.1,0-0.1,0-0.2,0c-0.3,0-0.6,0-0.8,0.1h-0.1c-0.9,0.1-1.8,0.4-2.7,0.5
		c0.4,0.4,0.7,0.5,1.1,0.6c0.2,0,0.4,0.1,0.6,0.1c1.6,0.2,3.2,0.4,4.8,0.6c2.1,0.3,4.1,1.3,6.2,0.2c0.2-0.1,0.6,0.1,0.8,0.1
		c1.8,0.5,3.6,1.1,5.4,1.4c0.3,0.1,0.7,0.1,1,0.2c1.4,0.2,2.9,0.4,4.4,0.6l0,0c0.4,0,0.9,0.1,1.3,0.2s0.8,0.1,1.3,0.2
		c0.1,0,0.2,0,0.3,0c0.2,0,0.4,0,0.5,0.1c3.7,0.5,7.4,0.9,11.1,1.4c3,0.4,5.9,0.8,8.9,1.2c1.9,0.3,3.7,0.2,5.5-1.3
		c-6.3-0.8-12.5-1.5-18.7-2.3c-1.4-0.2-2.8-0.3-4.3-0.5c-0.9-0.1-1.9-0.2-2.8-0.3c-0.5-0.1-1.1-0.1-1.6-0.2s-1-0.1-1.5-0.2
		c-1.1-0.1-2.2-0.3-3.3-0.4l0,0c-0.5-0.1-0.9-0.1-1.4-0.2l0,0l0,0c0.5,0.3,0.8,0.4,1,0.5c0,0.1,0,0.2,0,0.3
		C419.5,122,419,122,418.6,121.9z"
      />
      <path
        class="st2"
        d="M390,112c-0.2-0.1-0.4-0.2-0.6-0.2c-0.1,0-0.1,0-0.2,0c-0.3,0.1-0.7,0.1-0.9,0.3c-0.2,0.1-0.3,0.2-0.4,0.4
		c1.2-0.3,2.4-0.5,3.6-0.7c0.5-0.1,0.9-0.2,1.4-0.3c0-0.2,0-0.3,0-0.5c-0.9-0.3-1.5-0.3-1.9-0.1C390.5,111,390.3,111.4,390,112z"
      />
      <path
        class="st2"
        d="M355,225.8c0.3-0.1,0.6-0.3,0.9-0.5c0.1,0,0.1-0.1,0.2-0.1h0.1c0.4-0.2,0.9-0.5,1.6-0.1
		c-0.6,0.4-1.1,0.8-1.6,1.3c0,0,0,0,0.1,0c1,0.4,1.9,0.9,2.9,1.3c0.5,0.2,0.9,0.4,1.4,0.6c0.1,0,0.1,0,0.2,0c0.4,0.2,1,0.5,1.8,0.8
		v0.1c0.9,0.4,1.8,0.8,2.6,1.2c0.4,0.2,0.7,0.3,1.1,0.5c0.5,0.2,0.9,0.5,1.2,0.7c0.1,1-1.7,1.9-2.6,1.4c-0.5-0.2-1.1-0.5-1.6-0.8
		c-0.3-0.1-0.6-0.3-0.9-0.4c-2.1,0.2-3,0.7-3.3,1.9c1.2,0.6,2.4,1.2,3.6,1.8c0.2,0.1,0.5,0.2,0.7,0.3c0.6,0.1,1.1,0,1.7-0.4
		c4.4-3.2,8.7-6.4,13.1-9.6c0.6-0.5,1.2-0.9,1.9-1.4c0.6-0.4,1.2-0.9,1.8-1.3c0.5-0.4,1.1-0.8,1.6-1.2c0.3-0.2,0.6-0.5,1.1-0.9
		c-0.5-0.2-0.8-0.4-1.2-0.5c-12.3-5-24.6-10-36.8-15c-1.6-0.6-3.2-1.3-4.8-1.9c-0.3-0.1-0.6-0.2-1-0.4c-1-0.4-2.1-0.8-3.1-1.2l0,0
		l0,0c0.1,0.1,0.2,0.2,0.3,0.2c2,1.4,1.9,1.8-0.1,2.9c-0.7,0.4-1.5,0.8-2.3,1.2c-0.2,0.1-0.3,0.2-0.5,0.2l0,0
		c-0.7-2.6-3.1-2.4-5.3-3.2c2.8-1.4,5.2-2.2,8-1.4l0,0c-0.6-0.3-1.1-0.6-1.7-0.9c-9.9-4.1-19.9-8.1-29.8-12.2
		c-12.2-5-24.5-10-36.7-15c-0.6-0.2-1.2-0.5-1.7-0.7c-8.5-3.5-17.1-7-25.6-10.5c-1.8-0.7-3.6-1.3-5.3-2l0,0l0,0
		c1.4,1.5,1,2.7-1.2,3.7c-0.3-1-0.5-2.1-0.9-3.4c0.5-0.1,1.3-0.2,2-0.4l0,0c-0.5-0.3-1.1-0.6-1.6-0.9c-1,1.7-1.7,1.7-3.3,0.7
		c-0.8-0.5-1.8-0.6-3.2-1.1c0.5,1.1,0.7,1.7,1.1,2.4c-0.9,0.4-1.7,0.8-2.7,1.3c-0.5-1.6-0.3-2.9,0.9-3.6c1-0.6,2.4-0.6,3.9-1
		c-1.7-0.7-3.4-1.3-4.9-2c-0.3-0.1-0.5-0.2-0.8-0.3c-0.9-0.3-1.7-0.7-2.5-1.1c0,0-0.1,0-0.1-0.1c-0.5-0.2-1-0.4-1.5-0.7
		c-1.4-0.7-2.6-0.5-4-0.2c-0.5,0.1-1,0.3-1.6,0.4c1.2,0.6,2.2,1.1,3.1,1.6c-0.1,0.2-0.1,0.3-0.2,0.5c-0.8-0.3-1.6-0.6-2.4-0.9
		c-0.8-0.3-1.6-0.6-2.3-0.9c-0.1,0.1-0.1,0.3-0.2,0.4c0.7,0.4,1.4,0.8,2.1,1.2c0.2,0.1,0.3,0.2,0.5,0.3c-0.1,0.2-0.1,0.3-0.2,0.5
		c-0.7-0.3-1.6-0.5-2.2-0.9c0,0-0.1,0-0.1-0.1c-1.3-0.9-2.6-0.7-4.1-0.2c-0.2,0.1-0.4,0.1-0.7,0.2c0.7,0.4,1.4,0.8,2,1.2
		c0.3,0.2,0.6,0.4,1,0.6c-0.5,0.1-0.9,0.1-1.3,0c-1.5-0.4-2.8-1.9-4.7-1c1.1,0.6,2,1.2,2.8,1.7c-0.1,0.2-0.2,0.4-0.3,0.6
		c-0.9-0.4-1.9-0.8-2.8-1.3c-1.3-0.8-2.5-0.6-3.9,0.1c0.6,0.3,1,0.5,1.4,0.8c3.5,1.7,7,3.4,10.5,5.1c0.1,0,0.1,0.1,0.2,0.1
		c3.8,1.9,7.7,3.7,11.5,5.6c8.9,4.3,17.8,8.6,26.7,12.9c0.2,0.1,0.4,0.2,0.6,0.3c17.5,8.5,35.1,17,52.6,25.4
		c7.1,3.4,14.2,6.8,21.2,10.3c0.1,0,0.1,0.1,0.2,0.1c2.4,1.2,4.9,2.4,7.3,3.5c0.4,0.2,0.7,0.4,1.1,0.5c0.5,0.2,0.9,0.5,1.4,0.7
		c1.6,0.8,3.1,1.5,4.7,2.3c0.5,0.2,0.9,0.4,1.4,0.7c1,0.5,2,0.9,2.9,1.4c1,0.5,2,1,3,1.5c0.4,0.2,0.8,0.4,1.1,0.6c0-0.3,0.1-0.6,0-1
		c0-0.3-0.3-0.5-0.4-0.7c-0.1,0.1-0.3,0.2-0.4,0.3s-0.3,0.2-0.4,0.3s-0.2,0.1-0.3,0.3c0,0-0.1,0-0.1-0.1c-0.1,0-0.2-0.1-0.2-0.1
		c-0.7-0.5-1.4-1.1-2.5-1.5c-0.3-0.1-0.6-0.2-1-0.2c0.5-0.2,0.8-0.5,1-0.8c0.5-0.5,0.8-1,1.6-1.1c0,0.4-0.1,0.8-0.2,1.2
		c0.2,0,0.4-0.1,0.6-0.2c0.4-0.2,0.7-0.4,1-0.7s0.6-0.6,0.9-0.8c0.9,0.9,1.3,1.3,1.8,1.5c0.5-0.3,1-0.6,1.6-0.9
		c0.2-0.1,0.6,0.2,0.9,0.3C354.6,225.7,354.7,225.7,355,225.8C354.9,225.8,354.9,225.8,355,225.8z M221.3,165.4c0-0.1,0-0.2-0.1-0.3
		c0.9-0.4,1.7-0.8,2.7-1.3c0.3,0.5,0.6,0.9,1.1,1.6C223.6,165.4,222.5,165.4,221.3,165.4z M227.5,163.6c1-0.3,1.9-0.7,2.5-0.9
		c1.2,0.8,2.1,1.3,3,1.9C231.8,166.1,229.5,165.8,227.5,163.6z M244.2,175c-0.6,0.1-1.4,0.5-1.9,0.3c-2.2-1-4.2-2.1-6.5-3.3
		c1.1-0.8,2-0.9,3-0.3c1.7,1,3.6,1.9,5.4,2.9C244.3,174.7,244.2,174.9,244.2,175z M245.3,173.9c-1.7-1-3.5-2-5.2-3
		c0.1-0.2,0.1-0.5,0.2-0.7c0.8,0.2,1.8,0.1,2.5,0.5c1.8,0.9,3.5,1.9,5.4,3C247.1,174.4,246.2,174.5,245.3,173.9z M243.1,170
		c1.5-1,6,0.5,8.9,2.8C248.4,173.3,246.2,170.7,243.1,170z M255.4,171.8c-0.9,0-1.8,0.2-2.6,0c-2.1-0.8-4-1.8-6.1-2.7
		c0-0.1,0-0.3,0-0.4c0.6-0.1,1.4-0.5,1.9-0.3c2.3,0.9,4.5,1.9,6.8,2.9C255.4,171.4,255.4,171.6,255.4,171.8z M291.5,198.1
		c-0.6-0.2-1.1-0.5-1.7-0.8c-1.3-0.6-2.5-1.2-3.8-1.9c-1-0.5-2-1.1-3-1.7c0.2,0,0.4-0.1,0.5-0.2c0.4-0.1,0.8-0.3,1.1-0.2
		c0.3,0.1,0.6,0.2,0.8,0.4c0.5,0.2,1,0.4,1.5,0.7c1.3,0.5,2.5,1.1,3.8,1.6c0.7,0.3,1.4,0.6,2.1,0.9c0.3,0.1,0.6,0.3,0.9,0.4
		c0,0.2,0,0.3,0,0.5c-0.5,0.1-1,0.2-1.5,0.3C292,198.2,291.7,198.2,291.5,198.1z M297.4,196.3c-0.6,0.1-1.3,0.5-1.7,0.3
		c-2.9-1.3-5.7-2.7-8.5-4.1c0-0.1,0-0.3,0-0.4c0.6-0.1,1.2-0.4,1.7-0.2c2.9,1.3,5.7,2.7,8.6,4.1C297.4,196,297.4,196.2,297.4,196.3z
M301.3,194.7c-0.6,0.1-1.2,0.3-1.7,0.2c-2.9-1.2-5.7-2.6-8.5-3.9c0-0.2,0-0.3,0-0.5c0.5-0.1,1.2-0.4,1.6-0.3
		c2.9,1.3,5.7,2.6,8.6,4C301.3,194.4,301.3,194.5,301.3,194.7z M303.7,193.2c-3-1.2-6-2.5-9-3.8c0-0.1,0-0.3,0-0.4
		c0.5-0.1,1.2-0.5,1.6-0.3c3,1.2,5.9,2.6,8.8,4.2C304.6,193,304.1,193.4,303.7,193.2z M365,218.4c1.8,0.8,3.6,1.5,5.4,2.3
		c0.2,0.1,0.4,0.2,0.6,0.2c1.2,0.5,2.5,1.1,3.7,1.6c0.3,0.1,0.7,0.3,1,0.4c0.6,0.2,1.1,0.5,1.7,0.7c0.1,0.1,0.3,0.1,0.4,0.2
		c0,0.2,0,0.4,0,0.5c-0.3,0.1-0.6,0.2-0.8,0.2c-0.4,0.1-0.8,0.2-1.1,0.1h-0.1c-0.3-0.1-0.5-0.2-0.8-0.4c-0.5-0.2-1-0.5-1.6-0.7
		c-1-0.5-2-0.9-3-1.4c-0.1,0-0.2-0.1-0.3-0.1c-0.3-0.1-0.6-0.3-0.9-0.4c-0.1-0.1-0.3-0.1-0.4-0.2c-1.6-0.8-3.3-1.5-4.9-2.3
		c-0.1-0.1-0.2-0.2-0.3-0.3c0-0.2,0-0.3,0-0.5C364,218.5,364.6,218.2,365,218.4z M361.3,220.8c1.4,0.6,2.7,1.2,4.1,1.8
		c1.1,0.5,2.1,0.9,3.2,1.4c0.3,0.1,0.5,0.2,0.8,0.3c1.6,0.7,3.1,1.4,4.7,2.1c0.1,0,0.1,0.1,0.6,0.7c-1,0.1-1.7,0.4-2.2,0.2
		c-1.5-0.6-2.9-1.3-4.4-2c-0.7-0.3-1.3-0.6-2-0.9c-0.2-0.1-0.4-0.2-0.7-0.3c-0.4-0.2-0.8-0.4-1.3-0.6c-0.1,0-0.2-0.1-0.2-0.1
		c-1.2-0.6-2.5-1.1-3.7-1.7c-0.1-0.1-0.2-0.1-0.4-0.2c0-0.1,0-0.3,0-0.4C360.3,221,360.9,220.7,361.3,220.8z M357.6,223.1
		c3,1.4,6,2.7,9,4.1c1.3,0.6,2.6,1.2,3.9,1.8c0,0,0,0.1,0.3,0.5c-0.6,0.1-1.3,0.4-1.7,0.2c-0.9-0.4-1.8-0.8-2.6-1.2
		c-2-0.9-3.9-1.8-5.9-2.7c-0.5-0.3-1.1-0.5-1.6-0.8c-0.8-0.4-1.6-0.8-2.5-1.1c-0.1,0-0.1-0.2-0.4-0.5
		C356.7,223.3,357.2,222.9,357.6,223.1z M318.9,213.3c-0.1-0.1-0.3-0.3-0.4-0.4c1.4-1.3,2.8-2.8,4.4-3.9c0.3-0.2,1.3,0.6,2.4,1.2
		C322.8,211.3,320.8,212.3,318.9,213.3z M327.7,209.3c-1.6,0.7-3.1-0.7-2.7-2.5c0.4-1.6,1.7-2.7,3.7-2.8c-0.9,2.4,1.4,2.1,2.7,2.9
		C330,207.8,328.9,208.7,327.7,209.3z M341.6,210.2c-2.2,0.2-3.9,1-5.1,2.9c-0.4,0.7-1,1.2-1.9,0.8s-1.2-1.2-0.9-2.1
		c0.4-1.5,0.7-3.1,1.5-4.3c0,0,0,0,0-0.1c0.1-0.1,0.2-0.2,0.3-0.3c0.9-0.9,2.2-1.5,3.3-2.3c0.2,0.1,0.3,0.2,0.5,0.3
		c-0.5,1.2-1.1,2.4-1.7,3.9c2.7-0.7,5.5-0.9,6.3-4.1c1.3,0.6,1.9,1.3,1.9,2.1c0,0.4-0.1,0.8-0.4,1.2c-0.2,0.3-0.5,0.6-0.9,0.8
		C343.7,209.7,342.6,210.1,341.6,210.2z M347.8,223.9c-0.1,0-0.1,0-0.2,0c0.1-0.1,0.1-0.1,0.2-0.2c0.3-0.3,0.7-0.7,1-1.1
		C349.3,223.5,349.2,223.7,347.8,223.9z"
      />
      <path
        class="st2"
        d="M396.2,100c0,0.2-0.1,0.4-0.5,0.4c-0.5,0.1-0.9,0.1-1.5,0.1l0,0l0,0c0.6,0.7,1.4,0.7,2.2,1
		c-0.2,0.4-0.3,0.8-0.7,1.1c1,0,2.1,0,3.1,0c2.5,0,2.6,0,2.6-2.5c0-0.3,0-0.6-0.1-1c-0.2,0-0.4,0.2-0.5,0.5
		c-0.2,0.6-0.5,0.7-0.9,0.1c-0.2-0.3-1.1,0.2-1-0.6c0.1-0.1,0.3-0.2,0.4-0.3c-0.2,0-0.3,0-0.5,0v-0.1l0,0c-0.1,0-0.2,0-0.3,0
		c-0.1,0-0.1,0-0.2,0c-0.3,0-0.7,0-1,0c0,0.1,0,0.1,0,0.2c-0.2-0.1-0.4-0.1-0.5-0.2c-0.2,0.1-0.3,0.2-0.4,0.3
		c-0.2,0.2-0.2,0.3-0.2,0.4s0.1,0.2,0.1,0.3l0,0C396.2,99.8,396.2,99.9,396.2,100z M398.7,98.8c0,0.1,0,0.2,0.1,0.2
		c-0.2,0-0.3-0.1-0.5-0.1C398.4,98.9,398.5,98.9,398.7,98.8z"
      />
      <path
        class="st2"
        d="M346.3,99.3c-0.7,0.5-1.1,1.1-1.4,1.7c-0.3,0.7-0.3,1.4-0.1,2.2c2.5-0.1,5-0.2,7.5-0.2c1.1,0,2.2-0.1,3.3-0.1
		c1.5,0,3-0.1,4.5-0.1l0.1-0.1c0.7-0.8,1.7-1.4,2.1-2.4c0.2-0.3,0.2-0.7,0.2-1.1c0-0.8-0.3-1.4-0.8-1.8c-4.1-0.1-8.3-0.1-12.4-0.1
		c-0.3,0-0.7,0-1,0c-0.3,0.6-0.8,1.1-1.4,1.4C346.7,99,346.5,99.1,346.3,99.3z"
      />
      <path
        class="st2"
        d="M420.9,114.6c0-0.1,0-0.1,0-0.2c-0.4,0-0.8-0.1-1.3-0.1c-1.3-0.1-2.6-0.2-4-0.4c-0.3,0-0.6-0.1-0.9-0.1
		c0,0.1,0,0.2,0,0.3c0.2,0,0.4,0,0.7,0.1c1.8,0.2,3.6,0.3,5.5,0.5C420.9,114.7,420.9,114.7,420.9,114.6z"
      />
      <path
        class="st2"
        d="M341.7,102.8c0.1,0.2,0.2,0.4,0.3,0.6c0.5,0,1.1-0.1,1.6-0.1c-0.1-0.2-0.1-0.4-0.2-0.8
		C342.9,102.6,342.3,102.7,341.7,102.8z"
      />
      <path
        class="st2"
        d="M441.4,116.4c-1.2-0.1-2.4-0.2-3.6-0.3c-0.5,0-1.1-0.1-1.6-0.1s-1-0.1-1.5-0.1c-1-0.1-2.1-0.2-3.1-0.3
		c0,0.1,0,0.3,0,0.4c1,0.1,2.1,0.2,3.1,0.3c0.5,0,1,0.1,1.5,0.1c0.3,0,0.7,0.1,1,0.1c1.4,0.1,2.8,0.3,4.2,0.4
		C441.4,116.7,441.4,116.5,441.4,116.4z"
      />
      <path
        class="st2"
        d="M370.7,126.6c0.8,0.4,1.4,0.2,1.7-0.4c0.7,0.1,1.3,0.1,2,0.2c0.2,0,0.4,0.1,0.6,0.1c0.2,0.1,0.3,0.1,0.3,0.2
		c0.1,1.1,0.9,0.9,1.6,1c0.4,0.1,0.8,0.1,1.2,0.2c0.8,0.1,1.5,0.2,2.2,0.4c0.6,0.2,1.2,0.3,1.7,0.3c0.2,0,0.4,0.1,0.7,0.1
		c0.5,0,1.1,0.1,1.6,0c0.2,0,0.4,0,0.6,0c0.4,0,0.8-0.1,1.2-0.1c0.3-0.1,0.7-0.1,1-0.2c1-0.2,2-0.5,3-0.9c-0.9-0.2-1.6-0.3-2.2-0.4
		c-0.9-0.1-1.7-0.3-2.6-0.4c-1.3-0.2-2.6-0.4-3.9-0.6c-0.4-0.1-0.8-0.1-1.2-0.2c-0.7-0.1-1.4-0.2-2.1-0.3c-0.2,0-0.4-0.1-0.6-0.1
		c-0.3,0-0.6-0.1-0.9-0.1c-0.4-0.1-0.7-0.1-1.1-0.2c-1.4-0.2-3-1-4.3,0.4c-0.3-0.2-0.6-0.5-0.8-0.7c-0.1,0.1-0.2,0.3-0.3,0.4
		C369.9,125.9,370,126.3,370.7,126.6z"
      />
      <path
        class="st2"
        d="M383.5,117.4c-0.1,0.1-0.2,0.3-0.3,0.4c0.5,0.3,1.1,0.7,1.6,0.7c0.3,0,0.5,0.1,0.8,0.1c0.2,0,0.3,0,0.5,0.1
		c1.2,0.2,2.4,0.3,3.6,0.4c0.2,0,0.4,0,0.6,0.1c1.1,0.1,2.1,0.2,3,0.3c0.3,0,0.7,0.1,1,0.1h0.1c0.7-0.4,1.1-0.7,1.5-0.9
		c0-0.1,0.1-0.2,0.1-0.4C391.9,117.9,387.8,117,383.5,117.4z"
      />
      <path
        class="st2"
        d="M370.4,125c-0.5-0.2-0.9-0.6-1.4-0.6c-1-0.2-2.1-0.3-3.2-0.4s-2.2-0.3-3.3-0.4c-0.6-0.1-1.2-0.2-1.8-0.3
		c-1.1-0.2-2-0.2-3.1,0c-0.6,0.1-1.3,0.3-2,0.5c-0.1,0-0.1,0-0.2,0.1c0.1,0.1,0.2,0.1,0.3,0.2c0.7,0.4,1.3,0.7,1.8,0.8
		c0.1,0,0.1,0,0.2,0c0.8,0.1,1.6,0.2,2.4,0.3c0.4,0,0.8,0.1,1.2,0.2c2.7,0.5,5.4,1,7.9,1.4c0.1-0.1,0.1-0.2,0.2-0.2
		c0.2-0.4,0.4-0.7,0.6-1C370.2,125.3,370.3,125.2,370.4,125L370.4,125z"
      />
      <path
        class="st2"
        d="M433.4,117.1c-0.6-0.1-1.3-0.1-1.9-0.2l0,0c0,0.1,0,0.3,0,0.4c1.4,0.1,2.8,0.3,4.2,0.4
		c0.8,0.1,1.5,0.1,2.3,0.2c0.7,0.1,1.3,0.1,2,0.2c0-0.2,0-0.3,0-0.5c-0.9-0.1-1.9-0.2-2.8-0.3c-0.4,0-0.8-0.1-1.2-0.1
		C435.2,117.3,434.3,117.2,433.4,117.1z"
      />
      <path
        class="st2"
        d="M339.9,236.3c0.1,0.2,0.2,0.4,0.6,0.6c0-0.2,0-0.3,0.1-0.5c0-0.1,0-0.2,0-0.3c0,0,0,0,0-0.1
		c-0.3-0.2-0.7-0.4-1-0.6C339.7,235.7,339.8,236,339.9,236.3z"
      />
      <path
        class="st2"
        d="M346.9,234.1c0.2,0,0.3-0.6,0.5-0.8c0.3-0.2,0.6-0.3,1-0.5c-0.1-0.2-0.1-0.5,0-0.8l0,0l0,0c-1-0.5-2-1-3.1-1.5
		c-1.4-0.7-2.8-1.4-4.2-2c-0.3-0.2-0.7-0.3-1-0.5c-0.2-0.1-0.5-0.2-0.7-0.4c0,0-0.1,0-0.1-0.1c-0.9-0.5-1.9-0.9-2.8-1.4
		c0,0,0,0-0.1,0c0,0,0,0-0.1,0c-1.6-0.7-3.1-1.5-4.7-2.2c-0.2-0.1-0.5-0.2-0.7-0.4l0,0c-2.8-1.3-5.5-2.7-8.3-4
		c-1.1-0.5-2.2-1.1-3.3-1.6c-2.3-1.1-4.5-2.2-6.8-3.3c-2.2-1.1-4.4-2.1-6.6-3.2c-9.1-4.4-18.2-8.9-27.2-13.3
		c-0.6-0.3-1.3-0.6-1.9-0.9c-24.6-12-49.2-24.1-73.9-36.1c-1-0.5-1.9-0.9-2.9-1.4c-0.8-0.4-1.6-0.5-2.3-0.5c-1,0-2,0.3-3.1,0.6
		c1.1,0.6,1.9,1.1,2.8,1.6c0.1,0,0.1,0.1,0.2,0.1c-0.1,0.1-0.1,0.2-0.2,0.3c0,0.1-0.1,0.2-0.1,0.2c-0.4-0.2-0.8-0.4-1.2-0.5
		c-0.4-0.2-0.8-0.4-1.2-0.6c-0.1-0.1-0.2-0.1-0.3-0.2c-0.4-0.2-0.7-0.3-0.9-0.4c-0.6-0.3-0.9-0.3-1.3-0.1c-0.2,0.1-0.5,0.2-0.8,0.4
		c0.4,0.2,0.7,0.4,1.1,0.7c0.5,0.3,1,0.6,1.5,0.9c-0.1,0.2-0.2,0.4-0.3,0.5c-0.6-0.3-1.3-0.5-1.9-0.8c-0.2-0.1-0.4-0.2-0.6-0.3
		c-1.2-0.9-2.4-0.7-3.8-0.2c-0.1,0-0.3,0.1-0.4,0.2c0.1,0.1,0.2,0.2,0.4,0.2c0.9,0.6,1.7,1.1,2.7,1.7c-1.7,0.5-2.5-0.5-3.4-1.1
		c-0.1,0-0.1-0.1-0.2-0.1c-0.2-0.1-0.3-0.2-0.5-0.2c-0.1-0.1-0.3-0.1-0.4-0.1c-0.7-0.2-1.4,0-2.2,0.4c0.1,0.1,0.2,0.2,0.4,0.2
		c0.8,0.6,1.6,1.1,2.4,1.6c-1.3,0.8-2-0.2-2.6-0.7c-0.2-0.1-0.3-0.2-0.5-0.3c-1-0.6-1.9-0.6-3-0.3c-0.3,0.1-0.7,0.2-1,0.4
		c0.6,0.4,0.9,0.6,1.4,0.9c2.7,1.6,5.4,3.2,8.1,4.8c0.8,0.5,1.5,0.9,2.3,1.4c9.6,5.7,19.2,11.5,28.9,17.2c0.1,0,0.1,0.1,0.2,0.1
		c11.3,6.7,22.5,13.5,33.8,20.2c1.3,0.8,2.6,1.6,3.9,2.3c3.3,2,6.6,3.9,9.9,5.9c0.4,0.2,0.8,0.5,1.2,0.7c0.3,0.2,0.5,0.3,0.8,0.5
		s0.6,0.4,0.9,0.5c4.1,2.5,8.3,4.9,12.4,7.4c0.2,0.1,0.3,0.2,0.5,0.3c1.8,1.1,3.6,2.1,5.3,3.2c1.8,1.1,3.7,2.2,5.5,3.3
		c0-0.1,0-0.1-0.1-0.2c0.3-0.2,0.6-0.5,0.9-0.7c-0.5-0.2-1-0.4-1.4-0.6c0.9-0.6,1.8-1.1,2.6-1.7c0.5-0.3,1-0.6,1.5-0.9
		c0.6-0.4,1.2-0.8,1.9-1.2c0.1-0.1,0.4-0.1,0.6,0c0.1,0,0.1,0,0.2,0.1s0.2,0.2,0.3,0.2c1.6,1.1,3.3,1.5,5.2,1.5c0.5,0,0.9,0,1.4-0.1
		c0.1,0,0.2,0.1,0.4,0.2c-0.5,0.5-1.1,1-1.8,1.4v0.1c0.6,0.4,1.2,0.8,2.2,0.4c1-0.4,1.2-1.2,1.2-2c0.7-0.3,1.3-0.6,2-1
		c0.4-0.2,0.8-0.4,1.3-0.4c0.1,0,0.3,0,0.4,0.1c0.1,0,0.1,0,0.2,0c0.3,0,0.8-0.2,0.8-0.4c0.2-0.9,1.1-1,1.8-1.2
		c0.8-0.3,1.6-0.6,2.5-0.7c0.5-0.1,0.8-0.3,1.2-0.6c0.9-0.7,1.8-0.6,2.4,0.2c0.1,0.1,0.2,0.3,0.2,0.4c0.2,1,0.5,2.1,0.7,3.2
		c0,0.2,0.1,0.4,0.1,0.6c-0.1,0.1-0.2,0.2-0.4,0.4c-0.1,0.1-0.2,0.3-0.3,0.5c-0.5,0.9,0.1,1.8,1.2,1.7c0.1,0,0.1,0,0.2,0
		c0.6-0.1,1.2-0.2,1.8-0.4c0.3-0.1,0.5-0.1,0.8-0.2c0.2,0,0.4-0.1,0.6-0.1c0,0.1,0,0.1,0,0.2c0.2,0.7,0,1.6,1.2,1.8
		c0.1,0,0.1,0.3,0.1,0.4v0.1c0,0.6,0.3,1.1,1.1,1.2c0.2,0,0.3,0,0.5,0c0.6,0,1-0.3,1.4-0.8c0.1-0.1,0.2-0.2,0.3-0.3
		c0.3,0.1,0.6,0.1,0.9,0.1c1.2,0,2-0.7,2.7-1.5c0.3-0.4,0.6-0.8,1-1.1c0.2,0.1,0.3,0.2,0.5,0.3c0,0,0,0,0.1,0
		c0.6,0.4,1.2,0.8,0.9,1.7c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.2,0.2,0.2c0.1,0,0.2,0,0.2,0c0.3,0,0.4,0,0.5,0.1s0.1,0.3-0.1,0.6
		c-0.1,0.2,0.8,0.1,0.9,0.7c0,0.1,0,0.1,0,0.2c0.1-0.1,0.3-0.3,0.4-0.4c0.6-0.4,1.2-0.4,2,0s1.7,0.8,2.5,1.2
		c0.4-0.1,0.9-0.1,1.1-0.3s0.4-0.3,0.6-0.5C346.2,234.4,346.5,234.2,346.9,234.1z M192.8,169.2c-0.3-0.2-0.6-0.3-0.9-0.5
		c0.3-0.1,0.6-0.2,0.8-0.2c2.3-0.6,4.7-1.3,7.1-1.9c0.5,3.4-2.3,3.4-3.9,4.5C194.9,170.4,193.9,169.8,192.8,169.2z M203.3,173
		c-2.5,1.3-4.8,1-6.8-1.5c1.4-0.6,2.8-1.3,4.2-1.9c0.3-0.1,0.9,0.3,1.2,0.6c0.8,0.8,1.5,1.5,2.6,0.4c0.1,0.2,0.3,0.3,0.4,0.5
		C204.3,171.7,204,172.7,203.3,173z M216.3,182.7c-1.8-1.1-3.6-2.1-5.6-3.3c1.2-0.9,2.1-0.8,3.2-0.1c1.8,1.1,3.6,2.1,5.5,3.2
		C218.3,183.3,217.4,183.3,216.3,182.7z M221.5,181.7c-2.3-1-4.4-2.2-6.8-3.4c1.2-1,2.1-0.8,3.1-0.3c1.8,1,3.6,2,5.5,3
		c0,0.1,0,0.3,0,0.4C222.6,181.5,221.9,181.9,221.5,181.7z M225.7,180.1c-1.8-1.1-3.8-2.1-5.7-3.2c0-0.1,0-0.3,0-0.4
		c0.5-0.1,1.2-0.5,1.6-0.3c2.2,1.1,4.4,2.3,6.7,3.5C227.4,180.5,226.7,180.7,225.7,180.1z M228.7,178.8c-1.7-1-3.5-1.9-5.3-2.9
		c1-0.9,1.8-0.9,2.7-0.4c1.9,1,3.8,1.9,5.9,2.9C230.7,179.5,229.8,179.5,228.7,178.8z M263.3,202.5c2.5,1.6,5,3.1,7.6,4.6
		c0,0.1,0,0.3,0,0.4c-0.5,0.1-1.2,0.5-1.5,0.3c-2.8-1.5-5.4-3.2-8.2-4.8C261.8,202.1,262.4,201.9,263.3,202.5z M263.9,209.4
		c-2-1.3-4.1-2.5-6.2-3.7c-0.5-0.3-0.9-0.6-1.4-0.8c0.6-0.5,1.1-0.8,1.6-0.8c0.3,0,0.7,0.1,1,0.4c2.5,1.6,5.1,3,7.9,4.6
		C265.7,209.9,264.9,210,263.9,209.4z M274.4,205.6c-0.5-0.2-0.9-0.5-1.4-0.7c-1.1-0.6-2.3-1.2-3.4-1.8c-1.2-0.7-2.4-1.3-3.5-2
		c0-0.1,0-0.3,0-0.4c0.5-0.1,1.1-0.4,1.4-0.2c0.1,0.1,0.3,0.1,0.4,0.2c0.3,0.1,0.6,0.3,0.9,0.5c1.7,0.8,3.3,1.7,4.9,2.6
		c0.5,0.3,1,0.5,1.5,0.8c0.3,0.2,0.7,0.3,1,0.5c0,0.1,0,0.3,0,0.4C275.6,205.4,274.8,205.8,274.4,205.6z M278.4,203.7
		c-0.2-0.1-0.5-0.3-0.7-0.4c-1.3-0.7-2.5-1.3-3.7-2s-2.4-1.4-3.6-2c0-0.1,0-0.3,0-0.4c0.5-0.1,1.2-0.4,1.6-0.2
		c2.9,1.4,5.7,3,8.5,4.5c0,0.2,0,0.4,0,0.6C279.7,203.8,278.9,204,278.4,203.7z M297.3,227.2L297.3,227.2c-0.4,0.2-0.8,0.4-1.2,0.6
		c-0.9,0.5-1.8,1-2.7,1.5c-1.1,0.7-1.9,0.3-2.1-0.8s-0.1-2.4,0.2-3.6c0.4-1.6,1.5-2.8,2.8-3.6c1.6,1.7,3.1,3.2,4.6,4.8
		C298.5,226.5,297.9,226.8,297.3,227.2z M304,223.2c-0.8-0.8-1.6-1.4-2.6-1.8c-0.1-0.1-0.3-0.1-0.4-0.2c-1.1-0.4-2.2-0.5-3.4-0.5
		c-0.1,0-0.2-0.1-0.4-0.2c1.3-1.5,5.3-2.2,8.7-1.9c1.7,0.2,3.3,0.6,4.4,1.3c-1.5,0.9-2.9,1.8-4.4,2.6c-0.4,0.2-0.8,0.5-1.2,0.7
		C304.6,223.4,304.1,223.3,304,223.2z M313,224.5c-1,1.3-2.3,2.3-3.4,3.4c-0.2-0.1-0.4-0.1-0.6-0.2c0.1-2.1-1.3-3-3-4
		c-0.1-0.1-0.2-0.1-0.3-0.2c0.1-0.1,0.2-0.1,0.3-0.2c0.2-0.1,0.4-0.3,0.6-0.4c0.3-0.2,0.5-0.3,0.8-0.5c1.2-0.8,2.2-1.5,3.4-2
		c0.2-0.1,0.8,0.2,1.2,0.6c0.3,0.2,0.5,0.4,0.7,0.6c0.5,0.5,0.8,1.2,0.8,1.8C313.4,223.8,313.3,224.2,313,224.5z"
      />
      <path
        class="st2"
        d="M306,124.1v0.2c0,0,0,0,0.1,0c0.7-0.1,1.4-0.3,2-0.4c1.1-0.2,2.2-0.4,3.2-0.6c1.1-0.2,2.1-0.4,3.2-0.6
		c0.3-0.9,0.1-1.6-0.8-2.1c-0.1,0.3-0.1,0.5-0.2,0.7c-0.3,0.9-0.4,1-1.4,0.9c-0.3,0-0.7-0.1-1-0.1c-0.5-0.1-1-0.4-1.2-1.1
		c-0.2,0.5-0.3,0.7-0.4,1c-1,0.3-1.9,0.6-2.7,0.9C306.4,123.2,306.4,123.8,306,124.1z M313.6,122.4l-0.1,0.1l-0.1-0.1H313.6z"
      />
      <path
        class="st2"
        d="M319.5,123c-0.8,0.2-1.7,0.3-2.5,0.5c-1.8,0.3-3.5,0.7-5.3,1c-0.6,0.1-1.2,0.2-1.8,0.3c-0.1,0-0.2,0-0.3,0
		c-1.2,0.2-2.4,0.5-3.6,0.7c-0.9,0.2-1.9,0.4-2.8,0.5c-0.8,0.2-1.7,0.3-2.5,0.5c-0.4,0.1-0.9,0.2-1.3,0.2c0,0,0,0,0,0.1
		c0.1,0.3,0.4,0.6,0.8,0.7c0.2,0,0.4,0.1,0.6,0c0.6-0.1,1.2-0.1,1.8,0c0.4-0.1,0.9-0.2,1.3-0.3c0.4-0.1,0.7-0.1,1.1-0.2
		c0.1,0,0.2-0.1,0.2-0.1s0,0.1-0.1,0.1c0.2,0,0.5-0.1,0.7-0.1c1.3-0.3,2.7-0.5,4-0.8c3.4-0.7,6.9-1.3,10.3-2
		c-0.2-0.3-0.4-0.6-0.6-0.9C319.6,123.1,319.5,123.1,319.5,123z M305.8,126.7c-0.1,0.1-0.3,0.1-0.4,0.2c0-0.1,0.1-0.3,0.1-0.4
		c0.1-0.1,0.3,0,0.4,0C305.9,126.5,305.8,126.7,305.8,126.7z"
      />
      <path
        class="st2"
        d="M321.1,125.5c-0.1,0-0.1-0.1-0.2-0.1c-1.5,0.3-3.1,0.6-4.6,0.9c-0.2,0-0.4,0.1-0.6,0.1
		c-1.6,0.3-3.2,0.6-4.9,0.9c-1.6,0.3-3.2,0.6-4.9,0.9c-0.6,0.1-1.3,0.2-1.9,0.4c-0.4,0.5-0.7,1-0.9,1.6c0.9-0.2,1.9-0.4,2.8-0.6
		c2.2-0.5,4.5-0.9,6.7-1.4c0.5-0.1,1-0.2,1.5-0.3c0.7-0.1,1.4-0.3,2.2-0.4c1.8-0.4,3.6-0.7,5.4-1.1
		C321.6,125.9,321.5,125.6,321.1,125.5z"
      />
      <path
        class="st2"
        d="M423.9,77.7c0-0.9-0.3-1.8-0.6-2.7c-0.2-0.6-0.4-1.2-0.3-1.7c-0.9,0-1.9,0-2.8,0c0.3,0.1,0.6,0.2,0.9,0.2
		c0.2,1,0.4,1.8,0.6,2.7c0,0.3-0.1,0.7-0.3,1c-0.3,0.6-0.5,0.8-0.3,1c0.1,0.2,0.3,0.3,0.6,0.6c0.3,0.3,0.4,0.7,0.4,1.2
		c0,0.1,0,0.1,0,0.2c0,1.1-0.1,2.1-0.3,3.2c-0.1,0.4,0.1,0.7,0.3,1.1c0.4,0.7,0.3,1.3-0.1,1.8c-0.3,0.3-0.7,0.5-1.2,0.6
		c-0.3,0.1-0.7,0.2-0.9,0.1c-1.7-0.5-3.6-0.1-5.4-0.2c-0.3-0.4-0.5-0.8-0.8-1.1c-0.5-0.5-1.1-0.6-1.8-0.4c-0.8,0.2-1.3,0.7-1.3,1.2
		c0,0.1,0,0.1,0,0.2c0,0.5-0.1,1-0.2,1.4c-0.1,0.3-0.2,0.6-0.4,0.9c-0.1,0.1,0.1,0.4,0.2,0.7c-1.2,0-2.5-1-3.5,0.5
		c-0.3-0.1-0.7-0.2-1-0.2s-0.6-0.1-0.9,0c-0.2,0-0.3,0.1-0.5,0.2s-0.5,0.3-0.7,0.6c-0.1,0.1-0.1,0.1-0.1,0.2c-0.5,0.6-0.3,1.2,0.4,2
		c-0.1,0.5-0.3,0.9-0.4,1.3c0.8,0,1.6,0,2.4,0c0.3,0,0.6,0.4,0.9,0.6c-0.3,0.2-0.6,0.6-0.9,0.7l0,0c-0.6,0-1.2,0-1.8,0
		c-0.2,0-0.5,0-0.7,0v0.1c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0.1,0.2,0.2,0.3c0.3,0.4,0.6,0.8,0.9,1.2c0.2,0.3,0.5,0.6,0.9,1
		c-0.9,0.5-1.7,1.1-2.6,1.1c0,1-0.1,2.1-0.3,3.1c-0.2,1-0.7,1.4-1.8,1.4c-1.9,0-3.9,0-5.8,0c-0.2,0.2-0.4,0.5-0.6,0.7
		c0.2,0.1,0.4,0.3,0.7,0.5c-0.2,0.2-0.5,0.4-0.7,0.7c0.3,0.4,0.6,0.7,0.9,1c0.1,0.3,0,0.6-0.2,0.9c-0.3,0.4-0.8,0.8-1.2,1.2
		c-0.1,0.1-0.2,0.2-0.3,0.3c0.5,0.6,0.4,1.4,0.5,2.1h0.1c1.5-0.3,3.1-0.3,4.7-0.1c4.6,0.4,9.3,0.9,13.9,1.3c1.4,0.1,2.8,0.3,4.1,0.4
		c2.1,0.2,4.1,0.4,6.2,0.6c0.1,0,0.2,0,0.3,0c0.8,0.1,1.6,0.2,2.4,0.2c0.5,0,0.9,0.1,1.4,0.1c1.2,0.1,2.5,0.2,3.7,0.4
		c1.3,0.1,2.5,0.3,3.8,0.4h0.1c0.8,0.1,1.5,0.1,2.3,0.2c0.5,0,1,0.1,1.5,0.1c1.4,0.1,2.7,0.3,4.1,0.4c6.5,0.6,13,1.2,19.4,1.8
		c0.4,0,0.8,0,1.4,0c0-2.7,0-5.4,0-8.3c-0.4,0-0.9-0.1-1.4-0.2c-0.2,0-0.4-0.1-0.6-0.1c-0.1,0-0.2,0-0.2,0c-1-0.2-2.1,0.2-2.7-1
		c-0.1-0.2-0.6-0.2-1-0.2c-0.9-0.1-1.9-0.1-2.8-0.2c-1.2-0.1-2.3-0.2-3.5-0.3c-2.2-0.2-4.5-0.3-6.7-0.5c-0.5,0-1-0.1-1.4-0.1
		c-1-0.1-2-0.1-3-0.2c-0.3,0-0.7-0.1-1-0.1c-0.4,0-0.8-0.1-1.2-0.1h-0.1c-0.5,0-1.1-0.1-1.6-0.1c-1.1-0.1-2.2-0.2-3.3-0.2
		c-1.4-0.1-2.8-0.2-4.2-0.3c-0.1,0-0.3,0-0.4,0c-0.6,0-1-0.1-1.3-0.4c-0.1-0.1-0.2-0.3-0.3-0.4c-0.1-0.2-0.1-0.5-0.1-0.8
		c0.1-1.4,0-2.8,0-4.1c0-0.3,0-0.7,0-1c0-0.8,0.4-1.5,0.7-2.5c-0.7,0-1.5,0.1-2.2,0c-0.4-0.1-0.8-0.4-1.3-0.6
		c0.4-0.2,0.8-0.6,1.2-0.5c1.7,0.3,2.9,0,3.9-0.9c0.7-0.6,1.3-1.3,1.8-2.2c1.5-2.5,3.3-4.8,5.1-7.2c-0.1-0.1-0.1-0.3-0.2-0.5
		c-0.1-0.1-0.3-0.1-0.4-0.2c-0.3,0.2-0.5,0.3-0.7,0.4c-0.4,0.2-0.9,0.4-1.3,0.5s-1.8,0.6-2.2,0.7c-1.3,0.6-2.7,0.8-4.2,0.6
		c-0.7-0.1-1.3-0.2-2.1-0.4c0.4-0.2,0.7-0.2,0.9-0.4c0.6-0.3,0.7-0.8,0.3-1.2c-0.5-0.5-1-0.9-1.3-1.1c-0.2-1.2-0.4-2.2-0.6-3.3
		c0-0.1,0-0.2-0.1-0.3c-0.1-0.2-0.1-0.5-0.1-0.7C423.9,78.4,423.9,78,423.9,77.7z"
      />
      <path
        class="st2"
        d="M322,127.4c-1.9,0.4-3.7,0.8-5.6,1.2c-3.4,0.7-6.9,1.4-10.3,2.1v0.1c1.1,0.6,2.2,1.2,3.3,1.7
		c0-0.1,0.1-0.3,0.3-0.7c0.7,0.1,1.3,0.2,2,0.4c1.4-0.3,2.8-0.6,4.2-0.9c1.4-0.3,2.9-0.6,4.3-1l0,0c3.7-0.8,7.4-1.6,11.1-2.5
		c0.6-0.1,1.1-0.3,1.7-0.4c0.1,0,0.1,0,0.2,0c0.3-0.1,0.7-0.2,1-0.2c2.3-0.5,4.5-1,6.8-1.5c0.8-0.2,1.6-0.4,2.4-0.5
		c1.1-0.2,2.1-0.5,3.2-0.7c2.4-0.5,4.7-1.1,7.1-1.6c0.7-0.1,1.3-0.3,2-0.4h0.1c0.1,0,0.2,0,0.3-0.1c0.7-0.2,1.4-0.3,2.1-0.5
		c1.6-0.4,3.2-0.7,4.8-1.1c2.6-0.6,5.2-1.2,7.9-1.8c0,0,0,0,0.1,0c2.4-0.5,4.8-1.1,7.1-1.6c2.6-0.6,5.2-1.2,7.8-1.7l0,0
		c-0.3-0.5-0.9-0.9-1.4-1.3c-2.2,0.5-4.5,0.9-6.7,1.4c-0.3,0.1-0.5,0.1-0.8,0.2c0,0,0,0-0.1,0.1c-0.3,0.3-0.5,0.6-0.8,1.1
		c-0.3-0.2-0.5-0.4-0.7-0.6c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.1,0-0.2,0c-1.6,0.3-3.1,0.7-4.7,1c-2.6,0.6-5.2,1.1-7.8,1.7
		c-0.1,0-0.2,0-0.3,0.1l0,0c-0.6,0.1-1.2,0.3-1.9,0.4c-0.5,0.1-1.1,0.2-1.6,0.3c-1.1,0.2-2.2,0.5-3.3,0.7c-0.2,0-0.3,0.1-0.5,0.1
		h-0.1c-0.8,0.2-1.7,0.3-2.5,0.5c-1.3,0.3-2.5,0.5-3.8,0.8c-5.3,1.1-10.7,2.2-16,3.3c-2.8,0.6-5.6,1.2-8.4,1.8
		c-0.3,0.1-0.6,0.1-0.9,0.2c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1,0.1-0.2,0.1-0.3,0.2l0,0h-0.1c-0.1,0.1-0.2,0.1-0.3,0.2
		C322,127.7,322,127.6,322,127.4z"
      />
      <path
        class="st2"
        d="M610.2,56.6c-0.5,0-1.1,0-1.4,0.2c-0.9,0.8-2.6,0.4-3.2,1.5c-0.2,0.4-0.2,0.9-0.1,1.3c0.1,0.3,0.4,0.6,0.8,0.7
		c0.2,0,0.4,0.1,0.6,0c0.8-0.2,1.4-0.1,2.1,0c0.3,0.1,0.6,0,0.9,0c0.5-0.1,0.9-0.4,1.4-0.6c-0.4,0.5-0.7,1-1.1,1.4
		c-1.1,1.3-1.4,2.8-1.4,4.3c-0.4,0.2-0.8,0.3-1.3,0.5c-0.1-0.4-0.2-0.8-0.2-1.1c-0.8-0.2-1.4-0.3-2.2-0.5c0.3-0.4,0.5-0.7,0.7-1
		c0.4,0.1,0.8,0.2,1.2,0.3c0.1-0.2,0.2-0.3,0.1-0.4c0-0.1-0.1-0.4-0.2-0.4c-1.3-0.2-1.2-1.9-2.7-2c-0.4,0-0.8-0.4-1-0.7
		c-0.4-0.5-0.7-1.1-1.1-1.7c-0.8-1-1.2-2.2-1.2-3.4c0-1.1-0.3-1.9-1.4-2.6c0.7-0.2,1.2-0.3,1.6-0.5c1.6-0.6,2.4-2.3,1.6-3.6
		c-0.6-1.2-2.4-1.6-3.9-1c-1.7,0.7-2.5,2.2-1.7,3.5c0.5,0.9,1.2,1.7,1.9,2.5c0.9,1,0.7,2.2-0.6,3c-1.5,0.9-2,1.6-1.7,2.7
		c0.3,1,1.2,1.4,3,1.3c0.2,0,0.3,0,0.6,0c0,0.5,0,1,0.1,1.5c0,0-0.1,0.1-0.1,0.3c-0.5-0.2-1.1-0.2-1.5-0.2c-0.5,0-1.1,0.2-1.6,0.5
		c-0.1,0.1-0.3,0.2-0.4,0.3c-0.2,0.1-0.4,0.2-0.5,0.4c0-0.2-0.1-0.4-0.1-0.5s0-0.2-0.1-0.3c-0.3-1.1-1-1.6-2.4-1.6
		c-0.4,0-0.7,0.1-1.1,0.1l0.1-0.1l0,0l0,0c-0.3,0.3-0.6,0.5-0.8,0.8c-0.4,0.4-0.6,0.8-0.6,1.2s0.2,0.8,0.5,1.2
		c0.2,0.3,0.5,0.5,0.8,0.7c0.9,0,1.6-0.1,2.3-0.4c0.2-0.1,0.5-0.2,0.7-0.4c0.1,0.4,0.2,0.8,0.2,1.2c0.1,0.7,0.2,1.4,0.4,2.1
		c0.3,1-0.1,2.2-0.2,3.5c-2-0.7-2.8-2.5-5-2.7c-0.5,0.9-1,1.7-1.5,2.7c-0.2,0.1-0.7,0.2-1.1,0.4c-0.1,0.1-0.2,0.4-0.2,0.6
		c0.3,0.7,0.9,0.5,1.5,0.3l0,0c0.3,0.1,0.5,0.2,0.8,0.2c-1.1,1.5-2.5,1.4-4,1.3c-0.2-0.2-0.3-0.5-0.5-0.7c-0.1-0.1-0.1-0.2-0.2-0.2
		c-0.1-0.2-0.3-0.5-0.4-0.7c-0.3-0.7-0.6-1.6-0.6-2.4c0-0.1,0-0.2,0-0.3c0-0.8-0.2-1.4-0.9-1.9c-0.2-0.2-0.4-0.4-0.6-0.6
		c-0.3-0.5-0.4-1-0.4-1.6c0.6-0.5,1.2-0.9,2.1-0.9c0.8,0,0.8,0,1.5-1.1c-0.8-0.3-1.5-0.7-2.4-1c-0.1-0.7-0.2-1.3-1.4-1.5
		c-0.9-0.1-1.6-0.8-2.7-1.3c-0.3,0.1-0.7,0.4-0.6,1c0.2,0.6,0.6,1.3,0.9,1.9c0.1,0,0.2-0.1,0.4-0.1c0-0.3,0-0.7-0.1-1.3
		c0.5,0.6,0.7,0.9,1.1,1.4c0.5,0,1.3-0.6,1.7,0.3c-0.1,0.1-0.3,0.3-0.5,0.4c-1.7,1.5-1.9,2.9-0.5,4.6c0.2,0.2,0.4,0.5,0.6,0.7
		c0.1,0.1,0.2,0.3,0.4,0.4c-0.1,0.4-0.2,0.9-0.2,1.4c0,0.2-0.1,0.5-0.1,0.7c0,0.1-0.3,0.2-0.5,0.3c-0.7,0.4-0.7,0.4-0.1,1
		c0.2-0.2,0.5-0.3,0.9-0.5c0.1,0.6,0.2,1.2,0.3,1.8c0.2,1,0.3,2.1,0.5,3.1c-0.9,0-1.5,0.1-2.3,0.1c-0.1-0.3-0.2-0.6-0.4-1.1
		c-0.3,0.3-0.5,0.4-0.8,0.8c-0.3-0.6-0.5-1.2-0.8-1.9c-0.3,0-0.7-0.2-0.9-0.2c-0.9,0.3-1.2,0-1.8-0.5c-0.2-0.1-0.2-0.3-0.3-0.4
		c-0.1-0.3,0.2-0.7,0.1-1c0-0.1,0-0.1-0.1-0.2c0.8-0.7,0.2-1.1-0.3-1.5c-0.1-0.1-0.3-0.2-0.4-0.4c-0.1-0.1-0.2-0.2-0.2-0.3
		c0-0.3,0.3-0.6,0.5-1c0.3,0.1,0.6,0.2,1,0.3c0-0.5,0.1-1,0.1-1.4c-0.9-0.1-1.7-0.2-2.6-0.2c0.3,0.2,0.4,0.4,0.6,0.5
		c-0.4,0.5-1,0.6-1.7,0.6v-0.1h-0.1c0,0,0,0,0,0.1c-0.2,0.2-0.3,0.3-0.5,0.5c-0.7-0.6-0.9,0.2-1.4,0.4c-0.5-0.9,0-1.6,0.8-2.4
		c0.4-0.4,0.8-0.9,1.1-1.3l0,0c0.2-0.2,0.4-0.5,0.6-0.7c0.2-0.2,0.4-0.5,0.6-0.8c-0.1-0.1-0.2-0.2-0.4-0.4c-0.1-0.1-0.2-0.2-0.4-0.3
		c0-0.1,0.1-0.2,0.1-0.3c0.2-0.5,0.4-0.9,0.6-1.4c0.1-0.2,0.1-0.3,0.2-0.5c-0.2-0.1-0.5-0.1-0.9-0.2c0.6-0.8,1.4-1.3,2.2-1.2
		c0.9,0.2,1.4-0.4,2-0.7c0,0,0.1,0,0.1-0.1c0.9-0.3,0.9-1.1,0.2-1.6c-0.5-0.4-1.1-0.7-1.6-1.1c-0.9-0.8-2-1-3.2-0.9
		c-0.2,0-0.5,0-0.7,0.1c0,0.4,0.5,0.9-0.1,1.2c-0.1,0-0.3,0.1-0.5,0.1c-0.1-0.2-0.3-0.5-0.4-0.8c-0.1-0.2-0.2-0.4-0.4-0.5
		c-0.3-0.2-0.6-0.4-1.1-0.3c-0.8,0.1-1.1-0.3-1.5-0.6l-0.1-0.1c-0.6-0.5-1-0.5-1.6,0.2c-0.4,0.5-0.9,0.3-1.3,0.6
		c-0.1-0.6-0.1-0.8,0.2-1l0,0c0.1-0.1,0.3-0.2,0.5-0.3c-0.6-0.4-0.5-1.4-1.7-0.9c-0.1,0-0.3-0.2-0.3-0.3c-0.2-0.9-1.3-1.3-1.7-2.1
		c-0.1-0.1-0.3-0.2-0.5-0.3c-0.3,0.4-0.7,0.7-1,1.1c-0.5-0.4-1-0.8-1.5-1.3c-0.5,0.3-1,0.5-1.4,0.8l0.1-0.1c0,0,0,0-0.1,0
		c0,0,0,0,0,0.1c-0.3,0.3-0.6,0.7-1,1c0.5,0.5,1,1,1.5,1.5c-0.4,0.8-0.8,1.6-1.2,2.5c-0.4-0.3-0.5-0.7-0.8-0.8
		c-0.4-0.1-0.8,0.1-1.5,0.3c0.3-1,0.5-1.9,0.8-3.1c-0.1-0.3-0.3-0.9-1.4-0.7c-0.3,0.1-0.7-0.4-1.1-0.7c0.5-0.3,0.9-0.6,1.3-0.8
		c0.2-0.1,0.4-0.2,0.5-0.3c-0.1-0.3-0.2-0.5-0.3-0.6c-0.3-0.4-0.6-0.3-1.6-0.1c0,0.2,0,0.3,0,0.5c0,0.1,0,0.3,0,0.4
		c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0-0.2,0c-0.3-0.1-0.7-0.2-1.2-0.3l0,0l0,0c0.1,0.2,0.1,0.4,0.2,0.5c0.1,0.2,0.2,0.5,0.2,0.7
		c-0.5,0.1-0.9,0.2-1.4,0.3c-0.4,0.1-0.8,0.4-1.5,0.7c0.3-0.6,0.5-1,0.6-1.3c-0.3-0.6-0.6-1-1.7-0.8c-0.2,0-0.4,0-0.6-0.1
		c-0.3-0.1-0.6-0.2-1-0.4c-0.1,0-0.2-0.1-0.3-0.1c-0.3,0.6-0.6,1.1-0.8,1.6c-0.1,0.2,0.1,0.7,0.3,0.8s0.7-0.1,1-0.2
		c0.3-0.2,0.5-0.4,0.8-0.7c0.3,0.1,0.4,0.3,0.7,0.4c-0.4,0.8-1.5,1.4-1.3,2.5c0.9-0.2,1-0.9,1.5-1.3c0.7,0.3,1.8-0.6,2.1,0.5
		c0.4-0.3,0.6-0.5,0.9-0.7c0,0.2,0,0.4,0,0.6c0,0.7,0.1,1.3,1.1,1.5c1-0.5,0.1-1,0.1-1.5c0.9,0,0.8,0.9,1.5,1.2
		c-0.5,0.4-0.9,0.7-1.3,1c0.1,0,0.2,0.1,0.4,0.1s0.3,0.1,0.5,0.1c-0.3,0.5-0.6,1-1,1.6c0.5,0.4,0.4,1.3,0.6,2
		c0.1,0.3-0.3,0.8-0.5,1.1c-0.2,0.2-0.5,0.4-0.9,0.7c-0.4-0.1-1-0.3-1.6-0.4c-0.3,0.3-0.5,0.6-0.8,0.9l0,0c-0.2,0.3-0.5,0.5-0.7,0.8
		c0.4,0.1,0.8,0.2,1.2,0.3c0.2,0.1,0.4,0.1,0.6,0.2c0.4,0.1,0.9,0.1,1.4-0.1c1.2,0.7,2-0.6,3.2-0.6c-0.2,0.3-0.4,0.6-0.6,0.9
		c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0-0.2-0.1-0.3-0.1c-0.2-0.1-0.3-0.1-0.5-0.2c-0.3,0.2,0,0.8-0.9,0.6c-0.5-0.1-1,0.7-0.9,1.3
		c0,0.1,0,0.2,0.1,0.3c0.2,0.3,0.5,0.5,0.7,0.7c-0.1,0.4-0.4,0.9-0.4,1.3c0,0.1,0,0.2,0.1,0.3c0.1,0.2,0.3,0.4,0.6,0.5
		c0.1,0,0.2,0.1,0.3,0.1c0.2,0,0.5,0.1,0.6,0.3c0.7,1,0.6,1,2,1.2c-0.1-0.9-0.3-1.9,1.2-2.5c-0.2,0.6-0.7,1.4-0.5,1.8
		c0.3,0.6-0.4,1.2,0.2,1.8c-0.8,0.4-1.4,0.8-2.1,1.2c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.2,0.2,0.3
		c0.4-0.3,0.8-0.6,1.3-0.8c0.9-0.4,1.5-0.9,1.8-1.8c0.8,0,1.7,0.3,2.3-0.6c0.7,0.5,1.4,0.9,2,1.3c0.1-0.4,0.3-0.5,0.7-0.5
		c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0c0.6,0,1.2,0,1.6-0.7c0.3,0.3,0.5,0.5,0.7,0.8c-0.3,0.2-0.7,0.4-1.2,0.8
		c0.8-0.1,1.2-0.1,1.7-0.1c-0.3,0.4-0.6,0.6-0.7,0.8c-0.7-0.1-1.3-0.2-1.9-0.4c-0.5-0.1-1-0.4-1.5-0.6c0,0.6,0,1.2,0,2.2
		c-0.6-0.6-0.9-0.8-1.1-1.1c-0.3,0.4-0.9,0.6-0.6,1.3c0.2,0.5,0,1.2-1,1.3c-0.2-0.3-0.4-0.5-0.6-0.8c-0.7,0.2-0.5,0.7-0.4,1.1
		c0,0.1,0.3,0.1,0.6,0.1c-0.8,0.4-1.6,0.8-2.5,1.3c0.2,0.2,0.3,0.4,0.6,0.7c-0.3,0.1-0.5,0.2-0.6,0.1c-0.6-0.3-0.6-0.8-0.2-1.3
		c-1-1.1-2.6-0.8-4-0.9c0-1,1.1-0.3,1.5-1c-0.5-0.1-1-0.2-1.6-0.3c0.1-0.1,0.2-0.2,0.2-0.4c0.1-0.2,0.2-0.4,0.4-0.5
		c-0.3-0.1-0.6-0.3-0.8-0.5c-0.7-0.6-0.7-1.6-0.9-2.6c-1.1,0-2.6,0.8-2.7-1c-0.4,0.4-0.6,0.6-1,0.8c-0.2-0.2-0.4-0.4-0.6-0.6
		c-2,0.6-2.1,0.6-3.4,0.5c-0.1,0.1-0.2,0.2-0.3,0.3c-0.2,0.3-0.5,0.5-0.8,0.8c-0.2-0.1-0.5-0.2-0.7-0.3c-0.1-0.1-0.3-0.1-0.4-0.1
		c-0.2,0-0.4,0.2-0.6,0.3l0,0c-0.2,0.1-0.5,0.2-0.7,0.1c-0.9-0.1-0.9-0.2-1.9,0.2c0,0.4,0,0.8-0.1,1.2c-0.1,0-0.2,0-0.3,0
		c-0.5,0-1,0.1-1.4,0.3c-0.1,0.2-0.3,0.4-0.4,0.6c-0.3,0.4-0.6,0.8-0.9,1.2c-0.1,0.1-0.2,0.3-0.3,0.4c0.5,0.7,1,1.4,1.5,2.1
		c0.8-0.2,0.8-1,1.2-1.4c0.1-0.2,0.3-0.3,0.7-0.2c0.5,0.5,0.6,1,0.7,1.6v0.1c0.1,0.4,0.3,0.7,0.6,1l0.1,0.1c0.2,0.1,0.2,0.6,0.1,0.8
		c-0.1,0.3-0.5,0.6-0.6,1S540,80,539.6,80c-0.6,0-0.6-0.4-0.6-0.8c0-0.2,0.1-0.4,0.2-0.6c-0.2,0-0.5,0-0.7,0c-0.1,0-0.2,0-0.2,0
		c-0.6,0-1.3,0.1-1.7,0.5c-0.6,0.5-1.1,0.3-1.6,0.3c0-0.8,0.1-1.6-0.3-2.2c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.2-0.2
		c-0.1,0-0.1,0-0.1,0c-1,1.3-2.1,2.6-3.1,4c-0.3,0.4-0.6,0.8-1,1.3c3.2,0.4,6.2,0.8,9.2,1.2c12,1.5,24.1,2.9,36.1,4.6
		c2,0.3,3.8,0.3,5.6-0.2c0.5-0.1,1-0.3,1.4-0.5c0.6-0.3,1.3-0.7,1.9-1.1c1.1-0.8,2.3-1.6,3.4-2.3l0,0c1.6-1,3.2-1.9,4.8-2.8
		c0.4-0.2,1-0.2,1.4-0.2c-0.3,0.4-0.4,1-0.8,1.3c-10.6,6.6-21.2,13.1-31.9,19.7c-0.9,0.5-1,1-0.8,2c1.4,5.4,3.1,10.7,4.1,16.2
		c1.1,6.1,1.7,12.4,2.5,18.6c0.3,2.5,0.5,5,0.6,7.5c0.1,1.3,0.1,2.5,0.1,3.8c0.1,3.1,0,6.1-0.1,9.2c0.1,0,0.3,0,0.4,0.1
		c0.1,0.4,0.1,0.8-0.4,1c0,1.2-0.1,2.4-0.2,3.6c0,0.3,0,0.7-0.1,1c1.2,0.1,2.3-0.2,3.1-1c0.1-0.1,0.3-0.3,0.4-0.5h0.1
		c1.6,0.5,3,1.1,4.9-0.3c-0.2,0.8-0.3,1.3-0.4,1.8c-2.3-0.7-3.8-0.5-4.7,0.5l0,0c-0.1,0.1-0.2,0.2-0.3,0.4c-0.6,1-0.4,1.9,0.6,2.8
		c0.6-0.2,1.2-0.3,1.8-0.4c0.7-0.2,1.5,0,2.3,0c-0.6,0.4-1.2,0.9-1.9,1.2c-0.7,0.2-1.4,0.4-2.1,0.6c-0.1,0.1-0.2,0.1-0.2,0.2
		c-0.1,0-0.1,0-0.2,0c-0.9,0.2-1.8,0.5-2.6,0.7s-1.2,0.6-1.4,1.3c0,0.1,0,0.3-0.1,0.4c0,0.2,0,0.4-0.1,0.5c0,0.3-0.1,0.6-0.1,0.9
		c0.3,0,0.6,0.1,1,0c-0.3,0.9-0.6,1.7-0.8,2.4c-0.2,0.1-0.3,0.1-0.5,0.2c-0.1,0.8-0.2,1.6-0.3,2.4c0,0.3-0.1,0.5-0.1,0.8
		c-0.2,1-0.3,2-0.5,3c0,0.1,0,0.1,0,0.2c0.7,0.2,1.4,0.2,2.1,0c1-0.2,1.9-0.7,2.5-1.5c0.4-0.6,0.8-1.2,1.2-1.8
		c-0.2,0-0.3-0.1-0.4-0.2c-0.2-0.2,0-0.6-0.1-1c0.5-0.1,0.9-0.2,1.3-0.2c1.1-0.1,1.9-0.3,2.6-0.8c0.2-0.1,0.3-0.2,0.4-0.4
		c0.3-0.3,0.5-0.6,0.6-0.9c0.2-0.6,0.3-1.3,0.1-2c-0.1-0.4-0.2-0.7,0.4-1c0.3,0.2,0.7,0.4,1,0.6c0.4,0.2,0.8,0.4,1.3,0.7
		c-0.3,0.3-0.6,0.5-0.8,0.7c-0.1,0.2-0.1,0.5-0.1,1.1c0.6-0.4,0.9-0.7,1.2-0.8s0.7-0.2,1.1-0.3c0.1,0.3,0.2,0.6,0.3,0.9
		c0.2,0.5,0.5,0.8,0.9,1.1s0.9,0.4,1.6,0.4c0.3,0,0.6,0,0.9-0.1c0.4-0.1,0.7-0.3,1-0.5c0.2-0.1,0.4-0.2,0.5-0.4
		c0.2-0.2,0.4-0.4,0.5-0.6c0-0.1,0-0.2,0-0.3c-0.1-0.5,0.1-0.8,0.8-1c0.3-0.1,0.5-0.6,0.8-0.9c0.1-0.2,0.4-0.5,0.5-0.4
		c1,0.3,1.5-0.6,2.4-0.8c0.6,1.2,1.6,0.3,2.6,0.3c0.4-0.8,0.3-1.3-0.5-1.7c-0.8,0-0.3,1.3-1.4,0.9c0.2-0.7,0.3-1.4,0.4-2
		c0.7-0.6,1.4-1.1,2.3-1.8c0.5,0.1,1.2,0.2,2,0.3c1.2,0.3,1.8,0.1,2.3-1c0.1-0.3,0.2-0.7,0.3-1.1c0.2-0.4,0.4-0.7,0.7-1
		c0.1,0,0.3,0,0.4,0.1c0,0.6,0,1.2,0,1.8c0,0.5-0.1,0.9-0.1,1.4v-0.1c-0.2,0.4-0.4,0.8-0.6,1.2c0,0,0,0.1-0.1,0.1h0.1
		c0.4-0.1,0.6-0.1,0.8-0.1c-0.1-0.4-0.2-0.8-0.2-1.2c0.3-0.4,0.6-0.9,1-1.6c0,0.1,0.1,0.2,0.1,0.3c0.1,0.3,0.2,0.5,0.2,0.7l0,0
		c-0.2,0.1-0.2,0.3,0.1,0.3c-0.1,0.5-0.2,0.9-0.3,1.3c-0.3,0.1-0.6,0.1-0.9,0.2c0.1,0.2,0.1,0.4,0.2,0.6h-0.1c0,0,0,0,0,0.1
		c0,0,0,0,0.1,0c0.3,0.5,0.4,1.2,1,1.5c1.4,0.6,0.9,1.6,0.7,2.5c-1.1,0.4-2,0.3-2.9,0.1c-1.8-0.3-3.3,0.2-4.6,1.5l-0.1,0.1
		c-0.4,0.5-0.7,0.9-0.9,1.4c-0.3,0.9-0.2,1.8,0.3,2.7c0.3,0.5,0.7,1,0.9,1.5c0.1,0.3,0.1,0.6,0,1c-0.1,0.2,0.2,0.5,0.5,0.7l0.1,0.1
		c0.1,0.1,0.2,0.1,0.3,0.2c0.2,0.1,0.3,0.2,0.5,0.3s0.4,0.2,0.5,0.2c1.7,0.7,3.4,0.1,4-1.3c0.1-0.3,0.2-0.7,0.2-1.1
		c0-0.5,0.1-0.9,0.5-1.3c0.3-0.3,0.6-0.7,0.8-1c0.6-1,0.6-2,0.1-3c-0.1-0.2,0-0.5,0.1-1c1.7,1.9,2.4,2.2,5.4,2.2
		c-0.3,0.3-0.5,0.6-0.7,1c0,0.1-0.1,0.1-0.1,0.2c-0.3,0.5-0.5,0.9-0.6,1.4c0,0.1,0,0.2-0.1,0.3c-0.3,1.8,0.6,3.6,2.7,4.4
		c1.4,0.6,3,0.6,4.4,0.1v-8.4c-0.8-0.1-1.6-0.2-2.4-0.4c-0.1,0-0.2,0-0.3,0c0.3-0.5,0.5-0.9,0.7-1.3c0.5-1,0.6-1.9,0.3-2.6
		c-0.2-0.5-0.6-1-1.2-1.4c0,0,0,0-0.1,0c-0.4-0.3-1-0.6-1.6-1c-1.3-0.1-2.2,0.9-3.3,0.4c-0.8,1.2-0.8,1.2-2.1,1c0-0.2,0-0.4,0.1-0.6
		c0.6-0.8,0-1.4-0.5-1.9c-0.3-0.3-0.9-0.4-1.4-0.6c0-0.1,0-0.2-0.1-0.3l0,0l0,0c0.1-0.1,0.1-0.1,0.1-0.2c0.7-1.1,0.2-2.2-0.1-3.3
		c0.3-0.3,0.6-0.6,1-0.8c0.3-0.2,0.6-0.3,0.9-0.2c0.3,0,0.6,0.2,0.8,0.5c0.1,0.2,0.2,0.3,0.3,0.5c0.3,0.4,0.5,0.8,0.8,1.2
		c-0.1,0.2-0.4,0.5-0.4,0.8c0,0.2,0.5,0.3,0.8,0.6c0.6-1.2,1.3-2.2,3.1-1.9c-0.4,0.3-0.9,0.5-1.1,0.8c-0.2,0.5,0.3,1.1,1.1,1.5
		c0.3-0.3,0.7-0.6,1-0.9c0.2,0.1,0.5,0.2,0.8,0.3c0.1-0.2,0.3-0.2,0.3-0.3s0-0.1,0-0.2c0-0.2,0.1-0.4,0-0.6
		c-0.4-0.6-0.4-1.1-0.3-1.5c0.1-0.4,0.4-0.8,0.7-1.1c0.1-0.1,0.2-0.2,0.2-0.3c0.2-0.2,0.5-0.5,0.7-0.7c0.3-0.3,0.6-0.7,1-0.9h0.1V74
		V57.1c-0.5,0-1-0.1-1.4-0.4C610.6,56.6,610.4,56.5,610.2,56.6z M589.9,72.1L589.9,72.1C589.9,72,589.9,72,589.9,72.1
		C589.9,72,589.9,72.1,589.9,72.1z M535.1,79.4C535.1,79.4,535.1,79.3,535.1,79.4C535.2,79.3,535.2,79.3,535.1,79.4
		C535.2,79.3,535.1,79.4,535.1,79.4z M542.6,70.7c0-0.2-0.1-0.4-0.1-0.6C542.9,70.3,543.1,70.4,542.6,70.7z M572.8,57.5
		c0.1,0,0.2,0,0.3,0.1c0.1,0,0.1,0.1,0.2,0.1c-0.2,0.2-0.3,0.3-0.4,0.4c-0.1-0.1-0.2-0.2-0.3-0.3c0,0,0,0-0.1-0.1
		C572.6,57.6,572.7,57.5,572.8,57.5z M566,54.5L566,54.5L566,54.5L566,54.5z M556.5,63.8c-0.1,0-0.3-0.1-0.4-0.1
		c0.1-0.1,0.1-0.2,0.2-0.2c0.1,0,0.3,0,0.4,0C556.5,63.6,556.5,63.8,556.5,63.8z M567.7,70.1L567.7,70.1L567.7,70.1L567.7,70.1z
M568.7,69.8c0-0.3-0.2-0.5-0.5-1c0.7,0.1,1.2,0.2,1.6,0.3c-0.7,0.6,0.1,0.4,0.5,0.6c-0.6,0.4-1.1,0.7-1.8,1.1
		C568.7,70.3,568.8,70,568.7,69.8z M600.6,170.2c0.1,0.2,0.1,0.4,0.2,0.5c-0.1,0-0.1,0-0.2,0.1c-0.1-0.2-0.1-0.4-0.2-0.5
		C600.5,170.3,600.5,170.3,600.6,170.2z M602.6,75.4c0,0.3,0,0.6,0,0.9c-1.2,0.7-2.4,1.5-3.6,2.1c-0.2,0.1-0.6,0.1-0.9,0
		c-0.1,0-0.1-0.7,0-0.7C599.5,76.8,600.6,75.2,602.6,75.4z M611.7,59.2c0.1-0.1,0.3,0,0.4,0c0,0.1,0,0.2-0.1,0.2
		c-0.1,0.1-0.3,0.1-0.4,0.2C611.6,59.4,611.6,59.3,611.7,59.2z"
      />
      <path
        class="st2"
        d="M607.6,49.8c-0.1,0.9,0.4,1.6,1.3,2.1c1.1,0.6,2.2,1.1,3.2,1.8l0,0v-6.9c-0.9,0.3-1.9,0.5-2.8,0.9
		C608.3,48.1,607.7,48.8,607.6,49.8z"
      />
      <path
        class="st2"
        d="M475.7,95.2c-0.7,0-1.5-0.1-2.2-0.1c0,1.3,0,2.4,0,3.5c1.1,0.3,2.1,0.4,2.9,0.5c2.1,0,3.4-1,4.4-3.3
		c0-0.1,0.1-0.2,0.1-0.3c-0.6,0-1.2-0.1-1.8-0.1C477.9,95.3,476.8,95.2,475.7,95.2z"
      />
      <path
        class="st2"
        d="M476.8,66.4c0.1,0.1,0.3,0.2,0.4,0.3c1.1-1.6,2.2-3.1,3.3-4.7l0,0c0-0.1,0-0.1,0-0.1
		C479.2,63.4,478,64.9,476.8,66.4z"
      />
      <path
        class="st2"
        d="M461.5,100.7c0,1.6,0,3.1,0,4.6c0,0.1,0,0.3,0,0.4c1.6,0.1,3.1,0.3,4.7,0.4c1.1,0.1,2.3,0.2,3.5,0.3
		c0.2,0,0.4,0,0.6,0.1c0-0.3,0-0.5,0-0.7l0,0c0-1.5,0-2.9,0-4.4c-2.8-0.2-5.6-0.4-8.5-0.6C461.7,100.7,461.6,100.7,461.5,100.7z"
      />
      <path
        class="st2"
        d="M473.4,93.6c0.4,0.4,0.9,0.7,1.4,0.8c1,0.2,1.9,0.2,2.9,0.2c0.1,0,0.2,0,0.2,0c3.5,0.2,3.6,0.2,5.7-2.8
		c0.2-0.2,0.4-0.5,0.5-0.7c0.7-1,1.4-2,2.1-3l0,0c0.3-0.4,0.6-0.8,0.8-1.3l0,0c-0.2-0.1-0.3-0.2-0.4-0.2c-0.9,0-1.7-0.1-2.6-0.1
		c-4.9-0.3-9.9-0.5-14.8-0.8c-0.6,0-1.2-0.1-1.7-0.1c-0.7,0-1.5-0.1-2.2-0.1c-0.4,0-1,0.1-1.2,0.4c-1,1.3-2,2.6-3,4
		c-0.3,0.4-0.7,0.9-1,1.3c-0.2,0.3-0.5,0.7-0.7,1c0.2,0,0.4,0.1,0.6,0.1c0.7,0.1,1.3,0.2,1.4,0.5c0.3,0.7,0.7,0.9,1.2,0.9
		c0.3,0,0.5,0,0.8,0.1c2,0.1,4,0.3,6,0.3c0.4,0,0.8-0.3,1.1-0.6c0.3-0.4,0.9-0.5,1.4-0.5C472.7,93.1,473.1,93.3,473.4,93.6z"
      />
      <path
        class="st2"
        d="M329,129.7c0,0.2-0.1,0.4-0.1,0.6c1.3,0.3,2.6,0.5,3.9,0.8c0.6,0.1,1.2,0.2,1.8,0.4c0.3,0.1,0.6,0.1,0.9,0.2
		c3.3,0.7,6.6,1.4,10,2c-0.1-0.8-0.3-1.5-0.4-2.3c-2.9-0.5-5.9-1-8.8-1.5c-0.5-0.1-1-0.2-1.6-0.3c0,0,0,0-0.1,0
		c-0.4-0.1-0.9-0.2-1.3-0.2c-0.6-0.1-1.2-0.2-1.7-0.3c-0.1,0-0.2,0-0.3,0c0,0.2-0.1,0.3-0.1,0.5c0.6,0.2,1.2,0.4,1.8,0.5
		c0,0.1,0,0.2-0.1,0.3C331.7,130.1,330.4,129.9,329,129.7z"
      />
      <path
        class="st2"
        d="M544.4,205.6c0.3-0.7,0.6-1.4,1-2.1c0-0.1,0-0.1,0-0.2c0-0.3-0.3-0.6-0.5-1c-0.4,0.2-0.7,0.3-1,0.4
		c-0.5-0.2-0.4-1.1-1.4-0.7c-0.1,0.2-0.2,0.4-0.4,0.8c-0.2-0.4-0.4-0.6-0.4-0.8c0-0.4,0.2-0.9,0.3-1.4c0.1-1.3-0.2-1.6-1.7-1.8
		c-0.1,0-0.2,0-0.4-0.1c-0.6,1.5-1.2,3-1.9,4.5c0.8,0,1.3,0.4,1.5,1.3c0.2,0.6,0.6,0.8,1.5,1l0.1-0.1c-0.1-0.3-0.1-0.7-0.2-1.1
		c0.2-0.1,0.7-0.5,0.9-0.5c0.9,0.3,1.5-0.1,2-0.8c0.3,0.4,0.5,0.6,0.7,0.8c-0.3,0.2-0.6,0.4-0.9,0.6
		C543.4,204.7,543.9,205.5,544.4,205.6z"
      />
      <path
        class="st2"
        d="M540.6,192.9c0.5-0.3,0.7-0.5,1.1-0.5c0.1-0.2,0.1-0.3,0.2-0.5c0.1-0.2,0.1-0.4,0.2-0.6
		c0.1-0.4,0.3-0.8,0.4-1.1c-0.3,0-0.6-0.1-1-0.2c-0.3-0.2-1.2,0.3-1.9,0.6s-1.3,0.5-1.8,0l0,0l0,0c0.5-0.4,0.7-0.6,0.7-0.8
		c0-0.1,0-0.2,0-0.3c0-0.2-0.1-0.4-0.1-0.7c0-0.1,0-0.1,0-0.2c0.1,0,0.2,0,0.3,0c1.1,0,1.1,1,1.9,1.4c0.2-0.3,0.3-0.7,0.6-1.4
		c0.2,0.4,0.4,0.6,0.5,0.8c0.6-0.2,1.1-0.8,1.2-1.3V188c0-0.1,0-0.3,0-0.4c-0.2-0.5-0.6-0.9-1-1.4l-0.1-0.1c0.2,0,0.4,0,0.7,0
		c-0.1-0.7,0-1.3,0.3-1.9c0.2-0.5,0.6-0.9,1.1-1.3c0.1-0.1,0.2-0.2,0.3-0.3c0.2-0.3,0.3-0.6,0.4-0.9c0.1-0.3-0.7-0.7-0.8-0.5
		c-0.3,0.9-1.5,0.6-2,1.2c-0.1,0.1-0.2,0.3-0.4,0.4c-0.6-0.1-1-0.6-1.5-0.8c-0.4-0.1-0.8-0.2-1.3,0c0,0.3,0,0.6,0,0.8
		c-0.1,1-0.8,1.8-2.1,2.4c0.3-0.8,0.7-1.6,1-2.4c-0.8-0.7,1.2-1.7-0.2-2.4c-0.7,0.2-0.3,0.8-0.5,1.2c-0.5,0.2-1.1,0.4-1.6,0.6
		c0-0.1-0.1-0.1-0.1-0.2c0.4-0.2,0.8-0.4,1.2-0.6c-0.1-0.1-0.2-0.2-0.4-0.3c-0.6-0.1-1.3-0.2-2.2-0.2c-0.2,0.2-0.7,0.5-1.1,0.8
		c-0.3-0.2-0.6-0.5-0.9-0.7c-0.4,0.1-0.8,0.2-1.1,0.3c0,0-0.1,0-0.1,0.1c-0.5,0.2-0.9,0.8-1.1,1.3c-0.1,0.2-0.1,0.4-0.2,0.6
		c-1.7,5.6-3.8,10.9-6.4,16.1c0.3,0,0.5-0.2,0.9-0.5c0.5-0.4,0.9-0.6,1.7-0.8c0.1,0.2,0.1,0.5,0.3,0.7c0.1,0.2,0.4,0.2,0.9,0.5
		c-1,0.1-1.6,0.2-2.3,0.3c0.3,0.8,0.7,1.6,1.5,1.6s1.3-0.2,0.8,0.7c-0.2,0.4,1.2,0.1,0.5,0.8c0.7,0.1,0.8,0.6,1,1.1
		c0.1,0.3,0.3,0.6,0.7,0.6c1.1,0,0.8-1.1,1.5-1.2c0.4,0.5,0.9,0.9,1.3,1.4c0.1,0.2,0.3,0.3,0.4,0.5c0.6-0.3,1.1-0.5,1.6-0.7
		c0,0,0,0,0-0.1c0.1-0.2,0.1-0.4,0.3-0.5c0.3-0.2,0.7-0.4,1.3-0.6c-0.4-0.4-0.8-0.7-1-1.1c-0.3-0.4-0.5-0.9-0.6-1.3
		c0-0.1,0.3-0.2,0.5-0.4c0.1,0.1,0.2,0.2,0.2,0.3c1.3-0.2,2.1-0.8,2.6-1.9c0.5,0.1,1.1,0.2,0.7,0.7c-0.2,0.3-0.2,0.5-0.1,0.8
		c0.2,0.5-0.1,0.9-0.7,1.1c-0.4,0.9-0.4,0.9,0.3,2.1c0.7-1.6,1.4-3.1,2.1-4.7h-0.1c0.1-0.1,0.2-0.2,0.2-0.3c0.3-0.7,0.6-1.5,0.9-2.2
		c-0.2-0.2-0.5-0.2-0.6-0.4c0.2-0.1,0.4-0.2,0.8-0.3c-0.3-0.4-0.5-0.8-0.8-1.3c0.2-0.1,0.5-0.2,0.7-0.3
		C540.4,193.4,540.4,193,540.6,192.9z M527.2,200.7c-0.1-0.1-0.1-0.1-0.2-0.2c0.2-0.2,0.4-0.3,0.5-0.5c0.1,0.1,0.2,0.1,0.2,0.2
		C527.6,200.4,527.4,200.5,527.2,200.7z"
      />
      <path
        class="st2"
        d="M542.8,190.1c-0.1,0.4-0.2,0.8-0.3,1.2c-0.1,0.2-0.1,0.4-0.2,0.6c0,0.2-0.1,0.3-0.1,0.5
		c0.4,0.1,0.9,0.3,1.9,0.6c0.3-0.4,0.6-0.9,0.9-1.4c-0.3-0.4-0.5-0.9-0.8-1.4C543.6,190,543.2,190.1,542.8,190.1z"
      />
      <path
        class="st2"
        d="M360.9,238.2c-0.5-0.2-0.9-0.4-1.3-0.7c-0.2-0.1-0.5-0.2-0.7-0.4c-0.1-0.1-0.3-0.1-0.4-0.2
		c-0.2-0.1-0.3-0.2-0.5-0.3c-0.3,0-0.6,0.1-0.9,0.3c0,0-0.1,0-0.1,0.1c-0.4,0.2-0.6,0.4-0.9,0.6c-0.4,0.4-0.7,0.8-0.9,1.3
		c-0.1,0.2-0.1,0.4-0.1,0.5c-0.1,0.4-0.1,0.8-0.2,1.2c0.2,0.1,0.3,0.2,0.5,0.3c0.3,0.2,0.6,0.3,0.9,0.5c0,0,0.1,0,0.1,0.1
		c1-0.7,1.9-1.4,2.9-2.1C359.8,239,360.3,238.6,360.9,238.2z"
      />
      <path
        class="st2"
        d="M546.3,204.4c-0.2,0-0.4-0.1-0.5-0.2c-0.2,0.4-0.4,0.9-0.6,1.3c0.7,0,1.2,0.3,1.7,0.7c0.2,0.2,0.7,0.1,1.2,0.1
		C547.8,205.4,547.5,204.6,546.3,204.4z"
      />
      <path
        class="st2"
        d="M391.6,237.7c0.9,0.6,1.7,0.9,2.4,0.9c0.6,0,1.2-0.1,1.7-0.4c0.9-0.5,1.4-1.7,1.2-2.5
		c-0.3-1.1-1.4-1.6-3.5-1.5c-0.2-0.1-0.3-0.2-0.4-0.3c-0.3-0.3-0.4-0.6-0.5-0.9c0-0.2,0-0.4,0-0.6c0-0.2,0-0.5,0-0.7
		s-0.1-0.5-0.2-0.7c-0.1-0.1-0.1-0.2-0.2-0.3c-0.8,0.1-1.4,0-2-0.5l0,0c-0.1-0.1-0.2-0.1-0.3-0.2c-0.2,0.1-0.3,0.3-0.5,0.4
		c-1,0.8-1.9,1.5-2.9,2.3c-1.3,1-2.6,2-3.9,3c0,0,0,0-0.1,0.1c-0.2,0.2-0.5,0.4-0.7,0.6c0.1,0.1,0.2,0.3,0.3,0.4
		c0.3,0.5,0.7,0.9,1.2,1.4c0.3,0.3,0.5,0.5,0.8,0.8C386.6,239.7,389.2,239.1,391.6,237.7L391.6,237.7z"
      />
      <path
        class="st2"
        d="M536.8,201.2C536.9,201.2,536.9,201.2,536.8,201.2C536.9,201.1,536.9,201.1,536.8,201.2L536.8,201.2z"
      />
      <path
        class="st2"
        d="M543,198.6c0.8,0.3,1.4,0.9,2.2,1c0.7,0.1,1.4-0.3,1.3-0.8c-0.1-0.5-0.3-1.1-1-1.2c-1-0.1-1.6-0.4-2-1.2
		c-0.3-0.6-1-0.6-1.8-0.2c-0.3,0.1-0.5,0.2-0.9,0.4c0,0.1-0.1,0.1-0.1,0.2c0.4,0.3,0.6,0.5,0.8,0.7C541.8,198,542.2,198.3,543,198.6
		z"
      />
      <path
        class="st2"
        d="M381.3,235.1c1.4-1.1,2.7-2.1,4.1-3.2c1.1-0.9,2.3-1.8,3.4-2.7c-0.2-0.2-0.4-0.4-0.5-0.7
		c-0.1-0.2-0.2-0.3-0.4-0.4c-0.4-0.2-1.1-0.2-1.7,0.1l0,0c-0.3,0.1-0.5,0.4-0.8,0.6l-0.1,0.1c0-0.1,0-0.1,0-0.2
		c0-0.2-0.1-0.3-0.1-0.5c-1.1,0.9-2.3,1.7-3.4,2.6c-0.2,0.1-0.3,0.2-0.5,0.4c-0.1,0.1-0.2,0.1-0.3,0.2c0.2,0.3,0.5,0.6,0.8,0.9l0,0
		C381.2,233.3,381.1,234.2,381.3,235.1z"
      />
      <path
        class="st2"
        d="M349,95.5L349,95.5c-0.2,0.2-0.2,0.4-0.3,0.7c0.1,0,0.2,0,0.3,0c2.9,0,5.8,0,8.8,0.1c0-0.3,0-0.5-0.1-0.7
		C354.8,95.4,351.9,95.4,349,95.5z"
      />
      <path
        class="st2"
        d="M420.6,57c0,0.3,0.1,0.6,0.1,0.8c0,0.4,0.1,0.8,0.1,1.2c-1.8,0.2-2.2,0.2-2.6,1.2c-0.1,0.3-0.3,0.6-0.4,1.1
		c0,0.1,0.1,0.2,0.1,0.2c0.7,1.1,2,1.3,3.4,1.2c0,0.2,0,0.4,0,0.6c-0.1,2-0.1,4-0.2,6.1c-1.2,0.4-2.2,1.1-2.2,2.3c0,0.1,0,0.1,0,0.1
		c1.4,0,2.9,0.1,4.3,0.1c0.1-0.2,0.3-0.5,0.4-0.7c0.2,0,0.4,0.1,0.6,0c0.3-0.1,0.6-0.3,0.8-0.5c-0.2-0.3-0.4-0.6-0.7-0.7
		c-0.1-0.1-0.5,0.1-0.7,0.1c-0.8,0.1-1.2-0.1-1.2-0.7c-0.2-1.9-0.4-3.9-0.6-5.9c0-0.2,0-0.4-0.1-0.6c0.9,0.1,1.7,0.1,2.4-0.3
		c0.2-0.1,0.4-0.3,0.5-0.4c0.3-0.4,0.6-1,0.7-1.4c0-0.5-0.1-0.9-0.5-1.2c-0.6-0.5-1.6-0.6-3.2-0.5c-0.2-0.3-0.2-0.7-0.3-1.1
		C421.4,57.7,421.2,57.3,420.6,57z"
      />
      <path
        class="st2"
        d="M430.7,96.1c0.3,0.1,0.4,0.2,0.6,0.2c2.6,0.2,5.2,0.3,7.7,0.4c2.2,0.1,4.4,0.3,6.6,0.4
		c1.9,0.1,3.8,0.2,5.7,0.3c0.3,0,0.8-0.1,1-0.3c0.2-0.2,0.3-0.4,0.5-0.6c0.5-0.6,1-1.3,1.5-2.1c0.1-0.2,0.2-0.3,0.3-0.5
		c-0.5,0-1-0.1-1.4-0.1c-0.7-0.1-1.3-0.1-1.9-0.2c-0.2,0-0.5,0-0.7-0.1c0-0.1,0-0.2,0-0.2c0-0.1,0-0.2,0-0.4c0.6,0,1.3,0.1,1.9,0.1
		c0.5,0,0.9,0.1,1.4,0.1s1.2-0.1,1.4-0.4c1.1-1.4,2.1-2.7,3.1-4.1c0.2-0.2,0.4-0.5,0.5-0.7c0.6-0.8,1.2-1.7,1.9-2.5
		c-0.4-0.1-0.5-0.2-0.7-0.2s-0.5,0-0.7,0c0,0,0,0-0.1,0c-1.2-0.1-2.3-0.1-3.5-0.2c-0.5,0-1-0.1-1.5-0.1c-2.1-0.1-4.2-0.2-6.4-0.3
		c-0.6,0-1.1-0.1-1.7-0.1c-0.1,0.4,0,0.9-0.1,1.3c-0.1,0.3-0.3,0.6-0.4,0.8c-0.5-0.1-1-0.3-1.5-0.5h-0.1c-1.3-0.5-2.4-1.1-3.5-1.8
		l0,0c-0.3,0-0.6,0-0.8,0c-0.5,0-1.1,0.3-1.4,0.7c-1.6,2.1-3.2,4.3-4.7,6.5C432.9,93,431.8,94.5,430.7,96.1z"
      />
      <path
        class="st2"
        d="M444.6,34.2c-0.1-0.2-0.3-0.6-0.4-1c-0.1,0-0.2,0-0.3,0c0,0.2-0.2,0.6-0.1,0.7c1,0.5,0.8,1.4,0.8,2.2
		c-1.5,0.7-2.9,0.1-4.4,0.4c0.8,0.3,1.6,0.5,2.3,0.7c0.1,0.8,0.2,1.6,0.3,2.4c-0.4,0.2-0.8,0.2-1.1-0.3c-0.3-0.7-0.9-1-1.9-0.8
		c-0.6,0.8,0,1.4,0.5,2.1c-0.3,0.3-0.6,0.6-1,1c0.3,0.3,0.5,0.6,0.9,1c1.2-1.1,1.4-1.2,2.6-0.7c1.7,0.6,1.7,0.6,3.5,0.2
		c0.3,0.7,0.6,1.3,0.9,2.1c0.5,0,1.2,0.1,2.1,0.2c-0.5,0.4-0.8,0.6-1.3,1c0.8,0,1.6-0.5,1.8,0.3c-0.2,0.2-0.3,0.5-0.5,0.7
		c0.1,0,0.1,0.1,0.2,0.1c0.3-0.2,0.7-0.5,1.1-0.8c0.9,0.3,1.8,0.6,2.7,0.9c0.2,0.1,0.3,0.4,0.3,0.5c-0.1,0.2-0.4,0.4-0.6,0.5
		c-0.2,0-0.4-0.1-0.7-0.2c-0.6,1.2,0.9,1.8,0.9,2.9c-0.8,0.2-1.2,1.4-2.5,1c0.5-0.6,1-1.1,1.5-1.7c-0.8-0.5-1.4-1.1-2.4-1
		c-0.1,0.5-0.2,1-0.4,1.6c0,0.1,0,0.1,0,0.2c-0.2-0.3-0.3-0.6-0.4-0.9c-0.1-0.4-0.1-0.9,0.1-1.3c0.1-0.2-0.1-0.6-0.2-1.1
		c-0.6,0.3-1.1,0.6-1.7,0.9c-0.4-0.4-0.7-0.8-1-1.1c-0.2-0.1-0.4-0.1-0.6-0.2c-0.4-0.1-0.8-0.3-1.2-0.4c0.2-0.4,0.5-0.8,0.5-1.2
		s-0.2-0.8-1-0.9c-0.2,0-0.4-0.3-0.7-0.6c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2,0.2-0.6,0.4-0.7,0.7c-0.1,0.2,0.1,0.6,0.2,0.6
		c0.5,0.1,0.6,0.3,0.6,0.6s-0.1,0.7,0.1,0.9c0.1,0.1-0.4,0.7-0.6,1.1c-0.1-0.1-0.2-0.1-0.3-0.1c-0.8-0.3-1.4,0-2,0.8
		c0.4,0.2,0.7,0.3,1.1,0.5c0.6,0.3,1.2,0.5,1.8,0.8c0,0.3,0,0.6,0.1,0.9c0.2,1.5,1.2,1.9,3.5,1.7l0.1,0.1c0.3,0.3,0.5,0.5,0.7,0.8
		c1.2,0,1-1.5,2.3-1.4c0.1,0,0.1,0,0.2,0c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.2-0.2,0.3-0.2,0.5c-0.5,1.1-0.5,2.1,1.3,2.6
		c-0.5,0.8-1,1.5-1.5,2.2c0.4,0.5,1.1,0.6,1.7,0.4c0.2,0,0.3-0.1,0.5-0.2c0.6-0.2,1.2-0.4,1.8-0.7c0.5-0.2,1-0.4,1.6-0.6
		c0.3,0.8-0.7,1.6-0.7,2.5c0,0,0,0-0.1,0c0,0,0,0,0.1,0.1v-0.1c0,0.3,0.1,0.6,0.2,0.8c0.1,0,0.2-0.1,0.3-0.1c0,0.2,0.1,0.5,0.1,0.7
		c0.1,0.1,0.3,0.2,0.4,0.2c0.1-0.1,0.1-0.2,0.2-0.2c0.4-0.3,0.8-0.5,1.2-0.7c-0.1,0.4,0,0.8-0.2,1.2c0.2,0,0.3,0,0.5,0.1
		c-0.4,0.2-0.7,0.3-0.9,0.5c-0.2,0.3-0.5,0.7-0.7,1c0,0.2-0.1,0.3-0.1,0.5c0,0.3,0,0.6,0,1c0.1,0.5-0.2,1-0.3,1.4
		c-0.5,0.1-0.9,0.2-1.5,0.3c0.2,0.4,0.4,0.7,0.6,1.1c0.1,0.1,0.1,0.2,0.2,0.3c0.3-0.5,0.6-0.8,0.8-1.2c0,0,0-0.1,0.1-0.1l0,0
		c0.9-0.1,1.9,0.5,2.8-0.3c0.1-0.4,0.2-0.9,0.3-1.4c0.1,0,0.2,0,0.3,0c0.8,0,1.6,0.1,2.6,0.1c-0.3,0.5-0.5,0.9-0.7,1.2
		c0.2-0.1,0.3-0.1,0.5-0.2l0,0c0.1-0.1,0.3-0.1,0.4-0.2c-0.1,0.2-0.2,0.4-0.3,0.4c-0.1,0.1-0.2,0.1-0.4,0c-0.1,0-0.2,0-0.2-0.1
		c-0.2,0.1-0.4,0.3-0.6,0.4c-0.3,0.3-0.5,0.6-0.6,1c-0.2,0.5-0.6,1.1-1.1,1.8c0.1,0.1,0.1,0.3,0.2,0.5s0.2,0.4,0.4,0.6
		c0.3,0.4,0.7,0.8,0.7,1.3c0.1,0.7,0.7,1.1,1.5,1c1.3-0.2,1.7,0.5,2.3,1.3c0.3-0.1,0.6-0.2,0.9-0.3c0.1,0.1,0.2,0.2,0.1,0.2
		c-0.5,0.6-0.9,1.2-0.8,2c0,0.2-0.2,0.4-0.3,0.5c-0.6-0.2-1.1-0.4-1.8-0.7c-0.3-0.4,0.4-1.3-0.4-1.8c-0.4,0.4-0.6,0.5-0.6,1
		c0,0.1,0,0.3,0,0.4c0.1,0.4,0.2,0.9,0.5,1.8c2,0,3.9-0.7,5.9-0.3c0.5,1.1,0.5,1.1-1.3,2.3c0.4,0.2,0.7,0.3,1.1,0.5
		c0.4-0.7,0.9-1.3,1.4-2l0,0c0,0,0,0,0.1,0c1.1-1.5,2.2-3,3.4-4.6l0,0c0.8-1.1,1.6-2.1,2.5-3.3c0-0.1,0.1-0.1,0.1-0.1
		c-0.5,0-0.9-0.1-1.3-0.1c-0.7-0.1-1.3-0.1-2-0.2c0-0.2,0-0.3,0-0.5h0.1c0.2,0,0.5,0,0.7,0c0.4,0,0.8,0,1.2,0c0.2,0,0.3,0,0.5,0
		c0.9,0.1,1.4-0.2,2-0.9c0.4-0.6,0.8-1.1,1.2-1.7c0.6-0.8,1.1-1.6,1.7-2.3c-0.3,0.1-0.7,0.1-1.1,0.2c0.5-0.5,0.8-0.7,1-0.9
		c-0.3-0.1-0.6-0.2-1.2-0.3c0.7-0.2,1-0.3,1.3-0.5c0.1-0.1,0.3-0.1,0.4-0.2c0.7-0.3,1.3-0.7,1.4-1.5c0.1-0.4,0.4-0.7,0.8-1.2
		c0-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.1,0.1-0.2,0.1c-1,0.4-1.7,0.7-2.4,1c-0.3,0.1-0.5,0.2-0.8,0.2c-0.2,0.1-0.4,0.1-0.6,0.2
		c-0.4,0.1-0.8,0.2-1.2,0.3c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.3,0-0.6c0.1-0.3,0.2-0.7,0.2-1.1c0.1-0.5,0.2-0.9,0.7-1.3
		c-0.2-1.1,1-2.3,0-3.3c-0.1,0-0.2,0-0.4,0c-0.1-0.1-0.1-0.2-0.2-0.5c-0.9,0.6-2,1-1.9,2.2c-0.9-0.1-1.4-0.9-2.4-0.6
		c-0.3,0.1-1-0.4-1-0.7c-0.1-0.8-0.9-1-1.5-1.4c0.2-0.3,0.4-0.7,0.7-1.2c-0.6,0.1-1,0.1-1.6,0.1c0.5-0.4,0.9-0.6,1.3-1
		c0.1-0.1,0.2-0.1,0.2-0.2c-0.1,0-0.2-0.1-0.2-0.1c-0.4-0.1-0.7-0.3-0.9-0.4c-0.2-0.1-0.6-0.1-0.6-0.2c-0.1-0.8-0.8-0.9-1.5-1.1
		c-0.1,0-0.2-0.1-0.4-0.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.5,0.5-1.1,1.1-2.2,0.4c0.5-0.6,1-1.3,1.6-2c-0.1-0.2-0.2-0.6-0.3-0.9
		c-0.1-0.7-0.3-1.2-1.5-1.1c-0.4,0.1-0.9-0.3-1.4-0.6c0.2-0.6,0.4-1.1,0.6-1.5c-0.7-0.5-1,0.3-1.5,0.4l0,0c0,0.1,0,0.3,0,0.4
		c-0.1-0.1-0.2-0.2-0.3-0.3l0,0c-0.5-0.3-0.9-0.6-1.4-0.9c-0.2,0.1-0.4,0.1-0.6,0.2c-0.5,0.1-0.9,0.3-1.5,0.4c0-0.8,0-1.5-0.1-2.2
		c-0.2-0.9-1.1-0.9-2-0.9c0.6-0.8,0.7-1.6,0.5-2.4c-0.7-0.6-1.3-0.1-2,0c-0.2-0.2-0.4-0.5-0.6-0.7c-1.5,0.3-2.4-0.1-3.2-1.2
		c-0.5-0.7-1.5-1.1-2.4-1.6c-0.1,0.5-0.2,1-0.3,1.5C446.2,35,445.5,34.6,444.6,34.2z M475.8,53c0.1-0.1,0.2-0.1,0.3-0.1
		c0,0.1,0.1,0.2,0.1,0.2c-0.1,0.1-0.2,0.2-0.3,0.3l-0.3-0.1C475.6,53.2,475.7,53.1,475.8,53z M457.6,62L457.6,62h0.1H457.6z
M457.8,59.5c0.1,0,0.1,0.1,0.2,0.1c-0.1,0.1-0.1,0.2-0.2,0.2C457.8,59.8,457.8,59.7,457.8,59.5z"
      />
      <path
        class="st2"
        d="M351.8,93.1c-0.8,0.2-1.4,0.6-1.9,1c2.4,0,4.7,0,7.1,0c-0.3-0.4-0.7-0.7-1.2-1
		C354.6,92.3,353.1,92.7,351.8,93.1z"
      />
      <path
        class="st2"
        d="M510.3,53.6c-0.1,0-0.1,0.1-0.2,0.1c-0.1-0.1-0.2-0.2-0.4-0.3c-0.3-0.2-0.6-0.5-0.9-0.6
		c-0.2-0.1-2.2,0.5-2.3,0.6c-0.4,0.6-0.1,1.3,0.8,1.9l0,0c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.2,0.3-0.4,0.4-0.6c0.1-0.1,0.1-0.2,0.2-0.4
		c0,0,0,0,0-0.1c0,0,0,0,0.1,0c0.2,0.1,0.5,0.1,0.6,0.2c-0.3,0.9-0.5,1.7-0.8,2.7c-0.2,0.1-0.4,0.1-0.6,0.2
		c-0.8,0.3-1.5,0.6-1.8,1.5c-1-0.1-2-0.1-3-0.6s-2-0.1-2.5,0.9c-0.2,0.4-0.3,0.9-0.5,1.3c-0.3,0.5-0.7,1-1.1,1.6
		c-0.4-1.6-0.4-1.8,1.2-6c-0.4,0.3-0.8,0.4-0.9,0.6c-0.2,0.5-0.2,1-0.4,1.5c-0.2,0.5-0.6,1-0.9,1.7c-0.3-0.5-0.5-0.8-0.8-1.2
		c-0.6,1.5-0.7,2.8,0,4c-0.2,0.2-0.4,0.5-0.7,0.6c-0.4,0.3-0.8,0.5-1.2,0.6c-0.8,0.2-1.3-0.1-1.8-1.1c-0.2-0.4-0.4-0.7-0.6-1.1
		c-0.1-0.2-0.2-0.5-0.4-0.7c0,0,0.2-0.1,0.4-0.3l0,0c0.4-0.4,0.5-0.7,0-1s-1-0.1-1.3,0.5c-0.7,1.2-1.7,1.6-3.4,1.1
		c0.5-0.3,1.4,0.1,1.5-0.7c0-0.3,0-0.5,0-0.8c-0.1-0.3-0.2-0.7-0.3-1c-0.2-0.4-0.8-0.5-1.2-0.1c0,0,0,0-0.1,0.1
		c-0.3,0.3-0.6,0.6-0.8,0.9c-0.3-0.2-0.6-0.4-1.1-0.8c-0.3,0.8-0.5,1.4-0.2,2c0.4,0.7,0.7,1.4-0.6,1.9c-0.1,0.9-0.7,1.4-1.4,1.9
		c-0.6,0.4-1.2,0.7-1.6,1.2c-0.2-0.1-0.5-0.2-0.8-0.3c0.3-0.3,0.5-0.6,0.8-0.8c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.1
		c0.1-0.5,0.1-1,0.2-1.5c-0.8,1.1-1.7,2.2-2.5,3.4c-0.1,0.2-0.2,0.4-0.5,0.8c0.4,0,0.9,0,1.3,0.1c1.1,0,2.2,0.1,3.3,0.1
		c1.1,0,2.1,0.1,3.2,0.1c0.5,0,0.9,0,1.4,0.1c1.5,0.1,3,0.1,4.5,0.2c0,0.2,0,0.3,0,0.5c-0.5,0-1,0.1-1.4,0.1c-0.7,0-1.5-0.1-2.2-0.1
		c-0.1,0-0.2,0-0.3,0c-0.2,0-0.4,0-0.6,0c-0.3,0-0.7,0-1,0c-1.2,0-2.4-0.1-3.6-0.2c-1,0-1.9-0.1-2.9-0.1c-0.3,0-0.6,0-0.9,0
		c-1-0.1-1.6,0.2-2.2,1c-0.1,0.1-0.1,0.2-0.2,0.3c-0.9,1.2-1.8,2.5-2.7,3.7c0,0,0,0,0,0.1c-0.9,1.2-1.7,2.3-2.6,3.5
		c-0.4,0.5-0.7,1-1.1,1.5c-0.5,0.7-1,1.3-1.5,2c-0.3,0.4-0.6,0.8-0.9,1.3c0.5,0.1,0.8,0.2,1.1,0.2c2.1,0.1,4.2,0.2,6.2,0.3
		c1.7,0.1,3.4,0.2,5.2,0.3c1.8,0.1,3.6,0.2,5.4,0.3c0.9,0,1.8,0.1,2.7,0.1c0.3,0,0.5,0,0.8,0c0.2,0,0.3,0,0.5,0
		c0.4-0.1,0.7-0.2,0.9-0.4c0.8-1.2,1.7-2.3,2.5-3.5c0.2-0.3,0.5-0.7,0.7-1c1.1-1.5,2.2-3.1,3.3-4.7c0,0,0-0.1,0.1-0.1
		c0.9-1.2,1.7-2.4,2.6-3.6c0.1-0.1,0.1-0.2,0.2-0.3c0,0,0,0,0-0.1h-0.1c-0.1,0-0.1,0-0.1,0c-1.5-0.1-2.7-0.2-3.9-0.3
		c0-0.2,0-0.4,0-0.6c1.1,0.1,2.1,0,3.2,0.2c1,0.1,1.7-0.2,2.3-1.1c1.2-1.8,2.5-3.6,3.8-5.3c0.2-0.3,0.5-0.7,0.7-1s0.6-0.5,1-0.7
		c0.2-0.1,0.4-0.2,0.6-0.3c-0.1,0.2-0.1,0.4-0.2,0.7c-0.1,0.4-0.2,0.8-0.4,1.1c-0.7,1.1-1.5,2.2-2.3,3.3c-0.6,0.8-1.2,1.7-1.8,2.5
		c-0.2,0.3-0.3,0.5-0.5,0.8c0.1,0.1,0.2,0.2,0.3,0.2c0.3-0.4,0.7-0.7,0.9-1.1c0.6-0.8,1.1-1.5,1.7-2.3c1-1.4,2-2.8,3-4.1
		c0.1-0.1,0.2-0.2,0.4-0.3c0.3-0.2,0.7-0.3,1-0.4c-0.1,0.4-0.1,0.8-0.2,1.1c0,0.1-0.1,0.2-0.1,0.3c-0.9,1.3-1.8,2.5-2.7,3.8
		c-0.7,0.9-1.4,1.9-2.1,2.9c0.4,0.1,0.7,0.1,1,0.2c0,0,0,0,0.1,0s0.2,0,0.2,0c1.1,0,2.2,0.1,3.3,0.1c0.2,0,0.5,0,0.7,0
		c1,0,1.9,0.1,2.9,0.1l0,0c1.3,0.1,2.6,0.1,3.9,0.2c1.5,0.1,3.1,0.1,4.6,0.2c0.4,0,0.8,0,1.2,0c1.1,0,2.3,0.1,3.4,0.1
		c0-0.1,0.1-0.1,0.2-0.2c-0.5-0.1-1-0.1-1.6-0.2c0.1-0.4,0.2-0.8,0.3-1.2c0.3-1,0.5-2,1.2-2.9c0,0,0.1,0,0.1,0.1
		c1.3,0.6,2.5,1.1,4,0.4c0.7-0.3,1.4-0.8,1.8-1.3l0.1-0.1c0.4-0.6,0.6-1.2,0.4-1.8c-0.2-0.7-0.8-1.4-1.8-2.1
		c-0.1-0.1-0.2-0.1-0.3-0.2c0.1-0.1,0.2-0.2,0.4-0.2c0.4-0.2,0.8-0.5,1.2-0.8c0.6,1.4,1.7,2.4,3.4,2.5c0.2,0,0.4,0,0.6,0
		c2-0.1,3.3-1.1,4.3-2.6c0.2,0.1,0.4,0.2,0.6,0.3l0,0c1,0.1,1.9,0.1,2.9,0.1c0.7,0,1.2,0,1.7,0.2c0.1-0.5,0.2-0.9,0.4-1.4
		c0.2-0.6-0.2-0.9-0.8-1.2c-1.2-0.6-2.3,0.1-3.5,0.3c-0.2,0.3-0.4,0.7-0.5,1c-0.7-0.9-1.3-1.9-2.1-2.6c-0.4-0.3-0.9-0.5-1.4-0.7
		c-0.4-0.1-0.8-0.2-1.1-0.4c0.2-0.4,0.4-0.9,0.6-1.4c0-0.1,0.1-0.1,0.1-0.2c0.2-0.4,0.4-0.8,0.5-1.2c0.4-0.1,0.9-0.2,1.5-0.3l0,0
		c0.1,0,0.2-0.1,0.3-0.1c1-0.3,1.9-0.9,2.5-1.6c0.4-0.5,0.7-1,0.8-1.7l0,0c0-0.2,0.1-0.3,0.1-0.5c0-0.1,0-0.3,0-0.4
		c0-1-0.5-1.8-1.3-2.5l0,0c-0.3-0.3-0.7-0.5-1.1-0.6c-0.2-0.1-0.3-0.1-0.5-0.2c-1.9-0.6-4.2,0.1-5.5,1.5c-0.3,0.3-0.5,0.6-0.7,0.9
		c-0.5,0.7-1.2,1.2-2.1,1.4c0,0.1,0.1,0.1,0.1,0.2c0.2,0.2,0.3,0.3,0.4,0.4c0.2,0,0.4-0.2,0.9-0.5c0.1,0.4,0.2,0.8,0.4,1.3
		c-0.2,0-0.4,0-0.6,0c-0.4,0-0.7,0-1,0c-1.1,0-2,0.2-2.8,0.5c-0.8,0.4-1.4,0.9-1.8,1.6l-0.1,0.1c-0.3,0.7-0.5,1.5-0.3,2.4
		c0,0.2,0.2,0.4,0.2,0.6c0,0.4-0.6,0.7-0.9,0.5c-0.5-0.3-1-0.7-1.4-1c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1-0.1-0.3-0.2-0.4-0.3l-0.1-0.1
		c0,0,0-0.1,0.1-0.1c0.4-0.5,0.8-1,1-1.4c0.1-0.1-0.2-0.3-0.3-0.6c-0.6,0.3-1.1,0.8-1.6,1c-0.3,0.1-0.7,0.1-1.1,0v-0.1
		c0-1.3-0.5-2.4-2.1-2.9s-2.9,0.2-4,1.1c-0.2,0.2-0.4,0.3-0.6,0.5c0,0.4-0.1,0.9-0.1,1.4c-0.3-0.1-0.5-0.1-0.8-0.2
		c-0.1,0.1-0.2,0.2-0.3,0.3c-0.5,0.5-0.9,1-1.4,1.5c-0.2-0.1-0.4-0.1-0.5-0.2c-0.2-0.1-0.4-0.1-0.5-0.2
		C511.3,53.1,510.8,53.3,510.3,53.6z M541.2,57.6c0,0.1,0,0.1,0,0.2c-0.1,0-0.1-0.1-0.2-0.1C541.1,57.7,541.1,57.6,541.2,57.6z"
      />
      <path
        class="st2"
        d="M445.6,75.3c-0.1,0.2-0.2,0.3-0.3,0.5c-0.4,0.5-0.7,1-1.1,1.5c0.4,0.8,0.8,1.5,1.6,2.1c0.5,0.4,0.7,1,1,1.5
		c0.1,0.1,0.1,0.2,0.2,0.3c0.2,0.3,0.3,0.6-0.2,0.9c-0.1,0.1-0.1,0.3,0,0.4c0.3,0.4,0.2,0.9,0.1,1.3c0.7,0,1.4,0.1,2.2,0.1
		c1.7,0.1,3.5,0.2,5.2,0.3c0.2,0,0.4,0,0.6,0c2,0.1,4,0.2,6,0.3c0.5,0,1.1-0.3,1.5-0.7c0.6-0.6,1-1.4,1.7-2.3
		c-2.2-0.2-4.2-0.3-6.2-0.4c0-0.1,0-0.3,0-0.4c1,0,2.1-0.2,3.1,0c0.6,0.1,1.2,0.2,1.7,0.2c0.3-0.3,0.4-0.4,0.6-0.5
		c0.3-0.1,0.7-0.1,0.9-0.3c0.3-0.3,0.6-0.7,0.6-1s-0.4-0.7-0.7-0.7c-0.4,0-1,0.2-1.3,0.5s-0.4,0.7-0.6,1.2c-1.3-1.3-1.3-1.3-2.9-0.6
		c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.4c0-0.2,0-0.4-0.1-0.7c-0.2,0-0.4,0-0.4,0.1c-0.3,0.6-0.9,0.8-1.7,1c-0.1-0.4-0.2-0.7-0.3-1.1
		c-0.1-0.5-0.3-1-0.4-1.5c0.7-0.5,1.1-1,0.8-1.8c-0.1-0.2-0.1-0.5-0.1-0.8s0-0.6,0.1-0.9c0.1-0.5-1-0.9-0.2-1.5
		c0.1-0.1-0.3-0.7-0.6-1.2h-0.1c-0.4-0.1-1,0.8-1.5,0.2c-0.4-0.4-0.8-0.8-1.3-1.4c-0.2,0.5-0.4,0.9-0.7,1.3
		c-0.4-0.3-0.8-0.5-1.2-0.7c-0.3-0.2-0.7-0.3-1.3-0.6c0.1,0.6,0.2,0.9,0.3,1.2c0,0,0,0,0,0.1c-0.6,0.3-1.2,0.5-1.9,0.8
		C447.5,72.7,446.6,74,445.6,75.3z"
      />
      <path
        class="st2"
        d="M612,20.2c-1.4,0.3-2.6,1.4-3.6,3c-0.3-0.3-0.6-0.6-0.9-0.9c-0.3,0.3-0.5,0.5-0.7,0.6
		c-0.3,0.4-0.1,0.6,0.7,1.2c0.2-0.1,0.4-0.2,0.7-0.4l0,0c0.1,0.3,0.1,0.6,0.2,1.1c-0.4,0.1-0.7,0.1-1,0.1c-2.2,0-4.4,2.1-3.9,4.2
		c0.1,0.3,0.2,0.6,0.4,0.8c0.6,0.9,1.5,1.4,2.7,1.5c0.2,0,0.5,0,0.7,0c0.1,0,0.3,0,0.4,0c0.1,0,0.1,0,0.2,0v0.1c0,0.5-0.1,1-0.1,1.5
		c0,0.1,0,0.2,0,0.3c-0.4,0-0.7,0.1-1.1,0.1c-0.2,0-0.4,0-0.5,0c-0.5,0.1-0.9,0.2-1.3,0.4c-2,0.9-2.9,3-2,4.5
		c0.1,0.2,0.2,0.4,0.3,0.6c-0.4-0.1-0.7-0.2-1.1-0.3c-1.5-0.4-3.1,0.3-3.8,1.4c-0.1,0.2-0.2,0.3-0.2,0.5c-0.4,1.1,0.1,2.2,1.2,2.7
		c1.3,0.6,2.9,0.2,4-0.8l0.1-0.1c0.9-0.9,0.5-1.8,0.3-2.7c1.3,0.3,2.6,0.7,4.4,0.2c-0.6,1.4-0.3,2.5,0.3,3.5
		c0.3,0.1,0.6,0.2,0.9,0.3c0.9,0.4,1.9,0.5,2.9,0.3v-4v-3.2v-4.3v-1v-1.7v-6.5V22v-1.4L612,20.2C612.1,20.1,612,20.1,612,20.2z"
      />
      <path
        class="st2"
        d="M511.9,102.5c-3.2-0.2-6.4-0.4-9.6-0.6c-0.1,0-0.3,0-0.4,0c-0.9-0.1-1.8-0.1-2.8-0.2c-1.3-0.1-2.6-0.2-3.9-0.2
		c-3-0.2-5.9-0.4-8.9-0.6c-0.9-0.1-1.7-0.1-2.6-0.2c-0.5,0-0.9-0.1-1.4-0.1c-2.7-0.2-5.4-0.3-8-0.5c-0.2,0-0.5,0-0.7,0
		c0,0.1,0,0.1,0,0.2s0,0.1,0,0.2c1.5,0.1,3,0.2,4.5,0.3c0.9,0.1,1.8,0.1,2.7,0.2c0.4,0,0.7,0,1.1,0.1c0.6,0,1.2,0.1,1.8,0.1
		c1,0.1,1.9,0.1,2.9,0.2c2.8,0.2,5.5,0.3,8.3,0.5c1.3,0.1,2.7,0.2,4,0.2c1,0.1,2,0.1,3.1,0.2c0.1,0,0.2,0,0.3,0
		c3.2,0.2,6.4,0.4,9.6,0.6C511.8,102.7,511.9,102.6,511.9,102.5z"
      />
      <path
        class="st2"
        d="M470.5,97.8c0-1,0-1.9,0-3c-0.1,0-0.2,0-0.4,0c-2.8-0.2-5.5-0.3-8.3-0.5c0,1.3,0,2.4,0,3.7
		c2.9,0.2,5.7,0.4,8.7,0.6C470.5,98.4,470.5,98.1,470.5,97.8z"
      />
      <path
        class="st2"
        d="M404.7,169.6c-2.3-1.2-3.5-1.6-4.2-1.3c-0.3,0.1-0.5,0.4-0.7,0.9c0.1,0,0.3-0.1,0.4-0.1
		C401.8,169.1,402.9,171.2,404.7,169.6z"
      />
      <path
        class="st2"
        d="M450.4,198.6c-0.1-0.3-0.3-0.5-0.5-0.7c-1.5,1.4-3,2.7-4.6,4.1l-0.1,0.1c0.1,0,0.1,0,0.2,0
		c0.2,0,0.4,0.1,0.6,0.2c1.3,0.4,2.5,0.2,3.6-0.7C450.6,200.8,450.9,199.6,450.4,198.6z"
      />
      <path
        class="st2"
        d="M440.9,205.9c-0.6,0.5-1.1,1-1.7,1.5c1.2,0.8,1.8,0.9,2.4,0.3C442.2,207.1,442,206.7,440.9,205.9z"
      />
      <path
        class="st2"
        d="M409.3,163.4c0,0.2,0,0.4,0,0.6c1.1-0.2,2.1,1.6,3.6-0.3C411.5,163.6,410.4,163.5,409.3,163.4z"
      />
      <path
        class="st2"
        d="M437.2,209.2c0.6-0.2,1.3-0.4,1.9-0.7c-0.3,0-0.7,0-1-0.1C437.8,208.6,437.5,208.9,437.2,209.2z"
      />
      <path
        class="st2"
        d="M325.6,207.5c0,0.4,0.5,0.9,0.8,1c1.5,0.5,2.3-0.8,3.2-1.3c-0.8-0.8-1.5-1.5-2.3-2.3
		C326.4,205.3,325.5,206.2,325.6,207.5z"
      />
      <path
        class="st2"
        d="M455.8,192.7c-1.8,1.6-3.6,3.2-5.4,4.8c0.3,0,0.6,0,0.8-0.2c0.2-0.1,0.4-0.4,0.6-0.7c0.3,0.1,0.7,0.2,1,0.4
		c1.2,0.6,2.3,0.5,3.4-0.2c1-0.7,1.4-1.6,1.1-2.5C457.2,193.5,456.6,192.9,455.8,192.7z"
      />
      <path
        class="st2"
        d="M458.8,95.4c0-0.4,0-0.8,0-1.2c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0.1-0.1,0.2-0.2,0.3
		c-0.8,1.1-1.7,2.2-2.7,3.5c1.1,0.1,1.9,0.1,2.8,0.1c0.2,0,0.4,0,0.6,0C458.8,97,458.8,96.2,458.8,95.4z"
      />
      <path
        class="st2"
        d="M496.7,139.4c0.3-0.2,0.6-0.5,0.9-0.8s0.6-0.5,0.9-0.8c-4.5-0.6-9-1.2-13.4-1.8c-0.2,0-0.5-0.1-0.7-0.1
		c-5.3-0.7-10.5-1.4-15.7-2.1c0,0.1-0.1,0.2-0.1,0.3c0.7,0.6,1.3,1.2,1.9,1.8c0.9-0.3,1.7-0.5,2.4-0.8c0.1,0.2,0.1,0.3,0.2,0.5
		c-0.9,0.6-1.8,1.3-2.7,1.9c-0.7-0.8-1.2-1.6-2-2c-0.4-0.2-0.9-0.1-1.4,0c-0.2,0-0.3,0.1-0.5,0.1c-0.4,0-0.8,0.2-1.1,0.3l0,0
		c0-0.5,0-1,0.2-1.4l0.1-0.1c0.2-0.2,0.5-0.4,0.9-0.6c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.1,0-0.2,0c-0.4-0.1-0.8-0.1-1.1-0.2
		c-22.7-3.1-45.3-6.2-67.9-9.3c-0.7-0.1-1.5-0.2-2.2-0.3c-2.8-0.4-5.5-0.7-8.3-1.1c-0.1,0-0.2,0-0.2,0c0.1,0.2,0.1,0.3,0.2,0.4
		c0.1,0.4,0.2,0.6,0.3,0.7c-0.1,0-0.1,0-0.2-0.1c-1.6-0.6-3.2-1.1-4.8-1.6c-1.1-0.3-2.2-0.5-3.3-0.7c-1.2-0.2-2.5-0.3-3.8-0.4
		c-1.7-0.1-3.3-0.1-5,0.1c-0.4,0-0.8,0.1-1.1,0.1c-0.9,0.1-1.8,0.3-2.7,0.4c0.2,0.1,0.5,0.2,0.7,0.4l0,0c0,0.1,0,0.1,0,0.2
		c-0.1,0-0.2,0-0.3,0c-1,0-2-0.1-2.9-0.1c0,0.2,0,0.3,0,0.5c0.9,0.1,1.8,0.2,2.7,0.3c0.9,0.1,1.7,0.2,2.6,0.3c0.3,0,0.7,0.1,1,0.2
		c0.9,0.1,1.7,0.3,2.6,0.4c1.9,0.3,3.9,0.6,5.8,0.9c0.1,0,0.1,0,0.2,0c0.7,0.1,1.4,0.2,2.1,0.3c0.1,0,0.2,0,0.3,0.1
		c1.5,0.2,3,0.5,4.5,0.7c1,0.1,2,0.3,3,0.4c0.3,0,0.6,0.1,1,0.1c0.3,0,0.6,0.1,1,0.1c0.5,0,1,0.1,1.4,0.1c0.1,0,0.1,0,0.2,0
		c0.3,0,0.6,0.1,0.9,0.1c1,0.1,1.9,0.2,2.9,0.3c0.7,0.1,1.4,0.1,2.1,0.2c1.3,0.2,2.6,0.7,4,0.9c3.6,0.6,7.2,1.2,10.9,1.6
		c8.2,0.9,16.2,3.3,24.5,2.8l0,0l0,0l0,0c0,0,0,0,0.1,0c0.2-0.2,0.4-0.6,0.6-0.5c2,0.3,4.1,0.7,6.1,1c0,0.1,0,0.3-0.1,0.4
		c-2.2-0.3-4.4-0.6-6.6-0.9l0,0c2.4,0.6,4.8,1.3,7.2,1.8c1.4,0.3,2.9,0.5,4.4,0.7c3.5,0.5,6.9,1,10.4,1.5c0.8,0.1,1.6,0.2,2.3,0.4
		c9.3,1.4,18.5,2.9,27.9,3.7c-0.2,0.1-0.4,0.1-0.4,0.1c0.7,0.3,1.3,0.5,1.9,0.6c0.1,0,0.3,0,0.4,0.1
		C493.2,141.6,495,140.8,496.7,139.4z M400.7,127.2c-1.6-0.3-3.2-0.5-4.8-0.8h-0.1c0-0.1,0-0.1,0-0.2c0,0,0,0,0-0.1s0-0.2,0.1-0.3
		c0.5,0.1,1,0.2,1.4,0.3c1.1,0.3,2.2,0.5,3.3,0.8C400.7,127,400.7,127.1,400.7,127.2z M445.5,132.5c-2.3-0.3-4.6-0.7-6.8-1
		c0-0.1,0-0.3,0.1-0.4c2.3,0.3,4.6,0.6,6.9,1C445.6,132.2,445.6,132.3,445.5,132.5z M447.4,131.8c-2.3-0.3-4.7-0.6-7-0.9
		c0-0.1,0-0.3,0-0.4c2.3,0.3,4.7,0.6,7,0.9C447.4,131.5,447.4,131.6,447.4,131.8z"
      />
      <path
        class="st2"
        d="M502.9,96.8c-1.2-0.1-2.4-0.1-3.6-0.2c-3.4-0.2-6.8-0.4-10.1-0.6c-0.3,0-0.5,0-0.8,0c-1-0.1-2.1-0.1-3.1-0.2
		h-0.1c-0.3,0-0.7,0.1-0.9,0.4c-0.1,0.1-0.1,0.2-0.2,0.3c-0.3,0.4-0.7,0.9-1,1.3c-0.3,0.5-0.7,0.9-1,1.4c0.4,0.1,0.6,0.2,0.9,0.2
		c0.1,0,0.2,0,0.3,0c6.3,0.4,12.5,0.8,18.8,1.2c0.1,0,0.2,0,0.4,0c2.8,0.2,5.6,0.4,8.4,0.5c0.3,0,0.8-0.1,1-0.3c0.8-1,1.6-2,2.6-3.3
		C510.5,97.2,506.7,97,502.9,96.8z"
      />
      <path
        class="st2"
        d="M410.7,171.3c0-0.1-0.1-0.2-0.1-0.3c-1.6-0.3-3.1-0.5-4.7-0.8c0,0.1,0,0.2-0.1,0.4c0.7,0.7,1.5,1.3,2.3,2.1
		C409,172.3,409.8,171.8,410.7,171.3z"
      />
      <path
        class="st2"
        d="M410.8,124.5c1.8,0.3,3.6,0.6,5.4,0.9c9,1.2,18,2.4,27.1,3.6c1.2,0.2,2.3-0.1,3.1-1.4
		c-6.5-0.8-12.9-1.7-19.3-2.5c-1.5-0.2-3.1-0.4-4.6-0.6c-3.4-0.4-6.9-0.9-10.3-1.3c0,0.1,0,0.2,0,0.3c0.2,0.1,0.5,0.1,0.7,0.2
		c0,0.1,0,0.1,0,0.2c-0.7,0.1-1.3,0.2-2,0.3C410.8,124.3,410.8,124.4,410.8,124.5z"
      />
      <path
        class="st2"
        d="M417.1,206.4c-0.3,0.2-0.6,0.4-0.8,0.6c-0.2,0.3-0.4,0.6-0.4,0.8c1.2-0.9,2.3-1.8,3.5-2.8
		c0.4-0.3,0.8-0.6,1.1-0.9c6.5-5.1,12.9-10.2,19.4-15.3c0.4-0.3,0.9-0.7,1.3-1s0.8-0.6,1.2-1c-0.1-0.1-0.2-0.2-0.3-0.3
		c0-0.1,0-0.1-0.1-0.2c-0.1-0.4-0.1-0.9-0.2-1.4c-0.8,0.6-1.5,1.2-2.3,1.8c-3.2,2.5-6.5,4.9-9.7,7.4c-0.1,0.1-0.2,0.2-0.3,0.3
		c-3.2,2.4-6.3,4.8-9.5,7.2c-0.5,0.4-1,0.7-1.4,1.1c-1,0.7-1.9,1.5-2.9,2.2c-0.3,0.2-0.6,0.5-1,0.7c-1.2,0.9-2.5,1.9-3.7,2.8
		c0.2-0.1,0.4-0.2,0.6-0.4c0.2,0.1,0.3,0.1,0.5,0.2c0.2,0.1,0.4,0.2,0.7,0.3c0.1,0,0.2,0.1,0.3,0.1c0.1-0.3,0.1-0.6,0.2-1
		c0.6,0.1,1.2,0.1,2,0.2c-0.2-0.4-0.3-0.6-0.5-0.9c0-0.1,0.1-0.2,0.1-0.2c0.4-0.4,0.9-0.8,1.2-1.2c0.4-0.4,0.9-0.5,1.3-0.2
		C417.8,205.8,417.6,206.1,417.1,206.4z"
      />
      <path
        class="st2"
        d="M498.2,144.5c-7.3,5.8-14.7,11.6-22,17.4c-0.7,0.6-1.5,1.2-2.2,1.8c-1.1,0.9-2.2,1.7-3.2,2.6
		c-0.2,0.2-0.5,0.4-0.7,0.6c-0.2,0.1-0.3,0.3-0.5,0.4c-0.4,0.3-0.8,0.6-1.2,1c-0.7,0.6-1.5,1.2-2.2,1.8c-0.5,0.4-1,0.8-1.5,1.2
		c-0.1,0.1-0.2,0.2-0.3,0.2l-0.1,0.1c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.1-0.1,0.1-0.2,0.2c-0.4,0.3-0.8,0.6-1.2,0.9
		c-0.8,0.6-1.5,1.2-2.3,1.8c-0.4,0.3-0.7,0.6-1.1,0.8c-0.5,0.4-1,0.8-1.5,1.2c-0.2,0.2-0.4,0.3-0.6,0.5c-0.9,0.7-1.8,1.5-2.8,2.2
		c-1.4,1.1-2.9,2.3-4.3,3.4c-0.7,0.6-1.4,1.1-2.1,1.7c0,0,0.1,0,0.1,0.1c0.6,0.3,1.1,0.7,1.3,1.4c-0.5,0.2-1,0.3-1.4,0.5
		c-0.5,0.2-0.8,0.6-0.4,1c0.3,0.4,0.2,0.6-0.1,1c-0.5,0.7-0.6,1.3-0.3,1.9c2.9-2.4,5.8-4.8,8.7-7.2c2.1-1.8,4.3-3.5,6.4-5.3
		c0.2-0.2,0.4-0.4,0.6-0.5c0.5-0.5,1.1-0.9,1.6-1.4c0.1-0.1,0.3-0.2,0.4-0.3c0.1,0,0.1-0.1,0.2-0.1c0.5-0.4,0.9-0.8,1.4-1.2
		c0.7-0.6,1.4-1.1,2-1.7c0.3-0.3,0.6-0.5,0.9-0.8c0.6-0.5,1.2-0.9,1.7-1.4c2.2-1.8,4.5-3.7,6.7-5.5c5-4.1,9.9-8.1,14.9-12.2
		c3.2-2.6,6.3-5.3,9.4-8C500.7,144.2,499.5,143.5,498.2,144.5z"
      />
      <path
        class="st2"
        d="M357.6,163.6c0.3,0.1,0.7,0.3,0.8,0.1c1.1-0.9,2.1-0.1,3.2,0.1c1.2,0.3,2.3,0.7,3.5,1.2
		c0.6,0.2,1.2,0.5,1.8,0.7c0.7,0.3,1.5,0.6,2.2,0.9c3.9,1.6,8,2.4,12.1,3.5c1.4,0.4,2.8,0.8,4.2,1.2c0.2,0.1,0.4,0.1,0.6,0.2
		c0.9,0.3,1.8,0.5,2.7,0.8c2.7,0.8,5.5,1.5,8.2,2.3c7.9,2.2,15.9,4.5,23.8,6.7c1.5,0.4,3.1,0.9,4.6,1.3c2.4,0.7,4.8,1.3,7.2,2
		c1.1,0.3,1.8,0.1,2.7-0.5c0.1-0.1,0.3-0.2,0.4-0.3c0.8-0.6,1.6-1.2,2.4-1.8c1-0.7,2-1.4,3-2.1c0.7-0.5,1.3-1,2.3-1.7
		c-1.4-0.3-2.7-0.7-4.1-1c-0.8-0.2-1.7-0.4-2.5-0.6c-1.1-0.3-2.3-0.6-3.4-0.9c-1.5-0.4-3-0.8-4.5-1.1c-4.9-1.2-9.8-2.5-14.7-3.7
		c-1-0.3-2.1-0.5-3.1-0.8c-2.2-0.6-4.5-1.1-6.7-1.7v0.1c0.5,0.3,0.9,0.5,1.4,0.8c-0.9,1.8-2.3,1.7-3.9,0.8c0.7,1.7,1.7,2.5,3.4,2.1
		c-0.8,0.7-1.7,1.4-2.6,2.2c-0.9-1.6-1.7-3.2-2.6-4.7c-0.2-0.3-0.4-0.6-0.5-1c0.3-0.4,0.6-0.8,0.9-1.3c-1-0.2-1.9-0.5-2.9-0.7
		c-1.4-0.4-2.9-0.7-4.3-1.1c-0.8-0.2-1.7-0.4-2.5-0.6c-1.3-0.3-2.6-0.6-3.9-1c-0.6-0.1-1.1-0.3-1.7-0.4c-14.5-3.6-29-7.2-43.4-10.8
		c-2.3-0.6-4.5-1.1-6.8-1.7c-1-0.3-2.1-0.5-3.1-0.8c-0.3-0.1-0.7-0.2-1-0.3c-6.8-1.7-13.6-3.4-20.4-5.1c-0.8-0.2-1.7-0.4-2.5-0.6
		c-0.2-0.1-0.4-0.1-0.6-0.2c-0.3-0.1-0.6-0.1-0.9-0.2c-0.2-0.1-0.4-0.1-0.6-0.2c0.4,1.1,0.8,2-0.2,2.6c-0.7-0.8-1.4-1.6-2.1-2.4
		c0,0,0.1-0.3,0.3-0.6c-1.6,0.2-1.5,0.4,0.4,3.2c-0.8-0.1-1.4,0-1.9-0.2c-0.6-0.3-1.1-0.8-1.7-1.2s-1.4-0.5-1.7-1
		c-0.2-0.5,0.1-1.3,0.2-2c-3.8-0.9-7.7-1.9-11.6-2.9c0,0.1,0,0.2-0.1,0.3c0.6,0.3,1.3,0.5,1.9,0.8c-1.7,0.9-3.4,0.6-5,0.1
		c-0.2,0.1-0.3,0.2-0.5,0.3c0.4,0.2,0.8,0.3,1.2,0.5c0,0.1-0.1,0.3-0.1,0.4c-0.7-0.2-1.5-0.4-2.2-0.5c-0.5,0-1,0-1.6,0
		c0.8,0.7,1.7,1.5,2.6,1.7c4,1.3,8,2.3,12,3.4c0.5,0.1,1.2,0,1.6-0.3c1.2-0.7,1.6-0.7,2.1,0.5c-0.6,0.1-1.1,0.1-1.7,0.1
		c0,0.1,0,0.2,0,0.3c2.9,0.8,5.9,1.6,8.8,2.5c0.3,0.1,0.5,0.2,0.8,0.2c0.3,0.1,0.6,0.2,1,0.3c3.3,0.9,6.6,1.8,9.9,2.8c0,0,0,0,0.1,0
		c0-0.1,0.1-0.2,0.1-0.3c-0.1,0-0.1-0.1-0.2-0.1c-1.7-0.6-3.4-1.3-5.3-2c0.6-0.2,1.1-0.4,1.5-0.6c0.6-0.2,1.1-0.4,1.6-0.6
		c0.3-0.1,0.6-0.2,0.9-0.4c0.6-0.3,1.3-0.5,1.9-0.4c2.3,0.4,4.6,1.2,6.9,1.9c0,0.1,0,0.3,0,0.4c-1.1,0.3-2.2,0.6-3.5,1
		c-0.4,0.1-0.8,0.2-1.3,0.4c-0.1,0.1-0.5,0.5-1,1c0.2,0.1,0.5,0.1,0.7,0.2C332.7,156.6,345.1,160.1,357.6,163.6z M434.7,183.8
		c-0.6,0.2-1.2,0.6-1.5,0.5c-2.5-0.7-4.9-1.4-7.4-2.1c-1.1-0.3-2.2-0.6-3.3-1c-0.1,0-0.1-0.1-0.3-0.4c0.5-0.1,0.9-0.4,1.3-0.3
		c0.9,0.2,1.8,0.5,2.7,0.7c2.6,0.7,5.2,1.4,7.8,2.1c0.1,0,0.2,0,0.3,0.1c0.1,0,0.1,0.1,0.3,0.4C434.6,183.6,434.6,183.7,434.7,183.8
		z M429.6,176.3c1.1,0.3,2.2,0.5,3.2,0.8c2.5,0.6,5,1.2,7.4,1.9c0.1,0,0.1,0.1,0.3,0.5c-0.6,0.2-1.2,0.5-1.7,0.4
		c-1.4-0.3-2.8-0.7-4.2-1c-0.3-0.1-0.6-0.1-0.9-0.2c-0.7-0.2-1.4-0.4-2-0.5c-1-0.3-2-0.5-3.1-0.8c-0.1,0-0.2-0.2-0.5-0.5
		C428.7,176.6,429.2,176.2,429.6,176.3z M427.3,177.8c2.1,0.5,4.2,1,6.2,1.6c1.2,0.3,2.3,0.6,3.5,0.9c0.4,0.1,0.8,0.2,1.1,0.3
		c0,0.2,0.1,0.3,0.1,0.5c-0.1,0.1-0.3,0.1-0.4,0.2c-0.3,0.2-0.6,0.3-0.8,0.3c-1.1-0.3-2.2-0.6-3.3-0.9c-2.5-0.7-5-1.4-7.5-2.1
		c0-0.1,0-0.3,0-0.4C426.6,178,427,177.7,427.3,177.8z M425.6,179c2.7,0.7,5.4,1.4,8.2,2.2c0.9,0.2,1.8,0.5,2.7,0.7
		c0,0.2,0,0.4,0,0.6c-0.5,0.1-1,0.4-1.4,0.3c-0.5-0.1-1-0.3-1.6-0.4c-2.5-0.7-5-1.4-7.5-2.1c-0.4-0.1-0.8-0.2-1.2-0.3
		c-0.1,0-0.2-0.2-0.5-0.5c0.3-0.1,0.5-0.2,0.8-0.3C425.3,179,425.4,178.9,425.6,179z M407.1,169.9c1.3,0.4,2.7,0.5,4.1,0.8
		c0.2,0,0.5,0.1,0.7,0.1c0,0.1,0.1,0.2,0.1,0.3l0,0c-1.5,0.8-2.9,1.6-4.1,2.3c-1.1-1-2-1.8-2.9-2.7
		C405.5,169.9,406.1,169.6,407.1,169.9z M397,172.7c-0.4,0.1-0.7,0.3-1.1,0.4c-0.1-0.1-0.2-0.2-0.2-0.3c0.2-0.4,0.4-0.8,0.7-1.3
		c0.2-0.3,0.4-0.7,0.6-1.1c0.8,0.5,1.4,0.9,2.3,1.5C398.4,172.2,397.6,172.5,397,172.7z M366,160.6c2.9,0.7,5.7,1.4,8.6,2
		c0,0.2-0.1,0.4-0.1,0.6c-2.9-0.7-5.7-1.4-8.6-2.1C365.9,160.9,366,160.7,366,160.6z M363.5,161.6c3,0.6,5.9,1.5,8.9,2.2
		c0,0.2-0.1,0.4-0.1,0.6c-2.9-0.8-5.9-1.5-8.8-2.3C363.5,161.9,363.5,161.8,363.5,161.6z M361,162.5c3,0.7,5.9,1.4,8.9,2.1
		c0,0.2-0.1,0.4-0.1,0.5c-2.9-0.7-5.9-1.4-8.8-2.1C360.9,162.9,361,162.7,361,162.5z"
      />
      <path
        class="st2"
        d="M471.5,108c-1.3-0.2-2.7-0.3-4-0.5c-1-0.1-2.1-0.2-3.1-0.3c-0.9-0.1-1.7-0.2-2.6-0.2c-1.5-0.1-1.8-0.8-1.8-2.1
		c0-0.1,0-0.1,0-0.2c0.1-1.8,0.1-3.6,0-5c0-0.7,0-1.3,0-1.8c0,0.5-0.1,1.1-0.1,1.7c-0.1,1.4-0.1,3.2-0.2,5.1c0,0.8-0.1,1.6-0.1,2.4
		c1.6,0.1,3.2,0.3,4.8,0.5c0.9,0.1,1.7,0.2,2.6,0.2C468.5,107.9,470,108,471.5,108z"
      />
      <path
        class="st2"
        d="M516.7,126.3c-15.3,11.1-30.6,22.3-45.9,33.4c-0.3,0.2-0.6,0.4-0.9,0.7c-0.1,0.1-0.2,0.2-0.3,0.2
		c-0.7,0.5-1.5,1.1-2.2,1.6c-0.5,0.3-0.9,0.7-1.4,1c-0.9,0.6-1.8,1.3-2.7,1.9c-0.2,0.2-0.4,0.3-0.7,0.5c0,0,0,0-0.1,0
		c-0.5,0.4-1,0.7-1.4,1.1c-1.8,1.3-3.6,2.6-5.3,3.9c-0.4,0.3-0.7,0.5-1.1,0.8c-8.4,6.1-16.8,12.3-25.2,18.4
		c-0.2,0.1-0.3,0.2-0.5,0.4c-2.1,1.5-4.2,3.1-6.4,4.6c-0.5,0.4-1,0.7-1.5,1.1c-4.8,3.5-9.6,7-14.4,10.5c-0.1,0.2-0.2,0.5-0.1,0.8
		c0.3,0.3,0.6,0.5,1,0.8c0,0,0.1,0,0.1,0.1c0.6,0.4,1.3,0.6,2.3,0.3c0.1,0,0.1,0,0.2,0c9.8-7.5,19.6-14.9,29.4-22.4
		c0.7-0.6,1.5-1.1,2.2-1.7c0.2-0.2,0.4-0.3,0.6-0.5s0.5-0.4,0.7-0.6c4-3.1,8-6.1,12-9.2c1.1-0.8,2.1-1.6,3.2-2.4
		c2.1-1.6,4.2-3.2,6.3-4.8c0.9-0.7,1.9-1.4,2.8-2.1c0.3-0.3,0.7-0.5,1-0.8c1.2-0.9,2.4-1.8,3.6-2.8c16.1-12.3,32.3-24.6,48.5-37
		c-1.6-0.2-2.8-0.3-4-0.4c0.2,0.1,0.3,0.2,0.5,0.3c0.3,0.2,0.7,0.3,1,0.5c-0.2,0.4-0.4,0.7-0.6,1.1
		C517.3,125.9,517,126.1,516.7,126.3z"
      />
      <path
        class="st2"
        d="M354.2,202.3L354.2,202.3c-0.8-0.3-1.3-0.4-1.8-0.6c-0.3-0.1-0.6-0.2-1-0.4c-0.2-0.1-0.4-0.1-0.5-0.2
		c-1-0.5-1.7-0.6-2.3-0.4c-0.6,0.2-1.1,0.6-1.8,1.4c0.2,0.1,0.4,0.2,0.6,0.4c1.2,0.6,2.4,0.9,3.6,0.8
		C352,203.3,353.1,202.9,354.2,202.3L354.2,202.3z"
      />
      <path
        class="st2"
        d="M523.7,84.2c0.6,0,1.4-0.3,1.7-0.8c0.7-0.8,1.3-1.7,2-2.5c0.2-0.3,0.4-0.6,0.7-0.8c1.2-1.5,2.4-3,3.5-4.5
		c-0.1,0-0.3-0.1-0.4-0.1c-0.4-0.1-1,0.1-1.4,0.2c-0.9,0.2-1.7,0.3-2.6-0.4c1.2-0.4,2.4-0.9,2.8-1.9c0.2-0.5,0.2-1.2,0.1-1.6
		c-0.1-0.4-0.4-0.7-0.8-1c-0.3-0.2-0.7-0.3-1.1-0.4c-0.6-0.1-1.3-0.1-2,0.1c-0.1-0.3-0.2-0.6-0.3-0.8c-1.2,0-2.4-0.1-3.7-0.1
		c-0.9,0-1.8-0.1-2.7-0.1c-0.5,0-1,0-1.5-0.1c-1.6-0.1-3.1-0.1-4.7-0.2c-0.1,0-0.2,0-0.3,0c-1,0-1.9-0.1-2.9-0.1
		c-1.2,0-2.5-0.1-3.7-0.1c-0.3,0-0.7,0-1,0s-0.5,0-0.8,0c-0.4,0-1.1,0.4-1.4,0.9c-0.4,0.5-0.8,1-1.1,1.6c-0.2,0.3-0.4,0.5-0.6,0.8
		c-0.2,0.2-0.3,0.5-0.5,0.7c-0.1,0.2-0.3,0.4-0.4,0.5c-0.2,0.2-0.3,0.5-0.5,0.7c-0.1,0.2-0.2,0.3-0.3,0.5c-0.1,0.2-0.2,0.3-0.4,0.5
		c-0.1,0.1-0.2,0.3-0.3,0.4c-0.4,0.5-0.8,1-1.1,1.6c-1.1,1.5-2.2,3-3.2,4.5c-0.2,0.3-0.4,0.7-0.8,1.2c2,0.1,4,0.2,5.9,0.4
		c0.3,0,0.5,0,0.8,0c1.7,0.1,3.4,0.2,5,0.3c0,0.2,0,0.4,0,0.6c-0.5,0-1,0-1.5,0c-1.1-0.1-2.2-0.1-3.3-0.2c-0.3,0-0.5,0-0.8,0
		c-1.5-0.1-3.1-0.2-4.6-0.3c-2.5-0.1-3,0.3-4,2.9c0.5,0,1,0.1,1.5,0.1c2.5,0.1,5.1,0.3,7.6,0.4c0.7,0,1.4,0.1,2.2,0.1
		c0.2,0,0.3,0,0.5,0c3.2,0.2,6.4,0.3,9.6,0.5c2.2,0.1,4.4,0.2,6.7,0.4c2.2,0.1,2.9-0.2,3.8-1.9c0.1-0.3,0.3-0.6,0.5-0.9
		c-0.2,0-0.3,0-0.5,0c-0.3,0-0.6-0.1-0.9-0.1c-0.9-0.1-1.8-0.2-2.7-0.3c0-0.2,0-0.4,0-0.5C521.2,84.1,522.5,84.3,523.7,84.2z"
      />
      <path
        class="st2"
        d="M344.3,196.8c-1,0.6-1.6,1.6-1.4,2.8c0.1,0.5,0.8,1.4,1.2,1.4h0.1c0.8-0.1,1.5-0.6,2.1-0.9
		c-0.3-0.5-0.6-1-0.9-1.4C345,198,344.7,197.4,344.3,196.8z"
      />
      <path
        class="st2"
        d="M421.2,211.3c7.2-5.9,14.4-11.9,21.6-17.8c0.4-0.3,0.7-0.6,1.1-0.9c0.2-0.2,0.4-0.3,0.6-0.5
		c0-0.2,0.1-0.4,0.2-0.5c-0.3-0.3-0.6-0.5-1-0.6c-0.3-0.1-0.6-0.2-0.9-0.4c-0.6-0.3-1.2-0.6-1.5-1.2c-8.3,6.5-16.5,13-24.8,19.6
		c0.3,0.1,0.5,0.3,0.7,0.2c1.2-0.3,2.4,0.1,3.5,0C420.8,209.9,420.1,210.8,421.2,211.3z"
      />
      <path
        class="st2"
        d="M470.5,157.3c0.4,0.1,0.9,0.3,1.1,0.1c1.2-0.8,2.3-1.6,3.7-2.7c-0.6-0.2-0.9-0.3-1.1-0.3
		c-5.3-1-10.7-1.9-16-2.9c-0.2,0-0.4-0.1-0.6-0.1s-0.5-0.1-0.7-0.1s-0.3-0.1-0.5-0.1c-1.8-0.3-3.7-0.7-5.5-1c-1-0.2-1.9-0.2-2.7,0.5
		c-1,0.9-2.1,1.1-2.9-0.2c-0.4-0.6-0.9-0.5-1.3-0.1c-1.8,1.5-1.8,1.6-3.4-0.1c-0.4-0.5-1.1-0.9-1.3-1.4c-0.2-0.5-0.5-0.8-0.8-0.9
		c-0.2-0.1-0.5-0.1-0.7-0.1c-0.6-0.1-1.1-0.2-1.7-0.3c-0.7-0.1-1.3-0.2-2-0.4l0,0c-12.8-2.3-25.7-4.6-38.5-6.9
		c-1.2-0.2-2.4-0.4-3.5-0.7c-1.5-0.3-2.9-0.5-4.4-0.8c-2.7-0.5-5.5-1-8.2-1.5c-0.2,0-0.4-0.1-0.6-0.1c-1.9-0.3-3.9-0.7-5.8-1
		c-1.4-0.2-2.8-0.5-4.1-0.7c-0.5-0.1-0.9-0.2-1.4-0.2c-1.7-0.3-3.5-0.6-5.2-0.9c-0.4-0.1-0.9-0.1-1.3-0.2c-1.2-0.2-2.4-0.4-3.5-0.6
		c-2.4-0.4-4.8-0.9-7.1-1.3c-0.3,0-0.5,0-0.8,0c0.6,0.4,1.1,0.7,1.6,1c0,0-0.3,0.6-0.5,0.9c-1-1.5-1-1.5-1.9-0.8
		c0.6,0.3,1.1,0.8,1.7,1c2.5,0.6,5,1.2,7.5,1.5c1.6,0.2,3.4-0.5,5-0.3c1.5,0.1,2.9,0.4,4.4,0.7c0.3,0.1,0.6,0.1,0.9,0.2
		c0.3,0.1,0.6,0.1,1,0.2c0,0.1,0,0.3,0,0.4c-0.4-0.1-0.8-0.1-1.3-0.2c-0.3,0-0.6-0.1-0.8-0.1c-1-0.2-2.1-0.3-3.1-0.5
		c0.8,0.4,1.5,0.7,2.3,1c0.3,0.1,0.7,0.2,1,0.4c0.4,0.1,0.7,0.2,1.1,0.3c1.9,0.4,3.8,0.8,5.7,1.2c1,0.2,2,0.4,3,0.6
		c0.7,0.1,1.3,0.2,2,0.4c0.4,0.1,0.8,0.1,1.2,0.2c2.4,0.4,4.7,0.8,7,1.3c7.4,1.5,14.7,3.2,22.2,3.6c1.4,0.1,2.9,0.4,4.3,0.7
		c0,0.1,0,0.3-0.1,0.4c-1.1-0.1-2.1-0.2-3.2-0.3c0.5,0.3,1,0.4,1.5,0.5c6.1,1.2,12.3,2.4,18.4,3.6c0.9,0.2,1.8,0.3,2.7,0.5
		c7,1.4,14,2.7,21.1,4C459.7,155.7,464.9,157.4,470.5,157.3C470.3,157.2,470.4,157.3,470.5,157.3z M416.1,145.7
		c-2.7-0.5-5.4-1-8.1-1.6c0-0.2,0.1-0.4,0.1-0.5c2.7,0.5,5.4,1.1,8.1,1.6C416.1,145.4,416.1,145.5,416.1,145.7z"
      />
      <path
        class="st2"
        d="M446.6,193.5c-0.3,0.2-0.5,0.5-0.8,0.7C446,194,446.3,193.8,446.6,193.5z"
      />
      <path
        class="st2"
        d="M451.8,189c-1,0.8-1.9,1.6-2.9,2.4c0.4,0,0.8,0,1.2-0.2C451.3,190.8,451.9,190.1,451.8,189z"
      />
      <path
        class="st2"
        d="M308.8,220.1c-1-0.3-1.9-0.5-2.8-0.6c-2.2-0.4-4.3-0.4-6.3,0.3c1.5,0.8,3,1.7,4.5,2.5c0.2,0.1,0.7,0.2,0.9,0.1
		c0.3-0.2,0.7-0.4,1-0.6C306.9,221.3,307.8,220.7,308.8,220.1z"
      />
      <path
        class="st2"
        d="M516.2,123.7c-4.7-0.5-9.4-0.9-14.1-1.4c3.3,0.6,6.7,0.9,10,1.2C513.5,123.7,514.8,123.7,516.2,123.7z"
      />
      <path
        class="st2"
        d="M419.6,158c2.1,1.6,2.6,1.8,4.3,1.1c0.2-0.1,0.4-0.2,0.7-0.3c0.5-0.2,1-0.1,1.6-0.2c0.4,0,0.8,0,1.2,0
		c0-0.1,0-0.3,0-0.4c-1.1-0.6-2.1-0.5-3.1,0c-0.2,0.1-0.4,0.2-0.6,0.3c-0.5,0.3-1.2,0.2-1.9,0.3c0.2-0.5,0.5-1,0.7-1.6
		c0-0.1,0-0.2-0.1-0.6C421.5,157.2,420.6,157.6,419.6,158z"
      />
      <path
        class="st2"
        d="M447.9,174.8c0.3-0.3,0.6-0.5,0.9-0.8c1-0.8,2.2-1.6,3.4-2.5c0.2-0.1,0.3-0.2,0.5-0.4c-0.2,0-0.3-0.1-0.4-0.1
		c-1.3-0.3-2.4-0.5-3.5-0.8c-0.1,0-0.1,0-0.2,0c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0.1c0.8,0.2,1.5,0.5,2.3,0.7c-0.7,0.2-1.3,0.2-1.9,0.1
		c-0.3-0.1-0.7-0.2-1-0.2c-1.6-0.4-3.2-0.7-4.8-1.2c-1.4-0.4-2.7-1.4-4.1-1.7c-1.5-0.3-2.9-0.7-4.4-1c-1.9-0.4-3.7-0.9-5.6-1.3
		c-1.8-0.4-3.6-0.8-5.5-1.3c-2.3-0.5-4.6-1.1-7-1.6c-2.8-0.7-5.7-1.3-8.5-2c-0.2-0.1-0.5-0.1-0.7-0.2c-7.6-1.7-15.2-3.5-22.8-5.2
		c-2.7-0.6-5.5-1.3-8.2-1.9c-0.6-0.1-1.2-0.3-1.8-0.4c-0.9-0.2-1.8-0.4-2.7-0.6c-6.3-1.5-12.7-2.9-19-4.4c-0.4-0.1-0.9-0.2-1.3-0.3
		c-12.3-2.8-24.6-5.6-36.8-8.4c-1.2-0.3-2.3-0.5-3.5-0.8c-0.5-0.1-0.9-0.2-1.4-0.3c0,0,0,0-0.1,0c-0.7-0.2-1.4-0.3-2.1-0.5l0.1,0.1
		c0.6,0.4,1.2,0.6,1.9,0.4c0.1,0.8,0.5,1.2,1.2,1.4c0.3,0.1,0.7,0.1,1.1,0c-0.1,0.3-0.1,0.6-0.2,0.8c0.6-0.2,1.2-0.3,2-0.5
		c0,0.2,0,0.4,0,0.6c0,0.8,0,1.4,0,1.9c-0.1,0.8,0.3,1.2,1.1,1.4c5.1,1.2,10.3,2.5,15.4,3.7c-1.4-0.5-2.9-1-4.3-1.5
		c0-0.2,0.1-0.3,0.1-0.5c2.3,0.6,4.6,1.2,6.9,1.8c0,0.1,0,0.2,0,0.3c-0.3,0-0.6,0-0.9,0.1c0.7,0.3,1.3,0.6,2,0.8s1.4,0.3,2,0.5
		c1.6,0.4,3.3,0.8,4.9,1.2c2.1,0.5,4.3,1.1,6.4,1.6c0.4,0.1,0.8,0.2,1.2,0.3c12,3,24,6,36,9c1,0.3,2,0.5,3.1,0.8
		c0.8,0.2,1.6,0.4,2.4,0.6c1.4,0.4,2.9,0.7,4.3,1.1c1.7,0.4,3.4,0.9,5.1,1.3c0.5,0.1,1.1,0.3,1.6,0.4c1,0.3,2.1,0.5,3.1,0.8
		c0.9,0.2,1.9,0.5,2.8,0.7c-0.2-0.6-0.4-1.1-0.5-1.6c-0.1-0.3-0.2-0.7-0.4-1.1c0.8,0.5,1.5,1,2.1,1.4c0.5,0.3,1,0.6,1.5,1
		c-0.1,0.2-0.3,0.5-0.5,0.9c0.1,0.1,0.1,0.2,0.2,0.3c0.7-0.4,1.3-0.8,1.8-1.1c1.6,0.6,3.1,1.2,4.6,1.7c-0.1,0.2-0.3,0.4-0.4,0.7
		c0.3,0.1,0.6,0.2,0.8,0.3c1.9,0.5,3.7,0.9,5.6,1.4c1.8,0.5,3.6,0.9,5.5,1.4s3.8,0.9,5.7,1.4c0.8,0.2,1.5,0.4,2.3,0.6
		c2.4,0.6,4.7,1.2,7.1,1.8C444.6,176.5,446.3,176.4,447.9,174.8z M328.4,145.1c2.2,0.7,4.4,1.3,6.7,2
		C334.2,147.7,330,146.6,328.4,145.1z M330.3,145.1c1.7-1,6-0.5,8.8,1.1c-0.5-0.1-1.1-0.1-1.6-0.2c-0.6-0.1-1.1-0.2-1.7-0.2
		c0.5,0.2,1,0.4,1.6,0.5c0,0.2-0.1,0.4-0.1,0.5C335,146.3,332.8,145.7,330.3,145.1z M382.3,160c-0.4-0.1-0.9-0.2-1.3-0.3
		c-1.4-0.3-2.8-0.7-4.2-1c-1-0.2-2-0.5-3-0.7c0-0.2,0.1-0.4,0.1-0.5c0.8,0.2,1.5,0.3,2.3,0.5c1.9,0.4,3.9,0.9,5.8,1.3
		c0.1,0,0.2,0.1,0.3,0.1C382.3,159.6,382.3,159.8,382.3,160z M384.1,159.3c-0.5-0.1-0.9-0.2-1.4-0.3c-2.3-0.6-4.6-1.1-6.9-1.7
		c-0.2,0-0.4-0.1-0.6-0.1c0-0.2,0.1-0.4,0.1-0.5c0.1,0,0.2,0,0.3,0.1c2.5,0.6,5.1,1.2,7.6,1.9c0.3,0.1,0.6,0.2,0.9,0.2
		C384.2,158.9,384.2,159.1,384.1,159.3z M384.1,157.7c-2.2-0.4-4.4-0.9-6.5-1.3c0-0.1,0-0.3,0-0.4c2.5-0.9,4.8-0.2,7.2,0.4
		c1,0.3,2.1,0.5,3.1,0.5c0,0.2,0,0.4-0.1,0.5c-1.1-0.2-2.1-0.4-3.2-0.6c-0.1,0-0.1,0-0.2,0c-1.1-0.2-2.3-0.4-3.5-0.4
		c1.2,0.3,2.3,0.5,3.5,0.8c0.7,0.2,1.3,0.3,2,0.5c0,0.2-0.1,0.3-0.1,0.5C385.5,158,384.8,157.9,384.1,157.7z M410.4,164.9
		c-0.5-0.3-1.1-0.4-1.7-0.5c-0.4-0.1-0.8-0.1-1.2-0.2c0.3-0.3,0.7-0.6,1.1-0.8c1.4-0.8,3.1-0.6,5,0.7
		C412.6,164.8,411.9,165.8,410.4,164.9z M417.2,168.5c-0.7-2-1.7-3.2-3.8-3c0-0.2,0.1-0.5,0.1-0.7c0.9-0.2,2-0.8,2.8-0.5l0,0
		c1.1,0.4,1.4,1.3,1.3,2.7C417.4,167.5,417.3,168,417.2,168.5z M440,172.1c-0.9-0.3-1.8-0.5-2.5-0.8c0-0.1,0-0.3,0.1-0.4
		c0.9,0.2,1.8,0.4,2.7,0.6c2.6,0.6,5.2,1.2,7.8,1.9C447.5,173.7,443.4,173,440,172.1z M447.7,171.9c0.5,0.1,1,0.2,1.6,0.4
		c0,0.2-0.1,0.4-0.1,0.5c-0.5-0.1-0.9-0.2-1.4-0.3c-2.5-0.6-5-1.2-7.4-1.7c-0.4-0.1-0.9-0.2-1.3-0.3c0-0.2,0.1-0.4,0.1-0.5
		c0.3,0.1,0.7,0.2,1,0.2C442.7,170.7,445.2,171.3,447.7,171.9z M438.8,173.2c-1-0.3-2-0.5-2.9-0.8c0-0.2,0.1-0.4,0.1-0.6
		c1.2,0.3,2.3,0.6,3.5,0.9c2.3,0.6,4.5,1.2,6.8,1.8c0,0.2-0.1,0.4-0.1,0.6C443.7,174.4,441.3,173.8,438.8,173.2z"
      />
      <path
        class="st2"
        d="M514.4,129.7c-5.7,4.4-11.4,8.7-17.2,13.1l0,0c-1.8,1.4-3.7,2.8-5.5,4.2l-0.1,0.1c-6.2,4.8-12.5,9.5-18.7,14.3
		c-1,0.8-2.1,1.6-3.1,2.4c-0.2,0.2-0.4,0.3-0.6,0.5c-1.3,1-2.6,2-3.9,2.9c-0.3,0.2-0.6,0.4-0.9,0.6c-0.3,0.2-0.6,0.5-0.9,0.7
		c-1.5,1.1-2.9,2.2-4.4,3.4c-1.3,1-2.6,2-3.8,2.9c-3.9,3-7.9,6-11.8,9c0,0-0.1,0-0.1,0.1c-0.5,0.4-1,0.7-1.4,1.1
		c0.8,0.2,1.5,0.5,2.1,0.5c0.1,0,0.1,0,0.2,0c0.5-0.4,1-0.8,1.4-1.1c0.2-0.2,0.4-0.3,0.6-0.5c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0.1
		c0,0,0.1,0,0.1-0.1c0.9-0.7,1.8-1.4,2.7-2.1c1.4-1.1,2.8-2.2,4.2-3.3c2.8-2.2,5.6-4.4,8.4-6.6c0.5-0.4,1.1-0.8,1.6-1.3
		c0.1-0.1,0.3-0.2,0.4-0.3c0.2-0.2,0.4-0.3,0.6-0.5c0.3-0.2,0.6-0.5,0.9-0.7c0.8-0.6,1.6-1.3,2.4-1.9c1.1-0.9,2.2-1.7,3.3-2.6
		c0.6-0.5,1.3-1,1.9-1.5c0.6-0.4,1.1-0.9,1.7-1.3c4.3-3.4,8.7-6.8,13-10.3c0.1-0.1,0.2-0.2,0.4-0.3c1.3-1,2.6-2,3.9-3.1
		c0.2-0.2,0.5-0.4,0.7-0.6c1.6-1.2,3.1-2.5,4.7-3.7c0.1-0.1,0.2-0.2,0.3-0.3c5.7-4.5,11.3-8.9,17-13.4
		C514.5,129.9,514.5,129.8,514.4,129.7z"
      />
      <path
        class="st2"
        d="M486.7,146.5c-8.9-1.4-17.4-2.8-26-4.2c0.2,1.5-0.4,2.3-1.6,2.9l0,0l0,0c7.2,1.2,14.5,2.3,21.7,3.7
		C483.4,149.5,484.6,147.9,486.7,146.5z"
      />
      <path
        class="st2"
        d="M509.5,103.9c-4.2-0.2-8.4-0.5-12.6-0.7c-0.6,0-1.1-0.1-1.7-0.1c-2.2-0.1-4.3-0.3-6.5-0.4
		c-1.6-0.1-3.2-0.2-4.7-0.3c-2.3-0.1-4.5-0.3-6.8-0.4c-0.3,0-0.5,0-0.8,0c-1-0.1-1.9-0.1-3-0.1c-0.1,0-0.2,0-0.3,0
		c0,0.5,0,1-0.1,1.5c0,0.8-0.1,1.6-0.1,2.4c0,0.2,0,0.4,0,0.6c-0.1,0.9,0.3,1.1,1.2,1.2c0.2,0,0.5,0,0.7,0.1
		c0.7,0.1,1.4,0.1,2.1,0.2c1.3,0.1,2.7,0.2,4,0.3c0.3,0,0.5,0,0.8,0.1c1.6,0.1,3.3,0.2,4.9,0.4c1.6,0.1,3.2,0.2,4.9,0.4
		c4.3,0.3,8.5,0.6,12.8,1c2.3,0.2,4.6,0.3,7,0.5c0-1.6-0.1-3,0-4.4C511.5,104.4,511,104,509.5,103.9z"
      />
      <path
        class="st2"
        d="M344.4,206.2c-1.9,2.4-5,3.9-8,3.7c0.5-1.1,1-2.1,1.5-3.2c-0.1-0.1-0.2-0.2-0.3-0.3c-0.7,0.5-1.6,0.9-2,1.6
		c-0.7,1.2-1,2.6-1.4,4c-0.1,0.4,0.3,0.9,0.5,1.4c0.4-0.2,1-0.3,1.2-0.6c1.3-2.1,3.2-2.9,5.6-3.2c1-0.1,2.1-0.7,3-1.3
		C345.4,207.7,345.4,206.8,344.4,206.2z"
      />
      <path
        class="st2"
        d="M520.2,90.1c0-0.1,0.1-0.1,0.1-0.2c0.2-0.2,0.3-0.4,0.5-0.6s0.3-0.4,0.5-0.6c-0.4-0.1-0.6-0.2-0.8-0.2
		c-2.5-0.1-5.1-0.3-7.6-0.4c-4.1-0.2-8.2-0.5-12.3-0.7c-2.9-0.2-5.9-0.3-8.8-0.5c-0.5,0-1.2,0.4-1.5,0.8c-0.1,0.1-0.1,0.2-0.2,0.2
		c0,0,0,0-0.1,0.1c-0.1,0.2-0.3,0.4-0.4,0.6s-0.3,0.4-0.4,0.6c-1.2,1.6-2.4,3.3-3.6,4.9c-0.2,0.2-0.2,0.5-0.3,0.8
		c0.2,0.1,0.4,0.1,0.5,0.1c1.4,0.1,2.8,0.2,4.3,0.3c2.9,0.2,5.7,0.3,8.6,0.5c1.5,0.1,3,0.2,4.5,0.3c2.2,0.1,4.4,0.3,6.6,0.4
		c0.1,0,0.3,0,0.4,0c1.3,0.1,2.7,0.2,4,0.2c0.4,0,1-0.2,1.2-0.5C517,94.3,518.5,92.3,520.2,90.1z"
      />
      <path
        class="st2"
        d="M413.5,115.2c0,0.2,0,0.3,0,0.5c0.1,0,0.3,0,0.4,0c1.4,0.1,2.8,0.3,4.2,0.4c0.2,0,0.3,0,0.5,0
		c0-0.1,0-0.2,0-0.4v-0.1c-1.5-0.1-2.9-0.3-4.4-0.4C413.9,115.2,413.7,115.2,413.5,115.2z"
      />
      <path
        class="st2"
        d="M347.4,229.7c-1-0.5-1.9-0.9-2.9-1.4c-0.5-0.3-1.1-0.5-1.6-0.8c-0.4-0.2-0.8-0.4-1.1-0.6
		c-0.2-0.1-0.4-0.2-0.7-0.3c-0.9-0.4-1.8-0.9-2.6-1.3c-0.6-0.3-1.2-0.6-1.9-0.9c0,0-0.1,0-0.1-0.1c-3.3-1.6-6.5-3.2-9.8-4.7
		c-0.1,0.1-0.1,0.2-0.2,0.3c3.3,1.6,6.7,3.2,10,4.9l0,0c0.6,0.3,1.3,0.6,1.9,0.9c0.7,0.3,1.4,0.7,2.1,1c0.3,0.2,0.7,0.3,1,0.5
		c1.4,0.7,2.7,1.3,4.1,2c0,0,0,0,0.1,0c0.3,0.2,0.6,0.3,1,0.5c0.9,0.4,1.8,0.9,2.7,1.3c0.3,0.1,0.6,0.3,0.8,0.4
		c0.1-0.1,0.2-0.2,0.2-0.4c-0.2-0.1-0.5-0.2-0.7-0.4C349,230.5,348.2,230.1,347.4,229.7z"
      />
      <path
        class="st2"
        d="M378.5,188.5c-0.9,0.1-1.9-0.1-2.8,0c-0.6,0.1-1.1,0.5-1.6,0.8c0.6,0.3,1.2,0.9,1.7,0.7
		c1.6-0.5,3.2-1.1,4.7-1.9c0.8-0.4,1.3-1.1,2-1.7c-0.1-0.2-0.2-0.4-0.3-0.6c-0.8,0.2-1.6,0.4-2.6,0.6
		C380.2,188,380,188.4,378.5,188.5z"
      />
      <path
        class="st2"
        d="M379.9,184.4c-0.8,0-1.2-0.1-1.7,0c-1.5,0.2-2.7,0-3.9-1.1c-0.7-0.6-1.8-0.6-2.7-0.9c-0.1,0.2-0.2,0.4-0.2,0.6
		c1.5,0.4,2.8,1,2.4,3C375.9,185.4,378.1,186.6,379.9,184.4z"
      />
      <path
        class="st2"
        d="M382.2,181.2c-1.1-0.8-1.9-1.4-2.8-2.2c-0.5,1.5,0.3,2.3,1.3,2.7C381,181.9,381.6,181.4,382.2,181.2z"
      />
      <path
        class="st2"
        d="M383.1,182.1c0,0.2-0.1,0.4-0.1,0.5c1.4,0.3,2.8,0.5,4.2,0.8c0-0.2,0.1-0.3,0.1-0.5
		C385.8,182.9,384.8,181.2,383.1,182.1z"
      />
      <path
        class="st2"
        d="M369.7,186c-0.5-0.6-0.8-1.1-1.2-1.5c-0.2,0-0.4,0.1-0.6,0.1c0,0.1,0,0.3,0,0.5c0,0.5,0,1.1,0.2,1.5
		c0.1,0.2,1,0.1,1.8,0c0-0.1,0-0.1-0.1-0.2C369.8,186.2,369.7,186.1,369.7,186z"
      />
      <path
        class="st2"
        d="M452.9,143c0.6-0.7,1-1.1,1.3-1.5c-0.1-0.1-0.1-0.2-0.2-0.3c-0.6,0.1-1.2,0.3-1.8,0.4
		C452.4,141.9,452.6,142.3,452.9,143z"
      />
      <path
        class="st2"
        d="M430.8,133.6c-0.6-0.1-1.2-0.2-1.8-0.3c-0.7-0.1-1.4-0.2-2.1-0.3c-8.7-1.3-17.3-2.6-26-3.8
		c-1.7-0.2-3.4-0.4-5.1-0.3c-1.4,0.1-2.8,0.6-4,0.9c0.6,0.2,1.5,0.6,2.4,0.7c2.8,0.5,5.7,0.9,8.5,1.4c6,1,12,1.9,17.9,3
		c3.8,0.7,7.7,0.9,11.8,0.3c-0.9-0.2-1.5-0.3-2.3-0.4c0.6-0.2,1-0.4,1.5-0.6C431.4,133.7,431.1,133.6,430.8,133.6z"
      />
      <path
        class="st2"
        d="M331.9,203.2c1.2,0.8,2.3,1.5,3.6,2.4c0.8-0.4,1.8-1,2.9-1.6C336.9,202.1,334.4,201.9,331.9,203.2z"
      />
      <path
        class="st2"
        d="M394.1,199.3c4,1.4,8,2.9,12,4.3c0.2-0.1,0.5-0.2,0.7-0.3c0.3,0.3,0.6,0.6,0.8,0.9c2.5-1.8,5-3.7,7.5-5.5
		c1-0.7,1.9-1.4,3-2.3c-0.7-0.2-1.2-0.4-1.6-0.6c-9.8-3-19.5-6.1-29.3-9.1c-1.7-0.5-3.5-1-5.2-1.5l0,0l0,0c0.9,0.7,0.9,1.5,0,2.1
		c-1.8,1.1-3.8,2.1-5.7,3.1c-0.2,0.1-0.6,0.1-0.9,0.1c-0.1,0-0.1,0-0.2,0c-0.3,0-0.7-0.1-1-0.2c-0.4-0.2-0.7-0.5-0.6-1.1
		c0.1-0.5,1.2-1,1.9-1.1c0.5-0.1,0.9-0.1,1.4-0.1c0.1,0,0.2,0,0.4,0c0.7,0,1.5,0,2.4,0c-0.5-0.7-0.7-1-1.1-1.6
		c1.2-0.4,2.4-0.7,3.5-1.1l0,0c-0.6-0.1-1.5-0.5-1.8-0.3c-2.1,1.9-4.8,0.9-7.2,1.6c0.4-2.1,0.4-2.1-3.2-3.5c0.6-0.4,1.1-0.7,1.8-1.2
		c-2.4-0.8-4.8-1.5-7.3-2.2c-1.6-0.5-3.3-1-4.9-1.5c-17.9-5.5-35.8-11.1-53.6-16.6c-10.5-3.2-21-6.5-31.5-9.7c0,2-0.7,2.9-2.6,3.1
		c-1.5,0.2-2.8-0.1-4-1.3c0.8-0.4,1.4-0.8,1.8-1c1.2,0.7,2.2,1.3,3.3,1.9c0.5-1.8-0.5-2-1.6-2.3c0.5-0.4,0.8-0.6,1.1-0.9
		c-0.1-0.1-0.1-0.3-0.2-0.4c-0.8,0.3-1.6,0.9-2.4,0.8c-0.8-0.1-1.6-0.7-2.4-1.1c-0.1,0.1-0.2,0.3-0.3,0.4c0.4,0.4,0.8,0.9,1.3,1.4
		c-0.7,0.3-1.3,0.6-2.2,1.1c-0.2-0.7-0.6-1.4-0.5-1.9c0.2-0.8,0.7-1.5,1.1-2.3c-3.2-1-6.5-2.1-9.9-3c-1.1-0.3-2.3-0.2-3.5-0.2
		c0,0.2-0.1,0.4-0.1,0.5c0.9,0.3,1.7,0.6,2.6,0.9c0,0.1-0.1,0.3-0.1,0.4c-1.6-0.4-3.2-0.8-4.9-1.2c0,0.1-0.1,0.3-0.1,0.4
		c0.7,0.4,1.4,0.7,2.1,1.1c-0.1,0.1-0.1,0.3-0.2,0.4c-0.7-0.2-1.5-0.5-2.2-0.7c-0.8-0.2-1.5-0.4-2.3-0.7c-0.1,0.2-0.1,0.3-0.2,0.5
		c0.7,0.4,1.4,0.8,2.3,1.4c-2,0.7-3.3-1.8-5.2-0.8c0.7,0.4,1.3,0.8,2,1.2c-1.8,0.8-3-1.7-4.8-0.5c0.6,0.2,0.9,0.4,1.3,0.5
		c20.7,7.4,41.5,14.8,62.2,22.1c4,1.4,8,2.9,12,4.3c1,0.4,2,0.7,3,1.1c0.3,0.1,0.7,0.2,1,0.4c12,4.3,24.1,8.6,36.1,12.9
		c1.3,0.5,2.6,0.9,3.8,1.4c3.1,1.1,6.2,2.2,9.3,3.3c0.4,0.2,0.9,0.3,1.3,0.5c1.9,0.7,3.8,1.4,5.7,2c0.3,0.1,0.6,0.2,0.9,0.3
		c4.6,1.7,9.3,3.3,13.9,5c0.8,0.3,1.6,0.6,2.5,0.9c1.5,0.5,3,1.1,4.5,1.6c0.3-0.5,0.1-1.2,0.9-1.6c0.2,0.4,0.3,0.7,0.6,1
		c0.7,0.8,2,0.9,2.7,0.1c0.1-0.1,0.2-0.2,0.3-0.3c-0.1,0-0.2,0-0.2,0c-3.7-1.4-7.4-2.8-11.1-4.3c-0.1,0-0.2-0.2-0.7-0.6
		C393.3,199.5,393.8,199.2,394.1,199.3z M263.7,154.4c0.9-1.8,1.5-1.8,2.7,0C265.4,154.4,264.5,154.4,263.7,154.4z M276.5,160.2
		c3.2-0.7,5.6,1.5,8.3,2.4C281.7,163.1,279.2,161.1,276.5,160.2z M286.4,162.3c-2.4-0.8-4.8-1.7-7.2-2.6c0-0.2,0-0.3,0.1-0.5
		c0.5,0,1.1-0.2,1.5-0.1c2.3,0.8,4.7,1.6,7,2.8C287.3,162,286.8,162.4,286.4,162.3z M288.9,161.3c-2.1-0.8-4.2-1.7-6.4-2.6
		c-0.1,0-0.2-0.2-0.3-0.5c0.6-0.1,1.2-0.3,1.6-0.1c2.3,0.8,4.5,1.7,6.8,2.6c0,0.1,0,0.3,0,0.4C290.1,161.2,289.4,161.5,288.9,161.3z
M285.1,157.8c3.1-0.4,5.8,1.1,8.7,2C290.6,160.7,288,158.5,285.1,157.8z M335.1,180.2c-0.5,0.1-1,0.3-1.4,0.2
		c-2.8-1-5.5-2.2-8.3-3.3c0-0.1,0-0.3,0-0.4c0.4-0.1,0.8-0.3,1.1-0.2c2.9,1,5.7,2.1,8.6,3.2C335.1,179.9,335.1,180.1,335.1,180.2z
M337,179.1c-2.9-1-5.9-2-8.8-3c0-0.1,0-0.3,0-0.4c0.5-0.1,1-0.4,1.4-0.2c2.8,0.9,5.6,1.8,8.3,2.8c0.2,0.1,0.3,0.3,0.7,0.6
		C337.9,178.9,337.4,179.2,337,179.1z M339.1,177.9c-2.8-0.9-5.6-1.9-8.4-2.9c0-0.1,0-0.3,0-0.4c0.5-0.1,1-0.3,1.4-0.2
		c2.9,0.9,5.8,1.8,8.8,2.7c0,0.2,0,0.3,0.1,0.5C340.3,177.7,339.6,178.1,339.1,177.9z M342.6,176.5c-2.9-0.8-5.8-1.8-8.7-2.6
		c0-0.1,0-0.3,0-0.4c0.5-0.1,1-0.4,1.5-0.3c3,0.8,6,1.8,9,2.7c0,0.2,0,0.3,0,0.5C343.7,176.3,343.1,176.6,342.6,176.5z M362.9,190.3
		c-0.1-0.1-0.2-0.3-0.4-0.4c0.7-0.9,1.3-1.8,2.2-3c0.7,0.7,1.2,1.2,1.9,1.9C365.3,189.4,364.1,189.9,362.9,190.3z M370,186.7
		c-0.6,0.1-1.3,0.5-1.8,0.3s-1-1-0.9-1.5c0.1-0.3,0.3-0.7,0.5-1s0.4-0.5,0.6-0.8c0.1-0.1,0.2-0.2,0.2-0.3c0.1,0.2,0.2,0.3,0.2,0.4
		c0.4,0.7,0.6,1,0.8,1.4c0.1,0.2,0.2,0.5,0.2,0.8c0,0.1,0.1,0.2,0.1,0.4c0.1,0.1,0.1,0.1,0.2,0.2H370C370,186.6,370,186.7,370,186.7
		z M402.1,194.2c4,1.2,7.9,2.5,11.8,3.8c0,0.2,0,0.5,0,0.7c-0.6,0.1-1.3,0.5-1.9,0.3c-3.6-1.2-7.2-2.4-10.8-3.7
		c-0.2-0.1-0.4-0.2-1-0.6C401.2,194.4,401.7,194,402.1,194.2z M399.2,196.1c3.8,1.3,7.7,2.7,11.5,4c0.1,0,0.1,0.1,0.5,0.6
		c-0.7,0.2-1.3,0.5-1.7,0.4c-0.1,0-0.2-0.1-0.3-0.1h-0.1c-3.7-1.3-7.3-2.7-10.9-4c-0.1,0-0.2-0.2-0.5-0.6
		C398.3,196.3,398.9,196,399.2,196.1z M396.9,197.7c4,1.3,8,2.7,11.9,4c0,0.2,0,0.4,0.1,0.6c-0.5,0.2-1.2,0.6-1.6,0.5
		c-4-1.3-7.9-2.8-11.9-4.2c0-0.2,0-0.3-0.1-0.5C395.9,197.9,396.5,197.5,396.9,197.7z"
      />
      <path
        class="st2"
        d="M502.2,135.2c-8.1-1.2-16.1-2.3-24.1-3.5c0,0.1,0,0.3,0.1,0.4c0,0.1,0,0.2,0,0.3c0.4,1.5,1.6,1.7,3,1.8
		c1.2,0.1,2.3,0.3,3.5,0.5c0.7,0.1,1.4,0.2,2.1,0.3l0,0c0.2,0,0.5,0.1,0.7,0.1c0.1,0,0.1,0,0.2,0c1.3,0.2,2.5,0.3,3.8,0.5
		c2.4,0.3,4.9,0.1,7.2,0.7C500.5,136.8,501.2,136,502.2,135.2z"
      />
      <path
        class="st2"
        d="M310.6,221.1c-1,0.5-1.9,1.1-2.7,1.7c-0.3,0.2-0.5,0.3-0.8,0.5c0.4,0.4,0.7,0.9,1,1.3c0.6,0.7,1.2,1.4,1.8,2.2
		c0.7-0.8,1.8-1.5,2.4-2.6c0.3-0.6-0.1-1.6-0.4-2.3C311.8,221.4,310.9,221,310.6,221.1z"
      />
      <path
        class="st2"
        d="M312.5,134.9c0.1,0.1,0.2,0.3,0.3,0.4c0.2-0.7-0.4-1.3-0.5-1.8c-0.1,0-0.2,0-0.3,0c0.1,0.3,0.1,0.6,0.2,0.9
		c0.2,0.1,0.3,0.1,0.5,0.2c0,0.1,0,0.2,0,0.3C312.6,134.9,312.6,134.9,312.5,134.9z"
      />
      <path
        class="st2"
        d="M432.5,153c-1.2-0.1-2-0.1-2.9-0.1C430.5,153.4,431.2,155,432.5,153z"
      />
      <path
        class="st2"
        d="M422.2,158.5c0.1,0.1,0.1,0.2,0.2,0.3c0.8-0.4,1.6-0.8,2.5-1.3C423.3,156.4,423,157.9,422.2,158.5z"
      />
      <path
        class="st2"
        d="M486.8,120.9c0,0.1,0,0.1,0,0.2c3.7,0.4,7.4,0.7,11.1,1.1c0-0.1,0-0.2,0-0.2
		C494.2,121.6,490.5,121.3,486.8,120.9z"
      />
      <path
        class="st2"
        d="M500.5,124.1c3.5,0.3,7.1,0.7,10.6,1c0-0.1,0-0.2,0.1-0.3c-3.5-0.3-7.1-0.7-10.6-1
		C500.6,123.9,500.5,124,500.5,124.1z"
      />
      <path
        class="st2"
        d="M475.6,128.2c-4.7-0.6-9.3-1.1-14-1.8c-1.8-0.3-3.1,0.4-4.9,1.2c0.8,0.2,1.3,0.3,1.7,0.3
		c6.8,0.9,13.6,1.8,20.4,2.6c3.2,0.4,6.4,0.8,9.6,1.1c0.1,0,0.1,0,0.2,0c4,0.5,8,0.9,12,1.3c0.7,0.1,1.6-0.2,2.2,0.2
		c1.7,1.1,2.4-0.2,3.8-1.2c-0.8-0.1-1.2-0.2-1.7-0.3c-5.9-0.7-11.8-1.5-17.6-2.2c-1.3-0.2-2.6-0.5-3.8,0.4c-0.3,0.2-1,0.1-1.5,0
		c-1.3-0.2-2.5-0.5-3.5-0.7C477.2,128.9,476.4,128.3,475.6,128.2z"
      />
      <path
        class="st2"
        d="M306.3,140.9c1,0.4,1.8,0.7,2.6,1c0,0,0,0,0.1,0c0.3,0.1,0.7,0.3,1,0.4c0-0.1,0.1-0.2,0.1-0.3
		c-0.3-0.1-0.6-0.3-0.8-0.6l-0.1,0.1c-0.2-0.4-0.6-0.7-1-1c-0.2-0.1-0.4-0.1-0.6-0.2C307.2,140.5,306.8,140.6,306.3,140.9z"
      />
      <path
        class="st2"
        d="M472.3,139.7c-0.1,0-0.1,0-0.2,0c-3.9-0.6-7.7-1.1-11.6-1.7c0,0.7,0,1.2,0,1.6c-0.8-0.2-1.5-0.3-2.2-0.5
		c0.3,0.6,0.7,0.8,1.1,1.1c0.2,0.2,0.4,0.7,0.5,0.6c0.3-0.1,0.6-0.4,0.7-0.4c0.8,0,1.6,0,2.3,0c0.2,0,0.3,0,0.5,0c0.1,0,0.2,0,0.3,0
		c0-0.1,0-0.1,0-0.2v-0.1c-0.5-0.1-1-0.2-1.4-0.3c-0.2,0-0.3-0.1-0.5-0.1c0-0.2,0-0.3,0-0.5c0.2,0,0.3,0,0.5,0
		c0.6-0.1,1.1-0.1,1.6,0c0,0,0.1,0,0.1,0.1c0.5,0.2,0.9,0.7,1.2,1.2c0.1,0.1-0.6,0.7-1,1.1c0.2,0.1,0.5,0.2,0.8,0.2
		c6.8,1.1,13.6,2,20.4,3.3c2.8,0.5,4.4-0.7,6.4-2.5C485.3,141.6,478.8,140.7,472.3,139.7z"
      />
      <path
        class="st2"
        d="M404.4,208.1c0.2-0.1,0.3-0.3,0.5-0.4C404.7,207.9,404.5,208,404.4,208.1L404.4,208.1z"
      />
      <path
        class="st2"
        d="M451.5,129.5c0,0.2,0,0.4,0.1,0.6c0.8,0.1,1.6,0.2,2.5,0.3c0.1,0,0.2,0,0.4,0c5.5,0.7,11,1.5,16.4,2.2
		c0.2-0.5,0.3-0.9,0.4-1.1c2.1,1.3,4.4,1.2,6.6,1.8c0.1-0.1,0.1-0.3,0.2-0.4c-0.8-0.3-1.7-0.5-2.5-0.8c-1.4-0.4-2.9-1-4.3-1.3
		c-5.1-1-10.3-1.5-15.4-2.1C454.4,128.8,452.9,129.3,451.5,129.5z"
      />
      <path
        class="st2"
        d="M436.7,156.1c0.1-0.1,0.2-0.1,0.3-0.2c-0.2-0.2-0.5-0.5-0.7-0.7s-0.4-0.4-0.6-0.6c-0.2-0.2-0.4-0.4-0.7-0.6
		c-0.1-0.1-0.6,0.3-1,0.5c0,0,0,0,0.1,0c0.8,0.5,1.6,1,2.3,1.4C436.5,155.9,436.6,156,436.7,156.1z"
      />
      <path
        class="st2"
        d="M481.7,126.7c0.8,0.4,1.5,0.9,2.6,1.5C483.5,126.3,482.9,126,481.7,126.7z"
      />
      <path
        class="st2"
        d="M499.3,73.1c0.3-0.4,0.6-0.8,0.9-1.3c0.3-0.4,0.5-0.7,0.8-1.1c0.1-0.2,0.2-0.3,0.3-0.5c0.3-0.3,0.5-0.7,0.8-1
		c0.1-0.1,0.1-0.2,0.2-0.3c-0.2-0.1-0.3-0.2-0.5-0.3c-0.2,0.2-0.3,0.5-0.5,0.7c-0.1,0.2-0.2,0.3-0.3,0.5c-0.3,0.5-0.7,0.9-1,1.4
		c-0.1,0.2-0.2,0.3-0.3,0.5c-2.5,3.5-5,7-7.5,10.5c0.1,0.1,0.2,0.2,0.4,0.3c2.2-3,4.3-6,6.5-8.9C499.1,73.4,499.2,73.3,499.3,73.1z"
      />
      <path
        class="st2"
        d="M567.8,166c0-0.1-0.1-0.1-0.1-0.2c0,0.2,0,0.4,0,0.5l0,0c0,0.1,0,0.1,0,0.2l0.1-0.1v-0.1
		C567.8,166.2,567.8,166.1,567.8,166z"
      />
      <path
        class="st2"
        d="M562.9,162.9c0.7-0.2,1.3-0.8,1.9-1.3c0.6-0.6,1.1-1.3,1.7-2c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.1,0.1-0.1,0.2-0.2
		c0.1-0.1,0.2-0.1,0.3-0.2c0-3-0.1-6-0.2-9c0-1.4-0.1-2.7-0.1-4.1c-0.1-3.1-0.2-6.2-0.3-9.2c-0.2-3.8-0.6-7.5-1.3-11.2
		c-1-5.5-2.3-11-3.6-16.5c-0.5-2-1.1-4-1.8-6.3c-2.2,1.4-4.1,2.6-6.1,3.8c-8.2,5-16.3,10.1-24.5,15.1c-0.4,0.2-1,0.6-1,1
		c-0.1,2.3-0.6,4.8,0.1,6.8c1.7,4.8,2.9,9.6,3.6,14.4c0.1,0.8,0.2,1.5,0.3,2.3c1,8.3,0.8,16.7-0.6,25.1c-0.3,2.1-0.8,4.2-1.2,6.3
		c0.6,0.2,0.8,0.6,0.7,1.3c0.3-0.2,0.5-0.4,0.7-0.5s0.4-0.2,0.7-0.4c-0.6-0.5-0.4-1.3-0.1-1.9c0.3-0.6,1.3-1,2.1-1.6
		c0.2,0,0.7,0.1,1.4,0.2c0-1,0-2,0-2.9c0.5,0,1.1,0,1.6,0c-0.5-0.4,0.8-0.9,0.1-1.3c0.4-0.4,0.7-0.8,1.1-1.3
		c0.8,0.3,1.1-0.1,1.4-0.6c1.2,0.7,0.9,1.7,0.4,2.8c-0.7,0.2-1.6,0.5-2.5,0.8c0-0.3,0-0.6-0.5-0.5c-0.1,0.3-0.3,0.8,0.4,0.5
		c0,0.2-0.1,0.5-0.1,0.7c0.1,0.8,0.3,1.3,0.6,1.7c0.6,0.7,1.7,0.9,3.5,0.9c0.3,0.3,0.5,0.5,0.7,0.8c0.2-0.1,0.5-0.1,0.7-0.2
		c0.4-0.1,0.9-0.2,1.3-0.4c0.4-0.1,0.8-0.7,0.8-1.1c0.1-0.4,0.1-0.7,0.1-1.1c-0.5-0.4-0.5-0.9,0-1.5c-0.6-0.1-1.1-0.3-1.7-0.4
		c-0.2,0.6-0.5,1.2-0.7,1.7c-0.2-0.3-0.5-0.6-0.7-0.9c0.2-0.4,0.3-0.7,0.5-1.1c-0.7,0.1-1.2,0.1-1.8,0.2c0.5-0.6,0.9-1.3,1.5-1.8
		c0.7-0.5,1.6-0.9,2.3-1.3c0-0.4-0.1-0.8,0.1-1c0.1-0.2,0.6-0.1,0.9-0.2h0.1c0-0.6,0-1.2,0.1-1.7c-0.8,0.2-1.6,0.3-2.7,0.6
		c0.9-0.9,1.5-1.5,2.1-2.1c0.2-0.3,0.4-0.5,0.7-0.7c0-2.9-0.1-5.8-0.4-8.7c-0.1-1.5-0.3-3.1-0.6-4.6c-0.8-4.9-2-9.7-3.9-14.5
		c-0.1-0.2,0-0.4,0-0.6c0.2,0,0.3,0,0.5,0c1.9,4.9,3.2,9.8,4,14.8c0.3,1.7,0.5,3.4,0.6,5.1c0.3,2.7,0.4,5.4,0.4,8.2
		c0.5-0.3,1.1-0.5,1.7-0.8c0.2,0.7,0.3,1.4,0.5,2.3c-0.6-0.5-0.9-0.8-1.2-1s-0.7-0.2-0.9,0.1c0,1.2,0,2.4-0.1,3.6
		c0.4-0.1,0.7-0.2,1.2-0.3c0.1,0,0.4,0.2,0.8,0.5c0.4-0.2,0.9-0.5,1.4-0.7c-0.1-0.5-0.1-0.9-0.2-1.3c0.3,0.1,0.7,0.1,0.9,0.3
		c0.4,0.3,0.7,0.7,1,1c-1.6,0.4-2.9,1.2-3.9,3c1-0.5,1.8-0.8,2.4-1.3c1.2-0.9,1.9-1.2,3.3-1.4c0.1,0,0.1,0,0.2,0
		c0.1-4.5,0-8.9-0.5-13.4l0,0c0-0.1,0-0.2,0-0.3s0-0.2,0-0.3c-0.1-1.2-0.3-2.4-0.5-3.5c-0.2-1.3-0.4-2.6-0.7-3.8
		c-0.8-4.1-1.9-8.1-3.3-12.1c-0.1-0.3-0.2-0.7-0.2-1.1c0.2,0,0.3,0,0.5-0.1c1.6,4.2,2.7,8.5,3.6,12.8c0.3,1.5,0.6,3,0.8,4.5
		c0.2,1,0.3,2.1,0.4,3.1c0,0.2,0,0.4,0.1,0.6c0.5,4.4,0.6,8.9,0.5,13.5c0.8-0.2,1.3-0.7,2.1-1.9c0.9,0.3,1.3,1.3,2.5,1.1
		c0.2,0,0.4,0.4,0.5,0.7s0,0.6,0,0.9c0,0.1-0.1,0.2-0.1,0.4c0.1-0.1,0.2-0.2,0.3-0.3c0.1,0.1,0.3,0.2,0.3,0.3
		c-0.1,0.3-0.3,0.5-0.5,0.8c0.3,0,0.5,0,0.7,0c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.2-0.2,0.3-0.4,0.5c-0.1,0.3-0.2,0.7-0.2,1.1
		c0,0.1,0,0.1,0,0.2c0.1,0,0.2,0,0.2-0.1c0.1,0,0.3-0.1,0.5-0.1c0.1,0.3,0.3,0.6,0.4,0.8c0.2,0,0.3,0,0.4,0c0.3-0.3,0.6-0.5,1-0.8
		c0.3-0.2,0.6-0.5,0.9-0.7l0,0c0.6-0.5,1-0.9,0.6-1.5l-0.1-0.1c0,0,0.3-0.3,0.5-0.5c0.1,0.2,0.1,0.5,0.3,0.6c0.7,0.3,1.6,0,2.3-0.5
		c0.2-2.3,0.5-4.6,0.4-6.8c0-0.2,0-0.3,0-0.5c-1.1,0.6-1.5,1.5-1.4,2.6c0,0.1-0.1,0.3-0.2,0.5c-1.6,0.2-2.7,1-3.4,2.2
		c0,0.1-0.2,0.1-0.3,0.1c0-0.6-0.5-0.3-1-0.2C561.3,164.3,561.4,163.3,562.9,162.9z M549.7,164.7l0.1-0.1c0,0.1,0.1,0.1,0.1,0.2
		C549.8,164.7,549.8,164.7,549.7,164.7z M564.3,165.5c0.7-0.5,1.2-0.3,1.5,0.3c-0.5,0.5-1,1-1.6,1.5
		C564.3,166.7,564.3,166.1,564.3,165.5z M560.7,166l0.1-0.1l0.1,0.1C560.9,166.1,560.8,166.1,560.7,166
		C560.8,166.1,560.7,166,560.7,166z M560.8,168.2C560.8,168.2,560.8,168.3,560.8,168.2c0,0.1,0,0.1,0,0.1S560.8,168.3,560.8,168.2z
M561.9,165.7L561.9,165.7L561.9,165.7C561.9,165.7,561.8,165.7,561.9,165.7z"
      />
      <path
        class="st2"
        d="M430.4,138.1c0.4,1.7-1.4,1.1-2,2c2,0.3,3.9,0.7,5.9,1c0.3,0,0.6,0.1,0.8,0.1c3.4,0.6,6.8,1.2,10.3,1.7
		c0.5,0.1,1,0.2,1.6,0.3c2.9,0.5,5.7,1,8.6,1.5c0.7,0.1,1.4,0.2,2.2,0.4c0.1-0.1,0.2-0.2,0.2-0.3h-0.1c-0.4-0.1-0.7-0.3-1.2-0.4
		c0.9-0.6,1.4-1,2-1.4c-0.1-0.2-0.1-0.3-0.2-0.5c-0.9,0.2-1.9,0.4-2.9,0.6c-0.8-1.6-1.6-0.4-2.7,0.7c-0.5-0.9-1-1.7-1.6-2.7
		c-4.2-0.7-8.7-1.5-13.2-2.1c-2.3-0.3-4.7-0.5-7-0.7C430.9,138,430.7,138.1,430.4,138.1z"
      />
      <path
        class="st2"
        d="M409.6,212.8c0.2-0.1,0.4-0.3,0.5-0.4c0-0.4,0-0.8-0.3-1.2c-0.2-0.3-0.6-0.6-1.2-0.7c0,0-0.1,0-0.1-0.1
		c-0.3,0.2-0.6,0.5-0.9,0.7c0,0-0.1,0-0.1,0.1c-2.8,2.2-5.7,4.3-8.5,6.5c-0.9,0.7-1.8,1.4-2.7,2.1c-0.4,0.3-0.7,0.5-1.1,0.8
		c0.1,0.2,0.1,0.4,0.2,0.7c-0.7,0.3-1.3,0.5-2.1,0.8c-0.1,0-0.1,0.1-0.2,0.1l0,0c0.5,0.4,0.8,0.8,1.2,1.2c0.1,0.1,0.1,0.1,0.2,0.2
		c0.2,0.2,0.4,0.4,0.6,0.6c0.1-0.1,0.2-0.1,0.3-0.2l0.1-0.1c2.4-1.9,4.7-3.7,7.1-5.6C405,216.4,407.3,214.6,409.6,212.8z"
      />
      <path
        class="st2"
        d="M388,131.2c-0.3,0.1-0.5,0.1-0.8,0.2c-1.4,0.3-2.8,0.1-4.3-0.1c-0.4-0.1-0.8-0.1-1.2-0.2h-0.1
		c-0.4-0.1-0.9-0.2-1.3-0.2c-0.2,0-0.4-0.1-0.6-0.1c0.8-0.3,1.3-0.5,2.2-0.9c-1.1-0.2-2.1-0.3-3.1-0.5c-0.3,0-0.5-0.1-0.8-0.1
		c-1.5-0.3-3-0.5-4.5-0.8c-0.9-0.2-1.8-0.3-2.7-0.5c-0.5-0.1-1-0.2-1.5-0.3c0.1,0.4,0.2,0.8,0.3,1.2c-0.5,0.2-1,0.3-1.4,0.4
		c0.1,0.1,0.2,0.2,0.3,0.3c0.2,0.2,0.5,0.3,0.7,0.3l0,0c0.2,0,0.3,0,0.5,0.1c1.3,0.2,2.6,0.3,3.9,0.4c1.7,0.2,3.3,0.4,5,0.7
		c0,0,0,0,0.1,0c1,0.2,2,0.4,2.9,0.6h0.1c0.5,0.1,0.9,0.2,1.4,0.3c1.2,0.3,2.3,0.5,3.5,0.8h0.1c0.2,0,0.3,0.1,0.5,0.1
		c0.3,0.1,0.6,0.1,0.9,0.2c3.8,0.7,7.6,1.4,11.4,2c3.3,0.6,6.5,1.1,9.8,1.6c3,0.5,6,1,9.1,1.5c1.8,0.3,3.4,0.2,5-0.4
		c0.1-0.1,0.2-0.1,0.3-0.1c0.4-0.2,0.8-0.4,1.2-0.6c-0.1-0.2-0.1-0.4-0.2-0.5c-0.4-0.1-0.8-0.3-1.3-0.4c-3.7-0.5-7.3-1-11-1.6
		c-7.4-1.2-14.9-2.4-22.3-3.6C389.4,131,388.7,131.1,388,131.2z"
      />
      <path
        class="st2"
        d="M319.7,133.2c-0.1,0-0.1,0-0.2,0c-0.6,0-1.2-0.1-1.8-0.1h-0.1c0,0.1,0,0.1,0,0.2c0.2,0,0.4,0.1,0.6,0.1
		c0.3,0.1,0.6,0.1,0.9,0.2c0.2,0,0.3,0.1,0.5,0.1c0.4,0.1,0.7,0.2,1.1,0.2c0.4,0.1,0.8,0.2,1.1,0.2c0.4,0.1,0.7,0.2,1.1,0.2
		c0.2,0.1,0.5,0.1,0.7,0.2c3.1,0.7,6.3,1.3,9.5,2c-1-1.3-1.2-2.1-0.4-2.7c0.1,0,0.1-0.1,0.2-0.1c0.3-0.2,0.7-0.4,1.2-0.5
		c0.4-0.1,0.8-0.3,1.2-0.4c-0.8-0.1-1.6-0.3-2.4-0.4c-1-0.2-2.1-0.4-3.1-0.6c-0.4-0.1-0.7-0.1-1.1-0.2c-0.6-0.1-1.1-0.2-1.7-0.3
		c-0.5-0.1-0.9-0.1-1.4-0.2c-0.1,0-0.2,0-0.3,0c-1.4-0.1-2.9,0.1-4.3,0.1c0,0.2,0,0.3,0,0.5c0.5,0.2,1,0.4,1.5,0.6
		c0.1,0,0.1,0.1,0.2,0.1c0,0.1,0,0.1-0.1,0.2c0,0,0,0,0,0.1c-1.1-0.2-2.3-0.4-3.4-0.6l0,0c-0.4-0.1-0.9-0.1-1.3-0.2
		c0,0.2-0.1,0.3-0.1,0.5c0.3,0.1,0.5,0.1,0.8,0.2c0.4,0.1,0.7,0.2,1.1,0.2h0.1c0.1,0,0.3,0.1,0.4,0.1c0,0.1,0,0.2,0,0.3
		C319.9,133.2,319.8,133.2,319.7,133.2z"
      />
      <path
        class="st2"
        d="M313,142c-0.8-0.1-1.5-0.3-2.2-0.4c0-0.1,0-0.2,0-0.3c-0.3,0-0.6-0.1-1-0.1c0.7,0.5,1.4,1.1,2.2,1.6
		C312.9,143.5,313,142.8,313,142z"
      />
      <path
        class="st2"
        d="M442,119.6c-0.7-0.1-1.4-0.1-2.1-0.2c-1.7-0.2-3.4-0.3-5-0.5c-1.9-0.2-3.8-0.4-5.6-0.6c-0.2,0-0.4,0-0.6-0.1
		c-0.6-0.1-1.1-0.1-1.7-0.2c-2.3-0.2-4.6-0.5-6.9-0.7c-0.1,0-0.3,0-0.4,0c-0.3,0-0.7-0.1-1-0.1c-0.9-0.1-1.8-0.2-2.7-0.3
		c-0.2,0-0.4,0-0.6-0.1c-0.2,0-0.4,0-0.6-0.1c-0.5,0-0.9-0.1-1.4-0.1c-2.2-0.2-4.4-0.5-6.5-0.7c-2-0.2-4.1-0.1-6.1-0.5
		c-1.5-0.3-2.9-0.4-4.3-0.3c-0.4,0-0.8,0.1-1.2,0.1c-0.9,0.1-1.8,0.2-2.6,0.4c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3,0.1-0.5,0.1
		c0.1,0.1,0.2,0.1,0.2,0.2c0.2,0.3,0.4,0.5,0.7,0.6c0.9,0.2,1.8,0.4,2.7,0.5c0.2,0,0.3,0,0.5,0c0.3,0,0.6,0.1,1,0.1
		c0.7,0,1.3,0.1,2,0.1c0.1,0,0.2,0,0.3,0c0.4,0,0.8-0.1,1.1-0.2c0.3-0.1,0.6-0.1,0.9,0c0.2,0,0.5,0.1,0.7,0.2
		c0.6,0.1,1.1,0.3,1.7,0.4c0.2,0.1,0.4,0.1,0.6,0.2c1.1,0.3,2.3,0.6,3.4,0.8c0.1,0,0.3,0,0.4,0.1c2.3,0.4,4.6,0.6,7,0.9
		c0.8,0.1,1.6,0.2,2.5,0.2c0.6,0,1.1,0,1.7,0c1.3,0,2.7,0,4,0c0,0.1,0,0.2,0,0.3c-0.3,0.1-0.6,0.1-0.9,0.2c0.9,0.1,1.7,0.3,2.6,0.4
		c0.1,0,0.1,0,0.2,0c0.3,0,0.7,0.1,1,0.1c0.2,0,0.3,0,0.5,0.1c0.8,0.1,1.6,0.2,2.5,0.3c1.1,0.1,2.3,0.3,3.4,0.4
		c0.5,0.1,1,0.1,1.5,0.2c0.3,0,0.7,0.1,1,0.1c0.7,0.1,1.4,0.2,2.1,0.3c5.8,0.7,11.5,1.5,17.3,2.1c0.3,0,0.6,0,0.9,0s0.5-0.1,0.7-0.1
		c0.2-0.1,0.5-0.1,0.7-0.3c2.8-1.6,5.6-0.1,8.7-0.2c-1.1,0.6-1.9,0.9-2.6,1.3c0,0.1,0,0.2,0.1,0.3c6,0.7,12.1,1.5,18.1,2.2
		c0.5-2.2,1.6-2.6,3.5-1.5c0.3,0.2,0.8,0.1,1.2,0c1.4-0.1,2.1,0.8,1.8,2.2c0.3,0.1,0.7,0.2,1,0.2c5.6,0.7,11.3,1.4,16.9,2.1
		c1,0.1,2.2,0.5,3,0.1c1.9-1,3.5-2.4,5.4-3.9c-0.6-0.1-0.8-0.2-1.1-0.2c-14.9-1.5-29.8-2.9-44.7-4.4
		C459.3,121.3,450.7,120.5,442,119.6z"
      />
      <path
        class="st2"
        d="M567.4,169.3c0.6-0.2,1.3-0.3,1.9-0.5c0.2-0.1,0.5-0.1,0.7-0.2c-0.1-0.1-0.2-0.2-0.4-0.2
		c-0.6-0.4-1.3-0.5-2.1-0.4C567.5,168.4,567.4,168.8,567.4,169.3z"
      />
      <path
        class="st2"
        d="M410.3,114.9c-3.6-0.4-7.3-0.7-10.9-1.1c0,0.1,0,0.3,0,0.4c3.6,0.4,7.3,0.8,10.9,1.1
		C410.3,115.2,410.3,115,410.3,114.9z"
      />
      <path
        class="st2"
        d="M358,198.5c0.2-0.4,0-1.1-0.3-1.6c-0.2-0.3-0.9-0.6-1.2-0.5c-1.1,0.5-2,1.1-2.9,1.6c1,0.9,1.9,1.7,2.9,2.6
		C357,200,357.6,199.3,358,198.5z"
      />
      <path
        class="st2"
        d="M448.9,192.9c-0.1,0.2-0.2,0.4-0.2,0.6c0,0.7,0.4,1.3,0.7,2c0.3-0.2,0.6-0.5,0.9-0.7
		C450,194,449.9,193.2,448.9,192.9z"
      />
      <path
        class="st2"
        d="M566.5,171c-0.4,0-0.6,0-0.8,0.1c-0.4,0.1-0.8,0.2-1.1,0.3c-0.1,0-0.3,0.1-0.4,0.1c0,0,0,0.1,0.1,0.1l0,0
		c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.2,0.2,0.3,0.3c0.5,0.5,0.9,0.9,1.6,1.2C566.3,172.5,566.4,171.8,566.5,171z"
      />
      <path
        class="st2"
        d="M447.5,197c-0.2,0-0.3-0.1-0.4-0.1c-0.1-0.3-0.2-0.5-0.4-0.6c-0.3-0.3-0.8-0.4-1.3-0.5c-0.2,0-0.5-0.1-0.7-0.1
		h-0.1c0-0.1,0-0.1,0-0.2c0-0.2,0.1-0.4,0.2-0.5c-0.1,0.1-0.2,0.2-0.3,0.3c-1.2,1-2.3,2-3.5,3c-5.7,4.8-11.4,9.7-17.1,14.5
		c-0.3,0.3-0.8,0.4-1.2,0.5c0.1,0.2,0.3,0.4,0.4,0.5c0.1,0,0.1,0,0.2,0.1c0.5-0.1,1-0.5,1.5-0.9c2.6,1.3,4-0.8,5.7-1.8
		c0.1,0.1,0.2,0.2,0.3,0.3c4.1-3.5,8.2-7.1,12.3-10.6c0.5-0.4,1-0.9,1.5-1.3C445.6,198.7,446.6,197.9,447.5,197z"
      />
      <path
        class="st2"
        d="M387.5,216.4c-3.9-1.5-7.8-3.1-11.7-4.6c0,0.1-0.1,0.2-0.1,0.3c3.9,1.6,7.8,3.1,11.7,4.7
		C387.4,216.6,387.4,216.5,387.5,216.4z"
      />
      <path
        class="st2"
        d="M386.3,218.8c0.4,0.2,1.2,0,1.7-0.3c1.1-0.8,2.3-1.6,3.4-2.5c0.3-0.2,0.6-0.5,1-0.7l0,0
		c0.3-0.2,0.6-0.4,0.8-0.6c0.2-0.1,0.4-0.3,0.5-0.4c0.7-0.5,1.3-1,2-1.4c1.4-1,2.8-2.1,4.2-3.1c0.3-0.2,0.6-0.5,0.9-0.7
		c0.1-0.1,0.1-0.1,0.2-0.2c-0.6-0.3-0.8-0.6-0.7-0.9c-0.1,0-0.2-0.1-0.2-0.1c-0.6-0.2-1.1-0.4-1.7-0.6c-12.9-4.6-25.9-9.2-38.9-13.8
		c-0.2-0.1-0.3-0.1-0.5-0.2c-0.4-0.1-0.8-0.3-1.2-0.4c-17.4-6.2-34.7-12.3-52.1-18.4c-4.5-1.6-9-3.2-13.6-4.8
		c-12.3-4.3-24.5-8.7-36.8-13c-0.8-0.3-1.6-0.6-2.4-0.9c-1.8-0.6-3.7-1.3-5.5-1.9c-0.9-0.3-1.7-0.6-2.6-0.9
		c-2.2-0.8-4.5-1.6-6.7-2.4c-0.6-0.2-1.3-0.2-1.9-0.2c0,0.1,0,0.3-0.1,0.4c0.7,0.3,1.5,0.7,2.2,1c-2.1,0.5-3.8-1.7-6-0.3
		c1,0.4,1.9,0.8,3.2,1.3c-2.4,0.6-4-1.9-6.3-0.7c1,0.4,1.8,0.8,3,1.3c-2.2,0.6-3.6-1.7-5.8-0.7c1.1,0.5,1.9,0.9,2.8,1.3
		c-0.1,0.2-0.1,0.3-0.2,0.5c-0.8-0.3-1.7-0.6-2.5-0.9c-0.3-0.1-0.5-0.2-0.8-0.3c-0.4-0.1-0.7-0.3-1.1-0.4c-0.1,0.2-0.1,0.3-0.2,0.5
		c0.7,0.3,1.3,0.5,2,0.8c0.1,0,0.1,0.1,0.2,0.1c26.3,10.7,52.6,21.3,79,32c12.1,4.9,24.2,9.8,36.4,14.8c-0.5-2.9,0.5-4.7,2.3-5
		c0.4,0.6,0.7,1.1,1,1.7c0.5,0.8,1,1.7,1.6,2.5c-0.5,0.3-1,0.7-1.5,1.1c0.4,0.1,0.7,0,1-0.2c0.5-0.5,1.1-0.8,1.6-1
		c1-0.4,2.1-0.2,3.3,0.6c0.2,0.1,0.4,0.2,0.7,0.3c0.5,0.2,1,0.3,1.5,0.4c0.1,0,0.2,0.1,0.3,0.1c0.4,0.1,0.8,0.3,1.1,0.4
		c0,0.2,0.1,0.4,0.1,0.6c-0.4,0.2-0.9,0.4-1.3,0.5c-0.7,0.3-1.3,0.5-2,0.8c-0.4,0.2-0.7,0.3-1.1,0.4c0.1,0.1,0.3,0.2,0.5,0.3
		C363,209.3,374.7,214.1,386.3,218.8z M385.8,205c3.9,1.4,7.8,2.9,11.6,4.3c0.2,0.1,0.3,0.2,0.5,0.3c0,0.2,0,0.4,0,0.6
		c-0.7,0.1-1.5,0.4-2,0.2c-2.1-0.8-4.3-1.6-6.4-2.4c-0.4-0.1-0.7-0.3-1.1-0.4c-1.3-0.5-2.6-1-3.9-1.5c-0.2-0.1-0.4-0.2-0.6-0.8
		C384.6,205.2,385.3,204.8,385.8,205z M382,207.3c1.4,0.5,2.7,1,4.1,1.6c0.5,0.2,1,0.4,1.4,0.5c2.3,0.9,4.6,1.8,6.9,2.6l0,0
		c0,0.2,0,0.4,0,0.6c-0.3,0.1-0.6,0.2-0.9,0.3s-0.6,0.1-0.8,0c-1.4-0.5-2.7-1.1-4.1-1.6c-0.9-0.4-1.9-0.8-2.8-1.2
		c-1.6-0.7-3.2-1.3-4.7-2c-0.2-0.1-0.3-0.2-0.7-0.6C381.1,207.5,381.6,207.2,382,207.3z M379.4,209c4.1,1.5,8.2,3.2,12.3,4.8
		c0.1,0,0.1,0.1,0.4,0.5c-0.7,0.2-1.4,0.6-1.8,0.5c-4.1-1.5-8.2-3.2-12.3-4.8c-0.1,0-0.1-0.1-0.4-0.5
		C378.3,209.3,379,208.8,379.4,209z M376.2,211.2c4.1,1.5,8.1,3.2,12.1,4.8c0.1,0.1,0.2,0.2,0.8,0.6c-1,0.3-1.8,0.7-2.3,0.5
		c-4-1.5-8-3.2-12-4.8c-0.2-0.1-0.3-0.2-0.5-0.3c0-0.2,0-0.4,0-0.5C374.9,211.4,375.7,211,376.2,211.2z M251.5,159
		c-0.4,1.1-2.2,2-3.7,1.9s-2.5-0.7-2.9-2.2c-0.4-1.3-0.8-1.4-2-0.6c-1.8,1.3-1.8,1.2-3.5-0.9c2.3-0.8,4.5-1.5,6.7-2.1
		c0.3-0.1,0.6,0,0.9,0.2h0.1c0,0,0,0,0,0.1c0.3,0.1,0.5,0.2,0.8,0.3c-0.4,0.4-0.6,0.6-0.7,0.8c-0.3,0.6-0.6,1.2-0.8,1.8
		c0.2,0,0.4,0.1,0.7,0.2c0.6,0.2,1.2,0.3,1.8,0.3c0.5,0,0.9-0.5,1.3-0.8c0.1,0,0.1-0.1,0.2-0.1c0.3-0.1,0.9-0.1,1.1,0.1
		C251.6,158.2,251.6,158.7,251.5,159z M264.3,168.7c-2.2-0.8-4.4-1.8-6.6-2.8c0-0.2,0-0.3,0-0.5c0.6-0.1,1.2-0.3,1.6-0.2
		c2.2,0.8,4.4,1.8,6.6,2.7c0,0.2,0,0.3,0,0.5C265.4,168.5,264.7,168.8,264.3,168.7z M269.3,167.4c-0.8,0-1.7,0.2-2.4,0
		c-2.1-0.7-4.1-1.6-6.1-2.7c0.6-0.1,1.2-0.5,1.7-0.3c2.3,0.7,4.6,1.6,6.9,2.4C269.3,166.9,269.3,167.1,269.3,167.4z M263.8,163.8
		c3.2-0.4,5.8,1.6,8.9,2.2C271.3,167,266.5,165.7,263.8,163.8z M274.1,165.6c-2.3-0.8-4.6-1.7-6.9-2.5c1.1-0.8,5.8,0.4,8.7,2.3
		C275.2,165.5,274.6,165.7,274.1,165.6z M316.1,188.2c-0.5,0.1-1,0.5-1.4,0.3c-2.9-1-5.8-2.1-8.7-3.2c-0.1,0-0.2-0.1-0.3-0.1
		c0-0.2,0-0.3,0-0.5c0.1,0,0.2,0,0.2-0.1c0.4-0.1,0.8-0.3,1.1-0.2c3,1.1,6.1,2.2,9.1,3.3C316.1,187.9,316.1,188,316.1,188.2z
M318.3,187c-3-1.1-5.9-2.3-8.8-3.4c0-0.2,0-0.3,0.1-0.5c0.5,0,1.1-0.2,1.5-0.1c2.9,1,5.7,2.1,8.6,3.2c0,0.1,0,0.3,0,0.4
		C319.3,186.8,318.7,187.1,318.3,187z M322.7,185.6c-0.5,0.1-1.2,0.3-1.6,0.2c-2.9-1.1-5.7-2.2-8.5-3.3c0-0.1,0-0.3,0-0.4
		c0.5-0.1,1.1-0.4,1.5-0.2c2.9,1,5.8,2.2,8.7,3.3C322.7,185.3,322.7,185.4,322.7,185.6z M324.7,184.2c-2.8-0.9-5.5-2-8.3-3
		c-0.2-0.1-0.3-0.2-0.7-0.5c0.8-0.2,1.3-0.4,1.7-0.3c3,1,6.1,2.1,9.1,3.2c0,0.1,0,0.3,0,0.4C325.9,184.1,325.2,184.4,324.7,184.2z
M345.9,195.6c2-2.4,7.5-2.4,9.8-0.1c-0.8,0.4-1.5,0.9-2.3,1.3c-0.8,0.5-1.7,1-2.6,1.5c-0.3-0.5-0.6-0.9-0.9-1.2
		C348.9,196.1,347.5,195.6,345.9,195.6z M351.7,198.7c-0.1,0-0.2-0.1-0.3-0.1c0.7-0.4,1.3-0.8,1.9-1.1c1.1-0.7,2.2-1.3,3.3-1.8
		c1.1-0.4,2.6,1.7,2,2.9c-0.6,1.3-1.6,2.3-2.6,3.8c-0.2-0.5-0.4-0.9-0.5-1.2c-0.1-0.2-0.1-0.3-0.2-0.4
		C354.6,199.6,354,199.4,351.7,198.7z"
      />
      <path
        class="st2"
        d="M467.3,85c5.6,0.3,11.2,0.6,16.8,0.9c0.6,0,1.2,0.1,1.8,0.1c2.1,0.1,3.2-0.7,3.7-2.9c-1.2-0.1-2.5-0.1-3.7-0.2
		c-2.9-0.2-5.8-0.3-8.6-0.5c-0.6,0-1.3-0.1-1.9-0.1c-1.9-0.1-3.7-0.2-5.6-0.3c-2.7-0.1-3.1,0.1-4.4,2.9C466,84.9,466.6,85,467.3,85z
		"
      />
      <path
        class="st2"
        d="M477.1,153.4c1.4-0.9,2.7-1.9,4-2.8c-7.5-1.4-15-2.7-22.5-4c-1.6-0.3-3.2-0.6-4.8-0.8
		c-3.6-0.6-7.2-1.3-10.8-1.9c-0.2,0-0.4-0.1-0.6-0.1c-2.6-0.5-5.2-0.9-7.8-1.4c-0.3,0-0.5-0.1-0.8-0.1c-2.1-0.4-4.3-0.7-6.4-1.1
		c-1.9-0.3-3.8-0.6-5.7-1c-11.6-2-23.2-3.9-34.8-5.9c-0.3,0-0.5-0.1-0.8-0.1c-0.5-0.1-1-0.2-1.5-0.3c-0.1,0-0.2,0-0.3,0
		c-0.1,0-0.2,0-0.4-0.1c-0.4-0.1-0.7-0.1-1.1-0.2c-2.1-0.3-4.1-0.7-6.2-1c-0.5-0.1-0.9-0.2-1.4-0.2c-2.1-0.4-4.2-0.7-6.2-1.1
		c-0.2,0-0.5-0.1-0.7-0.1c-0.8-0.1-1.6-0.3-2.3-0.4c-1.1-0.2-2.3-0.4-3.4-0.6c-6.6-1.1-13.3-2.3-19.9-3.4c-0.2,0-0.5-0.1-0.7-0.1
		l0,0l0,0c0,0.1-0.1,0.3-0.1,0.4c0.2,0.1,0.5,0.2,0.7,0.3c0.2,0.1,0.3,0.1,0.5,0.2c-0.2,0.1-0.4,0.1-0.6,0.2
		c-0.7,0.3-1.3,0.5-1.9,0.5c-1,0-1.9-0.4-2.9-0.7c0.9,0.9,1.9,1.4,3,1.6c1.5,0.4,3.1,0.5,4.6,0.8c2.7,0.6,5.4,1,8.1,1.5
		c0-0.1,0-0.2,0.1-0.3c-1.1-0.3-2.2-0.6-3.4-0.9c0.5-1.2,1.3-1.1,2.2-0.8c1.3,0.5,2.6,1.3,3.9-0.1c0.3,0.5,0.5,0.7,0.6,1.1
		c0.4,1.5,1.4,2.1,2.9,2.2c0.8,0,1.5,0.2,2.3,0.3c0.7,0.1,1.4,0.2,2,0.4c1.7,0.3,3.5,0.6,5.3,0.5h0.1c0.7-0.1,1.4,0,2.2,0.2
		c0.9,0.2,1.8,0.5,2.8,0.8c0.7,0.2,1.4,0.5,2,0.7c1,0.3,2,0.6,3.1,0.8c2.7,0.6,5.4,1,8.1,1.4c0.6,0.1,1.3,0.2,1.9,0.3
		c1.1,0.2,2.2,0.4,3.4,0.6c4.6,0.8,9.2,1.6,13.8,2.4c3.6,0.6,7.2,1.3,10.8,1.9c0-0.1,0-0.1,0-0.2c-1.3-0.3-2.7-0.6-4-1
		c0-0.2,0.1-0.3,0.1-0.5c2.5,0.5,5.1,1,7.9,1.6c-0.5,0.3-0.7,0.4-1.1,0.6c6.9,1.2,13.6,2.4,20.3,3.6c0.3,0.1,0.7,0.1,1,0.2
		c0.8,0.1,1.6,0.3,2.4,0.4c-0.3-0.8-0.5-1.4-0.7-2c0.1,0,0.2-0.1,0.3-0.1c1,0.8,2,1.5,3.1,2.3c0.2-0.2,0.5-0.6,0.5-0.6
		c1.6,0.1,2.9,0.3,4.1,0.4l0,0c-0.7-0.4-1.5-0.9-2.3-1.4c0.7-1.2,1.7-0.7,2.6-0.2s1,1.2,0.5,2.1l0,0c0,0.1-0.1,0.1-0.1,0.2l0,0
		c-0.2-0.1-0.3-0.3-0.4-0.4c-0.1-0.1-0.2-0.2-0.3-0.3l0,0l0,0l0,0l0,0c0,0,0,0-0.1,0v0.1c-0.1,0.2-0.3,0.4-0.4,0.6
		c-0.1,0.2-0.2,0.3-0.3,0.5c0.3,0.1,0.7,0.2,1,0.2c5.8,0.9,11.7,1.8,17.5,2.8c2.3,0.4,4.5,1,6.8,1.6
		C476.4,153.5,476.9,153.6,477.1,153.4z M378,134.7c-0.7-0.1-1.4-0.3-2.1-0.4c-1.2-0.3-2.5-0.5-3.8-0.8c-0.3-0.1-0.6-0.1-0.9-0.2
		c0.4-0.2,0.8-0.4,1.2-0.5c2.3-0.7,4.3,0.5,6.3,0.9c-1.5-0.2-3.1-0.5-4.6-0.7c0,0.1,0,0.3-0.1,0.4c1.4,0.3,2.7,0.6,4.1,0.8
		c0,0.1-0.1,0.3-0.1,0.4C378,134.6,378,134.6,378,134.7z M417.5,140c1.4,0.2,2.9,0.5,4.3,0.7c1,0.2,2,0.4,3,0.5
		c0,0.2-0.1,0.4-0.1,0.5c-0.9-0.2-1.8-0.3-2.8-0.5c-1.5-0.3-3-0.5-4.5-0.8C417.5,140.4,417.5,140.2,417.5,140z M422.4,142.6
		c-2.4-0.5-4.8-1-7.2-1.5c0-0.2,0.1-0.4,0.1-0.5c2.4,0.5,4.8,1,7.2,1.5C422.5,142.3,422.4,142.4,422.4,142.6z M447.9,146.7
		c-1-0.4-2-0.7-2.9-1c0-0.1,0-0.2,0-0.3l0,0c0.1,0,0.2,0,0.3,0c1.1,0,2.3,0,3.4,0c0,0.1,0.1,0.3,0.1,0.4l-0.1,0.1l-0.1,0.1
		C448.4,146.3,448.1,146.5,447.9,146.7z"
      />
      <path
        class="st2"
        d="M400.9,112.2c-1.9,0-3.8-0.3-5.7,0.1c-0.1,0-0.2,0-0.2,0c0.1,0.2,0.2,0.4,0.2,0.6c-0.8,0.1-1.5,0.3-2.3,0.4
		c-0.1-0.2,0-0.4,0.1-0.6c-0.5,0.1-1.1,0.2-1.6,0.3c-1.6,0.3-3.1,0.6-4.7,0.9c-0.4,0.4-0.4,1-0.2,1.6c0.1,0,0.2-0.1,0.2-0.1
		c0.6-0.2,1.2-0.4,1.8-0.3c0.4-0.1,0.8-0.2,1.2-0.3c0.4-0.1,0.7-0.2,1.1-0.2c3.4-0.8,6.8-1.5,10.2-2.3
		C400.9,112.3,400.9,112.2,400.9,112.2z"
      />
      <path
        class="st2"
        d="M546.6,174c0,0.3-0.1,0.6-0.1,0.9c0.1,0,0.2,0.1,0.2,0.1C546.7,174.6,546.7,174.3,546.6,174z"
      />
      <path
        class="st2"
        d="M464.9,78.8c0.3,0.2,0.5,0.3,0.8,0.5c0.2-0.2,0.4-0.5,0.6-0.7C465.9,78.5,465.3,78.3,464.9,78.8z"
      />
      <path
        class="st2"
        d="M566.8,168.1c-0.8,0.3-1.4,0.7-1.8,1.3c-0.2,0.2-0.3,0.4-0.4,0.6l-0.1,0.1c0.5-0.2,1-0.3,1.6-0.5
		c0.3-0.1,0.7-0.7,0.8-1C566.7,168.5,566.8,168.3,566.8,168.1z"
      />
      <path
        class="st2"
        d="M565,182.3L565,182.3c0.2-0.9,0.3-1.8,0.5-2.7c0-0.2,0.1-0.4,0.1-0.6c0.1-0.9,0.2-1.7,0.4-2.6
		c-0.7,0.3-1.3,0.6-2,0.9c-0.2-0.2-0.6-0.5-0.9-0.9c0.1-0.1,0.1-0.3,0.3-0.4c0.4-0.3,0.6-0.7,0.6-1.1c0-0.2,0-0.3-0.1-0.5
		c-0.3-0.5-1-0.8-1.6-0.7c-0.8,0.1-1.2,0.6-1.3,1.2c-0.3,1.1-0.3,1.2-0.7,1.6c0,0,0,0.1-0.1,0.1c0-0.1-0.1-0.1-0.1-0.2
		c-0.2-0.3-0.3-0.5-0.5-0.8c-0.1,0-0.3,0.1-0.4,0.2c-0.4,0.2-0.6,0.4-0.6,0.7c0,0.1,0,0.1,0,0.2c0,0.2,0.4,0.3,0.8,0.6
		c-0.1,0.2-0.3,0.5-0.6,0.8c0.1,0.1,0.2,0.3,0.4,0.5l0.1,0.1c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.1-0.2,0.1-0.3,0.2
		c-0.5,0.2-1,0.4-1.5,0.6c-0.5,0.2-1,0.5-1.2,1c0,0,0,0.1-0.1,0.1c0.1,0,0.4,0,0.7,0c-0.1,0.2-0.3,0.5-0.4,0.7c0.4,0,0.8,0,1.2,0.1
		c-0.4,0.3-0.7,0.6-1.1,0.9c0.2,0.3,0.4,0.6,0.7,0.7c0.2,0.1,0.6,0,0.8-0.1c0.1,0,0.1-0.1,0.1-0.1c0.2-0.8,1-1.3,1.4-2l0.1-0.1
		c0.1-0.2,0.1-0.4,0.1-0.7v-0.1l0,0c1.4,0.5,2.5-0.2,3.6-0.9c0.2,0.8,0.4,1.4,0.6,2.1c0.1,0.2,0.1,0.4,0.2,0.6
		c0.1,0,0.1,0.1,0.2,0.1C564.2,182,564.5,182.1,565,182.3C564.9,182.3,565,182.3,565,182.3z"
      />
      <path
        class="st2"
        d="M432.5,214.4c0.7,1.4,0.5,3,0.7,4.8c1.1-0.9,1.1-1.8,0.8-2.7c-0.4-1.1-0.9-2.2-1-3.4V213
		c-0.3,0.3-0.6,0.6-0.9,0.8c-0.1,0.1-0.3,0.2-0.4,0.4c0.1,0,0.2,0.1,0.3,0.1C432.1,214.3,432.3,214.3,432.5,214.4z"
      />
      <path
        class="st2"
        d="M433.7,224.3c0.1-0.3,0.2-0.6,0.3-1c-0.3-0.1-0.6-0.2-1.1-0.4c-0.1,0.9-0.7,1.4-1.6,1.2
		c-1-0.2-1.6,0.3-2.4,0.9c-0.5-0.4-1-0.7-1.6-1.1c-0.2,0.1-0.5,0.1-0.8,0.2c-0.2,0-0.3,0.1-0.5,0.1c0-0.3,0-0.4,0-0.6
		c-0.5,0-1.4,0.5-1-0.6c-1,0.8-1,0.8-3.6,0.8c0.3-0.4,0.6-0.8,0.9-1.1c-0.2-0.1-0.4-0.2-0.6-0.3c-0.3-0.2-0.6-0.4-0.9-0.7
		c0.4-1.2,0.4-1.2,1.8-1.8c-0.1-0.7,0-1.5-1.3-1.6c-0.6-0.1-0.7-0.5-0.6-0.9c0.1-0.3,0.2-0.6,0.4-0.9c-2.1-0.4-2.4,1.3-3.7,1.9
		c-0.1-0.3-0.2-0.6-0.3-0.9c-0.6-1.5-0.8-1.6-3-1.3c0.9-0.7,0.5-1.6,0.1-1.9c-0.2-0.2-0.3-0.3-0.3-0.4c-0.3-0.1-0.7-0.2-1-0.3
		c-0.9-0.3-1.6-0.3-2.4,0.3c-1.9,1.5-3.8,3-5.7,4.5c-2,1.6-4.1,3.2-6.1,4.8c-0.7,0.6-1.4,1.1-2.2,1.7c0.2,0,0.4,0.1,0.6,0.1
		c0.4-0.4,1.1-0.9,1.5-1.5c0.1-0.1,0.2-0.2,0.2-0.3c0.6-0.6,1.5-0.6,2.3-0.8c0.5,0.7,0.7,1.3,0.1,1.9c-0.1,0.1-0.3,0.3-0.5,0.4
		c-0.4,0.3-0.7,0.8-0.7,1.2c-0.1,0.7,0,1.4,0,2.2c0,0.2,0,0.4,0,0.6c0.9-0.2,1.6-0.4,2.4-0.7c0,0.2,0,0.4,0,0.6c0,0.4,0,0.7,0,1.1
		c0.6-0.1,1.1-0.2,1.6-0.3c-0.2,0.7-0.3,1.5-0.6,2.5c-0.6,0.3-1.4,0.6-2.3,1c0,0.2,0,0.4,0.1,0.7c0,0.3,0.1,0.6,0.1,0.9v0.1
		c0.1,1.1,0.7,2,2,2.3c1.1,0.3,2.6-0.1,3.4-0.9c0.9-1,1.1-2,0.4-3c-0.1-0.2-0.2-0.3-0.4-0.5c0.9-0.9,2.3-0.7,3.4-1.2
		c0.5-0.6,1.1-1.2,1.3-1.8c0.3-0.8,0-1.6-0.7-2.2c-0.3-0.2-0.5-0.4-1-0.8c1,0.1,1.6,0.3,2.2,0.3s0.8-1,1.8-0.7
		c-0.1,0.4-0.2,0.8-0.3,1.2c0.3,0.3,0.5,0.6,0.9,0.9c0.2,0.1,0.5,0.2,0.8,0.1c1.3-0.2,1.3-0.2,1.6,0.7c0,0.1,0.1,0.2,0.2,0.3
		c0,0,0.1,0.1,0.2,0.2c0,0,0.1,0.1,0.2,0.1l0.1-0.1c0.1-0.3,0.3-0.5,0.4-0.8c0.1,0,0.1,0,0.2,0c0.4,0,0.8,0.1,1.3,0.1
		c0.3-0.3,0.7-0.5,1.1-0.8c0.2,0.1,0.3,0.2,0.4,0.3c0.7,1.3,0.7,1.3,2.2,1.2c0.3,0.6,0.6,1.2,0.9,1.9c1-1.1,2.2-0.5,3.2-1
		c0.3-0.1,0.9-0.1,1.2,0.1c0.8,0.7,1.8,0.3,2.8,0.6c-0.1-0.4-0.2-0.7-0.3-1c0.8-0.1,1.5-0.1,2.2-0.2c-0.2-0.4-0.5-0.7-0.8-1.2
		c0.8-0.3,1.5-0.7,2.2-0.9c-0.5-0.2-1-0.3-1.4-0.6s-0.5-0.7-0.9-1.3c0.4,0,0.6,0,0.9,0.1s0.7,0.3,1,0.3c0.2,0,0.5-0.2,0.6-0.3
		s0.1-0.4-0.1-0.5C434.4,224.7,434,224.5,433.7,224.3z M409,225.7c-0.1,0.2-0.1,0.6-0.3,0.6c-0.4,0.1-0.8,0-1.1,0c0,0,0,0-0.1,0
		c-1,0.6-1.5,1.5-2.3,2.2c-0.3,0.3-0.7,0.5-1.2,0.7c0.1-0.3,0.2-0.6,0.3-0.9c0.2-0.5,0.3-1,0.5-1.5c0.4-0.9,0.3-1.7-0.2-2.5
		c0.9,0,1.6-0.1,2.1,0C407.7,224.4,408.2,224.7,409,225.7c0.1-0.1,0.1-0.2,0.2-0.3c0.1,0,0.1,0.1,0.2,0.1
		C409.3,225.6,409.2,225.6,409,225.7z"
      />
      <path
        class="st2"
        d="M473.7,174.4c0.1-0.1,0.3-0.2,0.4-0.4c0.1-0.1,0.1-0.1,0.2-0.2c0.3-0.2,0.6-0.5,0.9-0.7
		c2.1-1.8,4.2-3.7,6.3-5.5c7-6,13.9-12,20.9-18c1.7-1.4,3.3-2.9,5.1-4.6c-2-0.5-3.6-0.8-5,0.8c-0.7,0.8-1.5,1.4-2.3,2
		c-7.2,6.1-14.3,12.2-21.5,18.3c-1.9,1.6-3.8,3.2-5.6,4.8c-0.8,0.7-1.7,1.4-2.5,2.2c-1.2,1-2.4,2.1-3.6,3.1c0,0,0,0-0.1,0
		c-0.2,0.2-0.4,0.4-0.6,0.5c-4.2,3.6-8.4,7.1-12.5,10.7c-0.5,0.4-1,0.8-1.4,1.2c0.3,0.1,0.5,0.4,0.4,0.8c0,0.1,0,0.1-0.1,0.2
		c-0.2,0.5-0.3,1-0.5,1.5c-0.3,0.6-0.6,1.3-0.8,1.9c-0.2,0.4-0.3,0.8-0.5,1.3c6.9-5.9,13.7-11.9,20.6-17.8
		C472.1,175.8,472.9,175.1,473.7,174.4z"
      />
      <path
        class="st2"
        d="M523.4,194.6c1.5-3.4,2.8-6.8,3.9-10.2c0.4-1.3,0.8-2.6,1.2-3.9c0-0.1,0.1-0.2,0.1-0.4c-0.1,0-0.2,0-0.3,0
		c-0.2,0-0.4-0.1-0.6-0.1c-0.3,0.2-0.6,0.5-0.9,0.7c-0.5-0.2-1.1-0.4-1.7-0.7c-0.2,0.5-0.3,0.9-0.5,1.4c-0.6-0.2-1.1-0.3-1.5-0.4
		c0.2-0.1,0.4-0.2,0.7-0.4c-0.5-0.1-0.8-0.2-1.1-0.3v-0.1c0.5-0.3,1.1-0.7,1.6-1c0.1-0.1,0.4,0.2,0.7,0.4c0.2-0.1,0.4-0.1,0.5-0.2
		c0.6-1.2,0.3-1.2,1.9-1.3c0.4,0,0.7-0.1,1.1-0.2c0.2,0.3,0.3,0.6,0.5,0.8c2.8-11,3.6-22.2,2.1-33.6c0-0.1,0-0.2,0-0.3
		c-0.2-1.1-0.3-2.1-0.5-3.2c-0.1-0.6-0.2-1.3-0.4-1.9c-0.3-1.5-0.6-2.9-1-4.4c-0.3-1-0.5-2.1-1-3.1c-1.7-3.3-1.3-6.8-1-10.2
		c0-0.5,0.6-1.2,1.1-1.5c0.1-0.1,0.2-0.1,0.3-0.2c0.3-0.2,0.6-0.4,0.9-0.6c9.5-5.9,19-11.8,28.6-17.6c0.5-0.3,0.9-0.6,1.4-0.9
		c-0.4-1.2-0.8-2.3-1.2-3.5c0.1-0.1,0.3-0.1,0.4-0.2c0.5,1,0.9,2.1,1.5,3.2c6.2-3.8,12.2-7.5,18.3-11.3c0-0.1,0-0.2,0-0.3
		c-1.4-0.2-2.8-0.4-4.2-0.6c-0.3,0-0.7-0.1-1-0.1c0,0,0,0-0.1,0c-3.7-0.5-7.3-0.9-11-1.4c-0.6-0.1-1.3-0.2-1.9-0.2
		c-2-0.3-4.1-0.5-6.1-0.8c-1.1-0.1-2.2-0.3-3.4-0.4c-6.8-0.9-13.6-1.7-20.3-2.6c-1.1-0.1-1.6,0.4-2,1.3c0.4,0.1,0.8,0.2,1.3,0.4
		c-0.2,0.2-0.2,0.4-0.3,0.4c-2.3-0.4-3,1.4-3.9,2.9c0,0,0,0.1-0.1,0.1c-0.3,0.4-0.7,0.7-1,1c-0.1,0.1-0.2,0.2-0.2,0.3
		c-1.9,2.4-3.8,4.9-6,7.5c2.1,0.2,3.9,0.3,5.6,0.4c0,0.2,0,0.4,0,0.6c-1.1-0.1-2.1,0-3.2-0.2c-2-0.3-3.7-0.1-4.6,2
		c-0.3,0.5-0.7,1-1.1,1.4c-2.7,2.3-2.6,5.3-2.2,8.7c1.8-0.9,3.6-1.8,5.4-2.7c3.9-2,7.8-4,11.7-5.9c0.7-0.4,1.7-0.5,2.5-0.4
		c2.7,0.3,5.4,0.7,8.2,1.1c0.5,0.1,1,0.5,1.5,0.8c-0.5,0.2-1.1,0.5-1.6,0.4c-2.6-0.3-5.2-0.7-7.9-1c-0.8-0.1-1.8,0.1-2.5,0.4
		c-5.5,2.7-11,5.6-16.5,8.3c-0.8,0.4-1.9,0.6-2.8,0.6c-6.8-0.5-13.7-1-20.5-1.5c-1.4-0.1-2.8-0.2-4.2-0.3c-4-0.3-7.9-0.6-11.9-0.9
		c-0.4,0-0.9,0.3-1.3,0.5c-0.5,0.1-1,0.4-1.5,0.3c-1.7-0.1-3.3-0.3-5.1-0.4c-0.1,2.8-0.2,5.6-0.4,8.4c2.4,0.2,4.6,0.5,6.8,0.7
		c5,0.5,10,1,14.9,1.4c0.4,0,0.8,0.1,1.2,0.1c10.8,1,21.6,2.1,32.4,3.1c0.6,0.1,1.2-0.2,1.8-0.5c0.5-0.2,0.9-0.6,1.4-0.9
		c0.1,0.1,0.2,0.2,0.3,0.3c-0.3,0.4-0.6,0.7-1,1.1c1.3,1,0.3,1.5-0.4,2.1c-7,5.6-14.1,11.1-21.1,16.7c-0.3,0.3-0.7,0.6-1.3,1.1
		c2.1,0.3,3.9,0.5,5.8,0.8c0.2,0,0.3,0.1,0.5,0.1c0.5,0.1,1,0.2,1.5,0.4c0.4,0.1,0.8,0.3,1.2,0.4c-0.6,0.7-1.1,1.4-1.8,2
		c-0.1,0.1-0.2,0.2-0.3,0.3c-0.2,0.2-0.4,0.4-0.7,0.6c-1.2,1.1-2.4,2.1-3.6,3.2c-0.3,0.2-0.5,0.5-0.8,0.7c-0.4,0.3-0.8,0.7-1.1,1
		l0,0c-5.8,5.2-11.7,10.4-17.5,15.5c-2.3,2.1-4.7,4.2-7,6.3c-0.4,0.3-0.7,0.6-1.1,1c-1.5,1.3-2.9,2.6-4.4,3.9
		c-2.4,2.1-4.8,4.3-7.2,6.4c-0.2,0.2-0.4,0.4-0.6,0.5c-1.6,1.5-3.3,2.9-4.9,4.4c0.2,0.1,0.3,0.2,0.4,0.3c0.3,1.1,1.2,1.7,2.6,1.9
		c-1,1.7-2.2,3.3-1.3,5.2c-0.5,0.1-0.9,0.2-1.4,0.3c-1.7,0.5-2.7,1.8-2.5,3.2c0.1,1.2,1.4,2.1,2.9,2.2c1.6,0.1,3-0.8,3.5-2.2
		c0.1-0.3,0.2-0.7,0.3-1.1c0.6-0.1,0.9,0.1,0.9,0.6c0,0.8,0.1,1.5,0.1,2.4c-1.3,0.5-2.5,1.3-3,2.8c-0.4-0.5-0.7-0.8-1-1.1
		c-0.1,0-0.3-0.1-0.4,0c-1.7,0.6-2.9,0.4-3.8-0.7c-0.1-0.2-0.2-0.4-0.4-0.5c-1.2-1.3-3.4-1.5-5.1-0.5c-1.6,1-2.1,2.8-1.1,4.2
		c0.2,0.3,0.5,0.5,0.8,0.8c-0.4,1.4-1,2.9-0.7,4.4c0.1,0.4,0.2,0.7,0.4,1.1c-1.4,0.7-2.5,1.7-2.1,3.2c0.3,0.9,1,1.5,2.1,1.6
		c1.6,0.2,2.7-0.5,3.4-1.6c1.7-0.2,3.3-0.3,5-0.5c0.1,0.7,0.1,1.5,0.2,2.3c0.1,0.1,0.2,0.1,0.3,0.2c0,0-0.1,0.1-0.1,0.2
		c-0.1-0.1-0.1-0.2-0.2-0.3c-0.5-0.1-0.9-0.2-1.4-0.3c-2.3-0.4-4.6,0.8-5.2,2.7c-0.6,2,0.8,3.7,3.1,4c0.4,0,0.8,0,1.5,0.1
		c-0.8,1.6-1.1,3.1-0.1,4.5s2.5,2,4.5,2.1c-0.3,1.2-0.4,2.4,0.3,3.5c1.1,1.6,2.8,2.4,5,2.3c2.1-0.1,3.8-1.1,4.9-2.7
		c0.2-0.3,0.4-0.6,0.6-0.9c0.1-0.6,0.1-1.2,0.2-1.9c1.8,0,3.6-0.2,4.9-1.5l0,0c0.6-0.5,0.9-1.1,1.1-1.8c0.1-0.3,0.2-0.6,0.2-0.9
		c0-0.1,0-0.2,0-0.4c0-0.3-0.1-0.6-0.2-0.9c-0.1-0.3-0.2-0.5-0.4-0.7c-0.7-1-2.3-1.7-4.6-1.8l0,0l0,0c0.1-0.7,0.3-1.5,0.4-2.2
		c0-0.1,0-0.1,0-0.2h0.1c0.9,0,1.7,0,2.6-0.2c0,0,0,0,0.1,0c2.4-0.5,4.1-2.3,4-4.4c-0.1-1.9-1.9-3.4-4.4-3.5c-0.6,0-1.2,0.1-1.8,0.1
		c0.2-1,0.6-2.1,0.5-3c-0.1-0.6-1-1.2-1.7-1.6c-1.3-0.8-2.7-0.9-4.2-0.2c-0.1,0-0.2,0.1-0.3,0.1c-1.8,0.9-2.4,2.1-2.3,3.5
		c0,0.4,0,0.7,0.1,1.1c-0.9-0.3-1.7-0.5-2.5-0.7c0.1-0.5,0.3-1,0.4-1.6s0.3-1.1,0.4-1.7c1.4-0.1,2.6-0.5,3.5-1.4
		c0.3-0.4,0.6-0.7,0.7-1.1c0.2-0.6,0.2-1.2,0.1-1.8c1.6-0.4,3.1-0.7,4.6-1.1c1.3-0.4,2-1.3,2.3-2.4c0.3-1.1-0.2-1.9-1.1-2.5
		c-1.1-0.8-2.3-1.5-3.5-2.3c-0.1,0-0.1-0.1-0.2-0.1c-0.5-0.3-0.8-0.7-0.9-1.3c-0.1-1.3-1.2-2.1-2.8-2c-1.7,0.2-2.4-0.9-3.7-1.2
		c0.6-0.7,0.9-1.2,1.9-1.5c0.1,0,0.1-0.1,0.2-0.1c0.5-0.1,0.9-0.4,1.3-0.7s0.8-0.6,1.3-0.8c1.2,0.4,1.3,1.2,1.1,2.1
		c-0.6,0.3-1.4-0.1-1.8,0.7c0.4,0.2,0.8,0.3,1.1,0.6c0.3,0.3,0.6,0.7,1.1,1.4c0.2-0.7,0.3-1.1,0.3-1.4c1-0.1,1.9-0.1,2.7,0.5
		c0.9,0.7,2.1,0.4,3.1-0.2c0.4-0.2,0.6-0.4,1.2-0.3c1.2,0.1,2.4-1,2.4-1.9c0,0,0,0,0-0.1c0-1-0.8-1.5-2-1.5c-0.2,0-0.4,0-0.6,0.1
		c-0.5,0.1-0.8,0.1-1.2-0.1c-1.4-0.6-2.6-0.3-3.6,0.8c-0.3,0.3-0.6,0.4-0.8,0c0.7-0.8,1.9-1.1,2.5-2.1c0.5-0.8,1.2-1.6,1.5-2.5
		c0.4-0.8,0.4-1.7,0.7-2.7c0.2-0.1,0.3-0.1,0.5-0.2c0.4-0.1,0.8-0.3,1.2-0.4c0,0.5-0.1,1-0.1,1.6c0.9,0.2,2.1-0.4,2.3,1.1
		c0,0-0.3,0.4-0.7,0.7l0,0H479c-0.4-0.2-0.8-0.4-1.2-0.6c-0.2,0.2-0.3,0.3-0.3,0.5c-0.1,0.4,0.1,0.6,0.5,0.8l0,0
		c0.3,0.1,0.7,0.3,0.7,0.5c0.1,0.5,0.3,0.9,0.7,1.2l0.1,0.1c0.5,0.3,1.1,0.5,1.8,0.6c0.1,0.1,0.1,0.2,0.2,0.3
		c0.3,0.6,0.6,1.2,0.9,1.7c0.2,0.3,0.4,0.7,0.6,1c0.8,1.3,1.2,2.7,1.1,4.1c0,0.5,0,1,0.1,1.5c0.2,0.7,0.5,1.3,1.3,1.8
		c-0.7,0.2-1.3,0.3-1.8,0.4l0,0c-0.4,0.1-0.7,0.2-1,0.4c-1.3,0.7-2.1,2.1-1.8,3.4c0.3,1.4,1.8,2.3,3.5,2.2c0.3,0,0.6,0,1-0.1
		c0.3-0.1,0.5-0.2,0.8-0.3c0.7-0.3,1.3-0.8,1.7-1.4c0.1-0.1,0.1-0.2,0.2-0.3c0.3-0.5,0.3-1.1,0.2-1.8c-0.1-0.2-0.1-0.4-0.2-0.5
		c-0.3-0.8-0.7-1.6-1.3-2.3c-0.1-0.1-0.2-0.3-0.3-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.7-1-1-2,0-3.4c0.2-0.1,0.6-0.3,1-0.5
		c2.2-0.9,2.7-1.9,2-3.8c0-0.1,0-0.2-0.1-0.4c1.4-0.9,0.6-1.9,0.4-2.9c0.6-0.6,1.1-1.1,1.6-1.6c0.4-1,0.6-2,0.2-2.9
		c-0.6-1.5-0.2-3,0.2-4.6c0-0.1,0-0.1,0.1-0.2c0.1-0.3,0.2-0.6,0.3-1c1.3,1,2.6,1.9,4,2.9c0.5,0.4,1,0.7,1.5,1.1
		c0.3-0.7,0.8-1.3,1.3-1.9c0.4-0.5,0.7-1.1,0.6-1.8c0.5,0.1,0.8,0.2,1.2,0.3c1-0.8,1.1-1.1,0.7-1.5s-0.7-0.4-2,0.2
		c-0.6-0.4-0.8-0.8,0-1.2c1-0.6,1.9-1.3,3.2-0.7c0.3,0.1,0.7,0,1.2,0c1.1,1.8,1.7,3.8,1.6,5.9c0,0.8,0,1.4,0.7,1.9s1,1.2,1.1,2
		c0.1,0.9,0,1.1-0.9,1.5c-0.5,0.2-1,0.3-1.4,0.3c-1.5,0.1-1.5,0-2.1,1.2l0.1,0.1c1.1,0.9,2.1,1.2,2.9,1c-0.5,1.3-0.3,1.8,0.5,2.1
		l0,0c2.4,0.9,2.4,0.9,3.4,2c0.3-0.2,0.9-0.5,0.9-0.7c0.1-1.1-0.2-2.1-1.3-2.8c0,0.3,0.1,0.6,0.1,0.9c0,0.1-0.3,0.3-0.5,0.5
		c-0.3-0.5-0.6-1.1-0.9-1.7c-0.3,0.1-0.6,0.2-0.8,0.3c-0.1,0-0.3,0.1-0.4,0.2c-0.3-0.2-0.6-0.5-1-0.9c0.7-0.2,1.3-0.7,2-1.4
		c0.1-0.1,0.2-0.2,0.3-0.4c0.3-0.3,0.3-0.8,0.4-1.1l0,0c0.2-1.4-0.3-2.7-1.3-3.8c-0.5-0.5-0.4-1.1-0.2-1.7c0.2-0.6,0.4-1.1,0.6-1.7
		c0.3-0.1,1-0.2,1.1-0.4c0.1-0.4-0.1-0.8-0.2-1.3c-0.5,0.4-0.8,0.7-1.1,0.9c-0.1,0-0.2-0.1-0.2-0.1c-0.2-2-0.9-3.9-0.3-6
		c0.9,0.1,2,0.2,3.2,0.3l0,0l0,0H510c1.5,0.4,1.1,1.7,1.4,2.6c0.5,0.1,1,0.4,1.3,0.3c1.2-0.4,1.7,0.1,2,0.9c0.1,0.2,0.7,0.4,0.3,0.7
		c-0.5,0.4,0.4,1.3-1.1,1.4c0.5,0.6,0.9,1.1,1.2,1.6c0.2,0.3,0.5,0.7,0.5,1.1c0,0.3-0.4,0.7-0.7,0.8c-0.6,0.2-0.8-0.2-0.9-0.6
		c-0.7,0.7-0.8,1.4-0.3,2.2c1-0.8,1.8,0.1,2.7,0c-0.2-0.2-0.4-0.4-0.8-0.7c1.1-0.4,2-0.7,3.4-1.2c-0.5,0.5-0.7,0.7-1,0.9
		c0,0,0,0.1,0.1,0.1c0.7-0.4,1.5-0.7,2.2-1.1c0,0.1,0.1,0.3,0.1,0.4c0.1,0.3,0.2,0.9,0.1,0.9c-0.7,0.2-0.6,1-1.2,1.2
		c-0.9,0.4-1.3,1.1-1.7,1.8c-0.5,0.7-0.9,1.2-1.9,1.4c0.5,0.5,0.8,0.8,1.2,1.2c-0.4,0.7-0.8,1.4-1.2,2.1c-0.1,0.2-0.2,0.4-0.4,0.6
		c0.3-0.1,0.6-0.1,0.9-0.2c0.1,0.2,0.2,0.4,0.3,0.7c-0.9,0.2-1.3,1-2.3,1c-0.3,0-0.7,0-1,0c-0.2,0-0.4-0.1-0.5-0.1
		c-0.9,0.5-1.7,1-2.5,1.4c0.2,0.8,0.4,1.3,1.2,1.6c0.7,0.3,1.3,0.9,1.6,1.5c0.5,0.9,1.9,0.4,2.5,1.2c0.1,0.2,1.1-0.2,1.7-0.3
		c-0.1-0.4-0.1-0.9-0.2-1.4c0.5-0.1,0.8-0.1,1.2-0.2c0,0.2,0.1,0.4,0.1,0.5c0.3,1.3,0.5,1.4,2.2,1.6c0.4,0,0.7,0.3,1,0.5
		c0.1,0.1,0.2,0.2,0.3,0.4C522.2,197.2,522.8,195.9,523.4,194.6z M463,222.6c-1.1,0-2.2,0.1-3.2,0.1c0-1,0-2,0-2.9
		c1.1,0.3,2.3,0.6,3.7,0.9C463.4,221.2,463.2,221.9,463,222.6z M470,189.7c0.4-0.5,0.7-0.3,1-0.1C470.6,189.7,470.3,189.7,470,189.7
		z M520.2,180.2L520.2,180.2c0-0.1,0.1-0.1,0.1-0.1C520.2,180.2,520.2,180.2,520.2,180.2z M517.6,194.8c0.3-0.3,0.5-0.6,0.7-0.9
		C518.6,194.7,518.6,194.7,517.6,194.8z"
      />
      <path
        class="st2"
        d="M462.9,163.8h0.1c0.3-0.2,0.7-0.5,1-0.7c1.8-1.3,3.6-2.6,5.5-4c0,0,0,0,0.1,0c-0.1,0-0.1,0-0.2-0.1
		c-0.2-0.1-0.5-0.1-0.7-0.2c-0.3-0.1-0.5-0.1-0.7-0.2c-11.7-2.3-23.5-4.5-35.2-6.8c-1-0.2-1.9-0.4-2.9-0.6
		c-8.4-1.6-16.8-3.2-25.1-4.9c-0.2,0-0.4-0.1-0.5-0.1c-5.5-1.1-11.1-2.1-16.6-3.2c-3.2-0.6-6.5-1.2-9.7-1.9c-4.7-0.9-9.4-1.8-14-2.7
		c-6-1.2-12.1-2.3-18.1-3.5c-3.5-0.7-7-1.4-10.4-2.2c0.3,0.7,1.7,0.9,1.1,2.1c-1-0.1-1.9-0.2-2.8-0.3c0,0.2,0,0.3,0,0.5
		c1,0.7,2.1,0.9,3.2,0.3c1.9-0.9,2.5-0.7,3.5,1.4c-0.6,0.3-1.1,0.5-1.9,0.9c0.7,0.2,1.1,0.3,1.6,0.4c3.6,0.7,7.2,1.8,11,1.6
		c-0.7-0.8,0-0.8,0.5-0.7c2,0.4,4,0.9,6,1.4c0,0.1,0,0.2-0.1,0.4c-0.6-0.1-1.1-0.2-1.7-0.3c-1.6-0.3-3.2-0.5-4.7-0.8
		c1.6,0.3,3.2,0.5,4.7,0.8c0.2,0.9,0.9,1.2,1.8,1.4c5.6,1.2,11.1,2.3,16.7,3.5c3.6,0.8,7.2,1.5,10.8,2.3c3.3,0.7,6.7,1.4,10,2.1
		c-0.4-0.9,0.2-0.7,0.7-0.7c2.5,0.5,5.1,1,7.6,1.5c0,0.2-0.1,0.3-0.1,0.5c-2.4-0.5-4.8-1-7.2-1.4c0.4,0.2,0.8,0.5,1.3,0.6
		c3.3,0.7,6.6,1.4,10,2.1c1.5,0.3,2.9,0.6,4.4,0.9c1.7,0.4,3.3,0.7,5,1.1c3.8,0.8,7.6,1.6,11.8,2.5c-0.6-0.6-1.1-0.8-1.3-1.2
		c-0.2-0.5-0.3-1.3,0-1.7c1.1-1.7,4.3-1.9,5.9-0.4c-0.6,0.5-1.2,1-1.7,1.5c-0.6-0.4-1-0.8-1.5-0.9c-0.5-0.1-1.1-0.1-1.6-0.1
		c0.2,0.5,0.4,1,0.7,1.4c0.3,0.5,0.8,1,1.2,1.6c0.7-1.2,1.7-1.6,2.9-1.1c0.2,0.1,0.5,0.2,0.7,0.4c0.5,0.3,1.3,0.2,1.9,0.2l0,0
		c-0.7-0.5-1.4-1-2.2-1.6c-0.1-0.1-0.1-0.1-0.2-0.1c0.4-0.4,0.6-1.7,1.9-1.1c1.8,0.8,2.3,2.2,1.1,4.1c-0.2-0.4-0.3-0.7-0.5-1
		c0-0.1-0.1-0.2-0.1-0.3l0,0c-0.1,0.2-0.2,0.4-0.2,0.5c-0.2,0.4-0.3,0.7-0.5,1.1c0,0,0,0.1,0.1,0.1c7.8,1.7,15.5,3.3,23.3,5
		c0.3,0.1,0.5,0.1,0.8,0.2c0.6,0.1,1.2,0.3,1.8,0.4c0.3,0.1,0.7,0.1,1,0.2C462.3,163.9,462.7,163.9,462.9,163.8z M359.8,139.8
		c-2.3-0.4-4.5-0.7-6.8-1.1c0-0.2,0.1-0.3,0.1-0.5c2.3,0.4,4.5,0.8,6.8,1.3C359.8,139.6,359.8,139.7,359.8,139.8z M361.6,139.4
		c-2.2-0.5-4.5-1-6.7-1.4c0-0.2,0.1-0.3,0.1-0.5c2.3,0.5,4.5,0.9,6.8,1.4C361.7,139.1,361.7,139.2,361.6,139.4z M405.1,150.2
		c-2.7-0.5-5.4-1.1-8.1-1.6c0-0.2,0.1-0.3,0.1-0.5c2.7,0.5,5.4,1,8,1.6C405.2,149.9,405.1,150.1,405.1,150.2z M407,149.4
		c-2.6-0.6-5.2-1.1-7.8-1.7c0-0.2,0.1-0.3,0.1-0.5c2.6,0.5,5.2,1.1,7.8,1.6C407.1,149,407.1,149.2,407,149.4z M401.2,147
		c0-0.2,0-0.4,0.1-0.5c2.6,0.5,5.1,1.1,7.7,1.6c0,0.2-0.1,0.3-0.1,0.5C406.3,148,403.7,147.5,401.2,147z M459,161.8
		c-0.3-0.1-0.5-0.1-0.8-0.2c-1.3-0.3-2.6-0.5-3.9-0.8c0-0.1,0-0.1,0-0.2c1.4,0.3,2.7,0.6,4.1,0.9c0.1,0,0.2,0,0.3,0.1
		c1.2,0.2,2.4,0.5,3.6,0.7c0.2,0,0.3,0.1,0.5,0.1c0,0.1,0,0.2-0.1,0.2c-0.2,0-0.3-0.1-0.5-0.1C461.2,162.3,460.1,162,459,161.8z"
      />
      <path
        class="st2"
        d="M378.8,233.1l-0.1,0.1l-0.1,0.1c-2,1.5-4,3-6,4.6c-0.1-0.2-0.3-0.3-0.4-0.5c2.2-1.7,4.4-3.3,6.6-5
		c0-0.1,0-0.2,0-0.3c0.2-0.3,0.4-0.6,0.6-0.9c0.2-0.3,0.4-0.6,0.6-0.9c0.2,0.2,0.4,0.5,0.7,0.7c0.2-0.1,0.4-0.3,0.6-0.4
		c0.3-0.2,0.6-0.5,0.9-0.7s0.6-0.5,0.9-0.7c0.7-0.5,1.4-1.1,2.1-1.6v-0.1c0.1,0,0.1,0,0.1,0c0.1-0.1,0.3-0.2,0.4-0.3
		c0.1,0,0.1-0.1,0.2-0.1c0.1-0.1,0.2-0.2,0.3-0.2c0,0,0,0,0-0.1c0.1,0,0.1,0,0.2-0.1c1.2-0.9,2.4-1.8,3.5-2.7
		c0.1-0.1,0.3-0.2,0.4-0.3l0,0c0,0,0-0.1,0.1-0.1c0.3-0.5,0.8-0.9,1.3-1.3c0.3-0.2,0.4-0.5,0.6-0.8c0.3-0.5,0.7-0.8,1.4-0.9
		c0.4,0,0.9-0.5,1.4-0.8c0,0.1,0,0.1,0,0.2c0.1-0.1,0.3-0.2,0.4-0.3s0.3-0.2,0.4-0.3c0.4-0.3,0.8-0.6,1.2-0.9
		c0.4-0.3,0.7-0.6,1.1-0.8c1.9-1.4,3.8-2.9,5.7-4.3c0,0,0,0,0.1-0.1c1.4-1,2.7-2.1,4.1-3.1c-0.2-0.3-0.3-0.6-0.5-0.8
		c-0.6,1.4-2,0.7-3.2,0.7c-0.2,0-0.3,0-0.5,0c0-0.3-0.1-0.8-0.1-1.2c0-0.1,0-0.1,0-0.2c-0.1,0-0.1,0.1-0.2,0.1
		c-0.5,0.4-1,0.7-1.5,1.1c-2,1.4-4,2.9-5.9,4.3c-0.6,0.4-1.2,0.9-1.8,1.3c-0.1,0.1-0.3,0.2-0.4,0.3c-0.6,0.5-1.3,0.9-1.9,1.4
		c-2.9,2.1-5.7,4.2-8.6,6.3c-0.5,0.3-0.9,0.7-1.4,1c-0.9,0.7-1.8,1.3-2.8,2c-5.5,4-11,8-16.6,12.1c-1,0.7-2,1.5-3,2.2
		c-0.1,0.1-0.2,0.2-0.3,0.3c-0.2,0.2-0.4,0.3-0.6,0.5c-0.2,0.1-0.4,0.3-0.6,0.4c0.3,0,0.5,0,0.8-0.1c0.2,0,0.3,0,0.5-0.1
		c0,0.2,0,0.3,0,0.5l0,0c0,0.6,0.1,1.1,0.1,1.7c-0.4,0.3-0.8,0.5-1.1,0.8c-1.1,1-1.5,2.3-0.9,3.4c0.6,1.1,2.2,1.8,3.7,1.6
		c1-0.1,1.9-0.7,2.5-1.3c0.3-0.4,0.6-0.7,0.7-1.2c0.1-0.2,0.1-0.5,0.2-0.7c0.1-0.4,0.1-0.8,0.2-1.2c-0.2,0-0.5,0.1-0.5,0.1
		c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.2-0.2-0.4-0.3-0.6h0.1c0.5-0.2,0.9-0.3,1.3-0.5c1.7-0.7,2.4-2.2,1.7-3.6
		c-0.1-0.1-0.1-0.2-0.2-0.3c-0.5-0.7-0.5-0.7-0.2-1.4c0.4,0.4,0.9,0.8,1.3,1.2l0,0c0.3,0.3,0.7,0.7,1,1c0.5-0.5,1-1,1.6-1.5
		c0.2,0.3,0.4,0.5,0.6,0.7c0.8,0.7,1.8,1,2.7,0.7c0.2,0,0.4-0.1,0.6-0.2c0.3-0.3,0.7-0.5,1-0.8c0.2-0.2,0.3-0.4,0.4-0.7
		c0-0.1,0.1-0.2,0.1-0.3c-0.1-0.2-0.2-0.4-0.1-0.6c0-0.8,0.9-1.5,0.9-2.4c0.6,0.1,1,0.2,1.5,0.3c0.1,0,0.1,0,0.2,0
		c0.2-0.7,0.4-1.4,0.4-2C378.8,233.7,378.8,233.4,378.8,233.1L378.8,233.1z"
      />
      <path
        class="st2"
        d="M362,237.3c0.1-0.1,0.1-0.3,0.2-0.4c-0.4-0.2-0.7-0.3-1.1-0.5s-0.8-0.4-1.2-0.6c-0.1,0-0.2-0.1-0.2-0.1
		c-0.2-0.1-0.5-0.2-0.7-0.3c0.1,0.2,0.3,0.3,0.5,0.5c0.1,0.1,0.3,0.2,0.4,0.2c0.3,0.1,0.6,0.3,1,0.4c0.1,0,0.3,0.1,0.4,0.1
		c-0.1,0.1-0.1,0.2-0.2,0.4C361.5,237,361.7,237.2,362,237.3z"
      />
      <path
        class="st2"
        d="M390.3,180.8c0.2,0.1,0.4,0.3,0.6,0.4c0.1,0.1,0.1,0.1,0.2,0.2c0.1-0.1,0.2-0.3,0.2-0.4
		c0.5-0.9,0.3-1.7-0.5-2.3l-0.1-0.1c-1.3-0.9-1.8,0.3-2.4,0.6C389,179.8,389.6,180.3,390.3,180.8z"
      />
      <path
        class="st2"
        d="M385.4,179.1c0.6-0.4,1.2-0.7,1.9-1.2c-1.2-0.7-2.1-1-2.9-1.1c-0.6,0-1.2,0.1-1.7,0.3c0.3,0.2,0.6,0.4,0.8,0.6
		C384.2,178.3,384.8,178.7,385.4,179.1z"
      />
      <path
        class="st2"
        d="M454.3,170c0.1,0,0.2,0,0.2-0.1c2.2-1.5,4.3-3.1,6.8-4.9c-7.1-1.5-13.9-2.9-20.7-4.4c-0.8-0.2-1.6-0.3-2.4-0.5
		c-2.4-0.5-4.8-1-7.2-1.5h-0.1c-0.1,0.4-0.2,0.8-0.3,1.2c-0.1,0.4-0.2,0.7-0.4,0.8c-0.1,0.1-0.2,0.1-0.3,0.1c-1.1,0.6-2.3,1-3.5,1.3
		c-0.3,0.1-0.8-0.6-1.2-0.9c0.5-0.3,0.9-0.6,1.4-0.7c0.5-0.1,1,0.1,1.8,0.2c-1.1-1.5-2.8-1.7-4.2-1c-0.1,0.1-0.3,0.1-0.4,0.2
		c-0.5,0.3-1.1,0.5-1.5,0.4c-1.2-0.4-2.3-1.1-3.5-1.8c-0.1-0.1-0.2-0.1-0.3-0.2c0.1-0.1,0.2-0.1,0.3-0.2c0.9-0.5,1.6-0.9,2.5-1.5
		c-1.3-0.3-2.6-0.6-3.9-0.8c-1-0.2-2-0.4-3-0.6c-1.2-0.3-2.4-0.5-3.6-0.8c-1.2-0.2-2.3-0.5-3.5-0.7c-5.7-1.2-11.3-2.4-17-3.6
		c-1.2-0.3-2.4-0.5-3.6-0.8c-1.5-0.3-3-0.6-4.6-1c-3.5-0.7-7-1.5-10.4-2.2c-14.8-3.1-29.5-6.3-44.3-9.4c-0.2,0.5-0.4,0.9-0.5,1.3
		c-1-0.7-1.7-1.7-2.6-1.9c-0.1,0-0.3-0.1-0.4-0.1h-0.1c-0.4-0.1-0.7-0.2-1.1-0.3c-0.6-0.1-1.2-0.3-1.8-0.4c-0.7-0.2-1.5-0.3-2.2-0.5
		c-0.8-0.2-1.7-0.4-2.6-0.5c-0.3-0.1-0.7-0.1-1-0.2c-0.3,0.2-0.7,0.4-1.1,0.6c0,1-0.1,2.1-0.1,3.2l0,0c0.1,0,0.2,0.1,0.3,0.1
		c8.4,1.9,16.6,4.5,25.2,5.1l0,0c-0.2-0.2-0.4-0.4-0.7-0.6c3.3-1.4,6.1,0.4,9.1,0.6c0,0.2,0,0.3,0,0.5c-0.9-0.1-1.7-0.2-2.9-0.3
		c0.7,0.3,1.1,0.4,1.5,0.6c0,0.1,0,0.3-0.1,0.4c-0.9-0.2-1.8-0.3-2.7-0.5c-1.4-0.2-2.8-0.5-4.3-0.7l0,0c2.1,0.7,4.1,1.6,6.2,2.1
		c0.7,0.2,1.4,0.3,2.1,0.5c0.2,0.1,0.4,0.1,0.7,0.2c1.5,0.4,3.1,0.8,4.6,1.1c0.5,0.1,1,0.2,1.5,0.4c5.6,1.3,11.1,2.6,16.7,3.8
		c1.9,0.4,3.9,0.9,5.8,1.3c0.3,0.1,0.6,0.1,0.9,0.2c1.2,0.3,2.4,0.5,3.6,0.8c1,0.2,2,0.4,3,0.7c0.5,0.1,0.9,0.2,1.4,0.3
		c0-0.1,0-0.1,0-0.2c-0.6-0.2-1.1-0.4-1.7-0.5c-0.1,0-0.3-0.1-0.4-0.1c0-0.1,0-0.2,0.1-0.3v-0.1c0.8,0.1,1.5,0.2,2.3,0.4
		c2.6,0.7,5.1,1.6,7.6,2.5c3.4,1.3,7,1.8,10.5,2.6c0.5,0.1,1,0.2,1.5,0.3c0.2,0,0.3,0.1,0.5,0.1c1.6,0.4,3.2,0.7,4.7,1.1
		c2,0.5,4,0.9,6,1.4c0.4,0.1,0.7,0.2,1.1,0.2c1.9,0.4,3.8,0.9,5.6,1.3c1.9,0.4,3.9,0.9,5.8,1.3c2,0.5,4.1,0.9,6.1,1.4
		c4.7,1.1,9.4,2.2,14.1,3.2c1.1,0.3,2.2,0.5,3.3,0.8C453.3,170,453.9,170.1,454.3,170z M330.4,139.7c-0.8-0.6-1.6-1.2-2.4-1.9
		c0-0.2,0.1-0.3,0.1-0.5c0.8,0.2,1.6,0.3,2.3,0.7c0.3,0.2,0.3,0.9,0.4,1.4C330.7,139.5,330.5,139.6,330.4,139.7z M349.4,143.1
		c-2.3-0.5-4.7-1-7-1.5c0-0.2,0.1-0.4,0.1-0.5c2.3,0.5,4.7,1,7,1.5C349.5,142.8,349.5,143,349.4,143.1z M394.5,154.6
		c-2.8-0.5-5.5-1.1-8.3-1.6c0-0.2,0.1-0.3,0.1-0.5c2.8,0.5,5.5,1.1,8.3,1.6C394.5,154.3,394.5,154.5,394.5,154.6z M396.2,153.9
		c-2.8-0.6-5.5-1.1-8.3-1.7v-0.1c0-0.1,0-0.3,0-0.4c0.4,0.1,0.7,0.1,1.1,0.2c2.4,0.5,4.8,1,7.2,1.5
		C396.3,153.5,396.2,153.7,396.2,153.9z M397.8,153.1c-2.6-0.6-5.3-1.1-7.9-1.7h-0.1c0-0.2,0.1-0.3,0.1-0.5c0.1,0,0.2,0,0.3,0.1
		c2.6,0.6,5.1,1.1,7.7,1.7C397.8,152.7,397.8,152.9,397.8,153.1z M449.3,163.2c3.3,0.7,6.5,1.5,9.8,2.2c0,0.2-0.1,0.3-0.1,0.5
		c-3.3-0.7-6.6-1.4-9.8-2.2C449.2,163.5,449.3,163.3,449.3,163.2z M447.7,164.1c3.3,0.7,6.6,1.5,9.9,2.2c0,0.1,0,0.1,0,0.2
		c0,0.1,0,0.2-0.1,0.3c-0.3-0.1-0.6-0.1-1-0.2c-3-0.7-5.9-1.3-8.9-2C447.6,164.5,447.7,164.3,447.7,164.1z M446.3,165.2
		c3.4,0.7,6.7,1.5,10.1,2.2c0,0.2-0.1,0.4-0.1,0.6c-3.4-0.7-6.7-1.5-10.1-2.2C446.2,165.5,446.2,165.3,446.3,165.2z M444,167.2
		c0-0.2,0.1-0.4,0.1-0.5c3.4,0.7,6.7,1.5,10.1,2.2c0,0,0,0.1-0.1,0.1c-0.1,0.1-0.1,0.3-0.2,0.4c-1.3-0.3-2.5-0.5-3.8-0.8
		C448.1,168.1,446.1,167.6,444,167.2z"
      />
      <path
        class="st2"
        d="M429,158.8c-0.1,0.6-0.2,1.3-0.2,1.9c0.2,0.1,0.4,0.1,0.6,0.2c0.3-0.6,0.6-1.1,0.9-1.7
		C429.8,159.1,429.4,159,429,158.8z"
      />
      <path
        class="st2"
        d="M458.2,144.6c0.2-0.1,0.5-0.2,0.7-0.3c0.4-0.2,0.9-0.4,1.2-0.7c0.2-0.2-0.2-1-0.3-1.6c-0.8,0.9-1.3,1.5-1.8,2
		c0.1,0.1,0.1,0.3,0.2,0.4C458.2,144.5,458.2,144.6,458.2,144.6z"
      />
      <path
        class="st2"
        d="M321.5,151C321.5,150.9,321.5,150.9,321.5,151C321.5,150.9,321.4,150.9,321.5,151c-0.8-0.3-1.6-0.5-2.3-0.7
		c-0.9-0.3-1.8-0.5-2.6-0.8c-0.2-0.1-0.3-0.1-0.5-0.2c0,0.1-0.1,0.2-0.1,0.3c0.2,0,0.3,0.1,0.5,0.1c0.8,0.2,1.5,0.5,2.3,0.7
		c0.9,0.3,1.8,0.5,2.7,0.8C321.4,151.1,321.4,151,321.5,151z"
      />
      <path
        class="st2"
        d="M351.2,197.3c0.6-0.3,1.2-0.7,1.9-1.1c0.5-0.3,1-0.6,1.6-0.9c-2.4-1.4-4.5-1-6.6-0.4c0.7,0.5,1.4,1,2,1.6
		C350.5,196.8,350.8,197.1,351.2,197.3z"
      />
      <path
        class="st2"
        d="M434.8,156.8c-0.6,0.2-1.1-0.2-1.6-0.5c-0.7-0.4-1.4-0.8-2.2,0.2c0,0.2,0,0.4,0,0.6c1.2,0.1,2.5,0.2,3.7,0.3
		c0-0.1,0-0.2,0-0.4C434.8,157,434.8,156.9,434.8,156.8z"
      />
      <path
        class="st2"
        d="M458.5,138.3c0.3-0.1,0.7-0.3,1-0.4l0,0l0,0c-0.4-0.1-0.8-0.1-1.2-0.2c-0.5-0.1-1-0.1-1.5-0.2
		c-1.7-0.3-3.2-0.5-4.8-0.7c-1-0.1-2-0.2-3-0.4c-0.3,0-0.7-0.1-1-0.1c-4.2-0.5-8.4-1-12.6-1.5c-0.3,0-0.5,0.1-0.8,0.1
		c0,0.1,0,0.1,0,0.2c0.9,0.2,1.9,0.4,2.8,0.5c0,0.1,0,0.2,0.1,0.4c-0.6,0.3-1.3,0.6-1.9,0.9c0,0.1,0,0.2,0,0.3
		c6.8,1.1,13.5,2.1,20.3,3.2c0.3,0.1,0.7,0.1,1,0.2c0-0.1,0-0.3-0.1-0.4c-0.1-0.5-0.1-0.8-0.2-1c0.1,0,0.1-0.1,0.2-0.1
		C457.4,138.7,457.9,138.5,458.5,138.3z"
      />
      <path
        class="st2"
        d="M353.9,125.3c-0.5,0-1,0-1.5,0c-0.4,0-0.9,0.1-1.3,0.1c-0.6,0.1-1.3,0.2-1.9,0.4c0,0.2-0.1,0.4-0.1,0.6
		c3,0.5,6,1,9,1.5c0.3,0.1,0.6,0.1,0.9,0.2c0.9,0.1,1.7,0.3,2.6,0.4c0.5,0.1,1.1,0.2,1.6,0.3c0.4,0.1,0.8,0.1,1.2,0.2
		c0-0.7,0-1.3,0-2.1c-3.1-0.3-6.2-1.3-9.4-1.6C354.6,125.4,354.3,125.4,353.9,125.3z"
      />
      <path
        class="st2"
        d="M336.2,119.9c-1.3,0.2-2.6,0.5-3.9,0.7c-0.7,0.1-1.3,0.2-2,0.4c-2,0.4-4,0.7-6,1.1c-0.7,0.1-1.4,0.3-2.1,0.4
		c0.1,0.4,0.4,0.7,0.6,1c0.3-0.1,0.5-0.1,0.8-0.2c2.7-0.5,5.3-1,8-1.6c0.3-0.1,0.6-0.1,0.9-0.2c1.8-0.3,3.5-0.7,5.3-1
		c0.5-0.1,1-0.2,1.5-0.3c0-0.1,0-0.3,0-0.4C338.2,119.9,337.1,119.7,336.2,119.9z"
      />
      <path
        class="st2"
        d="M324.2,125.7c-0.2-0.2-0.3-0.4-0.5-0.6c-0.3,0.3-0.4,0.5-0.4,0.8C323.6,125.8,323.9,125.7,324.2,125.7z"
      />
      <path
        class="st2"
        d="M324.3,116.5c-0.8,0.5-1.6,1.2-2,1.9c-0.4,0.7-0.5,1.6-0.6,2.3c0,0.2,0,0.3,0.1,0.5c1.9-0.4,3.8-0.7,5.7-1.1
		c1.7-0.3,3.3-0.6,5-0.9c1.1-0.2,2.2-0.4,3.3-0.6c0.9-0.2,1.9-0.1,2.8,0c0.4,0.1,0.8,0.1,1.3,0.2c-0.3-0.4-0.6-0.8-0.7-1.2
		c-0.8-2.2-1.9-2.5-4.5-1.2c-0.1,0-0.1,0-0.2,0.1c-0.1-0.2-0.2-0.3-0.3-0.5c-0.2-0.3-0.3-0.5-0.5-0.8c-0.1-0.2-0.1-0.3-0.2-0.5
		c-0.1-0.4-0.1-0.7,0.3-1.1c0.3-0.3,0.3-0.8,0.4-1.2c0-0.1,0-0.3,0.1-0.4c-0.1,0-0.2-0.1-0.3-0.1l-0.1,0.1c-0.3,0.5-0.7,0.9-0.9,1.4
		c-0.2,0.6-0.5,0.9-1.3,0.9c-0.5,0-0.9-0.1-1.3-0.4c-0.2-0.2-0.4-0.4-0.5-0.6c-0.1-0.3-0.2-0.7-0.3-1c-0.3,0.9-0.8,1.7-0.2,2.6
		c-0.3,0.2-0.6,0.4-0.9,0.6c-0.2,0.1-0.4,0.2-0.6,0.3c-0.1-0.3-0.2-0.5-0.3-0.9c-0.3-0.1-0.8-0.1-1.3-0.2
		C325.6,115.5,325.1,116,324.3,116.5z"
      />
      <path
        class="st2"
        d="M324.6,124.8c-0.1,0.3-0.2,0.6-0.3,0.9c2.9-0.6,5.8-1.2,8.7-1.8c0.2,0,0.5-0.1,0.7-0.1
		c2.2-0.5,4.3-0.9,6.5-1.4c1.3-0.3,2.6-0.5,3.9-0.8c0.4-0.1,0.8-0.2,1.6-0.4c-0.2-0.1-2,0.2-5,0.7c-3.8,0.6-9.4,1.6-16.3,2.9
		C324.5,124.7,324.6,124.7,324.6,124.8z"
      />
      <path
        class="st2"
        d="M314.7,122.6h0.1c1-0.2,2.1-0.4,3.1-0.6c0,0,0,0,0.1,0l0,0c-0.7-0.2-1.4-0.1-2.5,0.3
		C315.3,122.4,315.1,122.5,314.7,122.6z"
      />
      <path
        class="st2"
        d="M451.7,100.2c-0.9-0.1-1.8-0.1-2.7-0.2c-0.6,0-1.2-0.1-1.7-0.1c-1-0.1-1.9-0.1-2.9-0.2c-0.3,0-0.6,0-0.9-0.1
		c-0.4,0-0.8,0-1.2-0.1c-0.7,0-1.4-0.1-2.1-0.1c-1.6-0.1-3.3-0.2-4.9-0.3c-1.2-0.1-2.3-0.1-3.5-0.2c-0.2,0-0.4,0-0.6,0
		c-0.4,0-0.9,0-1.3-0.1c-0.8,0-1.5-0.1-2.3-0.1c0,1.4,0,2.5,0,3.7c0,0.4,0,0.8,0.1,1.4c0.2,0,0.4,0,0.6,0c0.6,0,1.1,0.1,1.7,0.1
		c2.9,0.2,5.7,0.4,8.6,0.6c0.1,0,0.2,0,0.3,0c0.2,0,0.3,0,0.5,0c1.4,0.1,2.8,0.2,4.2,0.3c0.3,0,0.7,0,1,0.1c1.9,0.1,3.7,0.3,5.6,0.4
		c1.7,0.1,3.4,0.2,5.2,0.4c1,0.1,2,0.1,3,0.2c0-0.4,0-0.8,0.1-1.2c0.1-1.4,0.1-2.8,0.2-4.4c-0.4,0-0.8,0-1.2-0.1
		C455.5,100.5,453.6,100.4,451.7,100.2z"
      />
      <path
        class="st2"
        d="M381.6,120.6c0.3,0,0.6,0.1,0.9,0.1c1.7,0.3,3.4,1.1,5-1c-0.8-0.1-1.6-0.1-2.3-0.2c0,0,0,0-0.1,0
		c-1.9-0.1-3.7-0.3-5.5-0.4c-0.4,0-0.9-0.1-1.3-0.1c-0.9-0.1-1.8-0.1-2.7-0.2c0,0.2-0.1,0.4-0.1,0.6c1,0.3,2,0.6,3.1,0.8
		c0.5,0.1,1,0.1,1.6,0.2C380.7,120.5,381.1,120.6,381.6,120.6z"
      />
      <path
        class="st2"
        d="M399,121.5L399,121.5L399,121.5c-2.4-0.3-4.8-0.6-7.2-0.9c0,0.2,0,0.3-0.1,0.5c0.5,0.1,1,0.1,1.5,0.2
		c0.3,0.1,0.9,0.2,0.9,0.3c0,1.3,1,1,1.6,1.1c1,0.1,1.9,0.3,2.9,0.4h0.1c0.2,0,0.4,0.1,0.6,0.1c1.4,0.2,2.7,0.3,4.1,0.4
		c2.1,0.2,4.2,0.2,6.4,0.3c0-0.1,0-0.2,0-0.2c-0.8-0.2-1.6-0.4-2.5-0.5c0-0.1,0-0.1,0-0.2c1.1,0.1,2.2,0.3,3.2,0.4
		c0-0.1,0-0.3,0-0.4c-3.2-0.4-6.5-0.8-9.7-1.2C400.3,121.7,399.7,121.6,399,121.5C399.1,121.5,399,121.5,399,121.5z"
      />
      <path
        class="st2"
        d="M385.9,227.7C386,227.7,386,227.7,385.9,227.7C386,227.7,386,227.6,385.9,227.7
		C386,227.6,386,227.6,385.9,227.7z"
      />
      <path
        class="st2"
        d="M409.8,234.2c-0.7,0.4-1.2,0.6-1.7,0.9c-0.9,0.7-1.7,1.4-2.6,2.1c-0.6,0.5-0.4,1.2,0.3,1.3
		c0.9,0.1,1.4,0.6,2,1c0.5,0.4,1,0.6,1.5,0.7c0.7,0.1,1.4,0,2.2-0.2c0.3-0.1,0.6-0.2,1-0.4c0,0.6,0,1.1,0.1,1.6
		c0.3,1.4,1.8,2.3,3.4,2.2c0.3,0,0.7,0,1-0.1c1.8-0.4,3-1.8,3-3.4c0-0.1,0-0.2,0-0.4c-0.3-1.8-2.1-2.8-4.2-2.4c-0.1,0-0.1,0-0.2,0.1
		c-0.4,0.1-0.7,0.2-1.1,0.3c-0.2,0.1-0.4,0.2-0.7,0.2c0.1-0.2,0.1-0.3,0.1-0.5c0.2-1.1-0.4-2-1.2-2.7c-0.1-0.1-0.3-0.1-0.4-0.2
		c-0.5-0.1-0.9-0.2-1.5-0.2c0.2-0.4,0.3-0.7,0.6-1.2c0.4,0.5,0.7,0.9,1.1,1.2c0.1,0.1,0.3,0.1,0.4,0.2c0.4,0,0.7,0.1,1.1,0.1
		c1.2,0.1,2.2-0.3,2.9-1c0.1-0.1,0.3-0.3,0.4-0.4c0.7-1,0.7-2-0.1-2.9c-0.1-0.1-0.2-0.2-0.4-0.3c-0.8-0.6-1.9-0.8-3.1-0.5
		c-0.5,0.1-0.9,0.3-1.3,0.4c-0.4,0.6-0.7,1.2-1,1.6c-0.5-0.1-0.9-0.3-1.3-0.4c-0.2,0.5-0.6,1-0.7,1.6
		C409.5,233.2,409.7,233.7,409.8,234.2z"
      />
      <path
        class="st2"
        d="M393,254c0-0.3-0.1-0.6-0.1-0.9c-0.6-0.1-1-0.2-1.4-0.2c-0.7,0-1.5,0-2.2,0c-0.2-0.3-0.4-0.6-0.6-0.9l-0.1-0.1
		c-0.5-0.5-1.4-0.6-2-0.2c-0.4,0.2-0.6,0.5-0.8,0.7c-0.7,0.8-0.4,1.7,0.7,2.4c0.1,0,0.1,0.1,0.2,0.2c-1.3,1.2-1.3,1.2-0.5,2.5
		c0.3,0.5,0.6,1,0.8,1.4c2.9,0.2,2.9,0.2,3.8-0.9c0.6,0,1.3,0.1,2,0.1c0-0.1,0-0.2,0-0.3c0-0.2,0-0.4,0-0.5c0-0.2-0.1-0.6,0-0.6
		c0.7-0.3,0.5-0.8,0.4-1.2C393.2,255,393.1,254.5,393,254z"
      />
      <path
        class="st2"
        d="M473.4,207.8c0.3,1.8,2.5,2.8,4.6,2.3c2.2-0.5,3.6-2.3,3.2-4.1c0-0.2-0.1-0.3-0.2-0.5s-0.2-0.4-0.3-0.5
		c-0.1-0.2-0.3-0.4-0.5-0.5c-0.6-0.5-1.3-0.8-2.1-0.9c-0.5-0.1-1.1,0-1.6,0.1C474.1,204.4,473.1,205.8,473.4,207.8z"
      />
      <path
        class="st2"
        d="M485.9,211.1c-0.6-1.2-2.2-1.9-3.9-1.6c-2,0.4-3.4,2.1-3.1,3.8c0.3,1.5,2.4,2.6,4.3,2.2
		c1.5-0.3,2.6-1.3,2.9-2.5c0.1-0.4,0.1-0.8,0.1-1.2C486.1,211.6,486,211.3,485.9,211.1z"
      />
      <path
        class="st2"
        d="M408.3,241.1c-0.1-0.1-0.1-0.1-0.2-0.1c-0.2-0.1-0.4-0.3-0.6-0.4c-0.7-0.3-1.3-0.3-2-0.1c-0.1,0-0.1,0-0.2,0.1
		c-0.7,0.3-1.3,0.9-1.8,1.8c-0.4,0.1-0.9,0.1-1.2,0.3c-0.4,0.2-0.8,0.5-1.1,0.7c-0.4-0.3-0.7-0.6-1.1-0.7c-0.4-0.2-0.9-0.2-1.3,0
		c-0.4,0.1-0.8,0.4-1.1,0.8c-0.1,0.1-0.1,0.2-0.1,0.2c-0.3,0.6,0,1.3,0.7,1.6c0.3,0.1,0.6,0.2,0.9,0.2c0.2,0,0.3,0,0.5-0.1
		c0.1,0,0.3-0.1,0.4-0.2c0.1,0,0.1-0.1,0.2-0.1c0.1-0.1,0.3-0.1,0.4-0.1c0.3,0.4,0.6,0.7,0.9,1c0.8-0.8,1.5-1.5,2.2-2.2
		c0.4,0.2,0.8,0.4,1.2,0.5c1.2,0.4,2.1,0.3,2.8-0.3c0.2-0.2,0.4-0.4,0.6-0.6c0.1-0.1,0.1-0.2,0.2-0.3c0,0,0-0.1,0.1-0.1
		c0.1-0.2,0.1-0.4,0.1-0.6c0-0.1,0-0.2,0-0.3s0-0.3-0.1-0.4C408.6,241.6,408.5,241.3,408.3,241.1z"
      />
      <path
        class="st2"
        d="M478.4,199.1c0.5,0.1,1,0.1,1.5,0c1.3-0.3,2.3-1.2,2.6-2.3c0.1-0.3,0.1-0.7,0-1.1c-0.2-0.9-1.1-1.6-2.2-1.8
		c-0.5-0.1-1.1-0.1-1.7,0c-1.4,0.3-2.3,1.3-2.5,2.3c-0.1,0.3-0.1,0.6,0,0.9C476.3,198.2,477.2,198.9,478.4,199.1z"
      />
      <path
        class="st2"
        d="M454.2,270c-1.4,0.2-2.4,1.1-2.6,2.1h5.9c0-0.1,0-0.2,0-0.3C457.3,270.6,455.8,269.8,454.2,270z"
      />
      <path
        class="st2"
        d="M553.1,170.9c0.1,0.5,0.3,1,0.7,1.3l0,0v-0.1c0.1-0.2,0.1-0.5,0.1-0.8c0-0.4,0.1-0.8,0.1-1.3
		c-0.4,0.2-0.9,0.5-1.4,0.9c0.4-1.1-0.4-1.3-0.8-1.7c-0.6-0.6-1.4-0.5-2.2-0.2c-0.7,0.2-1.3,0.6-1.9,0.8c0.3,1.1,0.8,1.9,2.1,2.2
		C551.4,172.5,552.1,171.6,553.1,170.9z"
      />
      <path
        class="st2"
        d="M556.8,169.9c-0.3-0.1-0.7-0.1-1-0.1c-0.2,0-0.5,0-0.7,0c-0.1,0-0.2,0-0.3,0.1c0,0.6-0.1,1.2-0.1,1.8
		c0,0.3,0,0.5-0.1,0.8c0,0,0,0,0.1,0c0.1-0.1,0.2-0.1,0.4-0.2c0.3-0.2,0.6-0.3,1-0.5c0.1,0.3,0.1,0.5,0.1,0.7
		c0.6-0.2,1.3-0.4,1.9-0.5c0.1-0.1,0.2-0.1,0.3-0.2c0.4-0.3,0.5-0.8,0.4-1.6c-0.6-0.1-1.2-0.1-1.8-0.2
		C556.9,169.9,556.8,169.9,556.8,169.9z"
      />
      <path
        class="st2"
        d="M533.7,224.7c0.2-0.3,0.4-0.6,0.6-0.9c-0.2,0-0.4,0.1-0.5,0.2C533.6,224,533.6,224.4,533.7,224.7
		C533.6,224.6,533.6,224.6,533.7,224.7C533.6,224.6,533.7,224.7,533.7,224.7L533.7,224.7z"
      />
      <path
        class="st2"
        d="M539,227.6c0.6-1.2-0.1-2.4-1.5-2.8c-0.2,0-0.3-0.1-0.5-0.1c-0.6-0.1-1.1-0.1-1.5-0.6
		c-0.1-0.1-0.2-0.2-0.4-0.3c-0.3,0.4-0.5,0.8-0.8,1.2c-0.1,0.1-0.2,0.2-0.2,0.4l0.1,0.1c-0.2,0.4-0.4,0.8-0.5,1.2
		c-0.3,1.3,0.5,2.3,2,2.6C537.1,229.5,538.5,228.8,539,227.6z"
      />
      <path
        class="st2"
        d="M492.3,189.1c1.1,0.4,2.6,0,3.4-0.8s1-2,0.4-2.9c-0.3-0.4-0.7-0.7-0.9-1c-1.7-0.3-2.9,0.2-4,0.9
		c-0.1,0.4-0.3,0.8-0.4,1.2C490.5,187.7,491.1,188.7,492.3,189.1z"
      />
      <path
        class="st2"
        d="M500.5,190.5c-0.1-0.4-0.7-0.8-1.2-1c-0.9-0.3-1.8-0.4-2.7-0.6c-0.8-0.1-1.5,0.1-2,0.7
		c-0.6,0.6-0.5,1.3-0.2,1.9c0.3,0.5,1,0.7,1.9,0.5c0.4-0.1,0.8-0.2,1.3-0.3c0.3,0.4,0.5,0.8,0.8,1.2c0.4,0,0.8-0.1,1.1-0.1
		c0.3,0,0.7,0.2,1.1,0.4c0.4-0.5,0.8-1,1.2-1.6C501.2,191.4,500.7,191.2,500.5,190.5z"
      />
      <path
        class="st2"
        d="M530.5,230.7c0.2,0.1,0.3,0.3,0.5,0.4c0,0,0.1,0,0.1,0.1c0.8,0.1,1.3-0.3,1.6-0.9c0.1-0.1,0.1-0.2,0.2-0.4
		c0.4-0.8,0.2-1.6-0.4-2.3C531.9,228.7,531.2,229.7,530.5,230.7z"
      />
      <path
        class="st2"
        d="M531.3,226.9c-0.5-0.1-1-0.2-1.5-0.3c0.2-0.7,0.3-1.2,0-1.7c-0.2-0.4-0.5-0.8-1.1-1.1
		c-0.4,0.4-0.6,0.8-0.6,1.1c-0.1,0.7,0.5,1.3,0.9,1.9c-0.4,0.4-0.8,0.7-1.1,1.1c0.3,0.9,0.9,1.5,1.5,2c0.2,0.1,0.3,0.2,0.5,0.4
		c0.2-0.2,0.3-0.5,0.5-0.8c0.5-0.8,1-1.5,1.6-2.3C531.8,227.1,531.6,227,531.3,226.9z"
      />
      <path
        class="st2"
        d="M397.6,239.9c0,0.3,0.2,0.6,0.3,0.9c0.3,0.5,0.9,0.8,1.6,0.9h0.1c0.3,0,0.7,0,1.1-0.1c1-0.2,1.8-0.8,2.1-1.6
		c0.2-0.4,0.2-0.7,0.2-1.1c-0.2-1.2-1.6-2-3.1-1.7C398.4,237.5,397.4,238.7,397.6,239.9z"
      />
      <path
        class="st2"
        d="M494.2,196.5c-0.4-1.1-1.5-1.6-2.8-1.5c-1,0.1-2,0.9-2.3,1.7c-0.4,1,0.1,2,1.1,2.5c1.1,0.5,2.2,0.3,3.2-0.5
		c0.5-0.4,1-0.8,1.7-1.3C494.2,197.5,494.4,196.9,494.2,196.5z"
      />
      <path
        class="st2"
        d="M396.1,229.8C396.1,229.7,396.2,229.7,396.1,229.8C396.1,229.7,396.1,229.7,396.1,229.8
		C396.1,229.7,396.1,229.8,396.1,229.8L396.1,229.8z"
      />
      <path
        class="st2"
        d="M396.2,232.6c0.3,0.3,0.6,0.5,1,0.6c0.5,0.2,1.2,0.2,1.8,0c0.5-0.1,1-0.4,1.3-0.7c0,0,0.1,0,0.1-0.1
		c0.7-0.8,0.8-2,0.2-2.7l0,0c-0.6-0.8-1.9-1-3.1-0.6c-0.5,0.2-1,0.4-1.4,0.7c-0.1,0.4-0.3,0.8-0.4,1.1
		C395.7,231.5,395.8,232.1,396.2,232.6z"
      />
      <path
        class="st2"
        d="M306.3,241.1c0.3,0.2,0.6,0.4,0.9,0.6c0.1,0.1,0.3,0.2,0.4,0.3c0-0.1-0.1-0.2-0.1-0.3
		c-0.1-0.2-0.2-0.4-0.4-0.6c-0.2-0.1-0.4-0.2-0.6-0.4C306.5,240.9,306.4,241,306.3,241.1z"
      />
      <path
        class="st2"
        d="M396.8,247c-0.2-0.2-0.4-0.4-0.7-0.4c-0.6,0-1.2,0.2-1.9,0.3c-0.6-1.5-1.3-1.9-2.8-1.6c-0.3,0.1-0.6,0.2-1,0.4
		c0.4,0.3,0.6,0.5,0.9,0.7c-0.5,0.5-1,1-1.5,1.5c-0.1,0.1-0.1,0.1-0.2,0.2c0.5,0.4,0.8,0.7,1.2,0.9c0.8,0.3,1.6,0.1,2.9-0.8
		c1.3,1,1.8,1.1,2.6,0.6C397.1,248.2,397.3,247.5,396.8,247z"
      />
      <path
        class="st2"
        d="M579.7,179.8c0-0.1,0.1-0.3,0.1-0.4c0-0.2,0-0.3,0-0.5c-0.2-1.2-1.6-2-3-1.7c-0.1,0-0.1,0-0.1,0
		c-1.2,0.3-2.1,1.3-2,2.4c0,0.1,0,0.1,0,0.2c0.1,0.9,1,1.6,2,1.7c0.3,0,0.7,0,1,0c0.2,0,0.5-0.1,0.7-0.2
		C579,180.9,579.5,180.4,579.7,179.8z"
      />
      <path
        class="st2"
        d="M312.2,246.1c-1-0.6-1.9-1.2-2.9-1.7l0,0c-0.3,0.3-0.6,0.7-0.7,1.2c-0.1,0.2-0.1,0.5,0,0.7
		c0,0.1,0,0.1,0.1,0.2c0.2,0.8,1,1.3,2,1.4c0.3,0,0.6,0,0.9,0c0.5-0.1,0.9-0.3,1.2-0.5c0.1-0.1,0.3-0.2,0.4-0.3s0.2-0.2,0.3-0.3
		c-0.2-0.1-0.4-0.2-0.5-0.3C312.6,246.3,312.4,246.2,312.2,246.1z"
      />
      <path
        class="st2"
        d="M392.7,226.1c-0.6,0-1.2,0.1-1.6,0.4c-0.4,0.3-0.8,0.9-0.8,1.5c0,0,0,0,0,0.1l0.1-0.1
		C391.1,227.4,391.9,226.8,392.7,226.1z"
      />
      <path
        class="st2"
        d="M394.8,228.6c-0.1-0.4-0.1-0.9-0.3-1.3c-0.1-0.2-0.3-0.4-0.5-0.6c-1.1,0.9-2.2,1.7-3.3,2.6c0,0,0,0-0.1,0.1
		c0.1,0.1,0.3,0.2,0.4,0.3c0.3,0.1,0.6,0.3,0.9,0.3c0.2,0,0.4,0,0.6,0l0,0c0.3,0,0.6,0,0.8,0.1c1,0.4,1.8,0.2,2.7-0.3
		c0.1-0.2,0.2-0.4,0.3-0.7C395.8,228.9,395.3,228.7,394.8,228.6z"
      />
      <path
        class="st2"
        d="M555.5,197.6c0.2-0.3,0.4-0.6,0.6-0.9c0.4-0.1,0.7-0.1,0.9-0.1c0-0.1,0-0.1,0-0.2c-0.4-0.1-0.9-0.2-1.3-0.2
		l0.1-0.1c0.3,0,0.5,0,0.8-0.1c0-0.1,0-0.2,0-0.3c-1.3,0-2.6-0.1-3.9-0.1c-0.2,0-0.4,0.1-0.5,0.1c-1.2,0.3-1.7,0.6-1.9,1.2
		c-0.1,0.4,0,0.8,0.1,1.5c0.5,0,0.9,0,1.4,0c0.1,0,0.1,0,0.2,0c0,0.2,0.1,0.4,0.1,0.7c0.8-0.2,1.4-0.5,2.1-0.5
		C555,198.3,555.3,198.1,555.5,197.6z"
      />
      <path
        class="st2"
        d="M513.4,201.7c-0.5-0.7-0.1-1.2,0.2-1.8c0.5-0.9,0.4-1.1-0.8-1.7c-0.5,0.3-0.9,0.8-1.4,0.9
		c-0.9,0.1-1.4,0.6-2,1.2c0.2,0.5,0.3,0.9,0.5,1.3c0.2,0.4,0.4,0.8,0.7,1.2c0.2,0.3,0.6,0.5,0.9,0.5
		C512.3,203.3,513.7,202.1,513.4,201.7z"
      />
      <path
        class="st2"
        d="M414.1,244.4c-0.5-0.6-1.4-0.9-2.3-0.7c-0.1,0-0.3,0.1-0.4,0.1c-1,0.4-1.6,1.4-1.4,2.3
		c0.3,1.1,1.5,1.6,2.8,1.3c1.2-0.3,1.9-1.3,1.7-2.3C414.4,244.9,414.3,244.6,414.1,244.4z"
      />
      <path
        class="st2"
        d="M555.9,215.2c0.5-0.2,1-0.4,1.5-0.6c0.1-0.1,0.2-0.1,0.3-0.2c0.6-0.5,0.8-1.2,0.6-1.8
		c-0.1-0.4-0.4-0.7-0.9-0.9c-1.6-0.5-3.7,0.8-3.6,2.3c0,0.5,0.3,1-0.1,1.7C554.6,215.5,555.3,215.4,555.9,215.2z"
      />
      <path
        class="st2"
        d="M316.5,238.8c-0.4-0.2-1-0.3-1.5-0.2c-1.3,0.2-2.1,1.3-1.9,2.4c0.2,1,1.3,1.6,2.5,1.3c0.6-0.1,1.2-0.4,1.5-0.8
		c0.3-0.4,0.5-0.9,0.4-1.4C317.5,239.5,317.1,239,316.5,238.8z"
      />
      <path
        class="st2"
        d="M584.4,201.2c0.2,0,0.5,0,0.7,0c-0.1-1-0.4-1.7-1-2.1c-0.2-0.2-0.4-0.3-0.7-0.4c-0.1,0-0.3-0.1-0.4-0.1
		c-0.3-0.1-0.6-0.1-1-0.1c-1.4,0.1-2.4,0.8-2.7,1.8c-0.1,0.3-0.2,0.6-0.2,0.9c1.4,0,2.7-0.1,4.2-0.1
		C583.7,201.2,584.1,201.2,584.4,201.2z"
      />
      <path
        class="st2"
        d="M309.6,239.2c0.1,0,0.1,0,0.2,0c1.2-0.3,2-1.3,1.7-2.3l0,0c-0.3-1-1.4-1.6-2.6-1.3c-0.8,0.2-1.4,0.7-1.7,1.4
		c-0.1,0.3-0.2,0.7-0.1,1v0.1C307.4,238.9,308.4,239.4,309.6,239.2z"
      />
      <path
        class="st2"
        d="M506.5,197c0,0.1-0.1,0.2,0,0.3c0.1,0.4,0.2,0.8,0.4,1.1c0.2,0.4,0.6,0.8,1.3,0.5c0.6-0.2,0.6-0.6,0.5-1.1
		c0-0.4-0.2-0.9,0-1.2c1.3-1.5,0.5-2.6-0.5-3.7C506.7,194.2,505.5,195.3,506.5,197z"
      />
      <path
        class="st2"
        d="M321.2,234.5L321.2,234.5v-0.1c-0.4-0.6-1-0.8-1.8-0.8c-0.6,0.1-1.2,0.3-1.4,0.7c-0.1,0.1-0.1,0.3-0.2,0.4
		c-0.1,0.7-0.6,1-1,1.4c-0.1,0.1-0.1,0.1-0.2,0.2c0.3,0.5,0.4,0.7,0.6,0.9s0.5,0.2,1,0.3c0.2-0.1,0.3-0.3,0.5-0.4
		c0.1-0.1,0.2-0.2,0.4-0.3c0.1,0.3,0.1,0.4,0.2,0.5c0.1-0.1,0.3-0.2,0.4-0.3s0.2-0.1,0.2-0.2c0.3-0.2,0.6-0.4,0.9-0.6
		C321.4,235.7,321.5,235,321.2,234.5z"
      />
      <path
        class="st2"
        d="M471.1,236.5c-1.2,0.3-1.9,1.4-1.6,2.4c0.3,0.9,1.4,1.4,2.5,1.1c1.2-0.3,2-1.4,1.7-2.3
		C473.4,236.8,472.1,236.2,471.1,236.5z"
      />
      <path
        class="st2"
        d="M601.7,187.1L601.7,187.1c0.6-0.1,1.1-0.4,1.4-0.7c0.4-0.4,0.6-0.9,0.5-1.5c-0.2-0.9-1.2-1.5-2.4-1.3
		c-0.2,0-0.3,0.1-0.5,0.1c-0.8,0.3-1.4,1.1-1.3,2c0,0.2,0.1,0.3,0.1,0.4C599.9,186.8,600.8,187.3,601.7,187.1z"
      />
      <path
        class="st2"
        d="M563.1,182.6C563,182.6,563,182.6,563.1,182.6c-0.1-0.2-0.3-0.3-0.4-0.4c-0.3-0.3-0.6-0.5-1-0.7
		c-0.1,0-0.2-0.1-0.3-0.1c-0.3,0.2-0.5,0.4-0.8,0.6c-0.2,0.2-0.5,0.4-0.7,0.6c-0.5,0.5-0.6,1.1-0.4,1.7l0,0c0.1,0.3,0.3,0.5,0.6,0.7
		c0.2,0.1,0.4,0.2,0.6,0.3c0.3,0.1,0.5,0.1,0.8,0.1c0.2,0,0.5-0.1,0.7-0.2c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.3-0.2,0.4-0.3l0.1-0.1
		c0.2-0.3,0.4-0.6,0.6-0.9c0.1-0.1,0.1-0.2,0.2-0.3c-0.1-0.1-0.2-0.1-0.2-0.2C563.3,182.9,563.2,182.8,563.1,182.6z"
      />
      <path
        class="st2"
        d="M501.2,183.6c0.2,0,0.4,0.1,0.5,0.2l0,0c0.3,0.2,0.5,0.3,0.7,0.3s0.4-0.2,0.7-0.8c-0.1-0.1-0.2-0.1-0.3-0.2
		l0,0c-0.1-0.1-0.3-0.2-0.4-0.3c0.4-1.3,0.3-1.8-0.5-2.2c-0.9-0.5-1.8-0.2-2.7,0.4c-0.1,0.1-0.2,0.1-0.3,0.2
		C498.5,183,498.8,183.4,501.2,183.6z"
      />
      <path
        class="st2"
        d="M589.5,181.9c-0.2-0.2-0.3-0.4-0.5-0.5c-0.2-0.2-0.5-0.4-0.9-0.5s-0.8-0.2-1.3-0.1c-0.3,1.2-0.6,2.4-0.8,3.5
		c-0.1,0.4,0.4,0.9,0.9,0.6c0.9-0.4,1.8-0.9,2.6-1.5C589.9,183,589.9,182.3,589.5,181.9z"
      />
      <path
        class="st2"
        d="M553.1,173.2L553.1,173.2L553.1,173.2c0,0-0.1,0-0.2,0c-0.1,0.1-0.1,0.1-0.2,0.2
		C552.8,173.4,553,173.3,553.1,173.2z"
      />
      <path
        class="st2"
        d="M553.2,177.5c0.1-0.5,0.2-1,0.3-1.5s0.2-1.1,0.3-1.6c-0.3,0.1-0.6,0.2-0.9,0.3c-0.4,0.1-0.7,0.2-1.1,0.3
		c-0.1,0.4-0.3,0.7-0.4,1.1c-0.2,0.6,0.3,1,0.9,1.4C552.6,177.7,552.9,177.7,553.2,177.5z"
      />
      <path
        class="st2"
        d="M554.5,176.8c0.2-0.2,0.4-0.3,0.6-0.5c-0.2-0.6-0.4-1.1-0.6-1.7c-0.2,0.2-0.3,0.4-0.3,0.6
		c-0.1,0.4-0.1,0.9-0.2,1.3c0,0.2-0.1,0.4-0.1,0.6C554.1,177,554.3,176.9,554.5,176.8z"
      />
      <path
        class="st2"
        d="M566.5,189.7L566.5,189.7c0.6-0.1,1-0.5,1.3-0.9s0.4-0.8,0.3-1.1l0,0c-0.2-0.9-1.3-1.5-2.4-1.2
		c-0.1,0-0.2,0.1-0.3,0.1c-0.3,0.1-0.5,0.2-0.7,0.3c0,0.1-0.1,0.3-0.1,0.4c-0.1,0.5-0.2,1-0.3,1.5v0.1
		C564.7,189.5,565.6,189.9,566.5,189.7z"
      />
      <path
        class="st2"
        d="M552.7,188.3c0.6-0.2,1.1-0.3,1.7-0.4c0.6-0.2,1.1-0.4,1.7-0.8c-0.4,0-0.6,0.1-0.9,0.1c-0.2,0-0.4,0-0.6,0.1
		c-0.5-1-0.6-1.1-1.5-1.3c0,0,0,0-0.1,0s-0.2,0-0.4-0.1c-0.1,0-0.3-0.1-0.4-0.1c-0.2,0.7-0.4,1.5-0.6,2.2l0,0c0.1,0,0.1,0.1,0.2,0.1
		C552.2,188.2,552.4,188.3,552.7,188.3C552.6,188.3,552.6,188.3,552.7,188.3z"
      />
      <path
        class="st2"
        d="M550.8,187.2c0.1,0.1,0.2,0.2,0.3,0.3c0.2-0.7,0.4-1.4,0.6-2.2c-0.6-0.3-1.1,0-1.7,0.3c0.1,0.5,0.3,1,0.6,1.4
		C550.6,187.1,550.7,187.1,550.8,187.2z"
      />
      <path
        class="st2"
        d="M347.4,265c-1.1,0.3-1.8,1.2-1.5,2c0.2,0.8,1.2,1.3,2.2,1.1c1.1-0.2,1.9-1.1,1.7-2
		C349.5,265.2,348.5,264.8,347.4,265z"
      />
      <path
        class="st2"
        d="M342.8,271c-0.8,0.1-1.4,0.6-1.6,1.1h3.7C344.8,271.4,343.8,270.8,342.8,271z"
      />
      <path
        class="st2"
        d="M446.2,208.7c-0.3-0.1-0.7-0.1-1,0c-0.8,0.2-1.4,0.8-1.6,1.4c0,0.1,0,0.3,0,0.4c0,0.3,0.2,0.5,0.4,0.7
		c0.5,0.4,1.2,0.6,1.9,0.4c0.9-0.2,1.5-0.9,1.5-1.7c0-0.1,0-0.2,0-0.3C447.2,209.3,446.8,208.9,446.2,208.7z"
      />
      <path
        class="st2"
        d="M327.2,237.6c-0.3-0.7-1.2-1.1-2.1-0.9c-1,0.2-1.7,1.1-1.5,1.9c0.1,0.7,0.7,1.1,1.5,1.1c0.2,0,0.4,0,0.6-0.1
		c1.1-0.2,1.7-1,1.5-1.9C327.3,237.8,327.2,237.7,327.2,237.6z"
      />
      <path
        class="st2"
        d="M314.6,230.8c-0.3-0.1-0.5-0.2-0.9-0.3c-0.2,0-0.4,0-0.6,0c-0.9,0.2-1.6,1-1.5,1.8c0.1,0.9,1,1.4,2.1,1.2
		c0.4-0.1,0.7-0.2,0.9-0.4c0.2-0.1,0.3-0.3,0.5-0.5c0.2-0.3,0.2-0.6,0.2-0.9C315.2,231.3,315,231,314.6,230.8z"
      />
      <path
        class="st2"
        d="M482.4,222.5c-0.2-0.8-1.2-1.3-2.2-1c-0.9,0.2-1.5,1-1.4,1.7c0,0.1,0,0.1,0,0.2c0.2,0.8,1.2,1.3,2.2,1.1
		c0.5-0.1,0.9-0.4,1.2-0.8c0.1-0.1,0.2-0.3,0.2-0.4C482.4,223,482.5,222.8,482.4,222.5L482.4,222.5z"
      />
      <path
        class="st2"
        d="M582.6,188.4c0.1,0.8,1,1.3,1.9,1.2c1-0.2,1.9-1.2,1.7-2c-0.1-0.7-1.4-1.2-2.3-1
		C583,186.8,582.4,187.6,582.6,188.4z"
      />
      <path
        class="st2"
        d="M531.3,210.5c-0.1-0.4-0.5-0.8-0.4-1.1c0.4-0.8-0.1-1.1-0.5-1.5c-1.1,0.3-0.6,0.8-0.6,1.3
		c-0.4-0.2-0.8-0.4-1.2-0.6c0,0-0.1,0-0.1,0.1c-0.2,0.4-0.4,0.9-0.6,1.3c0.8,1.3,0.8,1.3,2.4,1.5C531,211.5,531.5,211.1,531.3,210.5
		z"
      />
      <path
        class="st2"
        d="M527.5,234.9c-0.4,0.5-0.7,1-1.1,1.5c0.7-0.3,1.2-0.6,1.7-0.8c0.2-0.1,0.4-0.2,0.6-0.4
		c0.2-0.2,0.4-0.4,0.4-0.8c-0.3-0.1-0.6-0.3-0.9-0.5C528,234.3,527.8,234.6,527.5,234.9z"
      />
      <path
        class="st2"
        d="M527.5,233.7c-0.3,0-0.5-0.1-0.8,0c-0.7,0.2-1.3,0.6-2,0.9c-0.1,0.4,0,0.7,0.1,1s0.3,0.6,0.6,0.8
		c0.4-0.5,0.8-1,1.2-1.6C527,234.5,527.3,234.1,527.5,233.7z"
      />
      <path
        class="st2"
        d="M306.6,249.6c-0.2,0.1-0.4,0.2-0.6,0.3v-3.7v-0.4v-0.6v-0.5c0.2-0.1,0.4-0.2,0.6-0.3c0.3-0.2,0.6-0.4,0.8-0.7
		c0.1-0.1,0.2-0.3,0.2-0.4c-0.5-0.3-1.1-0.6-1.6-1l0,0l0,0v0.7v0.9c-0.8-0.1-1.6-0.2-2.4-0.4c-0.1,0-0.2,0-0.3,0
		c0.3-0.5,0.5-0.9,0.7-1.3c0.2-0.3,0.3-0.6,0.4-0.9c-0.7-0.4-1.4-0.8-2.1-1.3c-1.4-0.8-2.8-1.7-4.1-2.5c-0.8,1.2-0.8,1.2-2.1,1
		c0-0.2,0-0.4,0.1-0.6c0.6-0.8,0-1.4-0.5-1.9c-0.3-0.3-0.9-0.4-1.4-0.6c0-0.1,0-0.2-0.1-0.3l0,0l0,0l0,0c0,0-0.1,0-0.1-0.1v0.1l0,0
		c-0.2,0.1-0.2,0.3,0.1,0.3c-0.1,0.5-0.2,0.9-0.3,1.3c-0.3,0.1-0.6,0.1-0.9,0.2c0.1,0.2,0.1,0.4,0.2,0.6l0,0l0,0l0,0l0,0
		c0,0,0,0,0,0.1c0,0,0,0,0.1,0c0.3,0.5,0.4,1.2,1,1.5c1.4,0.6,0.9,1.6,0.7,2.5c-1.1,0.4-2,0.3-2.9,0.1c-1.8-0.3-3.3,0.2-4.6,1.5
		l-0.1,0.1c-0.4,0.5-0.7,0.9-0.9,1.4c-0.3,0.9-0.2,1.8,0.3,2.7c0.3,0.5,0.7,1,0.9,1.5c0.1,0.3,0.1,0.6,0,1c-0.1,0.2,0.2,0.5,0.5,0.7
		l0.1,0.1c0.1,0.1,0.2,0.1,0.3,0.2c0.2,0.1,0.3,0.2,0.5,0.3s0.4,0.2,0.5,0.2c1.7,0.7,3.4,0.1,4-1.3c0.1-0.3,0.2-0.7,0.2-1.1
		c0-0.5,0.1-0.9,0.5-1.3c0.3-0.3,0.6-0.7,0.8-1c0.6-1,0.6-2,0.1-3c-0.1-0.2,0-0.5,0.1-1c1.7,1.9,2.4,2.2,5.4,2.2
		c-0.3,0.3-0.5,0.6-0.7,1c0,0.1-0.1,0.1-0.1,0.2c-0.3,0.5-0.5,0.9-0.6,1.4c0,0.1,0,0.2-0.1,0.3c-0.3,1.8,0.6,3.6,2.7,4.4
		c1.4,0.6,3,0.6,4.4,0.1v-0.1c0.4,0.2,0.9,0.3,1.4,0.1c0.9-0.2,1.6-1.1,1.3-1.8C308.5,249.8,307.5,249.4,306.6,249.6z M294.5,238.1
		c-0.1-0.2-0.1-0.4-0.2-0.5c0.1,0,0.1,0,0.2-0.1c0.1,0.2,0.1,0.4,0.2,0.5C294.6,238.1,294.5,238.1,294.5,238.1z"
      />
      <path
        class="st2"
        d="M579.1,197.4c0.4,0.1,0.8,0.2,1.2,0.1c0.1,0,0.3-0.1,0.4-0.1c0.4-0.2,0.7-0.5,0.8-0.9c0.1-0.3,0.1-0.6,0-0.9
		c-0.2-0.7-1.1-1.1-2-0.9c0,0,0,0-0.1,0c-0.3,0.1-0.6,0.3-0.8,0.5s-0.3,0.4-0.4,0.7c-0.1,0.3-0.1,0.5,0,0.8
		C578.4,197,578.7,197.3,579.1,197.4z"
      />
      <path
        class="st2"
        d="M592.6,220.9c0-0.2-0.2-0.4-0.3-0.6c-0.4-0.3-0.9-0.5-1.5-0.4c-0.1,0-0.2,0-0.3,0.1c-0.7,0.2-1.2,0.9-1.1,1.5
		c0.1,0.8,0.9,1.3,1.8,1.1C591.9,222.5,592.7,221.6,592.6,220.9z"
      />
      <path
        class="st2"
        d="M517.1,249.3c0.7-0.2,1.4-0.7,2.1-1.3c-0.5-0.1-1.1-0.1-1.6-0.1c-0.1,0-0.2,0-0.3,0c-0.4,0.4-0.7,0.9-1.1,1.3
		c0.2,0.1,0.5,0.1,0.7,0.2C516.9,249.3,517,249.3,517.1,249.3z"
      />
      <path
        class="st2"
        d="M515.3,247.9c-0.7,0.1-1.5,0.1-2.3,0.2c-0.1,0-0.2,0-0.3,0c0.1,0.1,0.3,0.2,0.4,0.3c0.1,0,0.1,0,0.2,0
		c0.6,0.1,1.2,0.1,1.8,0c0.5-0.1,0.9-0.3,1.4-0.7C516.1,247.9,515.7,247.9,515.3,247.9z"
      />
      <path
        class="st2"
        d="M584.5,222.1c-0.7,0.1-1.3,0.7-1.4,1.2c0,0.2,0,0.4,0,0.5c0.1,0.5,0.7,0.8,1.3,0.9c0.2,0,0.5,0.1,0.8,0
		c0.9-0.2,1.4-1,1.3-1.7C586.2,222.3,585.4,221.9,584.5,222.1z"
      />
      <path
        class="st2"
        d="M417.8,247.4c-0.9,0.2-1.4,1-1.2,1.8c0.1,0.4,0.4,0.6,0.7,0.8c0.3,0.1,0.7,0.2,1.1,0.1c0.5-0.1,1-0.5,1.2-0.9
		c0.1-0.3,0.2-0.5,0.1-0.8C419.6,247.6,418.7,247.2,417.8,247.4z"
      />
      <path
        class="st2"
        d="M516.7,251.4c0.1,0.7,1,1.2,1.9,1c0.5-0.1,1-0.5,1.2-0.9c-1-0.3-1.9-0.5-2.9-0.9
		C516.7,250.9,516.6,251.1,516.7,251.4z"
      />
      <path
        class="st2"
        d="M519.4,250.1c-0.3-0.3-0.7-0.4-1.2-0.3C518.6,249.8,519,249.9,519.4,250.1z"
      />
      <path
        class="st2"
        d="M602.2,189.6c-0.8,0-1.6,0.3-2,1.2c0.3,0.3,0.5,0.7,0.8,0.9c0.6,0.4,1.2,0.3,1.9-0.1c0.5-0.3,0.8-0.6,0.7-1.2
		C603.5,189.9,603,189.6,602.2,189.6z"
      />
      <path
        class="st2"
        d="M544.3,186.4c-0.5,0.4-0.6,0.8-0.2,1.3c0,0,0,0.1,0.1,0.1c0.1,0.2,0.3,0.3,0.4,0.5c0.2,0.2,0.3,0.3,0.5,0.3
		c0.3,0.1,0.6,0.1,0.9-0.1c0.7-0.3,0.8-0.8,0.7-1.4c-0.1-0.2-0.3-0.5-0.5-0.7C545.7,186,544.9,186,544.3,186.4z"
      />
      <path
        class="st2"
        d="M317.9,228c0.8-0.2,1.3-0.8,1.2-1.4c-0.1-0.7-1-1.1-1.8-0.9c-0.7,0.2-1.3,0.8-1.2,1.4
		C316.3,227.8,317,228.2,317.9,228z"
      />
      <path
        class="st2"
        d="M306.2,269.4c-0.1,0-0.1,0-0.2,0.1v1c0.5,0.3,0.9,0.6,1.4,1c0.4-0.3,0.6-0.7,0.5-1.2
		C307.6,269.7,306.8,269.2,306.2,269.4z"
      />
      <path
        class="st2"
        d="M307.4,259c-0.4-0.3-0.9-0.6-1.3-0.9c-0.1,0-0.1-0.1-0.2-0.1v0.2v1.5c0.2,0,0.4,0,0.5,0
		C306.9,259.6,307.2,259.3,307.4,259z"
      />
      <path
        class="st2"
        d="M565.8,190.2c-0.1,0-0.3,0.1-0.4,0.1c-0.4,0.2-0.7,0.6-0.8,1c0,0.1,0,0.2,0,0.4c0.1,0.6,0.7,1.1,1.3,0.9
		c0.6-0.1,1.1-0.6,1.4-1.1c0.1-0.2,0.2-0.5,0.2-0.7s-0.2-0.4-0.5-0.5C566.5,190.2,566.1,190.1,565.8,190.2z"
      />
      <path
        class="st2"
        d="M324,269.6C323.9,269.6,323.9,269.6,324,269.6c-0.2,0.1-0.3,0.1-0.5,0.2c-1,0.4-1.4,1-1.3,1.8
		c0,0.2,0.1,0.4,0.1,0.6h0.5h0.3c0.6-0.2,1-0.4,1.2-0.7C324.6,271,324.5,270.4,324,269.6L324,269.6z"
      />
      <path
        class="st2"
        d="M584.5,218.4c-1.4,0.1-2.6,0.3-4,0.4c0.7,1.2,1.1,1.5,2.2,1.3C583.7,219.9,584.3,219.4,584.5,218.4z"
      />
      <path
        class="st2"
        d="M592.9,225.1c-0.8,0.2-1.2,0.8-1,1.5c0.2,0.6,0.8,0.9,1.5,0.7s1.1-0.8,1-1.3
		C594.3,225.3,593.5,225,592.9,225.1z"
      />
      <path
        class="st2"
        d="M518.5,238c-0.7,0.1-1.2,0.7-1.2,1.3c0,0.4,0.4,0.7,0.8,0.9c0.2,0.1,0.5,0.1,0.8,0s0.5-0.2,0.7-0.4
		c0.3-0.2,0.4-0.6,0.3-0.9C519.8,238.2,519.2,237.9,518.5,238z"
      />
      <path
        class="st2"
        d="M322.5,243.7c0.2-0.5,0-0.9-0.5-1.1c-0.9-0.3-1.5,0.1-2,0.6c0,0.7,0.3,1.3,1.2,1.4
		C321.7,244.6,322.3,244.3,322.5,243.7z"
      />
      <path
        class="st2"
        d="M522.5,245c-0.7,0.3-0.9,0.7-0.8,1.7c0.5,0,0.9,0,1.3-0.1c0.7-0.2,1.3-0.5,1.9-1.1c-0.4-0.4-0.8-0.6-1.2-0.7
		S522.9,244.8,522.5,245z"
      />
      <path
        class="st2"
        d="M489.4,206.7c-0.5,0.1-0.9,0.6-1,1c0,0.1,0,0.2,0,0.3c0.2,0.5,0.9,0.9,1.6,0.7c0.1,0,0.2-0.1,0.3-0.2
		c0.5-0.3,0.7-0.7,0.6-1.2S490.1,206.5,489.4,206.7z"
      />
      <path
        class="st2"
        d="M567.3,201.5C567.2,201.5,567.2,201.5,567.3,201.5c-0.2,0.1-0.2,0.1-0.3,0.2c-0.2,0.3-0.2,0.8,0.1,1.3
		c0.3,0.4,0.8,0.6,1.4,0.3c0.4-0.2,0.7-0.4,1.2-0.7c-0.2-0.3-0.3-0.4-0.4-0.6C568.8,201.4,567.9,201.2,567.3,201.5z"
      />
      <path
        class="st2"
        d="M589.5,198.6c0-0.2-0.2-0.3-0.3-0.4c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2-0.1-0.5-0.1-0.7,0
		c-0.4,0.1-0.6,0.3-0.8,0.6c-0.1,0.2-0.2,0.5-0.1,0.8c0.2,0.5,0.8,0.8,1.4,0.7c0.5-0.1,1-0.6,1-1
		C589.5,198.8,589.5,198.7,589.5,198.6z"
      />
      <path
        class="st2"
        d="M464.1,242c-0.5,0.1-0.9,0.5-1,0.9c0,0.1,0,0.3,0,0.4c0.1,0.6,0.8,0.9,1.5,0.7c0.1,0,0.2-0.1,0.3-0.1
		c0.5-0.2,0.9-0.8,0.8-1.2C465.6,242.2,464.8,241.9,464.1,242z"
      />
      <path
        class="st2"
        d="M503.1,198.5c-0.4,0.5-0.7,1.1-1.1,1.6c-0.4,0.1-0.8,0.2-1.3,0.3c0.3,0.5,0.6,0.9,0.9,1.5
		c0.8-0.9,1.5-1.5,2-2.2C504.1,199.1,504.1,198.7,503.1,198.5z"
      />
      <path
        class="st2"
        d="M525.2,204c-0.4-0.8-0.9-1.5-0.9-2.3c0-0.2-0.4-0.4-0.7-0.7c0.2,1.3,0.2,1.3-0.6,2.6c0.1,0.1,0.1,0.1,0.1,0.2
		c0.8,0.9,0.9,0.9,2.2,0.5C525.3,204.2,525.3,204.1,525.2,204z"
      />
      <path
        class="st2"
        d="M392.1,252.2c0.6-0.1,1.1-0.6,1-1.1c-0.1-0.6-0.7-1-1.4-0.9c-0.6,0.1-1.1,0.7-1,1.2
		C390.7,252,391.4,252.4,392.1,252.2z"
      />
      <path
        class="st2"
        d="M611.5,218.4c-0.7,0.1-1.2,0.7-1.1,1.3c0.1,0.5,0.8,0.8,1.4,0.7c0.1,0,0.2,0,0.3-0.1v-1.9
		C611.9,218.4,611.7,218.4,611.5,218.4z"
      />
      <path
        class="st2"
        d="M520.5,203.5c-0.1,0.1-0.2,0.3-0.2,0.4C520.3,203.9,520.4,203.7,520.5,203.5z"
      />
      <path
        class="st2"
        d="M518.6,204.3c0.3-0.5,0.5-1,0.8-1.5c-0.2,0-0.3-0.1-0.4-0.3c0-0.1-0.6-0.1-0.9-0.1
		C517.8,203.2,517.7,203.9,518.6,204.3z"
      />
      <path
        class="st2"
        d="M495.9,181.5c-0.6,0.3-0.7,0.8-0.6,1.2c0.1,0.5,0.3,1,1.2,0.8c0.3-0.7,0.6-1.4,0.9-2
		C496.9,180.7,496.4,181.2,495.9,181.5z"
      />
      <path
        class="st2"
        d="M539.8,218.1c-0.2,0.1-0.4,0.5-0.4,0.8c0,0.5,0.4,0.8,1,0.9c0.6,0,1.2-0.1,1.4-0.9c-0.3-0.3-0.6-0.6-1.1-0.9
		C540.6,217.9,540.1,217.9,539.8,218.1z"
      />
      <path
        class="st2"
        d="M537.2,205.7c0.2,0.3,0.4,0.6,0.6,0.8c0.5,0,0.9,0,1.2,0c1.1-0.8,0.5-1.3,0-1.8
		C538.3,204.9,537.5,204.9,537.2,205.7z"
      />
      <path
        class="st2"
        d="M395.8,242.6c0.3-0.1,0.5-0.2,0.6-0.4c0.4-0.3,0.6-0.8,0.5-1.5c-0.5,0.2-0.9,0.3-1.3,0.5
		c-0.3,0.1-0.5,0.2-0.8,0.4c-0.3,0.1-0.5,0.3-0.7,0.5l0,0C394.5,242.8,395.1,242.9,395.8,242.6z"
      />
      <path
        class="st2"
        d="M474,233.8c-0.3-0.5-0.6-0.8-1-1.3c-0.5,0.5-0.8,0.9-1.2,1.2c0.3,0.5,0.5,0.9,0.9,1.6
		C473.3,234.7,473.7,234.3,474,233.8z"
      />
      <path
        class="st2"
        d="M554.9,253.9c0.2,0.8,0.6,1.5,0.8,2.3c0.1-1.3,0.2-2.6,0.3-4C554.9,252.9,554.7,253.1,554.9,253.9z"
      />
      <path
        class="st2"
        d="M535.4,206.5c0.1-0.3,0-0.6,0-0.9c0-0.3,0.1-0.7,0.2-1.1c-0.5,0-0.9,0-1.3-0.1c0.1-0.2,0.2-0.4,0.5-0.8
		c-0.5,0.2-0.8,0.3-1.1,0.4l0,0l0,0C534,205,534.6,205.8,535.4,206.5z"
      />
      <path
        class="st2"
        d="M507.6,192.3c-0.5-0.1-0.8-0.3-1.1-0.3c-0.6-0.1-0.9,0.3-1.1,0.7s-0.1,0.8,0.3,0.9c0.4,0.1,0.9,0,1.3-0.2
		C507.3,193.1,507.4,192.7,507.6,192.3z"
      />
      <path
        class="st2"
        d="M509.6,176c0.3-0.4,0.6-0.8,0.9-1.2c-0.4-0.1-0.9,0.2-0.9-0.3c-0.6,0.1-1.1,0.2-1.7,0.4
		C508.3,175.8,508.3,175.8,509.6,176z"
      />
      <path
        class="st2"
        d="M380.8,259.6c1-0.6,1.8-1.1,2.7-1.6C381.9,257.4,381.3,257.7,380.8,259.6z"
      />
      <path
        class="st2"
        d="M334.1,269.4c1.5-0.5,1.7-0.8,1.2-1.9C334.1,268.2,334.1,268.2,334.1,269.4z"
      />
      <path
        class="st2"
        d="M516.4,200.9c-0.1,0.1-0.3,0.4-0.2,0.5c0.1,0.8,0.7,1.1,1.8,0.9c-0.2-0.5-0.5-1-0.8-1.5
		C517.1,200.8,516.7,200.8,516.4,200.9z"
      />
      <path
        class="st2"
        d="M522.4,228.2c0.3-0.5,0.7-1,1-1.4c-0.2-0.1-0.4-0.1-0.6-0.1c-0.6,0.1-0.9,0.4-0.9,0.9
		C522,227.9,522.1,228.1,522.4,228.2z"
      />
      <path
        class="st2"
        d="M523.9,227.5c0-0.1,0-0.2-0.1-0.3c-0.3,0.4-0.6,0.7-0.8,1.1l0,0C523.6,228.2,523.9,227.9,523.9,227.5z"
      />
      <path
        class="st2"
        d="M523.9,211c-0.2-0.2-0.4-0.3-0.8-0.5c-0.4,0.9-0.4,1.4,0.2,1.7c0.2,0.1,0.6,0.3,1,0.4
		C524.4,212,524.4,211.4,523.9,211z"
      />
      <path
        class="st2"
        d="M557.8,215.9c-0.3,0.2-0.5,0.5-0.5,0.8c-0.1,0.4,0.7,0.7,1.2,0.5c0.1-0.1,0.2-0.2,0.3-0.3
		c0.2-0.2,0.3-0.4,0.6-0.6c-0.6-0.2-1-0.6-1.3-0.5C557.9,215.8,557.9,215.8,557.8,215.9z"
      />
      <path
        class="st2"
        d="M538.3,230.9c-0.3,0.5-0.5,0.8-0.6,1.1c0,0.1,0,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.3c0.2,0.2,0.7,0.3,1,0.2
		c0.6-0.1,0.9-0.5,0.7-0.9C539.4,231.5,538.9,231.3,538.3,230.9z"
      />
      <path
        class="st2"
        d="M533.5,205.7c-0.2-0.1-0.4-0.2-0.6-0.2c-0.5-0.2-0.9-0.3-1.4-0.5c-0.1,0-0.5,0.3-0.5,0.4
		c0.1,0.2,0.3,0.4,0.5,0.5l0,0c0.5,0.2,1.1,0.4,1.8,0.6C533.8,206.3,534,205.9,533.5,205.7z"
      />
      <path
        class="st2"
        d="M500.3,187.6L500.3,187.6c-0.2-0.2-0.5-0.3-0.7-0.3h-0.1c-0.3,0.1-0.6,0.5-0.6,0.7c0,0.4,0.2,0.8,0.6,1
		c0.4,0.3,0.9,0,1.3-0.5C500.6,188.2,500.5,187.9,500.3,187.6z"
      />
      <path
        class="st2"
        d="M443.7,216.3c0.1,0.9,0.1,0.9,0.8,1.3c0.6-0.2,1.2-0.6,0.9-1.2C445.1,215.9,444.5,215.9,443.7,216.3z"
      />
      <path
        class="st2"
        d="M541.1,213.6c0.3,0.1,0.7,0.2,1.2,0c-0.2-0.4-0.4-0.7-0.7-1.1C541.5,212.9,541.3,213.2,541.1,213.6z"
      />
      <path
        class="st2"
        d="M540.6,213.2c0.2-0.3,0.4-0.7,0.6-1c-0.5,0.1-0.9,0.2-1.5,0.3C540.1,212.6,540.3,212.9,540.6,213.2z"
      />
      <path
        class="st2"
        d="M422.2,242.7c-0.3,0.2-0.6,0.5-0.7,0.8c-0.1,0.4,0.5,0.7,1,0.6c0.5-0.1,0.9-0.5,0.8-0.9
		C423.2,242.8,422.6,242.5,422.2,242.7z"
      />
      <path
        class="st2"
        d="M335.9,235.4c-0.1,0-0.3-0.1-0.4-0.1c-0.5,0-1,0.5-0.7,0.9c0.1,0.2,0.3,0.3,0.4,0.4c0.1,0.1,0.2,0.1,0.2,0.1
		c0.1-0.1,0.3-0.3,0.4-0.4c0.1,0,0.2,0.1,0.3,0.1c0.3-0.2,0.4-0.5,0.2-0.7C336.3,235.6,336.1,235.5,335.9,235.4z"
      />
      <path
        class="st2"
        d="M459,236.8c-0.3,0.2-0.7,0.6-0.7,0.8c0.1,0.2,0.3,0.4,0.7,0.6c0.1,0.1,0.2,0.2,0.4,0.3c0,0,0-0.1,0.1-0.1
		c0.3-0.5,0.5-0.8,0.6-1C460,236.9,459.4,236.6,459,236.8z"
      />
      <path
        class="st2"
        d="M593.4,208.5c0.6,0.6,0.6,1.5,2.1,1.2C594.8,208.3,594.8,208.3,593.4,208.5z"
      />
      <path
        class="st2"
        d="M380.6,249.7c0.2-0.2,0.3-0.5,0.5-0.7c-0.2-0.1-0.3-0.2-0.5-0.3h-0.1c-0.1-0.1-0.3-0.1-0.4-0.1
		c-0.2,0-0.4,0.3-0.7,0.6c-0.1,0.1-0.1,0.2-0.2,0.2c0.6,0.2,1,0.5,1.2,0.4C380.5,249.8,380.6,249.8,380.6,249.7z"
      />
      <path
        class="st2"
        d="M526.4,204.8c0.6,0.4-0.4,1.3,0.6,1.6h-0.1c0,0,0,0,0,0.1l0,0c0.1,0.1,0.3,0.1,0.4,0.2
		C527.8,205.5,527.6,205.1,526.4,204.8z"
      />
      <path
        class="st2"
        d="M541.6,214.8c-0.3,0.3-0.5,0.6-0.5,0.8c0,0,0,0,0,0.1c0,0.3,0.4,0.6,1.2,0.9
		C542.7,215.8,542.3,215.3,541.6,214.8z"
      />
      <path
        class="st2"
        d="M538.4,210.4c-0.1,0.2-0.1,0.3-0.2,0.4c-0.1,0.6,0.2,0.9,0.5,1.2c0.1,0.1,0.5,0.1,0.7,0c0,0,0,0,0.1,0
		s0.2-0.4,0.2-0.5C539.3,211.2,538.9,210.9,538.4,210.4z"
      />
      <path
        class="st2"
        d="M546.6,196c-0.1-0.1-0.3-0.2-0.4-0.2c-0.2,0-0.4,0.1-0.9,0.2c0.5,0.6,0.4,1.4,1.5,1.4l0,0c0,0,0,0,0.1,0l0,0
		C547.3,196.9,546.1,196.5,546.6,196z"
      />
      <path
        class="st2"
        d="M511.1,186.2c0.1,0,0.3,0,0.4-0.1c-0.2-0.6-0.5-1.2-0.9-2.2c0,0.1-0.1,0.2-0.1,0.3c-0.2,0.5-0.6,0.8-0.3,1.3
		C510.5,185.9,510.6,186.2,511.1,186.2z"
      />
      <path
        class="st2"
        d="M557.8,207.8c0.3-0.2,0.6-0.5,0.7-0.8c0-0.1-0.4-0.3-0.9-0.5c-0.3,0.4-0.6,0.7-0.6,1
		C557,207.5,557.7,207.8,557.8,207.8z"
      />
      <path
        class="st2"
        d="M555.3,167.5c-0.2,0.2-0.3,0.4-0.5,0.6c0,0.2,0,0.4,0,0.6c0.6-0.3,1.2-0.5,1.9-0.8
		C556.1,167.8,555.8,167.7,555.3,167.5z"
      />
      <path
        class="st2"
        d="M384.8,264.2c-0.2,0.2-0.5,0.5-0.4,0.7c0,0.2,0.4,0.3,0.8,0.6c0.2-0.4,0.5-0.7,0.4-0.9
		C385.5,264.4,385.1,264.3,384.8,264.2z"
      />
      <path
        class="st2"
        d="M611.2,162.9c-0.3,0.1-0.5,0.5-0.6,0.8c0,0.1,0.5,0.3,0.9,0.4c0.3-0.3,0.6-0.6,0.6-0.8
		C612,163,611.7,162.7,611.2,162.9z"
      />
      <path
        class="st2"
        d="M512.1,183.6c1.1,0.7,1.1,0.7,1.8-0.1C513.3,183.4,512.8,182.8,512.1,183.6z"
      />
      <path
        class="st2"
        d="M385.3,258.4c0-0.3-0.4-0.5-0.7-0.9c-0.3,0.4-0.8,0.7-0.7,0.9c0.1,0.3,0.5,0.4,0.8,0.6
		C384.9,258.8,385.3,258.6,385.3,258.4z"
      />
      <path
        class="st2"
        d="M512.8,177.8c0.7-0.4,0.4-1,0.4-1.5C512,176.7,512,176.8,512.8,177.8z"
      />
      <path
        class="st2"
        d="M558.2,174c-0.8,1-1.3,1.7-1.2,2.5C557.5,175.9,558.4,175.4,558.2,174z"
      />
      <path
        class="st2"
        d="M533.3,212.6c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.2-0.2,0.5-0.4,0.7c0.2,0.1,0.5,0.3,0.6,0.2
		c0.3-0.1,0.5-0.4,0.6-0.7C534,212.9,533.6,212.7,533.3,212.6z"
      />
      <path
        class="st2"
        d="M540.2,178.2c-0.4,0.1-0.9,0.2-1.3,0.4c-0.2,0.2-0.3,0.4-0.5,0.6c0.7,0.5,1.1-0.3,1.7-0.3
		C540.1,178.6,540.1,178.4,540.2,178.2L540.2,178.2z"
      />
      <path
        class="st2"
        d="M547.9,190.7c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.1,0.1-0.2,0.2c0.1,0,0.1,0,0.1,0c0.5,0,0.9,0,1.2-0.2
		s0.5-0.4,0.6-0.8C548.7,190,548.3,190.3,547.9,190.7z"
      />
      <path
        class="st2"
        d="M352.3,260.1c-0.2,0-0.3,0.4-0.4,0.6c0.3,0.1,0.5,0.3,0.8,0.3c0.1,0,0.3-0.3,0.6-0.7
		C352.9,260.2,352.6,260.1,352.3,260.1z"
      />
      <path
        class="st2"
        d="M318.1,260c0.1-0.2,0.2-0.3,0.3-0.4c-0.2-0.1-0.5-0.3-0.7-0.4C317.8,259.3,317.9,259.6,318.1,260z"
      />
      <path
        class="st2"
        d="M532.8,223.6c0-0.1,0.1-0.2,0.1-0.3c0.1-0.3,0.1-0.5,0-0.7s-0.4-0.4-0.9-0.5l0,0l0,0c0,0,0,0,0,0.1
		c0,0.4,0,0.7,0.2,0.9C532.2,223.3,532.4,223.4,532.8,223.6z"
      />
      <path
        class="st2"
        d="M420.5,234.3c-0.2,0.4-0.6,0.7-0.5,0.9s0.5,0.3,0.8,0.4c0.1,0,0.5-0.4,0.4-0.6
		C421.1,234.8,420.8,234.6,420.5,234.3z"
      />
      <path
        class="st2"
        d="M495,201.2c1.3-0.8,0.1-1.1,0.1-1.7C493.9,200.3,495,200.6,495,201.2z"
      />
      <path
        class="st2"
        d="M583.5,205.5c0.5,0.4,0.3,1.1,1.3,1.3C584.7,205.5,584.7,205.5,583.5,205.5z"
      />
      <path
        class="st2"
        d="M564.4,210.5c0.9,0,1.6,0.1,2.2,0.1c-0.5-0.3-0.9-0.5-1.3-0.8C565,210.1,564.8,210.2,564.4,210.5z"
      />
      <path
        class="st2"
        d="M534.9,174.6c-0.5,0.4-0.8,0.6-1.2,0.9c0.2,0.1,0.3,0.2,0.4,0.3c0.1,0.1,0.3,0.3,0.4,0.4
		C535.4,175.8,535.1,175.3,534.9,174.6z"
      />
      <path
        class="st2"
        d="M396.6,249.9c0.1,0.1,0.2,0.2,0.3,0.3l0,0c0.5-0.4,1.1-0.7,1.4-1.1c0.1-0.1,0.1-0.1,0.2-0.2
		c-0.1-0.1-0.2-0.2-0.3-0.2C397.7,249.1,397.2,249.5,396.6,249.9z"
      />
      <path
        class="st2"
        d="M553.9,178.7c0.5,0.5,0.9,0.7,1.4,0.2c0.1-0.1-0.2-0.5-0.4-0.9C554.4,178.3,554.2,178.5,553.9,178.7z"
      />
      <path
        class="st2"
        d="M562.3,218.7c0.1,0.8,0.1,0.8,0.9,1.3C563.1,219.5,563.1,219,562.3,218.7z"
      />
      <path
        class="st2"
        d="M512,253.9C511.9,253.9,511.9,253.9,512,253.9c-0.1,0.7,0.2,1.1,1,1.6C513,254.6,512.7,254.2,512,253.9z"
      />
      <path
        class="st2"
        d="M537.1,177c-0.2,0.1-0.3,0.3-0.5,0.7c0.7-0.1,1.3-0.2,1.8-0.8C537.7,176.9,537.3,176.9,537.1,177L537.1,177z"
      />
      <path
        class="st2"
        d="M518.4,219.7c-0.3,0.4-0.5,0.6-0.6,0.9c0,0.1,0.4,0.3,0.6,0.4c0.2-0.2,0.5-0.5,0.6-0.7
		C519,220.1,518.6,220,518.4,219.7z"
      />
      <path
        class="st2"
        d="M388,261.3c0.2,0.1,0.5,0.4,0.7,0.3c0.2,0,0.4-0.3,0.7-0.6c-0.3-0.2-0.7-0.4-0.8-0.4
		C388.4,260.8,388.2,261.1,388,261.3z"
      />
      <path
        class="st2"
        d="M595.2,203.3c-0.2-0.2-0.5-0.3-0.7-0.5c-0.2,0.2-0.5,0.4-0.4,0.5c0.2,0.2,0.4,0.4,0.8,0.6
		C595,203.6,595.3,203.4,595.2,203.3z"
      />
      <path
        class="st2"
        d="M558.5,193.9c-0.2-0.7-0.3-1.2-1.2-1.2C557.2,193.3,557.6,193.6,558.5,193.9z"
      />
      <path
        class="st2"
        d="M611.8,174c0.1,0,0.2,0,0.3,0v-1c0,0,0,0-0.1,0C612,173.3,611.9,173.6,611.8,174z"
      />
      <path
        class="st2"
        d="M539.6,206.8c0.4,0.3,0.8,0.5,1.2,0.8c0.1-0.1,0.2-0.2,0.3-0.4C540.9,206.7,540.5,206.5,539.6,206.8z"
      />
      <path
        class="st2"
        d="M353.3,270.5c0.2-0.5,0.4-1,0.7-1.6C352.9,269.7,352.9,269.7,353.3,270.5z"
      />
      <path
        class="st2"
        d="M579.4,184c-0.4-0.2-0.7-0.3-1-0.4c-0.1,0.2-0.4,0.5-0.3,0.6c0.2,0.2,0.5,0.3,0.8,0.3
		C579,184.5,579.2,184.2,579.4,184z"
      />
      <path
        class="st2"
        d="M522.3,206.1c0.1,0,0.3,0.1,0.5,0.1c-0.2-0.2-0.3-0.4-0.5-0.6c-0.2-0.3-0.5-0.5-0.8-0.9
		C521.7,205.7,521.7,205.9,522.3,206.1z"
      />
      <path
        class="st2"
        d="M547.4,179.3c0.1,0.1,0.2,0.2,0.3,0.2s0.1-0.1,0.2-0.1c0.3-0.2,0.6-0.4,0.8-0.6c0.1-0.1-0.2-0.3-0.3-0.5
		c-0.3,0.3-0.5,0.6-0.8,0.8C547.5,179.2,547.5,179.2,547.4,179.3z"
      />
      <path
        class="st2"
        d="M547.1,168.6c0,0.3,0,0.6-0.1,0.9c0.2-0.2,0.4-0.4,0.4-0.6C547.4,168.8,547.3,168.7,547.1,168.6z"
      />
      <path
        class="st2"
        d="M546.4,169c0,0.1-0.1,0.1,0,0.2l0,0C546.4,169.1,546.4,169,546.4,169z"
      />
      <path
        class="st2"
        d="M336.9,235.1L336.9,235.1c-0.1,0.2-0.2,0.3-0.2,0.4c0.1,0.2,0.4,0.3,0.7,0.3c0.2,0,0.3-0.3,0.6-0.6
		c-0.4-0.2-0.7-0.3-1-0.4C337,234.9,337,235,336.9,235.1z"
      />
      <path
        class="st2"
        d="M380.8,261.6c-0.2,0-0.4,0.4-0.4,0.5c0,0.2,0.4,0.3,0.7,0.5c0.2-0.3,0.4-0.6,0.4-0.7
		C381.4,261.7,381,261.5,380.8,261.6z"
      />
      <path
        class="st2"
        d="M322.9,233.7c0.1-0.1,0.1-0.2,0.2-0.3s-0.2-0.4-0.4-0.7c-0.4,0.4-0.6,0.7-0.9,1c0.2,0.1,0.3,0.1,0.4,0.2
		C322.6,234,322.8,233.9,322.9,233.7z"
      />
      <path
        class="st2"
        d="M335.5,255.1c0.8-0.2,0.9-0.5,0.6-1.2C335.5,254.2,335.2,254.5,335.5,255.1z"
      />
      <path
        class="st2"
        d="M514.7,187.8c0-0.3,0.1-0.6,0.1-0.8c0.1-0.3,0.2-0.5,0.3-0.8c-0.2,0-0.4,0.1-0.6,0.1
		C514.3,187,514.3,187,514.7,187.8z"
      />
      <path
        class="st2"
        d="M515.8,208.7c0.1,0,0.2,0,0.3,0c0-0.1,0.1-0.1,0.1-0.2c0.1-0.3,0.2-0.6,0.3-0.9c-0.2,0-0.4,0-0.6-0.1
		C515.9,207.9,515.9,208.3,515.8,208.7z"
      />
      <path
        class="st2"
        d="M539.1,228.6c0,0.1,0,0.3,0.1,0.4c0.1,0.4,0.4,0.7,1,1.1c0-0.2,0-0.3-0.1-0.4
		C540,229.1,539.8,228.7,539.1,228.6z"
      />
      <path
        class="st2"
        d="M395.8,253.5c-0.2,0.3-0.5,0.5-0.4,0.6c0.1,0.2,0.4,0.3,0.6,0.4c0.1-0.2,0.4-0.3,0.4-0.5
		C396.3,253.8,396.1,253.7,395.8,253.5z"
      />
      <path
        class="st2"
        d="M488.4,213.8c0.6-0.2,1.1-0.5,0.7-1.3C488.8,213.1,488.6,213.5,488.4,213.8z"
      />
      <path
        class="st2"
        d="M509.4,172.5c0.3-0.1,0.5-0.2,0.9-0.4c-0.2-0.3-0.3-0.6-0.5-0.8C509.1,171.5,509.2,171.9,509.4,172.5z"
      />
      <path
        class="st2"
        d="M508.3,173.9c-0.3,0-0.5,0-0.7,0.1s-0.3,0.3-0.5,0.6C507.8,174.6,508.2,174.6,508.3,173.9z"
      />
      <path
        class="st2"
        d="M499.2,184.7c0.7,0.2,1.1,0.3,1.8,0.5C500.6,184.5,500.2,184.3,499.2,184.7z"
      />
      <path
        class="st2"
        d="M490.3,191.7c0.4,0.2,0.8,0.4,1.5,0.8C491.5,191.7,491.1,191.6,490.3,191.7z"
      />
      <path
        class="st2"
        d="M519.7,222.4c0.1,0,0.2,0,0.4,0c0.1-0.4,0.1-0.8,0.2-1.2c-0.1,0-0.3,0-0.4,0
		C519.8,221.7,519.7,222.1,519.7,222.4z"
      />
      <path
        class="st2"
        d="M558.9,187.1c0.7-0.1,1.1-0.1,1.9-0.2C560,186.7,559.5,186.4,558.9,187.1z"
      />
      <path
        class="st2"
        d="M320.2,244.9c-0.1,0.1-0.2,0.1-0.3,0.2c0.2,0.2,0.4,0.4,0.5,0.6c0,0,0.1-0.1,0.2-0.2l0.1-0.1
		c-0.1-0.1-0.2-0.2-0.3-0.2C320.4,245.1,320.3,245,320.2,244.9z"
      />
      <path
        class="st2"
        d="M486.4,220.9c0.3-0.5,0.4-0.8,0.6-1.1C486.4,220,486,220.3,486.4,220.9z"
      />
      <path
        class="st2"
        d="M501.7,185.3c0.4-0.2,0.4-0.2,0.4-0.5c0-0.1,0-0.2-0.1-0.3c-0.2,0.4-0.4,0.6-0.6,0.9
		C501.5,185.4,501.6,185.3,501.7,185.3z"
      />
      <path
        class="st2"
        d="M598.4,170.5L598.4,170.5c0,0.1-0.1,0.1-0.1,0.2c0,0.1,0.1,0.3,0.2,0.3c0.6,0.1,0.6-0.3,0.7-0.6
		C598.9,170.4,598.6,170.2,598.4,170.5z"
      />
      <path
        class="st2"
        d="M523.3,208.5c-0.4,0-0.7-0.1-0.9,0s-0.3,0.3-0.3,0.5c0,0.1,0.3,0.3,0.5,0.3C522.7,209.2,522.9,209,523.3,208.5
		z"
      />
      <path
        class="st2"
        d="M351.1,253c-0.2,0.1-0.3,0.2-0.5,0.4c0.1,0.1,0.3,0.2,0.6,0.4c0.1-0.3,0.3-0.4,0.3-0.6
		C351.5,253.1,351.2,253,351.1,253z"
      />
      <path
        class="st2"
        d="M560.3,188.6c-0.2,0.5,0,0.7,0.4,0.9c0.1,0,0.2,0.1,0.3,0.1c0.1-0.2,0-0.3,0-0.5
		C560.9,188.9,560.7,188.7,560.3,188.6z"
      />
      <path
        class="st2"
        d="M596,188.8c-0.1-0.4-0.3-0.8,0.3-0.9c-0.2,0-0.5,0-1-0.1C595.6,188.3,595.8,188.5,596,188.8z"
      />
      <path
        class="st2"
        d="M384.1,252.3c0.3,0.1,0.5,0.3,0.7,0.2s0.4-0.3,0.3-0.5c0-0.1-0.4-0.3-0.5-0.3
		C384.5,251.8,384.3,252,384.1,252.3z"
      />
      <path
        class="st2"
        d="M556.9,178.5c0,0-0.1-0.1-0.1-0.3c-0.4,0.1-0.7,0.3-1.1,0.5C556.2,179.2,556.6,178.8,556.9,178.5z"
      />
      <path
        class="st2"
        d="M373.6,256.2c-0.3-0.3-0.5-0.5-0.7-0.7C372.7,256.2,372.7,256.2,373.6,256.2z"
      />
      <path
        class="st2"
        d="M578.5,197.8c-0.1,0.1-0.2,0.1-0.3,0.2l0.1,0.1c0.2,0.2,0.3,0.4,0.5,0.6l0,0c0.1,0,0.1-0.1,0.2-0.1l0.1-0.1
		C578.9,198.3,578.7,198.1,578.5,197.8C578.5,197.9,578.5,197.8,578.5,197.8z"
      />
      <path
        class="st2"
        d="M398.7,225c0-0.1-0.2-0.2-0.4-0.3c-0.1,0.2-0.3,0.3-0.3,0.5c0,0,0.3,0.1,0.4,0.2
		C398.6,225.2,398.7,225.1,398.7,225z"
      />
      <path
        class="st2"
        d="M527.7,244.2c0.1,0.1,0.3,0.2,0.4,0.2c0.1,0,0.2-0.2,0.3-0.3c-0.1-0.1-0.1-0.2-0.2-0.2
		C528,243.9,527.8,244.1,527.7,244.2z"
      />
      <path
        class="st2"
        d="M343.1,238.8c-0.3-0.1-0.5-0.2-0.7-0.2c-0.1,0-0.2,0.2-0.3,0.3c0.2,0.1,0.3,0.2,0.5,0.2
		C342.8,239.1,342.9,239,343.1,238.8z"
      />
      <path
        class="st2"
        d="M388.8,267.2c0,0-0.3,0.2-0.3,0.3c0,0.2,0.2,0.3,0.4,0.5c0.2-0.3,0.4-0.5,0.4-0.6
		C389.2,267.4,389,267.3,388.8,267.2z"
      />
      <path
        class="st2"
        d="M510,182.8c0.1,0.2,0.1,0.4,0.2,0.6c1.1-0.9,1.1-0.9,0.5-1.4c-0.1,0.2-0.3,0.3-0.4,0.5l0,0l0,0
		c-0.2,0-0.5,0-0.7-0.1c0,0.2-0.1,0.4-0.2,0.8C509.7,183,509.9,182.9,510,182.8L510,182.8L510,182.8z"
      />
      <path
        class="st2"
        d="M511.6,175.6l0.2,0.1c0.1-0.1,0.3-0.3,0.4-0.4c-0.2-0.1-0.3-0.1-0.4-0.2C511.8,175.3,511.7,175.4,511.6,175.6z
		"
      />
      <path
        class="st2"
        d="M558.7,189.6c0.1,0.1,0.1,0.1,0.2,0.2c0.3-0.2,0.5-0.3,0.8-0.5c-0.1-0.1-0.2-0.1-0.2-0.2
		C559.2,189.2,558.9,189.4,558.7,189.6z"
      />
      <path
        class="st2"
        d="M399.2,250.5c0.1,0.1,0.3,0.3,0.5,0.3c0.1,0,0.3-0.3,0.5-0.5c-0.3-0.1-0.5-0.2-0.7-0.1
		C399.4,250.2,399.2,250.4,399.2,250.5z"
      />
      <path
        class="st2"
        d="M609.2,214.6c0.2,0.1,0.3,0.3,0.5,0.2c0.2,0,0.3-0.3,0.5-0.5c-0.3-0.1-0.4-0.2-0.5-0.1
		C609.5,214.3,609.4,214.4,609.2,214.6z"
      />
      <path
        class="st2"
        d="M551.9,173.2c0,0.1,0.1,0.1,0.1,0.2c0.3-0.1,0.6-0.1,0.9-0.2c0-0.2,0.1-0.3,0.2-0.7
		C552.5,172.8,552.2,173,551.9,173.2z"
      />
      <path
        class="st2"
        d="M316.5,229c0,0,0.3-0.1,0.3-0.2c-0.1-0.2-0.2-0.3-0.3-0.4c-0.2,0.1-0.3,0.2-0.4,0.2
		C316.2,228.8,316.4,228.9,316.5,229z"
      />
      <path
        class="st2"
        d="M506.6,211c0.1,0,0.2,0,0.2,0c0.1-0.2,0.2-0.4,0.4-0.7c-0.1,0-0.3-0.1-0.4-0.1
		C506.7,210.5,506.6,210.7,506.6,211z"
      />
      <path
        class="st2"
        d="M605.6,205.1c-0.1,0.2-0.2,0.3-0.3,0.5c0,0.1,0.2,0.1,0.4,0.3c0.1-0.3,0.2-0.4,0.2-0.6
		C606,205.2,605.8,205.2,605.6,205.1z"
      />
      <path
        class="st2"
        d="M515.8,202.9c0,0.1,0.1,0.3,0.2,0.4c0.1-0.2,0.2-0.4,0.2-0.6c-0.1,0-0.2,0-0.3,0
		C515.9,202.8,515.8,202.9,515.8,202.9z"
      />
      <path
        class="st2"
        d="M543.3,178.7c-0.1,0.1-0.2,0.1-0.3,0.2c0.3,0,0.5,0.1,0.6,0c0.2,0,0.4-0.2,0.5-0.5c0-0.1,0.1-0.2,0.1-0.3
		c-0.2,0.1-0.3,0.2-0.5,0.3C543.6,178.5,543.4,178.6,543.3,178.7z"
      />
      <path
        class="st2"
        d="M541.6,179.2c-0.3,0.2-0.6,0.3-0.9,0.5c0,0.1,0.1,0.1,0.1,0.2c0.3-0.1,0.6-0.2,0.9-0.3
		C541.6,179.5,541.6,179.3,541.6,179.2z"
      />
      <path
        class="st2"
        d="M520.6,213.3c0.1,0,0.2,0,0.3,0c0-0.2,0-0.5,0-0.7c-0.1,0-0.2,0-0.3,0C520.6,212.8,520.6,213,520.6,213.3z"
      />
      <path
        class="st2"
        d="M611.2,169.7c0,0.3,0,0.6,0,0.9C611.6,170.3,611.7,170,611.2,169.7z"
      />
      <path
        class="st2"
        d="M611.2,170.6C611.2,170.6,611.1,170.6,611.2,170.6c-0.1,0.1-0.1,0.1-0.1,0.1
		C611.1,170.7,611.1,170.7,611.2,170.6L611.2,170.6z"
      />
      <path
        class="st2"
        d="M331.6,262.5c0.1,0.3,0.2,0.6,0.4,0.9c0.1-0.1,0.2-0.1,0.4-0.2c-0.2-0.3-0.3-0.5-0.5-0.8
		C331.7,262.4,331.6,262.4,331.6,262.5z"
      />
      <path
        class="st2"
        d="M551.8,182.3c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1,0-0.3,0.1-0.4,0.2c0.1,0.1,0.1,0.2,0.2,0.3
		C551.5,182.5,551.6,182.4,551.8,182.3z"
      />
      <path
        class="st2"
        d="M505.6,184.1c0,0.2-0.1,0.4-0.1,0.6c0.1,0,0.2,0,0.2,0c0.1-0.2,0.1-0.4,0.2-0.6
		C505.8,184.2,505.7,184.1,505.6,184.1z"
      />
      <path
        class="st2"
        d="M389.8,249.7c-0.1,0-0.2,0-0.3,0.1c0.1,0.2,0.1,0.4,0.2,0.6c0.1,0,0.2,0,0.3-0.1
		C389.9,250.1,389.8,249.9,389.8,249.7z"
      />
      <path
        class="st2"
        d="M512,190.2c0.1,0.1,0.3,0.2,0.4,0.1c0.1,0,0.2-0.2,0.3-0.4c-0.2-0.1-0.4-0.1-0.5-0.1
		C512.1,189.9,512,190.1,512,190.2z"
      />
      <path
        class="st2"
        d="M571.9,178.5c-0.1,0.2-0.3,0.4-0.4,0.6c0.2-0.1,0.4-0.3,0.6-0.4C572.1,178.6,572,178.6,571.9,178.5z"
      />
      <path
        class="st2"
        d="M571.5,179.1c-0.1,0-0.1,0.1-0.2,0.1l0,0c0,0,0,0,0.1,0C571.5,179.2,571.5,179.1,571.5,179.1z"
      />
      <path
        class="st2"
        d="M536.4,203.4c0-0.1-0.2-0.2-0.2-0.1c-0.1,0.1-0.3,0.2-0.3,0.3s0.2,0.2,0.4,0.3
		C536.4,203.6,536.4,203.5,536.4,203.4z"
      />
      <path
        class="st2"
        d="M507.2,263.5c0.2,0.2,0.4,0.4,0.6,0.6C507.8,263.8,508.1,263.5,507.2,263.5z"
      />
      <path
        class="st2"
        d="M507.8,264.1C507.7,264.1,507.7,264.2,507.8,264.1c0,0.1,0.1,0.1,0.1,0.1C507.8,264.2,507.8,264.2,507.8,264.1
		L507.8,264.1z"
      />
      <path
        class="st2"
        d="M399.3,234.2c-0.1-0.1-0.2-0.2-0.3-0.4c-0.1,0.2-0.3,0.3-0.2,0.4c0,0.1,0.2,0.1,0.4,0.1
		C399.2,234.4,399.3,234.2,399.3,234.2z"
      />
      <path
        class="st2"
        d="M535.3,247.1c0.2,0.1,0.4,0.1,0.6,0.2c0-0.1,0.1-0.2,0.1-0.3c-0.2,0-0.4-0.1-0.6-0.1
		C535.4,246.9,535.3,247,535.3,247.1z"
      />
      <path
        class="st2"
        d="M569.5,165.3c-0.1,0-0.2,0.2-0.2,0.2c0,0.1,0.2,0.2,0.2,0.3c0.1-0.1,0.2-0.2,0.4-0.3
		C569.8,165.4,569.7,165.3,569.5,165.3z"
      />
      <path
        class="st2"
        d="M609.3,167.7c-0.1,0.1-0.1,0.2-0.1,0.3s0.1,0.1,0.2,0.1h0.1l0.2-0.2c0-0.1-0.2-0.2-0.3-0.4
		C609.4,167.5,609.3,167.6,609.3,167.7z"
      />
      <path
        class="st2"
        d="M519.2,211.3L519.2,211.3C519.1,211.2,519.1,211.3,519.2,211.3C519.2,211.3,519.2,211.3,519.2,211.3z"
      />
      <path
        class="st2"
        d="M519.9,211.4c-0.2,0-0.4,0-0.6-0.1c0.1,0.1,0.2,0.3,0.4,0.4C519.7,211.6,519.8,211.5,519.9,211.4z"
      />
      <path
        class="st2"
        d="M612.1,165v-0.5c-0.1,0.1-0.2,0.2-0.3,0.3C611.9,164.9,612,164.9,612.1,165z"
      />
      <path
        class="st2"
        d="M510.3,189.4c0.1,0,0.1,0,0.2,0c0.1-0.2,0.2-0.4,0.3-0.5c-0.1,0-0.2-0.1-0.3-0.1
		C510.4,189,510.4,189.2,510.3,189.4z"
      />
      <path
        class="st2"
        d="M508.3,201.8c0.2,0,0.3,0.1,0.5,0c0.1,0,0.2-0.2,0.5-0.4c-0.4,0-0.5,0-0.6,0.1
		C508.5,201.6,508.4,201.7,508.3,201.8z"
      />
      <path
        class="st2"
        d="M610.8,165.9c0.1-0.1,0.3-0.2,0.3-0.3s-0.1-0.2-0.4-0.5c-0.1,0.3-0.2,0.5-0.1,0.6
		C610.6,165.8,610.7,165.9,610.8,165.9z"
      />
      <path
        class="st2"
        d="M511,213.4c0.1,0,0.2,0,0.3,0c0.1-0.2,0.2-0.4,0.3-0.7c-0.1,0-0.2,0-0.4,0C511.1,212.9,511.1,213.2,511,213.4z
		"
      />
      <path
        class="st2"
        d="M433.2,229.6C433.2,229.6,433.2,229.5,433.2,229.6c-0.1-0.1-0.1-0.1-0.1-0.1l0,0
		C433.1,229.6,433.2,229.6,433.2,229.6z"
      />
      <path
        class="st2"
        d="M433.2,229.6c0.2,0.2,0.4,0.5,0.6,0.8C434.1,229.6,433.6,229.7,433.2,229.6z"
      />
      <path
        class="st2"
        d="M490.1,216c-0.2,0.1-0.3,0.2-0.5,0.4c0.1,0.1,0.2,0.2,0.3,0.2c0.1-0.1,0.3-0.3,0.4-0.4
		C490.3,216.2,490.1,216.1,490.1,216z"
      />
      <path
        class="st2"
        d="M519,210.7c0.1,0.2,0.1,0.3,0.2,0.5c0-0.2,0.1-0.3,0.1-0.5C519.2,210.7,519.1,210.7,519,210.7z"
      />
      <path
        class="st2"
        d="M550.4,193.2l0.1,0.1c0.1,0.1,0.2,0.2,0.2,0.2c0.1-0.1,0.2-0.1,0.3-0.2l0.1-0.1H551c-0.1,0-0.2,0-0.4,0
		C550.5,193.2,550.4,193.2,550.4,193.2z"
      />
      <path
        class="st2"
        d="M504.2,207.1l0.1,0.1c0.1-0.1,0.2-0.2,0.3-0.3c0,0-0.1-0.1-0.2-0.2C504.3,206.8,504.3,206.9,504.2,207.1z"
      />
      <path
        class="st2"
        d="M555,184.3c0-0.1-0.3-0.1-0.3-0.1c-0.1,0.1-0.2,0.2-0.2,0.4c0,0,0.2,0.1,0.4,0.2
		C554.9,184.6,555,184.4,555,184.3z"
      />
      <path
        class="st2"
        d="M397.1,244.8c-0.1,0-0.2-0.1-0.4-0.1l-0.1,0.2c0.1,0.1,0.2,0.1,0.4,0.2C397,245.1,397,245,397.1,244.8z"
      />
      <path
        class="st2"
        d="M509.8,173.9c0,0.2-0.1,0.3-0.1,0.5c0.2-0.1,0.3-0.2,0.5-0.3C510.1,174.1,509.9,174,509.8,173.9z"
      />
      <path
        class="st2"
        d="M544.8,223.3l0.1,0.1c0.1,0,0.2-0.1,0.3-0.1c-0.1-0.1-0.1-0.1-0.2-0.2C544.9,223.2,544.9,223.2,544.8,223.3z"
      />
      <path
        class="st2"
        d="M597.1,188.2c0,0.1,0,0.1,0.1,0.2c0,0.1,0.1,0.2,0.1,0.3c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.2-0.2-0.2-0.3
		C597.2,188.3,597.1,188.3,597.1,188.2z"
      />
      <path
        class="st2"
        d="M364.9,244.8c0,0.1,0,0.3-0.1,0.4c0.1-0.1,0.2-0.2,0.3-0.3C365.1,244.8,365,244.8,364.9,244.8z"
      />
      <path
        class="st2"
        d="M364.8,245.2C364.8,245.2,364.8,245.3,364.8,245.2c-0.1,0.1-0.1,0.1-0.1,0.2h0.1
		C364.8,245.3,364.8,245.2,364.8,245.2z"
      />
      <path
        class="st2"
        d="M543.8,179.5c0.2-0.1,0.4-0.1,0.6-0.2v-0.1c-0.2,0-0.4,0-0.6,0C543.8,179.3,543.8,179.4,543.8,179.5z"
      />
      <path
        class="st2"
        d="M603.7,169.3c0.1-0.2,0.1-0.3,0.1-0.4c0-0.1-0.1-0.1-0.2-0.1C603.6,168.9,603.6,169,603.7,169.3z"
      />
      <path
        class="st2"
        d="M436.1,267.7c-0.1,0-0.2,0.1-0.2,0.1c0.1,0.1,0.1,0.2,0.2,0.2s0.2-0.1,0.3-0.1
		C436.2,267.8,436.1,267.7,436.1,267.7z"
      />
      <path
        class="st2"
        d="M415.2,210.2c0.1-0.1,0.1-0.1,0.2-0.2l0,0C415.2,210,415.2,210.1,415.2,210.2
		C415.1,210.2,415.2,210.2,415.2,210.2z"
      />
      <path
        class="st2"
        d="M373.3,243.5c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1-0.1-0.1-0.1-0.2-0.1C373.4,243.3,373.4,243.4,373.3,243.5z"
      />
      <path
        class="st2"
        d="M511.8,189.6c0.1,0,0.2-0.1,0.4-0.2c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0.1-0.2,0.2-0.3,0.3
		C511.7,189.5,511.8,189.6,511.8,189.6z"
      />
      <path
        class="st2"
        d="M536.7,204.3c0-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.2-0.1-0.3-0.1s-0.2,0.1-0.2,0.2
		C536.4,204.2,536.5,204.3,536.7,204.3L536.7,204.3z"
      />
      <path
        class="st2"
        d="M554.4,183.6c-0.6,0.2-0.8,0.3-1,0.3c0.1,0.1,0.1,0.2,0.2,0.3C553.8,184.1,553.9,184,554.4,183.6z"
      />
      <path
        class="st2"
        d="M598.7,188.8c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.1,0.1,0.2,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2
		C598.7,188.9,598.7,188.9,598.7,188.8z"
      />
      <path
        class="st2"
        d="M611.1,170.7c-0.1,0.1-0.3,0.3-0.4,0.4c0.1,0,0.2,0.1,0.3,0.1C611,171.1,611,170.9,611.1,170.7z"
      />
      <path
        class="st2"
        d="M468.4,243.4C468.4,243.4,468.4,243.5,468.4,243.4c0.1,0.1,0.2,0.2,0.2,0.2s0,0,0.1,0s0.1-0.1,0.2-0.1
		c-0.1-0.1-0.2-0.2-0.3-0.2C468.5,243.3,468.4,243.3,468.4,243.4z"
      />
      <path
        class="st2"
        d="M557.7,186.9C557.7,186.9,557.8,186.9,557.7,186.9c0.1,0.2,0.1,0.2,0.2,0.3c0.1-0.1,0.2-0.1,0.2-0.2l0,0
		c-0.1-0.1-0.1-0.2-0.2-0.2C557.9,186.8,557.7,186.8,557.7,186.9z"
      />
      <path
        class="st2"
        d="M368.7,253.7c0.1,0,0.2,0.2,0.3,0.1c0.1,0,0.2-0.2,0.3-0.2c-0.1-0.1-0.2-0.2-0.3-0.2
		C368.9,253.4,368.8,253.6,368.7,253.7z"
      />
      <path
        class="st2"
        d="M515.5,199.5c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.3-0.1c-0.1-0.1-0.1-0.2-0.2-0.2
		C515.7,199.4,515.6,199.4,515.5,199.5z"
      />
      <path
        class="st2"
        d="M501.9,205.6c0,0.1,0.2,0.1,0.3,0.1c0-0.1,0.1-0.3,0.1-0.4c0,0-0.2,0-0.4-0.1
		C501.8,205.4,501.8,205.5,501.9,205.6z"
      />
      <path
        class="st2"
        d="M604.1,188.2c-0.1,0-0.1,0.2-0.1,0.3l0,0c0.1,0,0.2,0,0.2,0s0-0.1,0.1-0.1c0-0.1,0.1-0.1,0.1-0.2
		C604.3,188.2,604.2,188.2,604.1,188.2z"
      />
      <path
        class="st2"
        d="M598.1,189.7c-0.1,0-0.2,0.1-0.3,0.1c0.1,0.1,0.2,0.2,0.2,0.3c0.1-0.1,0.2-0.1,0.2-0.2
		C598.2,189.8,598.2,189.7,598.1,189.7z"
      />
      <path
        class="st2"
        d="M599.9,215.4c0.1,0,0.2,0,0.3,0c0.1-0.1,0.1-0.2,0.2-0.3c-0.1,0-0.2-0.1-0.3-0.1
		C600,215.1,600,215.3,599.9,215.4z"
      />
      <path
        class="st2"
        d="M555.2,199c0.1-0.1,0.1-0.2,0.2-0.3c-0.1,0-0.2,0.1-0.4,0.1C555,198.9,555.1,198.9,555.2,199z"
      />
      <path class="st2" d="M346,244.1l-0.1-0.1v0.1H346z" />
      <path
        class="st2"
        d="M508,264.6c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.1-0.3-0.2C507.9,264.4,507.9,264.5,508,264.6z"
      />
      <path
        class="st2"
        d="M537.4,176C537.4,176.1,537.4,176.1,537.4,176c0,0.1,0.1,0.1,0.1,0.1L537.4,176C537.6,176,537.5,176,537.4,176
		z"
      />
      <path
        class="st2"
        d="M534.1,176.6c0.1-0.1,0.2-0.2,0.4-0.3c-0.2,0-0.3,0.1-0.5,0.1C534,176.5,534,176.6,534.1,176.6z"
      />
      <path
        class="st2"
        d="M534.4,176.3L534.4,176.3C534.5,176.2,534.5,176.2,534.4,176.3C534.5,176.2,534.5,176.2,534.4,176.3
		C534.5,176.3,534.5,176.3,534.4,176.3z"
      />
      <path
        class="st2"
        d="M548.5,173.1c-0.1,0-0.2-0.1-0.3-0.1l-0.1,0.1C548.2,173.1,548.3,173.1,548.5,173.1
		C548.4,173.2,548.5,173.1,548.5,173.1z"
      />
      <path
        class="st2"
        d="M565.1,174.1c0,0.1,0.1,0.1,0.2,0.1c0.1-0.1,0.1-0.1,0.2-0.2c-0.1,0-0.2,0-0.3,0
		C565.1,174,565.1,174.1,565.1,174.1z"
      />
      <path
        class="st2"
        d="M559.6,169l0.1,0.1c0.1,0,0.1,0,0.2,0C559.8,169.1,559.8,169,559.6,169C559.8,169,559.7,169,559.6,169z"
      />
      <path
        class="st2"
        d="M504.2,180.1c-0.1,0-0.1,0-0.2,0c0,0.1,0,0.1,0,0.2C504.1,180.2,504.1,180.2,504.2,180.1
		C504.2,180.2,504.2,180.1,504.2,180.1z"
      />
      <path
        class="st2"
        d="M498.8,181c0,0,0.1,0.1,0.1,0.2l0,0l0,0C498.9,181.1,498.9,181,498.8,181z"
      />
      <path
        class="st2"
        d="M420.8,229.6l-0.1-0.1c-0.1,0-0.2,0.1-0.3,0.2c0.1,0,0.1,0.1,0.2,0.1C420.6,229.7,420.7,229.6,420.8,229.6z"
      />
      <path
        class="st2"
        d="M316.9,248.9l0.1,0.1l0,0C317,248.9,317,248.9,316.9,248.9L316.9,248.9z"
      />
      <path
        class="st2"
        d="M513.2,176.1C513.2,176.1,513.1,176.2,513.2,176.1c0,0.1,0,0.1,0,0.1l0,0C513.2,176.2,513.2,176.2,513.2,176.1
		z"
      />
      <path
        class="st2"
        d="M513.2,175.8v0.1c0,0.1,0,0.1,0,0.2c0-0.1,0.1-0.1,0.1-0.2C513.3,175.9,513.2,175.8,513.2,175.8z"
      />
      <path
        class="st2"
        d="M507,173.5l-0.1,0.1c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2-0.1,0.2-0.2C507.3,173.5,507.1,173.5,507,173.5z"
      />
      <path
        class="st2"
        d="M450.3,225.3l0.1,0.1c0.1-0.1,0.2-0.1,0.3-0.2l-0.1-0.1C450.5,225.2,450.4,225.3,450.3,225.3z"
      />
      <path
        class="st2"
        d="M428,230.5c0,0.1,0.1,0.2,0.2,0.2c0-0.1,0.1-0.1,0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.2
		C428.1,230.5,428,230.5,428,230.5z"
      />
      <path
        class="st2"
        d="M510.5,242.8c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.1-0.1-0.2-0.2
		C510.5,242.7,510.5,242.8,510.5,242.8z"
      />
      <path
        class="st2"
        d="M487.4,218.6c0.1,0,0.2,0.1,0.2,0.1c0.1,0,0.1-0.1,0.2-0.2c-0.1,0-0.2,0-0.3,0
		C487.5,218.5,487.5,218.5,487.4,218.6z"
      />
      <path
        class="st2"
        d="M495,193.3c0-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.1,0.1,0.1,0.1,0.2
		C494.9,193.4,495.1,193.4,495,193.3z"
      />
      <path
        class="st2"
        d="M532,209.8c0,0.2,0,0.3,0.1,0.5c0.1,0,0.1,0,0.2,0c0-0.1-0.1-0.3-0.1-0.4C532.1,209.8,532,209.8,532,209.8z"
      />
      <path
        class="st2"
        d="M394.4,240.4c0-0.1,0.1-0.2,0.1-0.2c0-0.1-0.1-0.1-0.2-0.1c0,0.1-0.1,0.2-0.1,0.3
		C394.2,240.3,394.3,240.3,394.4,240.4z"
      />
      <path
        class="st2"
        d="M542.2,208.4c0,0.1,0.2,0.1,0.2,0.1c0-0.1,0.1-0.2,0.1-0.3l-0.2-0.1C542.3,208.2,542.2,208.3,542.2,208.4z"
      />
      <path
        class="st2"
        d="M560.5,192.3c0,0.1,0.1,0.1,0.1,0.2l0.1-0.1C560.7,192.4,560.7,192.3,560.5,192.3
		C560.6,192.2,560.6,192.3,560.5,192.3z"
      />
      <path
        class="st2"
        d="M536.3,211.6L536.3,211.6c0-0.1,0-0.1,0-0.2l0,0C536.2,211.5,536.2,211.5,536.3,211.6
		C536.2,211.6,536.2,211.6,536.3,211.6C536.3,211.7,536.3,211.7,536.3,211.6z"
      />
      <path
        class="st2"
        d="M546.4,194.8c0.1,0,0.2,0,0.3,0l0,0c0,0,0-0.1,0.1-0.1c-0.1,0-0.2,0-0.3,0
		C546.5,194.7,546.5,194.7,546.4,194.8C546.4,194.7,546.4,194.8,546.4,194.8z"
      />
      <path
        class="st2"
        d="M508,203.3c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2c-0.1,0-0.1-0.1-0.2-0.1
		C508,203.3,508,203.3,508,203.3z"
      />
      <path
        class="st2"
        d="M501.4,204.9c0,0,0.2,0,0.2,0.1c0-0.1,0.1-0.2,0.1-0.2s-0.1-0.1-0.2-0.1C501.5,204.7,501.4,204.8,501.4,204.9z
		"
      />
      <path
        class="st2"
        d="M468.1,242.8c0,0,0.1,0.1,0.2,0.1c0-0.1,0-0.2,0.1-0.2c-0.1,0-0.1-0.1-0.2-0.1S468,242.7,468.1,242.8z"
      />
      <path
        class="st2"
        d="M573.6,179.4l-0.1,0.1c0.1,0,0.2,0,0.3,0.1l0.1-0.1C573.8,179.4,573.7,179.4,573.6,179.4z"
      />
      <path
        class="st2"
        d="M522.3,216.6c0.1,0,0.2,0,0.2,0v-0.1c0,0-0.1-0.1-0.2-0.1C522.3,216.4,522.3,216.5,522.3,216.6z"
      />
      <path
        class="st2"
        d="M549.3,185.4c0,0,0-0.1,0.1-0.1c0,0,0-0.1-0.1-0.1c0,0-0.1,0.1,0,0.1C549.2,185.3,549.2,185.4,549.3,185.4z"
      />
      <path
        class="st2"
        d="M544.3,222.6c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1,0-0.2,0-0.3,0C544.4,222.5,544.4,222.5,544.3,222.6z"
      />
      <path
        class="st2"
        d="M584,178.4c-0.1,0-0.2,0.1-0.3,0.1c0.1,0,0.1,0.1,0.1,0.1c0.1,0,0.2-0.1,0.3-0.1L584,178.4z"
      />
      <path
        class="st2"
        d="M528.7,215.5v-0.1h-0.1C528.6,215.4,528.6,215.4,528.7,215.5C528.6,215.5,528.7,215.5,528.7,215.5z"
      />
      <path
        class="st2"
        d="M529.2,216.1c-0.1,0-0.2,0-0.3,0C529,216.1,529,216.1,529.2,216.1C529.1,216.2,529.2,216.1,529.2,216.1z"
      />
      <path
        class="st2"
        d="M504.7,196.8c0,0,0.1,0,0.1,0.1c0-0.1,0-0.2,0.1-0.3c0,0-0.1,0-0.1-0.1C504.7,196.7,504.7,196.8,504.7,196.8z"
      />
      <path
        class="st2"
        d="M558.4,185.1L558.4,185.1c-0.5,0-0.6,0-0.8,0c0,0.1,0,0.1,0,0.2C557.8,185.3,557.9,185.2,558.4,185.1
		L558.4,185.1z"
      />
      <path
        class="st2"
        d="M580.2,181c0.1,0.1,0.2,0.2,0.4,0.2c-0.1-0.1-0.1-0.3-0.2-0.4C580.4,180.9,580.3,180.9,580.2,181z"
      />
      <path
        class="st2"
        d="M580.6,181.3C580.6,181.2,580.6,181.2,580.6,181.3C580.6,181.2,580.6,181.3,580.6,181.3L580.6,181.3
		L580.6,181.3C580.7,181.3,580.7,181.3,580.6,181.3L580.6,181.3z"
      />
      <path
        class="st2"
        d="M549.3,187.9C549.3,187.9,549.3,188,549.3,187.9c0.2,0.1,0.4,0.1,0.6,0.1c0-0.1,0-0.1,0-0.2
		C549.7,187.8,549.5,187.8,549.3,187.9z"
      />
      <path
        class="st2"
        d="M585.8,205.7c0.1,0,0.2,0.1,0.3,0.1c0-0.1,0.1-0.1,0.1-0.2C586.1,205.6,586,205.6,585.8,205.7
		C585.8,205.6,585.8,205.7,585.8,205.7z"
      />
      <path
        class="st2"
        d="M574.5,182.7c0,0,0,0.1,0.1,0.1l0.1,0.1c0,0,0-0.1-0.1-0.1C574.6,182.8,574.6,182.7,574.5,182.7z"
      />
      <path
        class="st2"
        d="M574.4,182.6c-0.4-0.2-0.9-0.5-1.3-0.7c-0.7-0.3-1.5-0.3-2.2-0.1c-0.3,0.1-0.5,0.2-0.7,0.4
		c-0.9,0.6-1.1,1.6-0.6,2.5c0.2,0.4,0.6,0.7,0.8,1.1c0.4,0,0.7-0.1,1-0.1c1.5-0.1,2.3-0.7,2.7-1.8c0-0.2,0.1-0.3,0.1-0.5
		S574.3,182.9,574.4,182.6C574.5,182.7,574.5,182.7,574.4,182.6C574.5,182.7,574.5,182.6,574.4,182.6L574.4,182.6z"
      />
      <path
        class="st2"
        d="M580.7,181.6c0.1,0.1,0.2,0.1,0.3,0.2c0-0.1,0-0.3,0-0.4c0-0.1-0.2-0.1-0.3-0.1
		C580.7,181.4,580.6,181.5,580.7,181.6z"
      />
      <path
        class="st2"
        d="M567.4,211.2c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.2-0.1-0.3-0.1C567.3,211,567.3,211.1,567.4,211.2z"
      />
      <polygon class="st2" points="366.3,255 366.4,255 366.3,254.9 	" />
      <path
        class="st2"
        d="M510.7,198.5c-0.1,0-0.1,0-0.2,0.1c0.1,0,0.1,0,0.2,0s0.1-0.1,0.2-0.1C510.8,198.5,510.7,198.4,510.7,198.5z"
      />
      <path
        class="st2"
        d="M403.3,246.8c-0.1,0-0.2,0.1-0.3,0.2l0.1,0.1c0.1,0,0.1-0.1,0.2-0.1h0.1C403.4,246.8,403.4,246.8,403.3,246.8
		C403.4,246.8,403.3,246.7,403.3,246.8z"
      />
      <path
        class="st2"
        d="M575.4,184.7l0.1,0.1c0-0.1,0.1-0.2,0.1-0.2s-0.1-0.1-0.2-0.1C575.4,184.6,575.3,184.7,575.4,184.7z"
      />
      <path
        class="st2"
        d="M308.3,243.7l-0.1,0.1l0.1,0.1c0,0,0,0,0.1,0l0,0C308.3,243.8,308.3,243.8,308.3,243.7L308.3,243.7
		L308.3,243.7z"
      />
      <path
        class="st2"
        d="M395.9,225.2c-0.1,0.1-0.1,0.1-0.2,0.2l0,0C395.8,225.3,395.8,225.3,395.9,225.2L395.9,225.2z"
      />
      <path
        class="st2"
        d="M331.3,236.2l0.1-0.1l-0.1-0.1C331.3,236.1,331.3,236.1,331.3,236.2z"
      />
      <path
        class="st2"
        d="M319.1,237.5L319.1,237.5L319.1,237.5c0-0.1,0.1-0.1,0.1-0.2l0,0l0,0C319.1,237.4,319.1,237.4,319.1,237.5z"
      />
      <path
        class="st2"
        d="M502.8,197.5v0.1V197.5c0.1,0,0.1-0.1,0.1-0.1S502.9,197.5,502.8,197.5z"
      />
      <path
        class="st2"
        d="M351.2,228.7c0,0-0.1,0-0.1-0.1c0,0.1-0.1,0.1-0.1,0.2h0.1C351.2,228.7,351.2,228.7,351.2,228.7z"
      />
      <polygon class="st2" points="552.2,193.3 552.1,193.2 552.1,193.3 	" />
      <polygon class="st2" points="499.6,194.4 499.8,194.3 499.7,194.2 	" />
      <polygon class="st2" points="546.3,184 546.4,183.9 546.2,183.9 	" />
      <path
        class="st2"
        d="M578.4,176.7c0-0.1,0-0.1,0-0.2c-0.1,0-0.1,0.1-0.2,0.1C578.3,176.6,578.3,176.6,578.4,176.7z"
      />
      <path
        class="st2"
        d="M578.4,176.4L578.4,176.4C578.4,176.5,578.4,176.5,578.4,176.4C578.4,176.5,578.4,176.5,578.4,176.4
		c0.1-0.1,0.2-0.2,0.3-0.4l0,0C578.6,176.2,578.5,176.3,578.4,176.4z"
      />
      <path
        class="st2"
        d="M578.7,176.1L578.7,176.1C578.8,176.1,578.8,176.1,578.7,176.1C578.8,176,578.7,176.1,578.7,176.1z"
      />
      <path
        class="st2"
        d="M578.8,175.8c0,0.1,0,0.1-0.1,0.2c0.1,0,0.2-0.1,0.2-0.1S578.9,175.9,578.8,175.8z"
      />
      <path
        class="st2"
        d="M552.5,181c0,0,0,0.1-0.1,0.1C552.5,181.1,552.5,181.1,552.5,181C552.5,181.1,552.5,181,552.5,181z"
      />
      <path
        class="st2"
        d="M513.7,189.1l0.1,0.1l0.1-0.1l-0.1-0.1C513.8,189,513.8,189,513.7,189.1z"
      />
      <polygon class="st2" points="597,185.4 597,185.5 597.1,185.4 	" />
      <polygon class="st2" points="610.6,167.2 610.6,167.1 610.5,167.1 	" />
      <path
        class="st2"
        d="M547,197.5c-0.1,0-0.2,0-0.3,0c0,0.1,0.1,0.1,0.1,0.2C547,197.6,547,197.5,547,197.5z"
      />
      <polygon class="st2" points="315.1,230.2 315.2,230.2 315.2,230.1 	" />
      <path
        class="st2"
        d="M506.1,206.7l0.1,0.1l0.1-0.1l-0.1-0.1C506.2,206.6,506.1,206.6,506.1,206.7z"
      />
      <polygon class="st2" points="506.6,207.2 506.7,207.3 506.7,207.2 	" />
      <path
        class="st2"
        d="M500.4,189.4c0,0,0.1,0,0.1,0.1l0.1-0.1l-0.1-0.1C500.5,189.3,500.5,189.4,500.4,189.4z"
      />
      <path
        class="st2"
        d="M596.6,187.8c-0.1,0-0.2,0-0.3,0C596.4,187.9,596.5,187.9,596.6,187.8c0.1,0.1,0.3,0.2,0.4,0.3l0.1,0.1
		c0-0.1,0-0.1-0.1-0.2C596.9,188,596.7,187.9,596.6,187.8z"
      />
      <path
        class="st2"
        d="M514.5,186.2L514.5,186.2C514.6,186.2,514.6,186.2,514.5,186.2C514.6,186.3,514.6,186.2,514.5,186.2
		C514.5,186.2,514.5,186.2,514.5,186.2z"
      />
      <path
        class="st2"
        d="M510.6,187.1c0-0.1,0-0.2,0-0.2C510.6,186.9,510.5,187,510.6,187.1C510.5,187.1,510.6,187.1,510.6,187.1
		L510.6,187.1L510.6,187.1z"
      />
      <polygon class="st2" points="602.5,166.7 602.4,166.6 602.4,166.7 	" />
      <path
        class="st2"
        d="M596.4,189.2L596.4,189.2C596.5,189.2,596.5,189.2,596.4,189.2c-0.1-0.1-0.2-0.2-0.4-0.3c0,0,0-0.1-0.1-0.1
		c0,0.1,0,0.1,0,0.2C596.1,189,596.3,189.1,596.4,189.2z"
      />
      <path
        class="st2"
        d="M546.7,200.2l0.1-0.1l0,0c-0.1,0-0.2,0-0.3,0.1C546.6,200.1,546.7,200.2,546.7,200.2z"
      />
      <path
        class="st2"
        d="M540.2,178.9c0,0-0.1-0.1-0.2-0.1l0,0l0,0C540.1,178.9,540.2,178.9,540.2,178.9z"
      />
      <path
        class="st2"
        d="M555.4,198.6c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.1,0-0.2-0.1C555.4,198.5,555.4,198.6,555.4,198.6z"
      />
      <path
        class="st2"
        d="M447.6,195.9l0.1,0.1l0.1-0.1l-0.1-0.1C447.7,195.8,447.6,195.8,447.6,195.9z"
      />
      <path
        class="st2"
        d="M558.8,170L558.8,170c-0.1,0.1-0.1,0.1-0.1,0.1l0,0L558.8,170z"
      />
      <path
        class="st2"
        d="M569,167.3c0,0.1,0,0.2,0.1,0.2l0.1-0.1C569.2,167.3,569.1,167.3,569,167.3z"
      />
      <path
        class="st2"
        d="M507.4,179.4c0,0,0.1,0,0.1,0.1l0.1-0.1l-0.1-0.1C507.5,179.3,507.4,179.4,507.4,179.4z"
      />
      <path
        class="st2"
        d="M559.6,167.8l0.1-0.1C559.7,167.7,559.6,167.7,559.6,167.8C559.6,167.7,559.6,167.8,559.6,167.8z"
      />
      <path
        class="st2"
        d="M559.7,167.7L559.7,167.7c0.1-0.1,0.1-0.1,0.1-0.1C559.8,167.6,559.8,167.6,559.7,167.7L559.7,167.7z"
      />
      <polygon class="st2" points="509.8,177.4 509.8,177.3 509.7,177.4 	" />
      <path
        class="st2"
        d="M526.9,206.5l0.1,0.1C526.9,206.6,526.9,206.5,526.9,206.5L526.9,206.5z"
      />
      <path
        class="st2"
        d="M527,206.7C527,206.7,527,206.6,527,206.7L527,206.7c0.1,0,0.3,0,0.4-0.1l0,0l0,0
		C527.2,206.6,527.1,206.7,527,206.7z"
      />
      <path
        class="st2"
        d="M420.9,230.3l-0.1,0.1l0.1,0.1l0.1-0.1C421,230.4,421,230.4,420.9,230.3z"
      />
      <polygon class="st2" points="391.5,238.7 391.4,238.7 391.4,238.8 	" />
      <polygon class="st2" points="486,219.5 486.1,219.5 486.1,219.4 	" />
      <polygon class="st2" points="487.9,219.4 488,219.4 488,219.3 	" />
      <path
        class="st2"
        d="M542,207.7c-0.1,0-0.2,0.1-0.3,0.1l0.1,0.1C541.9,207.8,542,207.7,542,207.7z"
      />
      <path
        class="st2"
        d="M598.2,198.4l0.1,0.1l0.1-0.1l-0.1-0.1C598.2,198.3,598.2,198.3,598.2,198.4z"
      />
      <polygon class="st2" points="376.1,247.5 376.2,247.4 376.1,247.4 	" />
      <path
        class="st2"
        d="M598.8,199l-0.1,0.1l0.1,0.1l0.1-0.1C598.9,199.1,598.8,199,598.8,199z"
      />
      <polygon class="st2" points="543.9,211.7 544,211.7 544,211.6 	" />
      <path
        class="st2"
        d="M566.8,210.6L566.8,210.6C566.7,210.6,566.7,210.7,566.8,210.6c0.1,0.1,0.3,0.2,0.4,0.3c0,0,0,0,0.1,0v-0.1
		C567.1,210.8,566.9,210.7,566.8,210.6z"
      />
      <polygon
        class="st2"
        points="478.3,234.9 478.4,235 478.4,234.9 478.4,234.9 478.4,234.9 	"
      />
      <path
        class="st2"
        d="M584.1,216.2c0.1,0,0.2,0.1,0.2,0.1h0.1c0,0,0,0,0-0.1l0,0l0,0C584.3,216.2,584.2,216.2,584.1,216.2z"
      />
      <path
        class="st2"
        d="M350.2,267.4c0.1,0,0.1,0,0.2,0.1v-0.1l-0.1-0.1C350.3,267.3,350.3,267.4,350.2,267.4z"
      />
      <path
        class="st2"
        d="M531.1,231.3L531.1,231.3c0.1-0.1,0.1-0.1,0.1-0.1l0,0L531.1,231.3z"
      />
      <path
        class="st2"
        d="M603.1,221.6c0,0.1,0,0.2-0.1,0.3C603.1,221.7,603.1,221.7,603.1,221.6c0.1,0,0.1-0.1,0.1-0.1
		C603.1,221.5,603.1,221.5,603.1,221.6L603.1,221.6z"
      />
      <path
        class="st2"
        d="M535.5,246.4l-0.1-0.1l-0.1,0.1l0.1,0.1C535.5,246.5,535.5,246.5,535.5,246.4z"
      />
      <path
        class="st2"
        d="M534.3,200.7c0.1-0.1,0.1-0.2,0.2-0.2l0,0l0,0C534.4,200.5,534.3,200.6,534.3,200.7z"
      />
      <path
        class="st2"
        d="M363.9,76.8c0.6,0.6,1.4,0.7,2.3,0.4c1.9-0.5,3.2-2,3.1-3.6c0-0.4-0.2-0.9-0.3-1.4c2.8,0.2,4.6-0.3,5.7-1.6
		c0.1-0.2,0.3-0.4,0.4-0.6c0.2-0.4,0.3-0.7,0.4-1.1c0.2-0.9-0.1-1.8-0.7-2.5c-0.2-0.2-0.4-0.5-0.7-0.7c-0.5-0.4-1.2-0.6-1.9-0.7
		c-1-0.1-2,0-2.9,0.4c-0.1,0.1-0.2,0.1-0.4,0.2c-0.4,0.2-0.7,0.4-0.9,0.6c-0.4,0.3-0.7,0.7-0.9,1.1v0.1c-0.4,0.9-0.4,2,0,3.5
		c-0.7,0-1.2-0.1-1.7-0.1c-1.9,0.2-3.3,1.2-3.8,2.7c-0.2,0.6-0.1,1.1,0.4,1.5C362.6,75.6,363.3,76.2,363.9,76.8z"
      />
      <path
        class="st2"
        d="M433.7,73.8c0.1,0,0.1,0,0.2,0c0.3-0.1,0.5-0.2,0.7-0.3c-0.3,0-0.6,0-1,0c-0.5,0-1,0-1.5,0
		C432.6,73.7,433.1,73.9,433.7,73.8z"
      />
      <path
        class="st2"
        d="M426.6,68c0.2,0.3,0.5,0.5,0.9,0.8c0.8-0.3,1.6-0.5,2.4-0.9c1.1-0.6,0.6-1.6,0.9-2.5c1.6,0.2,2.8,0.8,4,1.3
		c0.1,0,0.1,0.4,0.1,0.7c-0.8-0.3-1.4-0.5-2.3-0.9c0.5,1.3,0.8,2.5,1.2,3.6c0,0.1,0.1,0.3,0.1,0.4c-1.2,0.2-1.9,0.6-2.2,1.2
		c-0.1,0.1-0.1,0.2-0.1,0.3l0,0c0.7,0,1.4,0,2.1,0.1c0.5,0,1,0,1.5,0c0-0.4,0-0.8-0.1-1.3c1,0.1,2,0.2,3.2,0.2c-0.8-0.8-1-1-0.9-1.7
		c0-0.2,0.1-0.4,0.2-0.7c1.8,0.5,3.7,1.1,5.6,1.7c0-0.4,0.1-0.5,0-0.6c-0.5-0.9-1.2-1.6-1.1-2.8c0.1-0.9-1.4-1.4-2.4-0.8
		c-0.8,0.5-1.5,0.4-2.3,0.3c-0.4-0.1-0.8-0.2-1.2-0.3c-1.5-0.4-2.9-1.1-4.4-1.8c0.6-0.2,0.9-0.3,1.7-0.6c-0.7-0.1-1.4-0.3-2-0.4
		c-0.7-0.1-1.3-0.2-1.9-0.3c-0.2,0-0.4-0.1-0.6-0.1c-0.7-0.1-1.2,0.4-1.3,1.2l0,0c0,0.5-0.4,0.6-0.7,0.8c-0.5,0.3-0.9,0.7-1,1.1
		C425.9,66.7,426,67.3,426.6,68z"
      />
      <path
        class="st2"
        d="M310.8,113.1c0.6,0.7,1.2,1.5,1.7,2.3c0,0.1,0.1,0.1,0.2,0.2c0.5,0.7,1.2,1,2.3,0.9c0.7-0.1,1.4-0.2,1.9-0.5
		c0.9-0.5,1.8-1.3,2.6-1.8c0,0.3,0,0.6,0.1,0.9c0,0.1,0,0.3,0,0.4c0.1,0,0.2,0,0.3,0c0.1-0.1,0.2-0.3,0.2-0.4s0-0.2,0-0.4
		c-0.1-0.6-0.1-1.2-0.2-1.8c0-0.2,0-0.5-0.1-0.7c-0.1-0.9-0.5-1.7-1.2-2.3c-0.7,0.1-1.4,0.1-2.1,0.2c-0.2,0-0.4,0-0.5,0
		s-0.1,0-0.2,0c-1.5,0.2-3.1,0.3-4.6,0.5c-0.1,0.2-0.2,0.3-0.3,0.5C310.3,111.7,310.2,112.4,310.8,113.1
		C310.7,113,310.7,113.1,310.8,113.1z"
      />
      <path
        class="st2"
        d="M317.9,109.4c-0.1-0.1-0.3-0.2-0.4-0.3c-0.1,0-0.1,0-0.2-0.1c-2-0.9-4.4-0.5-5.9,1c1.8-0.2,3.5-0.3,5.3-0.5
		C317.2,109.5,317.5,109.5,317.9,109.4z"
      />
      <path
        class="st2"
        d="M389,54.7c0.4,2,2.4,3.1,4.8,2.6s3.9-2.3,3.6-4.3c-0.4-1.9-2.6-3.1-4.9-2.6C390,51,388.6,53,389,54.7z"
      />
      <path
        class="st2"
        d="M499.4,42.5c0.8,0.9,1.6,1.9,3.1,2c0.2,0,0.4,0.2,0.5,0.3c0,0.8-0.3,1.3-1.1,1.8c-1.2,0.8-1.3,2-0.3,2.8
		c0.8,0.7,1.9,0.6,2.8-0.2s0.9-1.7,0.1-2.3c-0.4-0.3-0.8-0.5-1.3-0.8c0.4-0.9,0.9-1.6,1.6-2.2c0.1-0.1,0.2-0.1,0.3-0.2
		c0.4-0.2,0.7-0.6,1-1l0.1-0.1l0,0c0.1-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1,0.1-0.1c0.3-0.7,0.3-1.7-0.3-2.1c-0.6-0.5-1.4-1-2.2-1.3
		c-1-0.4-2.1-0.3-3.2,0.1c-1,0.4-1.6,1.4-1.7,2.3C499,41.8,499.1,42.2,499.4,42.5z"
      />
      <path
        class="st2"
        d="M487,42.7c0.1,0.2,0.2,0.4,0.2,0.6c0.1,0.5,0,1.1-0.1,1.6c-0.1,0.2,0,0.5,0.1,1c0.3-0.7,0.4-1.1,0.6-1.6
		c0.5,0.6,0.4,1.1,0.3,1.7c0,0.1,0,0.2,0,0.2c-0.1,0.5-0.2,1,0,1.5c0.3-0.2,0.5-0.4,0.7-0.6c0.2,0.4,0.2,0.9,0.5,1.1
		c1,0.6,1.7,1.4,1.4,2.6c0,0.2,0.5,0.4,0.8,0.6c0.2-0.3,0.6-0.6,0.6-0.9c0-0.4-0.2-0.7-0.4-1.1c0.1-0.1,0.2-0.2,0.3-0.2
		c0.1,0.1,0.2,0.2,0.3,0.4c0.8,1.3,1.6,2.6,2.5,3.9c0.4,0.6,0.6,1,0.1,1.7s0,1.3,0.4,1.8s0.9,1,1.9,0.7c0.1-0.4,0.2-0.9,0.3-1.3
		c0.2,0,0.4,0,0.8,0.1c0-0.4,0.2-0.8,0-1c-0.4-0.8-0.3-2-1.6-2.3c-0.2-0.8-0.8-1.4-1.7-1.8c-0.1,0,0.1-0.3,0.1-0.4
		c-0.9-0.3-1.1-1.1-1.6-1.7c-0.2-0.2-0.5-0.5-0.8-0.5c-1.3-0.2-2.1-0.8-2.4-1.7c-0.2-0.7-0.6-1.3-0.9-2c-0.1-0.3-0.4-0.6-0.4-0.8
		c0.3-1.3-0.6-2.1-1.4-2.9c-0.1-0.1-0.2-0.2-0.3-0.3c0,0,0,0-0.1-0.1c0,0,0,0.1-0.1,0.1C486.9,41.7,486.7,42.2,487,42.7z
M497.4,56.3c-0.5-0.4-0.6-0.9-0.8-1.4C497.2,55.4,497.2,55.4,497.4,56.3z"
      />
      <path
        class="st2"
        d="M402,57.9c-1.7-1.7-3.5-2.1-5.3-1.1c-1.6,0.8-2.4,2.5-1.9,3.8c0.6,1.5,2.4,2.4,4.3,2c2-0.4,3.1-1.8,3.2-4.2
		c0.3-0.1,0.6-0.3,0.9-0.4c0-0.1-0.1-0.2-0.1-0.2C402.7,57.9,402.3,57.9,402,57.9z"
      />
      <path
        class="st2"
        d="M370.7,75.4c-2.1,0.5-3.4,2.1-3,3.8c0.3,1.7,2.2,2.7,4.3,2.3c2-0.4,3.5-2.1,3.2-3.8
		C374.8,76,372.8,75,370.7,75.4z"
      />
      <path
        class="st2"
        d="M532.4,70.4c0.3,0.2,0.7,0.3,1.1,0.4c0.1,0,0.2,0,0.3,0c0.6,0.1,1.2,0.1,1.7-0.1c0.1-0.2,0.2-0.4,0.3-0.7
		c-1.4-0.1-2.7-0.1-4.1-0.2C531.9,70.1,532.1,70.3,532.4,70.4z"
      />
      <path
        class="st2"
        d="M537.2,68.4c0.2-0.2,0.4-0.4,0.6-0.6c0-0.1,0-0.1,0-0.2c0-0.3,0.1-0.6,0.1-0.9c0-0.1,0-0.1,0-0.2
		c-0.1,0-0.1-0.1-0.2-0.1c-0.4-0.3-0.9-0.6-1.3-0.9c0,0,0,0-0.1,0c-1.2-0.6-2.6-0.5-3.8,0.2l-0.1,0.1c-0.3,0.2-0.6,0.4-0.8,0.7
		c-0.6,0.7-0.8,1.6-0.5,2.5c0,0.1,0.1,0.1,0.1,0.1s0,0.1,0.1,0.1c0,0,0,0,0.1,0c0.7,0,1.4,0.1,2.2,0.1c0.6,0,1.2,0,1.8,0.1
		c0.5,0,1-0.2,1.5-0.6C536.9,68.7,537.1,68.6,537.2,68.4z"
      />
      <path
        class="st2"
        d="M402.9,56.4c0.8,0.9,1.9,1.1,3.1,1c1.5-0.3,3.5-2.3,3.5-3.4c0-0.7-0.4-1.3-1.2-1.5c-0.7-0.2-1.5-0.4-2.3-0.4
		c-1.3-0.1-2.4,0.4-3.2,1.4C402.1,54.3,402.1,55.5,402.9,56.4z"
      />
      <path
        class="st2"
        d="M608.3,43.3C608.4,43.3,608.4,43.4,608.3,43.3C608.4,43.4,608.4,43.3,608.3,43.3
		C608.4,43.3,608.4,43.3,608.3,43.3L608.3,43.3z"
      />
      <path
        class="st2"
        d="M603.9,43.3c-0.6,0.4-1.1,0.9-1.3,1.6c-0.5,1.5,0.6,3,2.4,3.3c1.5,0.3,3.5-0.8,4-2.2c0-0.1,0.1-0.2,0.1-0.4
		c0.1-0.9-0.5-1.5-0.7-2.3c-0.5-0.2-0.9-0.4-1.4-0.5C605.9,42.5,604.8,42.8,603.9,43.3z"
      />
      <path
        class="st2"
        d="M406.7,63.9c-0.5-1.2-2.1-1.8-3.6-1.5c-1.8,0.4-3,1.9-2.6,3.4c0.3,1.3,2.1,2.2,3.7,1.9c1-0.2,1.9-0.8,2.4-1.6
		c0.3-0.5,0.5-1.1,0.4-1.7C406.8,64.2,406.7,64.1,406.7,63.9z"
      />
      <path
        class="st2"
        d="M410.1,57.6c-1.7,0.4-2.8,1.8-2.6,3.2c0.3,1.5,1.9,2.4,3.7,2c1.8-0.4,3-1.8,2.6-3.3
		C413.6,58.1,411.9,57.2,410.1,57.6z"
      />
      <path
        class="st2"
        d="M526.5,48.9c1.7-0.4,2.8-1.9,2.5-3.3c-0.3-1.4-2-2.2-3.7-1.9l0,0h-0.1c-0.3,0.1-0.5,0.2-0.8,0.3
		c-0.2,0.1-0.3,0.1-0.4,0.2c-1,0.6-1.5,1.6-1.3,2.7C523,48.4,524.8,49.3,526.5,48.9z"
      />
      <path
        class="st2"
        d="M393.4,70.6c0.1,0.3,0.2,0.5,0.3,0.7c0.3,0.2,0.7,0.2,1.3,0.2c0.1,0,0.3,0,0.4,0c1.1,0,2.2,0,3.4,0
		c0.2-0.2,0.5-0.5,0.6-0.8c0.3-0.5,0.4-1,0.2-1.6c-0.3-1.3-1.7-2.1-3.4-1.9c-0.1,0-0.2,0-0.3,0c-0.5,0.1-1,0.3-1.4,0.6
		C393.6,68.7,393.1,69.6,393.4,70.6z"
      />
      <path
        class="st2"
        d="M349.2,92.6c-0.2-0.4-0.7-0.6-1.3-0.7c-0.1,0-0.3,0-0.5-0.1c-0.3,0-0.6,0-1,0c-1.2-1.2-2.2-1.5-3.4-0.9
		c-0.9,0.4-1.5,1.4-1.2,2.3c0.2,0.6,0.5,0.9,1.1,1.1c1.2,0,2.4,0,3.6,0c0.9,0,1.8,0,2.7,0c0.1-0.2,0.1-0.3,0.2-0.5l0,0
		c0-0.2,0-0.4,0-0.6C349.3,92.9,349.3,92.7,349.2,92.6z"
      />
      <path
        class="st2"
        d="M416,63.6c-1.2,0.1-2.1,0.7-2.6,1.6c-0.2,0.3-0.1,0.8-0.8,0.9c0.2,0.2,0.4,0.4,0.8,0.6c-0.9,0.4-2.1,0.5-2,1.5
		c0,0.5,0.3,0.9,0.9,1c1.1,0.2,1.6-0.5,1.9-1.2c0.7,0.1,1.2,0.2,1.8,0.1c0.3,0,0.6-0.1,0.9-0.2c1.1-0.4,1.7-1.2,1.7-2.2
		c0-0.6-0.3-1.2-0.7-1.5C417.5,63.7,416.8,63.5,416,63.6z"
      />
      <path
        class="st2"
        d="M531.6,43.7c0.8,0.3,1.7,0.3,2.5-0.1c0.3-0.1,0.6-0.3,0.9-0.5c0.9-0.8,1.2-1.9,0.7-2.8c-0.2-0.3-0.4-0.6-0.6-1
		c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.6,0-1.3,0-2,0.1c-1,0.1-1.8,0.6-2.2,1.2c-0.2,0.2-0.3,0.5-0.4,0.8
		C529.9,42.1,530.5,43.3,531.6,43.7z"
      />
      <path
        class="st2"
        d="M331.5,68.4c0.2,1.2,1.8,2.1,3.4,1.8c1.4-0.3,2.5-1.7,2.3-2.9c-0.2-1.2-1.8-2-3.2-1.7
		C332.5,65.9,331.3,67.2,331.5,68.4z"
      />
      <path
        class="st2"
        d="M399.3,74.5c-0.2,0.3-0.3,0.6-0.4,0.9c0,0.1,0,0.1,0,0.2s0,0.1,0,0.2s0,0.2,0,0.3c0.1,0.6,0.4,1.1,0.6,1.8
		c0.1-0.1,0.2-0.2,0.3-0.1c0.2,0,0.4,0,0.6,0s0.4,0,0.6,0c0.1,0,0.3,0,0.4,0c1.2-0.1,2.3-0.7,2.7-1.7c0.1-0.3,0.2-0.6,0.1-1
		c0-0.4-0.2-0.8-0.5-1.2c-0.1-0.1-0.3-0.3-0.4-0.4c-0.8-0.6-2-0.6-3-0.2h-0.1c-0.2,0.1-0.4,0.2-0.6,0.4
		C399.6,74.1,399.4,74.3,399.3,74.5z"
      />
      <path
        class="st2"
        d="M406.7,69.4c-0.1,0.1-0.2,0.2-0.3,0.4c-0.3,0.5-0.4,1.1-0.3,1.6c0,0.1,0.1,0.2,0.1,0.3c1.3,0,2.6,0,3.9,0.1
		c0.3,0,0.6,0,1,0c0.1-0.1,0.2-0.3,0.2-0.4c0.2-0.4,0.2-0.8,0.1-1.2c-0.2-0.9-1.1-1.5-2.1-1.6c-0.3,0-0.7,0-1,0.1s-0.6,0.2-0.8,0.3
		C407.2,69,406.9,69.2,406.7,69.4z"
      />
      <path
        class="st2"
        d="M341.2,76.4c0.5-0.2,1.1-0.4,0.7-1c0-0.1,0.2-0.4,0.3-0.4c1.1-0.2,0.7-0.8,0.7-1.2c-0.3-1.4-1.8-2.1-3.3-1.6
		c-1.5,0.4-2.5,1.8-2.1,3C338,76.3,339.7,77,341.2,76.4z"
      />
      <path
        class="st2"
        d="M365.4,66.6c1.6-0.3,2.6-1.5,2.4-2.8c-0.2-1.2-1.6-1.9-3.1-1.7c-1.5,0.3-2.6,1.5-2.4,2.8
		C362.6,66.1,363.9,66.9,365.4,66.6z"
      />
      <path
        class="st2"
        d="M552.3,7.7c0.1,0.7,0.8,1,1.6,1c1.2,0.1,2.3-0.3,3.2-1c0.7-0.6,0.9-1.6,0.5-2.3c-0.7-1.1-1.1-1.3-2.9-0.9
		c-0.3,0.2-1.1,0.4-1.7,0.9C552.1,6,552.1,6.9,552.3,7.7z"
      />
      <path
        class="st2"
        d="M602.2,54.4c0,0.1,0,0.1,0,0.2c0.2,1.2,1.6,1.9,3.1,1.6c1.4-0.3,2.4-1.5,2.2-2.6c-0.2-1.2-1.5-2-3-1.7
		c-1,0.2-1.7,0.8-2.1,1.5C602.2,53.7,602.2,54.1,602.2,54.4z"
      />
      <path
        class="st2"
        d="M517,37.1c0.6-0.1,1.2-0.1,1.7-0.2c0.2,0,0.4-0.1,0.6-0.1c0.9-0.3,1.3-1.2,1.1-2c-0.1-0.3-0.2-0.6-0.5-0.9
		c-0.2-0.2-0.4-0.3-0.7-0.4c-0.2-0.1-0.4-0.1-0.7-0.1l0,0c-0.5,0-1,0.2-1.5,0.4c-0.3,0.2-0.5,0.4-0.7,0.6c-0.1,0.1-0.1,0.2-0.2,0.3
		c-0.2,0.5-0.3,1-0.4,1.4c-0.3,0.1-0.7,0.2-0.9,0.4c-0.1,0-0.1,0.1-0.1,0.1c-0.8,0.6-0.7,1.2,0.1,1.8c0.2,0.1,0.3,0.2,0.5,0.3
		c0.1,0,0.3,0,0.4-0.1C516.7,38.4,517.1,37.8,517,37.1z"
      />
      <path
        class="st2"
        d="M406.6,78c-0.9-0.2-1.4,0.1-2.3,1.3c0.2,0.3,0.5,0.6,0.7,0.9c-0.1,0.1-0.1,0.1-0.2,0.2
		c-0.3-0.1-0.6-0.3-0.9-0.4c-0.1,0-0.2,0.1-0.3,0.1c0.4,0.7,0.8,1.5,1.3,2.2s1.3,0.8,2.2,0.7c0.9-0.2,1.5-0.7,1.8-1.5s0-1.4-0.7-1.9
		c-0.4-0.2-0.8-0.4-1.3-0.6C407.1,78.6,407.4,78.1,406.6,78z"
      />
      <path
        class="st2"
        d="M326,93.6c-0.3-0.4-0.7-0.5-0.4-1.1c0.2-0.4-0.2-0.8-0.8-0.8c-0.6,0-1.1,0.4-1,0.8c0.2,0.6-0.2,0.9-0.6,1.3
		c-0.3,0.3-0.5,0.6-0.7,0.9c1.3,0,2.7-0.1,4-0.1C326.4,94.2,326.3,93.8,326,93.6z"
      />
      <path
        class="st2"
        d="M326.5,96.2L326.5,96.2c0.2-0.2,0.4-0.3,0.5-0.4c-0.2,0-0.4,0-0.5,0c-1.3,0-2.6,0.1-3.9,0.1
		c0,0.1,0.1,0.3,0.2,0.4C323.9,96.3,325.2,96.3,326.5,96.2z"
      />
      <path
        class="st2"
        d="M373.7,109.6c0.2-0.2,0.3-0.3,0.4-0.4l0.1-0.1c0.4-0.5,0.3-0.7-0.1-1.3l-0.1-0.1c0-0.1-0.1-0.2,0-0.2
		c0.6-0.4,0.1-0.8-0.1-1c-0.3-0.2-0.7-0.4-1.1-0.5h-0.1c-0.6-0.1-1.3,0.4-1.1,0.8c0.1,0.2,0.2,0.5,0.2,0.8c0.1,0.6,0.1,1.3,0.6,1.8
		c0.1,0.1,0.2,0.2,0.4,0.3c0.1,0.1,0.3,0.1,0.5,0.2l-0.1,0.1c-0.9,1-1.3,1.6-0.9,2.3c0.2,0.4,0.7,0.8,1.5,1.2c1-0.4,1.5-1,1.6-1.9
		c0-0.1,0-0.2,0-0.3C375.1,110.2,374.3,109.9,373.7,109.6z"
      />
      <path
        class="st2"
        d="M378.3,100.3h-0.1c-0.2,0-0.4-0.1-0.6-0.1c-0.8,0.7-1.6,1.5-2.6,2.4l0,0c0.5,0,1,0,1.4,0c0.5,0,1,0,1.5,0
		c1.5,0,3,0,4.5,0c-0.5-0.1-1.1-0.2-1.7-0.3c-0.3-0.9-0.7-1.4-1.6-1.7c-0.1,0-0.2-0.1-0.2-0.1C378.8,100.4,378.6,100.4,378.3,100.3z
		"
      />
      <path
        class="st2"
        d="M382.5,104.2c0-0.1,0-0.2,0.1-0.4c-0.7,0-1.4,0-2.2,0C381,104.5,381.3,104.4,382.5,104.2z"
      />
      <path
        class="st2"
        d="M537.7,37.1c0.2,1.1,1.6,1.8,3,1.5s2.2-1.4,2-2.5s-1.5-1.7-2.9-1.5C538.4,34.9,537.5,36,537.7,37.1z"
      />
      <path
        class="st2"
        d="M557.6,32.1c0.3-1.2-1.2-2.2-2.6-1.9c-1,0.2-1.7,0.9-1.9,1.8c-0.1,0.8,0.3,1.6,1.2,1.8
		c0.4,0.1,0.8,0.2,1.2,0.3c0.5,0.1,1,0.3,1.4,0.6c0.1,0.1,0.6-0.1,0.8-0.2c0.1-0.1,0.2-0.5,0.1-0.5c-0.2-0.2-0.3-0.3-0.3-0.5
		C557.4,33,557.5,32.6,557.6,32.1z"
      />
      <path
        class="st2"
        d="M413.8,74.3c-0.7-1.1-0.7-1.1-2.3-1.2c0.5,1.1,1,1.9,0.4,3c-0.4,0.9,0.5,1.8,1.6,1.9c0.8,0.1,1.5-0.1,2-0.5
		c0.1-0.1,0.3-0.3,0.4-0.4s0.1-0.2,0.2-0.2c0.2-0.4,0.3-0.8,0.2-1.2c-0.1-0.5-0.5-0.9-1.1-1.1c-0.3-0.1-0.6-0.2-0.9-0.2
		C414.1,74.4,414,74.4,413.8,74.3z"
      />
      <path
        class="st2"
        d="M544.5,44.2c0.4,0.1,0.8,0.2,1.2,0.1c0.9-0.2,1.7-0.8,2-1.6c0.1-0.2,0.1-0.4,0.1-0.6c0-0.1,0-0.2,0-0.3
		c-0.2-1.1-1.5-1.8-2.8-1.5c-0.9,0.2-1.5,0.8-1.8,1.5c-0.2,0.4-0.2,0.7-0.1,1.1C543.2,43.5,543.8,44,544.5,44.2z"
      />
      <path
        class="st2"
        d="M572.7,21.7c-0.6,0.2-1.2,0.6-1.7,1c-0.7,0.6-0.8,1.5-0.3,2.1s1.8,0.9,2.6,0.6s1.5-0.7,2.2-1.1
		c-0.2-1.1-0.5-1.6-0.9-2.2C574.1,21.6,573.4,21.5,572.7,21.7z"
      />
      <path
        class="st2"
        d="M432.2,42.7c0.7,0.2,1.5,0.4,2.2,0.4c0.5,0,1-0.2,1.5-0.4c0.3-0.1,0.5-0.4,0.8-0.6c1.1-0.8,1.2-1.5,0.5-2.6
		c-0.4,0.2-1,0.7-1.3,0.6c-1.6-0.4-2.8,0.1-3.9,1.2c-0.2,0.2-0.5,0.3-0.8,0.4C431.4,42.2,431.6,42.6,432.2,42.7z"
      />
      <path
        class="st2"
        d="M371.3,60.9c1.3-0.3,2.1-1.4,1.8-2.4c-0.3-1-1.6-1.6-2.8-1.3c-1.2,0.3-2.1,1.5-1.8,2.5
		C368.7,60.6,370,61.2,371.3,60.9z"
      />
      <path
        class="st2"
        d="M388.4,50.2c1.2-0.3,2.1-1.4,1.9-2.4s-1.5-1.6-2.8-1.3c-1.2,0.3-2.1,1.5-1.8,2.5
		C386,49.8,387.2,50.4,388.4,50.2z"
      />
      <path
        class="st2"
        d="M592.6,58.8c-0.8-0.6-1.6-0.1-2.5,0.1c-0.3-1.3-1.7-0.7-2.7-1c-0.3,0.4-0.5,0.8-0.8,1.1c0.8,0.7,1.6,1.3,2.3,2
		c0.5,0,1-0.2,1.4-0.1c0.8,0.3,1.6,0.1,2.4-0.1C592.9,60.1,593.4,59.4,592.6,58.8z"
      />
      <path
        class="st2"
        d="M374.7,64.2c0.1,0.3,0.4,0.5,0.6,0.7c0.5,0.3,1.1,0.5,1.8,0.3c1.3-0.2,2.2-1.3,1.9-2.4c-0.2-1-1.3-1.6-2.6-1.3
		c-1.3,0.2-2.1,1.1-2,2.2C374.5,63.9,374.6,64,374.7,64.2z"
      />
      <path
        class="st2"
        d="M398.2,85.6c0.1,0.2,0.2,0.5,0.3,0.7c0.3,0.9,0.7,1.4,1.7,1.4h0.1h0.1c0.3-0.1,0.6-0.3,0.9-0.5
		c0.3-0.3,0.6-0.7,0.7-1c0-0.2,0.1-0.4,0-0.6c-0.2-1.1-1.3-1.7-2.6-1.5c-0.6,0.1-1.1,0.4-1.5,0.8C398,85.2,398.1,85.4,398.2,85.6z"
      />
      <path
        class="st2"
        d="M558.6,31.4c0.5,0.3,1.2,0.5,2.2,0.7c-0.2,1,0.1,1.7,1.2,2.2c0.6-1.2,0.6-1.2-0.5-2.5c0.9-0.9,0.9-1,0.6-1.4
		c-0.4-0.4-0.8-0.9-1.3-1.2c-0.5-0.4-1.1-0.7-1.8-0.8C557.7,29.7,557.6,30.7,558.6,31.4z"
      />
      <path
        class="st2"
        d="M592.4,54.4c0.1,0.2,0.1,0.5,0.3,0.7c0.7,1,2.6,1.2,3.5,0.3c0.9-0.8,0.9-2,0.1-2.7c-0.9-0.7-2.2-0.6-3.1,0.2
		c-0.4,0.3-0.8,0.7-1.2,1.1C592.1,54.1,592.3,54.2,592.4,54.4z"
      />
      <path
        class="st2"
        d="M334.4,79.3c-0.2-0.9-1.4-1.6-2.5-1.4c-0.3,0.1-0.6,0.2-0.9,0.3l0,0c-0.7,0.5-1.2,1.3-1.1,2
		c0.2,1,1.4,1.5,2.6,1.3C333.8,81.3,334.6,80.3,334.4,79.3z"
      />
      <path
        class="st2"
        d="M383.9,59c0.3,1.4,1.4,2,3.4,1.8c-0.4-1.6-0.1-3.4-0.8-5C384.4,56.6,383.6,57.6,383.9,59z"
      />
      <path
        class="st2"
        d="M336.2,87.3c0.5,0.6,1.4,0.9,2.3,0.7c0.5-0.1,0.9-0.4,1.3-0.7C338.5,87.3,337.3,87.3,336.2,87.3z"
      />
      <path
        class="st2"
        d="M340.2,85.6c-0.3-1-1.3-1.5-2.6-1.2c-0.8,0.2-1.4,0.7-1.7,1.3c1.4,0,2.9,0,4.3,0
		C340.2,85.7,340.2,85.6,340.2,85.6z"
      />
      <path
        class="st2"
        d="M349.5,87.4c0,0-0.1,0-0.1,0.1c0.1,1.3-0.1,2.7,0.5,4.2c0.4-0.7,0.6-1.1,0.9-1.7c0.7,0,1.4-0.2,1.9-0.7
		c0.2-0.2,0.3-0.3,0.4-0.6c0-0.1,0.1-0.1,0.1-0.2c0.1-0.5,0-0.8-0.2-1.1C351.9,87.5,350.7,87.4,349.5,87.4z"
      />
      <path
        class="st2"
        d="M390.9,62.6c-0.3,0.1-0.5,0.2-0.8,0.3c0.1,0.1,0.2,0.2,0.2,0.4c0.4,0.9,0.7,1.9,1.1,2.9c0.1,0,0.2,0,0.3,0
		c1.1-0.3,1.9-1.3,1.7-2.2C393.2,62.9,392,62.4,390.9,62.6z"
      />
      <path
        class="st2"
        d="M571.1,44.5C571.1,44.5,571.1,44.4,571.1,44.5c-0.2-0.4-0.3-0.6-0.4-0.9c-0.7,0.4-1.4,0.8-2,1.2
		c0.2-0.5,0.5-0.8,0.8-1.1c0.4-0.4,0.8-0.8,0.3-1.2c-0.4-0.3-0.9,0-1.3,0.3c-0.3,0.3-0.6,0.5-0.9,0.8c-0.4-0.2-0.7-0.3-1.6-0.6
		c0.6,1.2,0.3,2-0.5,2.7c-0.3,0.3-0.2,0.7-0.4,1.4c0.9-0.5,1.5-0.7,2.2-1.1c0.2,0.2,0.4,0.5,0.6,0.7
		C569.1,45.7,569.3,44.4,571.1,44.5L571.1,44.5z"
      />
      <path
        class="st2"
        d="M306.7,67.9c1.2-0.3,2-1.3,1.7-2.3c-0.2-0.9-1.3-1.5-2.4-1.2v2.9V68C306.2,68,306.4,68,306.7,67.9z"
      />
      <path
        class="st2"
        d="M576.7,54.6c1.1-0.7,2.1-1.3,3.1-2c-0.4-0.5-0.7-1-1-1.5c-0.3-0.4-0.5-0.8-0.8-1.2c-0.4,0.1-0.8,0.3-1.1,0.5
		c-0.2,0.1-0.4,0.3-0.5,0.4c-0.1,0.2-0.2,0.3-0.1,0.5c0.4,0.8-0.2,1.5-0.5,2.2l0,0C576.2,54,576.4,54.3,576.7,54.6z"
      />
      <path
        class="st2"
        d="M393.7,81.3c-0.2-0.5-0.3-1-0.5-1.4c-0.2,0.3-0.3,0.7-0.2,0.9c0.1,0.2,0.2,0.4,0.4,0.6
		c0.2,0.2,0.3,0.4,0.5,0.6C393.8,81.8,393.8,81.6,393.7,81.3C393.7,81.4,393.7,81.3,393.7,81.3z"
      />
      <path
        class="st2"
        d="M376.8,71.6c-0.1,0-0.3,0.1-0.4,0.2c-0.8,0.5-1.4,0.5-2.2,0.4c-0.2,0-0.4,0.1-0.9,0.3c1,0.7,1.9,1.4,2.9,2
		c0.2,0.1,0.5,0.2,0.8,0.2c0.1,0,0.1,0,0.2,0c0.2,0,0.3-0.1,0.5-0.2s0.4-0.2,0.5-0.4c0.6-0.6,0.7-1.3,0.2-1.8
		C378.1,71.8,377.4,71.5,376.8,71.6z"
      />
      <path
        class="st2"
        d="M364.7,104.9c0.5,0.4,1.2,0.5,2,0.2c0.1-0.5-0.5-0.8-0.8-1.2c-0.6,0-1.2,0-1.8,0
		C364.2,104.3,364.4,104.6,364.7,104.9z"
      />
      <path
        class="st2"
        d="M364.2,102.7c1.4,0,2.7,0,4.1-0.1c-0.2-0.7-0.8-1-1.6-1.1c-0.3,0-0.8,0-0.8,0.2c-0.2,0.4-0.5,0.5-1,0.6
		C364.5,102.3,364.3,102.5,364.2,102.7z"
      />
      <path
        class="st2"
        d="M449.4,61.2c0,0.1,0.1,0.1,0.2,0.2c0.7,0.2,1.4,0.3,2.1,0.4c0.1-0.1,0.2-0.3,0.3-0.4c0-0.1,0-0.1,0.1-0.2
		c0-0.1,0.1-0.2,0.1-0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.3-0.2-0.6-0.3-0.8-0.4c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.1,0.1-0.2
		c0.2-0.3,0.5-0.5,1-0.7c0.2-0.1,0.5-0.2,0.7-0.2c-0.6-0.5-1.1-1-1.6-1.5l-0.1-0.1c-0.7,0.5-1.3,0.8-1.8,1.3
		c-0.2,0.1-0.2,0.3-0.3,0.4c-0.1,0.3,0.1,0.7,0.2,1c0,0.1-0.2,0.3-0.4,0.5C449.3,60.7,449.3,61,449.4,61.2z"
      />
      <path
        class="st2"
        d="M544,51.2c-0.3,0-0.5,0-0.8,0c-1.1,0.2-1.7,1-1.5,1.9c0.1,0.4,0.3,0.8,0.7,1s0.9,0.3,1.4,0.2
		c1-0.2,1.7-1.1,1.6-1.9C545.3,51.7,544.7,51.3,544,51.2z"
      />
      <path
        class="st2"
        d="M497.9,31.9c1-0.2,1.7-0.8,1.5-1.3c-0.3-1.1-1.2-1.6-2.5-1.3c-1.1,0.3-1.6,0.8-1.5,1.5
		C495.5,31.7,496.6,32.2,497.9,31.9z"
      />
      <path
        class="st2"
        d="M557.8,38.3c-0.2-0.8-1.2-1.3-2.2-1.1s-1.7,1.1-1.5,1.9c0.2,0.8,1.2,1.2,2.1,1C557.3,39.8,558,39.1,557.8,38.3
		z"
      />
      <path
        class="st2"
        d="M442.8,32.9c0.5-0.3,1-0.7,1.5-1c0.4,0.9,1.2,1.3,2.3,1.4c0.2-0.2,0.5-0.4,0.5-0.6c0.1-0.3,0-0.7-0.2-0.8
		c-0.8-0.5-1.7-0.8-2.5-1.2c-0.3,0.3-0.5,0.5-0.7,0.8c-0.7-0.1-1.4-0.3-2.3-0.5C441.4,32,441.8,32.5,442.8,32.9z"
      />
      <path
        class="st2"
        d="M580.5,54.6c0.1,0.3,0.2,0.6,0,0.8c-1,1.3-0.4,2.1,0.8,2.9c0.1-0.1,0.2-0.2,0.2-0.3l0.1-0.1
		c0.6-0.6,1.4-1.2,1-1.9c-0.1-0.2-0.2-0.5-0.2-0.8c-0.1-0.4-0.1-0.8-0.3-1.1s-0.5-0.6-1.2-0.7C580.4,54.3,580.4,54.2,580.5,54.6z"
      />
      <path
        class="st2"
        d="M424.7,77.6c0.2,0.6,0.9,1,1.6,1c0.1,0,0.3,0,0.4,0c1-0.2,1.7-1.1,1.5-1.9s-1.1-1.2-2-1.1
		c-1,0.2-1.6,0.9-1.6,1.7C424.6,77.4,424.6,77.5,424.7,77.6z"
      />
      <path
        class="st2"
        d="M364.9,59.3c0.9-0.2,1.6-1,1.6-1.7c-0.1-0.8-1.1-1.4-2.1-1.2c-0.9,0.2-1.6,0.9-1.6,1.7
		C362.9,58.9,363.9,59.5,364.9,59.3z"
      />
      <path
        class="st2"
        d="M606.6,20.3c0.4,0.5,1.1,0.8,1.9,0.7c0.9-0.2,1.6-1,1.5-1.8c-0.1-0.3-0.2-0.6-0.5-0.8
		c-0.4-0.3-0.9-0.4-1.5-0.4c-1,0.1-1.8,1.1-1.6,1.9C606.5,20.1,606.6,20.2,606.6,20.3z"
      />
      <path
        class="st2"
        d="M332.1,95.7c-0.9,0-1.7,0-2.6,0.1c-0.2,0.1-0.3,0.3-0.4,0.4c1.1,0,2.2,0,3.3,0C332.3,96,332.2,95.9,332.1,95.7
		z"
      />
      <path
        class="st2"
        d="M331.2,98.1c0.4-0.1,0.8-0.4,1-0.7c-1,0-2.1,0-3.1,0C329.5,98.1,330.4,98.3,331.2,98.1z"
      />
      <path
        class="st2"
        d="M586.2,66.1c0.9,0.5,0,1.4,0.5,1.9c1.5,0.6,1.5,0.6,2.9-0.2c0.1-0.5,0.2-1.1,0.3-1.5c-0.8-0.9-2.2-0.3-3-0.9
		C586.6,65.2,585.9,65.9,586.2,66.1z"
      />
      <path
        class="st2"
        d="M419,80.4c-0.9,0.2-1.6,1-1.5,1.8s0.9,1.3,1.9,1.2c0.1,0,0.1,0,0.1,0c1-0.2,1.6-1,1.4-1.8
		c-0.1-0.3-0.2-0.5-0.4-0.7C420.2,80.5,419.6,80.3,419,80.4z"
      />
      <path
        class="st2"
        d="M541.2,34c0.9-0.3,1.6-1.3,1.4-2c-0.2-0.7-0.9-1.1-1.7-0.9c-1.1,0.3-2,1.4-1.8,2.2
		C539.2,33.7,540.6,34.2,541.2,34z"
      />
      <path
        class="st2"
        d="M348.8,68.6c0.8,0.6,1.7,0.8,2.8,0.3c0-2-0.8-2.7-3.2-2.7C347.7,67.1,348,67.9,348.8,68.6z"
      />
      <path
        class="st2"
        d="M500,46.7c-0.9,0.5-1.6,0.8-2.1,1.2c-0.7,0.4-1.1,1-1.1,1.7c0.1,0.8,0.8,1.1,1.6,0.8c0.6-0.3,1.1-0.7,1.6-0.9
		C500,48.5,500,47.7,500,46.7z"
      />
      <path
        class="st2"
        d="M330.3,93h0.1c0.9-0.3,1.5-1,1.3-1.8c-0.2-0.7-1-1.1-1.9-1c-0.1,0-0.1,0-0.2,0c-0.9,0.2-1.6,1.1-1.4,1.8
		C328.4,92.8,329.3,93.2,330.3,93z"
      />
      <path
        class="st2"
        d="M357.4,75.3c0.3-1.9-0.6-2.7-3-2.8C353.6,74.5,354.6,75.5,357.4,75.3z"
      />
      <path
        class="st2"
        d="M381.5,62.7c1-0.2,1.6-1,1.4-1.8c-0.2-0.7-1-1.1-1.9-0.9c-1,0.2-1.6,1-1.4,1.8
		C379.8,62.5,380.6,62.9,381.5,62.7z"
      />
      <path
        class="st2"
        d="M400.7,50.4c0.9-0.2,1.4-1,1.3-1.7s-0.9-1.2-1.8-1c-1,0.2-1.6,0.9-1.5,1.7C398.8,50.2,399.7,50.6,400.7,50.4z"
      />
      <path
        class="st2"
        d="M411.6,51.3c0,0.1,0.1,0.2,0.1,0.3c0.1,0.1,0.1,0.2,0.3,0.3c0.3,0.3,0.9,0.5,1.4,0.4c0.7-0.1,1.2-0.6,1.4-1.1
		c0.1-0.2,0.1-0.4,0-0.6c0-0.1,0-0.1-0.1-0.2c-0.1-0.2-0.2-0.4-0.4-0.5l0,0c-0.4-0.3-0.9-0.4-1.4-0.3
		C412,49.8,411.4,50.5,411.6,51.3z"
      />
      <path
        class="st2"
        d="M410.4,47.7L410.4,47.7c1-0.2,1.5-0.9,1.4-1.6c0-0.1,0-0.2-0.1-0.3c-0.2-0.6-0.9-0.9-1.7-0.8
		c-0.9,0.1-1.6,1-1.5,1.7C408.6,47.5,409.5,47.9,410.4,47.7z"
      />
      <path
        class="st2"
        d="M551.6,57.3c0.7,0.9,1.2,0.8,2.1-0.3c-0.7-1.1-2-1.5-3.3-1.9c-0.3-0.1-0.9,0-1.2,0.2c-0.4,0.3-0.2,0.6,0,0.9
		c0.1,0.1,0.1,0.3,0.2,0.5C550.3,56.6,551,56.6,551.6,57.3z"
      />
      <path
        class="st2"
        d="M337.6,97.4c-1.1,0-2.2,0-3.3,0c-0.1,0.1-0.1,0.2-0.2,0.3c0.8,0.5,1.5,1.1,2.4,1.7
		C337.5,98.8,338,98.2,337.6,97.4z"
      />
      <path
        class="st2"
        d="M440.1,31c-0.2-0.8-1.3-0.8-2.3-0.5c-0.4,1.2-0.3,2.3,0.5,3.3C439.9,33,440.4,32,440.1,31z"
      />
      <path
        class="st2"
        d="M577.5,26.5c0.6,0.3,1.3,0.2,1.8-0.3c0.4-0.3,0.7-0.7,1-1.2c-1.1-1-1.6-1.1-2.4-0.8c-0.4,0.2-0.7,0.4-0.9,0.7
		c0,0.1-0.1,0.2-0.2,0.3c0,0.1,0,0.2,0,0.2l0,0c0,0.1,0.1,0.2,0.1,0.3C577.1,26.2,577.3,26.4,577.5,26.5z"
      />
      <path
        class="st2"
        d="M346.6,82.7c-0.7-1.1-1.4-2.2-2.2-3.3c-0.1-0.1-0.1-0.2-0.2-0.3c-0.2,0.3-0.4,0.5-0.6,0.8
		c-0.4,0.7-0.4,1.4,0.1,2.1C344.5,82.8,345.1,83,346.6,82.7z"
      />
      <path
        class="st2"
        d="M460.4,72c-1-0.7-1.2-0.7-1.7,0.2c-0.2,0.4-0.7,0.4-0.9,0.7c-0.3,0.3-0.7,0.7-0.7,1s0.5,0.6,0.8,0.8
		c0.3,0.2,0.7,0.1,1.1,0.2c0-0.1,0.1-0.3,0.1-0.4c0.1-0.3,0.2-0.7,0.4-1c0.2-0.3,0.4-0.6,0.6-1C460.2,72.4,460.3,72.2,460.4,72z"
      />
      <path
        class="st2"
        d="M378.8,82.5c-0.2-0.7-1-1.1-1.8-0.8c-0.4,0.1-0.7,0.4-0.9,0.6c-0.2,0.3-0.3,0.6-0.2,1c0,0.1,0.1,0.2,0.2,0.3
		c0.3,0.4,0.9,0.6,1.5,0.4C378.4,83.8,378.9,83.2,378.8,82.5z"
      />
      <path
        class="st2"
        d="M602,33.8c0.8-0.1,1.4-0.8,1.3-1.5c-0.1-0.7-0.9-1.1-1.7-1c-0.8,0.2-1.3,0.8-1.3,1.4
		C600.4,33.4,601.1,33.9,602,33.8z"
      />
      <path
        class="st2"
        d="M562,47.7c0.1-0.7,0.2-1.1,0.3-1.5c0.3,0.2,0.6,0.4,0.8,0.6l0,0c0.7-1.5,0.4-2.1-1.1-2.2c-0.1,0-0.3,0-0.4,0
		c-0.7,0-1.1,0.4-0.8,0.9s0.5,0.9,0.4,1.4C561.1,47,561.5,47.2,562,47.7z"
      />
      <path
        class="st2"
        d="M438.6,76.6c-0.8,0.2-1.4,0.8-1.2,1.5c0.1,0.7,1,1.1,1.8,0.9c0.2-0.1,0.4-0.2,0.6-0.3c0.2-0.3,0.4-0.5,0.5-0.8
		c0-0.1,0-0.3,0-0.4C440.2,76.9,439.4,76.5,438.6,76.6z"
      />
      <path
        class="st2"
        d="M365.4,91.5c-0.3,0.9,0,1.5,0.8,1.9c0.7,0.4,1.5,0.5,2.3-0.1C368,91.6,367.5,91.3,365.4,91.5z"
      />
      <path
        class="st2"
        d="M348.8,80.7c0.1-1.6-0.4-2.1-2.6-2.4C346,80.2,346.7,80.8,348.8,80.7z"
      />
      <path
        class="st2"
        d="M307.9,136.7c0.8,0.1,1.6,0.3,2.4,0.4c0-0.1,0-0.2,0-0.4c-0.1-0.5-0.7-0.7-1.2-0.6c-0.3,0.1-0.6,0.2-0.9,0.3
		l0,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0.1C307.9,136.5,307.9,136.6,307.9,136.7C307.8,136.7,307.8,136.7,307.9,136.7L307.9,136.7z"
      />
      <path
        class="st2"
        d="M343.3,100.2c0.1-0.1,0.2-0.2,0.3-0.2c0.9-0.7,1.1-1.1,0.8-1.6c-0.1-0.1-0.2-0.2-0.3-0.3
		c-0.3-0.3-0.7-0.4-1.2-0.3c-0.7,0.1-1.1,0.5-1.2,1.1C341.5,99.7,342.3,100,343.3,100.2z"
      />
      <path
        class="st2"
        d="M562.4,26.2c0.7-0.4,1.3-0.7,1.9-0.9c0.1-0.8-0.2-1.3-1.2-1.8c-0.1,1.1-2.1,0.7-2.2,2.1
		C561.4,25.8,561.9,26,562.4,26.2z"
      />
      <path
        class="st2"
        d="M445.2,68.9c0.5,0.1,1.1-0.1,1.7-0.3c0.1-0.2,0.2-0.3,0.3-0.5c0.1-0.6,0.1-1.2,0.2-1.9
		c-0.6,0.3-1.2,0.5-1.7,0.8c-0.6,0.2-1.1,0.5-1.7,0.7C444.4,68.2,444.7,68.8,445.2,68.9z"
      />
      <path
        class="st2"
        d="M430.6,82.1c-0.2,0.2-0.4,0.3-0.7,0.6c0.4,0.5,0.7,0.8,1.1,1c0.5,0.3,1,0.3,1.5-0.1c0.6-0.4,0.7-1.3,0.2-1.8
		C432.1,81.3,431.5,81.4,430.6,82.1z"
      />
      <path
        class="st2"
        d="M316.2,117.6c-0.3-0.2-0.8-0.4-1.1-0.3c-0.3,0.1-0.7,0.6-0.6,0.8c0.1,0.4,0.2,0.8,0.4,1.2
		c0.2,0.5,0.5,0.9,1.3,1.2c0.1-0.2,0.2-0.5,0.2-0.7c0.2-0.6,0.2-1.4,0.1-1.7C316.5,117.9,316.4,117.7,316.2,117.6z"
      />
      <path
        class="st2"
        d="M325.3,103.3c0.7-0.2,1.2-0.9,1.1-1.5s-0.9-1-1.6-0.8s-1.3,0.8-1.2,1.4c0,0.3,0.3,0.6,0.6,0.7
		c0.2,0.1,0.4,0.2,0.6,0.2C325,103.3,325.2,103.3,325.3,103.3z"
      />
      <path
        class="st2"
        d="M371.3,96.4c0.9,0,1.8,0,2.7,0.1c-0.4-0.6-1.1-0.7-2.4-0.6C371.4,96.1,371.3,96.2,371.3,96.4z"
      />
      <path
        class="st2"
        d="M374,97.8c0.1,0,0.1,0,0.2-0.1C374.1,97.8,374.1,97.8,374,97.8c-0.5-0.1-1.1-0.1-1.6-0.1
		C372.9,98,373.4,98,374,97.8z"
      />
      <path
        class="st2"
        d="M568.1,14.1c0.6-0.1,1.2-0.1,1.8-0.2c1.1-0.1,2.3-0.2,3.5-0.3c-1.5-1.2-3-1.3-4.3-0.5
		C568.8,13.4,568.5,13.7,568.1,14.1z"
      />
      <path
        class="st2"
        d="M417.4,70.9c-0.2-0.5-0.9-0.8-1.6-0.6c-0.7,0.2-1.1,0.7-1,1.3c0,0.1,0.1,0.1,0.1,0.2c0.8,0,1.5,0,2.3,0
		c0.1,0,0.1,0,0.2,0c0.2-0.2,0.2-0.5,0.1-0.8C417.5,70.9,417.4,70.9,417.4,70.9z"
      />
      <path
        class="st2"
        d="M390.2,83.9c0.1,0.6,0.9,1,1.6,0.8c0.8-0.1,1.3-0.7,1.2-1.4c-0.1-0.6-0.8-1-1.6-0.8
		C390.7,82.6,390.1,83.3,390.2,83.9z"
      />
      <path
        class="st2"
        d="M550.4,45c0.5-0.3,1-0.6,1.5-0.9c0.4,0.5,1,0.4,1.6,0c-0.5-0.9-1.4-1-2.5-1c-0.8,0-1.2,0.2-1.5,0.7
		c0,0.1-0.1,0.2-0.1,0.3s0,0.2,0.1,0.3C549.6,44.7,549.9,44.9,550.4,45z"
      />
      <path
        class="st2"
        d="M438.2,54.1c-0.3-0.4-0.6-0.6-0.9-0.7c-0.4-0.2-0.7-0.1-1.1,0c-0.2,0.1-0.3,0.2-0.4,0.3s-0.2,0.2-0.3,0.4
		c-0.3,0.5,0.1,1.1,1.1,1.6c0.2-0.1,0.4-0.2,0.6-0.3C437.8,55.1,438.1,54.7,438.2,54.1z"
      />
      <path
        class="st2"
        d="M509.3,39.9c0,0.1,0.1,0.3,0.3,0.4c0.3,0.3,0.8,0.4,1.3,0.4c0.2,0,0.5-0.1,0.7-0.3c0.4-0.3,0.6-0.7,0.6-1.1
		c-0.1-0.6-0.9-1-1.6-0.8C509.7,38.7,509.1,39.4,509.3,39.9z"
      />
      <path
        class="st2"
        d="M513.4,43.8c0.1,0,0.2,0,0.3,0.1c0.2,0,0.4,0.1,0.7,0.1c0.8-1.1,0.9-1.5,0.3-1.9l0,0c-0.4-0.3-0.8-0.4-1.3-0.2
		h-0.1c-0.5,0.2-0.8,0.5-0.8,1C512.4,43.3,512.7,43.6,513.4,43.8z"
      />
      <path
        class="st2"
        d="M335.2,112.6c0.7,0.5,1.3,0.1,1.8-0.4c0.1,0.4,0.1,0.7,0.3,1.1c0.1,0.3,0.2,0.7,0.4,1c0.2,0.5,0.6,1,1.3,1.3
		c0.4,0.1,0.7,0.4,1,0.7c0.2,0.2,0.5,0.5,0.7,0.7c-0.4,0.4,0,0.6,0.1,0.9c0.1,0.2,0.1,0.3,0.1,0.5s0,0.4-0.3,0.6
		c0.2,0,0.4,0.1,0.5,0.1c2,0.3,4.1,0.6,6.1,0.9c1.6,0.2,3.3,0.2,4.9-0.1c0.5-0.1,1-0.2,1.5-0.3c0.5-0.1,1.1-0.2,1.6-0.3
		c1-0.2,2.1-0.4,3.1-0.6c0.1,0,0.3-0.1,0.4-0.1c0.6-0.1,1.1-0.2,1.7-0.3c0.8-0.2,1.6-0.3,2.3-0.5c0.1,0,0.1,0,0.2,0
		c2.1-0.4,4.3-0.9,6.4-1.3c0.5-0.1,0.9-0.2,1.4-0.3c0.9-0.2,1.9-0.4,2.8-0.6c0.1,0,0.2,0,0.2,0c0.1,0,0.3-0.1,0.4-0.1
		c-0.1-0.1-0.2-0.3-0.3-0.4c-0.3-0.4-0.6-0.8-1.1-1.1c-0.8,0.1-1.5,0-2.1-0.3c-0.5-0.2-0.9-0.5-1.3-0.9c-0.5,0.4-0.9,0.8-1.3,1.2
		c0-0.9,0.3-1.5,1.1-2c0,0,0.1,0,0.1-0.1l0,0c0.1,0.1,0.1,0.3,0.2,0.4c0.2-0.2,0.4-0.4,0.4-0.6c0-0.1-0.1-0.2-0.3-0.3l0,0
		c-0.1-0.1-0.3-0.2-0.3-0.3l0,0c-0.2-0.8-0.7-1.4-1.4-1.7c-0.4-0.1-0.8-0.2-1.3-0.2c0-0.1,0-0.1,0-0.2c0.1-0.3,0.1-0.5,0.2-0.7
		c0.1-0.3,0.2-0.7,0.3-1c0.1-0.1,0.2-0.3,0.4-0.4c0.1-0.1,0.3-0.2,0.5-0.3c0.2-0.1,0.5-0.2,0.8-0.3c0.1,0,0.3-0.1,0.4-0.1l0,0
		c0.2-0.2,0.5-0.7,0.6-0.7c1.1,0.2,1.4-0.7,2.2-1.1c-0.3-0.2-0.6-0.4-0.9-0.5c-0.9,0-1.8,0-2.7,0l0,0l0,0c0.1,0.2,0.2,0.4,0.3,0.5
		c-0.3,0.5-0.7,0.9-1.4,0.9h-0.1c-0.4,0-1,0.4-1.4,0.7c-0.5,0.4-1.1,0.6-1.4,0.2c-0.8-0.9-2.1-1.2-3.3-1.4l0,0
		c-0.4-0.1-0.9-0.1-1.3-0.2c-0.5-0.1-0.7-0.3-0.8-0.6c-5.5,0.1-10.9,0.3-16.4,0.5c-0.6,0.7-1.2,1.4-1.6,2.1
		c-0.2,0.3-0.2,0.6-0.2,0.9c10.3-0.8,18.8-1.2,23.3-1.1c0.1,0,0.1,0,0.2,0c0.7,0,1.3,0,1.7,0.1c-8.4,0.4-16.8,0.8-25.2,1.4
		c0.1,0.6,0.4,1.1,0.9,1.7c-1.5,0-2.7,0.3-3.5,1.1c-0.1,0.1-0.1,0.1-0.2,0.2c-0.3,0.3-0.5,0.5-0.7,0.9c-0.3-0.4-0.5-0.8-0.9-1.1
		c-0.6-0.5-1.4-0.2-1.7,0.5c-0.1,0.2-0.1,0.4-0.1,0.6l0,0C334.7,112,334.9,112.3,335.2,112.6z M365.9,115.3L365.9,115.3
		c0.2-0.2,0.4-0.3,0.6-0.4c0.4-0.2,0.7-0.4,1.2-0.7c-0.3,0.6-0.6,1-0.8,1.4c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1-0.1-0.2-0.2-0.3-0.2
		C366.3,115.5,366.1,115.4,365.9,115.3z M367.3,106L367.3,106L367.3,106L367.3,106z M341,117.1h-0.1l0,0
		C340.9,117,341,117.1,341,117.1z"
      />
      <path
        class="st2"
        d="M416.2,44.4c0.7-0.2,1.1-0.8,0.9-1.4c-0.2-0.5-0.9-0.9-1.5-0.7c-0.7,0.2-1.1,0.8-1,1.4
		C414.7,44.3,415.5,44.7,416.2,44.4z"
      />
      <path
        class="st2"
        d="M568.9,12.5c0.7-0.2,1.2-0.8,1-1.3c-0.1-0.5-0.9-0.9-1.5-0.8c-0.7,0.1-1.3,0.9-1.1,1.4
		C567.5,12.4,568.2,12.7,568.9,12.5z"
      />
      <path
        class="st2"
        d="M322.2,108.1c0.6-0.1,1.2-0.8,1-1.3c-0.1-0.5-0.7-0.8-1.4-0.7c-0.7,0.1-1.2,0.7-1.1,1.2
		C320.9,107.8,321.6,108.2,322.2,108.1z"
      />
      <path
        class="st2"
        d="M416.7,55.2c-0.1,0.2-0.1,0.4,0,0.5c0.1,0.2,0.3,0.4,0.5,0.6c0.3,0.1,0.7,0.2,1,0.1c0.7-0.2,1.2-0.8,1-1.3
		c-0.1-0.3-0.4-0.6-0.8-0.7c-0.2-0.1-0.5-0.1-0.7-0.1c-0.1,0-0.2,0-0.3,0.1C417.1,54.6,416.8,54.9,416.7,55.2z"
      />
      <path
        class="st2"
        d="M332.7,43.5c0.7-0.1,1.2-0.7,1.1-1.3s-0.7-0.9-1.4-0.8c-0.7,0.1-1.2,0.7-1.1,1.3
		C331.3,43.2,332,43.6,332.7,43.5z"
      />
      <path
        class="st2"
        d="M445.7,57c-0.7,0.2-1.3,0.5-1.3,1.2c0.5,0.5,1,0.9,1.5,1.5c0.7,0,1.1-0.3,1-0.8
		C446.7,58.2,446.5,57.4,445.7,57z"
      />
      <path
        class="st2"
        d="M451.9,66.6L451.9,66.6c-0.4,0.5-0.8,1-1.1,1.6c0.5,0,1-0.1,1.5-0.1C452.4,67.5,452.4,66.9,451.9,66.6z"
      />
      <path
        class="st2"
        d="M406.7,30.6c0.7-0.1,1.1-0.7,1-1.3c-0.1-0.6-0.9-0.9-1.5-0.7c-0.6,0.2-1,0.7-0.9,1.2
		C405.4,30.3,406.1,30.7,406.7,30.6z"
      />
      <path
        class="st2"
        d="M551.2,66c0.5-0.1,1-0.7,0.9-1.1c0-0.1,0-0.1-0.1-0.2c-0.2-0.5-1-1-1.4-0.9c-0.5,0.1-0.9,0.6-0.8,1.1
		c0,0.2,0.1,0.4,0.3,0.6C550.3,65.8,550.7,66.1,551.2,66z"
      />
      <path
        class="st2"
        d="M384,54.7c0.7-0.1,1.2-0.7,1.1-1.3c-0.1-0.5-0.7-0.8-1.3-0.7c-0.7,0.1-1.2,0.7-1.1,1.3
		C382.7,54.5,383.4,54.8,384,54.7z"
      />
      <path
        class="st2"
        d="M514.8,40.7c1.2-0.2,1.5-1.1,0.6-2c-0.5,0.2-1.1,0.4-1.6,0.7c-0.2,0.2-0.4,0.8-0.2,0.9
		C513.8,40.6,514.4,40.8,514.8,40.7z"
      />
      <path
        class="st2"
        d="M452.3,68.1c0.2,0.2,0.4,0.5,0.7,0.6c0.5,0.1,0.9,0.2,1.1,0.6s0.7,0.5,1.2,0.2c0.4-0.2,0.4-0.9-0.1-1.2
		c-0.5-0.3-1.1-0.6-1.7-0.9C453.1,67.6,452.7,67.9,452.3,68.1z"
      />
      <path
        class="st2"
        d="M390.7,110.3c0.3-0.3,0.7-0.7,0.9-1.1c0.1-0.3,0-0.7-0.2-0.9c0,0,0,0-0.1,0c-0.2-0.1-0.8-0.1-0.9,0l-0.1,0.1
		c-0.4,0.3-0.9,0.7-0.9,1.2C389.2,110.1,389.9,110.2,390.7,110.3z"
      />
      <path
        class="st2"
        d="M330.3,59.8c-0.2,1.2-0.3,2.4-0.4,3.5C331.8,61.9,331.8,60.9,330.3,59.8z"
      />
      <path
        class="st2"
        d="M544.5,65.6c0.4,0.6,0.7,1.2,1.5,1.3c0.3,0.1,0.7-0.2,1.1-0.3C546.3,64.9,546.2,64.9,544.5,65.6z"
      />
      <path
        class="st2"
        d="M443,83.1L443,83.1c-0.1,0.2-0.1,0.4-0.1,0.6c0.7,0,1.3,0.1,2,0.1c0.2-0.2,0.4-0.5,0.6-0.9
		c-0.2-0.1-0.4-0.1-0.6-0.2c-0.3-0.1-0.5-0.1-0.7-0.1s-0.3,0-0.4,0C443.3,82.6,443.2,82.8,443,83.1z"
      />
      <path
        class="st2"
        d="M309,117.4c0,0.1-0.1,0.3-0.1,0.4c0.2,0.6,0.4,1.2,0.1,1.9c-0.2,0.6,0.5,0.7,1,0.7c0.1-0.5,0.2-0.8,0.3-1.2
		c0-0.2,0-0.3,0-0.5c0-0.6-0.3-1-0.8-1.3c-0.2-0.1-0.3-0.2-0.5-0.3C309,117.3,309,117.4,309,117.4z"
      />
      <path
        class="st2"
        d="M354.5,85.9c-0.3-0.7-0.6-0.8-2-1.1c0,0.4,0,0.8,0.1,1.1C353.3,85.8,353.9,85.8,354.5,85.9z"
      />
      <path
        class="st2"
        d="M552.8,3.5c0.7-0.1,1.3-0.8,1.2-1.2c-0.2-0.5-0.6-0.7-1.2-0.7c-0.6,0-1,0.5-1,0.9
		C551.8,3.2,552.3,3.6,552.8,3.5z"
      />
      <path
        class="st2"
        d="M442.2,36c0.7-0.8,0.6-1.4,0-2c-0.9,0.1-1.5,0.5-1.5,1.2C440.7,36,441.5,35.9,442.2,36z"
      />
      <path
        class="st2"
        d="M435.1,34.1c0.1,0.5,0.7,0.9,1.2,0.8c0.5-0.1,0.8-0.6,0.7-1.3c-0.1-0.6-0.7-1-1.2-0.8
		C435.3,32.9,435,33.6,435.1,34.1z"
      />
      <path
        class="st2"
        d="M387.9,106.7c1.8-1.4,1.8-1.4,0.7-2.4C387,105.7,387,105.7,387.9,106.7z"
      />
      <path
        class="st2"
        d="M486.5,37.9c-0.7-0.4-1.2,0-1.8,0.7c0.5,0.4,1,0.8,1.5,1.3C487.2,38.7,487.2,38.3,486.5,37.9z"
      />
      <path
        class="st2"
        d="M517.6,40.1c-0.8,0.2-1.3,0.6-1.5,1.5c1.2-0.2,2.3-0.2,3.3-0.7C519,40.2,518.4,39.9,517.6,40.1z"
      />
      <path
        class="st2"
        d="M396.7,96.6c0,0.2,0.2,0.3,0.3,0.5c0.2,0.2,0.5,0.3,0.9,0.2c0.3,0,0.7-0.3,0.9-0.6h-0.1c-0.2,0-0.4,0-0.6,0
		H398c-0.3,0-0.6,0-0.8,0C397,96.6,396.9,96.6,396.7,96.6z"
      />
      <path
        class="st2"
        d="M595.4,44.6c-0.6,0.1-1.1,0.6-1,1.1c0.1,0.4,0.7,0.7,1.2,0.6c0.5-0.1,0.9-0.6,0.9-1.1
		C596.5,44.9,595.9,44.5,595.4,44.6z"
      />
      <path
        class="st2"
        d="M565.3,16.8c0.7-0.3,1-0.8,0.9-1.5c-1.1,0-2,0.2-2.6,1.1C564.1,16.9,564.7,17,565.3,16.8z"
      />
      <path
        class="st2"
        d="M400.1,88.9c-0.1,0-0.3,0-0.7,0.1c0.1,0.4,0.3,0.8,0.4,1.1c0.1-0.1,0.2-0.1,0.3-0.2c0.2-0.1,0.3-0.2,0.5-0.3
		c0.5-0.4,0.5-0.7,0.1-1C400.5,88.8,400.3,88.9,400.1,88.9z"
      />
      <path
        class="st2"
        d="M570.3,21c-0.1-0.5-0.8-0.8-1.4-0.6c-0.5,0.2-0.9,0.7-0.7,1.2c0.1,0.4,0.7,0.7,1.3,0.6
		C570,22,570.4,21.5,570.3,21z"
      />
      <path
        class="st2"
        d="M345.6,61.4c-0.1-0.9-0.7-1.4-1.9-1.6C343.3,61.5,343.8,62,345.6,61.4z"
      />
      <path
        class="st2"
        d="M493.8,43c0.5-0.1,1.1-0.7,0.8-1.1c-0.2-0.3-0.7-0.5-1.1-0.6c-0.5-0.1-1,0.5-0.9,1
		C492.6,42.7,493.2,43.1,493.8,43z"
      />
      <path
        class="st2"
        d="M485.3,46.1c0.2-0.3,0.2-0.7,0.1-1l-0.1-0.1c-0.2,0-0.6,0-0.8,0c-0.5,0.2-0.9,0.5-1.4,0.9
		c0.4,0.3,0.7,0.5,1,0.6C484.6,46.7,485,46.6,485.3,46.1z"
      />
      <path
        class="st2"
        d="M507.5,35.8c0.1,0.5,0.6,0.8,1.1,0.6c0.4-0.2,0.7-0.6,1.3-1c-0.6-0.3-1-0.6-1.5-0.7
		C507.9,34.7,507.4,35.3,507.5,35.8z"
      />
      <path
        class="st2"
        d="M493,54.7c0.2-0.8,0.2-1.5-1-2.2c0.1,1.1-0.8,2.1,0.3,3.1C492.6,55.2,492.9,54.9,493,54.7z"
      />
      <path
        class="st2"
        d="M391.5,77.5c0.2,0.3,0.7,0.5,1.1,0.6c-0.2-0.5-0.4-1-0.5-1.5C391.6,76.7,391.3,77.2,391.5,77.5z"
      />
      <path
        class="st2"
        d="M567.7,50c-0.1,0-0.1-0.1-0.2-0.1c-0.4-0.3-0.8-0.4-1.3,0.2l0,0c0.4,0.8,0.8,1.7,1.2,2.5
		c0.1-0.1,0.3-0.1,0.4-0.2c-0.4-0.5-0.6-0.9,0-1.5C568.2,50.6,568,50.3,567.7,50z"
      />
      <path
        class="st2"
        d="M356.7,90.9c-0.3,0.3-0.4,0.6-0.2,0.8c0.2,0.3,0.7,0.5,1.1,0.5c0.3,0,0.5-0.2,0.7-0.4c0.1-0.2,0.2-0.4,0.2-0.6
		c-0.1-0.4-0.8-0.7-1.3-0.6C357,90.6,356.8,90.8,356.7,90.9z"
      />
      <path
        class="st2"
        d="M585,53.7c0.2-0.3,0.4-0.7,0.7-1c0.2-0.2,0.5-0.4,0.8-0.6c0.1,0,0.1-0.1,0.2-0.1c-0.2-0.3-0.4-0.6-0.7-1
		c-0.2,0.3-0.4,0.5-0.6,0.8c-0.6,0.6-1.2,1.1-0.8,1.9C584.6,53.6,584.8,53.7,585,53.7z"
      />
      <path
        class="st2"
        d="M476.2,34.4c-0.2-0.9-0.8-1.4-2.1-1.1C474.6,34.8,474.9,34.9,476.2,34.4z"
      />
      <path
        class="st2"
        d="M482.8,63.7c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0.1,0.3,0,0.6-0.1c0.6-0.2,0.7-0.6,0.6-1c-0.1-0.5-0.6-0.5-1.8,0
		C482.5,63.2,482.6,63.5,482.8,63.7z"
      />
      <path
        class="st2"
        d="M413.4,36.4c-1.3,0.9-1.3,0.9-0.8,2C414.2,37.3,414.2,37.3,413.4,36.4z"
      />
      <path
        class="st2"
        d="M454.9,66.3c-0.4,0.2-0.7,0.5-0.3,0.9c0.3,0.3,0.7,0.5,1.2,0.2s0.7-0.7,0.6-1.4
		C455.8,66.1,455.3,66.2,454.9,66.3z"
      />
      <path
        class="st2"
        d="M421.1,43.6c-0.3-0.7-0.8-1-1.5-1c-0.2,0-0.5,0.1-0.6,0.3c-0.1,0.1-0.1,0.4,0,0.6
		C419.3,44,419.9,44,421.1,43.6z"
      />
      <path
        class="st2"
        d="M592.7,66.6c0.1-0.6-0.2-0.9-1.1-1c-0.2,0.6-0.4,1.2-0.7,2.2C592,67.5,592.6,67.2,592.7,66.6z"
      />
      <path
        class="st2"
        d="M552.4,14.9c0.3-0.5,0.7-0.8,0.7-1.2s-0.3-0.6-0.9-0.5c-0.6,0.1-1.1,0.7-0.9,1
		C551.5,14.5,551.9,14.6,552.4,14.9z"
      />
      <path
        class="st2"
        d="M570.7,51.1c0.6-0.6,0.9,0.3,1.4,0.1c0.7-0.6,0.3-1-0.2-1.5c-0.4,0.1-0.6,0.1-0.9,0.2c-0.1,0-0.1,0-0.2,0
		c-0.4,0.1-0.5,0.3-0.5,0.5c0,0.1,0,0.2,0,0.3C570.3,50.9,570.6,51,570.7,51.1z"
      />
      <path
        class="st2"
        d="M553.3,39.5c0.1-0.3,0.1-0.7-0.1-0.9c-0.4-0.5-0.9-0.4-1.9,0.4c0.4,0.3,0.7,0.6,1,0.7
		C552.6,39.7,553.2,39.6,553.3,39.5z"
      />
      <path
        class="st2"
        d="M435.6,62.5c0.3-0.1,0.7-0.5,0.8-0.7c0.1-0.4-0.4-0.7-1.1-0.6c-0.1,0.2-0.5,0.4-0.5,0.7
		C434.5,62.2,435.1,62.7,435.6,62.5z"
      />
      <path
        class="st2"
        d="M307,106.7c-0.2,0-0.3,0-0.5,0c0.1,0.1,0.2,0.1,0.3,0.2C306.9,106.9,307,106.8,307,106.7z"
      />
      <path
        class="st2"
        d="M434.8,21.6c0.5-1.1,0.5-1.1-0.8-1.8C433.7,21.2,433.7,21.2,434.8,21.6z"
      />
      <path
        class="st2"
        d="M308.7,55c0.6-0.1,0.8-0.5,0.7-0.9c-0.2-0.4-0.6-0.7-1.1-0.5c-0.3,0.2-0.7,0.6-0.7,1S308.1,55.2,308.7,55z"
      />
      <path
        class="st2"
        d="M492.8,47.8c0.6,0.3,1,0,1.5-0.6c-0.6-0.6-0.6-0.6-1.5-0.7C492.4,46.9,492.2,47.4,492.8,47.8z"
      />
      <path
        class="st2"
        d="M557.6,48.4c0.1,0.7,0.2,1.1,0.1,1.4c0,0.1,0,0.1,0,0.2c0,0.5,0.4,0.6,0.9,0.7l0,0c0.2,0,0.5,0.1,0.7,0.1
		c0-0.5-0.3-0.9-0.7-1.3C558.3,49.2,557.9,48.8,557.6,48.4z"
      />
      <path
        class="st2"
        d="M582,58.4c-0.1,0.2,0.1,0.6,0.3,0.7c0.9,0.3,1.1-0.3,1.4-0.9C582.6,57.8,582.1,57.8,582,58.4z"
      />
      <path
        class="st2"
        d="M444.6,30.2c0.2-0.3,0.4-0.5,0.7-0.9c-0.4-0.3-0.7-0.6-1-0.6c-0.4-0.1-0.8,0.6-0.6,0.9S444.3,30,444.6,30.2z"
      />
      <path
        class="st2"
        d="M581.3,72.4c-0.2,0.3-0.5,0.6-0.6,0.9c0,0.1,0.2,0.2,0.4,0.3c0-0.1,0-0.1,0.1-0.2c0.1,0,0.2,0.1,0.3,0.1
		c0.5-0.1,1.1,0,1.4-0.7C582.5,72.5,581.9,72.4,581.3,72.4z"
      />
      <path
        class="st2"
        d="M362.4,88c-0.1-0.1-0.2-0.3-0.4-0.4c-0.5,0-1,0-1.5,0C360.5,88.5,361,88.5,362.4,88z"
      />
      <path
        class="st2"
        d="M425.4,39.5c0-0.5,0.2-0.9,0-1.1c-0.4-0.3-1-0.5-1.6,0C423.9,39.1,424.5,39.3,425.4,39.5z"
      />
      <path
        class="st2"
        d="M485.7,42.4c0.2-0.4,0.5-0.7,0.4-1c-0.1-0.1-0.2-0.2-0.4-0.3c-0.5-0.2-1.3,0.1-1.3,0.5c0,0.1,0,0.2,0,0.2
		C484.5,42.3,485.2,42.2,485.7,42.4z"
      />
      <path
        class="st2"
        d="M483.7,50.9c0.2-0.3,0.4-0.5,0-0.8c-0.1-0.1-0.2-0.1-0.4-0.1c-0.4,0-0.8,0.4-1.2,0.9c0.4,0.2,0.6,0.4,1,0.7
		C483.3,51.3,483.6,51.1,483.7,50.9z"
      />
      <path
        class="st2"
        d="M434.3,50.3C434.3,50.3,434.2,50.3,434.3,50.3c-0.3-0.2-0.5-0.4-0.8-0.4c-0.4,0-0.8,0.2-1.3,0.3
		c0.3,0.2,0.5,0.5,0.7,0.6c0.1,0,0.1,0.1,0.2,0.1c0.2,0.1,0.7,0,1-0.2C434.2,50.8,434.4,50.4,434.3,50.3z"
      />
      <path
        class="st2"
        d="M565.7,31c0,0.2,0.5,0.6,0.8,0.6s0.6-0.4,1.1-0.8c-0.5-0.2-0.9-0.6-1.2-0.5C566.1,30.4,565.7,30.8,565.7,31z"
      />
      <path
        class="st2"
        d="M435.6,37.3c0.2-0.1,0.3-0.3,0.5-0.4c-0.2-0.4-0.3-0.9-0.6-1.3c-0.1-0.1-0.7-0.1-0.9,0
		c-0.2,0.1-0.2,0.6-0.1,0.8C434.8,36.8,435.2,37,435.6,37.3z"
      />
      <path
        class="st2"
        d="M587.7,61.8c0.4,0.3,0.3,1.1,1.2,0.7c0.7-0.3,0.2-0.8,0-1.2c0-0.1,0-0.2-0.1-0.2
		C588.4,61.2,587.8,61.2,587.7,61.8z"
      />
      <path
        class="st2"
        d="M561.3,49.6c-0.3-0.8-1.4-0.5-1.9-1l0,0l0,0C559.1,49.5,559.5,49.8,561.3,49.6z"
      />
      <path
        class="st2"
        d="M319.4,98.4c0.3-0.4,0.5-0.6,0.6-0.8c-0.4,0-0.8,0-1.2,0C318.8,98,319,98.2,319.4,98.4z"
      />
      <path
        class="st2"
        d="M427.8,33.2c0.3-1.1,0.3-1.1-1.3-1.4C426.6,32.5,426.8,33,427.8,33.2z"
      />
      <path
        class="st2"
        d="M572.9,52.2L572.9,52.2c0.2,0.2,0.7,0.3,0.9,0.2c0.5-0.4,0.1-0.7-0.2-1c-0.1-0.1-0.1-0.1-0.2-0.2
		c-0.1,0-0.2-0.1-0.3-0.2C572.1,51.5,572.5,51.9,572.9,52.2z"
      />
      <path
        class="st2"
        d="M538.1,11.7c0-0.7,0-1.4-0.7-1.8c-0.1,0.8-0.1,1.6-0.2,2.4C537.7,12.1,538.1,11.9,538.1,11.7z"
      />
      <path
        class="st2"
        d="M307.1,85.5c-0.1,0.3-0.2,0.5-0.3,0.6c0.4,0,0.7,0,1.1,0C307.8,85.8,307.6,85.6,307.1,85.5z"
      />
      <path
        class="st2"
        d="M330.7,87.7c0.1-0.2,0.3-0.4,0.4-0.5c-0.4,0-0.8,0-1.2,0l0,0C329.9,87.4,330.3,87.5,330.7,87.7z"
      />
      <path
        class="st2"
        d="M379.5,104.6c0.3,0.3,0.7,0.6,0.6,0.9c-0.1,0.5-0.2,0.8,0.6,0.9C380.9,105.4,380.5,105,379.5,104.6z"
      />
      <path
        class="st2"
        d="M553.4,28.6c0.3-0.1,0.4-0.4,0.7-0.9c-0.5-0.1-0.9-0.3-1.2-0.2c-0.2,0.1-0.5,0.5-0.4,0.7
		C552.5,28.7,553,28.8,553.4,28.6z"
      />
      <path
        class="st2"
        d="M408,84.2c-0.2-0.1-0.5-0.1-0.8,0c-0.1,0-0.2,0.4-0.1,0.5c0.2,0.6,0.7,0.7,1.4,0.2
		C408.4,84.6,408.3,84.3,408,84.2z"
      />
      <path
        class="st2"
        d="M430.9,53.2c0-0.1,0-0.3-0.1-0.4c-0.7-0.3-1.1,0-1.5,0.8C430.1,53.8,430.6,53.9,430.9,53.2z"
      />
      <path
        class="st2"
        d="M311.1,133.7L311.1,133.7c0,0.1,0,0.2,0,0.3c0.1-0.1,0.1-0.1,0.2-0.2C311.2,133.7,311.2,133.7,311.1,133.7z"
      />
      <path
        class="st2"
        d="M524.5,40.8c0.2,0.1,0.3,0.2,0.5,0.3c0.2-0.2,0.4-0.4,0.8-0.8c0,0-0.1,0-0.1-0.1c-0.4-0.2-0.7-0.4-1-0.4
		c-0.1,0-0.2,0.1-0.3,0.3c-0.1,0.1-0.2,0.3-0.1,0.3c0,0.1,0.1,0.1,0.2,0.2C524.4,40.7,524.4,40.7,524.5,40.8z"
      />
      <path
        class="st2"
        d="M460.6,32.6c0.4-0.5,0.8-0.9,0.2-1.4C459.8,32,459.8,32,460.6,32.6z"
      />
      <path
        class="st2"
        d="M471.8,50c0.2,0.1,0.4,0.2,0.6,0.3c-0.1-0.5,0.2-0.9-0.1-1.3l0,0c-0.1-0.1-0.1-0.1-0.2-0.2c0,0,0,0-0.1,0.1
		s-0.2,0.2-0.3,0.3c-0.4,0.4-0.5,0.6-0.2,0.8C471.6,49.9,471.7,50,471.8,50z"
      />
      <path
        class="st2"
        d="M441.1,71.8c0-0.1,0-0.2,0-0.2c-0.6-0.2-1.1-0.4-1.9-0.6c0.2,0.6,0.4,0.9,0.8,1
		C440.4,72,440.8,71.9,441.1,71.8z"
      />
      <path
        class="st2"
        d="M423.8,40.9c0.1,0,0.3-0.3,0.3-0.4c-0.1-0.7-0.6-0.7-1.5-0.5C422.7,40.7,423,41.1,423.8,40.9z"
      />
      <path
        class="st2"
        d="M564.6,49.6c0.1,0.1,0.1,0.2,0.2,0.4c0.1,0,0.2-0.1,0.3-0.1l0,0c-0.1-1.1-0.1-1.1-1.2-1.5
		C564.2,48.8,564.4,49.2,564.6,49.6z"
      />
      <path
        class="st2"
        d="M509.6,50.2C509.6,50.1,509.6,50.1,509.6,50.2c-0.6-0.5-0.7-1.1-1.7-1c0.2,0.5,0.3,0.8,0.5,0.9
		C508.6,50.2,508.9,50.2,509.6,50.2z"
      />
      <path
        class="st2"
        d="M551.7,40.8C551.7,40.8,551.6,40.8,551.7,40.8c-0.1,0-0.2,0-0.2,0.1c-0.2,0.4-0.2,0.6,0.1,0.8
		c0.2,0.1,0.4,0.3,0.8,0.5c0-0.3,0-0.5,0-0.7C552.2,41.3,552,41,551.7,40.8z"
      />
      <path
        class="st2"
        d="M481.3,46.7L481.3,46.7C481.2,46.7,481.2,46.7,481.3,46.7C481.2,46.8,481.3,46.8,481.3,46.7L481.3,46.7z"
      />
      <path
        class="st2"
        d="M481.9,45c-0.4,0.3-0.8,0.5-1.2,0.8c0.2,0.3,0.4,0.6,0.5,0.9c0.3-0.4,0.6-0.8,0.8-1.2
		C482.2,45.5,482,45.3,481.9,45z"
      />
      <path
        class="st2"
        d="M508.5,15.7c-0.4-0.2-0.5-0.3-0.8-0.3c-0.2,0-0.4,0-0.9,0.1c0.3,0.5,0.5,0.8,0.7,1.3
		C507.9,16.3,508.1,16.1,508.5,15.7z"
      />
      <path
        class="st2"
        d="M400.5,70.6c0.2-0.2,0.3-0.4,0.4-0.6c0.2-0.2,0.4-0.5,0.5-0.7h-0.1c-0.1,0-0.2-0.1-0.3-0.1
		C400,69.7,400,69.7,400.5,70.6z"
      />
      <path
        class="st2"
        d="M429.5,43.6c0.2,0.3,0.5,0.4,0.8,0.7c0.2-0.2,0.6-0.4,0.5-0.5c-0.1-0.3-0.4-0.5-0.7-0.9
		C429.7,43.2,429.4,43.5,429.5,43.6z"
      />
      <path
        class="st2"
        d="M438.7,29.6c0.2,0,0.5-0.5,0.8-0.7c0,0,0.1,0,0.1-0.1c-0.4-0.1-0.8-0.3-1.3-0.4C438,29.1,438,29.5,438.7,29.6z
		"
      />
      <path
        class="st2"
        d="M429.7,74.5c0.2,0.2,0.5,0.4,0.8,0.4c0.1,0,0.3-0.3,0.7-0.7c-0.5-0.1-0.8-0.3-1.2-0.3
		C430,73.9,429.7,74.4,429.7,74.5z"
      />
      <path
        class="st2"
        d="M555.3,45.3c-0.3-0.4-0.6-0.8-1.2-1.4c-0.1,0.6-0.3,0.9-0.2,1.1C554.2,45.3,554.4,45.8,555.3,45.3z"
      />
      <path
        class="st2"
        d="M339.1,101.7c0.2-0.4,0.1-0.7-0.2-1.1c-0.2,0.2-0.3,0.4-0.3,0.5c-0.2,0.3,0,0.4,0.4,0.9
		C339,101.9,339,101.8,339.1,101.7z"
      />
      <path
        class="st2"
        d="M373,91.5c0-0.6-0.3-0.9-0.8-1c-0.2,0-0.3-0.1-0.5-0.1c0,0.3,0,0.5,0,0.6C371.9,91.5,372.4,91.6,373,91.5z"
      />
      <path
        class="st2"
        d="M428.6,27.1c0.4-0.9-0.2-1.1-1-1.3C427.5,26.5,427.6,27.1,428.6,27.1z"
      />
      <path
        class="st2"
        d="M442.6,79.5c-0.1,0.2-0.3,0.4-0.4,0.5c0.1,0,0.2,0.1,0.3,0.1c0.1-0.1,0.2-0.2,0.3-0.3
		C442.8,79.8,442.7,79.6,442.6,79.5z"
      />
      <path
        class="st2"
        d="M489.6,55.1c0.2,0.2,0.5,0.3,0.8,0.3c0.2,0,0.4-0.3,0.6-0.5c-0.3-0.2-0.6-0.3-1-0.6
		C489.7,54.7,489.5,55,489.6,55.1z"
      />
      <path
        class="st2"
        d="M579.8,65.8c0.4-1.2,0.4-1.2-0.9-1.7C579.2,64.7,579.4,65.1,579.8,65.8z"
      />
      <path
        class="st2"
        d="M592.1,52.1c-0.2-0.3-0.4-0.6-0.8-1.1C590.8,51.9,591.2,52.1,592.1,52.1z"
      />
      <path
        class="st2"
        d="M579.2,67.3c0.1,0.1,0.2,0.2,0.3,0.3c0.5-0.1,1.2-0.1,1.5-0.8c-0.4-0.1-0.7-0.2-0.9-0.2
		C579.8,66.8,579.5,67.1,579.2,67.3z"
      />
      <path
        class="st2"
        d="M490.8,53c-0.2-0.1-0.6-0.3-0.7-0.2c-0.2,0.2-0.4,0.4-0.5,0.7c0,0.1,0.3,0.2,0.6,0.4
		C490.5,53.5,490.6,53.2,490.8,53z"
      />
      <path
        class="st2"
        d="M331.8,109.7c0.1,0,0.2,0,0.2-0.1c0.2-0.1,0.3-0.3,0.3-0.5c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.1-0.1-0.2-0.2
		c-0.1,0-0.1,0-0.2,0c-0.2,0.2-0.3,0.3-0.6,0.6c-0.1,0.1-0.3,0.3-0.5,0.5C331.2,109.7,331.6,109.7,331.8,109.7z"
      />
      <path
        class="st2"
        d="M441.9,57.3c0,0,0-0.1,0.1-0.3c-1-0.3-1.1-0.3-1.3,0c-0.1,0.1-0.1,0.3-0.1,0.4C441,57.8,441.5,57.6,441.9,57.3
		z"
      />
      <path
        class="st2"
        d="M494.7,12.8c0.2-0.1,0.4-0.4,0.3-0.5c-0.1-0.2-0.4-0.3-0.7-0.4c-0.2,0.3-0.4,0.5-0.4,0.6
		C494,12.8,494.3,12.9,494.7,12.8z"
      />
      <path
        class="st2"
        d="M444.6,70.5c0,0.2-0.1,0.4-0.1,0.5c0.2,0,0.3,0,0.5,0c0.2-0.1,0.4-0.3,0.5-0.5
		C445.1,70.6,444.8,70.5,444.6,70.5z"
      />
      <path
        class="st2"
        d="M437.1,43.7c0.1,0,0.4-0.1,0.4-0.2c0.2-0.5-0.1-0.7-0.8-0.8C436.5,43.2,436.4,43.6,437.1,43.7z"
      />
      <path
        class="st2"
        d="M463.3,31.8c0.1-0.3,0.3-0.5,0.4-0.8c0-0.1-0.3-0.2-0.6-0.4c-0.1,0.4-0.3,0.7-0.3,0.9
		C462.7,31.7,463.1,31.7,463.3,31.8z"
      />
      <path
        class="st2"
        d="M476.4,38.2c-0.4-0.1-0.7-0.2-0.8-0.2c-0.2,0.2-0.4,0.5-0.5,0.7l0.4,0.2C475.8,38.7,476.1,38.5,476.4,38.2z"
      />
      <path
        class="st2"
        d="M393,79.1c-0.1-0.2-0.1-0.4-0.2-0.5c-0.5,0-0.7,0.2-0.9,0.7C392.3,79.4,392.7,79.4,393,79.1z"
      />
      <path
        class="st2"
        d="M441.3,60.7c0.2-0.1,0.4-0.3,0.7-0.5c-0.3-0.1-0.6-0.3-0.7-0.3c-0.2,0.1-0.4,0.3-0.5,0.5
		C440.8,60.4,441.2,60.7,441.3,60.7z"
      />
      <path
        class="st2"
        d="M440.8,48.6L440.8,48.6c-0.2-0.1-0.5-0.2-0.7-0.2s-0.4,0.2-0.7,0.4c0.2,0.1,0.4,0.3,0.6,0.3c0.1,0,0.2,0,0.3,0
		c0.1,0,0.3,0,0.4-0.1C440.8,49,440.9,48.6,440.8,48.6z"
      />
      <path
        class="st2"
        d="M319.1,89.3c-0.1-0.6-0.2-1-0.3-1.4C318.2,88.6,318.3,89,319.1,89.3z"
      />
      <path
        class="st2"
        d="M313.9,102.2c-0.1-0.7-0.2-1.1-0.2-1.5c-0.2,0-0.3,0-0.5,0.1C312.8,101.3,312.9,101.7,313.9,102.2z"
      />
      <path
        class="st2"
        d="M578.6,66.3c-0.4-0.4-0.8-0.6-1.6,0.1C577.7,66.6,578.1,67.1,578.6,66.3z"
      />
      <path
        class="st2"
        d="M498.8,55.4c0,0.1,0.4,0.3,0.5,0.3c0.2-0.1,0.4-0.4,0.6-0.6c-0.3-0.1-0.6-0.3-0.7-0.2
		C499,54.9,498.8,55.2,498.8,55.4z"
      />
      <path
        class="st2"
        d="M390.3,102.5c0.1,0,0.2,0,0.3,0h0.1c0.2-0.1,0.3-0.3,0.5-0.6c-0.4-0.1-0.7-0.2-0.8-0.1
		c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.1-0.1,0.2-0.2,0.3C390.1,102.4,390.2,102.5,390.3,102.5z"
      />
      <path
        class="st2"
        d="M393.2,99.7c0.3-0.3,0.5-0.6,0.7-0.9C393,99.1,393,99.1,393.2,99.7z"
      />
      <path
        class="st2"
        d="M470.3,43.1c0.8-0.6,0.8-0.6,0.5-0.9c-0.2-0.1-0.5-0.1-0.9-0.3C470.1,42.5,470.2,42.8,470.3,43.1z"
      />
      <path
        class="st2"
        d="M477.1,51.2c-0.7,0.5-1,1-0.6,1.6C476.9,52.3,477.3,51.9,477.1,51.2z"
      />
      <path
        class="st2"
        d="M573.7,8.7c-0.2-0.3-0.4-0.6-0.6-1c-0.2,0.1-0.3,0.2-0.5,0.2c0.2,0.3,0.5,0.6,0.7,0.9
		C573.5,8.8,573.6,8.7,573.7,8.7z"
      />
      <path
        class="st2"
        d="M465.3,41.6c0.2-0.2,0.4-0.3,0.7-0.6c-0.4-0.1-0.6-0.2-0.8-0.2c-0.2,0.1-0.4,0.3-0.4,0.5
		C464.9,41.4,465.1,41.5,465.3,41.6z"
      />
      <path
        class="st2"
        d="M549.4,56.7L549.4,56.7C549.5,56.8,549.5,56.8,549.4,56.7C549.5,56.8,549.4,56.7,549.4,56.7z"
      />
      <path
        class="st2"
        d="M550.1,57.8c-0.2-0.3-0.4-0.7-0.6-1c-0.1,0-0.2,0-0.4,0C548.6,57.6,549.2,57.7,550.1,57.8z"
      />
      <path
        class="st2"
        d="M558.9,43.8c0.3-0.3,0.4-0.5,0.6-0.7c-0.2-0.1-0.4-0.3-0.5-0.3c-0.2,0.1-0.4,0.3-0.6,0.5
		C558.4,43.4,558.7,43.6,558.9,43.8z"
      />
      <path
        class="st2"
        d="M393.4,106.5c0-0.5-0.2-0.8-0.5-0.9c-0.1-0.1-0.3-0.1-0.5-0.1c-0.1,0.1-0.2,0.2-0.3,0.3c0.1,0,0.1,0.1,0.2,0.1
		C392.7,106.1,393,106.3,393.4,106.5z"
      />
      <path
        class="st2"
        d="M578.6,71.1c-0.5,0.5-0.5,0.9,0,1.3C579.2,71.9,579,71.5,578.6,71.1z"
      />
      <path
        class="st2"
        d="M437.4,58.5c0.2-0.3,0.3-0.5,0.4-0.8c-0.2-0.1-0.5-0.2-0.7-0.2c-0.1,0-0.4,0.4-0.3,0.4
		C436.9,58.2,437.1,58.3,437.4,58.5z"
      />
      <path
        class="st2"
        d="M571.1,37.1c0.1-0.2,0.2-0.5,0.2-0.7c0-0.1-0.4-0.3-0.5-0.3c-0.2,0.1-0.4,0.3-0.5,0.5c0,0.1,0.2,0.3,0.3,0.4
		C570.8,37.1,571,37.1,571.1,37.1z"
      />
      <path
        class="st2"
        d="M480.5,48.2c0.2-0.5,0.5-0.9,0.7-1.4c-0.4,0.1-0.7,0.1-0.8,0.2c-0.1,0-0.1,0.1-0.1,0.1l0,0
		c-0.1,0.2,0,0.5,0.2,0.9C480.5,48.1,480.5,48.1,480.5,48.2z"
      />
      <path
        class="st2"
        d="M543.7,64.3c0.1-0.1,0.2-0.2,0.4-0.3c-0.1,0-0.2-0.1-0.3-0.1C543.8,64,543.8,64.2,543.7,64.3z"
      />
      <path
        class="st2"
        d="M542.7,64.1C542.7,64.2,542.7,64.2,542.7,64.1c0.2-0.1,0.5-0.3,0.8-0.4c0,0-0.1,0-0.1-0.1h0.1c0,0,0,0-0.1,0
		c-0.1-1.2-0.7-2.1-2.5-2c-0.2,0.3-0.5,0.6-0.7,0.9c-0.5,1,0.2,1.9,1.5,1.8C542,64.4,542.3,64.2,542.7,64.1L542.7,64.1
		C542.6,64.2,542.7,64.2,542.7,64.1z"
      />
      <path
        class="st2"
        d="M401.4,32.3c-0.3-0.1-0.6-0.2-0.8-0.2c-0.1,0.2-0.1,0.3-0.2,0.5c0.2,0.1,0.5,0.1,0.7,0.2
		C401.2,32.7,401.3,32.5,401.4,32.3z"
      />
      <path
        class="st2"
        d="M356,81.6c-0.3,0.3-0.6,0.5-0.8,0.8c0,0,0.1,0.2,0.3,0.4c0.3-0.4,0.6-0.7,0.8-1
		C356.2,81.8,356.1,81.7,356,81.6z"
      />
      <path
        class="st2"
        d="M333.5,105.5l-0.1-0.1c-0.1,0-0.1-0.1-0.1-0.1c-0.2,0.1-0.4,0.3-0.5,0.4s-0.2,0.1-0.3,0.2
		c0.2,0.1,0.3,0.2,0.5,0.3C333.1,106,333.3,105.7,333.5,105.5z"
      />
      <path
        class="st2"
        d="M553,48.3c0,0.8,0.8,0.6,1.2,0.8C554,48.6,553.7,48.2,553,48.3z"
      />
      <path
        class="st2"
        d="M410.7,64.3c0.3,0.4,0.4,0.7,0.7,1.2C411.6,64.7,411.6,64.3,410.7,64.3z"
      />
      <path
        class="st2"
        d="M547.3,63.2c0.3-0.2,0.5-0.4,0.8-0.6c0.3-0.2,0.5-0.4,0.8-0.6c-0.3,0-0.6,0-0.8,0.1
		C547.6,62.2,547.4,62.5,547.3,63.2z"
      />
      <path
        class="st2"
        d="M434.4,46.8c0.6-0.1,1.1-0.2,1.7-0.4C435.3,46,435.3,46,434.4,46.8z"
      />
      <path
        class="st2"
        d="M434.4,46.8L434.4,46.8c-0.1,0-0.1,0.1-0.1,0.1C434.3,46.9,434.4,46.9,434.4,46.8
		C434.4,46.9,434.4,46.8,434.4,46.8z"
      />
      <path
        class="st2"
        d="M381.9,101c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.1-0.3,0.1-0.4
		c-0.2,0.1-0.3,0.1-0.4,0.2c-0.2,0.1-0.3,0.2-0.3,0.4c0,0.1,0,0.2,0,0.2C381.8,100.7,381.8,100.8,381.9,101z"
      />
      <path
        class="st2"
        d="M437.3,56.6c0-0.1-0.2-0.3-0.4-0.5c-0.3,0.3-0.4,0.5-0.6,0.7c0.2,0.1,0.4,0.3,0.6,0.2
		C437,57,437.2,56.8,437.3,56.6z"
      />
      <path
        class="st2"
        d="M416.7,80.3c0.1,0.1,0.1,0.1,0.2,0.2c0.3-0.2,0.6-0.3,0.9-0.5c-0.1-0.1-0.1-0.2-0.2-0.3
		c-0.2,0.1-0.4,0.1-0.6,0.2C416.8,80,416.8,80.2,416.7,80.3z"
      />
      <path
        class="st2"
        d="M335,108.9c0.5-0.1,0.7-0.3,0.6-0.6c-0.3,0-0.5,0-0.8,0.1C334.7,108.6,334.8,108.7,335,108.9z"
      />
      <path
        class="st2"
        d="M568.4,48c0.2,0.7,0.2,0.9,0.6,1c0.1,0,0.2,0.1,0.4,0.1c-0.1-0.1-0.2-0.2-0.3-0.3
		C569,48.6,568.8,48.4,568.4,48z"
      />
      <path
        class="st2"
        d="M475,47.2c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0.2-0.3,0.4-0.4,0.6c0,0,0.1,0,0.1,0.1c0.1,0,0.2,0.1,0.3,0.1
		c0.2-0.1,0.4-0.3,0.7-0.6C475.3,47.3,475.2,47.2,475,47.2z"
      />
      <path
        class="st2"
        d="M482.4,61.7c0.1,0,0.1,0,0.2,0s0.3-0.3,0.3-0.4c0-0.1,0-0.1-0.1-0.2C482.7,61.4,482.5,61.6,482.4,61.7z"
      />
      <path
        class="st2"
        d="M483.7,60.7c0.2,0,0.4,0.1,0.4,0.1c0.2-0.2,0.3-0.4,0.5-0.6c-0.3-0.1-0.4-0.2-0.5-0.2
		C483.9,60.2,483.8,60.5,483.7,60.7z"
      />
      <path
        class="st2"
        d="M363.4,84.5c-0.4,0-0.8,0-1.3,0.1c-0.1,0-0.2,0-0.3,0c0,0.1,0,0.2,0,0.3c0.2,0,0.3,0,0.5,0c0.1,0,0.2,0,0.4,0
		c0.2,0,0.5-0.1,0.7-0.2C363.4,84.6,363.4,84.6,363.4,84.5z"
      />
      <path
        class="st2"
        d="M589.5,56.6c-0.1-0.1-0.2-0.2-0.3-0.3c-0.3,0.2-0.7,0.4-1,0.6c0.1,0.1,0.1,0.2,0.2,0.2
		C588.7,56.9,589.1,56.8,589.5,56.6z"
      />
      <path
        class="st2"
        d="M369.9,108.5c0.3,0.3,0.7,0.6,1,1c0.1-0.1,0.2-0.1,0.3-0.2c-0.3-0.3-0.6-0.6-0.9-1
		C370.1,108.3,370,108.4,369.9,108.5z"
      />
      <path
        class="st2"
        d="M539.7,60.4c-0.1,0.6,0.3,0.8,1,1.1C540.6,60.8,540.4,60.5,539.7,60.4z"
      />
      <path
        class="st2"
        d="M432.6,21.4c-0.1-0.2-0.2-0.5-0.3-0.7c-0.2,0-0.3,0.1-0.5,0.1c0.1,0.2,0.3,0.4,0.4,0.7
		C432.4,21.5,432.5,21.5,432.6,21.4z"
      />
      <path
        class="st2"
        d="M385.7,112.2c0-0.1-0.1-0.2-0.1-0.2c-0.3,0.1-0.7,0.2-1,0.3C385,112.4,385.5,112.7,385.7,112.2z"
      />
      <path
        class="st2"
        d="M559.4,35.6c-0.1-0.4-0.1-0.8-1.1-0.9c0.3,0.5,0.5,0.8,0.7,1.1C559.1,35.8,559.3,35.7,559.4,35.6z"
      />
      <path
        class="st2"
        d="M381.4,110.1c0.1,0,0.2,0.1,0.3,0.1c0.3,0.2,0.7,0.4,1,0c0,0,0-0.1,0.1-0.1c-0.2-0.1-0.4-0.2-0.6-0.2
		C382,109.9,381.7,110,381.4,110.1z"
      />
      <path
        class="st2"
        d="M382.8,110.1L382.8,110.1c0.1-0.1,0.1-0.1,0.1-0.2C382.9,109.9,382.8,110,382.8,110.1L382.8,110.1z"
      />
      <path
        class="st2"
        d="M573.8,46c-0.1,0-0.2,0-0.4,0c-0.1,0.3-0.1,0.7-0.2,1c0.1,0,0.2,0,0.4,0C573.7,46.6,573.8,46.3,573.8,46z"
      />
      <path
        class="st2"
        d="M557.2,51.5c0.1,0,0.1-0.1,0.2-0.1c-0.2-0.3-0.3-0.6-0.5-0.9c-0.1,0-0.2,0.1-0.3,0.1
		C556.9,50.9,557,51.2,557.2,51.5z"
      />
      <path
        class="st2"
        d="M588,64.5c0,0.1-0.1,0.2-0.1,0.3c0.3,0,0.6,0.1,0.9,0.1c0-0.1,0.1-0.2,0.1-0.3C588.6,64.7,588.3,64.6,588,64.5
		z"
      />
      <path
        class="st2"
        d="M436.3,47.8c0.5-0.5,0.7-1,0-1.3c0.1,0.2,0.1,0.4,0.1,0.7C436.4,47.4,436.3,47.6,436.3,47.8z"
      />
      <path
        class="st2"
        d="M447.7,61.5c0,0.5,0.4,0.5,1,0.3c-0.3-0.2-0.4-0.4-0.6-0.6C448,61.2,447.7,61.4,447.7,61.5z"
      />
      <path
        class="st2"
        d="M473.7,44.5c-0.1-0.1-0.3-0.4-0.4-0.3c-0.2,0-0.3,0.2-0.6,0.4c0.2,0.2,0.4,0.3,0.4,0.3
		C473.4,44.8,473.5,44.6,473.7,44.5z"
      />
      <path
        class="st2"
        d="M420.5,39c0.4,0.2,0.7,0.4,1.2,0.7C421.6,38.8,421.2,38.7,420.5,39z"
      />
      <path
        class="st2"
        d="M484.4,20.9c0-0.1,0-0.2-0.1-0.3c-0.5-0.2-0.7,0-0.9,0.5C483.8,21.3,484.1,21.3,484.4,20.9z"
      />
      <path
        class="st2"
        d="M523.7,50.5c0.2-0.3,0.5-0.5,0.7-0.8c0,0,0,0,0.1-0.1l0.1-0.1c-0.1,0-0.2-0.1-0.2-0.1c-0.3,0.3-0.7,0.6-1,1
		C523.4,50.4,523.6,50.4,523.7,50.5z"
      />
      <path
        class="st2"
        d="M483.7,55.6c0.3-0.1,0.5-0.2,0.8-0.3c-0.1-0.3-0.2-0.5-0.3-0.7C483.6,54.8,483.5,55.2,483.7,55.6z"
      />
      <path
        class="st2"
        d="M441.6,64.7C441.6,64.7,441.7,64.7,441.6,64.7c0.3,0,0.5-0.2,0.6-0.3l0,0c0-0.1-0.2-0.2-0.4-0.4
		c-0.2,0.2-0.4,0.4-0.5,0.5C441.3,64.5,441.5,64.7,441.6,64.7z"
      />
      <path
        class="st2"
        d="M533.6,63.3c-0.2,0.1-0.3,0.3-0.5,0.5c0.2,0.1,0.4,0.1,0.6,0.2c0.1-0.2,0.2-0.4,0.3-0.5
		C534,63.5,533.7,63.3,533.6,63.3z"
      />
      <path
        class="st2"
        d="M464.9,75.1c-0.1,0.4-0.3,0.6-0.2,0.7c0.1,0.1,0.3,0.2,0.5,0.3c0.1-0.2,0.2-0.3,0.2-0.5
		C465.4,75.5,465.2,75.4,464.9,75.1z"
      />
      <path
        class="st2"
        d="M408.2,88.7c-0.1-0.3-0.2-0.6-0.3-0.9C407.5,88.5,407.5,88.5,408.2,88.7z"
      />
      <path
        class="st2"
        d="M479.8,47c0-0.4,0-0.8,0.1-1.2c-0.1,0-0.2,0-0.3,0c-0.1,0.4-0.1,0.8-0.2,1.2C479.6,47,479.7,47,479.8,47z"
      />
      <path
        class="st2"
        d="M553,30.7c-0.2-0.3-0.5-0.5-0.8-1C552.1,30.4,552.3,30.7,553,30.7z"
      />
      <path
        class="st2"
        d="M553.2,41.8c0,0,0.1,0.2,0.2,0.3c0.2-0.2,0.5-0.4,0.7-0.6c-0.1-0.1-0.1-0.1-0.2-0.2
		C553.6,41.5,553.4,41.6,553.2,41.8z"
      />
      <path
        class="st2"
        d="M442.9,65.7c0,0,0-0.2,0-0.3c-0.3,0.1-0.6,0.1-0.9,0.2c0,0.1,0.1,0.2,0.1,0.3
		C442.4,65.9,442.6,65.8,442.9,65.7z"
      />
      <path
        class="st2"
        d="M486,58.2c0.1,0,0.1-0.1,0.2-0.1c0.1-0.1,0.2-0.2,0.3-0.3c-0.2-0.2-0.3-0.3-0.4-0.4c-0.1,0.1-0.1,0.1-0.2,0.2
		c-0.1,0.1-0.2,0.2-0.3,0.4C485.6,58,485.9,58.2,486,58.2z"
      />
      <path
        class="st2"
        d="M585.7,48.6c0.1-0.1,0.2-0.1,0.3-0.2c-0.2-0.2-0.4-0.4-0.6-0.6h-0.1c-0.1,0-0.1,0.1-0.2,0.1c0,0,0,0.1,0.1,0.1
		C585.4,48.2,585.5,48.4,585.7,48.6z"
      />
      <path
        class="st2"
        d="M594.9,58.4c0.4,0.2,0.6,0.3,1,0.4C595.6,58.3,595.6,58.3,594.9,58.4z"
      />
      <path
        class="st2"
        d="M447.9,59c0.2,0,0.4-0.2,0.6-0.3c-0.2-0.2-0.4-0.3-0.5-0.3c-0.2,0.1-0.4,0.3-0.6,0.5
		C447.6,58.9,447.7,59.1,447.9,59z"
      />
      <path
        class="st2"
        d="M576.8,0.6c-0.1-0.2-0.3-0.4-0.4-0.6H576l0,0c0.2,0.2,0.3,0.5,0.5,0.7C576.6,0.7,576.7,0.6,576.8,0.6z"
      />
      <path
        class="st2"
        d="M386.9,99.5L386.9,99.5c-0.1,0-0.2,0-0.2,0c0,0.1,0,0.1,0.1,0.2c0.1,0.2,0.2,0.4,0.2,0.6
		c0.1,0,0.2-0.1,0.3-0.1h0.1c0-0.1-0.1-0.1-0.1-0.2C387.1,99.8,387,99.7,386.9,99.5z"
      />
      <path
        class="st2"
        d="M451,35.9c-0.1-0.3-0.1-0.6-0.2-0.8c-0.1,0-0.1,0-0.2,0c0,0.3,0,0.6,0,0.8C450.7,35.9,450.8,35.9,451,35.9z"
      />
      <path
        class="st2"
        d="M430.1,30.7c0-0.1-0.2-0.3-0.3-0.3c-0.1,0-0.4,0.2-0.3,0.2c0.1,0.2,0.2,0.3,0.4,0.5
		C430,30.9,430.2,30.8,430.1,30.7z"
      />
      <path
        class="st2"
        d="M433.2,27c0.2-0.4-0.1-0.6-0.7-0.7c0.2,0.3,0.3,0.6,0.4,0.8C432.9,27.1,433.2,27,433.2,27z"
      />
      <path
        class="st2"
        d="M339.5,93c-0.1,0-0.2,0-0.3,0c-0.1,0.3-0.1,0.5-0.2,0.8c0.2,0,0.3,0,0.5,0C339.5,93.6,339.5,93.3,339.5,93z"
      />
      <path
        class="st2"
        d="M388.5,98.9c0.1,0.1,0.3,0.1,0.4,0.2c0.1-0.2,0.3-0.5,0.4-0.7c-0.1,0-0.2,0-0.3,0
		C388.8,98.5,388.7,98.7,388.5,98.9z"
      />
      <path
        class="st2"
        d="M495.3,46.1c0,0.1,0.2,0.2,0.2,0.3c0.2-0.1,0.3-0.2,0.5-0.4c-0.2-0.1-0.4-0.2-0.5-0.2
		C495.5,45.8,495.4,45.9,495.3,46.1z"
      />
      <path
        class="st2"
        d="M433.5,22.7c0-0.3,0.1-0.4,0.1-0.6c0-0.1-0.2-0.1-0.4-0.2c-0.1,0.2-0.2,0.3-0.2,0.5
		C433,22.5,433.3,22.6,433.5,22.7z"
      />
      <path
        class="st2"
        d="M539.7,77.3c0-0.1-0.1-0.2-0.1-0.3c-0.3,0.1-0.6,0.2-0.9,0.4c0.1,0.1,0.2,0.3,0.2,0.3
		C539.2,77.6,539.5,77.5,539.7,77.3z"
      />
      <path
        class="st2"
        d="M557.5,73.4c0.6-0.3,1-0.5,1.4-0.6C558.3,72.6,557.8,72.6,557.5,73.4z"
      />
      <path
        class="st2"
        d="M538.5,64.5L538.5,64.5c-0.2-0.2-0.3-0.4-0.5-0.6c-0.1,0.1-0.2,0.2-0.3,0.2c0.1,0,0.1,0.1,0.2,0.1
		C538.1,64.3,538.2,64.4,538.5,64.5C538.4,64.6,538.4,64.6,538.5,64.5z"
      />
      <path
        class="st2"
        d="M539.1,66.1c0.1-0.1,0.1-0.1,0.2-0.2c-0.3,0.1-0.6,0.1-0.9,0.2v0.1C538.7,66.2,538.9,66.2,539.1,66.1z"
      />
      <path
        class="st2"
        d="M469.9,36.4c-0.2,0-0.4-0.1-0.5-0.1c-0.1,0.1-0.2,0.2-0.2,0.3c0.1,0,0.3,0.1,0.4,0.1
		C469.7,36.7,469.8,36.5,469.9,36.4z"
      />
      <path
        class="st2"
        d="M383,112.9L383,112.9C383.1,112.8,383.1,112.8,383,112.9C383,112.8,383,112.8,383,112.9
		C383,112.8,383,112.9,383,112.9z"
      />
      <path
        class="st2"
        d="M382.4,113c0,0.1,0,0.1,0,0.2c-0.4,0.1-0.8,0.3-1.2,0.4c-0.1-0.1-0.2-0.2-0.2-0.3c-0.2-0.5-0.6-0.8-1-1
		c-0.7-0.3-1.6-0.1-2.4,0.6c-0.5,0.5-0.8,1.1-1.8,0.8c0.1,0.4,0.2,0.7,0.2,1.1c1.3-0.3,2.6-0.5,3.9-0.8c0.1,0,0.2,0,0.3-0.1
		c0.3-0.1,0.6-0.1,1-0.2c0.6-0.1,1.1-0.2,1.7-0.4l0,0l0,0l0,0l0,0c0-0.2,0.1-0.4,0.1-0.5v-0.1C382.7,112.9,382.4,112.8,382.4,113z"
      />
      <path
        class="st2"
        d="M462.1,8.8c0.1,0,0.1-0.2,0.1-0.3c-0.1,0-0.2-0.1-0.3,0c-0.1,0-0.1,0.2-0.1,0.3C461.8,8.7,462,8.8,462.1,8.8z"
      />
      <path
        class="st2"
        d="M596,40.6c-0.1,0-0.3,0-0.4-0.1c-0.1,0.2-0.1,0.5-0.2,0.7c0.1,0,0.2,0,0.3,0C595.7,41.1,595.8,40.8,596,40.6z"
      />
      <path
        class="st2"
        d="M502.3,1.3c0.1-0.2,0.2-0.3,0.3-0.5c0,0-0.1-0.1-0.3-0.2c-0.1,0.2-0.2,0.3-0.3,0.5
		C501.9,1.1,502.2,1.2,502.3,1.3z"
      />
      <path
        class="st2"
        d="M477.4,44.4c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0.2-0.2,0.4-0.3,0.6c0.1,0,0.1,0,0.2,0.1
		C477.1,44.9,477.2,44.6,477.4,44.4z"
      />
      <path
        class="st2"
        d="M453.5,57.8c0.2,0,0.5,0,0.7,0c-0.1-0.1-0.3-0.3-0.4-0.4C453.7,57.6,453.6,57.7,453.5,57.8z"
      />
      <path
        class="st2"
        d="M459.7,37.3c0.1,0,0.3-0.2,0.3-0.3s-0.2-0.2-0.2-0.3c-0.1,0.1-0.3,0.2-0.5,0.3l-0.1,0.1c0.2,0,0.3,0.1,0.4,0.1
		C459.7,37.3,459.7,37.3,459.7,37.3z"
      />
      <path
        class="st2"
        d="M433.9,30.1c0,0.1,0.2,0.1,0.3,0.1c0.1-0.1,0.2-0.2,0.4-0.3c-0.2-0.1-0.4-0.1-0.5-0.2
		C433.9,29.9,433.8,30,433.9,30.1z"
      />
      <path
        class="st2"
        d="M610.7,15.7c-0.1-0.2-0.2-0.4-0.4-0.6c-0.1,0-0.1,0.1-0.2,0.1c0.1,0.2,0.3,0.4,0.4,0.6
		C610.6,15.7,610.7,15.7,610.7,15.7z"
      />
      <path
        class="st2"
        d="M550,38.7c0.1-0.1,0.3-0.2,0.4-0.3c-0.1,0-0.2-0.1-0.3-0.1s-0.1-0.1-0.2-0.1v0.1c-0.1,0.1-0.1,0.2-0.1,0.3
		C549.7,38.6,549.9,38.7,550,38.7z"
      />
      <path
        class="st2"
        d="M578.7,61.5c-0.2-0.2-0.4-0.4-0.6-0.6c-0.1,0-0.1,0.1-0.2,0.1c0.2,0.2,0.3,0.5,0.5,0.7
		C578.5,61.7,578.6,61.6,578.7,61.5z"
      />
      <path
        class="st2"
        d="M440.3,29.6c-0.1-0.3-0.1-0.7-0.7-0.7C439.7,29.2,439.6,29.6,440.3,29.6z"
      />
      <path
        class="st2"
        d="M569.4,35c-0.1,0-0.1,0-0.2,0c0,0.2,0,0.3,0,0.5c0,0.1,0,0.2,0,0.2s0,0,0.1,0s0.2,0,0.3,0
		C569.5,35.5,569.5,35.3,569.4,35C569.5,35,569.5,35,569.4,35C569.5,35,569.4,35,569.4,35z"
      />
      <path
        class="st2"
        d="M435.1,48.1c0-0.1,0-0.1-0.1-0.1c0,0-0.1,0-0.1-0.1V48C435,48.1,435,48.1,435.1,48.1z"
      />
      <path
        class="st2"
        d="M435.8,48.6c-0.3-0.2-0.5-0.3-0.7-0.5C435.2,48.4,435.1,48.8,435.8,48.6z"
      />
      <path
        class="st2"
        d="M389.3,74.5c-0.1,0.1-0.2,0.2-0.3,0.3c0.1,0.1,0.2,0.2,0.4,0.2l0.2-0.2C389.5,74.7,389.4,74.6,389.3,74.5z"
      />
      <path
        class="st2"
        d="M388.5,102.5C388.5,102.5,388.4,102.5,388.5,102.5c-0.1-0.1-0.2-0.1-0.2-0.2c-0.1,0.1-0.1,0.1-0.2,0.2l0,0
		C388.2,102.5,388.3,102.5,388.5,102.5L388.5,102.5z"
      />
      <path
        class="st2"
        d="M383.7,42c-0.3-0.1-0.5-0.2-0.6-0.2s-0.2,0.1-0.3,0.2c0.1,0.1,0.2,0.3,0.4,0.3C383.2,42.3,383.4,42.1,383.7,42
		z"
      />
      <path
        class="st2"
        d="M518.4,14c0.1-0.2,0.2-0.3,0.2-0.4c0-0.1-0.2-0.1-0.2-0.1c-0.1,0.1-0.3,0.2-0.3,0.2
		C518,13.8,518.2,13.8,518.4,14z"
      />
      <path
        class="st2"
        d="M375.8,109.5c0.1-0.2,0.2-0.3,0.3-0.5l0,0l0,0c0.5,0,1.1,0,1.6,0c0.4,0,0.7,0,0.9-0.1c0.7-0.1,0.8-0.4,1.3-1.5
		c-0.6-0.3-1.2-0.7-1.7-1c-0.5,0.2-0.8,0.2-1,0.4l0,0c-0.3,0.2-0.6,0.5-1,0.8c-0.5,0.3-0.8,0.7-0.6,1.2l0,0l0,0
		c-0.1,0.2-0.1,0.4-0.1,0.6C375.5,109.4,375.8,109.5,375.8,109.5z"
      />
      <path
        class="st2"
        d="M580.5,51.2c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.2,0.2-0.2,0.3
		c0.1,0,0.1,0.1,0.2,0.1C580.1,51.5,580.3,51.4,580.5,51.2L580.5,51.2z"
      />
      <path
        class="st2"
        d="M438,48.3c-0.1,0-0.2,0.2-0.3,0.3c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.2-0.1,0.4-0.3
		C438.2,48.5,438.1,48.3,438,48.3z"
      />
      <path
        class="st2"
        d="M467.2,27.5c0.1-0.2,0.2-0.3,0.2-0.4c-0.1,0-0.3-0.1-0.4-0.1c0,0-0.2,0.2-0.1,0.2
		C466.9,27.3,467,27.4,467.2,27.5z"
      />
      <path
        class="st2"
        d="M382.4,106.7c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0.1-0.2,0.1-0.2,0.2s0.1,0.1,0.2,0.2
		C382.2,106.9,382.3,106.8,382.4,106.7z"
      />
      <path
        class="st2"
        d="M531.1,47c0.1,0.1,0.3,0.1,0.4,0.1h0.1c-0.2-0.1-0.5-0.2-0.7-0.4C531,46.8,531,46.9,531.1,47z"
      />
      <path
        class="st2"
        d="M561.3,17.5c-0.1-0.1-0.2,0-0.3-0.1c0,0.1,0,0.2-0.1,0.3c0.1,0,0.2,0,0.3,0C561.2,17.7,561.3,17.6,561.3,17.5z
		"
      />
      <path
        class="st2"
        d="M477.5,24.5c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2c0,0,0.1,0.1,0.1,0.2
		C477.3,24.6,477.4,24.6,477.5,24.5z"
      />
      <path
        class="st2"
        d="M530,46.5c0.2,0,0.5,0.1,0.7,0.1c-0.2-0.1-0.4-0.3-0.6-0.4C530.1,46.3,530.1,46.4,530,46.5z"
      />
      <path
        class="st2"
        d="M530.7,46.6C530.7,46.6,530.8,46.6,530.7,46.6c0.1,0.1,0.1,0.1,0.2,0.1c0,0,0,0,0-0.1
		C530.8,46.6,530.8,46.6,530.7,46.6z"
      />
      <path
        class="st2"
        d="M464.7,28.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2s0.1,0.1,0.1,0.2
		C464.5,29,464.6,28.9,464.7,28.8z"
      />
      <path
        class="st2"
        d="M384.4,106.7c-0.1,0.1-0.1,0.1-0.2,0.2c0.2,0.1,0.3,0.1,0.4,0.2l0.1-0.1C384.6,106.8,384.5,106.8,384.4,106.7z
		"
      />
      <path
        class="st2"
        d="M537.2,9.4c0.1,0.1,0.1,0.2,0.2,0.4c0-0.1,0-0.3,0-0.4C537.3,9.3,537.2,9.4,537.2,9.4z"
      />
      <path
        class="st2"
        d="M537.3,9.7v0.1l0,0C537.3,9.8,537.3,9.8,537.3,9.7C537.4,9.8,537.4,9.8,537.3,9.7z"
      />
      <path
        class="st2"
        d="M432.6,36.5c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0-0.2,0.1-0.3,0.1
		C432.4,36.3,432.5,36.4,432.6,36.5z"
      />
      <path
        class="st2"
        d="M541.3,42.8c0.2-0.1,0.4-0.2,0.6-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.2,0.1-0.4,0.2-0.7,0.2
		C541.2,42.7,541.3,42.7,541.3,42.8z"
      />
      <path
        class="st2"
        d="M576.2,63.1c0,0.4,0.1,0.7,0.1,0.9C576.8,63.8,576.4,63.5,576.2,63.1z"
      />
      <path
        class="st2"
        d="M574.1,50.8c0.1-0.1,0.1-0.2,0.1-0.2c-0.1,0-0.2,0-0.3,0s0,0.2-0.1,0.2C573.9,50.8,574,50.8,574.1,50.8z"
      />
      <path
        class="st2"
        d="M331.5,105.7c0.1,0,0.2-0.1,0.3-0.1c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0-0.2,0-0.3,0.1
		C331.3,105.6,331.4,105.7,331.5,105.7z"
      />
      <path
        class="st2"
        d="M430.6,69.8c0,0-0.1,0.1-0.2,0.2c0.1,0,0.2,0.1,0.3,0.1l0.1-0.1C430.8,69.8,430.7,69.8,430.6,69.8z"
      />
      <path
        class="st2"
        d="M389.9,106.2L389.9,106.2c0.1,0.2,0.2,0.2,0.2,0.3c0.1-0.1,0.1-0.1,0.2-0.2c0-0.1-0.1-0.2-0.1-0.2
		C390.1,106,390,106.1,389.9,106.2C389.9,106.1,389.9,106.1,389.9,106.2z"
      />
      <path
        class="st2"
        d="M484.9,53.6c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0.2-0.2,0.4-0.3,0.7c0,0.1-0.1,0.1-0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2
		C484.6,54,484.8,53.8,484.9,53.6z"
      />
      <path
        class="st2"
        d="M491.9,57.1c0-0.1,0-0.2-0.1-0.4c0,0-0.1,0-0.1,0.1C491.8,56.9,491.8,57,491.9,57.1z"
      />
      <path
        class="st2"
        d="M479.5,41.2c-0.1-0.1-0.1-0.2-0.1-0.2c-0.1,0.1-0.2,0.1-0.3,0.2c0,0.1,0,0.2,0,0.2
		C479.3,41.3,479.4,41.3,479.5,41.2z"
      />
      <path
        class="st2"
        d="M582.9,74c0.1,0,0.2-0.2,0.4-0.3c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0.1-0.3,0.2-0.4,0.2
		C582.7,73.9,582.8,74,582.9,74z"
      />
      <path
        class="st2"
        d="M492.7,57.4c-0.2,0-0.4-0.1-0.6-0.1c0.1,0.1,0.3,0.3,0.4,0.4C492.5,57.6,492.6,57.5,492.7,57.4z"
      />
      <path
        class="st2"
        d="M492.1,57.3C492,57.3,492,57.2,492.1,57.3c-0.1-0.1-0.1-0.1-0.1-0.2v0.1C492,57.3,492,57.3,492.1,57.3z"
      />
      <path
        class="st2"
        d="M381.3,75.7c0.1,0,0.2,0,0.2-0.1l0,0v-0.1c0,0,0,0-0.1,0.1L381.3,75.7z"
      />
      <path
        class="st2"
        d="M380.8,76c0.2-0.1,0.3-0.2,0.5-0.3c-0.2,0.1-0.4,0.1-0.6,0.2C380.7,75.9,380.7,75.9,380.8,76z"
      />
      <path
        class="st2"
        d="M495.2,50.9L495.2,50.9C495.1,50.9,495.1,50.9,495.2,50.9C495.2,50.9,495.2,51,495.2,50.9L495.2,50.9z"
      />
      <path
        class="st2"
        d="M495.8,50.5c-0.2,0-0.4,0-0.5,0.1s-0.1,0.2-0.1,0.4c0.2,0,0.3,0,0.5-0.1C495.8,50.8,495.8,50.6,495.8,50.5z"
      />
      <path
        class="st2"
        d="M337.7,91.2c-0.1,0.1-0.2,0.2-0.3,0.3c0.1,0,0.1,0.1,0.2,0.1c0.1-0.1,0.2-0.1,0.2-0.2
		C337.8,91.3,337.8,91.2,337.7,91.2z"
      />
      <path
        class="st2"
        d="M466,46.3l0.1,0.1l0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.1C466.2,46,466,46.1,466,46.3
		C466,46.2,466,46.3,466,46.3z"
      />
      <path
        class="st2"
        d="M506.3,46.8c-0.1,0-0.3-0.1-0.4-0.1l-0.1,0.2c0,0.1,0.2,0.2,0.3,0.3C506.2,47.1,506.3,47,506.3,46.8z"
      />
      <path
        class="st2"
        d="M555.9,46.2c0.1-0.1,0.2-0.1,0.3-0.2c0-0.1-0.1-0.2-0.1-0.2C556,45.9,555.9,46.1,555.9,46.2
		C555.8,46.1,555.8,46.2,555.9,46.2z"
      />
      <path
        class="st2"
        d="M427,41.5c0.1,0.1,0.2,0.1,0.3,0.1c0-0.1,0.1-0.2,0-0.3c0-0.1-0.2,0-0.3-0.1C427.1,41.4,427,41.5,427,41.5z"
      />
      <path
        class="st2"
        d="M427,63.7c-0.1,0-0.3-0.1-0.4-0.1s-0.1,0.2-0.2,0.3c0.1,0,0.3,0.1,0.4,0.1S426.9,63.9,427,63.7z"
      />
      <path
        class="st2"
        d="M539.7,53.8c0.1-0.1,0.2-0.2,0.3-0.3c0,0-0.1-0.1-0.3-0.4c-0.1,0.2-0.1,0.4-0.2,0.5
		C539.5,53.7,539.6,53.8,539.7,53.8z"
      />
      <path
        class="st2"
        d="M544.5,68.1c-0.1-0.1-0.2-0.1-0.2-0.1c-0.1,0-0.2,0.1-0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.2
		C544.3,68.3,544.4,68.2,544.5,68.1z"
      />
      <path
        class="st2"
        d="M421.1,45.4c0,0-0.1,0.1-0.2,0.2c0.2,0.1,0.3,0.1,0.4,0.1l0,0l0.1-0.1l-0.1-0.1
		C421.2,45.5,421.1,45.4,421.1,45.4z"
      />
      <path
        class="st2"
        d="M526.1,22.6c-0.1,0-0.2,0.1-0.3,0.1c0.1,0.1,0.2,0.3,0.3,0.4C526.1,23,526.1,22.8,526.1,22.6z"
      />
      <path
        class="st2"
        d="M581.3,43.7c-0.1,0-0.2,0-0.2,0c0,0.2,0,0.3-0.1,0.5c0.1,0,0.2,0,0.2,0C581.2,44,581.2,43.9,581.3,43.7z"
      />
      <path
        class="st2"
        d="M491.7,42.7c0,0.2-0.1,0.3-0.1,0.5c0.1,0,0.2,0,0.3,0C491.8,43.1,491.7,42.9,491.7,42.7z"
      />
      <path
        class="st2"
        d="M472.6,36.2h-0.1c0,0.1-0.1,0.2-0.1,0.2c0.1,0,0.2,0,0.2,0C472.5,36.4,472.6,36.3,472.6,36.2z"
      />
      <path
        class="st2"
        d="M547.4,64.9c0,0,0.1-0.1,0.2-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.2,0.1-0.3,0.1
		C547.2,64.8,547.3,64.9,547.4,64.9z"
      />
      <path
        class="st2"
        d="M577,42.2c0,0.1,0.1,0.2,0.1,0.3c0.1-0.1,0.2-0.1,0.2-0.2c0-0.1-0.1-0.1-0.1-0.2C577.1,42.1,577,42.2,577,42.2
		z"
      />
      <path
        class="st2"
        d="M329.3,111.2c0,0.1,0.1,0.2,0.1,0.2c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.1,0,0.2,0c0-0.1,0-0.2-0.1-0.2
		c0-0.1,0-0.2-0.1-0.2C329.5,111.2,329.4,111.2,329.3,111.2z"
      />
      <path
        class="st2"
        d="M494.2,33.4c0.1,0,0.3,0.1,0.3,0c0.1-0.1,0.1-0.2,0.2-0.3c0,0-0.2-0.1-0.3-0.1
		C494.4,33.2,494.3,33.3,494.2,33.4z"
      />
      <path
        class="st2"
        d="M594.6,38.6c0.1-0.1,0.2-0.1,0.2-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.1,0.1-0.2,0.1-0.3,0.2
		C594.4,38.5,594.5,38.6,594.6,38.6z"
      />
      <path
        class="st2"
        d="M456.8,69.6c0-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.3-0.3,0.4c0.1,0,0.2,0,0.4,0
		C456.7,69.8,456.8,69.7,456.8,69.6z"
      />
      <path
        class="st2"
        d="M474.7,51.1c0.1,0,0.2,0,0.2-0.1c-0.1-0.2-0.2-0.3-0.2-0.5h-0.1C474.7,50.8,474.7,51,474.7,51.1z"
      />
      <path
        class="st2"
        d="M447,56.4L447,56.4C446.9,56.3,446.9,56.3,447,56.4C446.9,56.4,446.9,56.5,447,56.4
		C447,56.4,447,56.4,447,56.4z"
      />
      <path
        class="st2"
        d="M448,55.2c-0.1,0-0.2,0.1-0.3,0.2c0.1,0.1,0.1,0.1,0.2,0.2c0.1-0.1,0.2-0.1,0.3-0.2
		C448.1,55.3,448.1,55.2,448,55.2z"
      />
      <path
        class="st2"
        d="M547.4,32c0-0.1,0.1-0.2,0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c0,0.1-0.1,0.2-0.1,0.2
		C547.2,31.9,547.3,32,547.4,32z"
      />
      <path
        class="st2"
        d="M471.8,52.5c0.1,0,0.2-0.1,0.3-0.2l-0.1-0.1c-0.1,0.1-0.2,0.1-0.3,0.2C471.7,52.4,471.7,52.5,471.8,52.5z"
      />
      <path
        class="st2"
        d="M412.1,66c0.2,0,0.3,0,0.5,0h0.1c0,0,0,0-0.1-0.1C412.4,66,412.3,66,412.1,66z"
      />
      <path
        class="st2"
        d="M489.6,42.2c0.1,0.1,0.1,0.1,0.2,0.1c0.1-0.1,0.1-0.1,0.2-0.2c-0.1,0-0.2,0-0.3,0
		C489.6,42.1,489.5,42.2,489.6,42.2z"
      />
      <path
        class="st2"
        d="M382.1,73.7l-0.1-0.1l-0.1,0.1c0,0.1,0.1,0.1,0.2,0.2C382.1,73.9,382.1,73.8,382.1,73.7z"
      />
      <path
        class="st2"
        d="M381.6,75.2c-0.1,0-0.1,0.1-0.1,0.1c0,0.1,0,0.1,0,0.2C381.6,75.4,381.6,75.4,381.6,75.2
		C381.6,75.3,381.6,75.2,381.6,75.2z"
      />
      <path
        class="st2"
        d="M381.3,99c0.1-0.1,0.2-0.1,0.2-0.2s-0.1-0.1-0.2-0.3c0,0.1-0.1,0.2-0.1,0.2C381.2,98.9,381.3,99,381.3,99z"
      />
      <path
        class="st2"
        d="M502.8,37.5c0-0.1-0.1-0.1-0.1-0.2l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2C502.8,37.6,502.8,37.5,502.8,37.5z"
      />
      <path
        class="st2"
        d="M477.5,55.9h0.1C477.6,55.9,477.6,55.8,477.5,55.9C477.5,55.8,477.5,55.8,477.5,55.9
		C477.4,55.9,477.5,55.9,477.5,55.9z"
      />
      <path
        class="st2"
        d="M418.2,53.4c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0-0.1,0.1-0.2,0.2c0.1,0,0.2,0,0.3,0
		C418.1,53.5,418.2,53.4,418.2,53.4z"
      />
      <path
        class="st2"
        d="M438.7,48c0,0,0.1,0,0.2,0c0,0,0-0.1-0.1-0.1C438.8,47.9,438.7,47.9,438.7,48C438.7,47.9,438.7,48,438.7,48z"
      />
      <path
        class="st2"
        d="M477.4,58c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1,0-0.2,0-0.3,0C477.5,57.9,477.5,58,477.4,58z"
      />
      <path
        class="st2"
        d="M454.8,63.3c-0.1,0-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1C454.7,63.4,454.8,63.4,454.8,63.3L454.8,63.3z"
      />
      <path
        class="st2"
        d="M446.1,46.1c0,0.1,0.1,0.3,0.1,0.4c0.1-0.1,0.1-0.3,0.2-0.4C446.2,46.1,446.1,46.1,446.1,46.1z"
      />
      <path
        class="st2"
        d="M567.9,39.9L567.9,39.9C567.9,39.8,567.8,39.8,567.9,39.9h-0.2l0,0C567.7,40,567.8,40,567.9,39.9
		C567.9,40,567.9,40,567.9,39.9z"
      />
      <path
        class="st2"
        d="M469.4,40.4c0.1,0,0.2,0,0.3,0c0.1,0,0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0C469.5,40.3,469.4,40.4,469.4,40.4z"
      />
      <path
        class="st2"
        d="M581.3,73.7C581.3,73.7,581.4,73.7,581.3,73.7C581.4,73.6,581.3,73.6,581.3,73.7
		C581.3,73.6,581.3,73.7,581.3,73.7z"
      />
      <path
        class="st2"
        d="M581.2,74.1c0.1-0.1,0.1-0.3,0.2-0.4c-0.1,0-0.2,0-0.3,0.1C581.1,73.8,581.1,74,581.2,74.1z"
      />
      <path
        class="st2"
        d="M597.1,35C597.1,35.1,597,35.1,597.1,35C597,35.1,597.1,35.1,597.1,35C597.1,35.1,597.1,35.1,597.1,35z"
      />
      <path
        class="st2"
        d="M597.2,34.7c0,0.1-0.1,0.3-0.1,0.4c0.1-0.1,0.2-0.2,0.2-0.3C597.3,34.7,597.2,34.7,597.2,34.7z"
      />
      <path
        class="st2"
        d="M336.8,92.6l0.1-0.1c0-0.1-0.1-0.2-0.1-0.2l-0.1,0.1C336.7,92.5,336.8,92.5,336.8,92.6z"
      />
      <path
        class="st2"
        d="M425.1,73.7c-0.1,0-0.2,0-0.3,0l-0.1,0.1c0.1,0,0.2,0.1,0.3,0.1C425.1,73.9,425.1,73.8,425.1,73.7z"
      />
      <path
        class="st2"
        d="M579.3,73.1L579.3,73.1c0.2,0,0.2,0,0.3-0.1c-0.1,0-0.1-0.1-0.2-0.1C579.4,72.9,579.3,73,579.3,73.1z"
      />
      <path
        class="st2"
        d="M337.9,93.5c0-0.1-0.1-0.1-0.1-0.2l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2C337.9,93.6,337.9,93.5,337.9,93.5z"
      />
      <path
        class="st2"
        d="M494.2,59.7l-0.1,0.1c0,0.1,0.1,0.2,0.2,0.2l0.1-0.1C494.3,59.9,494.3,59.8,494.2,59.7z"
      />
      <path
        class="st2"
        d="M428.6,48.1c0,0.1,0.1,0.1,0.2,0.1c0-0.1,0.1-0.2,0.1-0.3c-0.1,0-0.2,0-0.3-0.1C428.6,48,428.6,48,428.6,48.1z
		"
      />
      <path
        class="st2"
        d="M560.1,45.6c0,0.1,0.1,0.2,0.1,0.2l0.1-0.1C560.2,45.6,560.2,45.5,560.1,45.6
		C560.1,45.5,560.1,45.6,560.1,45.6z"
      />
      <path
        class="st2"
        d="M551.5,47.7c0.1,0,0.2,0.1,0.3,0.1c0-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0
		C551.6,47.6,551.6,47.6,551.5,47.7z"
      />
      <path
        class="st2"
        d="M383.5,110.8l-0.1-0.1c-0.1,0-0.2,0-0.3,0.1c0,0.1,0.1,0.1,0.1,0.2C383.3,110.9,383.4,110.8,383.5,110.8z"
      />
      <path
        class="st2"
        d="M415.8,78.5L415.8,78.5C415.8,78.5,415.8,78.6,415.8,78.5c0,0.1,0.1,0.2,0.1,0.2s0,0,0.1,0c0,0,0,0,0.1,0
		l0.1-0.1C416.1,78.5,416,78.5,415.8,78.5C415.9,78.5,415.9,78.5,415.8,78.5z"
      />
      <path
        class="st2"
        d="M316.1,100.5H316v0.1c0.1,0,0.1,0,0.2,0C316.2,100.6,316.2,100.6,316.1,100.5z"
      />
      <path
        class="st2"
        d="M339.8,64.1L339.8,64.1C339.8,64.2,339.9,64.2,339.8,64.1C339.9,64.2,339.8,64.1,339.8,64.1z"
      />
      <path
        class="st2"
        d="M526.6,23.6c-0.1-0.1-0.2-0.2-0.3-0.3c0.1,0.1,0.1,0.2,0.2,0.4L526.6,23.6z"
      />
      <path
        class="st2"
        d="M526.3,23.3l-0.1-0.1l0,0C526.2,23.3,526.2,23.3,526.3,23.3z"
      />
      <path
        class="st2"
        d="M377.7,87.9c0,0,0.1,0,0.1-0.1c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.2,0-0.2,0l0,0
		C377.7,87.9,377.7,87.9,377.7,87.9z"
      />
      <path
        class="st2"
        d="M377.3,88.4c0.1-0.1,0.2-0.2,0.3-0.3c-0.2,0.1-0.3,0.1-0.5,0.2C377.2,88.3,377.2,88.3,377.3,88.4z"
      />
      <path
        class="st2"
        d="M377.6,88.1h0.1c0,0,0,0,0-0.1C377.7,88,377.7,88,377.6,88.1C377.6,88,377.6,88,377.6,88.1z"
      />
      <path
        class="st2"
        d="M554.7,15.6c-0.1,0-0.2,0-0.3,0.1c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.2-0.1,0.3-0.2
		C554.8,15.6,554.8,15.6,554.7,15.6z"
      />
      <path
        class="st2"
        d="M534.9,76.2c-0.1,0.1-0.1,0.2-0.2,0.3c0.1-0.1,0.3-0.1,0.4-0.2C535.1,76.3,535,76.2,534.9,76.2z"
      />
      <path
        class="st2"
        d="M534.7,76.6C534.7,76.5,534.7,76.5,534.7,76.6C534.7,76.5,534.7,76.5,534.7,76.6
		C534.6,76.5,534.7,76.5,534.7,76.6L534.7,76.6L534.7,76.6z"
      />
      <path
        class="st2"
        d="M466.3,30.5c0,0-0.1-0.1-0.2-0.1c0,0.1-0.1,0.2,0,0.3l0.1,0.1C466.2,30.7,466.3,30.6,466.3,30.5z"
      />
      <path
        class="st2"
        d="M333,58.6l-0.1,0.1c0.1,0,0.2,0,0.3,0l0.1-0.1C333.2,58.6,333.1,58.6,333,58.6z"
      />
      <path
        class="st2"
        d="M583.5,46.9c-0.1-0.1-0.1-0.1-0.1-0.2l-0.1,0.1C583.3,46.9,583.4,46.9,583.5,46.9
		C583.4,46.9,583.4,46.9,583.5,46.9z"
      />
      <path
        class="st2"
        d="M583.8,65.3c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2c0-0.1-0.1-0.1-0.2-0.2
		C583.9,65.1,583.8,65.2,583.8,65.3z"
      />
      <path
        class="st2"
        d="M450.6,32.9c0,0.1,0,0.1,0,0.2c0,0,0.1,0,0.1-0.1C450.7,33,450.7,33,450.6,32.9z"
      />
      <path
        class="st2"
        d="M555.1,71c-0.2,0-0.4,0.1-0.6,0.1v0.1C554.7,71.2,554.9,71.1,555.1,71L555.1,71z"
      />
      <path
        class="st2"
        d="M333.9,58.1c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.2-0.1-0.3-0.2C333.8,57.9,333.8,58,333.9,58.1z"
      />
      <path
        class="st2"
        d="M333.6,57.6C333.6,57.7,333.7,57.7,333.6,57.6c0.1,0.1,0.1,0.1,0.1,0.1C333.7,57.8,333.7,57.7,333.6,57.6
		C333.7,57.7,333.7,57.7,333.6,57.6z"
      />
      <path
        class="st2"
        d="M450.4,31.8l-0.1-0.1l-0.1,0.1l0.1,0.1C450.4,31.9,450.4,31.8,450.4,31.8z"
      />
      <path
        class="st2"
        d="M317.6,121c-0.1,0-0.1,0.1-0.2,0.1c0,0,0,0.1,0.1,0.1C317.5,121.2,317.6,121.2,317.6,121
		C317.6,121.1,317.6,121.1,317.6,121z"
      />
      <path
        class="st2"
        d="M402.8,40.6c-0.1-0.1-0.2-0.1-0.2-0.2c0,0.1,0.1,0.2,0.1,0.3C402.7,40.6,402.7,40.6,402.8,40.6z"
      />
      <path
        class="st2"
        d="M402.5,40.4L402.5,40.4l-0.1-0.1C402.4,40.3,402.4,40.3,402.5,40.4C402.5,40.3,402.5,40.4,402.5,40.4z"
      />
      <path
        class="st2"
        d="M479.1,22.8c-0.1-0.1-0.1-0.2-0.2-0.2l-0.1,0.1c0,0.1,0.1,0.2,0.2,0.2C479,22.9,479,22.9,479.1,22.8z"
      />
      <path
        class="st2"
        d="M375.1,107.2L375.1,107.2c0,0.1,0,0.2,0.1,0.2v-0.1C375.2,107.3,375.2,107.3,375.1,107.2z"
      />
      <path
        class="st2"
        d="M576,62.8C576,62.8,576,62.7,576,62.8C576,62.7,575.9,62.7,576,62.8C575.9,62.7,575.9,62.7,576,62.8L576,62.8z
		"
      />
      <path
        class="st2"
        d="M426,33.8c0-0.1,0.1-0.2,0.1-0.3l-0.1-0.1c0,0.1-0.1,0.2-0.1,0.3L426,33.8z"
      />
      <path
        class="st2"
        d="M534.7,61.3c-0.1,0-0.2-0.1-0.3-0.1s-0.2,0.1-0.2,0.2c0.1,0,0.2,0.1,0.3,0.1S534.6,61.4,534.7,61.3z"
      />
      <path
        class="st2"
        d="M550.5,68c0-0.1,0.1-0.1,0.1-0.2c0,0-0.1-0.1-0.2-0.1c0,0.1-0.1,0.2-0.1,0.3C550.4,67.9,550.4,68,550.5,68z"
      />
      <path
        class="st2"
        d="M463.7,77.4C463.7,77.3,463.7,77.4,463.7,77.4c-0.1,0.1,0,0.2,0,0.2l0.1-0.1C463.8,77.4,463.7,77.4,463.7,77.4
		z"
      />
      <path
        class="st2"
        d="M549.3,58.9c0,0.1,0,0.1,0.1,0.2l0.1-0.1C549.4,58.9,549.4,58.9,549.3,58.9C549.4,58.9,549.3,58.9,549.3,58.9z
		"
      />
      <path
        class="st2"
        d="M574.4,53.5c0,0.1,0.1,0.1,0.2,0.2v-0.1C574.6,53.4,574.5,53.4,574.4,53.5C574.5,53.4,574.4,53.4,574.4,53.5z"
      />
      <path
        class="st2"
        d="M546,60.3L546,60.3c-0.1,0-0.2,0.1-0.2,0.2c0,0,0.1,0,0.1,0.1C545.9,60.4,546,60.3,546,60.3z"
      />
      <path
        class="st2"
        d="M592.2,57.7c0-0.1,0.1-0.2,0.1-0.3l-0.1-0.1C592.2,57.4,592.1,57.5,592.2,57.7
		C592.1,57.6,592.2,57.6,592.2,57.7z"
      />
      <path
        class="st2"
        d="M413.3,30.1l-0.1-0.1c0,0-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1C413.1,30.1,413.2,30.1,413.3,30.1z"
      />
      <path
        class="st2"
        d="M386.1,101.7l-0.1-0.1c-0.1,0-0.2,0.1-0.2,0.1l0.1,0.1C385.9,101.8,386,101.8,386.1,101.7z"
      />
      <path
        class="st2"
        d="M489.7,6.9C489.6,6.9,489.6,6.9,489.7,6.9c-0.1,0.1-0.1,0.2-0.1,0.2C489.7,7.1,489.7,7.1,489.7,6.9L489.7,6.9z
		"
      />
      <path
        class="st2"
        d="M332.5,107.6C332.5,107.5,332.6,107.5,332.5,107.6C332.6,107.5,332.5,107.5,332.5,107.6l-0.1-0.2l-0.1,0.1
		C332.4,107.5,332.4,107.5,332.5,107.6L332.5,107.6z"
      />
      <path
        class="st2"
        d="M461,7.8c-0.1,0-0.2-0.1-0.3-0.1c0,0.1,0.1,0.2,0.1,0.4C460.9,8,460.9,7.9,461,7.8z"
      />
      <path
        class="st2"
        d="M371.4,22.2c0-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.2-0.1,0.2c0.1,0.1,0.2,0.1,0.3,0.2
		C371.4,22.4,371.4,22.3,371.4,22.2z"
      />
      <path
        class="st2"
        d="M320.5,110.4c0,0-0.1,0-0.2,0.1c0,0.1-0.1,0.2-0.1,0.3c0.1-0.1,0.1-0.2,0.2-0.2
		C320.4,110.4,320.4,110.4,320.5,110.4z"
      />
      <path
        class="st2"
        d="M324.4,109.6c0.1,0,0.1,0,0.2-0.1c0,0,0-0.1-0.1-0.1C324.5,109.4,324.4,109.4,324.4,109.6L324.4,109.6z"
      />
      <path
        class="st2"
        d="M445.9,83.5c0.1-0.1,0.2-0.1,0.3-0.2l-0.1-0.1c-0.1,0-0.2,0-0.3,0.1C445.9,83.4,445.9,83.5,445.9,83.5z"
      />
      <path
        class="st2"
        d="M308.1,140.6L308.1,140.6C308.1,140.7,308.2,140.7,308.1,140.6C308.2,140.7,308.2,140.7,308.1,140.6
		C308.2,140.6,308.2,140.6,308.1,140.6z"
      />
      <path
        class="st2"
        d="M583.7,74.2L583.7,74.2h-0.2H583.7C583.6,74.3,583.7,74.3,583.7,74.2z"
      />
      <path
        class="st2"
        d="M306.5,133.2v0.1V133.2C306.6,133.2,306.6,133.1,306.5,133.2C306.6,133.1,306.5,133.1,306.5,133.2z"
      />
      <path
        class="st2"
        d="M306.7,132.9c0,0.1-0.1,0.2-0.1,0.2c0.1-0.1,0.2-0.1,0.2-0.2C306.8,132.9,306.7,132.9,306.7,132.9z"
      />
      <path
        class="st2"
        d="M589.7,67.8C589.7,67.8,589.6,67.8,589.7,67.8L589.7,67.8L589.7,67.8C589.6,67.8,589.7,67.8,589.7,67.8z"
      />
      <path
        class="st2"
        d="M383.3,112.7c-0.1,0-0.1-0.1-0.2-0.1c0,0.1,0,0.1,0,0.2C383.1,112.8,383.2,112.7,383.3,112.7z"
      />
      <path
        class="st2"
        d="M560.9,73.2L560.9,73.2C560.8,73.4,560.8,73.3,560.9,73.2C560.8,73.3,560.8,73.3,560.9,73.2z"
      />
      <path
        class="st2"
        d="M376.6,111.9L376.6,111.9c-0.1,0-0.2,0-0.2,0C376.4,112,376.5,112,376.6,111.9
		C376.6,112,376.6,112,376.6,111.9z"
      />
      <path
        class="st2"
        d="M383.9,109.7c0,0,0.1,0,0.1,0.1l0.1-0.1l-0.1-0.1C384,109.6,383.9,109.6,383.9,109.7z"
      />
      <path
        class="st2"
        d="M586.7,64.7c0.1,0,0.1,0.1,0.2,0.1c0-0.1,0-0.2,0.1-0.3l0,0C586.9,64.6,586.8,64.7,586.7,64.7z"
      />
      <path
        class="st2"
        d="M555.6,71.6L555.6,71.6c0.1,0.1,0.1,0.1,0.2,0.1c0,0,0,0,0.1,0l0,0C555.7,71.6,555.6,71.6,555.6,71.6z"
      />
      <path
        class="st2"
        d="M587,64.6L587,64.6c0-0.1,0.1-0.2,0.1-0.3C587.1,64.4,587,64.5,587,64.6z"
      />
      <polygon class="st2" points="579.7,63.5 579.8,63.5 579.7,63.4 	" />
      <path
        class="st2"
        d="M576.1,64.3c0-0.1,0.1-0.2,0.1-0.2l0,0l0,0C576.2,64.2,576.2,64.2,576.1,64.3z"
      />
      <path
        class="st2"
        d="M385.5,104.8c0,0.1,0.1,0.1,0.1,0.2c0-0.1,0.1-0.1,0.1-0.2C385.7,104.8,385.6,104.8,385.5,104.8z"
      />
      <path
        class="st2"
        d="M385.3,104.7c0.1,0,0.1,0,0.2,0.1v-0.1C385.4,104.7,385.3,104.7,385.3,104.7z"
      />
      <path
        class="st2"
        d="M314.4,119.8h0.1l0.1-0.1l-0.1-0.1C314.5,119.7,314.5,119.7,314.4,119.8z"
      />
      <path
        class="st2"
        d="M579.5,61.8L579.5,61.8C579.5,61.9,579.6,61.9,579.5,61.8L579.5,61.8C579.6,61.8,579.6,61.7,579.5,61.8
		C579.6,61.7,579.6,61.8,579.5,61.8z"
      />
      <polygon class="st2" points="576.8,62 576.8,61.9 576.7,62 	" />
      <path
        class="st2"
        d="M389.6,99.5L389.6,99.5c0.1,0.1,0.1,0.1,0.1,0.1C389.7,99.5,389.7,99.5,389.6,99.5
		C389.7,99.5,389.6,99.5,389.6,99.5z"
      />
      <path
        class="st2"
        d="M389.4,99.4L389.4,99.4L389.4,99.4c0.1,0,0.2,0,0.2,0.1c0-0.1,0-0.1-0.1-0.2C389.5,99.3,389.5,99.4,389.4,99.4
		z"
      />
      <polygon class="st2" points="338.7,108.3 338.7,108.2 338.6,108.2 	" />
      <path
        class="st2"
        d="M539.2,64c0,0.1,0,0.2-0.1,0.2C539.1,64.1,539.2,64.1,539.2,64c0.1-0.1,0.1-0.1,0.1-0.2
		C539.3,63.8,539.2,63.9,539.2,64z"
      />
      <polygon class="st2" points="335,105.3 335.1,105.3 335,105.2 	" />
      <polygon class="st2" points="394,92.1 393.9,92.1 394,92.2 	" />
      <polygon class="st2" points="459.4,77.3 459.5,77.3 459.5,77.2 	" />
      <path
        class="st2"
        d="M392.6,90.8c-0.1,0-0.2,0-0.2-0.1h-0.1c0,0,0,0,0.1,0.1C392.4,90.8,392.5,90.8,392.6,90.8z"
      />
      <path
        class="st2"
        d="M580.7,49.8c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C580.6,49.9,580.6,49.9,580.7,49.8z"
      />
      <path
        class="st2"
        d="M548.8,56.8c0.1,0,0.1,0,0.2,0C548.9,56.8,548.9,56.7,548.8,56.8C548.9,56.7,548.9,56.8,548.8,56.8z"
      />
      <path
        class="st2"
        d="M392,90.7c0.1,0,0.2,0,0.3,0.1C392.2,90.7,392.2,90.7,392,90.7C392.1,90.6,392,90.6,392,90.7z"
      />
      <path
        class="st2"
        d="M408.1,86.8c0,0.1-0.1,0.2-0.1,0.2c0,0.1,0,0.2-0.1,0.2c0-0.1,0.1-0.1,0.1-0.2C408,87,408.1,86.9,408.1,86.8z"
      />
      <path
        class="st2"
        d="M541.5,56.4c0.1,0,0.2,0,0.2,0.1c0-0.1,0-0.1,0-0.2C541.6,56.3,541.6,56.4,541.5,56.4z"
      />
      <path
        class="st2"
        d="M541.7,56.5L541.7,56.5C541.8,56.6,541.8,56.5,541.7,56.5C541.8,56.5,541.8,56.5,541.7,56.5
		C541.8,56.5,541.8,56.5,541.7,56.5z"
      />
      <polygon class="st2" points="462,73.6 462.1,73.7 462.1,73.6 	" />
      <polygon class="st2" points="548.7,54.6 548.8,54.6 548.8,54.5 	" />
      <path
        class="st2"
        d="M541.8,56c0,0.1-0.1,0.1-0.1,0.2c0,0,0,0,0,0.1l0,0C541.8,56.2,541.8,56.1,541.8,56z"
      />
      <path
        class="st2"
        d="M381.9,90.4l-0.1-0.1l-0.1,0.1l0.1,0.1C381.8,90.4,381.9,90.4,381.9,90.4z"
      />
      <polygon class="st2" points="552.4,48.2 552.3,48.1 552.2,48.1 	" />
      <path
        class="st2"
        d="M596.5,36.4c-0.1,0-0.2,0-0.2,0.1c0,0,0.1,0,0.1,0.1C596.4,36.5,596.4,36.4,596.5,36.4z"
      />
      <path
        class="st2"
        d="M597,35.1c0,0.1,0,0.2-0.1,0.3C597,35.3,597,35.2,597,35.1L597,35.1z"
      />
      <path
        class="st2"
        d="M493.1,57c0-0.1,0.1-0.2,0.1-0.3C493.1,56.9,493.1,56.9,493.1,57c-0.2,0.1-0.3,0.2-0.4,0.3l0,0c0,0,0,0,0.1,0
		C492.8,57.3,493,57.2,493.1,57z"
      />
      <path
        class="st2"
        d="M484.6,58.7c0,0-0.1,0-0.1-0.1l-0.1,0.1l0.1,0.1L484.6,58.7z"
      />
      <polygon class="st2" points="409.5,74 409.5,74.1 409.6,74 	" />
      <path
        class="st2"
        d="M488.8,55.6c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C488.7,55.7,488.8,55.6,488.8,55.6z"
      />
      <path
        class="st2"
        d="M444.4,65.1L444.4,65.1L444.4,65.1L444.4,65.1c0-0.1-0.1-0.1-0.1-0.1S444.4,65,444.4,65.1z"
      />
      <polygon class="st2" points="560.3,39.2 560.3,39.3 560.4,39.2 	" />
      <path
        class="st2"
        d="M484.3,54.4c-0.1,0.1-0.1,0.1-0.2,0.2l0,0l0,0C484.2,54.5,484.2,54.5,484.3,54.4z"
      />
      <path
        class="st2"
        d="M514.7,46.3C514.7,46.3,514.6,46.3,514.7,46.3c-0.1,0-0.1,0-0.1,0.1C514.6,46.3,514.6,46.3,514.7,46.3z"
      />
      <path
        class="st2"
        d="M380.5,75.2l0.1-0.1c0,0,0-0.1,0.1-0.1c0,0-0.1,0-0.1,0.1C380.5,75.2,380.5,75.2,380.5,75.2z"
      />
      <path
        class="st2"
        d="M380.7,75.1L380.7,75.1c0.1,0,0.1-0.1,0.1-0.1C380.7,75,380.7,75,380.7,75.1z"
      />
      <path
        class="st2"
        d="M514.1,45.8L514.1,45.8c0.1-0.1,0-0.1,0-0.2V45.8C514,45.8,514.1,45.8,514.1,45.8z"
      />
      <polygon class="st2" points="549,36 548.9,36 548.9,36.1 	" />
      <path
        class="st2"
        d="M400.5,67.8C400.5,67.8,400.4,67.9,400.5,67.8l0.1,0.2c0-0.1,0-0.1,0-0.2H400.5z"
      />
      <polygon class="st2" points="333.4,82.3 333.4,82.4 333.6,82.4 	" />
      <polygon class="st2" points="548.5,35.5 548.4,35.4 548.4,35.6 	" />
      <polygon class="st2" points="433.3,57 433.4,57 433.3,56.9 	" />
      <path
        class="st2"
        d="M434.7,49.5h0.1l0.1-0.1l-0.1-0.1C434.7,49.4,434.7,49.5,434.7,49.5z"
      />
      <path
        class="st2"
        d="M575.6,17.7c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C575.6,17.8,575.6,17.7,575.6,17.7z"
      />
      <polygon
        class="st2"
        points="533.2,26.6 533.2,26.5 533.2,26.5 533.1,26.5 533.1,26.5 	"
      />
      <polygon class="st2" points="438.4,47 438.3,47.1 438.4,47.1 	" />
      <path
        class="st2"
        d="M501.2,33L501.2,33c-0.1,0.1-0.1,0.2-0.1,0.3C501.2,33.2,501.2,33.1,501.2,33L501.2,33z"
      />
      <path
        class="st2"
        d="M501.4,32.7c0,0.1-0.1,0.2-0.1,0.2c0.1-0.1,0.2-0.1,0.2-0.2C501.4,32.8,501.4,32.7,501.4,32.7z"
      />
      <polygon class="st2" points="445.9,44.9 446,44.9 446,44.8 	" />
      <polygon class="st2" points="548.7,22.2 548.6,22.3 548.7,22.3 	" />
      <polygon class="st2" points="532.7,25.7 532.6,25.8 532.7,25.8 	" />
      <path
        class="st2"
        d="M434.3,47.1L434.3,47.1C434.3,46.9,434.3,46.9,434.3,47.1C434.2,47,434.3,47,434.3,47.1z"
      />
      <path
        class="st2"
        d="M421.4,49.6l0.1-0.1l-0.1-0.1l-0.1,0.1C421.3,49.6,421.4,49.6,421.4,49.6z"
      />
      <path
        class="st2"
        d="M575.8,13c0,0-0.1,0-0.2-0.1c0,0.1,0,0.1,0.1,0.2C575.7,13,575.7,13,575.8,13z"
      />
      <polygon class="st2" points="418.5,45.1 418.5,45.2 418.6,45.1 	" />
      <path
        class="st2"
        d="M376.5,53.5h-0.1v0.1l0.1,0.1C376.5,53.7,376.5,53.6,376.5,53.5z"
      />
      <path
        class="st2"
        d="M412.6,43c0,0,0.1,0,0.1,0.1l0.1-0.1l-0.1-0.1C412.7,42.8,412.7,42.9,412.6,43z"
      />
      <path class="st2" d="M465.4,30.3l-0.1-0.1l-0.1,0.1l0.1,0.1L465.4,30.3z" />
      <polygon class="st2" points="427.4,38.2 427.3,38.3 427.4,38.3 	" />
      <polygon class="st2" points="445.3,33.7 445.5,33.7 445.4,33.6 	" />
      <path
        class="st2"
        d="M463.2,29.2l-0.1-0.1l-0.1,0.1c0,0,0.1,0,0.1,0.1C463.2,29.2,463.2,29.2,463.2,29.2z"
      />
      <path
        class="st2"
        d="M402.2,40.2L402.2,40.2c0.1,0.1,0.1,0.1,0.2,0.1C402.3,40.2,402.3,40.2,402.2,40.2z"
      />
      <path
        class="st2"
        d="M462,25.3l0.1-0.1v-0.1l-0.1,0.1C462.1,25.2,462,25.3,462,25.3z"
      />
      <polygon class="st2" points="440.8,29.9 440.8,30 440.9,30 	" />
      <path
        class="st2"
        d="M524.3,179.8c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.2-0.1,0.3-0.1c0.1-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0.1
		C524.5,179.7,524.4,179.7,524.3,179.8z"
      />
      <path
        class="st2"
        d="M546.1,163.8c0,0-0.1,0-0.1-0.1l0,0l0,0C546,163.8,546,163.8,546.1,163.8z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "FootballCover_c2",
  props: ["fill"],
};
</script>
